var app = (function (exports, enums, angular, _tools, flatpickr, Tether, _rules, kb3d, Q, signalR, Big) {
    'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () { return e[k]; }
                    });
                }
            });
        }
        n["default"] = e;
        return Object.freeze(n);
    }

    var enums__namespace = /*#__PURE__*/_interopNamespace(enums);
    var angular__namespace = /*#__PURE__*/_interopNamespace(angular);
    var flatpickr__default = /*#__PURE__*/_interopDefaultLegacy(flatpickr);
    var Tether__default = /*#__PURE__*/_interopDefaultLegacy(Tether);
    var kb3d__namespace = /*#__PURE__*/_interopNamespace(kb3d);
    var Q__namespace = /*#__PURE__*/_interopNamespace(Q);
    var Big__default = /*#__PURE__*/_interopDefaultLegacy(Big);

    // tslint:disable:variable-name
    var Token = /** @class */ (function () {
        function Token(key) {
            this.key = key;
        }
        Token.withKey = function (key) {
            var token = this[key];
            if (!token)
                token = new Token(key); // throw new Error(`Could not find token for key '${key}'`);
            return token;
        };
        // libraries
        Token.AdminLib = new Token("adminLib");
        Token.Creator = new Token("creator");
        Token.Vapp = new Token("vapp");
        Token.HandsontableLib = new Token("handsontableLib");
        Token.HighchartsLib = new Token("highchartsLib");
        Token.MarkdownDeepLib = new Token("markdownDeepLib");
        Token.MonacoLoaderLib = new Token("monacoLoaderLib");
        Token.Recaptcha = new Token("Recaptcha");
        Token.SnapLib = new Token("snapLib");
        Token.Viewer = new Token("viewer");
        // angular built-ins
        Token.$Animate = new Token("$animate");
        Token.$Scope = new Token("$scope");
        Token.$Location = new Token("$location");
        Token.$Http = new Token("$http");
        Token.$RootScope = new Token("$rootScope");
        Token.$Timeout = new Token("$timeout");
        Token.$Q = new Token("$q");
        Token.$Window = new Token("$window");
        Token.$Document = new Token("$document");
        Token.$Filter = new Token("$filter");
        Token.$Injector = new Token("$injector");
        Token.$Interval = new Token("$interval");
        Token.$TemplateCache = new Token("$templateCache");
        Token.$TemplateRequest = new Token("$templateRequest");
        Token.$Compile = new Token("$compile");
        Token.$Sce = new Token("$sce");
        Token.$Locale = new Token("$locale");
        Token.$CookieStore = new Token("$cookieStore");
        Token.$Sanitize = new Token("$sanitize");
        Token.PromiseTracker = new Token("promiseTracker");
        Token.$OcLazyLoad = new Token("$ocLazyLoad");
        // ui router
        Token.$State = new Token("$state");
        Token.$Transitions = new Token("$transitions");
        Token.$StateParams = new Token("$stateParams");
        // resolves
        Token.Model = new Token("model");
        Token.ProductResolve = new Token("productResolve");
        Token.Categories = new Token("categories");
        Token.Header = new Token("header");
        Token.SsoGroups = new Token("ssoGroups");
        // animations
        Token.KbRise = new Token(".kb-rise");
        // components
        Token.KbActionSelect = new Token("kbActionSelect");
        Token.KbAllowFraction = new Token("kbAllowFraction");
        Token.KbAtom = new Token("kbAtom");
        Token.KbAttachments = new Token("kbAttachments");
        Token.KbAutoComplete = new Token("kbAutoComplete");
        Token.KbAvatar = new Token("kbAvatar");
        Token.KbAvatarSelect = new Token("kbAvatarSelect");
        Token.KbButton = new Token("kbButton");
        Token.KbCheckbox = new Token("kbCheckbox");
        Token.KbColorPicker = new Token("kbColorPicker");
        Token.KbColumn = new Token("kbColumn");
        Token.KbContent = new Token("kbContent");
        Token.KbComments = new Token("kbComments");
        Token.KbDataGrid = new Token("kbDataGrid");
        Token.KbDatePicker = new Token("kbDatePicker");
        Token.KbDropdown = new Token("kbDropdown");
        Token.KbEdit = new Token("kbEdit");
        Token.KbEllipsis = new Token("kbEllipsis");
        Token.KbExpander = new Token("kbExpander");
        Token.KbExpanderGroup = new Token("kbExpanderGroup");
        Token.KbField = new Token("kbField");
        Token.KbFieldControl = new Token("kbFieldControl");
        Token.KbFocus = new Token("kbFocus");
        Token.KbForm = new Token("kbForm");
        Token.KbIcon = new Token("kbIcon");
        Token.KbIf = new Token("kbIf");
        Token.KbIfDelay = new Token("kbIfDelay");
        Token.KbImageSelect = new Token("kbImageSelect");
        Token.KbInclude = new Token("kbInclude");
        Token.KbInfiniteScroll = new Token("kbInfiniteScroll");
        Token.KbLabel = new Token("kbLabel");
        Token.KbList = new Token("kbList");
        Token.KbListItem = new Token("kbListItem");
        Token.KbMarkdownViewer = new Token("kbMarkdownViewer");
        Token.KbMax = new Token("kbMax");
        Token.KbMediaList = new Token("kbMediaList");
        Token.KbMediaManager = new Token("kbMediaManager");
        Token.KbMediaSelect = new Token("kbMediaSelect");
        Token.KbMediaViewer = new Token("kbMediaViewer");
        Token.KbMenu = new Token("kbMenu");
        Token.KbMenuItem = new Token("kbMenuItem");
        Token.KbMin = new Token("kbMin");
        Token.KbMoney = new Token("kbMoney");
        Token.KbMultiAutoComplete = new Token("kbMultiAutoComplete");
        Token.KbMultiSelect = new Token("kbMultiSelect");
        Token.KbImageMultiSelect = new Token("kbImageMultiSelect");
        Token.KbNumberbox = new Token("kbNumberbox");
        Token.KbOption = new Token("kbOption");
        Token.KbOverlayPopup = new Token("kbOverlayPopup");
        Token.KbPage = new Token("kbPage");
        Token.KbPageTitle = new Token("kbPageTitle");
        Token.KbPassword = new Token("kbPassword");
        Token.KbPrivacyPolicy = new Token("kbPrivacyPolicy");
        Token.KbProgress = new Token("kbProgress");
        Token.KbRadio = new Token("kbRadio");
        Token.KbResize = new Token("kbResize");
        Token.KbRipple = new Token("kbRipple");
        Token.KbScope = new Token("kbScope");
        Token.KbSearchGrid = new Token("kbSearchGrid");
        Token.KbSelect = new Token("kbSelect");
        Token.KbSfdcHeader = new Token("kbSfdcHeader");
        Token.KbSlide = new Token("kbSlide");
        Token.KbSlider = new Token("kbSlider");
        Token.KbSortable = new Token("kbSortable");
        Token.KbSpinner = new Token("kbSpinner");
        Token.KbSpinnerElement = new Token("kbSpinnerElement");
        Token.KbSrcOnError = new Token("kbSrcOnError");
        Token.KbSvgViewer = new Token("kbSvgViewer");
        Token.KbTab = new Token("kbTab");
        Token.KbTabs = new Token("kbTabs");
        Token.KbTextarea = new Token("kbTextarea");
        Token.KbTextbox = new Token("kbTextbox");
        Token.KbToggle = new Token("kbToggle");
        Token.KbToggleButton = new Token("KbToggleButton");
        Token.KbTooltip = new Token("kbTooltip");
        Token.KbTransclude = new Token("kbTransclude");
        Token.KbTree = new Token("kbTree");
        Token.KbTreeNode = new Token("kbTreeNode");
        Token.KbUiObject = new Token("kbUiObject");
        Token.KbUpload = new Token("kbUpload");
        Token.KbValidationMessages = new Token("kbValidationMessages");
        // filters
        Token.AssetFilter = new Token("asset");
        Token.BytesFilter = new Token("bytes");
        Token.EnumFilter = new Token("enum");
        Token.FileIconFilter = new Token("fileIcon");
        Token.FileIdFilter = new Token("fileId");
        Token.FxConvertFilter = new Token("fxConvert");
        Token.GetFileExtensionFilter = new Token("getFileExtension");
        Token.GetFilenameFilter = new Token("getFilename");
        Token.HasRoleFilter = new Token("hasRole");
        Token.IconFilter = new Token("icon");
        Token.IsAdminOrCompanyAdminFilter = new Token("isAdminOrCompanyAdmin");
        Token.KbCurrencyFilter = new Token("kbCurrency");
        Token.KbDateTimeFilter = new Token("kbDateTime");
        Token.KbDateFilter = new Token("kbDate");
        Token.LeadTimeFilter = new Token("leadTime");
        Token.LocFilter = new Token("loc");
        Token.LogIconFilter = new Token("logIcon");
        Token.MediaFilter = new Token("media");
        Token.NotificationIconFilter = new Token("notificationIcon");
        Token.NumberFormateFilter = new Token("numberFormat");
        Token.ProfileImageFilter = new Token("profileImage");
        Token.QuoteProductImageFilter = new Token("quoteProductImage");
        Token.RangeFilter = new Token("range");
        Token.RawTextFilter = new Token("rawText");
        Token.ShadeFilter = new Token("shade");
        Token.SmartColorFilter = new Token("smartColor");
        Token.ThemeColorFilter = new Token("themeColor");
        Token.ThumbFilter = new Token("thumb");
        Token.TruncateFilter = new Token("truncate");
        Token.TrustAsHtmlFilter = new Token("trustAsHtml");
        // interceptors
        Token.CacheBusterInterceptor = new Token("cacheBusterInterceptor");
        Token.ErrorInterceptor = new Token("errorInterceptor");
        Token.SecurityInterceptor = new Token("securityInterceptor");
        // services
        Token.ApiService = new Token("apiService");
        Token.AuthService = new Token("authService");
        Token.Base64Service = new Token("base64Service");
        Token.BundleLoaderService = new Token("bundleLoaderService");
        Token.ClaraSceneService = new Token("claraSceneService");
        Token.CrudService = new Token("crudService");
        Token.DialogService = new Token("dialogService");
        Token.DragAndDropService = new Token("dragAndDropService");
        Token.DrawerService = new Token("drawerService");
        Token.KbService = new Token("kbService");
        Token.QuoteService = new Token("quoteService");
        Token.RuleService = new Token("ruleService");
        Token.SearchService = new Token("searchService");
        Token.SecurityRetryService = new Token("securityRetryService");
        Token.SfdcService = new Token("sfdcService");
        Token.SignalRService = new Token("signalRService");
        Token.StorageService = new Token("storageService");
        Token.TelemetryService = new Token("telemetryService");
        Token.ThemeService = new Token("themeService");
        Token.UploadService = new Token("uploadService");
        Token.InteractionService = new Token("interactionService");
        Token.PrismService = new Token("PrismService");
        // views
        Token.ContactView = new Token("contactView");
        Token.ContactsView = new Token("contactsView");
        Token.CrudView = new Token("crudView");
        Token.CustomerView = new Token("customerView");
        Token.CustomersView = new Token("customersView");
        Token.DialogView = new Token("dialogView");
        Token.NotificationsView = new Token("notificationsView");
        Token.DrawerView = new Token("drawerView");
        Token.LoginView = new Token("loginView");
        Token.PortalView = new Token("portalView");
        Token.PrivacyPolicyView = new Token("privacyPolicyView");
        Token.ConfiguratorView = new Token("configuratorView");
        Token.ProductView = new Token("productView");
        Token.ProductsView = new Token("productsView");
        Token.ProductCompareView = new Token("productCompareView");
        Token.ConfiguredProductsView = new Token("configuredProductsView");
        Token.QuoteView = new Token("quoteView");
        Token.QuotesView = new Token("quotesView");
        Token.SceneEmbedView = new Token("sceneEmbedView");
        Token.SearchView = new Token("searchView");
        Token.ChangePasswordView = new Token("changePasswordView");
        Token.UserActivationView = new Token("userActivationView");
        Token.UserView = new Token("userView");
        return Token;
    }());

    function NgService(args) {
        return function (target) {
            DI.register("service", args, target);
        };
    }
    function NgAnimation(args) {
        return function (target) {
            DI.register("animation", args, target);
        };
    }
    function NgComponent(args) {
        return function (target) {
            DI.register("directive", args, target);
        };
    }
    function NgInterceptor(args) {
        return function (target) {
            DI.register("factory", args, target);
        };
    }
    function NgFilter(args) {
        return function (target) {
            DI.register("filter", args, target);
        };
    }
    function NgView(args) {
        return function (target) {
            DI.register("controller", args, target);
        };
    }
    var DI = /** @class */ (function () {
        function DI() {
        }
        DI.register = function (ngType, args, constructor) {
            var _a, _b, _c;
            if (DI.db.hasOwnProperty(args.token.key)) {
                // Phase 2 (Vue migration): when AngularHost mounts/unmounts, angular
                // re-bootstraps and oc.lazyLoad's per-injector cache is fresh, so it
                // re-fetches + re-evaluates admin.js. The IIFE re-runs and decorator
                // calls land here with tokens that already exist in this static
                // `DI.db`. Throwing would kill the second mount. Instead we detect
                // the re-evaluation and flip `addedToApp` back to false so the
                // subsequent `DI.fillAngularApp(kbadmin)` call (at the top of
                // admin.ts, which also redefines the kbadmin module via
                // `angular.module('kbadmin', [...])` — the deps-array form wipes
                // existing registrations) re-wires all services onto the fresh
                // module. The existing `INgInject` entry is kept with its original
                // constructor reference: the new class object produced by the
                // re-evaluation is functionally equivalent (same source), and keeps
                // `construct[i.ngType](i.token.key, i.construct)` stable across
                // mounts. If a different decorator genuinely tried to claim the
                // same token mid-session, flagging that is now the responsibility
                // of build-time / code-review rather than runtime.
                //
                // Legacy single-bootstrap mode never hits this path; the first
                // registration is still the only registration.
                var existing = DI.db[args.token.key];
                if (existing.ngType !== ngType) {
                    // Really-a-mistake case: same token claimed as a service AND a
                    // filter, for example. Keep the hard error for this.
                    throw new Error("A type with key ".concat(args.token.key, " has already been registered as ").concat(existing.ngType, ", cannot re-register as ").concat(ngType));
                }
                existing.addedToApp = false;
                return;
            }
            args.dependencies = args.dependencies || [];
            args.resolves = args.resolves || [];
            args.libraries = args.libraries || [];
            if (args.inherit) {
                for (var _i = 0, _d = args.inherit; _i < _d.length; _i++) {
                    var baseToken = _d[_i];
                    var baseInject = DI.get(baseToken);
                    if (baseInject.dependencies)
                        (_a = args.dependencies).unshift.apply(_a, baseInject.dependencies);
                    if (baseInject.resolves)
                        (_b = args.resolves).unshift.apply(_b, baseInject.resolves);
                    if (baseInject.libraries)
                        (_c = args.libraries).unshift.apply(_c, baseInject.libraries);
                }
            }
            var resolveObject = args.resolves &&
                args.resolves
                    .reduce(function (p, c) {
                    p[c.name] = [].concat.apply([], c.dependencies.map(function (d) { return d.key; })).concat(c.fn.bind(constructor));
                    return p;
                }, {});
            if (args.libraries) {
                resolveObject["scripts"] = [Token.BundleLoaderService.key, function (bundleLoader) {
                        return bundleLoader.load(args.libraries);
                    }];
            }
            var ngInject = {
                token: args.token,
                ngType: ngType,
                dependencies: args.dependencies,
                resolves: args.resolves,
                construct: [].concat(args.dependencies.map(function (d) { return d.key; })).concat(function () {
                    var a = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        a[_i] = arguments[_i];
                    }
                    return new (constructor.bind.apply(constructor, __spreadArray([void 0], a, false)))();
                }),
                resolveObject: resolveObject,
                libraries: args.libraries
            };
            DI.db[args.token.key] = ngInject;
        };
        DI.get = function (token) {
            return DI.db[token.key];
        };
        DI.fillAngularApp = function (app) {
            for (var key in DI.db) {
                var i = DI.db[key];
                if (!i.addedToApp) {
                    app[i.ngType](i.token.key, i.construct);
                    i.addedToApp = true;
                }
            }
        };
        DI.db = {};
        return DI;
    }());

    exports.eBundle = void 0;
    (function (eBundle) {
        eBundle["app"] = "app";
        eBundle["admin"] = "admin";
    })(exports.eBundle || (exports.eBundle = {}));
    var Dirs = /** @class */ (function () {
        function Dirs() {
        }
        Dirs.component = function (name, bundle) {
            if (bundle === void 0) { bundle = exports.eBundle.app; }
            return this.get("html/".concat(bundle, "/").concat(name, ".component.html"));
        };
        Dirs.template = function (name, bundle) {
            if (bundle === void 0) { bundle = exports.eBundle.app; }
            return this.get("html/".concat(bundle, "/").concat(name, ".html"));
        };
        Dirs.view = function (name, bundle) {
            if (bundle === void 0) { bundle = exports.eBundle.app; }
            return this.get("html/".concat(bundle, "/").concat(name, ".view.html"));
        };
        Dirs.get = function (url) {
            return window.html[url];
        };
        return Dirs;
    }());

    var ANGULAR_RUNTIME_STATE_PREFIXES = [
        "kb.configurator",
        "kb.configuredProduct",
        "kb.configuratorTest",
        "scene",
        "kb.login",
    ];
    var ANGULAR_ADMIN_CONFIGURATOR_STATES = new Set([
        "kb.admin.base.configuratorEdit",
        "kb.admin.base.configuratorNew",
    ]);
    /**
     * Returns true only when a transition can stay inside the currently mounted Angular host.
     * Vue owns navigation between admin resources and chooses whether a configurator destination is V2 or V3.
     */
    function shouldAngularOwnHostedTransition(input) {
        var stateName = input.targetStateName;
        if (!stateName)
            return false;
        if (ANGULAR_RUNTIME_STATE_PREFIXES.some(function (prefix) {
            return stateName === prefix || stateName.startsWith("".concat(prefix, "."));
        })) {
            return true;
        }
        if (input.hostMode !== "admin")
            return false;
        if (stateName === "kb.admin.**")
            return true;
        if (!ANGULAR_ADMIN_CONFIGURATOR_STATES.has(stateName))
            return false;
        var currentConfigurator = readAdminConfiguratorIdentity(input.currentVuePath);
        var targetConfigurator = readAdminConfiguratorIdentity(input.targetHref);
        return currentConfigurator !== null && currentConfigurator === targetConfigurator;
    }
    function readAdminConfiguratorIdentity(url) {
        if (!url)
            return null;
        var pathname;
        try {
            pathname = new URL(url, "https://kbmax.local").pathname;
        }
        catch (_a) {
            return null;
        }
        if (pathname === "/admin/configurators/new")
            return "new";
        var match = pathname.match(/^\/admin\/configurators\/(\d+)(?:\/.*)?$/);
        return match ? "id:".concat(match[1]) : null;
    }

    var StateHelper = /** @class */ (function () {
        function StateHelper($stateProvider, bundle) {
            this.$stateProvider = $stateProvider;
            this.bundle = bundle;
        }
        StateHelper.prototype.getPluralName = function (name) {
            var plural = name;
            if (!name.endsWith("s")) {
                if (name.endsWith("y")) {
                    plural = name.slice(0, -1) + "ies";
                }
                else {
                    plural = name + "s";
                }
            }
            return plural;
        };
        StateHelper.prototype.addState = function (o) {
            var _this = this;
            var ngInject = o.view && DI.get(o.view);
            var resolve = ngInject && Object.assign({}, ngInject.resolveObject);
            var nameSegment = o.name.split(".").last();
            var kebab = nameSegment.toKebabCase();
            if (!o.allowAnonymous && resolve) {
                resolve["auth"] = [
                    Token.AuthService.key, Token.$RootScope.key,
                    function (authService, $rootScope) {
                        return authService.authPromise.then(function () {
                            if (o.authorization && !o.authorization(authService, $rootScope)) {
                                $rootScope.$broadcast(_tools.events.permissionDenied);
                            }
                        });
                    }
                ];
            }
            else if (o.allowAnonymous) {
                if (!o.data)
                    o.data = {};
                o.data.allowAnonymous = true;
            }
            this.$stateProvider.state(o.name, {
                url: angular__namespace.isDefined(o.url) ? o.url : "/".concat(kebab),
                params: o.params,
                template: function () { return o.template || Dirs.get(o.templateUrl) || Dirs.view(o.templateName || kebab, _this.bundle); },
                // templateUrl: o.templateUrl || Dirs.view(o.templateName || kebab, this.bundle),
                controller: ngInject && ngInject.construct,
                resolve: resolve,
                data: o.data,
                reloadOnSearch: o.reloadOnSearch,
                parent: o.parent
            });
        };
        StateHelper.prototype.addSearchState = function (o) {
            var nameSegment = o.name.split(".").last();
            this.addState({
                name: o.name,
                view: o.view,
                url: o.url ? o.url : "/".concat(nameSegment.toKebabCase(), "?search&searchid"),
                params: {
                    search: { dynamic: true },
                    searchid: { dynamic: true }
                },
                authorization: o.authorization,
            });
        };
        StateHelper.prototype.addCrudStates = function (o) {
            var nameSegment = o.name.split(".").last();
            var nameKebab = nameSegment.toKebabCase();
            var pluralName = this.getPluralName(nameSegment);
            var baseUrl = "/".concat(pluralName.toKebabCase());
            var statePrefix = o.name.substring(0, o.name.lastIndexOf("."));
            var editStatePrefix = "".concat(statePrefix).concat(o.isSnapBased ? ".base" : "");
            this.addSearchState({
                name: "".concat(statePrefix, ".").concat(pluralName),
                view: o.searchView,
                authorization: o.authorization,
            });
            var newStateConfig = {
                name: "".concat(editStatePrefix, ".").concat(nameSegment, "New"),
                url: "".concat(baseUrl, "/new"),
                templateName: nameKebab,
                templateUrl: o.templateUrl,
                template: o.template,
                view: o.view,
                data: { viewType: enums.eViewType.new },
                authorization: o.authorization,
            };
            if (o.newStateParams)
                newStateConfig.url += "/:" + o.newStateParams.join("/:");
            this.addState(newStateConfig);
            this.addState({
                name: "".concat(editStatePrefix, ".").concat(nameSegment, "Edit"),
                url: "".concat(baseUrl, "/:id").concat(o.isSnapBased ? "?sel" : ""),
                templateName: nameKebab,
                templateUrl: o.templateUrl,
                template: o.template,
                view: o.view,
                data: { viewType: enums.eViewType.edit },
                reloadOnSearch: !o.isSnapBased,
                authorization: o.authorization,
            });
        };
        return StateHelper;
    }());

    var KbRise = /** @class */ (function () {
        function KbRise($timeout) {
            var _this = this;
            this.$timeout = $timeout;
            var duration = function (distance) {
                return Math.max(Math.min(distance / 2, 350), 150);
            };
            var show = function (element, done) {
                var origOpacity = element.css("opacity");
                element.css("overflow");
                element.css("opacity", 0);
                element.removeClass("ng-hide");
                var finalSetHeight = element.hasClass("kb-rise--full-height") ? element.css("max-height") : "auto";
                element.css("height", finalSetHeight);
                var autoHeight = element.height();
                if (!autoHeight)
                    autoHeight = "95%";
                element.height(0);
                element.css("opacity", origOpacity);
                element.animate({ height: autoHeight }, duration(autoHeight), function () {
                    element.css("height", finalSetHeight);
                    done();
                });
            };
            var hide = function (element, done) {
                _this.autoHeight = element.height();
                element.animate({ height: 0 }, duration(_this.autoHeight), function () {
                    element.css("height", 0);
                    done();
                });
            };
            this.beforeAddClass = function (element, className, done) {
                if (className == "ng-hide") {
                    hide(element, done);
                }
            };
            this.removeClass = function (element, className, done) {
                if (className == "ng-hide") {
                    show(element, done);
                }
            };
            this.enter = function (element, done) {
                show(element, done);
            };
            this.leave = function (element, done) {
                hide(element, done);
            };
        }
        KbRise = __decorate([
            NgAnimation({
                token: Token.KbRise,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbRise);
        return KbRise;
    }());
    // export class kbSlide extends ngAnimation {
    //    public injection(): any[] {
    //        return [
    //            Token.$Timeout,
    //            ($timeout) => { return new kbSlide($timeout) }
    //        ]
    //    }
    //    constructor($timeout: ng.ITimeoutService) {
    //        super();
    //        var show = (element: ng.IAugmentedJQuery , done) => {
    //            element.removeClass("ng-hide");
    //            element.css("width", "auto");
    //            var autoWidth: any = element.width();
    //            if (!autoWidth) autoWidth = "95%";
    //            element.width(0);
    //            element.animate({ "width": autoWidth }, 150, "linear", () => {
    //                element.css("width", "auto");
    //                done();
    //            });
    //        }
    //        var hide = (element: ng.IAugmentedJQuery, done) => {
    //            this.autoWidth = element.width();
    //            element.animate({ "width": 0 }, 150, () => {
    //                element.css("width", 0);
    //                done();
    //            });
    //        }
    //        this.beforeAddClass = (element: ng.IAugmentedJQuery, className: string, done) => {
    //            if (className == "ng-hide") {
    //                hide(element, done);
    //            }
    //        }
    //        this.removeClass = (element: ng.IAugmentedJQuery, className: string, done) => {
    //            if (className == "ng-hide") {
    //                show(element, done);
    //            }
    //        }
    //    }
    //    private autoWidth: number;
    // }
    // export class kbFade extends ngAnimation {
    //    public injection(): any[] {
    //        return [
    //            () => { return new kbFade() }
    //        ]
    //    }
    //    constructor() {
    //        super();
    //        this.addClass = (element, className, done) => {
    //            if (className == "ng-hide") {
    //                var origOpacity = element.css("opacity");
    //                element.animate({ "opacity": 0 }, 150, () => {
    //                    element.hide();
    //                    element.css("opacity", origOpacity);
    //                    done();
    //                });
    //            }
    //        }
    //        this.removeClass = (element, className, done) => {
    //            if (className == "ng-hide") {
    //                var origOpacity = element.css("opacity");
    //                element.css("opacity", 0);
    //                element.show();
    //                var to = "1";
    //                if (origOpacity && origOpacity != "0") {
    //                    to = origOpacity;
    //                }
    //                element.animate({ "opacity": to }, 150, () => {
    //                    element.show();
    //                    element.css("opacity", to);
    //                    done();
    //                });
    //            }
    //        }
    //    }
    // }

    var Directive = /** @class */ (function () {
        function Directive() {
        }
        return Directive;
    }());

    var KbActionSelect = /** @class */ (function (_super) {
        __extends(KbActionSelect, _super);
        function KbActionSelect($q, $http) {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-action-select");
            _this.scope = {
                source: "=",
                valueField: "@",
                defaultLabel: "@",
                icon: "@",
                onAction: "="
            };
            _this.replace = true;
            _this.link = function (scope, element, atts, ngModel) {
                scope._actionSelect = "";
                scope.$watch("_actionSelect", function (newValue) {
                    if (!newValue)
                        return;
                    scope.onAction(newValue);
                    scope._actionSelect = "";
                });
            };
            return _this;
        }
        KbActionSelect = __decorate([
            NgComponent({
                token: Token.KbActionSelect,
                dependencies: [
                    Token.$Q,
                    Token.$Http,
                ]
            })
        ], KbActionSelect);
        return KbActionSelect;
    }(Directive));

    var KbAllowFractions = /** @class */ (function (_super) {
        __extends(KbAllowFractions, _super);
        function KbAllowFractions() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.require = "ngModel";
            _this.link = function (scope, elem, attr, ctrl) {
                var maxValidator = function (value) {
                    var allowFractions = scope.$eval(attr.kbAllowFractions) || true;
                    if (!allowFractions && value % 1 != 0) {
                        var newValue = Math.round(value);
                        $(elem).val(newValue);
                        return newValue;
                    }
                    return value;
                };
                ctrl.$parsers.push(maxValidator);
                ctrl.$formatters.push(maxValidator);
            };
            return _this;
        }
        KbAllowFractions = __decorate([
            NgComponent({
                token: Token.KbAllowFraction,
                dependencies: [
                    Token.$Q,
                    Token.$Http,
                ]
            })
        ], KbAllowFractions);
        return KbAllowFractions;
    }(Directive));

    var KbAtom = /** @class */ (function (_super) {
        __extends(KbAtom, _super);
        function KbAtom($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-atom");
            _this.scope = false;
            _this.replace = true;
            _this.transclude = {
                display: "?kbAtomDisplay",
                edit: "?kbAtomEdit"
            };
            _this.link = function (scope, element, atts) {
                scope._editMode = scope.$eval(atts.editMode) == true;
                var guid = _tools.Utils.shortId();
                var eventName = "click.kbAtom." + guid;
                var documentClick = function (e) {
                    // ignore if it was this kbAtom that was clicked
                    if (!$(e.target).is(element) && !$.contains(element[0], e.target)) {
                        scope.$apply(function () {
                            scope._editing = false;
                        });
                        $(document).off(eventName, documentClick);
                    }
                };
                var changeEditMode = function (val) {
                    scope._editing = val;
                    if (val) {
                        scope._displayClick = function ($event) {
                        };
                        // scope._editClick = ($event: ng.IAngularEvent) => {
                        // }
                    }
                    else {
                        scope._displayClick = function ($event) {
                            if ($(element).hasClass("disabled") || $(element).attr("disabled"))
                                return;
                            // $event.stopPropagation();
                            scope._editing = true;
                            $(document).on(eventName, documentClick);
                        };
                        // scope._editClick = ($event: ng.IAngularEvent) => {
                        //    $event.stopPropagation();
                        // }
                    }
                };
                var editAtt = atts.editMode;
                if (editAtt) {
                    scope.$watch(function () { return scope.$eval(editAtt); }, changeEditMode);
                }
                else {
                    changeEditMode(false);
                }
                scope.$on("$destroy", function () {
                    $(document).off(eventName, documentClick);
                });
            };
            return _this;
        }
        KbAtom = __decorate([
            NgComponent({
                token: Token.KbAtom,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbAtom);
        return KbAtom;
    }(Directive));

    var KbAttachments = /** @class */ (function (_super) {
        __extends(KbAttachments, _super);
        function KbAttachments($rootScope, dialogService, $http, $q, uploadService, storageService) {
            var _this = _super.call(this) || this;
            _this.$rootScope = $rootScope;
            _this.dialogService = dialogService;
            _this.$http = $http;
            _this.$q = $q;
            _this.uploadService = uploadService;
            _this.storageService = storageService;
            _this.replace = false;
            _this.template = Dirs.component("kb-attachments");
            _this.restrict = "E";
            _this.scope = {
                objectId: "=",
                tableName: "@",
                relationshipProperty: "@",
                files: "=",
                fileEntityPath: "@",
                canChange: "=",
                canAdd: "=",
                downloadFile: "="
            };
            _this.link = function (scope, element, atts) {
                if (typeof scope.canChange == "undefined") {
                    scope.canChange = $rootScope.user.canModifyAllAttachments || $rootScope.user.canAddAttachments;
                }
                if (typeof scope.secureFileDownloadUrl == "undefined")
                    scope.secureFileDownloadUrl = "file/download";
                var displayDialog = function (callback, file, name, description, source) {
                    if (name === void 0) { name = ""; }
                    if (description === void 0) { description = ""; }
                    var fileInfo = scope.$new(true);
                    if (!file)
                        file = { name: "" };
                    fileInfo.model = {
                        fileName: file.name,
                        name: name,
                        description: description,
                        source: source
                    };
                    fileInfo.canViewMedia = _this.$rootScope.context.user.canModifyMedia;
                    dialogService.dialog({
                        type: enums.eInputDialogType.html,
                        template: Dirs.view("dialog-edit-attachment"),
                        scope: fileInfo,
                        buttons: [
                            new enums.DialogButton(loc.ok, _tools.icons.submit, function () {
                                callback(fileInfo.model.name, fileInfo.model.description, file, fileInfo.model.source);
                            }),
                            new enums.DialogButton(loc.cancel, _tools.icons.cancel)
                        ]
                    });
                    fileInfo.uploadNewAttachment = function () {
                        _this.uploadService.promptUserToChooseFile(atts.accept).then(function (selectedFile) {
                            if (file.name == fileInfo.model.name || !fileInfo.model.name) {
                                fileInfo.model.name = selectedFile.name;
                            }
                            fileInfo.model.fileName = selectedFile.name;
                            fileInfo.model.source = enums.eFileSource.uploaded;
                            file = selectedFile;
                        });
                    };
                    fileInfo.selectMediaFile = function () {
                        var name = fileInfo.model.name;
                        fileInfo.model.description;
                        dialogService.mediaSelect({
                            buttons: [
                                new enums.MediaDialogButton(loc.ok, _tools.icons.success, function (args) {
                                    if (!name || name == file.name) {
                                        fileInfo.model.name = args.selectedItem.name;
                                    }
                                    fileInfo.model.fileName = args.selectedItem.name;
                                    fileInfo.model.source = enums.eFileSource.media;
                                    file = args.selectedItem;
                                }),
                                new enums.MediaDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                                })
                            ]
                        });
                    };
                };
                if (!scope.downloadFile) {
                    scope.downloadFile = function (item) {
                        if (typeof window != "undefined") {
                            window.open(storageService.getMediaUrl(item.filePath));
                        }
                    };
                }
                scope._uploadFile = function (item) {
                    if (!item) {
                        item = {
                            filePath: "",
                            name: "",
                            description: "",
                            source: null
                        };
                    }
                    displayDialog(function (name, description, file, source) {
                        var newFileEntity = {
                            name: name,
                            description: description,
                            id: item.id,
                            filePath: file.name,
                            // idCompany: $rootScope.company.id,
                            // idUser: $rootScope.user.id,
                            createdBy: $rootScope.user.id,
                            // tableName: scope.tableName,
                            createdByName: $rootScope.user.firstName + " " + $rootScope.user.lastName,
                            source: null,
                            status: enums.eFileStatus.complete
                        };
                        if (source)
                            newFileEntity.source = source;
                        if (newFileEntity.source == enums.eFileSource.media)
                            newFileEntity.filePath = file.name;
                        if (scope.objectId && scope.relationshipProperty) {
                            newFileEntity[scope.relationshipProperty] = scope.objectId;
                        }
                        if (file && source != enums.eFileSource.media) {
                            scope.postUrl;
                            var deferred_1 = $q.defer();
                            dialogService.alert({
                                promise: deferred_1.promise,
                                successMsg: "Upload complete"
                            });
                            var uploadProgress = function (evt) {
                                if (evt.lengthComputable) {
                                    deferred_1.notify(Math.round(evt.loaded * 100 / evt.total));
                                }
                                else {
                                    deferred_1.notify("Unknown File Size");
                                }
                            };
                            var uploadComplete = function (result) {
                                deferred_1.resolve();
                                if (item.id) {
                                    $.extend(item, newFileEntity);
                                }
                                else {
                                    newFileEntity.id = result.id;
                                    scope.files.push(newFileEntity);
                                }
                            };
                            var uploadFailed = function () {
                                deferred_1.reject("Upload failed");
                            };
                            _this.uploadService.uploadAttachment(file, newFileEntity, scope.fileEntityPath)
                                .then(uploadComplete, uploadFailed, uploadProgress);
                        }
                        else {
                            if (item.id) {
                                $.extend(item, newFileEntity);
                                $http.put(scope.fileEntityPath, newFileEntity);
                            }
                            else {
                                scope.files.push(newFileEntity);
                                $http.post(scope.fileEntityPath, newFileEntity);
                            }
                        }
                    }, { name: item.filePath, isFromMedia: true }, item.name, item.description, item.source);
                };
                scope.delete = function (item) {
                    _this.dialogService.confirm(loc.msg_confirmdelete, function () {
                        scope.files.remove(item);
                        _this.$http.delete(scope.fileEntityPath + "/" + item.id);
                    });
                };
            };
            return _this;
        }
        KbAttachments = __decorate([
            NgComponent({
                token: Token.KbAttachments,
                dependencies: [
                    Token.$RootScope,
                    Token.DialogService,
                    Token.$Http,
                    Token.$Q,
                    Token.UploadService,
                    Token.StorageService
                ]
            })
        ], KbAttachments);
        return KbAttachments;
    }(Directive));

    /**
     * Acts as a base class to directives that work together with kbField to manage focus and common setup
     */
    var KbInput = /** @class */ (function (_super) {
        __extends(KbInput, _super);
        function KbInput($timeout) {
            var _this = _super.call(this) || this;
            _this.$timeout = $timeout;
            _this.restrict = "E";
            _this.replace = true;
            _this.scope = {
                ngModel: "=",
                ngDisabled: "=?",
                ngModelOptions: "=?",
                ngChange: "&",
                ngBlur: "&",
                touched: "&",
                ignoreField: "=?",
                textColor: "=?",
                backgroundColor: "=?",
                heightOverride: "=?"
            };
            _this.require = ["ngModel", "?^^kbField"];
            _this.link = function (s, e, a, c) { return _this.kbInputLinkFn(s, e, a, c); };
            return _this;
        }
        KbInput.prototype.kbInputLinkFn = function (scope, element, atts, controllers, shouldFloat, isEmpty) {
            var _this = this;
            if (shouldFloat === void 0) { shouldFloat = true; }
            var ngModelCtrl = controllers[0];
            var kbField = null;
            if (!scope.ignoreField) {
                kbField = controllers.length > 1 ? controllers.last() : null;
            }
            if (kbField) { //register our input ngModel with kbField
                kbField.setShouldFloat(shouldFloat);
            }
            if (!isEmpty) {
                isEmpty = function (val) {
                    return (val == null || val.toString().length == 0);
                };
            }
            var ngModelPipelineCheckValue = function (val) {
                if (kbField)
                    kbField.setHasValue(!isEmpty(val) && !(Array.isArray(val) && !val.length));
                return val;
            };
            ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
            ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);
            ngModelCtrl.$viewChangeListeners.push(function () {
                //for some controls, blur is not the right time to consider whether the control has been touched (like select controls).
                //so we also track it here.
                if (scope.touched) {
                    scope.touched();
                }
            });
            var focusin = function (e) {
                if (kbField)
                    kbField.setFocused(true);
            };
            var focusout = function () {
                if (kbField) {
                    kbField.setFocused(false);
                }
                if (scope.touched) {
                    scope.touched();
                }
            };
            element.on("focusin", focusin);
            element.on("focusout", focusout);
            // for some reason the ngChange is getting run before the model in the parent controller
            // is being updated by the value change, so we need to do this trick to wait until
            // everything is done before firing the ng-change
            scope._ngChange = function () {
                _this.$timeout(function () {
                    scope.ngChange();
                }, 0);
            };
            // bind keyboard event: esc(27)
            var el = element;
            if (!el.is("input")) {
                el = el.find("input");
            }
            if (el && el.length > 0) {
                el.on("keydown", function (e) {
                    if (e.which == 27) {
                        el.blur();
                    }
                });
            }
            scope._setHasValue = function (hasValue) {
                if (kbField) {
                    kbField.setHasValue(hasValue);
                }
            };
            scope.$on("$destroy", function () {
                if (kbField) {
                    kbField.setFocused(false);
                    kbField.setHasValue(false);
                }
                element.off();
            });
        };
        return KbInput;
    }(Directive));

    var KbAutoComplete = /** @class */ (function (_super) {
        __extends(KbAutoComplete, _super);
        function KbAutoComplete($q, $http, $timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-auto-complete");
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "&",
                data: "=?",
                getLabel: "&",
                editable: "=?",
                valueField: "@",
                labelField: "@",
                defaultLabel: "@",
                headerTemplate: "@",
                itemStyle: "@",
                throttle: "@",
                minCharacters: "=?",
                icon: "@",
                submit: "&",
                placeholder: "@",
                mobileDropdown: "=?",
            });
            _this.transclude = true;
            _this.compile = function (element, atts) {
                if (atts.mobileDropdown == null)
                    atts.mobileDropdown = "true";
                return _this.link;
            };
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers, true, (function (val) { return false; }));
                var ngModel = controllers[0];
                var input = element.find("input");
                scope._id = _tools.Utils.shortId();
                var toStringSafe = function (o) {
                    if (o == null)
                        return null;
                    return o.toString();
                };
                var getItemValue = function (item) {
                    if (item === null || item === undefined)
                        return null;
                    return scope.valueField ? item[scope.valueField] : item;
                };
                var getItemLabel = function (item) {
                    var l;
                    if (item != null) {
                        if (scope.labelField && item[scope.labelField]) {
                            l = item[scope.labelField];
                        }
                        else if (scope.valueField) {
                            l = item[scope.valueField];
                        }
                        else {
                            l = item;
                        }
                    }
                    return toStringSafe(l);
                };
                var isEnabled = function () {
                    return !scope.ngDisabled;
                };
                var setLabelForValue = function () {
                    // if the labelField is being used, then we need to make a 
                    // call to the consumer to get the label for the value
                    if (scope.labelField) {
                        // first we try to find if we already have a match in our _matches to get the label from there
                        // if not, then we make a call to the consumer to retrieve it
                        var match = scope._matches ? scope._matches.find(function (m) { return getItemValue(m) == ngModel.$viewValue; }) : null;
                        if (match) {
                            scope._label = getItemLabel(match);
                        }
                        else {
                            return $q.when(scope.getLabel({ value: ngModel.$viewValue })).then(function (l) {
                                scope._label = l;
                            });
                        }
                    }
                    else { // no label-field is being used, so we just set the text input to the value
                        scope._label = ngModel.$viewValue;
                    }
                };
                ngModel.$render = function () {
                    setLabelForValue();
                };
                scope._itemMousedown = function (e, item) {
                    e.preventDefault(); // so we don't lose focus and trigger the blur event
                    scope._select(item);
                    // call submit for search boxes
                    if (scope.submit)
                        scope.submit({ item: item });
                };
                scope._select = function (item) {
                    if (isEnabled()) {
                        hideDropdown();
                        ngModel.$setViewValue(getItemValue(item));
                        scope._label = getItemLabel(item);
                        scope._hint = null;
                        $timeout(function () {
                            suppressFocusEvent = true;
                            input.focus();
                            // suppressFocusEvent = false;
                        }, 0);
                    }
                };
                var showDropdown = function () {
                    // scope._activeIndex = 0;
                    scope._dropdownOpen = true;
                };
                var hideDropdown = function () {
                    scope._dropdownOpen = false;
                };
                scope._isActive = function (index) {
                    return index === scope._activeIndex;
                };
                var throttle = scope.throttle ? (scope.throttle == "true") : false;
                var getMatches = _tools.Utils.throttle(function () {
                    if (isEnabled()) {
                        var query = toStringSafe(scope._label);
                        if (query && (!scope.minCharacters || query.length >= scope.minCharacters)) {
                            scope._inProgress = true;
                            return $q.when(scope.source({ query: query })).then(function (result) {
                                scope._matches = result;
                                if (scope._matches && scope._matches.length)
                                    showDropdown();
                                scope._hint = null;
                                if (scope._label) {
                                    // if the first match is an exact match so far, then show the hint
                                    if (scope._matches && scope._matches.length) {
                                        var o = scope._matches[0];
                                        var l = getItemLabel(o);
                                        if (l && l.toString().toLowerCase().startsWith(scope._label.toLowerCase())) {
                                            // match the case of whatever the user has already typed
                                            scope._hint = scope._label + l.substr(scope._label.length);
                                        }
                                        scope._activeIndex = 0;
                                    }
                                    else {
                                        scope._activeIndex = -1;
                                    }
                                    scope._activeIndex = scope.editable ? -1 : 0;
                                }
                            }).finally(function () {
                                scope._inProgress = false;
                            });
                        }
                    }
                }, throttle ? 300 : 0);
                var suppressFocusEvent = false;
                scope._focus = function (e) {
                    if (!suppressFocusEvent && !scope._dropdownOpen) {
                        getMatches();
                    }
                    suppressFocusEvent = false;
                };
                scope._blur = function (e) {
                    // if this is editable, then set ngModel to whatever the user typed in when the input loses focus
                    // also when a labelField is declared, it CAN'T be editable
                    if (scope.editable) {
                        ngModel.$setViewValue(scope._label);
                    }
                    else {
                        setLabelForValue();
                    }
                    scope._hint = null;
                };
                scope._inputChange = function (e) {
                    getMatches();
                };
                var buildItem = function (val) {
                    var item = null;
                    if (scope._activeIndex > -1) {
                        item = scope._matches[scope._activeIndex];
                    }
                    else if (scope.valueField) {
                        item = {};
                        item[scope.valueField] = val;
                    }
                    else {
                        item = val;
                    }
                    return item;
                };
                var moveUp = function () {
                    if (scope._dropdownOpen) {
                        // if we are already at index zero, then close the dropdown
                        var newIndex = scope._activeIndex - 1;
                        if (newIndex >= 0)
                            scope._activeIndex = newIndex;
                    }
                };
                var moveDown = function () {
                    showDropdown();
                    // if we are already at index zero, then close the dropdown
                    var newIndex = scope._activeIndex + 1;
                    if (newIndex < scope._matches.length)
                        scope._activeIndex = newIndex;
                };
                // bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                element.on("keydown", function (e) {
                    if (e.which == 38) {
                        e.preventDefault();
                        scope.$apply(function () {
                            moveUp();
                        });
                    }
                    if (e.which == 40) {
                        e.preventDefault();
                        scope.$apply(function () {
                            moveDown();
                        });
                    }
                    if (e.which == 9 || e.which == 13) {
                        scope.$apply(function () {
                            var item = buildItem(scope._label);
                            if ((scope._dropdownOpen && scope._activeIndex > -1) || scope.editable) {
                                scope._select(item);
                                e.stopPropagation();
                            }
                            else {
                                hideDropdown();
                                scope._blur(null);
                            }
                            // call submit for search boxes                            
                            if (scope.submit) {
                                scope.submit({ item: item });
                            }
                        });
                    }
                    if (e.which == 27) {
                        e.preventDefault();
                        scope.$apply(function () {
                            hideDropdown();
                            e.stopPropagation();
                        });
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbAutoComplete = __decorate([
            NgComponent({
                token: Token.KbAutoComplete,
                dependencies: [
                    Token.$Q,
                    Token.$Http,
                    Token.$Timeout,
                ]
            })
        ], KbAutoComplete);
        return KbAutoComplete;
    }(KbInput));

    var KbAvatarSelect = /** @class */ (function (_super) {
        __extends(KbAvatarSelect, _super);
        function KbAvatarSelect(kbService, $rootScope, uploadService, $filter, apiService, dialogService) {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "E";
            _this.scope = {
                ngModel: "=",
                userId: "="
            };
            _this.template = Dirs.component("kb-avatar-select");
            _this.link = function (scope, element, atts, ngModelController) {
                scope.isEnabled = function () {
                    return !($(element).hasClass("disabled") || $(element).attr("disabled"));
                };
                scope.imgPath = $filter("profileImage")(scope.ngModel);
                scope.clear = function () {
                    apiService.users.clearProfileImage(scope.userId).then(function (user) {
                        scope.ngModel = user.imagePath;
                        scope.imgPath = user.imagePath;
                        if (scope.userId == $rootScope.user.id) {
                            $rootScope.$broadcast(_tools.events.avatarChanged, scope.ngModel);
                        }
                    });
                };
                scope.click = function () {
                    if (scope.isEnabled()) {
                        uploadService.promptUserToChooseFile("image/*").then(function (file) {
                            uploadService.uploadProfileImage(file, scope.userId).then(function (imagePath) {
                                var baseImagePath = $filter("profileImage")(scope.userId.toString());
                                scope.ngModel = scope.userId.toString();
                                scope.imgPath = baseImagePath;
                                if (scope.userId == $rootScope.user.id) {
                                    $rootScope.$broadcast(_tools.events.avatarChanged, scope.ngModel);
                                }
                            }, function (e) {
                                dialogService.alert({
                                    msg: loc.msg_uploaderror,
                                    type: enums.eAlertType.error
                                });
                            });
                        });
                    }
                };
            };
            return _this;
        }
        KbAvatarSelect = __decorate([
            NgComponent({
                token: Token.KbAvatarSelect,
                dependencies: [
                    Token.KbService,
                    Token.$RootScope,
                    Token.UploadService,
                    Token.$Filter,
                    Token.ApiService,
                    Token.DialogService,
                ]
            })
        ], KbAvatarSelect);
        return KbAvatarSelect;
    }(Directive));

    var KbAvatar = /** @class */ (function (_super) {
        __extends(KbAvatar, _super);
        function KbAvatar($rootScope, dialogService, $http) {
            var _this = _super.call(this) || this;
            _this.$rootScope = $rootScope;
            _this.dialogService = dialogService;
            _this.$http = $http;
            _this.replace = true;
            _this.template = Dirs.component("kb-avatar");
            _this.restrict = "E";
            _this.scope = {
                path: "="
            };
            _this.link = function (scope, element, atts) {
                $rootScope.$on(_tools.events.avatarChanged, function (e, newPath) {
                    // Adding a hash to force the model to change (otherwise the image will not
                    // auto-load, assuming the newPath has not changed (but the data has)
                    if (newPath == $rootScope.user.id) {
                        var cacheBuster = "?v=" + (new Date()).getTime().toString();
                        scope.path = newPath + cacheBuster;
                    }
                    else {
                        scope.path = newPath;
                    }
                });
            };
            return _this;
        }
        KbAvatar = __decorate([
            NgComponent({
                token: Token.KbAvatar,
                dependencies: [
                    Token.$RootScope,
                    Token.DialogService,
                    Token.$Http,
                ]
            })
        ], KbAvatar);
        return KbAvatar;
    }(Directive));

    var KbButton = /** @class */ (function (_super) {
        __extends(KbButton, _super);
        function KbButton($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.transclude = true;
            _this.scope = {
                ngClick: "&",
                textColor: "=?",
                backgroundColor: "=?"
            };
            _this.template = Dirs.component("kb-button");
            return _this;
        }
        KbButton = __decorate([
            NgComponent({
                token: Token.KbButton
            })
        ], KbButton);
        return KbButton;
    }(Directive));

    /**
     * KbCheckbox
     *
     * pass in an inputId to explicitly set the checkbox input with an id,
     * otherwise if its in a kbfield will use a guid that was generated by the kbField
     * if there is no ngModel and no id provided, it will create it's own guid
     */
    var KbCheckbox = /** @class */ (function (_super) {
        __extends(KbCheckbox, _super);
        function KbCheckbox($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                inputId: "=?"
            });
            _this.template = Dirs.component("kb-checkbox");
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                controllers[0];
                var kbField = controllers.length > 1 ? controllers[1] : null;
                if (atts.inputId) ;
                else if (kbField && atts.ngModel) {
                    // if we're inside a kbfield, then tie the labels together with the same id                
                    scope.inputId = _tools.Utils.shortId();
                    if (!scope.ignoreField) {
                        kbField.scope.isCheckbox = true;
                        kbField.scope._checkboxId = scope.inputId;
                    }
                }
                else {
                    scope.inputId = _tools.Utils.shortId();
                }
                if (!scope.inputId) {
                    throw new Error("empty checkbox id");
                }
                element.on("keydown", function (e) {
                    if (e.which == 13 || e.which == 32 && !scope.ngDisabled) {
                        scope.$apply(function () {
                            scope.ngModel = !scope.ngModel;
                            scope.ngChange();
                        });
                        e.preventDefault();
                    }
                    else if (e.which == 27) {
                        element.blur();
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbCheckbox = __decorate([
            NgComponent({
                token: Token.KbCheckbox,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbCheckbox);
        return KbCheckbox;
    }(KbInput));

    var KbColorPicker = /** @class */ (function (_super) {
        __extends(KbColorPicker, _super);
        function KbColorPicker($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.scope = {
                ngModel: "="
            };
            _this.require = "?ngModel";
            _this.template = Dirs.component("kb-color-picker");
            _this.link = function (scope, element, atts, ngModel) {
                element.minicolors({
                    control: "hue",
                    defaultValue: scope.ngModel || "",
                    inline: false,
                    letterCase: "lowercase",
                    opacity: true,
                    position: "bottom left",
                    change: function (newValue) {
                        scope.$apply(function () {
                            ngModel.$setViewValue(newValue);
                        });
                    }
                });
                element.parent().addClass("kb-color-picker");
                element.parent().append('<div class="kb-ripple-border"></div>');
                ngModel.$render = function () {
                    $timeout(function () {
                        element.minicolors("value", ngModel.$viewValue || "");
                    }, 0, false);
                };
                scope.$on("$destroy", function () {
                    element.minicolors("destroy");
                });
            };
            return _this;
        }
        KbColorPicker = __decorate([
            NgComponent({
                token: Token.KbColorPicker,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbColorPicker);
        return KbColorPicker;
    }(Directive));

    var KbColumn = /** @class */ (function (_super) {
        __extends(KbColumn, _super);
        function KbColumn() {
            var _this = _super.call(this) || this;
            _this.require = ["^?kbSearchGrid", "^?kbDataGrid"];
            _this.replace = true;
            _this.template = Dirs.component("kb-column");
            _this.restrict = "AE";
            _this.scope = {
                label: "@",
                id: "@",
                field: "@",
                sortable: "=?",
                toggleSort: "&",
                order: "=?"
            };
            _this.transclude = true;
            _this.link = function (scope, element, atts, gridCtrl) {
                if (scope.sortable == null)
                    scope.sortable = true;
                gridCtrl = gridCtrl[0] ? gridCtrl[0] : gridCtrl[1];
                gridCtrl.addColumn(scope);
                scope.show = function () {
                    return ((typeof (atts.kbIf) == "undefined") || scope.$parent.$eval(atts.kbIf) != false);
                };
                scope.getClass = function () {
                    return element.attr("class");
                };
                scope.getStyle = function () {
                    return element.attr("style");
                };
            };
            return _this;
        }
        KbColumn = __decorate([
            NgComponent({
                token: Token.KbColumn,
                dependencies: []
            })
        ], KbColumn);
        return KbColumn;
    }(Directive));

    var KbComments = /** @class */ (function (_super) {
        __extends(KbComments, _super);
        function KbComments($rootScope, dialogService, $http, authService) {
            var _this = _super.call(this) || this;
            _this.$rootScope = $rootScope;
            _this.dialogService = dialogService;
            _this.$http = $http;
            _this.authService = authService;
            _this.replace = false;
            _this.template = Dirs.component("kb-comments");
            _this.restrict = "E";
            _this.scope = {
                objectId: "=",
                tableName: "@",
                api: "=?"
            };
            _this.link = function (scope, element, atts) {
                if (!angular__namespace.isDefined(scope.api)) {
                    scope.api = {};
                }
                scope._comments = [];
                scope.api.refresh = function () {
                    // get the comments for this object
                    if (angular__namespace.isDefined(scope.objectId) && $rootScope.user.canViewComments) {
                        _this.$http.get("/api/comments", {
                            params: {
                                objectId: scope.objectId,
                                tableName: scope.tableName
                            }
                        }).then(function (r) {
                            scope._comments = r.data ? r.data : [];
                        });
                    }
                };
                scope.api.refresh();
                scope._delete = function (item) {
                    scope._comments.remove(item);
                    _this.$http.delete("/api/comments/" + item.id);
                };
                scope._model = { text: "" };
                scope._cancel = function () {
                    scope._model.text = "";
                };
                scope._addComment = function () {
                    var newComment = {
                        idUser: $rootScope.user.id,
                        tableName: scope.tableName,
                        body: scope._model.text,
                        createdByName: $rootScope.user.firstName + " " + $rootScope.user.lastName,
                        createdByImagePath: $rootScope.user.imagePath
                    };
                    _this.$http.post("/api/comments/" + scope.objectId, newComment).then(function (r) {
                        scope._comments.push(r.data);
                        scope._model.text = "";
                    });
                };
                scope._edit = function (item) {
                    dialogService.input({
                        msg: "Comment Edit",
                        inputType: enums.eInputDialogType.textArea,
                        value: item.body,
                        buttons: [
                            new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                                item.body = args.value;
                                _this.$http.put("/api/comments/" + item.id, item).then(function (r) {
                                });
                            }),
                            new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                            })
                        ]
                    });
                };
            };
            return _this;
        }
        KbComments = __decorate([
            NgComponent({
                token: Token.KbComments,
                dependencies: [
                    Token.$RootScope,
                    Token.DialogService,
                    Token.$Http,
                    Token.AuthService,
                ]
            })
        ], KbComments);
        return KbComments;
    }(Directive));

    var KbContent = /** @class */ (function (_super) {
        __extends(KbContent, _super);
        function KbContent() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.scope = false;
            _this.link = function (scope, element, atts) {
                element.addClass("ng-binding").data("$binding", atts.kbContent);
                scope.$watch(atts.kbContent, function (value) {
                    element.html(value || "");
                });
            };
            return _this;
        }
        KbContent = __decorate([
            NgComponent({
                token: Token.KbContent
            })
        ], KbContent);
        return KbContent;
    }(Directive));

    var KbDataGrid = /** @class */ (function (_super) {
        __extends(KbDataGrid, _super);
        function KbDataGrid() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-data-grid");
            _this.restrict = "AE";
            _this.scope = false;
            _this.transclude = true;
            _this.controller = ["$scope", "$element", '$attrs', function ($scope, $element, $attrs) {
                    var columns = $scope.columns = [];
                    this.addColumn = function (column) {
                        var exists = columns.some(function (c) { return c.id == column.id; });
                        if (!exists) {
                            columns.push(column);
                            column.$on("$destroy", function (event) {
                                columns.remove(column);
                            });
                        }
                    };
                    this.reload = function () {
                        $scope.ngModel = $scope.$eval($attrs.ngModel);
                    };
                }];
            _this.link = function (scope, element, atts) {
                scope.ngModel = scope.$eval(atts.ngModel);
            };
            return _this;
        }
        KbDataGrid = __decorate([
            NgComponent({
                token: Token.KbDataGrid,
                dependencies: []
            })
        ], KbDataGrid);
        return KbDataGrid;
    }(Directive));

    var KbDatePicker = /** @class */ (function (_super) {
        __extends(KbDatePicker, _super);
        function KbDatePicker($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-date-picker");
            _this.scope = _tools.Utils.extend(_this.scope, {
                minDate: "=?",
                maxDate: "=?",
                format: "=?",
                enableTime: "=?"
            });
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                var ngModel = controllers[0];
                var input = element.find("input")[0];
                var picker = flatpickr__default["default"](input, {
                    onChange: function () {
                        ngModel.$setViewValue(picker.parseDate(input.value) || null);
                    },
                    allowInput: true,
                    enableTime: !!scope.enableTime
                });
                ngModel.$render = function () {
                    picker.setDate(ngModel.$viewValue);
                };
                var onBlur = function () {
                    picker.setDate(picker.parseDate(input.value) || null, true);
                };
                // update picker on manual input
                input.addEventListener('blur', onBlur);
                scope.$watch("minDate", function (newValue, oldValue) {
                    picker.set("minDate", newValue);
                });
                scope.$watch("maxDate", function (newValue, oldValue) {
                    picker.set("maxDate", newValue);
                });
                scope.$watch("format", function (newValue, oldValue) {
                    picker.set("dateFormat", newValue || "Y-m-d");
                    picker.setDate(ngModel.$viewValue, false); // set the date to update the format in the input
                });
                scope.$watch("enableTime", function (newValue, oldValue) {
                    picker.set("enableTime", !!newValue);
                });
                scope._clear = function () {
                    picker.clear();
                };
                scope.$on("$destroy", function () {
                    if (picker) {
                        picker.destroy();
                    }
                    input.removeEventListener('blur', onBlur);
                    element.off();
                });
            };
            return _this;
        }
        KbDatePicker = __decorate([
            NgComponent({
                token: Token.KbDatePicker,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbDatePicker);
        return KbDatePicker;
    }(KbInput));

    var KbDropdown = /** @class */ (function (_super) {
        __extends(KbDropdown, _super);
        function KbDropdown($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.scope = {
                open: "=",
                scrollTo: "@",
                autoDirection: "=",
                horizontalAlign: "@",
                verticalAlign: "@",
                height: "@",
                width: "@",
                animate: "@",
                ignoreClickOn: "@",
                ignoreClickOnParent: "@"
            };
            _this.replace = true;
            _this.transclude = true;
            _this.template = "\n<div class='kb-dropdown'>\n    <div class='kb-dropdown__overlay'></div>\n    <div class='kb-dropdown__content' ng-transclude></div>\n</div>";
            _this.link = function (scope, element, atts) {
                var timeouts = [];
                _tools.Utils.shortId();
                var $parent = $(element).parent();
                var openIsDefined = angular__namespace.isDefined(atts.open);
                var hAlign = scope.horizontalAlign || "left";
                var vAlign = scope.verticalAlign || "bottom";
                var vAlignOpposite = vAlign == "top" ? "bottom" : "top";
                var isVisible = false;
                // if height is set, make the dropdown scrollable
                if (scope.height && scope.height != 'auto')
                    element.addClass("kb-dropdown--scrollable");
                var height = scope.height || "auto";
                element.css("max-height", height);
                // define a tether
                var tether;
                var createTether = function () {
                    if (!tether) {
                        var options = {
                            element: element,
                            target: $parent,
                            attachment: vAlignOpposite + " " + hAlign,
                            targetAttachment: vAlign + " " + hAlign,
                            constraints: [
                                {
                                    to: document,
                                    attachment: "together",
                                    pin: ["left", "right"]
                                }
                            ],
                            classes: {
                                tether: false,
                                element: false,
                                target: false,
                                enabled: false,
                            }
                        };
                        // if the dropdown is part of a hotspot, and we are in XR, then we need to add to the hotspot div instead of body
                        var p = element[0].closest(".xr-overlay");
                        if (p) {
                            options.bodyElement = p;
                        }
                        // if the dropdown is inside an overlay popup, append to the popup container
                        // so it inherits the correct stacking context and renders above the popup backdrop
                        if (!p) {
                            var overlayContainer = element[0].closest(".kb-overlay-popup__container");
                            if (overlayContainer) {
                                options.bodyElement = overlayContainer;
                            }
                        }
                        tether = new Tether__default["default"](options);
                    }
                };
                var scrollToActive = function () {
                    if (isVisible && scope.scrollTo && scope.scrollTo.length > 1) {
                        var $item = element.find(scope.scrollTo);
                        if ($item.length > 0) {
                            _tools.Utils.scrollIntoView({ elem: $item[0], mode: _tools.eScrollMode.middleIfNecessary, animate: false });
                        }
                    }
                };
                scope.$watch("scrollTo", function (newValue) {
                    scrollToActive();
                });
                var preventScroll = function (e) {
                    if (e.target == document.body)
                        e.preventDefault();
                };
                var hideDropdown = function () {
                    if (!isVisible)
                        return;
                    isVisible = false;
                    //stage the close so CSS can animate it
                    $parent.removeClass("is-open");
                    element.removeClass("is-open");
                    setTimeout(function () {
                        element.css("display", "none");
                    }, 366);
                    document.removeEventListener("click", onDocumentClicked, true);
                    document.body.removeEventListener("touchmove", preventScroll);
                };
                // let hideDropdown = () => {
                //     if (!isVisible) return;
                //     isVisible = false;
                //     // setting to false so that in configurators, we're not waiting for the dropdown 
                //     // to close while the scene is being updated.Makes it feel sluggish
                //     // var animate = false; //!element.hasClass("tether-element-attached-bottom");
                //     let afterAnimation = () => {
                //         element.css("display", "none");
                //         element.css("height", "auto");
                //         $parent.removeClass("is-open");
                //     };
                //     if (scope.animate) {
                //         element.animate({ height: 0 }, 133, "easeOutSine", afterAnimation);
                //     } else {
                //         afterAnimation();
                //         // $timeout(afterAnimation, 0);
                //     }
                //     document.removeEventListener("click", onDocumentClicked, true);
                //     // $("body").removeClass("is-mobile-keyboard").css("overflow-y", "auto");
                //     document.body.removeEventListener("touchmove", preventScroll);
                // };
                var onDocumentClicked = function (e) {
                    var $target = $(e.target);
                    if ($target.hasClass("kb-dropdown__overlay")
                        || (!$target.is(scope.ignoreClickOn) &&
                            !$target.is($parent) &&
                            !$.contains($parent[0], e.target) &&
                            !$target.hasClass("kb-dropdown--ignore-click") &&
                            !$target.parents(".kb-dropdown--ignore-click").length &&
                            (!scope.ignoreClickOnParent || !$target.parents(scope.ignoreClickOnParent).length))) {
                        scope.$apply(function () {
                            hideDropdown();
                            if (openIsDefined) {
                                scope.open = false;
                            }
                        });
                    }
                };
                var showDropdown = function () {
                    if (isVisible)
                        return;
                    isVisible = true;
                    // Workaround for a bug in tether that finds a "zero element" in the xr-overlay when in the document.body context, which throws positioning off.
                    var tetherZeroElem = document.body.querySelector(".xr-overlay [data-tether-id]");
                    if (tetherZeroElem) {
                        tetherZeroElem.parentElement.removeChild(tetherZeroElem);
                    }
                    createTether();
                    var parentWidth = $parent[0].getBoundingClientRect().width;
                    var maxWidth = scope.width == "parent" ? parentWidth : (scope.width || "auto");
                    element.css("max-width", maxWidth);
                    // make the dropdown at least the width of the parent
                    element.css("min-width", $parent[0].getBoundingClientRect().width);
                    element.css("display", "block");
                    tether.position();
                    scrollToActive();
                    $parent.addClass("is-open");
                    element.addClass("is-open");
                    document.addEventListener("click", onDocumentClicked, true);
                    $(document).on("touchmove", preventScroll);
                    $timeout(function () { return tether.position(); }, 0);
                };
                // let showDropdown = () => {
                //     if (isVisible) return;
                //     isVisible = true;
                //     createTether();
                //     // make the dropdown at least the width of the parent
                //     element.css("min-width", $parent[0].getBoundingClientRect().width);
                //     $parent.addClass("is-open");
                //     element.css("display", "block");
                //     tether.position();
                //     // element.css("height", "auto");
                //     let autoHeight = element.height();
                //     // if we are attached to the bottom of the element, we don't want the
                //     // normal height animation, so we just show the dropdown
                //     let goingDown = !element.hasClass("tether-element-attached-bottom");
                //     let afterAnimation = () => {
                //         element.css("height", "auto");
                //         document.addEventListener("click", onDocumentClicked, true);
                //     };
                //     if (scope.animate && goingDown) {
                //         scrollToActive();
                //         element.height(0).animate({ height: autoHeight }, 133, "easeOutSine", afterAnimation);
                //     } else {                    
                //         timeouts.push($timeout(() => {
                //             scrollToActive();
                //             afterAnimation();
                //         }, 0));
                //     }
                //     // $("body").addClass("is-mobile-keyboard").css("overflow-y", "hidden");
                //     $(document).on("touchmove", preventScroll);
                // };
                var toggleDropdown = function (e) {
                    if ($parent.hasClass("is-open")) {
                        hideDropdown();
                    }
                    else {
                        showDropdown();
                    }
                    e.stopPropagation();
                };
                if (openIsDefined) {
                    scope.$watch("open", function (newValue) {
                        if (newValue) {
                            showDropdown();
                        }
                        else {
                            hideDropdown();
                        }
                    });
                }
                else {
                    $parent.on("click.kbdropdown", toggleDropdown);
                }
                scope.$on("$destroy", function () {
                    timeouts.forEach(function (t) { return $timeout.cancel(t); });
                    document.removeEventListener("click", onDocumentClicked, true);
                    $(document).off("touchmove", preventScroll);
                    $parent.off("click.kbdropdown");
                    // remove the dropdown element which is at the bottom of the body thanks to tether
                    if (tether)
                        tether.destroy();
                    element.remove();
                });
            };
            return _this;
        }
        KbDropdown = __decorate([
            NgComponent({
                token: Token.KbDropdown,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbDropdown);
        return KbDropdown;
    }(Directive));

    var KbEdit = /** @class */ (function (_super) {
        __extends(KbEdit, _super);
        function KbEdit($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-edit");
            _this.scope = {
                ngModel: "=",
                enabled: "=?"
            };
            _this.replace = true;
            _this.link = function (scope, element, atts) {
                var input = $(element).find("input");
                if (typeof scope.enabled == "undefined")
                    scope.enabled = true;
                scope.$watch("enabled", function (newValue) {
                    if (!newValue) {
                        scope._editing = false;
                        input.hide();
                    }
                });
                scope._click = function () {
                    if (!scope.enabled)
                        return;
                    scope._editing = true;
                    input.show();
                    input.focus();
                };
                scope._blur = function () {
                    scope._editing = false;
                    input.hide();
                };
                scope._keydown = function ($event) {
                    $event.stopPropagation();
                    if ($event.keyCode == _tools.keyboard.enter) {
                        scope._editing = false;
                        input.hide();
                    }
                };
            };
            return _this;
        }
        KbEdit = __decorate([
            NgComponent({
                token: Token.KbEdit,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbEdit);
        return KbEdit;
    }(Directive));

    var KbEllipsis = /** @class */ (function (_super) {
        __extends(KbEllipsis, _super);
        function KbEllipsis(kbService) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-ellipsis");
            _this.scope = false;
            _this.replace = true;
            return _this;
            // this.link = (scope, element, atts) => {
            // }
        }
        KbEllipsis = __decorate([
            NgComponent({
                token: Token.KbEllipsis,
                dependencies: [
                    Token.KbService
                ]
            })
        ], KbEllipsis);
        return KbEllipsis;
    }(Directive));

    var KbExpanderGroup = /** @class */ (function (_super) {
        __extends(KbExpanderGroup, _super);
        function KbExpanderGroup() {
            var _this = _super.call(this) || this;
            _this.replace = false;
            _this.template = Dirs.component("kb-expander-group");
            _this.restrict = "E";
            _this.scope = {
                accordion: "=?"
            };
            _this.transclude = true;
            // // add scope defaults to the compile function
            // this.compile = (element, atts: any) => {
            //     if (!angular.isDefined(atts.accordion)) atts.selectable = "true";
            //     if (!angular.isDefined(atts.expandable)) atts.expandable = "true";
            // };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                function ($scope, $element, $attrs) {
                    // set the scope of the tree on it's controller so children can access it
                    this.scope = $scope;
                    $scope.element = $element;
                    $scope._expanders = [];
                    // all child nodes register themselves with the tree to handle selection and accordion functionality
                    this.registerExpander = function (e) {
                        $scope._expanders.push(e);
                        var off = e.$on("$destroy", function (event) {
                            $scope._expanders.remove(e);
                            off();
                        });
                        if ($scope.accordion) {
                            for (var _i = 0, _a = $scope._expanders; _i < _a.length; _i++) {
                                var expander = _a[_i];
                                if (expander.expanded) {
                                    updateExpanders(expander);
                                    return;
                                }
                            }
                        }
                    };
                    this.expand = function (e) {
                        if (e.expanded)
                            updateExpanders(e);
                    };
                    var updateExpanders = function (activeExpander) {
                        if ($scope.accordion) {
                            for (var _i = 0, _a = $scope._expanders; _i < _a.length; _i++) {
                                var e = _a[_i];
                                if (e !== activeExpander)
                                    e.expanded = false;
                            }
                        }
                    };
                }
            ];
            return _this;
        }
        KbExpanderGroup = __decorate([
            NgComponent({
                token: Token.KbExpanderGroup
            })
        ], KbExpanderGroup);
        return KbExpanderGroup;
    }(Directive));

    var KbExpander = /** @class */ (function (_super) {
        __extends(KbExpander, _super);
        function KbExpander($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-expander");
            _this.transclude = {
                "title": "?kbExpanderTitle",
                "body": "kbExpanderBody"
            };
            _this.scope = {
                expanded: "=?",
                expandedChanged: "&",
                invalid: "=?",
                icon: "@",
                image: "@"
            };
            _this.replace = false;
            _this.require = ["?^^kbExpanderGroup", "?^^kbExpander"];
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                function ($scope, $element, $attrs) {
                    this.scope = $scope;
                    $scope.element = $element;
                }
            ];
            _this.link = function (scope, element, atts, controllers) {
                var kbExpanderGroup = controllers[0];
                var parentExpander = controllers[1];
                if (kbExpanderGroup && parentExpander) {
                    if ($(parentExpander.scope.element).parents().length > $(kbExpanderGroup.scope.element).parents().length) {
                        // if the parent expander is closer to this element than the group then we need to ignore the group
                        kbExpanderGroup = undefined;
                    }
                }
                if (kbExpanderGroup)
                    kbExpanderGroup.registerExpander(scope);
                scope._toggle = function () {
                    scope.expanded = !scope.expanded;
                };
                scope._hasError = function () {
                    return element.find(".kb-field__error").length > 0;
                };
                scope.$watch("expanded", function (newVal, oldVal) {
                    // Animate after transcluding to prevent the body being shown on load.
                    element.find(".kb-expander__body").addClass("kb-animate");
                    if (newVal != oldVal) {
                        if (kbExpanderGroup && scope.expanded)
                            kbExpanderGroup.expand(scope);
                        if (scope.expandedChanged)
                            scope.expandedChanged();
                    }
                });
            };
            return _this;
        }
        KbExpander = __decorate([
            NgComponent({
                token: Token.KbExpander,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbExpander);
        return KbExpander;
    }(Directive));

    /**
     * kbField
     * works in tandem with kbForm.  Will pull the modelType from kbForm and use it to find localized label
     * and description for the field.  It will also search it's direct children looking for an ngModel, as it
     * needs this info to find the model property name being bound to (also used to find the label and description)
     *
     * To override the localized label and description, you can directly set the attributes labelLoc and descLockb
     * to the name of a localization resource.
     *
     * If there is no clear way to find the ngModel child, you can set the modelProp attribute to help it find
     * the label and desc localizations
     *
     * The required attribute can be set to true to have a * show up at the end of the label
     *
     * If the model property is localizeable by the user, set the localize attribute to the model id
     * example:  <kb-field localize="model.id">
     *
     *
     */
    var KbField = /** @class */ (function (_super) {
        __extends(KbField, _super);
        function KbField(kbService) {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-field");
            _this.scope = {
                required: "@",
                label: "@",
                labelLoc: "@",
                desc: "@",
                descLoc: "@",
                ngDisabled: "=?",
                validationErrors: "=?",
                runFixThis: "&",
                warnings: "=?",
                fixOptions: "=?",
                isCheckbox: "=?",
                helpMedia: "=?",
                helpUrl: "=?",
                mobileHelpDropdown: "=?",
                useZeroPadding: "=?"
            };
            _this.replace = true;
            _this.transclude = true;
            _this.require = "^?kbForm";
            _this.compile = function (element, atts) {
                if (atts.mobileHelpDropdown == null)
                    atts.mobileHelpDropdown = "true";
                return _this.link;
            };
            _this.controller = ["$scope", "$element", function ($scope, $element) {
                    this.scope = $scope;
                    this.setFocused = function (focused) {
                        if ($scope._focused !== focused) {
                            $element.toggleClass("kb-field--is-focused", focused);
                        }
                        $scope._focused = focused;
                    };
                    this.setHasValue = function (hasValue) {
                        if ($scope._hasValue !== hasValue) {
                            $element.toggleClass("kb-field--has-value", hasValue);
                        }
                        $scope._hasValue = hasValue;
                    };
                    this.setShouldFloat = function (shouldFloat) {
                        $element.toggleClass("kb-field--should-float", shouldFloat);
                    };
                }];
            _this.link = function (scope, element, atts, kbForm) {
                if (kbForm) { //integration with kbForm
                    var modelProp_1;
                    //if in a kbForm, we look in the child input and 
                    // scrape the ng - model from it so we know the property we're connecting to
                    var $input = element.find(".kb-field__input *[ng-model]").first();
                    if ($input.length > 0) {
                        var path = $input.attr("ng-model");
                        modelProp_1 = path.substring(path.lastIndexOf(".") + 1);
                    }
                    // if title is specified, then it means it's the name of a loc
                    var autoLoc = false; // whether the label/desc is being automatically inferred
                    if (modelProp_1 && !scope.labelLoc) {
                        // title was not specified, so we look for a kbForm ancestor that could be providing
                        // model type information
                        if (kbForm && kbForm.scope.modelType && modelProp_1) {
                            scope.labelLoc = kbForm.scope.modelType + "_" + modelProp_1 + "_title";
                            scope.descLoc = kbForm.scope.modelType + "_" + modelProp_1 + "_desc";
                            autoLoc = true;
                            // check to see if the loc exists... if not, we can try generic resources
                            if (!loc[scope.labelLoc.toLowerCase()]) {
                                scope.labelLoc = "generic_" + modelProp_1 + "_title";
                                scope.descLoc = "generic_" + modelProp_1 + "_desc";
                                // if the generics don't exist either, then we'll just not have a label
                                if (!loc[scope.labelLoc.toLowerCase()]) {
                                    scope.labelLoc = "";
                                    scope.descLoc = "";
                                }
                            }
                        }
                    }
                    if (scope.labelLoc) {
                        scope.label = kbService.loc(scope.labelLoc);
                    }
                    if (scope.descLoc) {
                        var autoDesc = kbService.loc(scope.descLoc);
                        scope.desc = (autoLoc && autoDesc == scope.descLoc) ? "" : autoDesc;
                    }
                    // validation
                    // if the validationErrors attribute was set, then we use it
                    // if not set, then we check for a parentForm's validation property that matches our ngmodel expression
                    if (!atts.validationErrors) {
                        scope.$watch(function () {
                            if (!kbForm.scope.validation)
                                return null;
                            return kbForm.scope.validation[modelProp_1];
                        }, function (newValue) {
                            if (newValue) {
                                scope.validationErrors = [newValue];
                            }
                            else {
                                scope.validationErrors ? scope.validationErrors.clear() : scope.validationErrors = [];
                            }
                        });
                    }
                }
                //pass throughs for field controls in a configurator
                scope._runFixThis = function (f) {
                    return scope.runFixThis({ fix: f });
                };
                // $scope._upload = file => {
                //     return $scope.upload({ file });
                // };
                // $scope._autoCompleteQuery = query => {
                //     return $scope.autoCompleteQuery({ query, field: $scope.field });
                // };
                // $scope._autoCompleteGetLabel = value => {
                //     return $scope.autoCompleteGetLabel({ value, field: $scope.field });
                // };
                // $scope._translateKbo = property => {
                //     return $scope.translateKbo({ kbObject: $scope.field, property });
                // };
                scope.$on("$destroy", function () {
                });
            };
            return _this;
        }
        KbField = __decorate([
            NgComponent({
                token: Token.KbField,
                dependencies: [
                    Token.KbService
                ]
            })
        ], KbField);
        return KbField;
    }(Directive));

    var KbFocus = /** @class */ (function (_super) {
        __extends(KbFocus, _super);
        function KbFocus($timeout) {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "A";
            _this.scope = false;
            _this.link = function (scope, element, atts) {
                $timeout(function () {
                    element[0].focus();
                }, 200);
            };
            return _this;
        }
        KbFocus = __decorate([
            NgComponent({
                token: Token.KbFocus,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbFocus);
        return KbFocus;
    }(Directive));

    var KbForm = /** @class */ (function (_super) {
        __extends(KbForm, _super);
        function KbForm() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-form");
            _this.restrict = "E";
            _this.scope = {
                modelType: "@",
                validation: "=",
                ngDisabled: "=?"
            };
            _this.transclude = true;
            _this.controller = ["$scope", "$element", function ($scope, $element) {
                    this.scope = $scope;
                }];
            return _this;
        }
        KbForm = __decorate([
            NgComponent({
                token: Token.KbForm,
                dependencies: []
            })
        ], KbForm);
        return KbForm;
    }(Directive));

    var KbIcon = /** @class */ (function (_super) {
        __extends(KbIcon, _super);
        function KbIcon(kbService) {
            var _this = _super.call(this) || this;
            _this.kbService = kbService;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-icon");
            _this.scope = {
                icon: "@",
                label: "@"
            };
            _this.replace = true;
            return _this;
        }
        KbIcon = __decorate([
            NgComponent({
                token: Token.KbIcon,
                dependencies: [
                    Token.KbService
                ]
            })
        ], KbIcon);
        return KbIcon;
    }(Directive));

    /**
     * A performance driven directive that does the following:
     * * will not render the html it is placed on until the kb-if evaluates to truthy (like ng-if)
     * * will NOT destroy the html when kb-if thereafter evaluates to false.  Instead, it will
     *   hide the html like ng-show would, but also suspend all the watchers on this element and any children.
     *
     * Uses the feature described here:  https://github.com/angular/angular.js/pull/16308
     */
    var KbIf = /** @class */ (function (_super) {
        __extends(KbIf, _super);
        function KbIf($animate) {
            var _this = _super.call(this) || this;
            _this.watchAtt = "kbIf";
            _this.restrict = "A";
            _this.priority = 600;
            _this.transclude = "element";
            _this.terminal = true;
            _this.$$tlb = true;
            _this.link = function (scope, element, atts, ctrl, $transclude) {
                var innerScope;
                var innerElement;
                var hide = function () {
                    $animate.addClass(innerElement, "ng-hide", {
                        tempClasses: "ng-hide-animate"
                    });
                };
                var show = function () {
                    $animate.removeClass(innerElement, "ng-hide", {
                        tempClasses: "ng-hide-animate"
                    });
                };
                scope.$watch(atts[_this.watchAtt], function (value, oVal) {
                    // $animate[value ? 'removeClass' : 'addClass'](innerElement, NG_HIDE_CLASS, {
                    //     tempClasses: NG_HIDE_IN_PROGRESS_CLASS
                    // });
                    if (value) {
                        if (!innerElement) {
                            // Add the transcluded content after the transclusion comment placeholder    
                            $transclude(function (el, sc) {
                                element.after(el);
                                innerElement = el;
                                innerScope = sc;
                                innerScope.$resume();
                                $animate.enter(el, element.parent(), element);
                                innerElement.removeClass("ng-hide");
                            });
                        }
                        else {
                            innerScope.$resume();
                            show();
                        }
                    }
                    else {
                        if (innerElement) {
                            if (_this.hideDelay) {
                                setTimeout(function () {
                                    hide();
                                }, _this.hideDelay);
                            }
                            else {
                                hide();
                            }
                            // Before suspending, the scope should digest one more time to allow updates (e.g. initial watch)
                            scope.$$postDigest(function () {
                                innerScope.$suspend();
                            });
                        }
                    }
                });
            };
            return _this;
        }
        KbIf = __decorate([
            NgComponent({
                token: Token.KbIf,
                dependencies: [
                    Token.$Animate
                ]
            })
        ], KbIf);
        return KbIf;
    }(Directive));

    /**
     * A version of kbIf that delays the adding of the ng-hide once the value resolves to false to
     * give animations a chance to finish.
     */
    var KbIfDelay = /** @class */ (function (_super) {
        __extends(KbIfDelay, _super);
        function KbIfDelay($animate) {
            var _this = _super.call(this, $animate) || this;
            _this.watchAtt = "kbIfDelay";
            _this.hideDelay = 300;
            return _this;
        }
        KbIfDelay = __decorate([
            NgComponent({
                token: Token.KbIfDelay,
                dependencies: [
                    Token.$Animate
                ]
            })
        ], KbIfDelay);
        return KbIfDelay;
    }(KbIf));

    var KbMultiSelect = /** @class */ (function (_super) {
        __extends(KbMultiSelect, _super);
        function KbMultiSelect($timeout, $window) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-multi-select");
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "=",
                valueField: "@",
                labelField: "@",
                headerTemplate: "@",
                data: "=?",
                addItem: "&",
                removeItem: "&",
                mode: "@",
                itemStyle: "=?",
                allowDeleteInHeader: "=?",
                itemIsSelectable: "&",
                mobileDropdown: "=?"
            });
            _this.transclude = true;
            _this.compile = function (element, atts) {
                if (angular__namespace.isUndefined(atts.mode)) {
                    atts.mode = "objects";
                }
                if (angular__namespace.isUndefined(atts.allowDeleteInHeader)) {
                    atts.allowDeleteInHeader = "true";
                }
                if (atts.mobileDropdown == null)
                    atts.mobileDropdown = "true";
                return _this.link;
            };
            _this.link = function (s, e, a, c) { return _this.kbMultiSelectLinkFn(s, e, a, c, true); };
            return _this;
        }
        KbMultiSelect.prototype.kbMultiSelectLinkFn = function (scope, element, atts, controllers, shouldFloat) {
            if (shouldFloat === void 0) { shouldFloat = true; }
            this.kbInputLinkFn(scope, element, atts, controllers, shouldFloat);
            var ngModelCtrl = controllers[0];
            scope._dropdownOpen = false;
            scope._selectedItems = [];
            scope._selectedMap = [];
            scope._binding = { query: "" };
            element.find("input");
            scope._id = _tools.Utils.shortId();
            scope._isEnabled = function () {
                return !scope.ngDisabled;
            };
            var getItemValue = function (item) {
                if (item == null)
                    return null;
                return scope.valueField ? item[scope.valueField] : item;
            };
            scope._getItemLabel = function (item) {
                if (scope.labelField && item[scope.labelField]) {
                    return item[scope.labelField];
                }
                else if (scope.valueField) {
                    return item[scope.valueField];
                }
                else {
                    return item;
                }
            };
            var updateSelected = function () {
                scope._selectedItems.clear();
                // set all options to visible
                scope._selectedMap.clear();
                if (scope.source)
                    scope.source.forEach(function (item) { return scope._selectedMap.push(false); });
                if (ngModelCtrl.$viewValue) {
                    for (var _i = 0, _a = ngModelCtrl.$viewValue; _i < _a.length; _i++) {
                        var item = _a[_i];
                        var itemValue = item;
                        if (scope.mode == "objects") {
                            itemValue = getItemValue(item);
                        }
                        if (scope.source) {
                            for (var i = 0; i < scope.source.length; i++) {
                                var sourceItem = scope.source[i];
                                if (getItemValue(sourceItem) == itemValue) {
                                    scope._selectedItems.push(sourceItem);
                                    // hide the option since it's selected
                                    scope._selectedMap[i] = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            };
            // let showDropdown = () => {
            //     scope._dropdownOpen = true;
            //     // on mobile the filter input will kick off the keyboard, which we don't necessarily want.  
            //     // The problem is worse on IOS because of focus restrictions
            //     if ($window.innerWidth >= Utils.MOBILE_WIDTH && !Utils.isIos()) {
            //         $timeout(() => input.focus());
            //     }
            // };
            // let hideDropdown = () => {
            //     scope._dropdownOpen = false;
            //     scope._binding.query = null;
            //     updateFilteredSource();
            // };
            // let toggleDropdown = () => {
            //     scope._dropdownOpen ? hideDropdown() : showDropdown();
            // };
            // options might be added after the ngModel is set by the consumer, so
            // we need to refind the selected option 
            scope.$watchCollection("source", function () {
                updateSelected();
                updateFilteredSource();
            });
            scope.$watchCollection("ngModel", function () {
                // ngModel watches by reference, which doesn't work well for arrays
                updateSelected();
            });
            ngModelCtrl.$render = function () {
                updateSelected();
            };
            scope._itemMousedown = function (e) {
                e.preventDefault(); // so we don't lose focus
            };
            scope._itemClick = function (e, item) {
                e.preventDefault();
                scope._select(item);
            };
            scope._itemIsSelectable = function (item) {
                if (atts.itemIsSelectable) {
                    return scope.itemIsSelectable({ item: item });
                }
                return true;
            };
            scope._select = function (sourceItem) {
                if (scope._isEnabled() && scope._itemIsSelectable(sourceItem)) {
                    if (atts.addItem) {
                        scope.addItem({ sourceItem: sourceItem });
                    }
                    else {
                        if (isSelected(sourceItem)) {
                            scope._delete(sourceItem);
                        }
                        else {
                            var viewValue = ngModelCtrl.$viewValue;
                            if (scope.mode == "objects") {
                                ngModelCtrl.$setViewValue(viewValue.concat([sourceItem])); // $viewValue.push(sourceItem);
                            }
                            else {
                                ngModelCtrl.$setViewValue(viewValue.concat([getItemValue(sourceItem)]));
                            }
                        }
                    }
                    //updateSelected(); don't need to call because the watch on ngModel picks up the change
                    //scope.ngChange();
                    // moveDown();
                }
            };
            scope._isActive = function (index) {
                return index === scope._activeIndex;
            };
            var updateFilteredSource = function () {
                if (!scope._binding.query) {
                    scope._filteredSource = scope.source;
                }
                else {
                    scope._filteredSource = _tools.SearchUtils.search(scope._binding.query, scope.source, function (o) { return scope._getItemLabel(o); }, 10000);
                    scope._activeIndex = -1;
                }
            };
            scope._queryChange = function (e) {
                updateFilteredSource();
            };
            scope._queryKeydown = function (e) {
                if (e.which == 38) {
                    moveUp();
                    e.stopPropagation();
                }
                if (e.which == 40) {
                    moveDown();
                    e.stopPropagation();
                }
                if (e.which === 13) {
                    enter();
                    e.stopPropagation();
                }
                if (e.which === 9) {
                    tab();
                    if (scope._dropdownOpen) {
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
            };
            scope._click = function (e) {
                if (scope._isEnabled()) {
                    scope._activeIndex = -1;
                    scope._dropdownOpen = !scope._dropdownOpen;
                }
            };
            scope._itemDeleteBtnClick = function (e, item) {
                scope._delete(item);
                e.stopPropagation();
            };
            scope._delete = function (item) {
                if (scope._isEnabled()) {
                    if (atts.removeItem) {
                        scope.removeItem({ item: item });
                    }
                    else {
                        var itemValue = getItemValue(item);
                        // the normal array.remove compares values strictly (with ===), 
                        // but we need == in this case because of possible string / number mismatch
                        for (var i = ngModelCtrl.$viewValue.length - 1; i >= 0; i--) {
                            var ngModelValue = ngModelCtrl.$viewValue[i];
                            if (scope.mode == "objects") {
                                ngModelValue = getItemValue(ngModelValue);
                            }
                            if (ngModelValue == itemValue) {
                                var viewValue = ngModelCtrl.$viewValue;
                                var newVal = __spreadArray([], viewValue, true);
                                newVal.splice(i, 1);
                                ngModelCtrl.$setViewValue(newVal);
                                break;
                            }
                        }
                    }
                    //updateSelected(); don't need to call because the watch on ngModel picks up the change
                    // scope.ngChange();
                }
            };
            var isSelected = function (sourceItem) {
                var optionVal = getItemValue(sourceItem);
                for (var _i = 0, _a = scope._selectedItems; _i < _a.length; _i++) {
                    var selectedItem = _a[_i];
                    if (optionVal === getItemValue(selectedItem)) {
                        return true;
                    }
                }
                return false;
            };
            var moveUp = function () {
                if (scope._dropdownOpen) {
                    var newIndex = scope._activeIndex - 1;
                    if (newIndex >= 0) {
                        scope._activeIndex = newIndex;
                    }
                }
            };
            var moveDown = function () {
                scope._dropdownOpen = true;
                var newIndex = scope._activeIndex + 1;
                if (newIndex < scope._filteredSource.length) {
                    scope._activeIndex = newIndex;
                }
            };
            var enter = function () {
                if (scope._dropdownOpen) {
                    if (scope._filteredSource.length && scope._activeIndex > -1) {
                        scope._select(scope.source[scope._activeIndex]);
                    }
                }
                else {
                    scope._dropdownOpen = true;
                }
            };
            var tab = function () {
                if (scope._dropdownOpen) {
                    if (scope._filteredSource.length && scope._activeIndex > -1) {
                        scope._select(scope.source[scope._activeIndex]);
                        scope._dropdownOpen = false;
                    }
                }
            };
            // bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
            element.on("keydown", function (e) {
                if (e.key == 'ArrowUp') {
                    e.preventDefault();
                    scope.$apply(function () {
                        moveUp();
                    });
                }
                if (e.key == 'ArrowDown') {
                    e.preventDefault();
                    scope.$apply(function () {
                        moveDown();
                    });
                }
                if (e.key == 'Enter') {
                    scope.$apply(function () {
                        e.preventDefault();
                        enter();
                    });
                }
                if (e.key == 'Tab') {
                    scope.$apply(function () {
                        if (scope._dropdownOpen) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        tab();
                    });
                }
                if (e.key == 'Escape') {
                    e.preventDefault();
                    element.trigger('blur');
                    scope.$apply(function () {
                        scope._dropdownOpen = false;
                        e.stopPropagation();
                    });
                }
            });
            scope.$on("$destroy", function () {
                element.off();
            });
        };
        KbMultiSelect = __decorate([
            NgComponent({
                token: Token.KbMultiSelect,
                dependencies: [
                    Token.$Timeout,
                    Token.$Window,
                ]
            })
        ], KbMultiSelect);
        return KbMultiSelect;
    }(KbInput));

    var ImageSelectHelper = /** @class */ (function () {
        function ImageSelectHelper($window, $timeout, scope, element) {
            this.$window = $window;
            this.$timeout = $timeout;
            this.scope = scope;
            this.element = element;
            var windowResize = _tools.Utils.debounce(function () {
                //if we are in a mode of scroll, then we need to find a margin between items that leaves an option
                //halfway out of view to be clear there are more items to scroll horizontally to.
                if (scope.optionLayout == enums.eOptionLayout.scroll) {
                    //make sure there are enough items to scroll
                    var minMargin = 4;
                    var play = .05;
                    var minPlayRange = .5 - play;
                    var maxPlayRange = .5 + play;
                    var $items = element.find(".kb-option");
                    var $firstItem = $items.length ? $items[0] : null;
                    if ($firstItem) {
                        var itemWidth = $firstItem.offsetWidth;
                        var itemAndMargin = itemWidth + minMargin;
                        var elWidth = element.innerWidth();
                        //make sure there are enough items that we should be scrolling
                        if (elWidth < (itemAndMargin * $items.length)) {
                            //find the number of visible items with min margin
                            var n = elWidth / itemAndMargin;
                            //now round up to the nearest half
                            var remainder = n % 1;
                            if (remainder < minPlayRange || remainder > maxPlayRange) {
                                var nModifier = remainder < minPlayRange ? -remainder - .5 : .5 - remainder;
                                var idealN = n + nModifier;
                                var idealMargin = (elWidth - (itemWidth * idealN)) / (idealN - .5);
                                $items.css("margin-right", idealMargin);
                            }
                            else {
                                //do nothing... we are close enough
                                $items.css("margin-right", minMargin);
                            }
                        }
                    }
                }
            }, 100);
            $($window).on("resize", windowResize);
            $timeout(function () {
                windowResize();
            }, 0);
            scope.$watch("optionLayout", function (newVal, oldVal) {
                element.removeClass("kb-image-select--" + (oldVal || enums.eOptionLayout.wrap));
                element.addClass("kb-image-select--" + (newVal || enums.eOptionLayout.wrap));
                windowResize();
            });
            scope.$on("$destroy", function () {
                element.off();
                $($window).off("resize", windowResize);
            });
        }
        return ImageSelectHelper;
    }());

    var KbImageMultiSelect = /** @class */ (function (_super) {
        __extends(KbImageMultiSelect, _super);
        function KbImageMultiSelect($timeout, $window) {
            var _this = _super.call(this, $timeout, $window) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                optionLayout: "=?"
            });
            _this.template = Dirs.component("kb-image-multi-select");
            _this.link = function (scope, element, atts, controllers) {
                _this.kbMultiSelectLinkFn(scope, element, atts, controllers, false);
                new ImageSelectHelper($window, $timeout, scope, element);
            };
            return _this;
        }
        KbImageMultiSelect = __decorate([
            NgComponent({
                token: Token.KbImageMultiSelect,
                dependencies: [
                    Token.$Timeout,
                    Token.$Window,
                ]
            })
        ], KbImageMultiSelect);
        return KbImageMultiSelect;
    }(KbMultiSelect));

    var KbImageSelect = /** @class */ (function (_super) {
        __extends(KbImageSelect, _super);
        function KbImageSelect($timeout, $window) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-image-select");
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "=",
                data: "=?",
                valueField: "@",
                labelField: "@",
                itemStyle: "=?",
                optionLayout: "=?"
            });
            _this.transclude = true;
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers, false);
                new ImageSelectHelper($window, $timeout, scope, element);
                var ngModel = controllers[0];
                var getItemValue = function (item) {
                    if (item === null || item === undefined)
                        return null;
                    return scope.valueField ? item[scope.valueField] : item;
                };
                var isEnabled = function () {
                    return !scope.ngDisabled;
                };
                var updateSelected = function () {
                    var selected = null;
                    if (scope.source) {
                        for (var _i = 0, _a = scope.source; _i < _a.length; _i++) {
                            var item = _a[_i];
                            item.$selected = false;
                            if (getItemValue(item) == ngModel.$viewValue) {
                                selected = item;
                                item.$selected = true;
                            }
                        }
                    }
                    scope._selectedItem = selected;
                };
                // options might be added after the ngModel is set by the consumer, so
                // we need to refind the selected option 
                scope.$watchCollection("source", function () {
                    updateSelected();
                });
                ngModel.$render = function () {
                    updateSelected();
                };
                scope._select = function (item) {
                    if (isEnabled()) {
                        ngModel.$setViewValue(getItemValue(item));
                        scope._selectedItem = item;
                        for (var _i = 0, _a = scope.source; _i < _a.length; _i++) {
                            var item_1 = _a[_i];
                            item_1.$selected = false;
                        }
                        item.$selected = true;
                    }
                };
                scope._helpClick = function (e) {
                    e.stopPropagation();
                };
                var moveUp = function () {
                    if (scope.source && scope._selectedItem) {
                        var curIndex = scope.source.indexOf(scope._selectedItem);
                        var newIndex = curIndex - 1;
                        if (newIndex >= 0)
                            scope._select(scope.source[newIndex]);
                    }
                    else if (scope.source && scope.source.length) {
                        scope._select(scope.source[0]);
                    }
                };
                var moveDown = function () {
                    if (scope.source && scope._selectedItem) {
                        var curIndex = scope.source.indexOf(scope._selectedItem);
                        var newIndex = curIndex + 1;
                        if (newIndex < scope.source.length)
                            scope._select(scope.source[newIndex]);
                    }
                    else if (scope.source && scope.source.length) {
                        scope._select(scope.source[0]);
                    }
                };
                var scrollSelectedIntoView = function () {
                    if (scope.optionLayout == enums.eOptionLayout.scroll) {
                        $timeout(function () {
                            var $selected = element.find(".kb-option.selected");
                            var selectedElem = $selected.length ? $selected[0] : null;
                            if (selectedElem) {
                                _tools.Utils.scrollIntoView({
                                    elem: selectedElem,
                                    mode: _tools.eScrollMode.nearest,
                                    horizontal: true,
                                    animate: true,
                                    nearestEndPadding: parseInt(selectedElem.style.marginRight) + selectedElem.offsetWidth / 2
                                });
                            }
                        });
                    }
                };
                scope.$watch("_selectedItem", function () {
                    scrollSelectedIntoView();
                });
                // bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                element.on("keydown", function (e) {
                    if (e.key == 'ArrowLeft' || e.key == 'ArrowUp') {
                        e.preventDefault();
                        scope.$apply(function () {
                            moveUp();
                        });
                    }
                    if (e.key == 'ArrowRight' || e.key == 'ArrowDown') {
                        e.preventDefault();
                        scope.$apply(function () {
                            moveDown();
                        });
                    }
                    if (e.key == 'Escape') {
                        element.trigger('blur');
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                    // $($window).off("resize", windowResize);
                });
            };
            return _this;
        }
        KbImageSelect = __decorate([
            NgComponent({
                token: Token.KbImageSelect,
                dependencies: [
                    Token.$Timeout,
                    Token.$Window
                ]
            })
        ], KbImageSelect);
        return KbImageSelect;
    }(KbInput));

    /**
     * Creates a new scope for ng-include along with being able to set variables on the new scope
     */
    var KbInclude = /** @class */ (function (_super) {
        __extends(KbInclude, _super);
        function KbInclude($templateRequest, $compile) {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.link = function (scope, element, atts) {
                var templateUrl = scope.$eval(atts.kbInclude);
                $templateRequest(templateUrl, true).then(function (response) {
                    var $template = angular__namespace.element(response);
                    // compile the template
                    var compiled = $compile($template);
                    // append it to the label
                    element.replaceWith($template);
                    // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                    compiled(scope);
                });
            };
            return _this;
        }
        KbInclude = __decorate([
            NgComponent({
                token: Token.KbInclude,
                dependencies: [
                    Token.$TemplateRequest,
                    Token.$Compile
                ]
            })
        ], KbInclude);
        return KbInclude;
    }(Directive));

    var KbInfiniteScroll = /** @class */ (function (_super) {
        __extends(KbInfiniteScroll, _super);
        function KbInfiniteScroll($rootScope, $window, $timeout, $compile, promiseTracker, $q) {
            var _this = _super.call(this) || this;
            _this.$rootScope = $rootScope;
            _this.restrict = "A";
            _this.replace = false;
            _this.scope = false;
            _this.link = function (scope, element, atts) {
                // var checkWhenEnabled: boolean;
                var scrollDistance;
                // var scrollEnabled: boolean;
                angular__namespace.element($window);
                var $parent;
                var $child;
                if (angular__namespace.isDefined(atts.kbInfiniteScrollParent)) {
                    $parent = angular__namespace.element(atts.kbInfiniteScrollParent);
                    //if we are inside a directive, then the element might not be in the DOM yet,
                    //so we search for it in the directive element chain
                    if (!$parent.length) {
                        $parent = _this.findDirectiveElement(element, atts.kbInfiniteScrollParent);
                    }
                }
                else {
                    $parent = $window;
                }
                if (angular__namespace.isDefined(atts.kbInfiniteScrollChild)) {
                    $child = angular__namespace.element(atts.kbInfiniteScrollChild);
                    //if we are inside a directive, then the element might not be in the DOM yet,
                    //so we search for it in the directive element chain
                    if (!$child.length) {
                        $child = _this.findDirectiveElement(element, atts.kbInfiniteScrollChild);
                    }
                }
                else {
                    $child = element;
                }
                var isHorizontal = false;
                if (angular__namespace.isDefined(atts.kbInfiniteScrollOrientation)) {
                    if (atts.kbInfiniteScrollOrientation.toLowerCase() == "horizontal") {
                        isHorizontal = true;
                    }
                }
                var hasReverseScroll = false;
                if (angular__namespace.isDefined(atts.kbInfiniteScrollReverse)) {
                    hasReverseScroll = true;
                }
                var template;
                if (isHorizontal) {
                    template = "\n<div ng-class=\"{'is-hidden': !infiniteScrollTracker.active()}\"\n     style=\"width: 50px; \n            height: 100%; \n            display: inline-flex; \n            display: -webkit-inline-flex; \n            align-items: center; \n            justify-content: center;\">\n</div>";
                }
                else {
                    template = "\n<div ng-class=\"{'is-hidden': !infiniteScrollTracker.active()}\"\n     style=\"height: 50px; \n            display: flex; \n            display: -webkit-flex; \n            align-items: center; \n            justify-content: center;\">\n</div>";
                }
                var $template = $(template);
                var spinner = "<img ng-src=\"{{::'images/spinning_circle.gif' | asset}}\" style=\"width: 28px; height: 28px;\">";
                $template.append(spinner);
                $template = $compile($template)(scope);
                element.append($template);
                scrollDistance = 0;
                if (atts.kbInfiniteScrollDistance) {
                    scope.$watch(atts.kbInfiniteScrollDistance, function (value) {
                        return scrollDistance = parseFloat(value);
                    });
                }
                var busy = false;
                var handler = _tools.Utils.debounce(function () {
                    if (busy)
                        return;
                    busy = true;
                    var shouldScroll = false;
                    if (isHorizontal) {
                        var parentWidth = $parent[0].clientWidth;
                        var portalRight = parentWidth + $parent[0].scrollLeft;
                        var remaining = $child[0].clientWidth - portalRight;
                        shouldScroll = remaining <= parentWidth * scrollDistance;
                    }
                    else {
                        var parentHeight = $parent[0].clientHeight;
                        var portalBottom = parentHeight + $parent[0].scrollTop;
                        var remaining = $child[0].clientHeight - portalBottom;
                        shouldScroll = remaining <= parentHeight * scrollDistance;
                    }
                    return $q.when(shouldScroll && scope.$eval(atts.kbInfiniteScroll)).then(function () {
                        busy = false;
                    });
                }, 10);
                var reverseBusy = false;
                var reverseHandler = _tools.Utils.debounce(function () {
                    if (reverseBusy || scope.$eval(atts.kbInfiniteScrollReverseDisabled))
                        return;
                    reverseBusy = true;
                    var shouldScroll = false;
                    if (isHorizontal) {
                        var threshold = $parent[0].clientWidth * scrollDistance;
                        var curScroll = $parent[0].scrollLeft;
                        if (curScroll <= threshold) {
                            $parent[0].scrollLeft = threshold;
                        }
                        shouldScroll = curScroll <= threshold;
                    }
                    else {
                        var threshold = $parent[0].clientHeight * scrollDistance;
                        var curScroll = $parent[0].scrollTop;
                        // This is needed because if the scrollbar reaches the top 
                        // it will not move down once the items are added to the top of the list
                        if (curScroll <= threshold) {
                            $parent[0].scrollTop = threshold;
                        }
                        shouldScroll = curScroll <= threshold;
                    }
                    return $q.when(shouldScroll && scope.$eval(atts.kbInfiniteScrollReverse)).then(function () {
                        reverseBusy = false;
                    });
                }, 10);
                var onMousewheel = function (e) {
                    if (e.deltaY === 1) {
                        e.preventDefault();
                    }
                };
                $parent[0].addEventListener("scroll", handler);
                $parent[0].addEventListener("mousewheel", onMousewheel); //need the mousewheel event for a bug in chrome:  https://stackoverflow.com/a/47684257/709968
                if (hasReverseScroll) {
                    $parent[0].addEventListener("scroll", reverseHandler);
                }
                //$parent.on("scroll", handler);
                scope.$on("$destroy", function () {
                    $parent[0].removeEventListener("scroll", handler);
                    $parent[0].removeEventListener("scroll", reverseHandler);
                    $parent[0].removeEventListener("mousewheel", onMousewheel);
                    //return $parent.off("scroll", handler);
                });
                return $timeout((function () {
                    if (atts.kbInfiniteScrollImmediateCheck) {
                        if (scope.$eval(atts.kbInfiniteScrollImmediateCheck)) {
                            return handler();
                        }
                    }
                    else {
                        return handler();
                    }
                }), 0);
            };
            return _this;
        }
        KbInfiniteScroll.prototype.findDirectiveElement = function (directiveElement, selector) {
            //if we are inside a directive, then the element might not be in the DOM yet,
            //so we search for it in the directive element chain
            var p = directiveElement;
            while (p.parent().length) {
                p = p.parent();
            }
            return p.find(selector).addBack(selector);
        };
        KbInfiniteScroll = __decorate([
            NgComponent({
                token: Token.KbInfiniteScroll,
                dependencies: [
                    Token.$RootScope,
                    Token.$Window,
                    Token.$Timeout,
                    Token.$Compile,
                    Token.PromiseTracker,
                    Token.$Q,
                ]
            })
        ], KbInfiniteScroll);
        return KbInfiniteScroll;
    }(Directive));

    var KbLabel = /** @class */ (function (_super) {
        __extends(KbLabel, _super);
        function KbLabel() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-label");
            _this.restrict = "E";
            _this.scope = {
                invalid: "=?",
                icon: "@",
                image: "@",
                imageWhenSelected: "@",
                selected: "=?",
                backgroundColor: "=?",
                textColor: "=?"
            };
            _this.transclude = true;
            _this.link = function (scope, element, atts) {
            };
            return _this;
        }
        KbLabel = __decorate([
            NgComponent({
                token: Token.KbLabel
            })
        ], KbLabel);
        return KbLabel;
    }(Directive));

    var KbListItem = /** @class */ (function (_super) {
        __extends(KbListItem, _super);
        function KbListItem($timeout) {
            var _this = _super.call(this) || this;
            _this.require = "^kbList";
            _this.replace = true;
            _this.template = Dirs.component("kb-list-item");
            _this.restrict = "AE";
            _this.scope = {
                selectable: "=?",
                item: "=?",
                image: "@",
                icon: "@",
                onDelete: "&",
                onDoubleClick: "&",
                deletable: "=?",
                childTemplate: "@"
            };
            _this.transclude = true;
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                "$templateCache",
                Token.$Compile.key,
                Token.$Http.key,
                function ($scope, $element, $attrs, $transclude, $templateCache, $compile, $http) {
                    this.scope = $scope;
                    var processTemplateElement = function ($template) {
                        // compile the template
                        var compiled = $compile($template, $transclude);
                        // append it to the label
                        $element.html("").append($template);
                        // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                        compiled($scope.$parent);
                    };
                    // if a child template was provided, then use that instead of the transclusion content
                    var templateName = $scope.childTemplate;
                    var $template = angular__namespace.element($templateCache.get(templateName));
                    if (!$template.length) {
                        $http.get(templateName).then(function (response) {
                            $templateCache.put(templateName, response.data);
                            $template = angular__namespace.element(response.data);
                            processTemplateElement($template);
                        });
                    }
                    else {
                        processTemplateElement($template);
                    }
                }
            ];
            _this.compile = function (element, atts) {
                if (angular__namespace.isUndefined(atts.selectable)) {
                    atts.selectable = "true";
                }
                if (angular__namespace.isUndefined(atts.deletable)) {
                    atts.deletable = "true";
                }
                return _this.link;
            };
            _this.link = function (scope, element, atts, listController) {
                // get parent scopes to use for selection and expansion
                var listScope = listController.scope;
                scope._listScope = listScope;
                // register the item with the parent kbList
                listController.registerListItem(scope);
                scope._itemClick = function (e) {
                    // select the item if it's selectable
                    if (listScope.selectable && scope.selectable) {
                        // set the selected item on the tree so it can be bound to by controllers
                        // if (listScope.multiple && e.)
                        var mouseEvent = e;
                        if (listScope.multiple) {
                            if (mouseEvent.ctrlKey) {
                                listScope.addToSelectedItems(scope.item);
                            }
                            else if (mouseEvent.shiftKey) {
                                listScope.shiftToSelectedItems(scope.item);
                            }
                            else {
                                listScope.setSelectedItems(scope.item);
                            }
                        }
                        else {
                            listScope.selectedItem = scope.item;
                        }
                    }
                };
                scope._itemDoubleClick = function (e) {
                    scope.onDoubleClick();
                };
            };
            return _this;
        }
        KbListItem = __decorate([
            NgComponent({
                token: Token.KbListItem,
                dependencies: [
                    Token.$Timeout,
                ]
            })
        ], KbListItem);
        return KbListItem;
    }(Directive));

    /**
     * kbList
     *
     * to use kbList, you nest kb-list-item directives inside of a kb-list directive:
     * <kb-list>
     *    <kb-list-item ng-repeat="field in model.fields"></kb-list-item>
     * </kb-list>
     *
     */
    var KbList = /** @class */ (function (_super) {
        __extends(KbList, _super);
        function KbList() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-list");
            _this.restrict = "AE";
            _this.scope = {
                selectedItem: "=",
                selectedItems: "=?",
                skin: "@",
                multiple: "=?",
                selectable: "=?"
            };
            _this.transclude = true;
            // add scope defaults to the compile function
            _this.compile = function (element, atts) {
                if (angular__namespace.isUndefined(atts.selectable)) {
                    atts.selectable = "true";
                }
            };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                function ($scope, $element, $attrs, $transclude) {
                    // set the scope of the tree on it's controller so children can access it
                    this.scope = $scope;
                    $scope._listItems = [];
                    $scope.isSelected = function ($id) {
                        if ($scope.multiple) {
                            return ($scope._selectedListItems.some(function (li) { return li.$id == $id; }));
                        }
                        return ($scope._selectedListItem ? $scope._selectedListItem.$id == $id : false);
                    };
                    var lastSelectedItem = -1;
                    $scope.addToSelectedItems = function (item, doNotAutoRemove) {
                        if (!doNotAutoRemove && $scope.selectedItems.indexOf(item) > -1) {
                            $scope.selectedItems.remove(item);
                            return;
                        }
                        $scope.selectedItems.push(item);
                        lastSelectedItem = $scope._listItems.map(function (i) { return i.item; }).indexOf(item);
                    };
                    $scope.setSelectedItems = function (item) {
                        $scope.selectedItems.clear();
                        $scope.selectedItems.push(item);
                        lastSelectedItem = $scope._listItems.map(function (i) { return i.item; }).indexOf(item);
                    };
                    $scope.shiftToSelectedItems = function (item) {
                        if (lastSelectedItem < 0) {
                            $scope.setSelectedItems(item);
                        }
                        var newIdx = $scope._listItems.map(function (i) { return i.item; }).indexOf(item);
                        var i = (newIdx > lastSelectedItem ? lastSelectedItem + 1 : lastSelectedItem - 1);
                        var check = function () {
                            if (newIdx > lastSelectedItem)
                                return i <= newIdx;
                            return i >= newIdx;
                        };
                        var increment = function () {
                            if (newIdx > lastSelectedItem)
                                i++;
                            else
                                i--;
                        };
                        for (; check(); increment()) {
                            $scope.addToSelectedItems($scope._listItems[i].item, true);
                        }
                        lastSelectedItem = newIdx;
                    };
                    // all child nodes register themselves with the tree to handle selection and accordion functionality
                    this.registerListItem = function (listItem) {
                        $scope._listItems.push(listItem);
                        listItem.$on("$destroy", function (event) {
                            $scope._listItems.remove(listItem);
                        });
                    };
                    var selectFirstItem = function () {
                        if ($scope._listItems.length) {
                            if ($scope.multiple) {
                                $scope._selectedListItems = [$scope._listItems.first()];
                                $scope.selectedItems = [$scope._selectedListItems.first().item];
                            }
                            else {
                                $scope._selectedListItem = $scope._listItems.first();
                                $scope.selectedItem = $scope._selectedListItem.item;
                            }
                        }
                    };
                    var updateSelectedItem = function () {
                        $scope._selectedListItems = [];
                        $scope._selectedListItem = undefined;
                        if ((!$scope.multiple && !$scope.selectedItem) ||
                            ($scope.multiple && (!$scope.selectedItems ||
                                !$scope.selectedItems.length))) {
                            selectFirstItem();
                        }
                        else {
                            for (var _i = 0, _a = $scope._listItems; _i < _a.length; _i++) {
                                var listItem = _a[_i];
                                if (!$scope.multiple && $scope.selectedItem == listItem.item) {
                                    $scope._selectedListItem = listItem;
                                }
                                else if ($scope.multiple && $scope.selectedItems.indexOf(listItem.item) > -1) {
                                    $scope._selectedListItems.push(listItem);
                                }
                            }
                            // if listitem is still undefined, the selected item is no longer in the list, so we reset it
                            if ($scope.multiple && !$scope._selectedListItems.length) {
                                $scope.selectedItems = [];
                            }
                            else if (!$scope.multiple && !$scope._selectedListItem) {
                                $scope.selectedItem = undefined;
                            }
                        }
                    };
                    // if the consumer changes the selected item, we update the selected node
                    if ($scope.multiple) {
                        $scope.$watchCollection("selectedItems", function () {
                            updateSelectedItem();
                        });
                    }
                    else {
                        $scope.$watch("selectedItem", function () {
                            updateSelectedItem();
                        });
                    }
                    // nodes might be added after the selectedItem is set by the consumer, so
                    // we need to refind the selected node when the nodes collection changes
                    $scope.$watchCollection("_listItems", function () {
                        // if (!$scope._selectedListItem) {
                        updateSelectedItem();
                        // }
                    });
                }
            ];
            return _this;
        }
        KbList = __decorate([
            NgComponent({
                token: Token.KbList,
                dependencies: []
            })
        ], KbList);
        return KbList;
    }(Directive));

    /**
     * Given markdown text in the ngModel, will display the html
     */
    var KbMarkdownViewer = /** @class */ (function (_super) {
        __extends(KbMarkdownViewer, _super);
        function KbMarkdownViewer() {
            var _this = _super.call(this) || this;
            _this.scope = {
                ngModel: "=",
                kbClick: "&",
            };
            _this.restrict = "E";
            _this.template = Dirs.component("kb-markdown-viewer", exports.eBundle.app);
            _this.replace = true;
            _this.require = "ngModel";
            _this.link = function (scope, element, atts, ngModel) {
                // override the onPrepareImage from the markdown library so that we can have our
                // custom image size add-on.  
                // to control size of images, append =heightxwidth to the end of the url
                // some markdown implementations have a space before the equals sign, but
                // that doesn't seem to be possible here because markdownDeep won't recognize it
                // as an image at all
                MarkdownDeep.Markdown.prototype.OnPrepareImage = function (tag) {
                    var re = /=(\w+)x(\w+)$/;
                    var src = tag.attributes["src"];
                    var parts = src.match(re);
                    if (parts && parts[0]) {
                        tag.attributes["src"] = src.substr(0, src.length - parts[0].length);
                        tag.attributes["width"] = parts[1];
                        tag.attributes["height"] = parts[2];
                    }
                };
                ngModel.$render = function () {
                    // Create an instance of Markdown
                    var md = new MarkdownDeep.Markdown();
                    md.NewWindowForExternalLinks = true;
                    var v = ngModel.$viewValue;
                    scope._html = v ? md.Transform(v) : null;
                };
                $(element).find(".kb-markdown-viewer");
                var onMouseup = function (e) {
                    scope.kbClick({ $event: e });
                    var el = e.target;
                    if (!el || !el.href) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                };
                element[0].addEventListener("click", onMouseup);
                scope.$on("$destroy", function () {
                    element[0].removeEventListener("click", onMouseup);
                });
            };
            return _this;
        }
        KbMarkdownViewer = __decorate([
            NgComponent({
                token: Token.KbMarkdownViewer
            })
        ], KbMarkdownViewer);
        return KbMarkdownViewer;
    }(Directive));

    var KbMax = /** @class */ (function (_super) {
        __extends(KbMax, _super);
        function KbMax() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.require = "ngModel";
            _this.link = function (scope, elem, attr, ctrl) {
                var maxValidator = function (value) {
                    var max = scope.$eval(attr.ngMax) || Infinity;
                    if (ctrl.$viewValue && ctrl.$viewValue > max) {
                        $(elem).val(max);
                        return max;
                    }
                    return value;
                };
                ctrl.$parsers.push(maxValidator);
                ctrl.$formatters.push(maxValidator);
            };
            return _this;
        }
        KbMax = __decorate([
            NgComponent({
                token: Token.KbMax,
                dependencies: []
            })
        ], KbMax);
        return KbMax;
    }(Directive));

    var KbMediaList = /** @class */ (function (_super) {
        __extends(KbMediaList, _super);
        function KbMediaList($rootScope, dialogService) {
            var _this = _super.call(this) || this;
            _this.$rootScope = $rootScope;
            _this.dialogService = dialogService;
            _this.replace = true;
            // this.require = 'ngModel';
            _this.template = Dirs.component("kb-media-list");
            _this.restrict = "E";
            _this.scope = {
                ngModel: "=",
                addItem: "&",
                imagePath: "@"
            };
            _this.link = function (scope, element, atts) {
                scope.isEnabled = function () {
                    return !($(element).hasClass("disabled") || $(element).attr("disabled"));
                };
                scope.deleteItem = function (index) {
                    scope.ngModel.splice(index, 1);
                };
            };
            return _this;
        }
        KbMediaList = __decorate([
            NgComponent({
                token: Token.KbMediaList,
                dependencies: [
                    Token.$RootScope,
                    Token.DialogService,
                ]
            })
        ], KbMediaList);
        return KbMediaList;
    }(Directive));

    var KbMediaManager = /** @class */ (function (_super) {
        __extends(KbMediaManager, _super);
        function KbMediaManager($window, $http, kbService, dialogService, $rootScope, drawerService, dragAndDropService, uploadService, $q, $filter, $timeout, api) {
            var _this = _super.call(this) || this;
            _this.$window = $window;
            _this.$http = $http;
            _this.kbService = kbService;
            _this.dialogService = dialogService;
            _this.$rootScope = $rootScope;
            _this.drawerService = drawerService;
            _this.dragAndDropService = dragAndDropService;
            _this.uploadService = uploadService;
            _this.$q = $q;
            _this.$filter = $filter;
            _this.$timeout = $timeout;
            _this.api = api;
            _this.getChildren = function (dir) {
                var params = $.param($.extend({ dir: dir }, { filter: _this.atts.filter }));
                var url = _this.mscope.apiPath + "/children?" + params;
                _this.$http.get(url, { tracker: _this.mscope.tracker }).then(function (r) {
                    _this.mscope.files = r.data;
                    _this.$timeout(function () {
                        if (_this.mscope.startPath) {
                            var startFile = _this.mscope.files.find(function (f) { return f.relativePath == _this.mscope.startPath; });
                            if (startFile)
                                _this.mscope.selectedFile = startFile;
                            _this.mscope.startPath = null;
                        }
                    }, 0);
                });
            };
            _this.getDirectory = function (path) {
                var index = path.indexOf("/");
                if (index > -1) {
                    return path.substr(0, index);
                }
                return "";
            };
            _this.restrict = "E";
            _this.template = Dirs.component("kb-media-manager");
            _this.scope = {
                dialog: "@",
                multiple: "=?",
                selectedFile: "=?",
                selectedFiles: "=?",
                filter: "@",
                apiPath: "@",
                rootDir: "@",
                startPath: "@",
                open: "&",
                tracker: "=?",
                isDragging: "=?"
            };
            _this.replace = true;
            _this.link = function (scope, element, atts) {
                _this.atts = atts;
                _this.mscope = scope;
                if (!_this.mscope.apiPath)
                    _this.mscope.apiPath = "api/media";
                if (!_this.mscope.rootDir)
                    _this.mscope.rootDir = "media";
                if (!_this.mscope.tracker)
                    _this.mscope.tracker = _this.$rootScope.contentTracker;
                if (typeof atts.multiple == "undefined") {
                    scope.multiple = true;
                }
                scope.isDialog = (atts.dialog == "true");
                scope.isReadOnly = !_this.$rootScope.user.canModifyMedia || _this.$rootScope.environment != "dev";
                scope.deleteItems = function () {
                    _this.deleteSelectedListItems();
                };
                scope.refresh = function () {
                    _this.refreshList();
                };
                scope.addFolder = function () {
                    _this.addFolder();
                };
                scope.fileDoubleClicked = function (file) {
                    // if this is a folder, then navigate to the folder.  If a file, then call the handler of the consumer
                    if (!file.isFile) {
                        _this.navigate(file.relativePath);
                    }
                    else {
                        if (scope.open) {
                            scope.open({ file: file }); // call the handler of the consumer
                        }
                    }
                };
                scope.upload = function (accept) {
                    _this.uploadService.promptUserToChooseFiles().then(function (files) {
                        _this.uploadFiles(files);
                    });
                };
                scope.crumbClick = function (crumb) {
                    _this.navigate(crumb.url);
                };
                scope.addBlank = function (ext) {
                    _this.dialogService.input({
                        msg: "Select a name for the new file",
                        inputType: "text",
                        value: "New File",
                        buttons: [
                            new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                                if (args.value) {
                                    $http.post("/api/templates/blank", {
                                        relativePath: _this.currentDir + args.value + "." + ext
                                    }, { tracker: scope.tracker }).then(function (response) {
                                        _this.refreshList();
                                    });
                                }
                            }),
                            new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                            })
                        ]
                    });
                };
                scope.download = function (file) {
                    if (file) {
                        if (file.isFile) {
                            scope.fileDoubleClicked(file);
                        }
                        else {
                            var params = $.param({ relativePath: file.relativePath });
                            var url = _this.mscope.apiPath + "/sizeInfo?" + params;
                            _this.$http.get(url, { tracker: _this.mscope.tracker }).then(function (r) {
                                var warnMsg = null;
                                if (r.data.size > 500000000) {
                                    warnMsg = loc.msg_warndownloadfoldersize.format("500 MB");
                                }
                                else if (r.data.fileCount > 500) {
                                    warnMsg = loc.msg_warndownloadfolderfilecount.format("500");
                                }
                                if (warnMsg) {
                                    _this.dialogService.dialog({
                                        content: warnMsg,
                                        buttons: [
                                            new enums.DialogButton(loc.ok, _tools.icons.success, function () {
                                                _this.downloadFolder(file.relativePath);
                                            }),
                                            new enums.DialogButton(loc.cancel, _tools.icons.cancel, function () {
                                            })
                                        ]
                                    });
                                }
                                else {
                                    _this.downloadFolder(file.relativePath);
                                }
                            });
                        }
                    }
                };
                scope.files = [];
                if (!scope.isDialog) {
                    if ($rootScope.user.canModifyMedia && _this.$rootScope.environment == "dev") {
                        drawerService.addDrawer(_tools.icons.addFolder, loc.addfolder, scope.addFolder);
                    }
                    drawerService.addDrawer(_tools.icons.open, loc.open, function () { return scope.fileDoubleClicked(_this.selectedItem()); });
                    drawerService.addDrawer(_tools.icons.download, loc.download, function () { return scope.download(_this.selectedItem()); });
                    if ($rootScope.user.canModifyMedia && _this.$rootScope.environment == "dev") {
                        drawerService.addDrawer(_tools.icons.upload, loc.upload, scope.upload);
                        drawerService.addDrawer(_tools.icons.deleter, loc.deleter, scope.deleteItems);
                    }
                    drawerService.addDrawer(_tools.icons.refresh, loc.refresh, scope.refresh);
                }
                // setup root crumb
                var startDir = scope.startPath ? _this.getDirectory(scope.startPath) : "";
                _this.navigate(startDir);
                var dragAndDrop = _this.dragAndDropService.subscribe({
                    onDropFiles: function (files) {
                        _this.onDropFiles(files);
                        scope.isDragging = false;
                        scope.$applyAsync();
                    }
                });
                scope.$on("globalDragStateChanged", function (event, isDragging) {
                    scope.isDragging = isDragging;
                    scope.$applyAsync();
                });
                scope.$on("$destroy", dragAndDrop);
            };
            return _this;
        }
        KbMediaManager.prototype.navigate = function (dir) {
            this.currentDir = dir;
            this.refreshCrumbs(dir);
            this.getChildren(dir);
            // this.mscope.listSource.read({ id: dir });            
        };
        KbMediaManager.prototype.refreshCrumbs = function (dir) {
            this.mscope.crumbs = [];
            this.mscope.crumbs.push({ url: "", name: this.mscope.rootDir, icon: _tools.icons.image });
            var segments = dir.split("/");
            for (var index = 0; index < segments.length; index++) {
                var segment = segments[index];
                if (segment) {
                    // calculate the absolute url of the segment
                    var url = "";
                    for (var i = 0; i <= index; i++) {
                        url += segments[i] + "/";
                    }
                    this.mscope.crumbs.push({ url: url, name: segment, icon: _tools.icons.crumb });
                }
            }
        };
        KbMediaManager.prototype.deleteSelectedListItems = function () {
            var _this = this;
            var isTemplate = this.mscope.apiPath.toLowerCase().includes("template");
            var selected = this.getListViewSelectedItems();
            var ids = selected.map(function (m) { return (isTemplate ? "template/" : "media/") + m.relativePath; });
            this.api.dependencies.isRequiredByDependency(isTemplate ? "Template" : "Media", ids, this.mscope.tracker).then(function (required) {
                _this.dialogService.dialog({
                    content: required ? loc.msg_deleterequiredbydependency : loc.msg_deletemedia,
                    buttons: [
                        new enums.DialogButton(loc.ok, _tools.icons.success, function () {
                            selected.forEach(function (mobject) {
                                _this.$http.delete(_this.mscope.apiPath, {
                                    params: {
                                        relativePath: mobject.relativePath
                                    },
                                    headers: {
                                        "Content-Type": "application/json"
                                    }
                                });
                            });
                            // delete the stuff directly in the source so the user doesn't have to wait
                            $.each(selected, function (index, mobject) {
                                // now remove the item from the listview
                                _this.mscope.files.remove(mobject);
                                // (<any>this.mscope.listSource).remove(mobject);
                            });
                        }),
                        new enums.DialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                        })
                    ]
                });
            });
        };
        KbMediaManager.prototype.addFolder = function () {
            var _this = this;
            this.dialogService.input({
                msg: loc.msg_renamefolder,
                value: loc.newfolder,
                buttons: [
                    new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                        _this.$http.post(_this.mscope.apiPath + "/addfolder", {
                            dir: _this.currentDir, folderName: args.value
                        }, { tracker: _this.mscope.tracker })
                            .then(function () {
                            _this.refreshList();
                        });
                    }),
                    new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                    })
                ]
            });
        };
        KbMediaManager.prototype.getListViewDataItem = function ($domItem) {
            $domItem.index();
            return null;
            // return this.mscope.listSource.view()[index];
        };
        KbMediaManager.prototype.getListViewSelectedItems = function () {
            if (this.mscope.multiple) {
                return this.mscope.selectedFiles;
            }
            return [this.mscope.selectedFile];
        };
        KbMediaManager.prototype.selectedItem = function () {
            var selected = this.getListViewSelectedItems();
            if (selected) {
                return selected[0];
            }
            return null;
        };
        KbMediaManager.prototype.refreshList = function () {
            this.getChildren(this.currentDir);
        };
        KbMediaManager.prototype.onUpload = function (e) {
            var _this = this;
            if (!this.mscope.uploadingFiles)
                this.mscope.uploadingFiles = [];
            angular__namespace.forEach(e.files, function (item, index) {
                item.percentComplete = 0;
                _this.mscope.uploadingFiles.push(item);
            });
            if (!this.mscope.uploading) {
                this.uploadDialog = this.dialogService.dialog({
                    template: Dirs.view("dialog-upload-files"),
                    scope: this.mscope.$new(),
                    buttons: [
                        new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                            _this.mscope.uploadingFiles = null;
                            _this.refreshList();
                        }, false) // hide the ok button by passing in visible = false
                    ]
                });
            }
            this.mscope.uploading = true;
        };
        KbMediaManager.prototype.uploadProgress = function (e) {
            var _this = this;
            $.each(e.files, function (index, file) {
                $("#uploading-list #" + _this.$filter("fileId")(file.name));
                file.percentComplete = e.percentComplete;
            });
        };
        KbMediaManager.prototype.uploadError = function (e) {
            var _this = this;
            $.each(e.files, function (index, file) {
                var $li = $("#uploading-list #" + _this.$filter("fileId")(file.name));
                $li.prepend('<div class="kb-icon error"><div class="kb-icon__glyph">' + _tools.icons.error + "</div></div>");
            });
        };
        KbMediaManager.prototype.uploadComplete = function (e) {
            this.mscope.uploading = false;
            // show the buttons in the dialog now\
            this.uploadDialog.buttons[0].visible = true;
        };
        KbMediaManager.prototype.downloadFolder = function (relativePath) {
            var relPath = encodeURIComponent(relativePath);
            window.open(this.mscope.apiPath + "/downloadFolder?relativePath=" + relPath, "_blank");
        };
        KbMediaManager.prototype.uploadFiles = function (files) {
            var _this = this;
            this.onUpload({ files: files });
            var promises = files.map(function (file) {
                var p = _this.uploadService.uploadFileToMedia(file, _this.currentDir, _this.mscope.apiPath);
                return p.then(function () {
                    _this.uploadProgress({ files: [file], percentComplete: 100 });
                }, function () {
                    _this.uploadError({ files: [file] });
                }, function (e) {
                    _this.uploadProgress({
                        files: [file],
                        percentComplete: ((e.loaded / e.total) * 100)
                    });
                });
            });
            return this.$q.all(promises).finally(function () { return _this.uploadComplete(); });
        };
        KbMediaManager.prototype.onDropFiles = function (files) {
            if (this.$rootScope.environment === "dev") {
                this.uploadFiles(files);
            }
        };
        KbMediaManager = __decorate([
            NgComponent({
                token: Token.KbMediaManager,
                dependencies: [
                    Token.$Window,
                    Token.$Http,
                    Token.KbService,
                    Token.DialogService,
                    Token.$RootScope,
                    Token.DrawerService,
                    Token.DragAndDropService,
                    Token.UploadService,
                    Token.$Q,
                    Token.$Filter,
                    Token.$Timeout,
                    Token.ApiService,
                ]
            })
        ], KbMediaManager);
        return KbMediaManager;
    }(Directive));

    var KbMediaSelect = /** @class */ (function (_super) {
        __extends(KbMediaSelect, _super);
        function KbMediaSelect(kbService, $rootScope, dialogService) {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "E";
            _this.scope = {
                ngModel: "="
            };
            _this.template = Dirs.component("kb-media-select");
            _this.link = function (scope, element, atts, ngModelController) {
                scope.isEnabled = function () {
                    return !($(element).hasClass("disabled") || $(element).attr("disabled"));
                };
                scope.clear = function () {
                    scope.ngModel = null;
                };
                scope.click = function () {
                    if (scope.isEnabled()) {
                        dialogService.mediaSelect({
                            startPath: scope.ngModel,
                            buttons: [
                                new enums.MediaDialogButton(loc.ok, _tools.icons.success, function (args) {
                                    scope.ngModel = args.selectedItem ? args.selectedItem.relativePath : null;
                                }),
                                new enums.MediaDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                                })
                            ]
                        });
                    }
                };
            };
            return _this;
        }
        KbMediaSelect = __decorate([
            NgComponent({
                token: Token.KbMediaSelect,
                dependencies: [
                    Token.KbService,
                    Token.$RootScope,
                    Token.DialogService,
                ]
            })
        ], KbMediaSelect);
        return KbMediaSelect;
    }(Directive));

    var KbMediaViewer = /** @class */ (function (_super) {
        __extends(KbMediaViewer, _super);
        function KbMediaViewer($filter, kbService, $sce, $rootScope, storageService) {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-media-viewer");
            _this.scope = {
                path: "=",
                thumb: "@",
                cachebuster: "=?"
            };
            _this.link = function (scope, element, atts) {
                //// for some reason the classes aren't getting merged
                //// but it is shown correctly in atts.  Here's a workaround
                // element.removeClass();
                // element.addClass(atts.class);
                scope.fallback = storageService.getFallbackImage();
                scope.$watch("path", function (newValue) {
                    scope.ext = kbService.getExtension(scope.path);
                    if (scope.ext == "ogv")
                        scope.ext = "ogg";
                    if (_tools.extensions.image.indexOf(scope.ext) != -1) {
                        scope.type = "image";
                        if (scope.thumb) {
                            scope.fullPath = $filter("thumb")(scope.path);
                        }
                        else {
                            scope.fullPath = $filter("media")(scope.path);
                        }
                    }
                    else if (_tools.extensions.video.indexOf(scope.ext) != -1) {
                        scope.type = "video";
                        scope.fullPath = $filter("media")(scope.path);
                    }
                    if (_tools.Utils.isAbsoluteUrl(scope.path)) {
                        scope.fullPath = scope.path;
                    }
                    if (scope.cachebuster) {
                        scope.fullPath = scope.fullPath + "?v=" + $rootScope.cacheBuster;
                    }
                    scope.fullPath = $sce.trustAsResourceUrl(scope.fullPath);
                });
            };
            return _this;
        }
        KbMediaViewer = __decorate([
            NgComponent({
                token: Token.KbMediaViewer,
                dependencies: [
                    Token.$Filter,
                    Token.KbService,
                    Token.$Sce,
                    Token.$RootScope,
                    Token.StorageService
                ]
            })
        ], KbMediaViewer);
        return KbMediaViewer;
    }(Directive));

    var KbMenuItem = /** @class */ (function (_super) {
        __extends(KbMenuItem, _super);
        function KbMenuItem(kbService, $state, $rootScope) {
            var _this = _super.call(this) || this;
            _this.kbService = kbService;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-menu-item");
            _this.scope = {
                icon: "@",
                label: "@",
                params: "=?"
            };
            _this.replace = true;
            _this.transclude = true;
            _this.link = function (scope, element, atts) {
                // remove the submenu element if there are no sub menu items
                var $subMenu = element.find(".kb-menu__sub");
                if (!$subMenu.html().length) {
                    $subMenu.remove();
                }
                element.click(function () {
                    var isExpanded = $(element).hasClass("is-expanded");
                    $(element).children(".kb-menu__item").removeClass("is-expanded");
                    if (!isExpanded) {
                        $(element).addClass("is-expanded");
                        var collapse_1 = function () {
                            $(element).removeClass("is-expanded");
                            $("html").unbind("click", collapse_1);
                        };
                        setTimeout(function () { $("html").bind("click", collapse_1); }, 1);
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbMenuItem = __decorate([
            NgComponent({
                token: Token.KbMenuItem,
                dependencies: [
                    Token.KbService,
                    Token.$State,
                    Token.$RootScope,
                ]
            })
        ], KbMenuItem);
        return KbMenuItem;
    }(Directive));

    var KbMenu = /** @class */ (function (_super) {
        __extends(KbMenu, _super);
        function KbMenu(kbService, $rootScope, $state) {
            var _this = _super.call(this) || this;
            _this.kbService = kbService;
            _this.restrict = "E";
            _this.template = Dirs.component("kb-menu");
            _this.scope = true;
            _this.replace = true;
            _this.transclude = true;
            _this.link = function (scope, element, atts) {
            };
            return _this;
        }
        KbMenu = __decorate([
            NgComponent({
                token: Token.KbMenu,
                dependencies: [
                    Token.KbService,
                    Token.$RootScope,
                    Token.$State,
                ]
            })
        ], KbMenu);
        return KbMenu;
    }(Directive));

    var KbMin = /** @class */ (function (_super) {
        __extends(KbMin, _super);
        function KbMin() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.require = "ngModel";
            _this.link = function (scope, elem, attr, ctrl) {
                var minValidator = function (value) {
                    var min = scope.$eval(attr.ngMin) || 0;
                    if (ctrl.$viewValue && ctrl.$viewValue < min) {
                        $(elem).val(min);
                        return min;
                    }
                    return value;
                };
                ctrl.$parsers.push(minValidator);
                ctrl.$formatters.push(minValidator);
            };
            return _this;
        }
        KbMin = __decorate([
            NgComponent({
                token: Token.KbMin,
                dependencies: []
            })
        ], KbMin);
        return KbMin;
    }(Directive));

    var KbMoney = /** @class */ (function (_super) {
        __extends(KbMoney, _super);
        function KbMoney(kbService, $rootScope) {
            var _this = _super.call(this) || this;
            _this.kbService = kbService;
            _this.$rootScope = $rootScope;
            _this.template = '<input class="kb-textbox" type="text" />';
            _this.restrict = "E";
            _this.scope = {
                label: "@",
                ngModel: "=",
                currency: "@"
            };
            _this.require = "?ngModel";
            _this.replace = true;
            _this.transclude = true;
            _this.link = function (scope, element, atts, ngModel) {
                var update = function (v) {
                    return v ?
                        kbService.fxConvert(parseFloat(v), _this.$rootScope.companySettings.currency.toUpperCase(), scope.currency)
                        : 0;
                };
                scope.$watch("currency", function () {
                    ngModel.$modelValue = (update(ngModel.$viewValue));
                });
                ngModel.$formatters.push(function (v) { return v ? kbService.fxConvert(parseFloat(v), scope.currency) : 0; });
                ngModel.$parsers.push(update);
            };
            return _this;
        }
        KbMoney = __decorate([
            NgComponent({
                token: Token.KbMoney,
                dependencies: [
                    Token.KbService,
                    Token.$RootScope
                ]
            })
        ], KbMoney);
        return KbMoney;
    }(Directive));

    var KbMultiAutoComplete = /** @class */ (function (_super) {
        __extends(KbMultiAutoComplete, _super);
        function KbMultiAutoComplete($q, $timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-multi-auto-complete");
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "&",
                buildItem: "&",
                editable: "@", // should it restrict ngModel values to ones selected in the dropdown
                valueField: "@"
            });
            _this.replace = true;
            _this.transclude = {
                header: "?kbMultiAutoCompleteHeader",
                dropdown: "?kbMultiAutoCompleteDropdown"
            };
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                controllers[0];
                if (!atts.ngModel)
                    throw new Error("ngModel is required for kbAutoSelect");
                if (!angular__namespace.isFunction(scope.source)) {
                    throw new Error("source for kbMultiAutoComplete must be a function that accepts the current query");
                }
                if (scope.buildItem && !angular__namespace.isFunction(scope.buildItem)) {
                    throw new Error("buildItem for kbMultiAutoComplete must be a function that accepts the current query");
                }
                scope._userInput = null;
                scope._matches = [];
                scope._dropdownOpen = false;
                scope._loading = false;
                scope._highlightedItems = {};
                var editable = scope.$parent.$eval(atts.editable) == true;
                var $input = element.find("input");
                scope._isEnabled = function () {
                    return !scope.ngDisabled;
                };
                var getMatches = function () {
                    var lastUserInput = scope._userInput;
                    scope._loading = true;
                    var promise = $q.when(scope.source({ query: scope._userInput }));
                    promise.then(function (data) {
                        // it might happen that several async queries were in progress if a user were typing fast
                        // but we are interested only in responses that correspond to the current view value
                        if (lastUserInput === scope._userInput) {
                            scope._matches.clear();
                            scope._matches.pushArray(data);
                            scope._activeIndex = -1;
                            scope._dropdownOpen = scope._matches.length > 0;
                            scope._loading = false;
                        }
                    });
                };
                scope.$watch("_userInput", function (newUserInput) {
                    if (!newUserInput) {
                        scope._matches.clear();
                        scope._dropdownOpen = false;
                        $input.attr("size", 0);
                    }
                    else {
                        $input.attr("size", newUserInput.length);
                        getMatches();
                    }
                });
                var getValue = function (item) {
                    if (item == null)
                        return null;
                    if (scope.valueField)
                        return item[scope.valueField];
                    return item;
                };
                var buildItem = function (value) {
                    var item = null;
                    if (value) {
                        if (scope.valueField) {
                            item = {};
                            item[scope.valueField] = value;
                        }
                        else {
                            item = value;
                        }
                        // we will add the item right away but come back to it with any modifications from the consumer
                        $q.when(scope.buildItem({ value: value })).then(function (builtItem) {
                            $.extend(item, builtItem);
                        });
                    }
                    return item;
                };
                scope._selectMatch = function (item) {
                    if (scope._isEnabled() && item) {
                        var existingItem_1 = scope.ngModel.find(function (i) { return getValue(i) == getValue(item); });
                        if (!existingItem_1) {
                            // if (typeof item != "string") scope.ngModel.push(item);
                            // else if (atts["valueField"]) scope.ngModel.push({name: item});
                            // else scope.ngModel.push(item);
                            scope.ngModel.push(item);
                        }
                        else {
                            scope._highlightedItems[(existingItem_1.name ? existingItem_1.name : existingItem_1)] = true;
                            setTimeout(function () {
                                scope.$apply(function (scope) {
                                    scope._highlightedItems[(existingItem_1.name ? existingItem_1.name : existingItem_1)] = false;
                                });
                            }, 500);
                        }
                        scope._userInput = "";
                    }
                };
                scope._itemMousedown = function (e, item) {
                    e.preventDefault(); // so we don't lose focus and trigger the blur event
                    scope._selectMatch(item);
                };
                scope._delete = function (item) {
                    if (scope._isEnabled()) {
                        scope.ngModel.remove(item);
                    }
                };
                scope._click = function () {
                    if (scope._isEnabled()) {
                        $input.focus();
                    }
                };
                scope._isActive = function (index) {
                    return scope._activeIndex == index;
                };
                scope._selectActive = function (index) {
                    scope._activeIndex = index;
                };
                $input[0].addEventListener("focus", function () {
                    element.addClass("focus");
                });
                $input[0].addEventListener("blur", function () {
                    if (editable) {
                        scope.$apply(function () {
                            scope._selectMatch(buildItem(scope._userInput));
                        });
                    }
                    element.removeClass("focus");
                });
                // bind keyboard events: 
                // backspace(8) 
                // arrows up(38) /
                // down(40),
                // enter(13) and
                // tab(9),
                // esc(27),
                // space(32)
                // comma(188)
                $input.on("keydown", function (e) {
                    if (e.which == _tools.keyboard.backspace) {
                        if (!scope._userInput && scope.ngModel.length > 0) {
                            scope.$apply(function () {
                                scope.ngModel.pop();
                            });
                        }
                    }
                    if (e.which == _tools.keyboard.up) {
                        e.preventDefault();
                        scope.$apply(function () {
                            if (scope._dropdownOpen) {
                                scope._activeIndex -= 1;
                                if (scope._activeIndex < 0) {
                                    scope._dropdownOpen = false;
                                }
                            }
                        });
                    }
                    if (e.which == _tools.keyboard.down) {
                        e.preventDefault();
                        if (scope._activeIndex < scope._matches.length - 1) {
                            scope.$apply(function () {
                                scope._activeIndex += 1;
                                scope._dropdownOpen = true;
                            });
                        }
                    }
                    if (e.which == _tools.keyboard.enter) {
                        scope.$apply(function () {
                            e.preventDefault();
                            if (scope._dropdownOpen) {
                                if (scope._matches.length > 0) {
                                    scope._selectMatch(scope._matches[(scope._activeIndex > 0 ? scope._activeIndex : 0)]);
                                }
                            }
                            else if (editable) {
                                scope._selectMatch(buildItem(scope._userInput));
                            }
                            else {
                                scope._dropdownOpen = true;
                            }
                        });
                    }
                    if (e.which == _tools.keyboard.tab) {
                        if (scope._dropdownOpen) {
                            if (scope._matches) {
                                scope.$apply(function () {
                                    scope._selectMatch(scope._matches[(scope._activeIndex > 0 ? scope._activeIndex : 0)]);
                                });
                            }
                            e.stopPropagation();
                        }
                    }
                    if (e.which == _tools.keyboard.escape) {
                        e.preventDefault();
                        scope.$apply(function () {
                            scope._dropdownOpen = false;
                            e.stopPropagation();
                        });
                    }
                    if ((e.which == _tools.keyboard.comma) && editable) {
                        e.preventDefault();
                        scope.$apply(function () {
                            scope._selectMatch(buildItem(scope._userInput));
                        });
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbMultiAutoComplete = __decorate([
            NgComponent({
                token: Token.KbMultiAutoComplete,
                dependencies: [
                    Token.$Q,
                    Token.$Timeout
                ]
            })
        ], KbMultiAutoComplete);
        return KbMultiAutoComplete;
    }(KbInput));

    var KbNumberbox = /** @class */ (function (_super) {
        __extends(KbNumberbox, _super);
        function KbNumberbox($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                format: "@",
                minPrecision: "@",
                maxPrecision: "@",
                currency: "@",
                thousandsSeparator: "@",
                decimalSeparator: "@",
                prefix: "@",
                suffix: "@",
                step: "@"
            });
            _this.template = Dirs.component("kb-numberbox");
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                scope.$watch("[ngModel,format,minPrecision,maxPrecision,currency,decimalSeparator,thousandsSeparator,prefix,suffix]", function () {
                    if (scope.ngModel != null && !isNaN(scope.ngModel)) {
                        scope._formattedValue = scope.ngModel.format({
                            formatType: scope.format,
                            minPrecision: Number(scope.minPrecision),
                            maxPrecision: Number(scope.maxPrecision),
                            currency: scope.currency,
                            decimalSeparator: scope.decimalSeparator,
                            thousandsSeparator: scope.thousandsSeparator,
                            prefix: scope.prefix,
                            suffix: scope.suffix
                        });
                    }
                    else {
                        scope._formattedValue = "";
                    }
                });
            };
            return _this;
        }
        KbNumberbox = __decorate([
            NgComponent({
                token: Token.KbNumberbox,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbNumberbox);
        return KbNumberbox;
    }(KbInput));

    var KbOverlayPopupComponent = /** @class */ (function (_super) {
        __extends(KbOverlayPopupComponent, _super);
        function KbOverlayPopupComponent() {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.scope = true;
            _this.controller = [
                "$scope",
                "$element",
                "$document",
                function ($scope, $element, $document) {
                    var body = $document.find("body").eq(0);
                    // ⭐ MOVE POPUP TO BODY
                    body.append($element);
                    // cleanup
                    $scope.$on("$destroy", function () {
                        $element.remove();
                        body.removeClass("kb-no-scroll");
                    });
                    // watch selected popup
                    $scope.$watch(function () { return $scope.selected && $scope.selected.overlayPopup; }, function (popup) {
                        if (!popup)
                            return;
                        if (!$scope._overlayPopups) {
                            $scope._overlayPopups = [];
                        }
                        var list = $scope._overlayPopups;
                        var index = list.indexOf(popup);
                        if (index > -1) {
                            list.splice(index, 1);
                        }
                        list.push(popup);
                    });
                    $scope.$watch(function () { var _a; return (_a = $scope._overlayPopups) === null || _a === void 0 ? void 0 : _a.some(function (p) { return p.visible; }); }, function (anyOpen) {
                        body.toggleClass("kb-no-scroll", anyOpen);
                    });
                    $scope.close = function (popup) {
                        if (!popup)
                            return;
                        if (!popup.enableClose)
                            return;
                        popup.visible = false;
                    };
                }
            ];
            _this.template = Dirs.component("kb-overlay-popup");
            return _this;
        }
        KbOverlayPopupComponent = __decorate([
            NgComponent({
                token: Token.KbOverlayPopup,
                dependencies: []
            })
        ], KbOverlayPopupComponent);
        return KbOverlayPopupComponent;
    }(Directive));

    var KbPageTitle = /** @class */ (function (_super) {
        __extends(KbPageTitle, _super);
        function KbPageTitle(kbService) {
            var _this = _super.call(this) || this;
            _this.kbService = kbService;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-page-title");
            _this.transclude = true;
            _this.scope = {
                icon: "@",
                label: "@",
                desc: "@",
                error: "@"
            };
            _this.replace = true;
            _this.link = function (scope, element, atts) {
            };
            return _this;
        }
        KbPageTitle = __decorate([
            NgComponent({
                token: Token.KbPageTitle,
                dependencies: [
                    Token.KbService
                ]
            })
        ], KbPageTitle);
        return KbPageTitle;
    }(Directive));

    // tslint:disable:max-line-length
    var KbPage = /** @class */ (function (_super) {
        __extends(KbPage, _super);
        function KbPage() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "E";
            _this.scope = true;
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$templateCache",
                Token.$Compile.key,
                Token.$Http.key,
                "$controller",
                Token.$Timeout.key,
                "$animate",
                "$transclude",
                function ($scope, $element, $attrs, $templateCache, $compile, $http, $controller, $timeout, $animate, $transclude) {
                    var pageDb = {};
                    var oldTemplate;
                    var newTemplate;
                    var oldTemplateScope;
                    var newTemplateScope;
                    // because multiple instances of a nested configurator have the same page id, 
                    // we need to hash it with the configurator name
                    var getPageIdentifier = function (page) {
                        return page.$parentConfigurator.name + "-" + page.id;
                    };
                    //cache the compiled template since it doesn't change
                    var origTemplate = angular__namespace.element(Dirs.component("kb-page"));
                    var compiled = $compile(origTemplate);
                    // pick the right properties page template
                    var updateTemplate = function () {
                        oldTemplate = newTemplate;
                        oldTemplateScope = newTemplateScope;
                        // if (oldTemplate) {
                        //     oldTemplate.removeClass("active");
                        //     // $timeout(() => {
                        //     //    oldTemplate.remove();
                        //     //    if (oldTemplateScope) {
                        //     //        oldTemplateScope.$destroy();
                        //     //        oldTemplateScope = null;
                        //     //    }
                        //     // }, 100);
                        // }
                        // create the new template
                        if ($scope.selected && $scope.selected.page) {
                            var pageIden_1 = getPageIdentifier($scope.selected.page);
                            if (pageDb[pageIden_1]) {
                                newTemplate = pageDb[pageIden_1].template;
                                newTemplateScope = pageDb[pageIden_1].scope;
                            }
                            else {
                                // newTemplate = angular.element(Dirs.component("kb-page"));
                                // let compiled = $compile(newTemplate);
                                newTemplateScope = $scope.$new();
                                compiled(newTemplateScope, function (clonedElement, scope) {
                                    clonedElement.addClass("kb-page-control__page--initializing");
                                    $element.append(clonedElement);
                                    pageDb[pageIden_1] = {
                                        scope: newTemplateScope,
                                        template: clonedElement
                                    };
                                    newTemplate = clonedElement;
                                });
                                // add it to element
                                // $element.append(newTemplate);
                            }
                            newTemplateScope._page = $scope.selected.page;
                            //$timeout(() => newTemplate.addClass("active"), 0);
                            //$timeout(() => {
                            var oldPage_1 = oldTemplateScope ? oldTemplateScope._page : null;
                            var newPage_1 = newTemplateScope._page;
                            var oldPageIndex_1 = _this.getHierarchicalIndex(oldPage_1);
                            var newPageIndex_1 = _this.getHierarchicalIndex(newPage_1);
                            var $oldPageEl_1 = oldTemplate;
                            var $newPageEl_1 = newTemplate;
                            $newPageEl_1.removeClass("kb-page-control__page--initializing");
                            newPage_1 && $newPageEl_1.css("transition", "none");
                            if (_this.isIndexGreater(newPageIndex_1, oldPageIndex_1)) {
                                //oldPage && $oldPageEl.css("transform", "translate3d(-100%,0,0)");
                                newPage_1 && $newPageEl_1.css("transform", "translate3d(100%,0,0)");
                            }
                            else {
                                newPage_1 && $newPageEl_1.css("transform", "translate3d(-100%,0,0)");
                            }
                            //if (newPage) newPage.selected = true;
                            if (newTemplate)
                                newTemplate.addClass("kb-page-control__page--selected");
                            setTimeout(function () {
                                //animate the height also.     
                                // let currentHeight = oldPage && $oldPageEl.outerHeight();
                                // newPage && $newPageEl.css("position", "relative");
                                // let newHeight = newPage && $newPageEl.outerHeight(); 
                                // newPage && $newPageEl.css("position", "absolute");
                                // $container.height(currentHeight);
                                if (_this.isIndexGreater(newPageIndex_1, oldPageIndex_1)) {
                                    oldPage_1 && $oldPageEl_1.css("transform", "translate3d(-100%,0,0)");
                                }
                                else {
                                    oldPage_1 && $oldPageEl_1.css("transform", "translate3d(100%,0,0)");
                                }
                                newPage_1 && $newPageEl_1.css("transition", "");
                                newPage_1 && $newPageEl_1.css("transform", "translate3d(0,0,0)");
                                // $container.height(newHeight);
                                // $timeout(() => {
                                //     if (oldPage) oldPage.selected = false;
                                //     //on the first run the new tab element might not have existed until now, so we refresh the reference
                                //     $newPageEl = newTab && $element.find(`#tab-${newTab.$id}`);
                                //     newPage && $newPageEl.css("position", "relative");
                                //     oldPage && $oldPageEl.css("position", "absolute");
                                //     $container.height("auto");
                                //     locked = false;
                                // }, 300);
                                setTimeout(function () {
                                    if (oldTemplate)
                                        oldTemplate.removeClass("kb-page-control__page--selected");
                                }, 300);
                            }, 0);
                            //});
                        }
                    };
                    $scope.selected.pageChanged.add(function (args) {
                        updateTemplate();
                    });
                    $scope.$on("$destroy", function () {
                        Object.keys(pageDb).forEach(function (key) {
                            if (pageDb[key].scope)
                                pageDb[key].scope.$destroy();
                        });
                        pageDb = null;
                    });
                    updateTemplate();
                }
            ];
            return _this;
        }
        KbPage.prototype.getHierarchicalIndex = function (parent) {
            var indexMap = [];
            while (parent && parent.$parent) {
                var index = 0;
                if (parent instanceof enums.Page) {
                    index = parent.$parent.pages.indexOf(parent);
                }
                else if (parent instanceof enums.Configurator) {
                    index = parent.$parent.configurators.indexOf(parent);
                }
                else {
                    throw "unexpected parent type";
                }
                indexMap.unshift(index);
                parent = parent.$parent;
            }
            return indexMap;
        };
        KbPage.prototype.isIndexGreater = function (thisIndex, otherIndex) {
            for (var i = 0; i < thisIndex.length; i++) {
                if (otherIndex.length == i)
                    return true;
                if (thisIndex[i] < otherIndex[i])
                    return false;
                if (thisIndex[i] > otherIndex[i])
                    return true;
            }
            return false;
        };
        KbPage = __decorate([
            NgComponent({
                token: Token.KbPage,
                dependencies: []
            })
        ], KbPage);
        return KbPage;
    }(Directive));

    var KbPassword = /** @class */ (function (_super) {
        __extends(KbPassword, _super);
        function KbPassword($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.template = Dirs.component("kb-password");
            return _this;
        }
        KbPassword = __decorate([
            NgComponent({
                token: Token.KbPassword,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbPassword);
        return KbPassword;
    }(KbInput));

    var KbPrivacyPolicy = /** @class */ (function (_super) {
        __extends(KbPrivacyPolicy, _super);
        function KbPrivacyPolicy($http) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.scope = {
                _html: "="
            };
            _this.template = Dirs.component("kb-privacy-policy");
            _this.link = function (scope, element, atts) {
                /*$http.get("/privacy.html").then((d) => {
                    scope._html = d.data;
                });*/
            };
            return _this;
        }
        KbPrivacyPolicy = __decorate([
            NgComponent({
                token: Token.KbPrivacyPolicy,
                dependencies: [
                    Token.$Http
                ]
            })
        ], KbPrivacyPolicy);
        return KbPrivacyPolicy;
    }(Directive));

    var KbProgress = /** @class */ (function (_super) {
        __extends(KbProgress, _super);
        function KbProgress() {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.replace = true;
            _this.scope = {
                animate: "=",
                type: "@",
                value: "@"
            };
            _this.template = Dirs.component("kb-progress");
            _this.link = function (scope, element, atts) {
            };
            return _this;
        }
        KbProgress = __decorate([
            NgComponent({
                token: Token.KbProgress,
                dependencies: []
            })
        ], KbProgress);
        return KbProgress;
    }(Directive));

    var KbRadio = /** @class */ (function (_super) {
        __extends(KbRadio, _super);
        function KbRadio($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "=",
                valueField: "@",
                labelField: "@",
                data: "=?"
            });
            _this.transclude = true;
            _this.template = Dirs.component("kb-radio");
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers, false);
                var ngModel = controllers[0];
                scope._id = _tools.Utils.shortId();
                scope._getItemValue = function (item) {
                    if (item === null || item === undefined)
                        return null;
                    return scope.valueField ? item[scope.valueField] : item;
                };
                scope._select = function (item) {
                    if (!scope.ngDisabled) {
                        ngModel.$setViewValue(scope._getItemValue(item));
                    }
                };
                scope._itemKeydown = function (e, item) {
                    if (e.key == 'Enter' || e.key == ' ' && !scope.ngDisabled) {
                        scope._select(item);
                        e.preventDefault();
                    }
                    else if (e.key == 'Escape') {
                        // element.find("input").blur();
                        element.find(".kb-radio__item").trigger('blur');
                    }
                };
            };
            return _this;
        }
        KbRadio = __decorate([
            NgComponent({
                token: Token.KbRadio,
                dependencies: [
                    Token.$Timeout,
                ]
            })
        ], KbRadio);
        return KbRadio;
    }(KbInput));

    var KbResize = /** @class */ (function (_super) {
        __extends(KbResize, _super);
        function KbResize() {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.transclude = true;
            _this.scope = {
                handles: "@", // top, bottom, left, right
                minWidth: "@",
                maxWidth: "@",
                minHeight: "@",
                maxHeight: "@",
                resizePosY: "=?", // allow the anchor point (top-left) to move vertically
                resizePosX: "=?", // allow the anchor point (top-left) to move horizontally
                disabled: "=?",
            };
            _this.template = Dirs.component("kb-resize");
            _this.link = function (scope, elem, atts) {
                var $handles = $();
                var resizing = false;
                var curHandleName = "right";
                var prevSize = {
                    width: 0,
                    height: 0,
                    top: 0,
                    left: 0
                };
                var curSize = {
                    width: 0,
                    height: 0,
                    top: 0,
                    left: 0
                };
                var startingSize = {
                    width: 0,
                    height: 0,
                    top: 0,
                    left: 0
                };
                var startingMousePosition = {
                    top: 0,
                    left: 0
                };
                var setup = function () {
                    if ($handles) {
                        $handles.remove();
                    }
                    if (!scope.disabled) {
                        setupHandles();
                    }
                };
                var setupHandles = function () {
                    $handles = $();
                    curHandleName = "right";
                    var handlesString = scope.handles || "right";
                    handlesString.split(",").forEach(function (h) {
                        var handleName = h.trim();
                        var $handle = $("<div>");
                        $handle.addClass("kb-resize-handle kb-resize-handle-" + handleName);
                        $handle.css({ zIndex: 90 });
                        elem.append($handle);
                        $handles = $handles.add($handle);
                    });
                    $handles.on("mouseover", function (e) {
                        if (!resizing) {
                            var name_1;
                            var el = e.target;
                            if (el.className) {
                                name_1 = el.className.match(/kb-resize-handle-(top|bottom|left|right)/i);
                            }
                            // the handle we last hover is the one we will move
                            curHandleName = name_1 && name_1[1] ? name_1[1] : "right";
                        }
                    });
                };
                var mouseInit = function () {
                    elem.on("mousedown", mouseDown);
                    _tools.TouchUtils.addMouseSimulation(elem);
                };
                var mouseDown = function (event) {
                    if (scope.disabled) {
                        return true;
                    }
                    var leftMouseBtn = (event.button === 0);
                    if (!leftMouseBtn) {
                        return true;
                    }
                    var handleClicked = false;
                    for (var i in $handles) {
                        if ($handles[i] === event.target || $.contains($handles[i], event.target)) {
                            handleClicked = true;
                            break;
                        }
                    }
                    if (!handleClicked) {
                        return true;
                    }
                    if (!resizing) {
                        startResizing(event.pageY, event.pageX);
                    }
                    $(document).on('mousemove', mouseMove);
                    $(document).on('mouseup', mouseUp);
                    event.preventDefault();
                    return true;
                };
                var mouseUp = function () {
                    $(document).off('mousemove', mouseMove);
                    $(document).off('mouseup', mouseUp);
                    resizing = false;
                    // we can restore the cursor since we are not resizing
                    $("body").css("cursor", "auto");
                };
                var mouseMove = function (event) {
                    if (resizing) {
                        mouseDrag(event.pageY, event.pageX);
                    }
                    else {
                        startResizing(event.pageY, event.pageX);
                        if (resizing) {
                            mouseDrag(event.pageY, event.pageX);
                        }
                        else {
                            // something happened, abort resize
                            mouseUp();
                        }
                    }
                    return !resizing;
                };
                var mouseDrag = function (mouseY, mouseX) {
                    prevSize = {
                        width: curSize.width,
                        height: curSize.height,
                        top: curSize.top,
                        left: curSize.left
                    };
                    var diffY = (mouseY - startingMousePosition.top) || 0;
                    var diffX = (mouseX - startingMousePosition.left) || 0;
                    var newSize = {};
                    switch (curHandleName) {
                        case "top":
                            newSize = {
                                height: startingSize.height - diffY,
                                top: scope.resizePosY ? startingSize.top + diffY : startingSize.top
                            };
                            break;
                        case "bottom":
                            newSize = {
                                height: startingSize.height + diffY
                            };
                            break;
                        case "left":
                            newSize = {
                                width: startingSize.width - diffX,
                                left: scope.resizePosX ? startingSize.left + diffX : startingSize.left
                            };
                            break;
                        default: // right
                            newSize = {
                                width: startingSize.width + diffX
                            };
                            break;
                    }
                    if (!isNaN(parseFloat(newSize.width))) {
                        curSize.width = newSize.width;
                    }
                    if (!isNaN(parseFloat(newSize.height))) {
                        curSize.height = newSize.height;
                    }
                    if (!isNaN(parseFloat(newSize.top))) {
                        curSize.top = newSize.top;
                    }
                    if (!isNaN(parseFloat(newSize.left))) {
                        curSize.left = newSize.left;
                    }
                    if (curSize.width !== prevSize.width) {
                        elem.css("width", curSize.width + "px");
                    }
                    if (curSize.height !== prevSize.height) {
                        elem.css("height", curSize.height + "px");
                    }
                    if (curSize.top !== prevSize.top) {
                        elem.css("top", curSize.top + "px");
                    }
                    if (curSize.left !== prevSize.left) {
                        elem.css("left", curSize.left + "px");
                    }
                };
                var startResizing = function (mouseY, mouseX) {
                    resizing = true;
                    var curTop = parseFloat(elem.css("top")) || 0;
                    var curLeft = parseFloat(elem.css("left")) || 0;
                    curSize = {
                        width: elem.width(),
                        height: elem.height(),
                        top: curTop,
                        left: curLeft
                    };
                    startingSize = {
                        width: elem.width(),
                        height: elem.height(),
                        top: curTop,
                        left: curLeft
                    };
                    startingMousePosition = {
                        top: mouseY,
                        left: mouseX
                    };
                    // keep the cursor type while resizing
                    var cursor = $(".kb-resize-handle-" + curHandleName).css("cursor");
                    $("body").css("cursor", cursor !== null && cursor !== void 0 ? cursor : "auto");
                };
                elem.addClass("kb-resize");
                if (scope.minWidth)
                    elem.css("min-width", scope.minWidth);
                if (scope.maxWidth)
                    elem.css("max-width", scope.maxWidth);
                if (scope.minHeight)
                    elem.css("min-height", scope.minHeight);
                if (scope.maxHeight)
                    elem.css("max-height", scope.maxHeight);
                setup();
                mouseInit();
                scope.$watch("handles", function () {
                    setup();
                });
                scope.$watch("disabled", function () {
                    setup();
                });
                scope.$on("$destroy", function () {
                    if ($handles) {
                        $handles.remove();
                    }
                    elem.off("mousedown", mouseDown);
                    $(document).off('mousemove', mouseMove);
                    $(document).off('mouseup', mouseUp);
                    _tools.TouchUtils.removeMouseSimulation(elem);
                });
            };
            return _this;
        }
        KbResize = __decorate([
            NgComponent({
                token: Token.KbResize,
                dependencies: []
            })
        ], KbResize);
        return KbResize;
    }(Directive));

    var KbRipple = /** @class */ (function (_super) {
        __extends(KbRipple, _super);
        function KbRipple($rootScope) {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.scope = false;
            _this.link = function (scope, element, atts) {
                var checkbox = scope.$eval(atts.kbRippleCheckbox);
                var $ripple;
                var $wave;
                var ripples = [];
                var last;
                var duration = 300;
                if (!checkbox) {
                    element.addClass("kb-ripple--hover");
                }
                var rippleShow = function (e) {
                    var rippleDisabled = scope.$eval(atts.kbRippleDisabled) === true;
                    if (!rippleDisabled) {
                        if (element.closest("[disabled]").length) {
                            return;
                        }
                        var initPos = element.css("position");
                        var offset = element.offset();
                        var elWidth = element[0].offsetWidth;
                        var elHeight = element[0].offsetHeight;
                        var dia = Math.max(elHeight, elWidth) * 2; // start diameter
                        var x_1 = checkbox ? "50%" : e.pageX - offset.left - (dia / 2) + "px";
                        var y_1 = checkbox ? "50%" : e.pageY - offset.top - (dia / 2) + "px";
                        var scale_1 = checkbox ? 2.88 : 1;
                        $ripple = $('<div/>', {
                            class: "kb-ripple",
                            appendTo: element,
                            css: {
                                overflow: checkbox ? "visible" : "hidden"
                            }
                        });
                        ripples.push($ripple);
                        if (!initPos || initPos === "static") {
                            element.css({ position: "relative" });
                        }
                        $wave = $('<div/>', {
                            class: "kb-ripple__wave kb-ripple__wave--enter kb-ripple__wave--visible" + (checkbox ? " kb-ripple__wave--checkbox" : ""),
                            css: {
                                width: checkbox ? "1.2rem" : dia,
                                height: checkbox ? "1.2rem" : dia,
                                transform: "translate(".concat(x_1, ", ").concat(y_1, ") scale3d(0,0,0)"),
                                marginLeft: checkbox ? "-.6rem" : 0,
                                marginTop: checkbox ? "-.6rem" : 0
                            },
                            appendTo: $ripple,
                            // one: {
                            //     animationend: function () {
                            //        $ripple.remove();
                            //     }
                            // }
                        });
                        setTimeout(function () {
                            $wave.removeClass("kb-ripple__wave--enter");
                            $wave.css("transform", "translate(".concat(x_1, ", ").concat(y_1, ") scale3d(").concat(scale_1, ", ").concat(scale_1, ", ").concat(scale_1, ")"));
                            last = performance.now();
                        }, 0);
                    }
                };
                var rippleHide = function () {
                    if (!element || !$ripple || !$wave)
                        return;
                    var delay = Math.max(duration - (performance.now() - last), 0);
                    setTimeout(function () {
                        $wave.removeClass("kb-ripple__wave--visible");
                        setTimeout(function () {
                            ripples.forEach(function (r) { return r.remove(); });
                        }, duration);
                    }, delay);
                };
                element.on("pointerdown", rippleShow);
                element.on('pointerup', rippleHide);
                element.on('pointerleave', rippleHide);
                element.on('dragstart', rippleHide);
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbRipple = __decorate([
            NgComponent({
                token: Token.KbRipple,
                dependencies: [
                    Token.$RootScope
                ]
            })
        ], KbRipple);
        return KbRipple;
    }(Directive));

    /**
     * KbScope
     *
     * Allows you to create a new prototypically inherited scope on an element.  Consider this example:
     * <div kb-scope="item: _selectedItem">
     *   <input ng-model="item.value"/>
     * </div>
     *
     * kbScope will put everything inside of the div into a new scope with the item property set on it
     * It accomplishes this by using transclusion
     */
    var KbScope = /** @class */ (function (_super) {
        __extends(KbScope, _super);
        function KbScope() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.scope = false;
            _this.priority = 1000; // make sure it runs first
            _this.transclude = "element";
            _this.link = function (scope, element, atts, ctrl, $transclude) {
                var childScope = scope.$new();
                scope.$watch("{" + atts.kbScope + "}", function (data) {
                    angular__namespace.extend(childScope, data);
                }, true);
                $transclude(childScope, function (clone) {
                    element.after(clone);
                });
                scope.$on("$destroy", function () {
                    if (childScope)
                        childScope.$destroy();
                });
            };
            return _this;
        }
        KbScope = __decorate([
            NgComponent({
                token: Token.KbScope,
                dependencies: []
            })
        ], KbScope);
        return KbScope;
    }(Directive));

    var KbSearchGrid = /** @class */ (function (_super) {
        __extends(KbSearchGrid, _super);
        function KbSearchGrid(drawerService) {
            var _this = _super.call(this) || this;
            _this.template = Dirs.component("kb-search-grid");
            _this.restrict = "AE";
            _this.scope = false;
            _this.replace = true;
            _this.transclude = {
                results: '?kbSearchGridResults',
                customResults: '?kbSearchGridCustomResults',
                toolbar: '?kbSearchGridToolbar'
            };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                Token.ApiService.key,
                function ($scope, $element, $attrs, $transclude, api) {
                    var columns = $scope.columns = [];
                    $scope.scrollParent = $attrs.scrollParent || "#search-content";
                    $scope.drawerService = drawerService;
                    var colDb = {};
                    this.addColumn = function (column) {
                        if (!colDb[column.id]) {
                            colDb[column.id] = column;
                            columns.push(column);
                            columns.sortBy(function (c) { return c.order; });
                            // column.$on("$destroy", (event) => {
                            //    columns.remove(column);
                            // });
                            // set sort properties from query string                        
                            if (column.field && column.field == $scope.binding.search.sortField) {
                                column.sorted = true;
                                column.descending = $scope.binding.search.descending;
                            }
                        }
                    };
                }
            ];
            return _this;
        }
        KbSearchGrid = __decorate([
            NgComponent({
                token: Token.KbSearchGrid,
                dependencies: [
                    Token.DrawerService
                ]
            })
        ], KbSearchGrid);
        return KbSearchGrid;
    }(Directive));

    var KbSelect = /** @class */ (function (_super) {
        __extends(KbSelect, _super);
        function KbSelect($timeout, $window) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-select");
            _this.scope = _tools.Utils.extend(_this.scope, {
                source: "=",
                data: "=?",
                valueField: "@",
                labelField: "@",
                defaultLabel: "@",
                headerTemplate: "@",
                mobileDropdown: "=?",
                filter: "=",
                itemStyle: "=?",
                deepWatch: "=?",
                optionLayout: "=?"
            });
            _this.transclude = true;
            _this.compile = function (element, atts) {
                if (atts.mobileDropdown == null)
                    atts.mobileDropdown = "true";
                return _this.link;
            };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                "$templateCache",
                Token.$Compile.key,
                function ($scope, $element, $attrs, $transclude, $templateCache, $compile) {
                    // set the scope on the controller so children can access it
                    this.scope = $scope;
                    // if a header template was passed in then get it from the template cache
                    if ($scope.headerTemplate) {
                        var $template = angular__namespace.element($templateCache.get($scope.headerTemplate));
                        // compile the template
                        var compiled = $compile($template, $transclude);
                        // append it to the label
                        $element.find(".kb-select__header").html("").append($template);
                        // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                        compiled($scope);
                    }
                }
            ];
            _this.link = function (scope, element, atts, controllers) {
                // we provide out own implementation of isEmpty to kbInput since a value because null is an allowed value that could have a label
                // this is for material design so we know when to float the label
                var isEmpty = function (val) {
                    return scope._selectedLabel == null || scope._selectedLabel.length == 0;
                };
                _this.kbInputLinkFn(scope, element, atts, controllers, true, isEmpty);
                var ngModelCtrl = controllers[0];
                scope._id = _tools.Utils.shortId();
                scope._binding = { query: "" };
                var input = element.find("input");
                // the source as an array (it might have been passed in as a function so we normalize it)
                var arraySource;
                //readyForValue tracks wether a value has been chosen for the select list or not 
                var readyForValue = false;
                var getItemValue = function (item) {
                    if (item === null || item === undefined)
                        return null;
                    return scope.valueField ? item[scope.valueField] : item;
                };
                var getItemLabel = function (item) {
                    var _a, _b;
                    if (scope.labelField && item[scope.labelField] && ((_a = item[scope.labelField]) === null || _a === void 0 ? void 0 : _a.toString())) {
                        return (_b = item[scope.labelField]) === null || _b === void 0 ? void 0 : _b.toString();
                    }
                    else if (scope.valueField) {
                        return item[scope.valueField];
                    }
                    else {
                        return item;
                    }
                };
                var updateSelectedLabel = function () {
                    scope._selectedLabel = scope.item ? getItemLabel(scope.item) : scope.defaultLabel;
                };
                var isEnabled = function () {
                    return !scope.ngDisabled;
                };
                var updateSelected = function () {
                    if (arraySource) {
                        for (var i = 0; i < arraySource.length; i++) {
                            var item = arraySource[i];
                            if (getItemValue(item) == ngModelCtrl.$viewValue) {
                                scope.item = item;
                                scope._selectedIndex = i;
                                scope._activeIndex = i;
                                updateSelectedLabel();
                                scope._setHasValue(!isEmpty());
                                return;
                            }
                        }
                    }
                    // if we get here, then it wasn't found.
                    scope.item = null;
                    updateSelectedLabel();
                    scope._setHasValue(!isEmpty());
                };
                var showDropdown = function () {
                    scope._dropdownOpen = true;
                    readyForValue = true;
                    // on mobile the filter input will kick off the keyboard, which we don't necessarily want.  
                    // The problem is worse on IOS because of focus restrictions
                    if ($window.innerWidth >= _tools.Utils.MOBILE_WIDTH && !_tools.Utils.isIos()) {
                        $timeout(function () { return input.trigger('focus'); });
                        if (scope.source.length > 10) {
                            var searchBox_1 = document.getElementById(scope._id + "-input");
                            $timeout(function () { return searchBox_1.focus(); });
                        }
                    }
                };
                var hideDropdown = function () {
                    scope._dropdownOpen = false;
                    scope._binding.query = null;
                    updateFilteredSource();
                };
                var toggleDropdown = function () {
                    scope._dropdownOpen ? hideDropdown() : showDropdown();
                };
                // options might be added after the ngModel is set by the consumer, so
                // we need to refind the selected option 
                var sourceChange = function () {
                    if (angular__namespace.isFunction(scope.source)) {
                        arraySource = scope.source();
                    }
                    else {
                        arraySource = scope.source;
                    }
                    updateSelected();
                    updateFilteredSource();
                };
                if (scope.deepWatch) {
                    scope.$watch("source", function () { return sourceChange(); }, true);
                }
                else {
                    scope.$watchCollection("source", function () { return sourceChange(); });
                }
                ngModelCtrl.$render = function () {
                    updateSelected();
                };
                scope._itemMousedown = function (e, item) {
                    e.preventDefault(); // so we don't lose focus
                    scope._select(item);
                };
                scope._select = function (item) {
                    if (readyForValue) {
                        if (isEnabled()) {
                            readyForValue = false;
                            hideDropdown();
                            ngModelCtrl.$setViewValue(getItemValue(item));
                            updateSelected();
                        }
                    }
                };
                scope._click = function (e) {
                    if (isEnabled()) {
                        toggleDropdown();
                    }
                };
                scope._isActive = function (index) {
                    return index === scope._activeIndex;
                };
                var updateFilteredSource = function () {
                    if (!scope._binding.query) {
                        scope._filteredSource = arraySource;
                    }
                    else {
                        scope._filteredSource = _tools.SearchUtils.search(scope._binding.query, arraySource, function (o) { var _a; return (_a = getItemLabel(o)) === null || _a === void 0 ? void 0 : _a.toString(); }, 10000);
                        scope._activeIndex = 0;
                    }
                };
                scope._queryChange = function (e) {
                    updateFilteredSource();
                };
                scope._queryKeydown = function (e) {
                    if (e.key == "ArrowUp") {
                        moveUp();
                        e.stopPropagation();
                    }
                    if (e.key == "ArrowDown") {
                        moveDown();
                        e.stopPropagation();
                    }
                    if (e.key === "Enter") {
                        enter();
                        e.stopPropagation();
                    }
                    if (e.key === "Tab") {
                        tab();
                        if (scope._dropdownOpen) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }
                };
                var moveUp = function () {
                    if (scope._dropdownOpen) {
                        // if we are already at index zero, then close the dropdown
                        var newIndex = scope._activeIndex - 1;
                        if (newIndex >= 0)
                            scope._activeIndex = newIndex;
                    }
                };
                var moveDown = function () {
                    showDropdown();
                    // if we are already at index zero, then close the dropdown
                    var newIndex = scope._activeIndex + 1;
                    if (newIndex < scope._filteredSource.length)
                        scope._activeIndex = newIndex;
                };
                var enter = function () {
                    if (scope._dropdownOpen) {
                        if (scope._filteredSource.length && scope._activeIndex > -1) {
                            scope._select(scope._filteredSource[scope._activeIndex]);
                        }
                        element.trigger("focus");
                    }
                    else {
                        showDropdown();
                    }
                };
                var tab = function () {
                    if (scope._dropdownOpen) {
                        element.trigger('focus');
                        if (scope._filteredSource.length && scope._activeIndex > -1) {
                            scope._select(scope._filteredSource[scope._activeIndex]);
                        }
                    }
                };
                var keySearch = function (key) {
                    var _a, _b, _c, _d;
                    key = key.toLowerCase();
                    var option = scope._activeIndex;
                    var labelOrValue = (_b = (_a = scope._filteredSource[option].label) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : scope._filteredSource[option].value;
                    if (labelOrValue && !labelOrValue.toLowerCase().startsWith(key)) {
                        option = scope._filteredSource.findIndex(function (a) {
                            var _a;
                            var b = ((_a = a.label) === null || _a === void 0 ? void 0 : _a.toString()) || a.value;
                            return b.toLowerCase().startsWith(key);
                        });
                    }
                    else {
                        if ((option + 1) < scope._filteredSource.length) {
                            var optionPlusOne = (_d = (_c = scope._filteredSource[(option + 1)].label) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : scope._filteredSource[(option + 1)].value;
                            if (optionPlusOne && optionPlusOne.toLowerCase().startsWith(key)) {
                                option++;
                            }
                            else {
                                option = scope._filteredSource.findIndex(function (a) {
                                    var _a, _b;
                                    var b = (_b = (_a = a.label) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : a.value;
                                    return b.toLowerCase().startsWith(key);
                                });
                            }
                        }
                        else {
                            option = scope._filteredSource.findIndex(function (a) {
                                var _a, _b;
                                var b = (_b = (_a = a.label) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : a.value;
                                return b === null || b === void 0 ? void 0 : b.toLowerCase().startsWith(key);
                            });
                        }
                    }
                    if (option > -1) {
                        showDropdown();
                        scope._activeIndex = option;
                    }
                };
                // bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
                element.on("keydown", function (e) {
                    switch (e.key) {
                        case 'ArrowUp':
                            e.preventDefault();
                            scope.$apply(function () {
                                moveUp();
                            });
                            break;
                        case 'ArrowDown':
                            e.preventDefault();
                            scope.$apply(function () {
                                moveDown();
                            });
                            break;
                        case 'Enter':
                            scope.$apply(function () {
                                e.preventDefault();
                                enter();
                            });
                            break;
                        case 'Tab':
                            scope.$apply(function () {
                                if (scope._dropdownOpen) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                                tab();
                            });
                            break;
                        case 'Escape':
                            e.preventDefault();
                            scope.$apply(function () {
                                hideDropdown();
                                e.stopPropagation();
                            });
                            element.trigger('blur');
                            break;
                        default:
                            if (e.key.match(/^[a-zA-Z,0-9]+$/) && e.key.length == 1) {
                                e.stopPropagation();
                                e.preventDefault();
                                scope.$apply(function () {
                                    keySearch(e.key);
                                });
                            }
                            break;
                    }
                });
                scope.$on("$destroy", function () {
                    element.off();
                });
            };
            return _this;
        }
        KbSelect = __decorate([
            NgComponent({
                token: Token.KbSelect,
                dependencies: [
                    Token.$Timeout,
                    Token.$Window,
                ]
            })
        ], KbSelect);
        return KbSelect;
    }(KbInput));

    var KbSfdcHeader = /** @class */ (function (_super) {
        __extends(KbSfdcHeader, _super);
        function KbSfdcHeader($timeout, drawerService) {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-sfdc-header");
            _this.scope = false;
            _this.replace = true;
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                "$templateCache",
                Token.$Compile.key,
                function ($scope, $element, $attrs, $transclude, $templateCache, $compile) {
                    // set the scope on the controller so children can access it
                    this.scope = $scope;
                    $scope.drawerService = drawerService;
                }
            ];
            _this.link = function (scope, element, atts, ngModel) {
            };
            return _this;
        }
        KbSfdcHeader = __decorate([
            NgComponent({
                token: Token.KbSfdcHeader,
                dependencies: [
                    Token.$Timeout,
                    Token.DrawerService,
                ]
            })
        ], KbSfdcHeader);
        return KbSfdcHeader;
    }(Directive));

    var KbSlide = /** @class */ (function (_super) {
        __extends(KbSlide, _super);
        function KbSlide() {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.replace = true;
            _this.scope = {
                open: "="
            };
            _this.transclude = true;
            _this.template = Dirs.component("kb-slide");
            _this.link = function (scope, element, atts) {
                // put a class on the body element in the form of
                // <slideid>-visible so that other elements can react
                // to the slide being open
                if (atts.id) {
                    var className_1 = atts.id + "-open";
                    scope.$watch("open", function (newValue) {
                        if (angular__namespace.isDefined(newValue)) {
                            $("body").toggleClass(className_1, newValue);
                        }
                    });
                }
                scope.clicked = function () {
                    scope.open = false;
                };
                scope.$watch("open", function (newValue) {
                    if (!newValue) {
                        $(element).find(".kb-slide__nav").scrollTop(0);
                    }
                });
            };
            return _this;
        }
        KbSlide = __decorate([
            NgComponent({
                token: Token.KbSlide,
                dependencies: []
            })
        ], KbSlide);
        return KbSlide;
    }(Directive));

    var KbSlider = /** @class */ (function (_super) {
        __extends(KbSlider, _super);
        function KbSlider($timeout, $document) {
            var _this = _super.call(this, $timeout) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                min: "=",
                max: "=",
                step: "=?",
                format: "@",
                minPrecision: "@",
                maxPrecision: "@",
                currency: "@",
                thousandsSeparator: "@",
                decimalSeparator: "@",
                prefix: "@",
                suffix: "@",
                directEdit: "=?",
                valueVisibility: "=?"
            });
            _this.template = Dirs.component("kb-slider");
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                var ngModel = controllers[0];
                var $thumb = element.find(".kb-slider__thumb");
                var thumbElem = $thumb[0];
                var lineElem = element.find(".kb-slider__line")[0];
                var valueLineElem = element.find(".kb-slider__value-line")[0];
                var setViewValue = function (val) {
                    ngModel.$setViewValue(val);
                    setFormattedValue(val);
                };
                var getNearestVal = function (tryVal) {
                    Math.floor(scope.max / scope.step);
                    var val = Math.round(tryVal / scope.step) * scope.step;
                    val = Math.min(scope.max, Math.max(val, scope.min));
                    return val;
                };
                var setCurrentValue = function (val) {
                    scope.currentVal = val;
                    return val;
                };
                var setThumbPos = function (val, withAnimation) {
                    if (withAnimation === void 0) { withAnimation = true; }
                    lineElem.clientWidth;
                    var percent = (val - scope.min) / (scope.max - scope.min);
                    percent = Math.max(Math.min(1, percent), 0);
                    var cssVal = "".concat(percent * 100, "%");
                    if (withAnimation) {
                        $(thumbElem).stop(true, true).animate({ left: cssVal }, 300);
                        $(valueLineElem).stop(true, true).animate({ width: cssVal }, 300);
                    }
                    else {
                        thumbElem.style.left = cssVal;
                        valueLineElem.style.width = cssVal;
                    }
                    return val;
                };
                var getValFromMousePos = function (mouseClientX) {
                    var lineRect = lineElem.getBoundingClientRect();
                    var lineWidth = lineRect.right - lineRect.left;
                    var percent = (mouseClientX - lineRect.left) / lineWidth;
                    var cval = ((scope.max - scope.min) * percent) + scope.min;
                    cval = cval.rounder(scope.maxPrecision);
                    cval = getNearestVal(cval);
                    return cval;
                };
                var setFormattedValue = function (value) {
                    var format = scope.format;
                    if (!format || format == enums.eFormatType.none)
                        format = enums.eFormatType.number;
                    scope.formattedValue = value.format({
                        formatType: format,
                        minPrecision: Number(scope.minPrecision),
                        maxPrecision: Number(scope.maxPrecision),
                        currency: scope.currency,
                        decimalSeparator: scope.decimalSeparator,
                        thousandsSeparator: scope.thousandsSeparator,
                        prefix: scope.prefix,
                        suffix: scope.suffix
                    });
                    return value;
                };
                var setTicks = function (val) {
                    scope.tickPercent = Math.min(Math.max(scope.step / (scope.max - scope.min), .01), 1);
                    return val;
                };
                //formatters are run in reverse
                ngModel.$formatters.push(setTicks);
                ngModel.$formatters.push(setFormattedValue);
                ngModel.$formatters.push(setThumbPos);
                ngModel.$formatters.push(setCurrentValue);
                ngModel.$formatters.push(getNearestVal);
                scope.lineClick = function (e) {
                    if (!scope.ngDisabled) {
                        var cval = getValFromMousePos(e.clientX);
                        setCurrentValue(cval);
                        setThumbPos(cval, true);
                        setViewValue(cval);
                        // scope.ngModel = cval; // set ngmodel instead of setViewValue so that it runs through all the formatters again
                    }
                };
                var pointerdown = function (e) {
                    if (!scope.ngDisabled) {
                        scope.dragging = true;
                        $document.attr("touch-action", "none");
                        $document.on("pointerup", pointerup);
                        $document.on("pointermove", pointermove);
                        scope.$digest();
                    }
                };
                var pointerup = function (e) {
                    if (!scope.ngDisabled) {
                        scope.dragging = false;
                        $document.attr("touch-action", "");
                        $document.off("pointerup", pointerup);
                        $document.off("pointermove", pointermove);
                        setViewValue(scope.currentVal);
                        scope.$digest();
                    }
                };
                var pointermove = function (e) {
                    if (!scope.ngDisabled) {
                        var cval = getValFromMousePos(e.clientX);
                        scope.currentVal = cval;
                        setThumbPos(cval, false);
                        setFormattedValue(cval);
                        scope.$digest();
                    }
                };
                var keydown = function (e) {
                    if (!scope.ngDisabled) {
                        if (e.key == 'ArrowLeft') { //arrow left
                            var cval = getNearestVal(scope.ngModel - scope.step);
                            scope.currentVal = cval;
                            setThumbPos(cval, false);
                            setViewValue(cval);
                            scope.$digest();
                        }
                        else if (e.key == 'ArrowRight') { //arrow right
                            var cval = getNearestVal(scope.ngModel + scope.step);
                            scope.currentVal = cval;
                            setThumbPos(cval, false);
                            setViewValue(cval);
                            scope.$digest();
                        }
                        else if (e.key == 'Escape') {
                            element.trigger('blur');
                        }
                    }
                };
                // we need to add the touch-action attribute to the svg element for the pep library
                // for the pointer-events w3c standard, this will be replaced by a css attribute
                $thumb.attr("touch-action", "none");
                $thumb.on("pointerdown", pointerdown);
                element.on("keydown", keydown);
                scope.$watch("min", function (newVal) {
                    setThumbPos(scope.ngModel);
                    setTicks(scope.ngModel);
                });
                scope.$watch("max", function (newVal) {
                    setThumbPos(scope.ngModel);
                    setTicks(scope.ngModel);
                });
                scope.$watch("step", function (newVal) {
                    setThumbPos(scope.ngModel);
                    setTicks(scope.ngModel);
                });
                scope.$on("$destroy", function () {
                    element.off();
                    $document.off("pointerup", pointerup);
                    $document.off("pointermove", pointermove);
                });
            };
            return _this;
        }
        KbSlider = __decorate([
            NgComponent({
                token: Token.KbSlider,
                dependencies: [
                    Token.$Timeout,
                    Token.$Document
                ]
            })
        ], KbSlider);
        return KbSlider;
    }(KbInput));

    var KbSortable = /** @class */ (function (_super) {
        __extends(KbSortable, _super);
        function KbSortable($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.transclude = true;
            _this.require = "?ngModel";
            _this.scope = {
                ngModel: "=",
                itemSelector: "@", // selector for the sortable items (point to the ng-repeat element)
                handleSelector: "@", // selector for the item's handle
                horizontal: "=?", // determines the orientation of the list
                disabled: "=?",
                onStop: "&", // callback after sorting (fires even if no change happened)
            };
            _this.template = Dirs.component("kb-sortable");
            _this.link = function (scope, elem, atts, ngModel) {
                var itemQuery = "> *";
                var items = [];
                var itemCaptured = false;
                var itemMoved = false;
                var $placeholder = null;
                var $originalListDOM = null;
                var $currentItem = null;
                var currentItemOriginalIndex = null;
                var currentItemNewIndex = null;
                var currentItemOriginalCSS = {
                    width: "",
                    height: "",
                    top: "",
                    left: "",
                    position: "",
                    zIndex: ""
                };
                var $itemScrollParent = null;
                var $itemParent = null;
                var offsetClick = {
                    top: 0,
                    left: 0,
                };
                var offsetParent = {
                    top: 0,
                    left: 0,
                };
                var itemPosition = {
                    top: 0,
                    left: 0,
                };
                var itemPointerPosition = {
                    top: 0,
                    left: 0,
                };
                var itemLastPointerPosition = {
                    top: 0,
                    left: 0,
                };
                var setup = function () {
                    itemQuery = "> *";
                    if (scope.itemSelector) {
                        itemQuery = scope.itemSelector;
                    }
                    cleanDOM();
                    if (!scope.disabled) {
                        setItems();
                        setHandles();
                    }
                };
                var setItems = function () {
                    items = [];
                    elem.find(itemQuery).each(function (i, child) {
                        items.push($(child));
                    });
                };
                var setHandles = function () {
                    // add handle per item
                    $.each(items, function (i, $item) {
                        if (scope.handleSelector) {
                            $item.find(scope.handleSelector).addClass("kb-sortable-handle");
                        }
                        else {
                            // if no handle selector given, then make the whole item the handle
                            $item.addClass("kb-sortable-handle");
                        }
                    });
                };
                var mouseInit = function () {
                    elem.on("mousedown", mouseDown);
                    _tools.TouchUtils.addMouseSimulation(elem);
                };
                var mouseDown = function (event) {
                    if (scope.disabled) {
                        return true;
                    }
                    var leftMouseBtn = (event.button === 0);
                    if (!leftMouseBtn) {
                        return true;
                    }
                    // make sure items are set
                    setItems();
                    var itemClicked = null;
                    if (items.length > 0) {
                        // get the clicked item
                        itemClicked = items.find(function (el) { return el[0] == event.target; });
                        // item not found, search for a parent
                        if (!itemClicked) {
                            $(event.target).parents().each(function (i, parent) {
                                itemClicked = items.find(function (el) { return el[0] == parent; });
                                if (itemClicked) {
                                    return false;
                                }
                            });
                        }
                    }
                    if (!itemClicked) {
                        return true;
                    }
                    if (scope.handleSelector) {
                        var validHandle_1 = false;
                        $(scope.handleSelector, itemClicked).find("*").addBack().each(function (i, el) {
                            if (el === event.target) {
                                validHandle_1 = true;
                                return false;
                            }
                        });
                        // handle not found, abort sorting
                        if (!validHandle_1) {
                            return true;
                        }
                    }
                    cleanCurrentState();
                    $currentItem = itemClicked;
                    currentItemOriginalIndex = items.indexOf($currentItem);
                    if (!itemCaptured) {
                        captureItem(event.pageY, event.pageX);
                    }
                    $(document).on('mousemove', mouseMove);
                    $(document).on('mouseup', mouseUp);
                    event.preventDefault();
                    return true;
                };
                var mouseUp = function () {
                    $(document).off('mousemove', mouseMove);
                    $(document).off('mouseup', mouseUp);
                    // somehow the placeholder is missing, abort sorting
                    if (!$placeholder) {
                        restoreDOM();
                        return;
                    }
                    // update the DOM position of the item
                    // only do this if we actually moved, otherwise the DOM update will cause inside clicks to be ignored
                    if (itemMoved && $currentItem.parent().length) {
                        $placeholder.before($currentItem);
                    }
                    // remove the placeholder from the DOM
                    $placeholder.remove();
                    // restore the original css of the item
                    for (var prop in currentItemOriginalCSS) {
                        // avoid default values to be set as a style attr
                        if (currentItemOriginalCSS[prop] === "auto" || currentItemOriginalCSS[prop] === "static") {
                            currentItemOriginalCSS[prop] = "";
                        }
                    }
                    $currentItem.css(currentItemOriginalCSS);
                    // get new index based on the DOM
                    currentItemNewIndex = elem.find(itemQuery).index($currentItem);
                    // we should only update if we actually moved, otherwise inside clicks will be ignored
                    if (itemMoved) {
                        restoreDOM();
                        if (currentItemNewIndex != null && currentItemOriginalIndex != null && currentItemNewIndex != currentItemOriginalIndex) {
                            // $apply so that ng-repeat renders the new order
                            scope.$apply(function () {
                                ngModel.$modelValue.splice(currentItemNewIndex, 0, ngModel.$modelValue.splice(currentItemOriginalIndex, 1)[0]);
                            });
                        }
                        if (scope.onStop) {
                            // timeout so that it executes on the next $digest
                            $timeout(function () {
                                scope.onStop();
                            });
                        }
                    }
                    cleanCurrentState();
                };
                var mouseMove = function (event) {
                    // the mouse has moved, we are committed to sorting even if positions don't change
                    itemMoved = true;
                    if (itemCaptured) {
                        mouseDrag(event.pageY, event.pageX);
                    }
                    else {
                        captureItem(event.pageY, event.pageX);
                        if (itemCaptured) {
                            mouseDrag(event.pageY, event.pageX);
                        }
                        else {
                            // something happened, abort sorting
                            mouseUp();
                        }
                    }
                    return !itemCaptured;
                };
                var captureItem = function (mouseY, mouseX) {
                    // save the original list DOM
                    $originalListDOM = $currentItem.parent().contents();
                    // don't inlcude the placeholder
                    if ($placeholder) {
                        $originalListDOM = $originalListDOM.not($placeholder);
                    }
                    // save the item's original css
                    currentItemOriginalCSS = {
                        width: $currentItem[0].style.width,
                        height: $currentItem[0].style.height,
                        top: $currentItem.css("top"),
                        left: $currentItem.css("left"),
                        position: $currentItem.css("position"),
                        zIndex: $currentItem.css("zIndex"),
                    };
                    // add the computed size if missing, will avoid a size change when changing the position
                    if (!$currentItem[0].style.width) {
                        $currentItem.width($currentItem.width());
                    }
                    if (!$currentItem[0].style.height) {
                        $currentItem.height($currentItem.height());
                    }
                    var itemPosition = $currentItem.offset();
                    // item's absolute position minus margins
                    var offsetItem = {
                        top: itemPosition.top - parseCSSNumber($currentItem, "marginTop"),
                        left: itemPosition.left - parseCSSNumber($currentItem, "marginLeft")
                    };
                    // click position relative to the item
                    offsetClick = {
                        top: mouseY - offsetItem.top,
                        left: mouseX - offsetItem.left
                    };
                    $itemScrollParent = _tools.Utils.getScrollParent($currentItem);
                    $itemParent = $currentItem.offsetParent();
                    var parentPosition = $itemParent.offset();
                    if ($.contains($itemScrollParent[0], $itemParent[0])) {
                        // if the parent is inside a scroll it will have it's position offset so we need to restore it
                        parentPosition.top += $itemScrollParent.scrollTop();
                        parentPosition.left += $itemScrollParent.scrollLeft();
                    }
                    // item parent's absolute position plus borders
                    offsetParent = {
                        top: parentPosition.top + parseCSSNumber($itemParent, "borderTopWidth"),
                        left: parentPosition.left + parseCSSNumber($itemParent, "borderLeftWidth")
                    };
                    // create the placeholder that will show the new position when moving the item
                    createPlaceholder();
                    // after calculating the offset and placeholder we can change the position
                    $currentItem.css("position", "absolute");
                    $currentItem.css("zIndex", 1000);
                    itemCaptured = true;
                    // execute the drag once to set the item's correct screen position
                    mouseDrag(mouseY, mouseX);
                };
                var mouseDrag = function (mouseY, mouseX) {
                    var scrollAmount = 20;
                    // get the position for intersection check
                    itemPointerPosition = {
                        top: mouseY - offsetClick.top,
                        left: mouseX - offsetClick.left
                    };
                    if (!itemLastPointerPosition) {
                        itemLastPointerPosition = itemPointerPosition;
                    }
                    // get the node that will act as the scroll offset for the item's screen position
                    var scrollNode = $.contains($itemScrollParent[0], $itemParent[0]) ? $itemScrollParent : $itemParent;
                    // get the screen position for the "flying" item
                    itemPosition = {
                        top: itemPointerPosition.top - offsetParent.top + scrollNode.scrollTop(),
                        left: itemPointerPosition.left - offsetParent.left + scrollNode.scrollLeft()
                    };
                    var scrollParentPosition = $itemScrollParent.offset();
                    // perform scrolling
                    if ((scrollParentPosition.top + $itemScrollParent[0].offsetHeight - mouseY) < scrollAmount) {
                        $itemScrollParent[0].scrollTop += scrollAmount;
                        itemPointerPosition.top -= scrollAmount;
                    }
                    else if ((mouseY - scrollParentPosition.top) < scrollAmount) {
                        $itemScrollParent[0].scrollTop -= scrollAmount;
                        itemPointerPosition.top += scrollAmount;
                    }
                    if ((scrollParentPosition.left + $itemScrollParent[0].offsetWidth - mouseX) < scrollAmount) {
                        $itemScrollParent[0].scrollLeft += scrollAmount;
                        itemPointerPosition.left -= scrollAmount;
                    }
                    else if ((mouseX - scrollParentPosition.left) < scrollAmount) {
                        $itemScrollParent[0].scrollLeft -= scrollAmount;
                        itemPointerPosition.left += scrollAmount;
                    }
                    // set the position for the "flying" item
                    $currentItem[0].style.top = itemPosition.top + "px";
                    $currentItem[0].style.left = itemPosition.left + "px";
                    // check intersection of items
                    for (var i = items.length - 1; i >= 0; i--) {
                        var $item = items[i];
                        var intersection = intersectsWithPointer($item, scope.horizontal ? "left" : "top");
                        if (intersection == 0) {
                            continue;
                        }
                        // item can't intersect with itself
                        if ($item[0] !== $currentItem[0]) {
                            var movePrev = intersection == -1;
                            // check if the item captured is not the parent of the $item
                            if ($placeholder[movePrev ? "next" : "prev"]()[0] !== $item[0] && !$.contains($placeholder[0], $item[0])) {
                                // sort DOM
                                $item[0].parentNode.insertBefore($placeholder[0], (movePrev ? $item[0] : $item[0].nextSibling));
                                break;
                            }
                        }
                    }
                    itemLastPointerPosition = itemPointerPosition;
                };
                // 0: no intersection, 1: should move next, -1: should move prev
                var intersectsWithPointer = function ($item, dir) {
                    var itemPosition = $item.offset();
                    var itemClick = itemPointerPosition[dir] + offsetClick[dir];
                    var itemSize = itemPosition[dir] + (dir == "top" ? $item.outerHeight() : $item.outerWidth());
                    var isOver = (itemClick >= itemPosition[dir]) && (itemClick < itemSize);
                    if (!isOver) {
                        return 0;
                    }
                    var delta = itemPointerPosition[dir] - itemLastPointerPosition[dir];
                    if (delta == 0) {
                        return 0;
                    }
                    return delta > 0 ? 1 : -1;
                };
                var createPlaceholder = function () {
                    var nodeName = $currentItem[0].nodeName.toLowerCase();
                    $placeholder = $("<" + nodeName + ">", document);
                    $placeholder.addClass($currentItem[0].className);
                    $placeholder.css("visibility", "hidden");
                    // append the placeholder after the actual item
                    $currentItem.after($placeholder);
                    // if the placeholder doesn't have a size we copy the computed size from the item
                    if (!$placeholder.height()) {
                        $placeholder.outerHeight($currentItem.outerHeight());
                    }
                    if (!$placeholder.width()) {
                        $placeholder.outerWidth($currentItem.outerWidth());
                    }
                };
                var restoreDOM = function () {
                    if ($currentItem && $originalListDOM) {
                        if (!angular__namespace.equals($currentItem.parent().contents().toArray(), $originalListDOM.toArray())) {
                            // restore the original list DOM to preserve the ng-repeat scope
                            $originalListDOM.appendTo($currentItem.parent());
                        }
                    }
                };
                var cleanCurrentState = function () {
                    itemCaptured = false;
                    itemMoved = false;
                    $placeholder = null;
                    $originalListDOM = null;
                    $currentItem = null;
                    currentItemOriginalIndex = null;
                    currentItemNewIndex = null;
                    currentItemOriginalCSS = {
                        width: "",
                        height: "",
                        top: "",
                        left: "",
                        position: "",
                        zIndex: ""
                    };
                    $itemScrollParent = null;
                    $itemParent = null;
                    offsetClick = {
                        top: 0,
                        left: 0,
                    };
                    offsetParent = {
                        top: 0,
                        left: 0,
                    };
                    itemPosition = {
                        top: 0,
                        left: 0,
                    };
                    itemPointerPosition = {
                        top: 0,
                        left: 0,
                    };
                    itemLastPointerPosition = {
                        top: 0,
                        left: 0,
                    };
                };
                var cleanDOM = function () {
                    // remove existing handles
                    elem.find(".kb-sortable-handle").removeClass("kb-sortable-handle");
                    // remove existing placeholder
                    if ($placeholder) {
                        $placeholder.remove();
                    }
                };
                var parseCSSNumber = function ($item, prop) {
                    return parseInt($item.css(prop), 10) || 0;
                };
                setup();
                mouseInit();
                scope.$watchCollection('ngModel', function () {
                    // timeout to let ng-repeat modify the DOM
                    $timeout(function () {
                        setup();
                    });
                });
                scope.$watch("handles", function () {
                    setup();
                });
                scope.$watch("disabled", function () {
                    setup();
                });
                scope.$on("$destroy", function () {
                    cleanDOM();
                    elem.off("mousedown", mouseDown);
                    $(document).off('mousemove', mouseMove);
                    $(document).off('mouseup', mouseUp);
                    _tools.TouchUtils.removeMouseSimulation(elem);
                });
            };
            return _this;
        }
        KbSortable = __decorate([
            NgComponent({
                token: Token.KbSortable,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbSortable);
        return KbSortable;
    }(Directive));

    var KbSpinnerElement = /** @class */ (function (_super) {
        __extends(KbSpinnerElement, _super);
        function KbSpinnerElement() {
            var _this = _super.call(this) || this;
            _this.restrict = "E";
            _this.scope = {
                tracker: "=?",
                show: "=?",
                label: "=?"
            };
            _this.replace = true;
            _this.template = "<div ng-show='tracker.active() && show' class='kb-cube kb-fade'>" +
                "<div class='kb-cube__cloak'></div>" +
                "<div class='kb-cube__cube'>" +
                "<div class='kb-cube__face kb-cube__one'></div>" +
                "<div class='kb-cube__face kb-cube__two'></div>" +
                "<div class='kb-cube__face kb-cube__three'></div>" +
                "<div class='kb-cube__face kb-cube__four'></div>" +
                "<div class='kb-cube__face kb-cube__five'></div>" +
                "<div class='kb-cube__face kb-cube__six'></div>" +
                "</div>" +
                "<div class='kb-cube__label'>{{label}}</div>" +
                "</div>";
            _this.link = function (scope, element, atts) {
                // get the template
            };
            return _this;
        }
        KbSpinnerElement = __decorate([
            NgComponent({
                token: Token.KbSpinnerElement,
                dependencies: []
            })
        ], KbSpinnerElement);
        return KbSpinnerElement;
    }(Directive));

    var KbSpinner = /** @class */ (function (_super) {
        __extends(KbSpinner, _super);
        function KbSpinner($http, $compile, $rootScope) {
            var _this = _super.call(this) || this;
            _this.$http = $http;
            _this.$compile = $compile;
            _this.$rootScope = $rootScope;
            _this.restrict = "A";
            _this.scope = true;
            _this.link = function (scope, element, atts) {
                scope._tracker = scope.$eval(atts.kbSpinner);
                // get the template
                var template = "<div ng-show='_tracker.active()' class='kb-cube kb-fade'>" +
                    "<div class='kb-cube__cloak'></div>" +
                    "<div class='kb-cube__cube'>" +
                    "<div class='kb-cube__face kb-cube__one'></div>" +
                    "<div class='kb-cube__face kb-cube__two'></div>" +
                    "<div class='kb-cube__face kb-cube__three'></div>" +
                    "<div class='kb-cube__face kb-cube__four'></div>" +
                    "<div class='kb-cube__face kb-cube__five'></div>" +
                    "<div class='kb-cube__face kb-cube__six'></div>" +
                    "</div>" +
                    "</div>";
                var templateElement = $compile(template)(scope);
                element.append(templateElement);
            };
            return _this;
        }
        KbSpinner = __decorate([
            NgComponent({
                token: Token.KbSpinner,
                dependencies: [
                    Token.$Http,
                    Token.$Compile,
                    Token.$RootScope,
                ]
            })
        ], KbSpinner);
        return KbSpinner;
    }(Directive));

    var KbSrcOnError = /** @class */ (function (_super) {
        __extends(KbSrcOnError, _super);
        function KbSrcOnError() {
            var _this = _super.call(this) || this;
            _this.restrict = "A";
            _this.link = function (scope, element, atts, ctrl, $transclude) {
                element.on('error', function () {
                    element.attr('src', atts.kbSrcOnError);
                });
            };
            return _this;
        }
        KbSrcOnError = __decorate([
            NgComponent({
                token: Token.KbSrcOnError
            })
        ], KbSrcOnError);
        return KbSrcOnError;
    }(Directive));

    /**
     * Given markdown text in the ngModel, will display the html
     */
    var KbSvgViewer = /** @class */ (function (_super) {
        __extends(KbSvgViewer, _super);
        function KbSvgViewer($timeout) {
            var _this = _super.call(this) || this;
            _this.scope = {
                ngModel: "=",
                width: "=?",
                height: "=?",
                svgWidth: "=?",
                svgHeight: "=?",
                svgStyle: "=?",
                kbDragStart: "&",
                kbDragMove: "&",
                kbDragEnd: "&",
                kbClick: "&",
                defs: "=?",
                maxZoom: "=?",
                minZoom: "=?",
                disablePan: "=?",
                disableZoom: "=?",
                zoomLevel: "=?",
                panX: "=?",
                panY: "=?"
            };
            _this.restrict = "E";
            _this.template = Dirs.component("kb-svg-viewer", exports.eBundle.app);
            _this.replace = true;
            _this.require = "ngModel";
            _this.transclude = true;
            _this.link = function (scope, element, atts, ngModel) {
                scope.svg = { width: "0", height: "0" };
                if (!scope.svgStyle)
                    scope.svgStyle = "";
                if (!scope.minZoom)
                    scope.minZoom = 0.124;
                if (!scope.maxZoom)
                    scope.maxZoom = 4;
                if (!scope.zoomLevel)
                    scope.zoomLevel = 1;
                if (!scope.panX)
                    scope.panX = 0;
                if (!scope.panY)
                    scope.panY = 0;
                var tolerance = 10;
                var isDown = false;
                var dragged = false;
                var baseMouse;
                var svg = element.find("svg");
                var g = svg.find("g");
                var svgDims = {
                    width: 0,
                    height: 0,
                    scale: scope.zoomLevel,
                    scrollX: scope.panX,
                    scrollY: scope.panY
                };
                var svgWidthIsAuto = function () { return !scope.svgWidth || scope.svgWidth == "auto"; };
                var svgHeightIsAuto = function () { return !scope.svgHeight || scope.svgHeight == "auto"; };
                if (!svgWidthIsAuto()) {
                    svgDims.width = parseFloat(scope.svgWidth);
                }
                if (!svgHeightIsAuto()) {
                    svgDims.height = parseFloat(scope.svgHeight);
                }
                scope.$watch("zoomLevel", function (level) {
                    svgDims.scale = level;
                    svgDims.scale = Math.min(Math.max(scope.minZoom, svgDims.scale), scope.maxZoom);
                    updateSvg();
                });
                scope.$watch("panX", function (x) {
                    svgDims.scrollX = x;
                    svgDims.scrollX = Math.min(Math.max(-svg.outerWidth() * svgDims.scale, svgDims.scrollX), svg.outerWidth() * svgDims.scale);
                    updateSvg();
                });
                scope.$watch("panY", function (y) {
                    svgDims.scrollY = y;
                    svgDims.scrollY = Math.min(Math.max(-svg.outerHeight() * svgDims.scale, svgDims.scrollY), svg.outerHeight() * svgDims.scale);
                    updateSvg();
                });
                var getEvent = function (e) {
                    var svgWidth = svg.outerWidth();
                    var svgHeight = svg.outerHeight();
                    var modifierX = svgDims.width / svgWidth;
                    var modifierY = svgDims.height / svgHeight;
                    var event = {
                        offsetX: e.offsetX * modifierX + svgDims.scrollX * modifierX,
                        offsetY: e.offsetY * modifierY + svgDims.scrollY * modifierY,
                        target: e.target,
                        currentTarget: e.currentTarget
                    };
                    return event;
                };
                var updateSvg = function (recalculateSize) {
                    if (recalculateSize === void 0) { recalculateSize = true; }
                    if (recalculateSize) {
                        if (svgWidthIsAuto()) {
                            svgDims.width = 0;
                        }
                        else {
                            svgDims.width = (parseInt(scope.svgWidth));
                        }
                        if (svgHeightIsAuto()) {
                            svgDims.height = 0;
                        }
                        else {
                            svgDims.height = (parseInt(scope.svgHeight));
                        }
                        g.children().each(function () {
                            var thisEl = jQuery(this)[0];
                            if (thisEl.getBBox) {
                                var bbox = thisEl.getBBox();
                                var xPos = (bbox.x + bbox.width);
                                var yPos = (bbox.y + bbox.height);
                                if (svgWidthIsAuto()) {
                                    if (xPos > svgDims.width)
                                        svgDims.width = xPos;
                                }
                                if (svgHeightIsAuto()) {
                                    if (yPos > svgDims.height)
                                        svgDims.height = yPos;
                                }
                            }
                        });
                    }
                    scope.svg.width = svgDims.width * svgDims.scale;
                    scope.svg.height = svgDims.height * svgDims.scale;
                    var render = function () {
                        g.attr("transform", "scale(".concat(svgDims.scale, ", ").concat(svgDims.scale, ")"));
                        //element.scrollLeft(svgDims.scrollX);
                        //element.scrollTop(svgDims.scrollY);
                        var svgWidth = svg.outerWidth();
                        var svgHeight = svg.outerHeight();
                        var modifierX = svgDims.width / svgWidth;
                        var modifierY = svgDims.height / svgHeight;
                        var viewBoxX = (svgDims.scrollX * modifierX);
                        var viewBoxY = (svgDims.scrollY * modifierY);
                        if (!isNaN(viewBoxX) && !isNaN(viewBoxY)) {
                            svg.attr("viewBox", viewBoxX + " " + viewBoxY + " " + svgDims.width + " " + svgDims.height);
                        }
                    };
                    render();
                    if (recalculateSize) {
                        render();
                    }
                    $timeout(function () { return scope.$digest(); });
                };
                var onMousedown = function (e) {
                    isDown = true;
                    scope.kbDragStart({ $event: getEvent(e) });
                    baseMouse = {
                        x: e.screenX + svgDims.scrollX,
                        y: e.screenY + svgDims.scrollY
                    };
                };
                var onMouseup = function (e) {
                    scope.kbDragEnd({ $event: getEvent(e) });
                    if (!dragged) {
                        var inSvg = false;
                        var el = e.target;
                        while (el) {
                            if (el.tagName == "svg") {
                                inSvg = true;
                                break;
                            }
                            el = el.parentElement;
                        }
                        if (inSvg) {
                            scope.kbClick({ $event: getEvent(e) });
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                    else {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    isDown = dragged = false;
                };
                var onMousemove = function (e) {
                    if (isDown) {
                        scope.kbDragMove({ $event: getEvent(e) });
                        if (!scope.disablePan) {
                            scope.panX = svgDims.scrollX = (baseMouse.x - e.screenX);
                            scope.panY = svgDims.scrollY = (baseMouse.y - e.screenY);
                            updateSvg(false);
                        }
                        var diff = Math.sqrt(Math.abs(((baseMouse.x - e.screenX) ^ 2) + ((baseMouse.y - e.screenY) ^ 2)));
                        if (diff > tolerance)
                            dragged = true;
                    }
                };
                var onWheel = function (event) {
                    event.preventDefault();
                    if (scope.disableZoom)
                        return;
                    var difference = 1;
                    if (event.deltaY < 0) {
                        difference = 1.05;
                    }
                    else {
                        difference = 0.95;
                    }
                    var oldZoom = svgDims.scale;
                    svgDims.scale *= difference;
                    scope.zoomLevel = svgDims.scale;
                    svgDims.scale = Math.min(Math.max(scope.minZoom, svgDims.scale), scope.maxZoom);
                    var zoom = svgDims.scale;
                    var scalechange = zoom - oldZoom;
                    scope.panX = svgDims.scrollX = svgDims.scrollX + (event.offsetX * scalechange);
                    scope.panY = svgDims.scrollY = svgDims.scrollY + (event.offsetY * scalechange);
                    //window.console.log(svgDims.scrollX + ", " + svgDims.scrollY);
                    updateSvg(false);
                };
                ngModel.$render = function () {
                    var v = ngModel.$viewValue;
                    if (!v)
                        v = "";
                    v = v.replace(/url\((#[^\)]*)\)/g, "url(" + location.href + "$1)");
                    scope._html = v; // $v[0].innerHTML;// v? md.Transform(v): null;
                    setTimeout(updateSvg, 1);
                };
                element[0].addEventListener("pointerdown", onMousedown);
                document.addEventListener("pointerup", onMouseup);
                element[0].addEventListener("pointermove", onMousemove);
                element[0].addEventListener("wheel", onWheel);
                scope.$on("$destroy", function () {
                    element[0].removeEventListener("pointerdown", onMousedown);
                    document.removeEventListener("pointerup", onMouseup);
                    element[0].removeEventListener("pointermove", onMousemove);
                    element[0].removeEventListener("wheel", onWheel);
                });
            };
            return _this;
        }
        KbSvgViewer = __decorate([
            NgComponent({
                token: Token.KbSvgViewer,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbSvgViewer);
        return KbSvgViewer;
    }(Directive));

    var KbTab = /** @class */ (function (_super) {
        __extends(KbTab, _super);
        function KbTab() {
            var _this = _super.call(this) || this;
            _this.require = "^kbTabs";
            _this.replace = true;
            _this.template = Dirs.component("kb-tab");
            _this.restrict = "AE";
            _this.scope = {
                value: "=",
                label: "@",
                invalid: "=?",
                selected: "=?",
                visible: "=?",
                icon: "@",
                image: "@",
                imageWhenSelected: "@",
                sortIndex: "=?", // specify a sort value (weight) for each tab, otherwise they will be sorted in the order they are registered
                verticalStretch: "=?",
            };
            _this.transclude = true;
            _this.compile = function (element, atts) {
                if (atts.visible == null)
                    atts.visible = "true";
                return _this.link;
            };
            _this.link = function (scope, element, atts, tabsCtrl) {
                scope._getElement = function () {
                    return element;
                };
                scope._tabsScope = tabsCtrl.scope;
                tabsCtrl.registerTab(scope);
                scope.$watch("visible", function () { return tabsCtrl.tabVisibleChanged(scope); });
            };
            return _this;
        }
        KbTab = __decorate([
            NgComponent({
                token: Token.KbTab,
                dependencies: []
            })
        ], KbTab);
        return KbTab;
    }(Directive));

    /**
     * kbTabs
     *
     * kbTabs is utilized by having a parent kb-tabs element, and inside of it a kb-tab-pane (which are the headers)
     * and many kb-tab directives.  You can place the kb-tabs-pane and the kb-tabs wherever you like, as long as they
     * are inside the kb-tabs directive.  This gives a flexible approach which we can use in any situation.
     *
     * <kb-tabs>
     *     <kb-tab-pane></kb-tab-pane>
     *     <kb-tab name="tab1" label="Contacts"></kb-tab>
     *     <kb-tab name="tab2" label="Email"></kb-tab>
     * </kb-tabs>
     *
     * you can remotely control the selected tab by using a two-way binding with selectedTab scope property.  This
     * property is looking for the name of the tab.
     *
     */
    var KbTabs = /** @class */ (function (_super) {
        __extends(KbTabs, _super);
        function KbTabs($timeout, $window) {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-tabs");
            _this.restrict = "AE";
            _this.scope = {
                selectedTab: "=?",
                tabChanged: "&",
                tabWidth: "=?",
                customTabWidth: "=?",
                verticalStretch: "=?",
            };
            _this.transclude = true;
            // add scope defaults to the compile function
            _this.compile = function (element, atts) {
            };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                function ($scope, $element, $attrs, $transclude) {
                    // set the scope of the tree on it's controller so children can access it
                    this.scope = $scope;
                    var locked = false; //during tab animations we lock the user from switching tabs
                    var firstRun = true;
                    var scrollLeft = 0;
                    $scope._tabs = [];
                    var $container = $element.find(".kb-tabs__tab-container");
                    var $headers = $element.find(".kb-tabs__headers");
                    var $pane = $element.find(".kb-tabs__pane");
                    var $headersContainer = $element.find(".kb-tabs__headers-container");
                    var selectionLineEl = $element.find(".kb-tabs__selection-line")[0];
                    $scope._select = function (tab) {
                        $scope.selectedTab = tab.value;
                    };
                    $scope._headerClick = function (e, tab) {
                        if (!locked) {
                            $scope._select(tab);
                        }
                    };
                    var setSelectedTabScope = function (tab) {
                        var oldTab = $scope._selectedTabScope;
                        var newTab = tab;
                        $scope._selectedTabScope = tab;
                        if (oldTab !== newTab) {
                            firstRun ? $timeout(function () { return positionSelectionLine(tab); }, 0) : positionSelectionLine(tab);
                            scrollSelectedIntoView();
                            animateContent(oldTab, newTab);
                            if (!firstRun && $scope.tabChanged) { //for the first run, we are just selecting the first visible tab.  This should not count as a tabChanged event
                                firstRun = false;
                                $scope.tabChanged({ oldTab: oldTab ? oldTab.value : null, newTab: newTab ? newTab.value : null });
                            }
                            firstRun = false;
                        }
                    };
                    var positionSelectionLine = function (tab) {
                        var headerEl = $element.find("#".concat(tab.$id))[0];
                        if (headerEl) {
                            selectionLineEl.style.left = headerEl.offsetLeft + "px";
                            selectionLineEl.style.width = headerEl.offsetWidth + "px";
                        }
                    };
                    var animateContent = function (oldTab, newTab) {
                        locked = true;
                        var oldTabIndex = $scope._tabs.indexOf(oldTab);
                        var newTabIndex = $scope._tabs.indexOf(newTab);
                        var $oldTabEl = oldTab && oldTab._getElement();
                        var $newTabEl = newTab && newTab._getElement();
                        newTab && $newTabEl.css("transition", "none");
                        if (newTabIndex > oldTabIndex) {
                            //oldTab && $oldTabEl.css("transform", "translate3d(-100%,0,0)");
                            newTab && $newTabEl.css("transform", "translate3d(100%,0,0)");
                        }
                        else {
                            newTab && $newTabEl.css("transform", "translate3d(-100%,0,0)");
                        }
                        if (newTab)
                            newTab.selected = true;
                        setTimeout(function () {
                            //animate the height also.     
                            var currentHeight = oldTab && $oldTabEl.outerHeight();
                            newTab && $newTabEl.css("position", "relative");
                            // oldTab && $oldTabEl.css("position", "absolute");
                            // $container.height("auto");
                            var newHeight = newTab && $newTabEl.outerHeight(); // $container[0].offsetHeight;
                            newTab && $newTabEl.css("position", "absolute");
                            // oldTab && $oldTabEl.css("position", "relative");
                            $container.height(currentHeight);
                            if (newTabIndex > oldTabIndex) {
                                oldTab && $oldTabEl.css("transform", "translate3d(-100%,0,0)");
                            }
                            else {
                                oldTab && $oldTabEl.css("transform", "translate3d(100%,0,0)");
                            }
                            newTab && $newTabEl.css("transition", "");
                            newTab && $newTabEl.css("transform", "translate3d(0,0,0)");
                            $container.height(newHeight);
                            // $timeout(() => {
                            // }, 0);
                            $timeout(function () {
                                if (oldTab)
                                    oldTab.selected = false;
                                //on the first run the new tab element might not have existed until now, so we refresh the reference
                                $newTabEl = newTab && $element.find("#tab-".concat(newTab.$id));
                                newTab && $newTabEl.css("position", "relative");
                                oldTab && $oldTabEl.css("position", "absolute");
                                $container.height("auto");
                                locked = false;
                            }, 300);
                        }, 0);
                    };
                    // all child nodes register themselves with the tree to handle selection and accordion functionality
                    this.registerTab = function (tab) {
                        if (tab.sortIndex == null) {
                            tab.sortIndex = $scope._tabs.length;
                        }
                        $scope._tabs.push(tab);
                        $scope._tabs.sortBy(function (t) { return t.sortIndex; });
                        tab.$on("$destroy", function (event) {
                            $scope._tabs.remove(tab);
                            var selectedTab = $scope._tabs.find(function (t) { return t.selected; });
                            if (selectedTab) {
                                $scope._select(selectedTab);
                                $timeout(function () { return positionSelectionLine(selectedTab); }, 0);
                            }
                        });
                        updateSelectedTabScope();
                    };
                    this.tabVisibleChanged = function (tab) {
                        //if the selected tab isn't visible then select the first visible one
                        if (tab.selected && !tab.visible) {
                            $scope.selectedTab = null;
                            $timeout(function () {
                                updateSelectedTabScope();
                            });
                        }
                        else {
                            $timeout(function () {
                                if ($scope._selectedTabScope)
                                    positionSelectionLine($scope._selectedTabScope);
                            });
                        }
                    };
                    var updateSelectedTabScope = function () {
                        if (!$scope.selectedTab && $scope._tabs.some(function (t) { return t.visible; })) {
                            $scope.selectedTab = $scope._tabs.find(function (t) { return t.visible; }).value;
                        }
                        for (var _i = 0, _a = $scope._tabs; _i < _a.length; _i++) {
                            var tab = _a[_i];
                            if (tab.value === $scope.selectedTab) {
                                setSelectedTabScope(tab);
                                break;
                            }
                        }
                    };
                    // if the consumer changes the selected item, we update the selected node
                    $scope.$watch("selectedTab", function (newVal, oldVal) {
                        updateSelectedTabScope();
                    });
                    $scope.$watch("tabWidth", function () {
                        if ($scope._selectedTabScope)
                            $timeout(function () { return positionSelectionLine($scope._selectedTabScope); }, 300);
                    });
                    $scope.$watch("customTabWidth", function () {
                        if ($scope._selectedTabScope)
                            $timeout(function () { return positionSelectionLine($scope._selectedTabScope); }, 300);
                    });
                    var updatePagination = function () {
                        var containerWidth = $headersContainer.width();
                        var headersWidth = $headers.width();
                        var paneWidth = $pane.width();
                        $scope._paged = (headersWidth > paneWidth);
                        $scope._pageNextVisible = (headersWidth > containerWidth + scrollLeft);
                        $scope._pagePrevVisible = (scrollLeft > 0);
                    };
                    var scrollSelectedIntoView = function () {
                        var headerEl = $element.find("#".concat($scope._selectedTabScope.$id))[0];
                        if (headerEl) {
                            var elemLeft = headerEl.offsetLeft;
                            var elemRight = elemLeft + headerEl.offsetWidth;
                            var containerWidth = $headersContainer[0].clientWidth;
                            if (elemLeft - scrollLeft < 0) {
                                setScroll(elemLeft);
                            }
                            else if (elemRight > scrollLeft + containerWidth) {
                                setScroll(elemRight - containerWidth);
                            }
                        }
                    };
                    $scope._scrollNext = function () {
                        setScroll(scrollLeft + $headersContainer.width());
                    };
                    $scope._scrollPrev = function () {
                        setScroll(scrollLeft - $headersContainer.width());
                    };
                    var setScroll = function (val) {
                        scrollLeft = fixScroll(val);
                        $headers.css("transform", "translateX(".concat(-scrollLeft, "px)"));
                        updatePagination();
                    };
                    var scroll = function (e) {
                        if ($scope._paged) {
                            e.preventDefault();
                            setScroll(scrollLeft - e.wheelDelta);
                            $scope.$digest();
                        }
                    };
                    var fixScroll = function (value) {
                        if (!$scope._paged)
                            return 0;
                        if (value < 0)
                            return 0;
                        var headersWidth = $headers.width();
                        var containerWidth = $headersContainer.width();
                        if (value > headersWidth - containerWidth)
                            return headersWidth - containerWidth;
                        return value;
                    };
                    var windowResize = function (e) {
                        updatePagination();
                        setScroll(scrollLeft);
                        $scope.$digest();
                    };
                    $headersContainer[0].addEventListener("mousewheel", scroll);
                    $($window).on("resize", windowResize);
                    $timeout(function () {
                        updatePagination();
                    }, 0);
                    $scope.$on("$destroy", function () {
                        if ($headers && $headers.length)
                            $headers[0].removeEventListener("mousewheel", scroll);
                        $($window).off("resize", windowResize);
                    });
                }
            ];
            return _this;
        }
        KbTabs = __decorate([
            NgComponent({
                token: Token.KbTabs,
                dependencies: [
                    Token.$Timeout,
                    Token.$Window
                ]
            })
        ], KbTabs);
        return KbTabs;
    }(Directive));

    var KbTextbox = /** @class */ (function (_super) {
        __extends(KbTextbox, _super);
        function KbTextbox($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.scope = _tools.Utils.extend(_this.scope, {
                mask: "=?"
            });
            _this.template = Dirs.component("kb-textbox");
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                function ($scope, $element, $attrs) {
                    $scope._maskConfig = {
                        mask: function () {
                            switch ($scope.mask) {
                                case enums.eMaskType.phone:
                                    return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
                                case enums.eMaskType.zipCode:
                                    return [/\d/, /\d/, /\d/, /\d/, /\d/];
                                default:
                                    return false;
                            }
                        },
                        placeholderChar: '\u2000',
                        guide: true,
                        keepCharPositions: false,
                        showMask: false
                    };
                }
            ];
            _this.link = function (scope, element, atts, controllers) {
                _this.kbInputLinkFn(scope, element, atts, controllers);
                //need to fully blur field on ESC press
                element.on("keydown", function (e) {
                    if (e.key == 'Escape') {
                        element.find("input").trigger('blur');
                        element.find("textarea").trigger('blur');
                    }
                });
            };
            return _this;
        }
        KbTextbox = __decorate([
            NgComponent({
                token: Token.KbTextbox,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbTextbox);
        return KbTextbox;
    }(KbInput));

    var KbTextarea = /** @class */ (function (_super) {
        __extends(KbTextarea, _super);
        function KbTextarea($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.restrict = "E";
            _this.replace = true;
            _this.template = Dirs.component("kb-textarea");
            return _this;
        }
        KbTextarea = __decorate([
            NgComponent({
                token: Token.KbTextarea,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbTextarea);
        return KbTextarea;
    }(KbTextbox));

    var KbToggle = /** @class */ (function (_super) {
        __extends(KbToggle, _super);
        function KbToggle($timeout) {
            var _this = _super.call(this, $timeout) || this;
            _this.template = Dirs.component("kb-toggle");
            return _this;
        }
        KbToggle = __decorate([
            NgComponent({
                token: Token.KbToggle,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbToggle);
        return KbToggle;
    }(KbCheckbox));

    var KbTooltip = /** @class */ (function (_super) {
        __extends(KbTooltip, _super);
        function KbTooltip($timeout) {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.scope = {
                label: "=?",
                media: "=?",
                helpUrl: "=?",
                desc: "=?"
            };
            _this.replace = true;
            _this.transclude = true;
            _this.template = Dirs.component("kb-tooltip");
            _this.link = function (scope, element, atts) {
            };
            return _this;
        }
        KbTooltip = __decorate([
            NgComponent({
                token: Token.KbTooltip,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbTooltip);
        return KbTooltip;
    }(Directive));

    /**
     * kbTransclude
     *
     * This is an alternative to ngTransclude, which allows you to select which
     * scope the transcluded content in the directive should have.
     * This is usefule because the standard ngTransclude will always create
     * a child scope of the outer scope where the directive is used.
     * Which stops us from using ng-repeat type directives where the transcluded
     * content accesses something like an item property that is coming
     * from the ng-repeat inside the directive template.
     * See here for details: https://github.com/angular/angular.js/issues/7874#issuecomment-53450394
     * usage:
     *
     * <div kb-transclude="parent">
     * </div>
     */
    var KbTransclude = /** @class */ (function (_super) {
        __extends(KbTransclude, _super);
        function KbTransclude() {
            var _this = _super.call(this) || this;
            _this.restrict = "EAC";
            _this.link = function (scope, element, atts, ctrl, $transclude) {
                if (!$transclude) {
                    throw new Error("Illegal use of ngTransclude directive in the template! " +
                        "No parent directive that requires a transclusion found.");
                }
                var iScopeType = atts.kbTransclude || "outer";
                var slotName = atts.kbTranscludeSlot; //slot name for multi-slot transclusion
                var iChildScope;
                switch (iScopeType) {
                    // this is the default of angular 1.3+... 
                    // outer is the controller scope where the directive was originally called from
                    case "outer":
                        $transclude(function (clone) {
                            element.empty();
                            element.append(clone);
                        }, null, slotName);
                        break;
                    case "parent": // this will use the scope of the directive
                        $transclude(scope, function (clone) {
                            element.empty();
                            element.append(clone);
                        }, null, slotName);
                        break;
                    case "child": // this will create a new child scope of the directive scope
                        iChildScope = scope.$new();
                        $transclude(iChildScope, function (clone) {
                            element.empty();
                            element.append(clone);
                            element.on("$destroy", function () {
                                if (iChildScope) {
                                    iChildScope.$destroy();
                                }
                            });
                        }, null, slotName);
                        break;
                }
                scope.$on("$destroy", function () {
                    if (iChildScope) {
                        iChildScope.$destroy();
                    }
                });
            };
            return _this;
        }
        KbTransclude = __decorate([
            NgComponent({
                token: Token.KbTransclude,
                dependencies: []
            })
        ], KbTransclude);
        return KbTransclude;
    }(Directive));

    var KbTreeNode = /** @class */ (function (_super) {
        __extends(KbTreeNode, _super);
        function KbTreeNode($timeout) {
            var _this = _super.call(this) || this;
            _this.require = ["^kbTree", "^^?kbTreeNode", "kbTreeNode"];
            _this.replace = true;
            _this.template = Dirs.component("kb-tree-node");
            _this.restrict = "AE";
            _this.scope = {
                label: "@",
                selectable: "=?",
                expanded: "=?",
                item: "=?",
                image: "@",
                imageWhenSelected: "@",
                icon: "@",
                valid: "=?",
                checked: "=?",
                checkedChanged: "&",
                labelTemplate: "@",
                childTemplate: "@",
                hasChildren: "=?"
            };
            _this.transclude = true;
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                "$templateCache",
                Token.$Compile.key,
                function ($scope, $element, $attrs, $transclude, $templateCache, $compile) {
                    this.scope = $scope;
                    var timeouts = [];
                    $element.controller("kbTree");
                    // let loadAllNodes = false;
                    var childTemplateProcessed = false;
                    // if (treeController) loadAllNodes = treeController.scope.loadAllNodes;
                    $scope._children = [];
                    // $scope._childrenValid = true;
                    this.registerNode = function (node) {
                        $scope._children.push(node);
                        var off = node.$on("$destroy", function (event) {
                            $scope._children.remove(node);
                            off();
                        });
                    };
                    // $scope._calculateChildrenValid = () => {
                    //    for (var i = 0; i < $scope._children.length; i++) {
                    //        var node = $scope._children[i];
                    //        if (!node.valid || !node._childrenValid) {
                    //            $scope._childrenValid = false;
                    //            return;
                    //        }
                    //    }
                    //    $scope._childrenValid = true;
                    // };
                    $scope._getElement = function () {
                        return $element;
                    };
                    var $headerElem;
                    $scope._getHeaderElement = function () {
                        if (!$headerElem)
                            $headerElem = $element.find(">.kb-tree__header");
                        return $headerElem;
                    };
                    $scope._calculateIcon = function () {
                        if (!$scope.valid) {
                            $scope._icon = "error";
                            // } else if (!$scope._childrenValid) {
                            //    $scope._icon = "childError";
                        }
                        else if ($scope.icon) {
                            $scope._icon = $scope.icon;
                        }
                        else {
                            $scope._icon = null;
                        }
                    };
                    $scope._getAncestorNodes = function (includeThis) {
                        if (includeThis === void 0) { includeThis = true; }
                        var ancestorNodes = (includeThis ? [$scope] : []);
                        var parent = $scope;
                        do {
                            parent = parent._parentNode;
                            if (parent) {
                                ancestorNodes.push(parent);
                            }
                        } while (parent);
                        return ancestorNodes;
                    };
                    // if a label template was passed in then get it from the template cache
                    if ($scope.labelTemplate) {
                        var templateHtml = $templateCache.get($scope.labelTemplate);
                        if (!templateHtml) {
                            throw "Could not find template for " + $scope.labelTemplate;
                        }
                        var $template = angular__namespace.element(templateHtml);
                        // compile the template
                        var compiled = $compile($template, $transclude);
                        // append it to the label
                        $element.find(".kb-tree__label").empty().append($template);
                        // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                        compiled($scope.$parent);
                    }
                    var childScope;
                    var addChildTemplate = function () {
                        if (!childTemplateProcessed) {
                            // if a child template was provided, then use that instead of the transclusion content
                            if ($scope.childTemplate) {
                                var templateHtml = $templateCache.get($scope.childTemplate);
                                if (!templateHtml) {
                                    throw "Could not find template for " + $scope.childTemplate;
                                }
                                var $template = angular__namespace.element(templateHtml);
                                // compile the template
                                var compiled = $compile($template, $transclude);
                                // append it to the label
                                $element.find(".kb-tree__node-children").empty().append($template);
                                childScope = $scope.$parent.$new();
                                // now link it to the parent scope(we don't want this scope because it's an isolate scope)
                                compiled(childScope);
                            }
                            else { // no child template was provided so use the content of the directive
                                $transclude(function (clone, cloneScope) {
                                    childScope = cloneScope;
                                    $element.find(".kb-tree__node-children").empty().append(clone);
                                });
                            }
                            childTemplateProcessed = true;
                        }
                    };
                    // if (loadAllNodes) {
                    //     addChildTemplate();
                    // }
                    this.updateChildTemplate = function () {
                        // if (!loadAllNodes) {
                        if ($scope.expanded) {
                            addChildTemplate();
                        }
                        // }
                    };
                    $scope.$on("$destroy", function () {
                        timeouts.forEach(function (t) { return $timeout.cancel(t); });
                        if (childScope)
                            childScope.$destroy();
                    });
                }
            ];
            _this.compile = function (element, atts) {
                if (angular__namespace.isUndefined(atts.selectable)) {
                    atts.selectable = "true";
                }
                if (angular__namespace.isUndefined(atts.valid)) {
                    atts.valid = "true";
                }
                if (angular__namespace.isUndefined(atts.childrenValid)) {
                    atts.childrenValid = "true";
                }
                return _this.link;
            };
            _this.link = function (scope, element, atts, controllers) {
                var timeouts = [];
                var treeController = controllers[0];
                var parentController = controllers.length > 1 ? controllers[1] : null;
                var thisController = controllers[2];
                // get parent scopes to use for selection and expansion
                var treeScope = treeController.scope;
                scope._treeScope = treeScope;
                // register the node with the parent kbTree
                treeController.registerNode(scope);
                if (parentController) {
                    scope._parentNode = parentController.scope;
                    parentController.registerNode(scope);
                }
                // if no data item was given for the node, then we create one
                if (!scope.item) {
                    scope.item = { id: _tools.Utils.shortId() };
                }
                var updateExpanded = function () {
                    if (treeScope.expandable) ;
                    else {
                        scope.expanded = true;
                    }
                };
                scope.$watch("expanded", function (newValue, oldValue) {
                    // update the child template when expanded is changed... 
                    // this is what makes kbTree do virtual rendering of nodes to increase performance
                    thisController.updateChildTemplate();
                    treeController.refreshSelectionLine();
                });
                var select = function () {
                    // select the item if it's selectable
                    if (treeScope.selectable && scope.selectable) {
                        // set the selected item on the tree so it can be bound to by controllers
                        treeScope._selectedNode = scope;
                        treeScope.selectedItem = scope.item;
                    }
                };
                scope._arrowClick = function ($event) {
                    $event.stopPropagation();
                    scope.expanded = !scope.expanded;
                    updateExpanded();
                };
                scope._nodeClick = function ($event) {
                    // $event.stopPropagation();
                    // toggle expanded
                    if (treeScope.accordion) {
                        // only collapse when this node is already selected
                        if (treeScope._selectedNode == scope && scope.expanded) {
                            scope.expanded = false;
                        }
                        else {
                            scope.expanded = true;
                        }
                        updateExpanded();
                    }
                    select();
                };
                scope._checkedChanged = function (item) {
                    $timeout(function () {
                        scope.checkedChanged({ item: item });
                    }, 0);
                };
                // calculate the levels which is used for margins
                scope._level = function () {
                    return scope._getAncestorNodes().length - 1;
                };
                updateExpanded();
                // watch for changes in validity to recalculate the icon
                scope.$watch("valid", function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // if (parentController) parentController.scope._calculateChildrenValid();
                        scope._calculateIcon();
                    }
                });
                // watch for changes to the icon provided by the consumer to recalculate
                scope.$watch("icon", function (newValue, oldValue) {
                    scope._calculateIcon();
                });
                // scope.$watch("_childrenValid", (newValue, oldValue) => {
                //    if (newValue !== oldValue) {
                //        if (parentController) parentController.scope._calculateChildrenValid();
                //        scope._calculateIcon();
                //    }
                // });
                if (treeScope.dragDrop) {
                    var el_1 = element[0];
                    var getDropPosition_1 = function (e, allow) {
                        var elementPosition = element.offset();
                        var elementHeight = element.find(">.kb-tree__header").outerHeight(true);
                        var mouseRelativeToElementY = e.clientY - elementPosition.top;
                        var dropPosition;
                        if (allow == "any") {
                            if (mouseRelativeToElementY < (elementHeight / 4)) {
                                dropPosition = "above";
                            }
                            else if (mouseRelativeToElementY > (elementHeight * .75)) {
                                dropPosition = "below";
                            }
                            else {
                                dropPosition = "in";
                            }
                        }
                        else if (allow == "sibling") {
                            if (mouseRelativeToElementY < (elementHeight / 2)) {
                                dropPosition = "above";
                            }
                            else {
                                dropPosition = "below";
                            }
                        }
                        else if (allow == "child") {
                            dropPosition = "in";
                        }
                        return dropPosition;
                    };
                    el_1.ondragstart = function (e) {
                        treeScope._dragNode = scope;
                        e.dataTransfer.effectAllowed = "move";
                        e.dataTransfer.setData("text/plain", "node");
                        e.stopPropagation();
                        timeouts.push($timeout(function () {
                            select();
                        }));
                    };
                    el_1.ondragover = function (e) {
                        var allow;
                        if (treeScope.allowDrop()) {
                            allow = treeScope.allowDrop()(scope.item, treeScope._dragNode.item);
                        }
                        if (allow === "any" || allow === "child" || allow == "sibling") {
                            // tell the drag drop system the drop is ok by preventingDefault
                            e.preventDefault();
                        }
                        else {
                            e.dataTransfer.dropEffect = "none";
                        }
                        var dropPosition = getDropPosition_1(e, allow);
                        element.toggleClass("kb-tree--dropping-child", ((allow == "child" || allow == "any") && dropPosition == "in"));
                        element.toggleClass("kb-tree--dropping-sibling-below", ((allow == "sibling" || allow == "any") && dropPosition == "below"));
                        element.toggleClass("kb-tree--dropping-sibling-above", ((allow == "sibling" || allow == "any") && dropPosition == "above"));
                        // e.dataTransfer.setData("text", dropPosition);
                        e.stopPropagation();
                        treeController.setCurrentDragTarget(e.currentTarget);
                    };
                    // el.ondragenter = e => {
                    //     console.log({ event: "dragenter", el: e.currentTarget });
                    // };
                    // el.ondragleave = e => {
                    //     if (e.currentTarget === currentDragTarget) {
                    //         removeDropClasses();
                    //         e.stopPropagation();
                    //         console.log({ event: "dragleave", el: e.currentTarget });
                    //     }                    
                    // };
                    el_1.ondrop = function (e) {
                        if (e.preventDefault)
                            e.preventDefault();
                        if (e.stopPropagation)
                            e.stopPropagation();
                        treeController.removeDropClasses(element);
                        timeouts.push($timeout(function () {
                            if (treeScope._dragNode) {
                                var target = scope.item;
                                var source = treeScope._dragNode.item;
                                if (target != source) {
                                    var allow = treeScope.allowDrop()(target, source);
                                    var dropPosition = getDropPosition_1(e, allow);
                                    var targetParent = scope._parentNode ? scope._parentNode.item : undefined;
                                    var sourceParent = treeScope._dragNode._parentNode ?
                                        treeScope._dragNode._parentNode.item
                                        : undefined;
                                    treeScope.dropped()(target, source, targetParent, sourceParent, dropPosition);
                                    treeScope._dragNode = undefined;
                                    // if we just dropped in this node, then expand it
                                    if (dropPosition == "in") {
                                        scope.expanded = true;
                                        updateExpanded();
                                    }
                                }
                            }
                        }));
                    };
                    el_1.ondragend = function (e) {
                        timeouts.push($timeout(function () {
                            treeScope._dragNode = undefined;
                            treeController.setCurrentDragTarget(null);
                        }));
                    };
                    scope.$on("$destroy", function () {
                        el_1.ondragstart = null;
                        el_1.ondragover = null;
                        el_1.ondragleave = null;
                        el_1.ondrop = null;
                        el_1.ondragend = null;
                        scope._parentNode = null;
                        treeController = null;
                        treeScope = null;
                        timeouts.forEach(function (t) { return $timeout.cancel(t); });
                    });
                }
            };
            return _this;
        }
        KbTreeNode = __decorate([
            NgComponent({
                token: Token.KbTreeNode,
                dependencies: [
                    Token.$Timeout
                ]
            })
        ], KbTreeNode);
        return KbTreeNode;
    }(Directive));

    /**
     * KbTree
     *
     * kbTree can be used in several different ways.
     * If you have a hierarchy of like objects that infinitely nest, you can use it like so:
     *
     *   <script type="text/ng-template" id="cat-child-template">
     *     <kb-tree-node ng-repeat="cat in cat.items"
     *                 item="cat"
     *                 child-template="cat-child-template">
     *     </kb-tree-node>
     * </script>
     *
     * <kb-tree>
     *     <kb-tree-node ng-repeat="cat in categories"
     *                     item="cat"
     *                     child-template="cat-child-template">
     *     </kb-tree-node>
     * </kb-tree>
     *
     * in this case you are providing a child template to the tree-node directive,
     * which refers to itself.  In this way we achieve
     * infinite nesting.
     *
     * If you do NOT need infinite nesting, then you can just add tree-nodes as content
     * of other tree-nodes, while NOT providing
     * a child template.  Like so:
     *
     * <<kb-tree>
     *     <kb-tree-node ng-repeat="page in pages" item="page">
     *         <kb-tree-node ng-repeat="group in page.groups">
     *         </kb-tree-node>
     *     </kb-tree-node>
     * </kb-tree>
     *
     */
    var KbTree = /** @class */ (function (_super) {
        __extends(KbTree, _super);
        function KbTree() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.template = Dirs.component("kb-tree");
            _this.restrict = "AE";
            _this.scope = {
                selectedItem: "=?",
                accordion: "=?",
                skin: "@",
                selectable: "=?",
                expandable: "=?",
                dragDrop: "=?",
                allowDrop: "&?",
                dropped: "&?",
                animation: "@",
                // loadAllNodes: "=?",
                horizontal: "=?",
                selectionStyle: "=?",
                selectionClass: "=?",
                selectionLineColor: "=?",
                tabWidth: "=?"
                // control: "=?"
            };
            _this.transclude = true;
            // add scope defaults to the compile function
            _this.compile = function (element, atts) {
                if (!angular__namespace.isDefined(atts.selectable))
                    atts.selectable = "true";
                if (!angular__namespace.isDefined(atts.expandable))
                    atts.expandable = "true";
                if (!angular__namespace.isDefined(atts.selectionStyle))
                    atts.selectionStyle = "'background'";
                if (!angular__namespace.isDefined(atts.selectionLineColor))
                    atts.selectionLineColor = "'accent'";
                if (!angular__namespace.isDefined(atts.tabWidth))
                    atts.tabWidth = "'auto'";
            };
            _this.controller = [
                "$scope",
                "$element",
                "$attrs",
                "$transclude",
                function ($scope, $element, $attrs, $transclude) {
                    var _this = this;
                    // set the scope of the tree on it's controller so children can access it
                    this.scope = $scope;
                    $scope._nodes = [];
                    // $scope.control = $scope.control || {};
                    // $scope.control.expandToNode = (item) => {
                    //    $scope._nodes.forEach(n => setChildrenValid(n));
                    // };
                    // all child nodes register themselves with the tree to handle selection and accordion functionality
                    this.registerNode = function (node) {
                        $scope._nodes.push(node);
                        var off = node.$on("$destroy", function (event) {
                            $scope._nodes.remove(node);
                            off();
                        });
                    };
                    this.setCurrentDragTarget = function (el) {
                        if (el !== $scope._currentDragTarget && $scope._currentDragTarget) {
                            _this.removeDropClasses($($scope._currentDragTarget));
                            console.log({ event: "currentDragChanged", el: el });
                        }
                        $scope._currentDragTarget = el;
                    };
                    this.removeDropClasses = function ($target) {
                        $target.removeClass("kb-tree--dropping-child");
                        $target.removeClass("kb-tree--dropping-sibling-below");
                        $target.removeClass("kb-tree--dropping-sibling-above");
                    };
                    var updateSelectedNode = function () {
                        for (var _i = 0, _a = $scope._nodes; _i < _a.length; _i++) {
                            var node = _a[_i];
                            if (node.item === $scope.selectedItem) {
                                $scope._selectedNode;
                                $scope._selectedNode = node;
                                scrollToSelectedNode();
                                refreshSelectionLine();
                                // expand all parent nodes when a node is selected
                                node._getAncestorNodes(false).forEach(function (n) { return n.expanded = true; });
                                break;
                            }
                        }
                    };
                    // if the consumer changes the selected item, we update the selected node
                    $scope.$watch("selectedItem", function () {
                        updateSelectedNode();
                    });
                    // nodes might be added after the selectedItem is set by the consumer, so
                    // we need to refind the selected node when the nodes collection changes
                    $scope.$watchCollection("_nodes", function () {
                        if (!$scope._selectedNode) {
                            updateSelectedNode();
                        }
                    });
                    $scope.$watch("expandable", function () {
                        if (!$scope.expandable) {
                            $scope._nodes.forEach(function (n) { return expandNodeAndChildren(n); });
                            refreshSelectionLine();
                        }
                    });
                    $scope.$watch("horizontal", function () {
                        setTimeout(function () { return refreshSelectionLine(); }, 0);
                    });
                    $scope.$watch("selectionStyle", function () {
                        setTimeout(function () { return refreshSelectionLine(); }, 0);
                    });
                    $scope.$watch("tabWidth", function () {
                        setTimeout(function () { return refreshSelectionLine(); }, 0);
                    });
                    var expandNodeAndChildren = function (node) {
                        node.expanded = true;
                        node._children.forEach(function (child) { return expandNodeAndChildren(child); });
                    };
                    var scrollToSelectedNode = function () {
                        setTimeout(function () {
                            if ($scope._selectedNode) {
                                var $node = $scope._selectedNode._getHeaderElement();
                                if ($node && $node.length) {
                                    _tools.Utils.scrollIntoView({ elem: $node[0], mode: _tools.eScrollMode.nearest, animate: true, horizontal: $scope.horizontal });
                                }
                            }
                        }, 0);
                    };
                    var $selectionLine;
                    var refreshSelectionLine = this.refreshSelectionLine = function () {
                        if ($scope._selectedNode && $scope.selectionStyle && $scope.selectionStyle.isEqual("line")) {
                            if (!$selectionLine || !$selectionLine.length) {
                                $selectionLine = $('<div/>', {
                                    class: "kb-tree__selection-line",
                                    appendTo: $element
                                });
                            }
                            var $node = $scope._selectedNode._getElement();
                            var nodeEl = $node.find(".kb-tree__header").first()[0];
                            if ($scope.horizontal) {
                                $selectionLine.css({ left: nodeEl.offsetLeft, width: nodeEl.offsetWidth, bottom: 0, height: "2px", top: "auto" });
                            }
                            else {
                                $selectionLine.css({ top: nodeEl.offsetTop, height: nodeEl.offsetHeight, left: 0, width: "2px", bottom: "auto" });
                            }
                        }
                        else {
                            if ($selectionLine)
                                $selectionLine.remove();
                            $selectionLine = null;
                        }
                    };
                }
            ];
            return _this;
        }
        KbTree = __decorate([
            NgComponent({
                token: Token.KbTree,
                dependencies: []
            })
        ], KbTree);
        return KbTree;
    }(Directive));

    var KbUiObject = /** @class */ (function (_super) {
        __extends(KbUiObject, _super);
        function KbUiObject() {
            var _this = _super.call(this) || this;
            _this.replace = true;
            _this.restrict = "E";
            _this.scope = false;
            _this.template = Dirs.component("kb-ui-object");
            return _this;
        }
        KbUiObject = __decorate([
            NgComponent({
                token: Token.KbUiObject,
            })
        ], KbUiObject);
        return KbUiObject;
    }(Directive));

    var KbUpload = /** @class */ (function (_super) {
        __extends(KbUpload, _super);
        function KbUpload($timeout, uploadService, dialogService, storageService) {
            var _this = _super.call(this, $timeout) || this;
            _this.restrict = "EA";
            _this.scope = _tools.Utils.extend(_this.scope, {
                upload: "&",
                cleared: "&",
                accept: "@"
            });
            _this.template = Dirs.component("kb-upload");
            _this.link = function (scope, element, atts) {
                scope._fileName = function () {
                    if (atts.guid && scope.ngModel && scope.ngModel.path) {
                        return scope.ngModel.path.substr(scope.ngModel.path.indexOf("_") + 1);
                    }
                    else {
                        return scope.ngModel.path;
                    }
                };
                scope._clear = function () {
                    dialogService.confirm("Are you sure you want to remove this upload?", function () {
                        scope.ngModel.path = null;
                        scope.ngModel.assetId = null;
                        scope._thumbnailDataUrl = "";
                        scope.ngChange();
                        scope.cleared();
                    });
                };
                scope._btnClick = function () {
                    uploadService.promptUserToChooseFile(scope.accept).then(function (file) {
                        if (!scope.ngModel)
                            scope.ngModel = { path: null, assetId: null };
                        scope.ngModel.path = file.name;
                        scope.upload({ file: file }).then(function () {
                            // only trigger valuechange when upload is done so the rules have
                            // the file(especially important for images being uploaded to the scene)
                            scope.ngChange();
                        });
                        // show a thumbnail of the image
                        if (file.type.match("image.*")) {
                            scope._thumbnailDataUrl = storageService.getAssetUrl("images/spinning_circle.gif");
                            var reader_1 = new FileReader();
                            reader_1.onloadend = function () {
                                scope._thumbnailDataUrl = reader_1.result;
                                reader_1.onloadend = null;
                            };
                            reader_1.readAsDataURL(file);
                        }
                        else {
                            scope._thumbnailDataUrl = null;
                        }
                    });
                };
            };
            return _this;
        }
        KbUpload = __decorate([
            NgComponent({
                token: Token.KbUpload,
                dependencies: [
                    Token.$Timeout,
                    Token.UploadService,
                    Token.DialogService,
                    Token.StorageService
                ]
            })
        ], KbUpload);
        return KbUpload;
    }(KbInput));

    /**
     * For showing validation messages of a configurator
     */
    var KbValidationMessages = /** @class */ (function (_super) {
        __extends(KbValidationMessages, _super);
        function KbValidationMessages() {
            var _this = _super.call(this) || this;
            _this.restrict = "EA";
            _this.template = Dirs.component("kb-validation-messages", exports.eBundle.app);
            _this.scope = {
                ngModel: "=?",
                messageClicked: "&",
                hideAutoValidation: "=?",
                autoValidation: "=?"
            };
            _this.replace = true;
            _this.link = function (scope, element, atts) {
                scope._toggleAutoValidation = function () {
                    scope.autoValidation = !scope.autoValidation;
                };
                scope._getTitle = function () {
                    var title = "";
                    if (!scope.ngModel || scope.ngModel.length == 0) {
                        title = loc.noerrors;
                    }
                    else {
                        var errors = scope.ngModel.filter(function (m) { return m.messageType == enums.eValidationType.error; });
                        var warnings = scope.ngModel.filter(function (m) { return m.messageType == enums.eValidationType.warning; });
                        if (errors.length) {
                            title += errors.length + " " + (errors.length > 1 ? loc.errors : loc.error);
                        }
                        if (errors.length && warnings.length) {
                            title += " / ";
                        }
                        if (warnings.length) {
                            title += warnings.length + " " + (warnings.length > 1 ? loc.warnings : loc.warning);
                        }
                    }
                    return title;
                };
            };
            return _this;
        }
        KbValidationMessages = __decorate([
            NgComponent({
                token: Token.KbValidationMessages
            })
        ], KbValidationMessages);
        return KbValidationMessages;
    }(Directive));

    var AssetFilter = /** @class */ (function () {
        function AssetFilter(storageService) {
            return (function (relativePath) {
                return storageService.getAssetUrl(relativePath);
            });
        }
        AssetFilter = __decorate([
            NgFilter({
                token: Token.AssetFilter,
                dependencies: [
                    Token.StorageService
                ]
            })
        ], AssetFilter);
        return AssetFilter;
    }());

    var BytesFilter = /** @class */ (function () {
        function BytesFilter() {
            return (function (bytes, precision) {
                if (isNaN(parseFloat(bytes)) || !isFinite(bytes))
                    return "-";
                if (bytes == 0)
                    return "0 KB";
                var units = ["bytes", "KB", "MB", "GB", "TB", "PB"];
                var n = Math.floor(Math.log(bytes) / Math.log(1024));
                if (typeof precision === "undefined")
                    precision = (n ? 1 : 0);
                return (bytes / Math.pow(1024, Math.floor(n))).toFixed(precision) + " " + units[n];
            });
        }
        BytesFilter = __decorate([
            NgFilter({
                token: Token.BytesFilter,
                dependencies: []
            })
        ], BytesFilter);
        return BytesFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "enum"): IEnumFilter;
    //     }
    // }
    /**
     * takes an enum type name and returns an array of name/value pairs
     * that have the localization representing the enum value as the name
     * and the value as the string value for the enum
     */
    var EnumFilter = /** @class */ (function () {
        function EnumFilter(kbService) {
            return (function (enumName, localize) {
                if (localize === void 0) { localize = true; }
                var enumType = enums__namespace[enumName];
                var results = [];
                for (var i in enumType) {
                    var locTitle = enumType[i];
                    var locDesc = null;
                    if (localize) {
                        // get the localized value for the enum value.  This is convention based
                        var resxName = enumName + "_" + enumType[i] + "_title";
                        locTitle = kbService.loc(resxName);
                        // if we still have the resx name, then try to see if there is already a matching word
                        if (locTitle.isEqual(resxName)) {
                            var low = enumType[i].toLowerCase();
                            if (loc.hasOwnProperty(low)) {
                                locTitle = kbService.loc(low);
                            }
                        }
                        resxName = enumName + "_" + enumType[i] + "_desc";
                        locDesc = kbService.loc(resxName);
                    }
                    results.push({ name: locTitle, value: enumType[i], desc: locDesc });
                }
                return results;
            });
        }
        EnumFilter = __decorate([
            NgFilter({
                token: Token.EnumFilter,
                dependencies: [
                    Token.KbService
                ]
            })
        ], EnumFilter);
        return EnumFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "fileIcon"): IFileIconFilter;
    //     }
    // }
    var FileIconFilter = /** @class */ (function () {
        function FileIconFilter($filter, storageService) {
            this.$filter = $filter;
            this.storageService = storageService;
            return (function (filepath, root) {
                if (root === void 0) { root = "media"; }
                var ext = filepath && filepath.substr(filepath.lastIndexOf("."));
                if (ext)
                    ext = ext.toLowerCase();
                var imageName = "";
                switch (ext) {
                    case ".docx":
                    case ".doc":
                        imageName = "docx.png";
                        break;
                    case ".xlsx":
                    case ".xls":
                        imageName = "xlsx.png";
                        break;
                    case ".txt":
                        imageName = "txt.png";
                        break;
                    case ".xml":
                        imageName = "xml.png";
                        break;
                    case ".pdf":
                        imageName = "pdf.png";
                        break;
                    case ".sldasm":
                        imageName = "sldasm.png";
                        break;
                    case ".sldprt":
                        imageName = "sldprt.png";
                        break;
                    case ".slddrw":
                        imageName = "slddrw.png";
                        break;
                    case ".iam":
                        imageName = "default.png";
                        break;
                    case ".ipt":
                        imageName = "default.png";
                        break;
                    case ".idw":
                        imageName = "default.png";
                        break;
                    case ".dwg":
                        imageName = "dwg.png";
                        break;
                    case ".dxf":
                        imageName = "dxf.png";
                        break;
                    case ".webm":
                    case ".ogv":
                    case ".mp4":
                    case ".3gp":
                    case ".avi":
                        imageName = "video.png";
                        break;
                    case ".png":
                    case ".gif":
                    case ".jpg":
                    case ".bmp":
                        if (root == "media") {
                            return $filter("thumb")(filepath);
                        }
                        else {
                            imageName = "image.png";
                            break;
                        }
                    case ".zip":
                        imageName = "zip.png";
                        break;
                    default:
                        imageName = "default.png";
                        break;
                }
                return storageService.getAssetUrl("images/file_icons/" + imageName);
            });
        }
        FileIconFilter = __decorate([
            NgFilter({
                token: Token.FileIconFilter,
                dependencies: [
                    Token.$Filter,
                    Token.StorageService
                ]
            })
        ], FileIconFilter);
        return FileIconFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "fileId"): IFileIdFilter;
    //     }
    // }
    /**
     * Takes file name and strips non alpha-numeric characters out to make it compatible with
     * HTML ids, for instance.
     */
    var FileIdFilter = /** @class */ (function () {
        function FileIdFilter() {
            return (function (fileName) {
                return fileName.replace(/[^A-Z0-9]/gi, "_");
            });
        }
        FileIdFilter = __decorate([
            NgFilter({
                token: Token.FileIdFilter,
                dependencies: []
            })
        ], FileIdFilter);
        return FileIdFilter;
    }());

    var FxConvertFilter = /** @class */ (function () {
        function FxConvertFilter($filter, kbService) {
            return (function (value, currencyCode, precision) {
                if (value == null)
                    return "";
                var formattedValue = value.toString();
                if (currencyCode) {
                    var convertedValue = kbService.fxConvert(value, currencyCode.toUpperCase());
                    formattedValue = $filter("kbCurrency")(convertedValue, currencyCode.toUpperCase(), precision);
                }
                return formattedValue;
            });
        }
        FxConvertFilter = __decorate([
            NgFilter({
                token: Token.FxConvertFilter,
                dependencies: [
                    Token.$Filter,
                    Token.KbService,
                ]
            })
        ], FxConvertFilter);
        return FxConvertFilter;
    }());

    var GetFileExtensionFilter = /** @class */ (function () {
        function GetFileExtensionFilter() {
            return (function (path) {
                var filename = path.substring(path.lastIndexOf("/") + 1);
                return filename.substring(path.lastIndexOf(".") + 1);
            });
        }
        GetFileExtensionFilter = __decorate([
            NgFilter({
                token: Token.GetFileExtensionFilter,
                dependencies: []
            })
        ], GetFileExtensionFilter);
        return GetFileExtensionFilter;
    }());

    var GetFilenameFilter = /** @class */ (function () {
        function GetFilenameFilter() {
            return (function (path) {
                var filename = path.substring(path.lastIndexOf("/") + 1);
                return filename;
            });
        }
        GetFilenameFilter = __decorate([
            NgFilter({
                token: Token.GetFilenameFilter,
                dependencies: []
            })
        ], GetFilenameFilter);
        return GetFilenameFilter;
    }());

    var HasRoleFilter = /** @class */ (function () {
        function HasRoleFilter(authService) {
            var _this = this;
            this.authService = authService;
            return (function (role) {
                return _this.authService.hasRole(role);
            });
        }
        HasRoleFilter = __decorate([
            NgFilter({
                token: Token.HasRoleFilter,
                dependencies: [
                    Token.AuthService
                ]
            })
        ], HasRoleFilter);
        return HasRoleFilter;
    }());

    var IconFilter = /** @class */ (function () {
        function IconFilter($sce) {
            var _this = this;
            this.$sce = $sce;
            return (function (key) {
                if (key)
                    key = key.toCamelCase();
                var icon = _tools.icons[key];
                if (!icon) {
                    icon = _tools.svgIcons[key];
                    if (icon) {
                        return _this.$sce.trustAsHtml(icon);
                    }
                }
                if (!icon) {
                    icon = key;
                }
                return icon;
            });
        }
        IconFilter = __decorate([
            NgFilter({
                token: Token.IconFilter,
                dependencies: [
                    Token.$Sce
                ]
            })
        ], IconFilter);
        return IconFilter;
    }());

    var IsAdminOrCompanyAdminFilter = /** @class */ (function () {
        function IsAdminOrCompanyAdminFilter(authService) {
            var _this = this;
            this.authService = authService;
            return (function (user) {
                return _this.authService.isAdminOrCompanyAdmin();
            });
        }
        IsAdminOrCompanyAdminFilter = __decorate([
            NgFilter({
                token: Token.IsAdminOrCompanyAdminFilter,
                dependencies: [
                    Token.AuthService
                ]
            })
        ], IsAdminOrCompanyAdminFilter);
        return IsAdminOrCompanyAdminFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "kbCurrency"): IKbCurrencyFilter;
    //     }
    // }
    var KbCurrencyFilter = /** @class */ (function () {
        function KbCurrencyFilter($filter, $rootScope, $locale) {
            return (function (value, currencyCode, precision) {
                // if no iso given, then assume it's the company base currency
                // in future, should be the currency of the active quote
                if (!currencyCode) {
                    // if ($rootScope.quote) {
                    //    currencyCode = $rootScope.quote.currency;
                    // }
                    // else {
                    currencyCode = $rootScope.companySettings.currency;
                    // }
                }
                currencyCode = currencyCode.toUpperCase();
                var symbol = _tools.currencies[currencyCode] || "";
                var formatted = $filter("currency")(Number(value), undefined, precision);
                var localSymbol = $locale.NUMBER_FORMATS.CURRENCY_SYM;
                // replace local symbol in formatted with the real symbol
                formatted = formatted.replace(localSymbol, symbol);
                // add the iso code at the end
                formatted = formatted + " " + currencyCode;
                return formatted;
            });
        }
        KbCurrencyFilter = __decorate([
            NgFilter({
                token: Token.KbCurrencyFilter,
                dependencies: [
                    Token.$Filter,
                    Token.$RootScope,
                    Token.$Locale,
                ]
            })
        ], KbCurrencyFilter);
        return KbCurrencyFilter;
    }());

    var KbDateTimeFilter = /** @class */ (function () {
        function KbDateTimeFilter() {
            return (function (d) {
                return d.getFullYear().toString() + "/" +
                    (d.getMonth() + 1).toString() + "/" +
                    d.getDate().toString() + " " +
                    d.getHours() + ":" +
                    d.getMinutes();
            });
        }
        KbDateTimeFilter = __decorate([
            NgFilter({
                token: Token.KbDateTimeFilter,
                dependencies: []
            })
        ], KbDateTimeFilter);
        return KbDateTimeFilter;
    }());

    var KbDateFilter = /** @class */ (function () {
        function KbDateFilter() {
            return (function (d) {
                return d.getFullYear().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getDate().toString();
            });
        }
        KbDateFilter = __decorate([
            NgFilter({
                token: Token.KbDateFilter,
                dependencies: []
            })
        ], KbDateFilter);
        return KbDateFilter;
    }());

    /**
     * converts a number of days to a human readable format:  like '10 days', '7.5 weeks', '3 months'
     */
    var LeadTimeFilter = /** @class */ (function () {
        function LeadTimeFilter() {
            return (function (days, singular) {
                if (singular === void 0) { singular = false; }
                if (days < 14) {
                    return days + " " + (singular ? loc.day : loc.days);
                }
                else if (days < 90) {
                    return (days / 7).rounder(1).toString() + " " + (singular ? loc.week : loc.weeks);
                }
                else {
                    return (days / 30.42).rounder(1).toString() + " " + (singular ? loc.month : loc.months);
                }
            });
        }
        LeadTimeFilter = __decorate([
            NgFilter({
                token: Token.LeadTimeFilter,
                dependencies: []
            })
        ], LeadTimeFilter);
        return LeadTimeFilter;
    }());

    var LocFilter = /** @class */ (function () {
        function LocFilter() {
            return (function (key) {
                var replacements = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    replacements[_i - 1] = arguments[_i];
                }
                if (key) {
                    // replacements = [replacement1, replacement2];
                    var lkey = key.toLowerCase();
                    var localizedString = loc[lkey];
                    if (localizedString) {
                        var result = localizedString.format.apply(localizedString, replacements);
                        return result;
                    }
                }
                return key;
            });
        }
        LocFilter = __decorate([
            NgFilter({
                token: Token.LocFilter,
                dependencies: []
            })
        ], LocFilter);
        return LocFilter;
    }());

    var LogIconFilter = /** @class */ (function () {
        function LogIconFilter() {
            return (function (type) {
                switch (type) {
                    case enums.eLogType.error:
                        return _tools.icons.error;
                    case enums.eLogType.info:
                        return _tools.icons.info;
                    default:
                        return _tools.icons.success;
                }
            });
        }
        LogIconFilter = __decorate([
            NgFilter({
                token: Token.LogIconFilter,
                dependencies: []
            })
        ], LogIconFilter);
        return LogIconFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "media"): IMediaFilter;
    //     }
    // }
    var MediaFilter = /** @class */ (function () {
        function MediaFilter(storageService) {
            return (function (mediaPath) {
                if (!mediaPath) {
                    return storageService.getFallbackImage();
                }
                else {
                    return storageService.getMediaUrl(mediaPath);
                }
            });
        }
        MediaFilter = __decorate([
            NgFilter({
                token: Token.MediaFilter,
                dependencies: [
                    Token.StorageService
                ]
            })
        ], MediaFilter);
        return MediaFilter;
    }());

    var NotificationIconFilter = /** @class */ (function () {
        function NotificationIconFilter() {
            return (function (type) {
                switch (type) {
                    case enums.eNotificationType.quoteApproved:
                        return _tools.icons.approve;
                    case enums.eNotificationType.quoteRejected:
                        return _tools.icons.reject;
                    default:
                        return _tools.icons.user;
                }
            });
        }
        NotificationIconFilter = __decorate([
            NgFilter({
                token: Token.NotificationIconFilter,
                dependencies: []
            })
        ], NotificationIconFilter);
        return NotificationIconFilter;
    }());

    var NumberFormatFilter = /** @class */ (function () {
        function NumberFormatFilter() {
            return (function (value, format, minPrecision, maxPrecision, currency, decimalSeparator, thousandsSeparator, prefix, suffix) {
                return value.format({
                    formatType: format,
                    minPrecision: Number(minPrecision),
                    maxPrecision: Number(maxPrecision),
                    currency: currency,
                    decimalSeparator: decimalSeparator,
                    thousandsSeparator: thousandsSeparator,
                    prefix: prefix,
                    suffix: suffix
                });
            });
        }
        NumberFormatFilter = __decorate([
            NgFilter({
                token: Token.NumberFormateFilter,
                dependencies: []
            })
        ], NumberFormatFilter);
        return NumberFormatFilter;
    }());

    var ProfileImageFilter = /** @class */ (function () {
        function ProfileImageFilter(storageService) {
            return (function (path) {
                if (!path) {
                    return storageService.getFallbackImage();
                }
                else {
                    return storageService.getProfileImageUrl(path);
                }
            });
        }
        ProfileImageFilter = __decorate([
            NgFilter({
                token: Token.ProfileImageFilter,
                dependencies: [
                    Token.StorageService
                ]
            })
        ], ProfileImageFilter);
        return ProfileImageFilter;
    }());

    var QuoteProductImageFilter = /** @class */ (function () {
        function QuoteProductImageFilter(storageService) {
            return (function (relativePath) {
                if (!relativePath) {
                    return storageService.getFallbackImage();
                }
                else if (relativePath.startsWith("media/") || relativePath.startsWith("productimages/")) {
                    // if it's a media file, go straight to the blob storage to spare the round trip and redirect
                    return storageService.getFileUrl(relativePath);
                }
                else {
                    return "/api/" + relativePath;
                }
            });
        }
        QuoteProductImageFilter = __decorate([
            NgFilter({
                token: Token.QuoteProductImageFilter,
                dependencies: [
                    Token.StorageService
                ]
            })
        ], QuoteProductImageFilter);
        return QuoteProductImageFilter;
    }());

    /**
     * used in ng-repeat to have something like a for loop instead of looping over a collection
     */
    var RangeFilter = /** @class */ (function () {
        function RangeFilter() {
            return (function (input, total) {
                total = parseInt(total, 10);
                for (var i = 0; i < total; i++) {
                    input.push(i);
                }
                return input;
            });
        }
        RangeFilter = __decorate([
            NgFilter({
                token: Token.RangeFilter,
                dependencies: []
            })
        ], RangeFilter);
        return RangeFilter;
    }());

    /**
     * convert html to raw text
     */
    var RawTextFilter = /** @class */ (function () {
        function RawTextFilter() {
            return (function (html) {
                return String(html).replace(/<(?:.|\n)*?>/gm, "");
            });
        }
        RawTextFilter = __decorate([
            NgFilter({
                token: Token.RawTextFilter,
                dependencies: []
            })
        ], RawTextFilter);
        return RawTextFilter;
    }());

    var ShadeFilter = /** @class */ (function () {
        function ShadeFilter() {
            return (function (shadeEnumValue, colorName) {
                var shadeNum = 50;
                if (shadeEnumValue.startsWith("lighter")) {
                    shadeNum = Number(shadeEnumValue.substr(7)) * 10;
                }
                else if (shadeEnumValue.startsWith("darker")) {
                    shadeNum = (Number(shadeEnumValue.substr(6)) * 10) + 50;
                }
                var prefix = "kb-background";
                return "".concat(prefix, "--").concat(colorName.toLowerCase(), "-").concat(shadeNum);
            });
        }
        ShadeFilter = __decorate([
            NgFilter({
                token: Token.ShadeFilter,
                dependencies: []
            })
        ], ShadeFilter);
        return ShadeFilter;
    }());

    /**
     * Given a background color, will provide a contrasting foreground color as a hex code
     */
    var SmartColorFilter = /** @class */ (function () {
        function SmartColorFilter() {
            return (function (backgroundHex) {
                var color;
                var background = new _tools.Color(backgroundHex);
                if (background.isDark()) {
                    color = new _tools.Color({ r: 250, g: 250, b: 250 });
                }
                else {
                    color = new _tools.Color({ r: 17, g: 17, b: 17 });
                }
                return color.toHexString();
            });
        }
        SmartColorFilter = __decorate([
            NgFilter({
                token: Token.SmartColorFilter,
                dependencies: []
            })
        ], SmartColorFilter);
        return SmartColorFilter;
    }());

    var ThemeColorFilter = /** @class */ (function () {
        function ThemeColorFilter(themeService, $rootScope) {
            return (function (palette, shadeEnumValue, opacity, contrast) {
                var shadeNum = 50;
                if (shadeEnumValue.startsWith("lighter")) {
                    shadeNum = Number(shadeEnumValue.substr(7)) * 10;
                }
                else if (shadeEnumValue.startsWith("darker")) {
                    shadeNum = (Number(shadeEnumValue.substr(6)) * 10) + 50;
                }
                if (palette == "warning") {
                    palette = "warn";
                }
                return themeService.getRgbString(themeService.getActiveTheme(), palette, shadeNum, opacity, contrast, false);
            });
        }
        ThemeColorFilter = __decorate([
            NgFilter({
                token: Token.ThemeColorFilter,
                dependencies: [
                    Token.ThemeService,
                    Token.$RootScope
                ]
            })
        ], ThemeColorFilter);
        return ThemeColorFilter;
    }());

    // declare module "angular" {
    //     interface IFilterService {
    //         (name: "thumb"): IThumbFilter;
    //     }
    // }
    var ThumbFilter = /** @class */ (function () {
        function ThumbFilter(storageService) {
            return (function (mediaPath, width, height) {
                var path = mediaPath;
                if (mediaPath) {
                    if (!_tools.Utils.isAbsoluteUrl(mediaPath)) {
                        // if the consumer is asking for a size bigger than our thumbnails, then we load the full res image
                        if ((width && width > 90) || (height && height > 90)) {
                            path = storageService.getMediaUrl(mediaPath);
                        }
                        else { // size is thumbnail size or lower, so we load the thumbnail for speed
                            path = "".concat(storageService.getMediaUrl(mediaPath), "?width=96&height=96");
                        }
                    }
                }
                return path;
            });
        }
        ThumbFilter = __decorate([
            NgFilter({
                token: Token.ThumbFilter,
                dependencies: [
                    Token.StorageService
                ]
            })
        ], ThumbFilter);
        return ThumbFilter;
    }());

    var TruncateFilter = /** @class */ (function () {
        function TruncateFilter() {
            return (function (text, length, end) {
                if (isNaN(length)) {
                    length = 10;
                }
                if (!angular__namespace.isDefined(end)) {
                    end = "...";
                }
                if (!text || text.length - end.length <= length) {
                    return text;
                }
                else {
                    return String(text).substring(0, length - end.length) + end;
                }
            });
        }
        TruncateFilter = __decorate([
            NgFilter({
                token: Token.TruncateFilter,
                dependencies: []
            })
        ], TruncateFilter);
        return TruncateFilter;
    }());

    var TrustAsHtmlFilter = /** @class */ (function () {
        function TrustAsHtmlFilter($sce) {
            return (function (html) {
                return $sce.trustAsHtml(html);
            });
        }
        TrustAsHtmlFilter = __decorate([
            NgFilter({
                token: Token.TrustAsHtmlFilter,
                dependencies: [
                    Token.$Sce
                ]
            })
        ], TrustAsHtmlFilter);
        return TrustAsHtmlFilter;
    }());

    exports.eClaraPropertyType = void 0;
    (function (eClaraPropertyType) {
        eClaraPropertyType["string"] = "string";
        eClaraPropertyType["number"] = "number";
        eClaraPropertyType["boolean"] = "boolean";
        eClaraPropertyType["color"] = "color";
        eClaraPropertyType["reference"] = "reference";
    })(exports.eClaraPropertyType || (exports.eClaraPropertyType = {}));
    exports.eHighlightType = void 0;
    (function (eHighlightType) {
        eHighlightType["user"] = "user";
        eHighlightType["hover"] = "hover";
        eHighlightType["selection"] = "selection";
    })(exports.eHighlightType || (exports.eHighlightType = {}));
    var ClaraSceneUtilities = /** @class */ (function () {
        function ClaraSceneUtilities(sceneService, sceneApi, ruleType, idMap, nestedSceneId) {
            this.sceneService = sceneService;
            this.sceneApi = sceneApi;
            this.ruleType = ruleType;
            this.idMap = idMap;
            this.nestedSceneId = nestedSceneId;
        }
        ClaraSceneUtilities.prototype.setProperty = function (args) {
            args.nestedSceneId = this.nestedSceneId;
            args.objectId = this.mapId(args.objectId);
            args.value = this.mapId(args.value); // sometimes the value is an id as well (like setting a material reference)
            this.sceneService.setProperty(this.sceneApi, args);
            if (this.sceneApi.afterSetProperty)
                this.sceneApi.afterSetProperty(args);
        };
        ClaraSceneUtilities.prototype.getProperty = function (args) {
            args.nestedSceneId = this.nestedSceneId;
            args.objectId = this.mapId(args.objectId);
            return this.sceneService.getProperty(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.setVisible = function (args) {
            args.nestedSceneId = this.nestedSceneId;
            args.objectId = this.mapId(args.objectId);
            return this.sceneService.setVisibleRecursively(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.frameScene = function (args) {
            return this.sceneService.frameScene(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.animateCamera = function (args) {
            return this.sceneService.animateCamera(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.animate = function (args) {
            args.objectId = this.mapId(args.objectId);
            this.sceneService.animate(this.sceneApi, args);
            if (this.sceneApi.afterAnimateProperty)
                this.sceneApi.afterAnimateProperty(args);
        };
        ClaraSceneUtilities.prototype.animateClip = function (args) {
            return this.sceneService.animateClip(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.addModelClickHandler = function (args) {
            args.modelId = this.mapId(args.modelId);
            args.addedByRuleType = this.ruleType;
            // we need a unique id for the handler, but in the context of the nested configurator.
            if (this.nestedSceneId) {
                args.uniqueId = this.nestedSceneId + "-" + args.uniqueId;
                if (args.hotspotId) {
                    args.hotspotId = this.nestedSceneId + "-" + args.hotspotId;
                }
            }
            if (this.sceneApi.addModelClickHandler) {
                return this.sceneApi.addModelClickHandler(args);
            }
        };
        ClaraSceneUtilities.prototype.clearClickHandlers = function () {
            if (this.sceneApi.clickDb)
                this.sceneApi.clearClickHandlers();
        };
        ClaraSceneUtilities.prototype.addDraggable = function (args) {
            args.addedByRuleType = this.ruleType;
            args.objectId = this.mapId(args.objectId);
            this.sceneApi.addDraggable(args);
        };
        ClaraSceneUtilities.prototype.clearDraggables = function () {
            if (this.sceneApi.draggableDb)
                this.sceneApi.clearDraggables();
        };
        ClaraSceneUtilities.prototype.ghost = function (args) {
            return this.sceneService.ghost(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.clearGhosts = function () {
            return this.sceneService.clearGhosts(this.sceneApi);
        };
        ClaraSceneUtilities.prototype.highlight = function (args) {
            return this.sceneService.highlight(this.sceneApi, args, exports.eHighlightType.user);
        };
        ClaraSceneUtilities.prototype.clearHighlights = function () {
            return this.sceneService.clearHighlightsOfType(this.sceneApi, exports.eHighlightType.user);
        };
        ClaraSceneUtilities.prototype.select = function (args) {
            return this.sceneService.select(this.sceneApi, args);
        };
        ClaraSceneUtilities.prototype.clearSelection = function () {
            return this.sceneService.clearSelection(this.sceneApi);
        };
        ClaraSceneUtilities.prototype.getId = function (args) {
            return this.sceneApi.cache.paths.getId({ name: args.name });
        };
        ClaraSceneUtilities.prototype.getName = function (args) {
            return this.sceneApi.api.scene.get({ id: args.id, property: "name" });
        };
        ClaraSceneUtilities.prototype.mapId = function (id) {
            return this.idMap ? this.idMap[id] || id : id;
        };
        ClaraSceneUtilities.prototype.getNode = function (args) {
            var o = this.sceneService.getQueryObject(this.sceneApi, args.id, null);
            var id = this.sceneApi.cache.paths.getId(o);
            var name = this.sceneApi.api.scene.get({ id: id, property: "name" });
            var t = this.sceneApi.api.scene.get({ id: id, property: "type" });
            return {
                id: id,
                name: name,
                type: t
            };
        };
        ClaraSceneUtilities.prototype.getChildNodes = function (args) {
            var _this = this;
            var children = [];
            var o = this.sceneService.getQueryObject(this.sceneApi, args.id, null);
            var id = this.sceneApi.cache.paths.getId(o);
            if (id) {
                // TODO: 2018-01-19 (RH): Had to cast this to <any> due to a type mismatch error in the
                // new TS 2.5 compiler.
                var childIds = this.sceneApi.api.scene.filter({ from: id });
                if (childIds && childIds.length) {
                    childIds.forEach(function (childId) {
                        children.push(_this.getNode({ id: childId }));
                    });
                }
            }
            return children;
        };
        ClaraSceneUtilities.prototype.whenAssetsLoaded = function () {
            return this.sceneApi.api.sceneIO.whenLoaded();
        };
        ClaraSceneUtilities.prototype.getActiveCamera = function () {
            return this.sceneApi.api.player.getCamera();
        };
        return ClaraSceneUtilities;
    }());
    /**
     * PathCache stores a map between query objects and paths for the V2 player.
     * Paths are better because it doesn't result in a search.
     * We also store the last set value so we don't keep setting the current value
     * over and over which costs with performance.
     */
    var PathCache = /** @class */ (function () {
        function PathCache(sceneApi) {
            this.sceneApi = sceneApi;
            this._data = {};
        }
        PathCache.prototype.get = function (query) {
            var paths = this.getPaths(query, false);
            return paths.length ? paths.first() : [];
        };
        PathCache.prototype.getId = function (query) {
            var paths = this.getPaths(query, false);
            return paths.length ? paths.first() : null;
        };
        PathCache.prototype.getIds = function (query) {
            return this.getPaths(query, true);
        };
        PathCache.prototype.getAll = function (query) {
            return this.getPaths(query, true);
        };
        PathCache.prototype.clear = function () {
            this._data = {};
        };
        PathCache.prototype.clearEntriesThatContain = function () {
            var searchTerms = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                searchTerms[_i] = arguments[_i];
            }
            var keys = Object.keys(this._data);
            for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
                var key = keys_1[_a];
                for (var _b = 0, searchTerms_1 = searchTerms; _b < searchTerms_1.length; _b++) {
                    var term = searchTerms_1[_b];
                    if (key.indexOf(term) > -1) {
                        delete this._data[key];
                        break;
                    }
                }
            }
        };
        PathCache.prototype.getPaths = function (query, forSetAll) {
            var key = JSON.stringify(query);
            var exists = this._data.hasOwnProperty(key);
            if (exists) {
                return this._data[key];
            }
            else {
                var paths = [];
                if (forSetAll) {
                    paths = this.sceneApi.api.scene.filter(query);
                }
                else {
                    var path = this.sceneApi.api.scene.find(query);
                    if (path)
                        paths.push(path);
                }
                if (!paths.length) {
                    console.warn("cannot find object with query: " + JSON.stringify(query));
                }
                else {
                    this._data[key] = paths;
                }
                return paths;
            }
        };
        return PathCache;
    }());
    var LastValueCache = /** @class */ (function () {
        function LastValueCache() {
            this._data = {};
        }
        LastValueCache.prototype.get = function (path) {
            var key = JSON.stringify(path);
            return this._data[key];
        };
        LastValueCache.prototype.set = function (path, value) {
            this._data[JSON.stringify(path)] = JSON.stringify(value);
        };
        LastValueCache.prototype.valueEqualTo = function (path, val) {
            var key = JSON.stringify(path);
            return this._data[key] === JSON.stringify(val);
        };
        return LastValueCache;
    }());
    var SceneCache = /** @class */ (function () {
        function SceneCache(sceneApi) {
            this.sceneApi = sceneApi;
            this.paths = new PathCache(this.sceneApi);
            this.lastValues = new LastValueCache();
        }
        return SceneCache;
    }());
    var ClaraSceneService = /** @class */ (function () {
        function ClaraSceneService(ruleService, $q) {
            this.ruleService = ruleService;
            this.$q = $q;
            this._vectorProperties = [
                "translationx",
                "translationy",
                "translationz",
                "rotationx",
                "rotationy",
                "rotationz",
                "scalex",
                "scaley",
                "scalez"
            ];
            this.NESTED_SCENE_PREFIX = "kb-nested-";
        }
        ClaraSceneService.prototype.convertColorForScene = function (hex) {
            // clara expects rgb values from 0 to 1
            var color = new _tools.Color(hex).toRgb();
            color.r = color.r / 255;
            color.g = color.g / 255;
            color.b = color.b / 255;
            return color;
        };
        ClaraSceneService.prototype.normalizePropertyValue = function (sceneApi, args) {
            var origValue = args.value;
            if (args.propertyType && args.propertyType.isEqual("Color")) { // property type is the clara data type, not the snap data type
                // if value is already an rgb object, then skip this
                if (args.value &&
                    typeof args.value === "object" &&
                    args.value.hasOwnProperty("r") &&
                    args.value.hasOwnProperty("g") &&
                    args.value.hasOwnProperty("b")) ;
                else if (args.value !== null) {
                    args.value = this.convertColorForScene(args.value);
                }
            }
            if (this._vectorProperties.indexOf(args.property) > -1) {
                var axis = args.property.charAt(args.property.length - 1);
                args.property = args.property.substr(0, args.property.length - 1);
                var currentVal = this.getProperty(sceneApi, {
                    objectId: args.objectId,
                    name: args.name,
                    plug: args.plug,
                    operator: args.operator,
                    property: args.property,
                    propertyType: null,
                    nestedSceneId: args.nestedSceneId
                });
                if (currentVal && currentVal.clone)
                    currentVal = currentVal.clone();
                currentVal[axis] = origValue;
                args.value = currentVal;
            }
        };
        ClaraSceneService.prototype.toggleTool = function (sceneApi, args) {
            sceneApi.api.commands.updateCommand(args.tool, { enabled: args.enabled });
        };
        ClaraSceneService.prototype.constrainCamera = function (sceneApi, args) {
            var radius = args.constrain ? args.radius : null;
            sceneApi.api.player.setCameraRadiusConstraint(radius);
        };
        /**
         * validates that the given string is a valid clara id.  Note that clara used to use guids,
         * and now uses these: https://github.com/ericelliott/cuid
         * so we need to validate for both
         * @param id
         */
        ClaraSceneService.prototype.isClaraId = function (id) {
            var cuidRegex = /^c[^\s-]{8,}$/;
            return _tools.Utils.isGuid(id) || (cuidRegex.exec(id) != null);
        };
        ClaraSceneService.prototype.getParentNodeId = function (sceneApi, nodeId) {
            return sceneApi.api.scene.find({
                id: nodeId,
                parent: true
            });
        };
        ClaraSceneService.prototype.getChildNodeIds = function (sceneApi, nodeId) {
            return sceneApi.api.scene.filter({ from: nodeId });
        };
        ClaraSceneService.prototype.findAncestorNodeId = function (sceneApi, nodeId, callback) {
            var parentId = nodeId;
            while (parentId) {
                if (callback(parentId))
                    break;
                parentId = this.getParentNodeId(sceneApi, parentId);
            }
            return parentId;
        };
        ClaraSceneService.prototype.getProperty = function (sceneApi, args) {
            var axis;
            if (this._vectorProperties.indexOf(args.property) > -1) {
                axis = args.property.charAt(args.property.length - 1);
                args.property = args.property.substr(0, args.property.length - 1);
            }
            var query = this.getQueryObjectFromArgs(sceneApi, args);
            // if the item is in a nested scene, we must look for the item only in the nested scene null,
            // otherwise regex style sets will be applied to the whole scene
            // materials are not nested under the nested scene null so they do not apply & 
            // from is not needed if doing an id search, so we only use it when doing by name
            if (args.nestedSceneId && query.name && !args.operator.equalsAny("Physical", "Canvas", "CanvasText")) {
                query.from = { id: args.nestedSceneId };
            }
            var path = sceneApi.cache.paths.get(query);
            var result = null;
            result = sceneApi.api.scene.get(path);
            if (axis && result) {
                result = result[axis];
            }
            return result;
        };
        ClaraSceneService.prototype.setProperty = function (sceneApi, args) {
            this.normalizePropertyValue(sceneApi, args);
            // if this is a reference type, then we need to set the reference property to the id of the referenced item
            if (args.propertyType && args.propertyType.isEqual("Node")) { // property type is the clara data type, not the snap data type
                if (!this.isClaraId(args.value)) {
                    args.value = sceneApi.cache.paths.getId({ name: args.value });
                }
            }
            var query = this.getQueryObjectFromArgs(sceneApi, args);
            // if the item is in a nested scene, we must look for the item only in the nested scene null,
            // otherwise regex style sets will be applied to the whole scene
            // materials are not nested under the nested scene null so they do not apply & 
            // from is not needed if doing an id search, so we only use it when doing by name
            if (args.nestedSceneId && query.name && !args.operator.equalsAny("Physical", "Canvas", "CanvasText")) {
                query.from = { id: args.nestedSceneId };
            }
            (query.name != null); // we use setAll if this is possibly a regex query
            var paths = sceneApi.cache.paths.getAll(query);
            paths.forEach(function (path) {
                if (!sceneApi.cache.lastValues.valueEqualTo(path, args.value)) {
                    sceneApi.api.scene.set(path, args.value);
                    _tools.Logger.logSceneChange("set " + JSON.stringify(args));
                    sceneApi.cache.lastValues.set(path, args.value);
                }
            });
        };
        ClaraSceneService.prototype.setVisibleRecursively = function (sceneApi, args) {
            // hierarchical visibility is not set, so we fallback to what we used to do, which is setting the node and all it's children's visibility to simulate hierarchical visibility
            var query = { name: "*", plug: "Properties", property: "visible" };
            query.includeParent = true; // include the parent in the query
            query.from = this.getQueryObject(sceneApi, args.objectId, args.name);
            if (!query.from)
                return;
            // if we're in a nested scene, then only look for nodes inside of that
            if (args.nestedSceneId) {
                query.from.from = { id: args.nestedSceneId };
            }
            var paths = sceneApi.cache.paths.getAll(query);
            if (paths) {
                paths.forEach(function (path) {
                    if (!sceneApi.cache.lastValues.valueEqualTo(path, args.visible)) {
                        sceneApi.api.scene.set(path, args.visible);
                        _tools.Logger.logSceneChange("set " + JSON.stringify(args));
                        sceneApi.cache.lastValues.set(path, args.visible);
                    }
                });
            }
        };
        ClaraSceneService.prototype.getQueryObjectFromArgs = function (sceneApi, args) {
            return this.getQueryObject(sceneApi, args.objectId, args.name, args.plug, args.property, args.operator);
        };
        ClaraSceneService.prototype.getQueryObject = function (sceneApi, id, name, plug, property, operator) {
            var o = {};
            // temporary check for transition to V2.  Old blocks will only be using objectId even if it's the name 
            // we're after newer blocks differentiate.  So we need to make sure the id is really an id.  
            // If it isn't, then we'll use it as the name
            if (id) {
                var foundId = sceneApi.api.scene.find({ id: id });
                if (foundId) {
                    o.id = id;
                }
                else {
                    o.name = id;
                }
            }
            else if (name) {
                o.name = name;
            }
            if (plug) {
                o.plug = plug;
            }
            if (property) {
                o.property = property;
            }
            if (operator) {
                // using named operators is a little strange.  We need to match the operator through it's properties.  
                // In this case, we use the name property
                o.properties = { name: operator };
            }
            return o;
        };
        ClaraSceneService.prototype.animateCamera = function (sceneApi, args) {
            var duration = args.duration || 3000;
            args.easing || "linear";
            sceneApi.cameraAnimationInProgress = true;
            return sceneApi.api.player.animateCameraTo(args.toCameraId, duration).then(function () {
                sceneApi.cameraAnimationInProgress = false;
            });
        };
        ClaraSceneService.prototype.animate = function (sceneApi, args) {
            this.normalizePropertyValue(sceneApi, args);
            var query = this.getQueryObjectFromArgs(sceneApi, args);
            (query.name != null); // we use setAll if this is possibly a regex query
            var paths = sceneApi.cache.paths.getAll(query);
            paths.forEach(function (path) {
                // if (!sceneApi.cache.lastValues.valueEqualTo(path, args.value)) {
                sceneApi.api.animation.queueAnimation({
                    name: _tools.Utils.shortId(),
                    iterations: args.iterations,
                    autoplay: true,
                    tracks: [
                        {
                            path: path,
                            type: args.propertyType,
                            value: args.value,
                            duration: args.duration,
                            easing: args.easing || "linear",
                            start: args.start
                        }
                    ],
                    onEnd: function () {
                        // after the animation set the value in the cache
                        sceneApi.cache.lastValues.set(path, args.value);
                    }
                });
                // }
            });
        };
        ClaraSceneService.prototype.animateClip = function (sceneApi, args) {
            var clip = sceneApi.api.animation.getClips().find(function (c) { return c.name.isEqual(args.name); });
            if (clip) {
                sceneApi.api.animation.queueClip(clip.id, { autoplay: true });
            }
            else {
                console.warn("Could not find animation clip with name '" + args.name + "'");
            }
        };
        ClaraSceneService.prototype.getSceneUtilities = function (sceneApi, ruleType, idMap, nestedSceneId) {
            return new ClaraSceneUtilities(this, sceneApi, ruleType, idMap, nestedSceneId);
        };
        ClaraSceneService.prototype.runSceneRules = function (sceneConfig, uiConfig, ruleArgs, skipRulesIfNoNestedSceneChanges) {
            var _this = this;
            return this.runNestedSceneRules(ruleArgs.sceneApi, uiConfig).then(function (r) {
                if (!skipRulesIfNoNestedSceneChanges || (r && r.some(function (r2) { return r2 != null; }))) { //skip running the rules if there were no nested scene rules run
                    return _this.importAllUploadFieldImages(ruleArgs.sceneApi, uiConfig).then(function () {
                        ruleArgs.sceneUtils.ruleType = enums.eRuleType.scene;
                        return _this.ruleService.runRuleTypeAsync(sceneConfig, enums.eRuleType.scene, ruleArgs).then(function (ruleResult) {
                            uiConfig.$fieldsDirtyForSceneRules = false;
                            return ruleResult;
                        });
                    });
                }
            });
        };
        ClaraSceneService.prototype.runRulesCycle = function (sceneConfig, uiConfig, ruleArgs) {
            var _this = this;
            var runUiRules = !ruleArgs.sceneApi.sceneDb[sceneConfig.idScene].idProduct;
            // before running the scene rules, we need to clear out transient handlers
            ruleArgs.sceneApi.draggableDb.clearTransient();
            ruleArgs.sceneApi.clickDb.clearTransient();
            if (runUiRules) {
                // run the value rule first
                ruleArgs.sceneUtils.ruleType = enums.eRuleType.value;
                return this.ruleService.runRuleTypeAsync(sceneConfig, enums.eRuleType.value, ruleArgs)
                    .then(function () {
                    sceneConfig.preValidate();
                    sceneConfig.isValid();
                })
                    .then(function () { return _this.runSceneRules(sceneConfig, uiConfig, ruleArgs, false); });
            }
            else {
                return this.runSceneRules(sceneConfig, uiConfig, ruleArgs, false);
            }
        };
        ClaraSceneService.prototype.runNestedSceneRules = function (sceneApi, uiConfig) {
            var _this = this;
            var nestedConfigs = uiConfig.getNestedConfigurators();
            if (nestedConfigs.length) {
                var promises_1 = [];
                // loop through nested configurators, merge the scenes if they haven't been already, and run their rules
                nestedConfigs.forEach(function (nested) {
                    if (nested.idScene) {
                        var refConfig = uiConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
                        if (refConfig.nestScene) {
                            // create the scene configurator for the nested configurator if it doesn't already exist 
                            // (or has been swapped for another scene)
                            if (!nested.$sceneConfigurator || nested.$sceneConfigurator.idScene != nested.idScene) {
                                nested.$sceneConfigurator = new enums.Configurator(new enums.KbObjectManager(), sceneApi.sceneDb[nested.idScene].configurator);
                                nested.$fieldsDirtyForSceneRules = true;
                            }
                            nested.$sceneConfigurator.$uiConfigurator = nested;
                            nested.$nestHotspots = refConfig.nestHotspots;
                            // in case the nested scene is a standalone scene, we need to set it's fields from the uiConfig
                            if (nested != nested.$sceneConfigurator && !nested.$sceneConfigurator.idProduct) {
                                nested.$sceneConfigurator.setFields(nested.getFieldsObject());
                            }
                            var skipRules_1 = !nested.$fieldsDirtyForSceneRules;
                            promises_1.push(_this.nestScene(// merge the scene if it hasn't already been merged
                            sceneApi, sceneApi.sceneDb[nested.idScene].claraId, sceneApi.sceneDb[nested.idScene].publishHash, nested).then(function () {
                                // now run the rules on the nested scene
                                return _this.runSceneRules(nested.$sceneConfigurator, nested, _this.getNestedSceneRuleArgs(sceneApi, nested, nested.$sceneConfigurator, nested.$sceneConfigurator.$sceneIdMap, enums.eRuleType.scene), skipRules_1);
                            }));
                        }
                    }
                });
                return this.$q.all(promises_1);
            }
            else {
                return (new _rules.KPromise(null));
            }
        };
        ClaraSceneService.prototype.getNestedSceneRuleArgs = function (sceneApi, uiConfig, sceneConfig, idMap, ruleType) {
            // if the scene config is standalone, then it will also act as the uiConfig for the rules
            if (!sceneApi.sceneDb[uiConfig.idScene].idProduct)
                uiConfig = uiConfig.$sceneConfigurator;
            var sceneUtils = this.getSceneUtilities(sceneApi, ruleType, idMap, uiConfig.$nestedSceneId);
            return {
                environment: "",
                company: {},
                configurator: uiConfig,
                kom: uiConfig.$manager,
                parentKom: uiConfig.$parentConfigurator ? uiConfig.$parentConfigurator.$manager : null,
                sceneKom: sceneConfig.$manager,
                sceneApi: sceneApi,
                isRender: sceneApi.isRender,
                isMobile: sceneApi.isMobile,
                clientLanguage: sceneApi.clientLanguage,
                logs: new _rules.ClientLogger(),
                upload: function () {
                    return new _rules.KPromise(null);
                },
                // TODO:  leave in scene rule args for backwards compatibility.  
                // Can be removed in the future, since it's real place is in scene utilities
                addModelClickHandler: function (args) {
                    sceneUtils.addModelClickHandler(args);
                },
                playSceneAnimation: function (args) {
                    // no need for animations server side
                },
                toggleSceneAnimation: function () {
                    // no need for animations server side
                },
                sceneUtils: sceneUtils,
                sendMessage: function (msg) {
                    sceneApi.sendMessage(msg);
                },
                selectPage: function (page) {
                },
                convertCurrency: function (obj) {
                    return null;
                },
                toggleTool: function (args) {
                },
                constrainCamera: function (args) {
                },
                getUploadImageNode: function (args) {
                    var a = sceneApi.importedImages[uiConfig.name + "_" + args.fieldId];
                    return a ? a.imageNodeId : null;
                },
                getTables: function (args) {
                    return sceneApi.getTables(args);
                }
            };
        };
        ClaraSceneService.prototype.nodeWithIdExists = function (sceneApi, id) {
            return id && (sceneApi.api.scene.find({ id: id }) != null);
        };
        ClaraSceneService.prototype.nestSceneInner = function () {
        };
        ClaraSceneService.prototype.fetchScene = function (sceneApi, claraId, publishHash) {
            if (!sceneApi.fetchedScenes.hasOwnProperty(claraId)) {
                sceneApi.fetchedScenes[claraId] =
                    sceneApi.api.sceneIO.fetch(claraId, publishHash, { waitForPublish: true });
            }
            return sceneApi.fetchedScenes[claraId];
        };
        ClaraSceneService.prototype.nestScene = function (sceneApi, claraId, publishHash, nested) {
            var _this = this;
            // first check to see if this nested configurator scene has already been merged
            if (nested.$nestedSceneId && this.nodeWithIdExists(sceneApi, nested.$nestedSceneId)) {
                return (new _rules.KPromise(null));
            }
            else {
                var deferred_1 = this.$q.defer();
                var api_1 = sceneApi.api;
                var rootSceneId_1 = api_1.scene.find({ includeParent: true });
                // first fetch the scene from the server (or cache)
                this.fetchScene(sceneApi, claraId, publishHash).then(function () {
                    // if this nested scene is a child of another nested scene, 
                    // then we must place this node inside of the parent nested scene node
                    // otherwise, just put it in the 'Objects' node of the scene
                    var parentId;
                    if (nested.$parentConfigurator && nested.$parentConfigurator.$nestedSceneId) {
                        parentId = nested.$parentConfigurator.$nestedSceneId;
                    }
                    else {
                        parentId = sceneApi.cache.paths.getId({ type: "Objects" }); // get the 'Objects' node id
                    }
                    // now that we've fetched the nested scene template, we need to add a null node to house it
                    api_1.sceneGraph.addNode({
                        name: _this.NESTED_SCENE_PREFIX + nested.name,
                        parent: parentId,
                        type: "Null",
                        plugs: {
                            Transform: [["Transform", {}]],
                            Properties: [["Default", {}]]
                        }
                    }).then(function (nullId) {
                        // we have our new null node to house the nested scene.  
                        // Now we need to copy nodes from the other scene into it
                        var nestedObjectsNodeId = sceneApi.cache.paths.getId({
                            from: { id: claraId },
                            name: "Objects"
                        });
                        var nestedMaterialsNodeId = sceneApi.cache.paths.getId({
                            from: { id: claraId },
                            name: "Material Library"
                        });
                        var parentMaterialsNodeId = sceneApi.cache.paths.getId({
                            from: { id: rootSceneId_1 },
                            name: "Material Library"
                        });
                        // only clone nodes that make sense - materials can stay where they're 
                        // at and still be used.Ignore cameras, lights, etc.
                        var objectsToClone = api_1.scene.filter({
                            from: { id: nestedObjectsNodeId },
                            type: ["PolyMesh", "BinMesh", "Null", "Model", "Annotation", "Helper"]
                        });
                        var materialsToClone = api_1.scene.filter({
                            from: { id: nestedMaterialsNodeId },
                            type: ["Material"]
                        });
                        var allNodesToClone = objectsToClone.concat(materialsToClone);
                        // create a parent map to tell the cloned nodes where to go
                        var parentMap = {};
                        // nested object nodes to go into our new null
                        parentMap[nestedObjectsNodeId] = nullId;
                        // nested material nodes to go into the parent material library
                        parentMap[nestedMaterialsNodeId] = parentMaterialsNodeId;
                        // this.dumpScene(sceneApi, <string>api.scene.find({ includeParent: true }), 0);
                        api_1.sceneGraph.clone(allNodesToClone, parentMap, { cloneDependencies: true }).then(function (nodeMap) {
                            // console.log('new nodes', nodeMap);
                            api_1.scene.find({ includeParent: true });
                            // this.dumpScene(sceneApi, sceneId, 0);
                            // this.checkScene(sceneApi, sceneId, 0, sceneId);
                            // store the node map into the scene configurator
                            nested.$sceneConfigurator.$sceneIdMap = nodeMap;
                            // set the nested scene id of the configurator to make it easier to find this node by id
                            nested.$nestedSceneId = nullId;
                            if (sceneApi.onSceneNested) {
                                sceneApi.onSceneNested(nested, nullId);
                            }
                            var nestedRuleArgs = _this.getNestedSceneRuleArgs(sceneApi, nested, nested.$sceneConfigurator, nested.$sceneConfigurator.$sceneIdMap, enums.eRuleType.sceneLoaded);
                            _this.ruleService.runRuleTypeAsync(nested.$sceneConfigurator, enums.eRuleType.sceneLoaded, nestedRuleArgs).then(function () {
                                deferred_1.resolve();
                            });
                        });
                    });
                });
                return deferred_1.promise;
            }
        };
        ClaraSceneService.prototype.deleteOrphanedNestedScenes = function (sceneApi, uiConfig) {
            var allNested = uiConfig.getAllConfigurators();
            var api = sceneApi.api;
            var nestedSceneIds = api.scene.filter({ name: this.NESTED_SCENE_PREFIX + "*" });
            nestedSceneIds.forEach(function (id) {
                if (!allNested.some(function (c) { return c.$nestedSceneId == id; })) {
                    api.sceneGraph.deleteNode(id);
                }
            });
        };
        /**
         * used to output the heirarchy for debugging
         * @param level
         */
        ClaraSceneService.prototype.dumpScene = function (sceneApi, nodeId, level) {
            var _this = this;
            var api = sceneApi.api;
            if (nodeId == null) {
                nodeId = sceneApi.api.scene.find({ includeParent: true });
                level = 0;
            }
            // tslint:disable-next-line:no-console
            console.log(new Array(level + 1).join("  "), " - ", api.scene.get({ id: nodeId, property: "name" }), " - ", nodeId);
            var paths = api.scene.filter({ from: { id: nodeId }, shallow: true });
            paths.forEach(function (id) { return _this.dumpScene(sceneApi, id, level + 1); });
        };
        ClaraSceneService.prototype.checkScene = function (sceneApi, nodeId, level, parentId) {
            var _this = this;
            var api = sceneApi.api;
            var name = api.scene.get({ id: nodeId, property: "name" });
            if (!name) {
                console.error("No data for child: ", nodeId, "child of: ", api.scene.get({ id: parentId, property: "name" }));
            }
            var children = api._store.getIn(["sceneGraph", nodeId, "children"]);
            children.forEach(function (id) { return _this.checkScene(sceneApi, id, level + 1, nodeId); });
        };
        ClaraSceneService.prototype.importAllUploadFieldImages = function (sceneApi, uiConfig) {
            var _this = this;
            var promise = new _rules.KPromise(null);
            // only find fields with an assetId but don't have an image node yet.  
            // The asset should have already been imported at time of upload
            // (has to be this way because we don't have the File object)
            var uploadFields = uiConfig.getFields(function (f) {
                return f.type == enums.eFieldType.upload &&
                    f.uploadToScene;
            });
            if (uploadFields.length) {
                var promises_2 = [];
                uploadFields.forEach(function (uf) {
                    promises_2.push(_this.importUploadFieldImage(sceneApi, uiConfig, uf));
                });
                promise = this.$q.all(promises_2);
            }
            return promise;
        };
        ClaraSceneService.prototype.importUploadFieldImage = function (sceneApi, uiConfig, field, file) {
            var promise = new _rules.KPromise(null);
            var uploadValue = field.value;
            var api = sceneApi.api;
            sceneApi.isRender;
            // only import if the upload field is set to upload to scene
            if (field.uploadToScene) {
                var prefix = uiConfig.isNested() ? uiConfig.name : "";
                prefix += "_" + field.name;
                var nullNodeName_1 = prefix + "_null";
                var imageNodeName = prefix + "_image";
                var shapeNodeName_1 = prefix + "_shape";
                var extrudeNodeName_1 = prefix + "_extrude";
                var options = { outputName: imageNodeName };
                if (field.convertUploadedSceneImageToMesh) {
                    options = {
                        targetFormat: "svg",
                        mode: "threshold",
                        threshold: field.uploadImageThreshold,
                        backgroundColor: "#00FFFFFF",
                        outputName: imageNodeName
                    };
                }
                // if there is already an asset id, and it has an image node, then there is nothing to do here
                // if there is no asset id, then this file still needs to get uploaded to assets
                var importObject = null;
                var prevImportedImage = sceneApi.importedImages[uiConfig.name + "_" + field.id];
                if (file && !uploadValue.assetId) { //user just uploaded                
                    importObject = file;
                }
                else if (uploadValue.assetId && !prevImportedImage) { //uploaded this session (and not an svg conversion)
                    // pass the assetId to import to make the image node
                    importObject = uploadValue.assetId;
                }
                if (importObject) {
                    promise = sceneApi.api.assets.importImage(importObject, options);
                }
                else {
                    return promise;
                }
                //clean up old svg image if it exists
                var svgNodeId = api.scene.find(imageNodeName + ".svg");
                if (svgNodeId) {
                    api.sceneGraph.deleteNode(svgNodeId);
                }
                promise.then(function (r) {
                    uploadValue.assetId = r.assetId;
                    sceneApi.importedImages[uiConfig.name + "_" + field.id] = { imageNodeId: r.imageNodeId, threshold: field.uploadImageThreshold };
                    if (field.convertUploadedSceneImageToMesh) {
                        //create a null to house the shape if one doesn't already exist
                        var nullNodeId = api.scene.find(nullNodeName_1);
                        if (!nullNodeId) {
                            api.scene.addNode({
                                name: nullNodeName_1,
                                parent: api.scene.find('Objects'),
                                type: "Null",
                                plugs: {
                                    Transform: [["Transform", {}]],
                                    Properties: [["Default", {}]]
                                }
                            });
                            nullNodeId = api.scene.find(nullNodeName_1);
                        }
                        //if the shape node already exists, then delete it
                        //if it doesn't exist, then create it
                        var shapeNodeId = api.scene.find(shapeNodeName_1);
                        if (shapeNodeId) {
                            api.sceneGraph.deleteNode(shapeNodeId);
                            sceneApi.cache.paths.clearEntriesThatContain(shapeNodeName_1, shapeNodeId);
                        }
                        api.scene.addNode({
                            name: shapeNodeName_1,
                            type: 'Shape',
                            parent: nullNodeId,
                            plugs: {
                                Shape: [
                                    [
                                        'SVGShape',
                                        {
                                            image: r.imageNodeId,
                                            curveSegments: 8,
                                        },
                                    ],
                                ]
                            },
                        });
                        shapeNodeId = api.scene.find(shapeNodeName_1);
                        // Resize shape (default operation is to fit a 1x1 square)
                        api.scene.addOperator(shapeNodeId, 'Shape', 'ResizeShape', { keepAspectRatio: true });
                        // Center the shape since center of svg is on top left corner
                        api.scene.addOperator(shapeNodeId, 'Shape', 'CenterShape', {});
                        //add an extrude of the shape
                        var extrudeNodeId = api.scene.find(extrudeNodeName_1);
                        if (extrudeNodeId) {
                            api.sceneGraph.deleteNode(extrudeNodeId);
                            sceneApi.cache.paths.clearEntriesThatContain(extrudeNodeName_1, extrudeNodeId);
                        }
                        api.scene.addNode({
                            name: extrudeNodeName_1,
                            type: "PolyMesh",
                            parent: nullNodeId,
                            plugs: {
                                PolyMesh: [
                                    [
                                        "FromShapeWithExtrude",
                                        {
                                            shape: shapeNodeId,
                                            extrudeLength: 0.1
                                        }
                                    ]
                                ]
                            }
                        });
                    }
                });
            }
            return promise;
        };
        ClaraSceneService.prototype.snapshot = function (sceneApi, options) {
            sceneApi.api.commands.setCommandOptions('snapshot', options);
            var result = sceneApi.api.commands.runCommand('snapshot');
            return result;
        };
        ClaraSceneService.prototype.getRootSceneId = function (sceneApi) {
            return sceneApi.api.scene.find({ includeParent: true });
        };
        ClaraSceneService.prototype.frameScene = function (sceneApi, args) {
            var nodeList = args ? [args.node] : null;
            sceneApi.api.player.frameScene(nodeList, args);
        };
        ClaraSceneService.prototype.isHierarchicalVisibilityEnabled = function (sceneApi) {
            var rootSceneId = sceneApi.api.scene.find({ includeParent: true });
            var r = sceneApi.api.scene.get({
                id: rootSceneId,
                plug: "Properties",
                property: "hierarchyVisibility"
            });
            return r == "Enable";
        };
        ClaraSceneService.prototype.ghost = function (sceneApi, args) {
            if (!sceneApi.ghoster) {
                sceneApi.ghoster = sceneApi.api.selection.addGhoster({ opacity: .7 });
            }
            var nodeIds = sceneApi.api.scene.filter({ from: { id: args.id }, includeParent: true });
            nodeIds.forEach(function (n) {
                if (args.on) {
                    sceneApi.ghoster.selectionSet.add(n);
                }
                else {
                    sceneApi.ghoster.selectionSet.remove(n);
                }
            });
        };
        ClaraSceneService.prototype.highlight = function (sceneApi, args, type) {
            if (!sceneApi.highlighter) {
                sceneApi.highlighter = sceneApi.api.selection.setHighlighting(true, { color: "#ff0000", thickness: 2 });
            }
            var nodeIds = sceneApi.api.scene.filter({ from: { id: args.id }, includeParent: true, type: ["PolyMesh", "BinMesh", /*"Null",*/ "Model", "Annotation", "Helper"] });
            var highlighter = sceneApi.highlighter;
            nodeIds.forEach(function (n) {
                if (args.on) {
                    highlighter.selectionSet.add(n);
                    sceneApi.highlights[type][n] = true;
                }
                else {
                    highlighter.selectionSet.remove(n);
                    delete sceneApi.highlights[type][n];
                }
            });
        };
        ClaraSceneService.prototype.clearHighlightsOfType = function (sceneApi, type) {
            var types = [exports.eHighlightType.user, exports.eHighlightType.selection, exports.eHighlightType.hover];
            types.remove(type);
            var _loop_1 = function (id) {
                //only remove if the node is not part of another highlight type
                var shouldUnhighlight = !types.some(function (t) { return sceneApi.highlights[t][id]; });
                if (shouldUnhighlight && sceneApi.highlighter) {
                    sceneApi.highlighter.selectionSet.remove(id);
                }
            };
            for (var id in sceneApi.highlights[type]) {
                _loop_1(id);
            }
            sceneApi.highlights[type] = {};
        };
        ClaraSceneService.prototype.clearGhosts = function (sceneApi) {
            if (sceneApi.ghoster) {
                sceneApi.ghoster.selectionSet.clear();
            }
        };
        ClaraSceneService.prototype.select = function (sceneApi, args) {
            if (!sceneApi.selector) {
                sceneApi.selector = sceneApi.api.selection.createSelectionSet();
                sceneApi.api.selection.setActiveSelectionSet(sceneApi.selector);
            }
            if (!sceneApi.selectedNodes.contains(args.id)) {
                this.clearSelection(sceneApi);
                sceneApi.selectedNodes.push(args.id);
                sceneApi.selector.add(args.id);
                this.highlight(sceneApi, { id: args.id, on: true }, exports.eHighlightType.selection);
            }
        };
        ClaraSceneService.prototype.deselect = function (sceneApi, nodeId) {
            this.highlight(sceneApi, { id: nodeId, on: false }, exports.eHighlightType.selection);
            sceneApi.selectedNodes.remove(nodeId);
            sceneApi.selector && sceneApi.selector.remove(nodeId);
        };
        ClaraSceneService.prototype.clearSelection = function (sceneApi) {
            for (var i = sceneApi.selectedNodes.length - 1; i >= 0; i--) {
                this.deselect(sceneApi, sceneApi.selectedNodes[i]);
            }
        };
        ClaraSceneService.prototype.getThree = function (sceneApi) {
            return sceneApi.api.player.getThree().THREE;
        };
        ClaraSceneService = __decorate([
            NgService({
                token: Token.ClaraSceneService,
                dependencies: [
                    Token.RuleService,
                    Token.$Q,
                ]
            })
        ], ClaraSceneService);
        return ClaraSceneService;
    }());

    var SceneViewer = /** @class */ (function () {
        function SceneViewer(args) {
            var _this = this;
            this.args = args;
            Object.keys(args).forEach(function (prop) {
                _this[prop] = args[prop];
            });
            this.isOutput = args.isOutput === true;
            this.loadDeferred = this.$q.defer();
        }
        SceneViewer.prototype.loadScene = function (args) {
            // flush out stuff that needs to be flushed
            this.clearHandlers();
            this.$scope.loaded = false;
            this.loadDeferred = this.$q.defer();
            // reset scope
            this.scene = args.scene;
            if (args.isStandalone) {
                //it's a standalone scene, so the uiConfig and sceneConfig are one and the same
                this.sceneConfig = args.config;
                this.uiConfig = args.config;
                this.sceneConfig.$uiConfigurator = args.config;
            }
            else {
                //it's a full cpq config, so we make another configurator just for the scene
                this.sceneConfig = new enums.Configurator(new enums.KbObjectManager(), this.scene.configurator);
                this.sceneConfig.$running = true;
                this.sceneConfig.name = this.scene.name;
                this.sceneConfig.idScene = this.scene.id;
                this.sceneConfig.$uiConfigurator = args.config;
                this.uiConfig = args.config;
                this.uiConfig.$sceneConfigurator = this.sceneConfig; //set the sceneConfigurator in the uiconfig so templates have access to it
            }
            return this.loadSceneInternal(args);
        };
        SceneViewer.prototype.createElem = function () {
            var parentElem = document.querySelector(this.elemSelector);
            this.elem = document.createElement('div');
            this.elem.classList.add('kb-viewer__3d');
            parentElem.appendChild(this.elem);
        };
        SceneViewer.prototype.createHotspotElem = function () {
            // load the hotspot div after the player so it ends up later in the html
            this.hotspotDiv = document.createElement('div');
            this.hotspotDiv.classList.add('kb-viewer__hotspots', 'xr-overlay');
            this.hotspotDiv.setAttribute('ng-include', "'hotspots-template'");
            this.hotspotDiv.setAttribute('ng-if', 'loaded');
            this.hotspotDiv.setAttribute('ng-cloak', '');
            this.elem.appendChild(this.hotspotDiv);
            this.hotspotDiv = this.compileTemplate(this.hotspotDiv, this.$scope);
        };
        SceneViewer.prototype.show = function () {
            if (this.elem.classList.contains('kb-hide')) {
                this.elem.classList.remove('kb-hide');
                // redraw otherwise it won't actually show
                this.resize();
            }
        };
        SceneViewer.prototype.hide = function () {
            if (!this.elem.classList.contains('kb-hide')) {
                this.elem.classList.add('kb-hide');
            }
        };
        SceneViewer.prototype.notifyLoaded = function () {
            /* notify any outside pages that are embedding that the scene is loaded.
            We pass the requestid that was passed in as a query string param back to
            them so they know which iframe has been loaded (in case they have multiple
            kbmax iframes on the same page) */
            _tools.Utils.sendMessageToParent({
                name: 'sceneloaded',
                data: {
                    requestId: this.requestId,
                },
            });
            _tools.Utils.sendMessageToParent({ name: 'progress', data: 0.2 });
            this.$scope.loaded = true;
            this.loadDeferred.resolve();
        };
        SceneViewer.prototype.runActionRule = function (actionName, ruleArgs) {
            var _this = this;
            var action = this.sceneConfig.actions.find(function (a) { return a.name.isEqual(actionName); });
            if (action) {
                return this.loadDeferred.promise.then(function () {
                    return _this.ruleService.runRuleContainerAsync(action, ruleArgs).then(function (r) {
                        _this.handleRuleError(action.name + ' ' + action.$type, r);
                        return r;
                    });
                });
            }
        };
        SceneViewer.prototype.setFieldsIfStandalone = function () {
            // if this is a standalone scene being used with a full CPQ configurator,
            // then we need to set the fields of the scene configurator
            if (this.sceneConfig != this.uiConfig && !this.sceneConfig.idProduct) {
                this.sceneConfig.setFields(this.uiConfig.getFieldsObject());
            }
        };
        SceneViewer.prototype.sendMessage = function (msg) {
            if (this.messageCallback) {
                this.messageCallback(msg);
            }
            // send message to embed consumer
            _tools.Utils.sendMessageToParent(msg);
        };
        SceneViewer.prototype.refreshElementParent = function () {
            //get the first visible viewer element
            var $parent = $(this.elemSelector + ':visible:first');
            if ($parent.length && this.elem && !$parent.find(this.elem).length) {
                $parent[0].appendChild(this.elem);
            }
        };
        SceneViewer.prototype.positionHotspot = function (pos, hotspot) {
            hotspot.$top = pos.y;
            hotspot.$left = pos.x;
            if (hotspot.popupPosition == enums.eHotspotPosition.target) {
                var x = pos.x;
                var y = pos.y;
                if (hotspot.popupAttach == enums.eHotspotAttach.top) {
                    y = pos.top;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.bottom) {
                    y = pos.top + pos.height;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.left) {
                    x = pos.left;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.right) {
                    x = pos.left + pos.width;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.topLeft) {
                    y = pos.top;
                    x = pos.left;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.topRight) {
                    y = pos.top;
                    x = pos.left + pos.width;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.bottomLeft) {
                    y = pos.top + pos.height;
                    x = pos.left;
                }
                else if (hotspot.popupAttach == enums.eHotspotAttach.bottomRight) {
                    y = pos.top + pos.height;
                    x = pos.left + pos.width;
                }
                x += hotspot.popupOffsetX;
                y += hotspot.popupOffsetY;
                if (hotspot.keepPopupInViewer && hotspot.open) {
                    var $popup = $('#kb-hotspot__popup-' + hotspot.id);
                    var popupHeight = $popup.height();
                    var popupWidth = $popup.width();
                    if (y < 0)
                        y = 0;
                    if (y + popupHeight > this.hotspotDiv.clientHeight) {
                        y = Math.round(this.hotspotDiv.clientHeight - popupHeight);
                    }
                    if (x < 0)
                        x = 0;
                    if (x + popupWidth > this.hotspotDiv.clientWidth) {
                        x = Math.round(this.hotspotDiv.clientWidth - popupWidth);
                    }
                }
                hotspot.popupTop = y.toString() + 'px';
                hotspot.popupLeft = x.toString() + 'px';
                hotspot.popupRight = 'auto';
                hotspot.popupBottom = 'auto';
            }
        };
        SceneViewer.prototype.getAllHotspots = function () {
            var allHotspots = [];
            var allUiConfigs = [this.uiConfig].concat(this.uiConfig.getAllConfigurators());
            for (var _i = 0, allUiConfigs_1 = allUiConfigs; _i < allUiConfigs_1.length; _i++) {
                var uic = allUiConfigs_1[_i];
                if (uic.$sceneConfigurator && (uic == this.uiConfig || uic.$nestHotspots))
                    allHotspots.pushArray(uic.$sceneConfigurator.hotspots);
            }
            return allHotspots;
        };
        return SceneViewer;
    }());

    var HandlerDb = /** @class */ (function () {
        function HandlerDb(sceneApi, sceneService) {
            this.sceneApi = sceneApi;
            this.sceneService = sceneService;
            // public byHandler: { [handlerId: string]: T } = {};
            this.byNode = {};
        }
        HandlerDb.prototype.clear = function () {
            // this.byHandler = {};
            this.byNode = {};
        };
        HandlerDb.prototype.clearTransient = function () {
            for (var key in this.byNode) {
                var h = this.byNode[key];
                if (h) {
                    var removed = h.removeWhere(function (h1) { return h1.addedByRuleType && h1.addedByRuleType.equalsAny(enums.eRuleType.value, enums.eRuleType.scene); });
                    if (removed && removed.length && !h.length) {
                        delete this.byNode[key];
                    }
                }
            }
        };
        HandlerDb.prototype.addToDb = function (id, handler) {
            if (!this.byNode.hasOwnProperty(id)) {
                this.byNode[id] = [];
            }
            this.byNode[id].push(handler);
        };
        HandlerDb.prototype.add = function (node, handlerId, handler) {
            var _this = this;
            var hotspotId = handler.hotspotId;
            if (hotspotId) {
                //for non-mesh hotspots, we just add the hotspot id to the clickdb
                this.addToDb(hotspotId, handler);
            }
            else {
                var query = this.sceneService.getQueryObject(this.sceneApi, node, null);
                var matchingNodes = this.sceneApi.cache.paths.getIds(query);
                matchingNodes.forEach(function (matchingNode) {
                    _this.addToDb(matchingNode, handler);
                });
            }
            //add the node id to map to itself
            // db.nodeMap[args.modelId] = args.modelId;
            //add children of the node to the map
            // this.sceneService.getChildNodeIds(this.sceneApi, args.modelId).forEach(i => db.nodeMap[i] = args.modelId);
            // }
        };
        return HandlerDb;
    }());
    var ClaraSceneRuleArgs = /** @class */ (function () {
        function ClaraSceneRuleArgs(viewer) {
            this.viewer = viewer;
            this.logs = new _rules.ClientLogger();
            this.isMobile = viewer.isMobile;
        }
        // public upload() {
        //     return this.viewer.upload();
        // }
        // TODO:  remove in future.  It's only here for backwards compatibility.  It's true place now is in SceneUtilities
        ClaraSceneRuleArgs.prototype.addModelClickHandler = function (args) {
            this.sceneUtils.addModelClickHandler(args);
        };
        ClaraSceneRuleArgs.prototype.addDraggable = function (args) {
            this.sceneUtils.addDraggable(args);
        };
        ClaraSceneRuleArgs.prototype.playSceneAnimation = function (args) {
            // DEPRECATED
        };
        ClaraSceneRuleArgs.prototype.toggleSceneAnimation = function () {
            // DEPRECATED
        };
        ClaraSceneRuleArgs.prototype.sendMessage = function (msg) {
            this.viewer.sendMessage(msg);
        };
        ClaraSceneRuleArgs.prototype.selectPage = function (page) {
            if (this.viewer.navigateToElement) {
                this.viewer.navigateToElement(page);
            }
        };
        ClaraSceneRuleArgs.prototype.convertCurrency = function (obj) {
            return null;
        };
        ClaraSceneRuleArgs.prototype.toggleTool = function (args) {
            this.viewer.sceneService.toggleTool(this.sceneApi, args);
            if (args.tool == "orbit") {
                this.viewer.sceneConfig.allowOrbit = args.enabled;
            }
            else if (args.tool == "pan") {
                this.viewer.sceneConfig.allowPan = args.enabled;
            }
            else if (args.tool == "zoom") {
                this.viewer.sceneConfig.allowZoom = args.enabled;
            }
        };
        ClaraSceneRuleArgs.prototype.constrainCamera = function (args) {
            this.viewer.sceneService.constrainCamera(this.sceneApi, args);
        };
        ClaraSceneRuleArgs.prototype.getUploadImageNode = function (args) {
            var a = this.sceneApi.importedImages[this.configurator.name + "_" + args.fieldId];
            return a ? a.imageNodeId : null;
        };
        ClaraSceneRuleArgs.prototype.getTables = function (args) {
            var _this = this;
            return new _rules.KPromise(args.ids.map(function (tid) { return _this.viewer.tableArraysDb[tid]; }));
        };
        return ClaraSceneRuleArgs;
    }());
    var ClaraViewer = /** @class */ (function (_super) {
        __extends(ClaraViewer, _super);
        function ClaraViewer(cArgs) {
            var _this = _super.call(this, cArgs) || this;
            _this.hovers = [];
            /**
             * in the form of {annotationId: hotspotId}
             */
            _this.annotationToHotspotDb = {};
            /**
             * stores what scene Id's we've already prefetched so we don't bother prefetching them again.
             * Once they are prefetched they are in the browser cache.
             */
            _this.prefetchedScenes = {};
            // protected getDragOffset(ev: clara2.IMouseEvent, d: IDraggable): THREE.Vector3 {
            //     let three = this.sceneService.getThree(this.sceneApi);
            //     let referPoint = new three.Vector3();
            //     let offset = new three.Vector3(0, 0, 0);
            //     let ray: THREE.Ray = void 0;
            //     if (d.mode == eDragMode.plane) {
            //         if (ev.eventRay) {
            //             ray = ev.eventRay.ray;
            //         } /*else {
            //         let rect = this.elem.getBoundingClientRect();
            //         let ndc = { //normalized device coordinates.  x & y should be between -1 and 1
            //             x: (2 * ev.clientX - rect.width) / rect.width,
            //             y: (rect.height - 2 * ev.clientY) / rect.height
            //         };
            //         ray = store.getTranslator().getCameraMouseRay(ndc).ray;
            //     }*/
            //         if (d.mode == eDragMode.plane) {
            //             let moveOnPlane = new three.Plane();
            //             let moveOnNormal = new three.Vector3();
            //             moveOnNormal.set(d.normal.x, d.normal.y, d.normal.z);
            //             moveOnPlane.set(moveOnNormal, -(d.distanceFromOrigin || 0)); //plane.constant);
            //             if (!ray.intersectsPlane(moveOnPlane)) return;
            //             ray.intersectPlane(moveOnPlane, referPoint);
            //         }
            //         var nodeMatrix = this.sceneApi.api.scene.getWorldTransform(d.$activeNode.id);
            //         var nodePosition = new three.Vector3().setFromMatrixPosition(nodeMatrix);
            //         offset = referPoint.sub(nodePosition);
            //     }
            //     return offset;
            // }
            // /** draggables store the nodes they match, but since they support regex too, at some point we need to run those searches to find the matching nodes to compare against for mouse events */
            // protected fillDraggables() {
            //     let sceneApi = this.sceneApi;
            //     for (let d of sceneApi.draggables) {
            //         //get all of the matching node id's to the query provided, and cache for fast retrieval
            //         if (!d.$matchingNodes) {
            //             d.$matchingNodes = {};
            //             let query = this.sceneService.getQueryObject(sceneApi, d.objectId, d.name);
            //             sceneApi.cache.paths.getIds(query).forEach(id => d.$matchingNodes[id] = {});
            //             //also get all of the children of the matching nodes
            //             // for (let mid in d.$matchingNodes) {
            //             //     sceneApi.cache.paths.getIds({ from: mid }).forEach(id => d.$matchingNodes[mid][id] = null);
            //             // }
            //         }
            //     }
            // }
            _this._clickAlreadyHandled = false; //during drags, the mousedown might initiate the click event.  We mark whether it has, so the click handler can ignore.
            _this.hotspotCounter = 0;
            _this.processingMouseOver = false;
            _this.sceneService = cArgs.sceneService;
            _this.playerUrl = cArgs.playerUrl;
            _this.ocLazyLoad = cArgs.ocLazyLoad;
            _this.sceneApi = {
                isMobile: cArgs.isMobile,
                isRender: _this.isRender,
                clientLanguage: cArgs.clientLanguage,
                sceneDb: cArgs.sceneDb,
                onSceneNested: function (nested, nodeId) { return _this.onSceneNested(nested, nodeId); },
                afterSetProperty: function (setArgs) { return _this.afterSetProperty(setArgs); },
                afterAnimateProperty: function (setArgs) { return _this.afterAnimateProperty(setArgs); },
                addModelClickHandler: function (args) { return _this.sceneApi.clickDb.add(args.modelId, args.uniqueId, args); },
                clearClickHandlers: function () { return _this.sceneApi.clickDb = new HandlerDb(_this.sceneApi, _this.sceneService); },
                addDraggable: function (args) { return _this.sceneApi.draggableDb.add(args.objectId, args.uniqueId, args); },
                clearDraggables: function () { return _this.sceneApi.draggableDb = new HandlerDb(_this.sceneApi, _this.sceneService); },
                sendMessage: function (msg) { return _this.sendMessage(msg); },
                fetchedScenes: {},
                importedImages: {},
                getTables: function (args) { return new _rules.KPromise(args.ids.map(function (tid) { return _this.tableArraysDb[tid]; })); },
                cameraAnimationInProgress: false,
                // cameraAnimationPromise: new KPromise(null)
                highlights: { user: {}, hover: {}, selection: {} },
                selectedNodes: []
            };
            _this.sceneApi.clickDb = new HandlerDb(_this.sceneApi, _this.sceneService);
            _this.sceneApi.draggableDb = new HandlerDb(_this.sceneApi, _this.sceneService);
            _this.sceneApi.cache = new SceneCache(_this.sceneApi);
            //this.$scope = this.controllerScope.$new();
            _this.$scope.hotspotClick = function ($event, ann) { return _this.hotspotClick($event, ann); };
            _this.$scope.hotspotCloseClick = function ($event, ann) { return _this.hotspotCloseClick($event, ann); };
            // this.$scope.vrMode = false;
            // this.$scope.toggleVrMode = () => this.toggleVrMode();
            // this.$scope.arMode = false;
            // this.$scope.toggleArMode = () => this.toggleArMode();
            _tools.Utils.supportsVr().then(function (res) { return _this.$scope.supportsVr = res; });
            _this.$scope.allHotspots = [];
            return _this;
        }
        ClaraViewer.detectWebGL = function () {
            try {
                var canvas = document.createElement("canvas");
                return !!(window.WebGLRenderingContext &&
                    (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")));
            }
            catch (e) {
                return false;
            }
        };
        ClaraViewer.prototype.init = function () {
            var _this = this;
            return this.ocLazyLoad.load(this.playerUrl).then(function () {
                // initialize clara viewer
                _this.createElem();
                var api = claraplayer(_this.elem);
                _this.sceneApi.api = api;
                ["orbit", "pan", "zoom", "home", "fullscreen", "vrSettings", "arMode"].forEach(function (s) {
                    return api.player.hideTool(s);
                }); // hide the icons         
                api.player.removeTool("select");
                // turn off the thumbnail
                api.player.displayThumbnail(false);
                // setup highlighting
                _this.sceneApi.highlighter = api.selection.setHighlighting(true, { color: _this.highlightColor, thickness: 2 });
                /* we use both the customAnnotationFn (for when a hotspot is tied to an annotation) and
                useCustomOverlay for hotspots that are tied to other types of nodes.
                We can't use useCustomOverlay for both because annotations aren't loaded into the scene
                and getScenePosition(idAnnotation) won't work as a result */
                api.annotations.useCustomAnnotationFunction(function (a, d) { return _this.annotationFn(a, d); });
                api.annotations.useCustomOverlayFunction(function (d) { return _this.customOverlayFn(d); });
                _this.createHotspotElem();
                // add click event
                api.player.addTool({
                    click: function (event) { return _this.click(event); }
                }, "ComponentClick");
                // add hover event
                api.player.addTool({
                    hover: function (event) { return _this.hover(event); }
                }, "Hover");
                // add hover event
                api.player.addTool({
                    mousedown: function (event) { return _this.mousedown(event); }
                }, "Mousedown");
            });
        };
        ClaraViewer.prototype.loadSceneInternal = function (loadSceneArgs) {
            var _this = this;
            // flush out stuff that needs to be flushed
            this.clearHandlers();
            this.annotationToHotspotDb = {};
            this.sceneApi.cache = new SceneCache(this.sceneApi);
            this.sceneApi.highlights = { user: {}, hover: {}, selection: {} };
            this.sceneApi.selectedNodes = [];
            var api = this.sceneApi.api;
            if (loadSceneArgs.clearMemory) {
                this.sceneApi.api.sceneIO.clearScene();
                this.sceneApi.fetchedScenes = {}; // clear out the fetched scenes since they were just cleared out of memory
                this.sceneApi.importedImages = {};
            }
            // toggle tools based on initial scene configurator properties
            this.toggleTools();
            if (this.sceneConfig.constrainCameraToRadius) {
                this.sceneService.constrainCamera(this.sceneApi, {
                    constrain: this.sceneConfig.constrainCameraToRadius,
                    radius: this.sceneConfig.cameraRadius
                });
            }
            // 'rendered' event is when the loading animation is done - we might want to use this when clearing memory
            // new loading animation too
            // turn thumbnail off with displayThumbnail in player
            var rulesRun = false; // to get around a bug in clara where resize causes the loaded event to fire
            api.on("loaded", function () {
                if (!rulesRun) {
                    rulesRun = true;
                    _this.sceneApi.hierarchicalVisibility = _this.sceneService.isHierarchicalVisibilityEnabled(_this.sceneApi);
                    _this.shimThree(_this.sceneApi);
                    _this.runLoadedRule(_this.getRuleArgs(enums.eRuleType.sceneLoaded)).then(function () {
                        if (_this.sceneApi.api.commands.isCommandEnabled) {
                            // need to check armode here because it's calculation is delayed
                            _this.$scope.arEnabled = _this.sceneApi.api.commands.isCommandEnabled("arMode");
                        }
                        _this.$timeout(function () { return _this.resize(); }, 0);
                        // prefetch all scenes so that nested scenes and d&d components load faster
                        _this.prefetchScenes(_this.sceneApi);
                    });
                }
            });
            this.sceneApi.fetchedScenes[this.sceneConfig.claraId] = api.sceneIO.fetchAndUse(this.sceneConfig.claraId, this.scene.publishHash, { waitForPublish: true });
            this.prefetchedScenes[this.sceneConfig.claraId] = null;
            return this.loadDeferred.promise;
        };
        ClaraViewer.prototype.toggleTools = function () {
            // toggle tools based on initial scene configurator properties
            this.sceneService.toggleTool(this.sceneApi, { tool: "orbit", enabled: this.sceneConfig.allowOrbit });
            this.sceneService.toggleTool(this.sceneApi, { tool: "pan", enabled: this.sceneConfig.allowPan });
            this.sceneService.toggleTool(this.sceneApi, { tool: "zoom", enabled: this.sceneConfig.allowZoom });
            if (this.sceneConfig.allowOrbit)
                this.sceneApi.api.commands.activateCommand("orbit");
            else if (this.sceneConfig.allowPan)
                this.sceneApi.api.commands.activateCommand("pan");
            else if (this.sceneConfig.allowZoom)
                this.sceneApi.api.commands.activateCommand("zoom");
        };
        ClaraViewer.prototype.runLoadedRule = function (ruleArgs) {
            var _this = this;
            // run the loaded rule of the scene
            this.setFieldsIfStandalone();
            return this.ruleService.runRuleTypeAsync(this.sceneConfig, enums.eRuleType.sceneLoaded, ruleArgs).then(function (loadedRuleResult) {
                _this.handleRuleError(enums.eRuleType.sceneLoaded, loadedRuleResult);
                return _this.runRules(false).then(function () {
                    _this.notifyLoaded();
                });
            });
        };
        ClaraViewer.prototype.mousedown = function (event) {
            var _this = this;
            var sceneApi = this.sceneApi;
            var api = sceneApi.api;
            this._clickAlreadyHandled = false;
            //search for draggables
            if (Object.keys(sceneApi.draggableDb.byNode).length) {
                // this.fillDraggables();
                var hits = this.currentFilterNodes = api.player.filterNodesFromPosition(event);
                var hit = hits.first();
                var activeDrag_1 = null;
                var activeNodeId_1 = this.sceneService.findAncestorNodeId(this.sceneApi, hit, function (nid) {
                    activeDrag_1 = sceneApi.draggableDb.byNode[nid] ? sceneApi.draggableDb.byNode[nid].first() : null;
                    return activeDrag_1 != null;
                });
                if (activeDrag_1) {
                    //ok we have an active drag, so we select the node
                    this.sceneService.select(sceneApi, { id: activeNodeId_1 });
                    var dragStarted_1 = false;
                    var sceneUtils = this.sceneService.getSceneUtilities(sceneApi, enums.eRuleType.scene, {}, null);
                    var dragNode_1 = activeDrag_1.$activeNode = sceneUtils.getNode({ id: activeNodeId_1 });
                    var three_1 = this.sceneService.getThree(sceneApi);
                    var startPos_1 = (new three_1.Vector3()).setFromMatrixPosition(api.scene.getWorldTransform(activeNodeId_1));
                    // let offset = this.getDragOffset(event, activeDrag);
                    //console.log({ event: "beforeDrag", x: startPos.x, y: startPos.y, z: startPos.z });
                    //and we start the nodeMove command so they can drag it
                    api.commands.setCommandOptions('nodeMove', {
                        displayGizmo: false,
                        mode: activeDrag_1.mode,
                        plane: activeDrag_1.mode == enums.eDragMode.plane ? { normal: activeDrag_1.normal, constant: activeDrag_1.distanceFromOrigin ? -activeDrag_1.distanceFromOrigin : 0 } : null,
                        surfaceNodeIds: activeDrag_1.mode == enums.eDragMode.surface ? (Array.isArray(activeDrag_1.surfaceNodes) ? activeDrag_1.surfaceNodes : [activeDrag_1.surfaceNodes]) : null,
                        keepOffset: true,
                        shouldMove: function (event, newPos, data) {
                            // offset && newPos.sub(offset); // temp fix for clara bug:  https://github.com/Exocortex/ExocortexKBMax/issues/208
                            var hitData = data ? data.first() : null;
                            var uv = hitData ? hitData.uv : null;
                            var args = { dragNode: dragNode_1, startPos: startPos_1, newPos: newPos, allow: true, relativeSurfacePos: uv };
                            if (!dragStarted_1) {
                                dragStarted_1 = true;
                                activeDrag_1.dragStart && activeDrag_1.dragStart(args);
                                //console.log({ event: "dragStart", x: args.newPos.x, y: args.newPos.y, z: args.newPos.z });
                            }
                            if (activeDrag_1.dragging && dragStarted_1) {
                                activeDrag_1.dragging(args);
                                //console.log({ event: "dragging", x: args.newPos.x, y: args.newPos.y, z: args.newPos.z });
                            }
                            // offset && newPos.add(offset); // temp fix for clara bug:  https://github.com/Exocortex/ExocortexKBMax/issues/208
                            return args.allow;
                        },
                        // updatePosition: (newPos, surface) => {
                        //     newPos.sub(offset); // temp fix for clara bug:  https://github.com/Exocortex/ExocortexKBMax/issues/208
                        //     let args = { dragNode, startPos, newPos } as IDragArgs;
                        //     if (activeDrag.dragging) {
                        //         activeDrag.dragging(args);
                        //     }
                        //     newPos.add(offset); // temp fix for clara bug:  https://github.com/Exocortex/ExocortexKBMax/issues/208
                        // },
                        onEnd: function (event) {
                            _this.$timeout(function () {
                                //if the drag never started, then we don't have a drop event
                                if (dragStarted_1) {
                                    var args = { dragNode: dragNode_1, allow: true, startPos: startPos_1, newPos: (new three_1.Vector3()).setFromMatrixPosition(api.scene.getWorldTransform(activeNodeId_1)), relativeSurfacePos: null };
                                    activeDrag_1.dropped && activeDrag_1.dropped(args);
                                    //console.log({ event: "dropped", x: args.newPos.x, y: args.newPos.y, z: args.newPos.z });
                                }
                                _this.toggleTools();
                                sceneApi.activeDrag = null;
                                _this.click(event);
                            });
                        }
                    });
                    api.commands.runCommand("nodeMove");
                }
                else {
                    this.sceneService.clearSelection(sceneApi);
                    this.toggleTools();
                    sceneApi.activeDrag = null;
                }
            }
        };
        ClaraViewer.prototype.click = function (event) {
            var _this = this;
            if (!this._clickAlreadyHandled) {
                this._clickAlreadyHandled = true;
                this.$timeout(function () {
                    _this.clearAnnotations();
                    var db = _this.sceneApi.clickDb;
                    //let idsToFilterBy = Object.keys(db.nodeMap);
                    var nodeIds = _this.currentFilterNodes || _this.sceneApi.api.player.filterNodesFromPosition(event /*, null, { nodes: idsToFilterBy }*/);
                    //clear out our stored results
                    _this.currentFilterNodes = null;
                    if (nodeIds && nodeIds.length) {
                        var nodeId = nodeIds[0];
                        if (db) {
                            // check if this node or any of it's parents have a click event
                            var parentId = nodeId;
                            var _loop_1 = function () {
                                if (db.byNode.hasOwnProperty(parentId)) {
                                    var sceneUtils = _this.sceneService.getSceneUtilities(_this.sceneApi, enums.eRuleType.scene, {}, null);
                                    var clickArgs_1 = { clickedNode: sceneUtils.getNode({ id: parentId }), propogate: false };
                                    db.byNode[parentId].forEach(function (h) { return h.handler(clickArgs_1); });
                                    if (!clickArgs_1.propogate)
                                        return "break";
                                }
                                parentId = _this.sceneService.getParentNodeId(_this.sceneApi, parentId);
                            };
                            while (parentId) {
                                var state_1 = _loop_1();
                                if (state_1 === "break")
                                    break;
                            }
                        }
                    }
                    else {
                        //empty space was clicked.  See if there was a handler put on the root scene node
                        var rootSceneId = _this.sceneService.getRootSceneId(_this.sceneApi);
                        if (db.byNode.hasOwnProperty(rootSceneId)) {
                            var sceneUtils = _this.sceneService.getSceneUtilities(_this.sceneApi, enums.eRuleType.scene, {}, null);
                            var clickArgs_2 = { clickedNode: sceneUtils.getNode({ id: rootSceneId }), propogate: false };
                            db.byNode[rootSceneId].forEach(function (h) { return h.handler(clickArgs_2); });
                        }
                    }
                });
            }
        };
        ClaraViewer.prototype.hover = function (event) {
            var clickdb = this.sceneApi.clickDb;
            var dragdb = this.sceneApi.draggableDb;
            if ((Object.keys(clickdb.byNode).length || Object.keys(dragdb.byNode).length) && !this.sceneApi.cameraAnimationInProgress && !this.sceneApi.activeDrag) {
                if (this.processingMouseOver)
                    return;
                this.processingMouseOver = true;
                //let idsToFilterBy = Object.keys(db.nodeMap);
                var nodeIds = this.sceneApi.api.player.filterNodesFromPosition(event /*, null, { nodes: idsToFilterBy }*/);
                if (nodeIds && nodeIds.length) {
                    var nodeId = nodeIds[0];
                    // find the closest ancestor node with a click handler on it
                    var hoverParentId = this.sceneService.findAncestorNodeId(this.sceneApi, nodeId, function (nid) { return (clickdb.byNode.hasOwnProperty(nid) || dragdb.byNode.hasOwnProperty(nid)); });
                    if (hoverParentId) {
                        if (this.hoverParentId != hoverParentId) {
                            this.clearMouseOver();
                            this.hoverParentId = hoverParentId;
                            // now we have the parent that has the click handler.  
                            // The parent and all of it's children should have their materials changed
                            this.setMouseOverEffectRecursive(this.sceneApi, hoverParentId);
                            var handlers = clickdb.byNode[hoverParentId];
                            handlers && handlers.forEach(function (arg) {
                                if (arg.hotspot)
                                    arg.hotspot.$hover = true;
                            });
                        }
                    }
                    else {
                        this.clearMouseOver();
                    }
                }
                else {
                    this.clearMouseOver();
                }
                this.processingMouseOver = false;
            }
            else {
                this.clearMouseOver();
            }
        };
        ClaraViewer.prototype.shimThree = function (sceneApi) {
            var three = sceneApi.api.player.getThree().THREE;
            if (!three.$originalUpdateMatrixWorld) {
                three.$originalUpdateMatrixWorld = three.Object3D.prototype.updateMatrixWorld;
            }
            if (sceneApi.hierarchicalVisibility) {
                //THREE traverses from parent down updating the matrix world on every pass
                //But it doesn't pay attention to hierarchical visibility
                three.Object3D.prototype.updateMatrixWorld = function (force) {
                    if (!this.visible)
                        return;
                    three.$originalUpdateMatrixWorld.apply(this, arguments);
                };
            }
            else {
                three.Object3D.prototype.updateMatrixWorld = three.$originalUpdateMatrixWorld;
            }
            /** override updateMatrix to add in a cache for the matrix vectors, so
             *  we're only rebuilding it when we have to.  Makes a big difference on render frame rates
             */
            three.Object3D.prototype.updateMatrix = function () {
                var createdCache = false;
                if (!this._positionCache) {
                    this._positionCache = new three.Vector3();
                    this._quaternionCache = new three.Quaternion();
                    this._scaleCache = new three.Vector3(1, 1, 1);
                    this._visibleCache = this.visible;
                    createdCache = true;
                }
                if (createdCache ||
                    (!this._positionCache.equals(this.position)
                        || !this._quaternionCache.equals(this.quaternion)
                        || !this._scaleCache.equals(this.scale)
                        || this.visible != this._visibleCache)) {
                    this.matrix.compose(this.position, this.quaternion, this.scale);
                    this.matrixWorldNeedsUpdate = true;
                    this._positionCache.copy(this.position);
                    this._quaternionCache.copy(this.quaternion);
                    this._scaleCache.copy(this.scale);
                    this._visibleCache = this.visible;
                }
            };
        };
        ClaraViewer.prototype.prefetchScenes = function (sceneApi) {
            var _this = this;
            Object.keys(sceneApi.sceneDb).forEach(function (idScene) {
                if (!_this.prefetchedScenes.hasOwnProperty(sceneApi.sceneDb[idScene].claraId)) {
                    _this.prefetchedScenes[sceneApi.sceneDb[idScene].claraId] = null;
                    sceneApi.api.sceneIO.prefetch(sceneApi.sceneDb[idScene].claraId, sceneApi.sceneDb[idScene].publishHash, { waitForPublish: true });
                }
            });
        };
        ClaraViewer.prototype.getRuleArgs = function (ruleType) {
            var args = new ClaraSceneRuleArgs(this);
            args.configurator = this.sceneConfig.idProduct ? this.uiConfig : this.sceneConfig;
            args.kom = args.configurator.$manager;
            args.parentKom = args.configurator.$parentConfigurator ? args.configurator.$parentConfigurator.$manager : null;
            args.sceneKom = this.sceneConfig.$manager;
            args.sceneApi = this.sceneApi;
            args.isRender = this.isRender;
            args.sceneUtils = this.sceneService.getSceneUtilities(this.sceneApi, ruleType);
            args.clientLanguage = this.clientLanguage;
            return args;
        };
        ClaraViewer.prototype.resolveHotspotTargetNode = function (hotspot) {
            var idMap = hotspot.$parentConfigurator.$sceneIdMap;
            var targetNode = hotspot.targetNode;
            if (idMap) {
                targetNode = idMap[hotspot.targetNode] || hotspot.targetNode;
            }
            return targetNode;
        };
        ClaraViewer.prototype.customOverlayFn = function (div) {
            var _this = this;
            var db = this.sceneApi.clickDb;
            var hotspotProcessed = false;
            var _loop_2 = function (hotspot) {
                if (hotspot.target && hotspot.targetNode && hotspot.visible) {
                    hotspotProcessed = true;
                    var resolvedTargetNode = this_1.resolveHotspotTargetNode(hotspot);
                    var pos = this_1.sceneApi.api.scene.getScreenPosition(resolvedTargetNode);
                    if (pos) {
                        this_1.positionHotspot(pos, hotspot);
                    }
                    if (hotspot.targetShape == enums.eHotspotShape.mesh && resolvedTargetNode) {
                        if (!db.byNode.hasOwnProperty(resolvedTargetNode) || !db.byNode[resolvedTargetNode].some(function (h) { return h.hotspot == hotspot; })) {
                            this_1.sceneApi.addModelClickHandler({
                                modelId: resolvedTargetNode,
                                uniqueId: hotspot.$uid,
                                handler: function () { return _this.hotspotClick({}, hotspot); },
                                hotspot: hotspot
                            });
                        }
                    }
                }
                if (hotspot.targetShape == enums.eHotspotShape.mesh && !hotspot.visible) {
                    var resolvedTargetNode = this_1.resolveHotspotTargetNode(hotspot);
                    // remove from click db if the hotspot is invisible
                    if (resolvedTargetNode) {
                        if (db.byNode[resolvedTargetNode]) {
                            db.byNode[resolvedTargetNode].removeWhere(function (a) { return a.uniqueId == hotspot.$uid; });
                            if (db.byNode[resolvedTargetNode].length == 0) {
                                delete db.byNode[resolvedTargetNode];
                            }
                        }
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = this.$scope.allHotspots; _i < _a.length; _i++) {
                var hotspot = _a[_i];
                _loop_2(hotspot);
            }
            // call digest manually on this scope instead of scope.$apply because $apply starts 
            // at the root and digests everything.We only want to affect the hotspots here.
            if (hotspotProcessed) { //this can be expensive, so only run if there is something to update
                this.$scope.$digest();
            }
        };
        ClaraViewer.prototype.annotationFn = function (annotation, div) {
            // we don't call scope.$apply here because it's too slow, and the scope.$apply 
            // in the customOverlayFn takes care of making sure everything is updated anyways.
            // it's better in the customOverlay because that is only called once per global update, 
            // whereas this is called once for each annotation.
            // find the hotspot
            var hotspot = this.annotationToHotspotDb[annotation.id];
            // if it's an orphan annotation, then stop searching for it
            if (!hotspot && !this.annotationToHotspotDb.hasOwnProperty(annotation.id)) {
                hotspot = this.$scope.allHotspots.find(function (h) { return h.targetNode == annotation.id; });
                this.annotationToHotspotDb[annotation.id] = hotspot;
            }
            if (hotspot) {
                hotspot.alpha = annotation.alpha;
                var pos = {
                    x: annotation.left,
                    y: annotation.top,
                    top: annotation.top,
                    left: annotation.left,
                    width: 0,
                    height: 0
                };
                this.positionHotspot(pos, hotspot);
            }
        };
        ClaraViewer.prototype.hotspotClick = function ($event, hotspot) {
            var _this = this;
            hotspot.open = true;
            this.hotspotCounter++;
            hotspot.$zindex = this.hotspotCounter;
            if (hotspot.idCamera) {
                this.sceneService.animateCamera(this.sceneApi, {
                    duration: hotspot.animationDuration,
                    toCameraId: hotspot.idCamera,
                    easing: hotspot.animationEasing
                });
            }
            var clickDb = this.sceneApi.clickDb;
            if (clickDb) {
                var nestedNullId = hotspot.$parentConfigurator.$uiConfigurator.$nestedSceneId;
                var handlerId = nestedNullId ? nestedNullId + "-" + hotspot.id : hotspot.id;
                if (clickDb.byNode.hasOwnProperty(handlerId)) {
                    var clickArgs_3 = { propogate: false };
                    clickDb.byNode[handlerId].forEach(function (h) { return h.handler(clickArgs_3); });
                }
            }
            // some hotspot popups start off the screen because the height can't be calculated until it's shown
            // so we need to offload to recalculate the hotspot position after the digest
            this.$timeout(function () {
                var pos = _this.sceneApi.api.scene.getScreenPosition(_this.resolveHotspotTargetNode(hotspot));
                if (pos) {
                    _this.positionHotspot(pos, hotspot);
                }
            });
        };
        ClaraViewer.prototype.hotspotCloseClick = function ($event, hotspot) {
            $event.stopPropagation();
            hotspot.open = false;
        };
        ClaraViewer.prototype.clearAnnotations = function () {
            for (var _i = 0, _a = this.$scope.allHotspots; _i < _a.length; _i++) {
                var h = _a[_i];
                if (h.target && h.allowClose) {
                    h.open = false;
                }
            }
        };
        // protected toggleVrMode() {
        //     if (this.$scope.vrMode) {
        //         this.sceneApi.api.commands.deactivateCommand("vrMode");
        //     } else {
        //         this.sceneApi.api.commands.activateCommand("vrMode");
        //     }
        // }
        // protected toggleArMode() {
        //     if (this.$scope.vrMode) {
        //         this.sceneApi.api.commands.deactivateCommand("arMode");
        //     } else {
        //         this.sceneApi.api.commands.runCommand("arMode");
        //         // this.sceneApi.api.commands.activateCommand("arMode");
        //     }
        // }
        ClaraViewer.prototype.afterSetProperty = function (setArgs) {
            // if (setArgs.plug.isEqual("material") && setArgs.operator.isEqual("physical")) {
            //     let mouseOverMatId = this.hoverMaterialDb.get(setArgs.objectId);
            //     if (mouseOverMatId) {
            //         setArgs.objectId = mouseOverMatId;
            //         this.sceneService.setProperty(this.sceneApi, setArgs);
            //     }
            // }
        };
        ClaraViewer.prototype.afterAnimateProperty = function (animateArgs) {
            // if (animateArgs.plug.isEqual("material") && animateArgs.operator.isEqual("physical")) {
            //     let mouseOverMatId = this.hoverMaterialDb.get(animateArgs.objectId);
            //     if (mouseOverMatId) {
            //         animateArgs.objectId = mouseOverMatId;
            //         this.sceneService.animate(this.sceneApi, animateArgs);
            //     }
            // }
        };
        ClaraViewer.prototype.onSceneNested = function (nestedConfig, nullNodeId) {
            var _this = this;
            // setup auto click to select page
            if (nestedConfig.$parentConfigurator.nestedSceneClickToSelect) {
                this.sceneApi.addModelClickHandler({
                    modelId: nullNodeId,
                    uniqueId: _tools.Utils.shortId(),
                    handler: function () {
                        _this.navigateToElement(nestedConfig);
                    }
                });
            }
        };
        ClaraViewer.prototype.clearHandlers = function () {
            this.sceneApi.draggableDb && this.sceneApi.draggableDb.clear();
            this.sceneApi.clickDb && this.sceneApi.clickDb.clear();
        };
        ClaraViewer.prototype.clearMouseOver = function () {
            // clear out old mouse over
            this.sceneService.clearHighlightsOfType(this.sceneApi, exports.eHighlightType.hover);
            this.hovers.clear();
            this.hoverParentId = null;
            this.elem.style.cursor = "default";
            for (var _i = 0, _a = this.$scope.allHotspots; _i < _a.length; _i++) {
                var h = _a[_i];
                h.$hover = false;
            }
        };
        // TODO:  remove this
        ClaraViewer.prototype.findAncestorNode = function (node, callback) {
            var parent = node;
            while (parent) {
                if (callback(parent))
                    break;
                parent = parent.parentNode();
            }
            return parent;
        };
        ClaraViewer.prototype.setMouseOverEffectRecursive = function (sceneApi, nodeId) {
            if (nodeId) {
                var api = sceneApi.api;
                api.scene.get({ id: nodeId, property: "type" });
                this.hovers.push({ nodeId: nodeId });
                this.sceneService.highlight(sceneApi, { id: nodeId, on: true }, exports.eHighlightType.hover);
                this.elem.style.cursor = "pointer";
            }
        };
        // public addModelClickHandler(args: IAddModelClickHandlerArgs) {
        //     let db = this.sceneApi.clickDb;
        //     // only add it to the list of handlers if the id doesn't already have a handler associated
        //     if (!db.byHandler.hasOwnProperty(args.uniqueId)) {
        //         db.byHandler[args.uniqueId] = args;
        //         // get all nodes that match the given query
        //         let query = this.sceneService.getQueryObject(this.sceneApi, args.modelId, null);
        //         let matchingNodes = this.sceneApi.cache.paths.getIds(query);
        //         matchingNodes.forEach(matchingNode => {
        //             if (!db.byNode.hasOwnProperty(matchingNode)) {
        //                 db.byNode[matchingNode] = [];
        //             }
        //             db.byNode[matchingNode].push(args);
        //         });
        //         //add the node id to map to itself
        //         // db.nodeMap[args.modelId] = args.modelId;
        //         //add children of the node to the map
        //         // this.sceneService.getChildNodeIds(this.sceneApi, args.modelId).forEach(i => db.nodeMap[i] = args.modelId);
        //     }
        // }
        // public addDraggable(d: IDraggable) {
        //     let sceneApi = this.sceneApi;
        //     d.$matchingNodes = {};
        //     let query = this.sceneService.getQueryObject(sceneApi, d.objectId, d.name);
        //     sceneApi.cache.paths.getIds(query).forEach(id => d.$matchingNodes[id] = {});
        // }
        ClaraViewer.prototype.resize = function () {
            if (this.$scope.loaded) {
                this.sceneApi.api.player.resize();
            }
        };
        // public upload(): ng.IPromise<string> {
        //     // without streamchanges, the upload needs to do the following:
        //     // 1.  Upload the file to kbmax server
        //     // 2.  kbmax server imports the file to a public scene in clara that is strictly for uploads
        //     // 3.  now our client makes a call to importNode into this scene
        //     // 4.  in the callback of importNode, we can finally get back to the rule with the uploaded file
        //     return this.uploadService.promptUserToChooseFile().then(file => {
        //         // post the upload to kbmax
        //         let url = "api/scenes/upload";
        //         let postConfig: ng.IRequestShortcutConfig = {
        //             transformRequest: angular.identity, // add this to not serialize form data
        //             // set header to undefined so the browser sets the multipart content type
        //             headers: { "Content-Type": undefined }
        //         };
        //         let formData = new FormData();
        //         formData.append("file", file, file.name);
        //         let deferred = this.$q.defer<string>();
        //         // post the file
        //         this.$http.post<ISceneUploadResult>(url, formData, postConfig).then(response => {
        //             // returns the filename of the new node in the upload scene
        //             let uploadResult = response.data;
        //             // now we need to import the file node from the upload scene into this scene
        //             clara("importNode", {
        //                 el: this.elem,
        //                 importSceneId: uploadResult.uploadSceneId,
        //                 importSelector: uploadResult.filename,
        //                 parentId: "%MaterialLibrary",
        //                 callback: (err, uploadedNode) => {
        //                     if (err) {
        //                         deferred.reject(err);
        //                     } else {
        //                         deferred.resolve(uploadResult.filename);
        //                     }
        //                 }
        //             } as clara.IImportNodeCommandConfig);
        //         }, reason => {
        //             deferred.reject(reason);
        //         });
        //         // alert the user the file is uploading
        //         this.dialogService && this.dialogService.alert({
        //             msg: "Uploading file '" + file.name + "'",
        //             successMsg: "'" + file.name + "' uploaded successfully",
        //             promise: deferred.promise
        //         });
        //         return deferred.promise;
        //     });
        // }
        ClaraViewer.prototype.runAction = function (actionName) {
            var args = this.getRuleArgs(enums.eRuleType.action);
            return this.runActionRule(actionName, args);
        };
        ClaraViewer.prototype.runFieldAction = function (elem) {
            var _this = this;
            var args = this.getRuleArgs(enums.eRuleType.field);
            return this.ruleService.runRuleContainerAsync(elem, args).then(function (res) {
                _this.handleRuleError(elem.name + " " + elem.$type, res);
                return res;
            });
        };
        ClaraViewer.prototype.runRules = function (waitForLoad) {
            var _this = this;
            if (waitForLoad === void 0) { waitForLoad = true; }
            var promise = waitForLoad ? this.loadDeferred.promise : new _rules.KPromise(null);
            return promise.then(function () {
                _this.setFieldsIfStandalone();
                return _this.sceneService.runRulesCycle(_this.sceneConfig, _this.uiConfig, _this.getRuleArgs(enums.eRuleType.scene))
                    .then(function (result) {
                    _this.sceneService.deleteOrphanedNestedScenes(_this.sceneApi, _this.uiConfig);
                    _this.handleRuleError(enums.eRuleType.scene, result);
                    //recalculate all hotspots
                    _this.$scope.allHotspots = _this.getAllHotspots();
                    return result;
                });
            });
        };
        ClaraViewer.prototype.importUploadFieldImage = function (uiConfig, field, file) {
            return this.sceneService.importUploadFieldImage(this.sceneApi, uiConfig, field, file);
        };
        ClaraViewer.prototype.snapshot = function (options) {
            return new _rules.KPromise(this.sceneService.snapshot(this.sceneApi, options));
        };
        ClaraViewer.prototype.dispose = function () {
            if (this.elem) {
                this.elem.remove();
                this.elem = null;
            }
        };
        return ClaraViewer;
    }(SceneViewer));

    /**
     * NOT meant to be used as an angular singleton service.  It's a helper for running configurators
     */
    var ConfiguratorHelper = /** @class */ (function () {
        function ConfiguratorHelper(args) {
            this.args = args;
            this.filterLevelDb = {};
            /** once the tablespromise resolves, will be filled with the tables converted to arrays
             * (for sending in to the rule args)
             */
            this.tableArraysDb = {};
            this._optionFilterRunCount = 0;
        }
        ConfiguratorHelper.prototype.downloadTables = function (tableIds) {
            var _this = this;
            if (tableIds.length) {
                return this.args.api.tables.getBatch({ ids: tableIds }, this.args.tracker).then(function (data) {
                    _this.loadTables(data);
                });
            }
            else {
                return this.args.$q.when(null);
            }
        };
        ConfiguratorHelper.prototype.loadTables = function (itables) {
            var _this = this;
            itables.forEach(function (t) {
                var table = new enums.Table(t);
                _this.tableArraysDb[table.id] = table.toObjectArray();
            });
        };
        ConfiguratorHelper.prototype.handleRuleError = function (ruleName, result) {
            if (result && result.hasError && this.args.showErrors()) {
                var dialogScope = this.args.$rootScope.$new();
                dialogScope.ruleName = ruleName;
                dialogScope.configuratorName = result.parameters.configurator.name;
                dialogScope.error = result.error.message;
                this.args.dialogService.alert({
                    type: enums.eAlertType.error,
                    template: Dirs.view("alert-rule-error"),
                    scope: dialogScope,
                    persist: true
                });
            }
        };
        ConfiguratorHelper.prototype.runRuleContainerAsync = function (ruleContainer, args) {
            var _this = this;
            if (ruleContainer && ruleContainer.references.length > 0 && ruleContainer.references.findIndex(function (a) { return a.type.isEqual(enums.eRuleType.globalFunction); }) > -1) {
                var ids = ruleContainer.references.filter(function (b) { return b.type.isEqual(enums.eRuleType.globalFunction); }).map(function (c) { return c.id; });
                return this.args.api.globalFunctions.getDependencies({ ids: ids }).then(function (globalFuncs) {
                    args.globalFunctions = globalFuncs;
                    return _this.args.ruleService.runRuleContainerAsync(ruleContainer, args || _this.args.getRuleArgs(ruleContainer.$parentConfigurator)).then(function (res) {
                        _this.handleRuleError(ruleContainer.name + " " + ruleContainer.$type, res);
                        return res;
                    });
                });
            }
            else {
                if (ruleContainer.ruleType == enums.eRuleType.optionFilter && ruleContainer.queryMode == enums.eQueryMode.database) {
                    var runRule = this.args.ruleService.runRuleContainerSync(ruleContainer, args || this.args.getRuleArgs(ruleContainer.$parentConfigurator));
                    return this.args.$q.when(runRule).then(function (res) {
                        _this.handleRuleError(ruleContainer.name + " " + ruleContainer.$type, res);
                        return res;
                    });
                }
                else {
                    return this.args.ruleService.runRuleContainerAsync(ruleContainer, args || this.args.getRuleArgs(ruleContainer.$parentConfigurator)).then(function (res) {
                        _this.handleRuleError(ruleContainer.name + " " + ruleContainer.$type, res);
                        return res;
                    });
                }
            }
        };
        ConfiguratorHelper.prototype.runRuleContainerSync = function (ruleContainer, args) {
            var res = this.args.ruleService.runRuleContainerSync(ruleContainer, args || this.args.getRuleArgs(ruleContainer.$parentConfigurator));
            this.handleRuleError(ruleContainer.name + " " + ruleContainer.$type, res);
            return res;
        };
        ConfiguratorHelper.prototype.getRefedProducts = function (ids) {
            var _this = this;
            if (!this.referencedConfigsCache)
                this.referencedConfigsCache = [];
            var refedToFetch = [];
            ids.forEach(function (element) {
                if (_this.referencedConfigsCache.findIndex(function (a) { return a.id == element.idProduct; }) < 0) {
                    refedToFetch.push(element.idProduct);
                }
            });
            if (refedToFetch.length > 0) {
                return this.args.api.products.getBatch({ ids: refedToFetch }, this.args.tracker).then(function (res) {
                    var _a;
                    (_a = _this.referencedConfigsCache).push.apply(_a, res);
                    return _this.referencedConfigsCache;
                });
            }
            else {
                return this.args.$q.when(this.referencedConfigsCache);
            }
        };
        ConfiguratorHelper.prototype.loadGlobalFunctions = function (config) {
            var _this = this;
            var _a;
            if (!this.globalFuncsCache)
                this.globalFuncsCache = [];
            var allConfigs = config.getAllConfigurators();
            var allGlobals = [];
            if (allGlobals == undefined)
                allGlobals = [];
            allConfigs.forEach(function (element) {
                var _a;
                var rcs = (_a = element.allRuleContainers()) !== null && _a !== void 0 ? _a : [];
                rcs.forEach(function (rc) {
                    var _a;
                    var globalIds = (_a = rc.references) === null || _a === void 0 ? void 0 : _a.filter(function (b) { return b.type.isEqual(enums.eRuleType.globalFunction); }).map(function (c) { return c.id; });
                    if (globalIds && globalIds.length > 0) {
                        globalIds.forEach(function (id) {
                            if (_this.globalFuncsCache.findIndex(function (a) { return a == id; }) < 0) {
                                allGlobals.push(id);
                            }
                        });
                    }
                });
            });
            var topRcs = (_a = config.ruleContainers) !== null && _a !== void 0 ? _a : [];
            topRcs.forEach(function (rc) {
                var _a;
                var globalIds = (_a = rc.references) === null || _a === void 0 ? void 0 : _a.filter(function (b) { return b.type.isEqual(enums.eRuleType.globalFunction); }).map(function (c) { return c.id; });
                if (globalIds && globalIds.length > 0) {
                    globalIds.forEach(function (id) {
                        if (_this.globalFuncsCache.findIndex(function (a) { return a == id; }) < 0) {
                            allGlobals.push(id);
                        }
                    });
                }
            });
            var referencedConfigurators = config.referencedConfigurators;
            if (referencedConfigurators && referencedConfigurators.length > 0) {
                return this.getRefedProducts(referencedConfigurators)
                    .then(function (refConfigs) {
                    refConfigs.forEach(function (refC) {
                        var _a;
                        (_a = refC.configurator.ruleContainers) === null || _a === void 0 ? void 0 : _a.forEach(function (refRc) {
                            var _a;
                            var refedGlobal = (_a = refRc.references) === null || _a === void 0 ? void 0 : _a.filter(function (b) { return b.type.isEqual(enums.eRuleType.globalFunction); }).map(function (c) { return c.id; });
                            if (refedGlobal && refedGlobal.length > 0) {
                                refedGlobal.forEach(function (id) {
                                    if (_this.globalFuncsCache.findIndex(function (a) { return a == id; }) < 0) {
                                        allGlobals.push(id);
                                    }
                                });
                            }
                        });
                    });
                    allGlobals = Array.from(new Set(allGlobals));
                    var idsToFetch = allGlobals.filter(function (id) { return !_this.globalFuncsCache || _this.globalFuncsCache.findIndex(function (g) { return g.id == id; }) < 0; });
                    if (!idsToFetch.length) {
                        var cached = (_this.globalFuncsCache || []).filter(function (g) { return allGlobals.indexOf(g.id) > -1; });
                        return _this.args.$q.when(cached);
                    }
                    return _this.args.api.globalFunctions.getDependencies({ ids: idsToFetch }).then(function (globalFuncs) {
                        var _a;
                        if (!_this.globalFuncsCache)
                            _this.globalFuncsCache = [];
                        (_a = _this.globalFuncsCache).push.apply(_a, globalFuncs);
                        var combined = _this.globalFuncsCache.filter(function (g) { return allGlobals.indexOf(g.id) > -1; });
                        return combined;
                    });
                });
            }
            else {
                allGlobals = Array.from(new Set(allGlobals));
                var idsToFetch = allGlobals.filter(function (id) { return !_this.globalFuncsCache || _this.globalFuncsCache.findIndex(function (g) { return g.id == id; }) < 0; });
                if (!idsToFetch.length) {
                    var cached = (this.globalFuncsCache || []).filter(function (g) { return allGlobals.indexOf(g.id) > -1; });
                    return this.args.$q.when(cached);
                }
                return this.args.api.globalFunctions.getDependencies({ ids: idsToFetch }).then(function (globalFuncs) {
                    var _a;
                    if (!_this.globalFuncsCache)
                        _this.globalFuncsCache = [];
                    (_a = _this.globalFuncsCache).push.apply(_a, globalFuncs);
                    var combined = _this.globalFuncsCache.filter(function (g) { return allGlobals.indexOf(g.id) > -1; });
                    return combined;
                });
            }
        };
        ConfiguratorHelper.prototype.runRuleTypeAsync = function (config, ruleType, args) {
            var _this = this;
            args = args || this.args.getRuleArgs(config);
            var rc = config.ruleContainers.find(function (r) {
                return r.ruleType.isEqual(ruleType);
            });
            if (rc && rc.references.length > 0 && rc.references.findIndex(function (a) { return a.type.isEqual(enums.eRuleType.globalFunction); }) > -1) {
                var ids = rc.references.filter(function (b) { return b.type.isEqual(enums.eRuleType.globalFunction); }).map(function (c) { return c.id; });
                if (ids && ids.length > 0) {
                    //check saved functions
                    var idsToGet_1 = [];
                    if (this.globalFuncsCache == undefined)
                        this.globalFuncsCache = [];
                    ids.forEach(function (id) {
                        if (_this.globalFuncsCache.findIndex(function (a) { return a.id == id; }) < 0) {
                            idsToGet_1.push(id);
                        }
                    });
                    args.globalFunctions = this.globalFuncsCache;
                    return this.args.ruleService.runRuleTypeAsync(config, ruleType, args).then(function (res) {
                        _this.handleRuleError(ruleType, res);
                        return res;
                    });
                }
                else {
                    args.globalFunctions = this.globalFuncsCache;
                    return this.args.ruleService.runRuleTypeAsync(config, ruleType, args || this.args.getRuleArgs(config)).then(function (res) {
                        _this.handleRuleError(ruleType, res);
                        return res;
                    });
                }
            }
            else {
                args.globalFunctions = this.globalFuncsCache;
                return this.args.ruleService.runRuleTypeAsync(config, ruleType, args || this.args.getRuleArgs(config)).then(function (res) {
                    _this.handleRuleError(ruleType, res);
                    return res;
                });
            }
        };
        ConfiguratorHelper.prototype.runActionByIdAsync = function (config, actionId, args) {
            var _this = this;
            return this.args.ruleService.runActionRuleByIdAsync(config, actionId, args || this.args.getRuleArgs(config))
                .then(function (res) {
                _this.handleRuleError(actionId, res);
                return res;
            });
        };
        ConfiguratorHelper.prototype.runOptionFilterSourceRule = function () {
        };
        ConfiguratorHelper.prototype.autoCompleteQuery = function (query, field) {
            if (query) {
                if (field.autoCompleteSource == enums.eAutoCompleteSource.table) {
                    // return this.tablesPromise.then(() => {
                    var arr = this.tableArraysDb[field.idTable].data;
                    var results = _tools.SearchUtils.search(query, arr, function (item) { return item[_tools.Utils.scrubName(field.labelColumn || field.valueColumn)]; });
                    var scrubValueCol_1 = _tools.Utils.scrubName(field.valueColumn);
                    var scrubLabelCol_1 = _tools.Utils.scrubName(field.labelColumn);
                    var scrubImageCol_1 = _tools.Utils.scrubName(field.imageColumn);
                    // map the results to options
                    var options = results.map(function (item) {
                        var o = new enums.Option();
                        o.value = item[scrubValueCol_1];
                        o.label = item[scrubLabelCol_1];
                        o.image = item[scrubImageCol_1];
                        return o;
                    });
                    return this.args.$q.when(options);
                    // });
                }
                else if (field.autoCompleteSource == enums.eAutoCompleteSource.database) {
                    return this.args.api.products.autocomplete(field.$parentConfigurator.idProduct, field.id, query, this.args.tracker);
                }
            }
            return this.args.$q.when([]);
        };
        ConfiguratorHelper.prototype.autoCompleteGetLabel = function (value, field) {
            if (field.labelColumn) {
                // when autocomplete fields are using the labelColumn, then when they are first opening,
                // they will request for the label of their current value
                if (field.autoCompleteSource == enums.eAutoCompleteSource.table) {
                    var scrubValueCol_2 = _tools.Utils.scrubName(field.valueColumn);
                    var scrubLabelCol = _tools.Utils.scrubName(field.labelColumn);
                    _tools.Utils.scrubName(field.imageColumn);
                    // return this.tablesPromise.then(() => {
                    var arr = this.tableArraysDb[field.idTable].data;
                    var row = arr.find(function (item) { return item[scrubValueCol_2] === value; });
                    return row ? row[scrubLabelCol] : null;
                    // });
                }
                else if (field.autoCompleteSource == enums.eAutoCompleteSource.database) ;
            }
            return value;
        };
        ConfiguratorHelper.prototype.getOptionFilterSource = function (filter) {
            var arr = [];
            if (filter.source == enums.eOptionFilterSource.table) {
                var tableObject = this.tableArraysDb[filter.idTable];
                if (tableObject)
                    arr = tableObject.data;
            }
            else if (filter.source == enums.eOptionFilterSource.optionFilter) {
                var f = filter.$parentConfigurator.$manager.get(filter.idOptionFilter);
                arr = f ? f.$source : [];
            }
            else { //must be a query
                // get the source table by running the query
                var ruleArgs = this.args.getRuleArgs(filter.$parentConfigurator);
                arr = this.runRuleContainerSync(filter, ruleArgs).parameters.source;
            }
            if (arr == null)
                throw new Error("Could not find source for option filter '".concat(filter.name, "'"));
            filter.$source = arr;
            return arr;
        };
        ConfiguratorHelper.prototype.shouldRunOptionFilter = function (config, filter) {
            var shouldRun = true;
            if (config.v >= 1 && filter.optimized) { // older configurators will not have the needed info for optimization
                var last_1 = filter.$lastValues;
                if (last_1) { // if it has lastReferenceValues then it has already been run
                    shouldRun = Object.keys(last_1).some(function (fieldId) {
                        var field = config.$manager.get(fieldId);
                        if (field.isArrayType()) {
                            return !field.value.equals(last_1[fieldId]);
                        }
                        else {
                            return (last_1[fieldId] != field.value);
                        }
                    });
                }
            }
            // if this filter is sourced from another option filter, we need to also check if that option filter
            // needed to be run in this cycle
            if (filter.source == enums.eOptionFilterSource.optionFilter ||
                (filter.source == enums.eOptionFilterSource.query && filter.queryMode == enums.eQueryMode.optionFilter)) {
                var otherFilter = config.$manager.get(filter.idOptionFilter);
                shouldRun = otherFilter.$shouldRun || shouldRun;
            }
            else if (filter.source == enums.eOptionFilterSource.query && filter.queryMode == enums.eQueryMode.parentOptionFilter) {
                var otherFilter = config.$parentConfigurator.$manager.get(filter.idOptionFilter);
                shouldRun = otherFilter.$shouldRun || shouldRun;
            }
            filter.$shouldRun = shouldRun;
            return shouldRun;
        };
        ConfiguratorHelper.prototype.runOptionFilter = function (config, s) {
            var filter = config.$manager.get(s.filterId);
            // optimize by not running if all the inputs are the same as last time it was run
            var shouldRun = this.shouldRunOptionFilter(config, filter);
            if (shouldRun) {
                this._optionFilterRunCount++;
                var source_1 = this.getOptionFilterSource(filter);
                var clientLang = this.args.$rootScope.clientLanguage;
                var shouldTranslate = (clientLang != this.args.$rootScope.companySettings.defaultLanguage);
                // start with full table. //Use int array and preallocate it for performance reasons
                var matchedRows = [];
                for (var r = 0; r < source_1.length; r++) {
                    matchedRows.push(r);
                }
                var _loop_1 = function (f) {
                    // get the real field from this configurator
                    var field = config.$manager.get(s.fieldIds[f]);
                    var fieldBaseType = field.getBaseType();
                    var fieldIsArray = field.isArrayType();
                    var newOptions = [];
                    var scrubValueCol = _tools.Utils.scrubName(field.valueColumn);
                    var scrubLabelCol = _tools.Utils.scrubName(field.labelColumn);
                    var scrubSortCol = _tools.Utils.scrubName(field.sortColumn);
                    var scrubTranslateCol = shouldTranslate ?
                        (scrubLabelCol ?
                            scrubLabelCol + clientLang.toUpperCase()
                            : scrubValueCol + clientLang.toUpperCase())
                        : "";
                    var scrubImageCol = _tools.Utils.scrubName(field.imageColumn);
                    var scrubImageWhenSelectedCol = _tools.Utils.scrubName(field.imageWhenSelectedColumn);
                    var scrubDescCol = _tools.Utils.scrubName(field.descriptionColumn);
                    scrubDescTranslateCol = shouldTranslate ? (scrubDescCol + clientLang.toUpperCase()) : "";
                    // fill in options... we only want unique options
                    var uniqueDb = {};
                    for (var _i = 0, matchedRows_1 = matchedRows; _i < matchedRows_1.length; _i++) {
                        var rowIndex = matchedRows_1[_i];
                        var row = source_1[rowIndex];
                        if (!uniqueDb[row[scrubValueCol]]) {
                            var entry = {
                                label: row.hasOwnProperty(scrubTranslateCol) ? row[scrubTranslateCol] : row[scrubLabelCol],
                                image: row[scrubImageCol],
                                imageWhenSelected: row[scrubImageWhenSelectedCol],
                                description: row.hasOwnProperty(scrubDescTranslateCol) ? row[scrubDescTranslateCol] : row[scrubDescCol],
                                value: enums.Field.convertToType(row[scrubValueCol], fieldBaseType, field.precision),
                                sort: row[scrubSortCol]
                            };
                            uniqueDb[row[scrubValueCol]] = entry;
                            newOptions.push(entry);
                        }
                    }
                    // sort if applicable
                    var sortCol = field.sortColumn ? "sort" : (field.labelColumn ? "label" : "value");
                    if (field.sort == enums.eSort.ascending) {
                        newOptions.sortBy(function (o) { return o[sortCol]; });
                    }
                    else if (field.sort == enums.eSort.descending) {
                        newOptions.sortByDescending(function (o) { return o[sortCol]; });
                    }
                    // set the new options all at once
                    field.options = newOptions;
                    this_1.handleSingleOption(field, filter);
                    // now recalculate the matched rows for the next field
                    if (f !== s.fieldIds.length - 1) {
                        matchedRows = matchedRows.filter(function (rowIndex) {
                            var cellValue = source_1[rowIndex][scrubValueCol];
                            cellValue = enums.Field.convertToType(cellValue, fieldBaseType, field.precision);
                            return fieldIsArray ? field.value.contains(cellValue) : (cellValue == field.value);
                        });
                    }
                };
                var this_1 = this, scrubDescTranslateCol;
                for (var f = 0; f < s.fieldIds.length; f++) {
                    _loop_1(f);
                }
                this.storeLastValuesFor(config, s);
            }
        };
        ConfiguratorHelper.prototype.handleSingleOption = function (field, optionFilter) {
            // if there is only one option left, check the specified behavior on the option filter
            if (optionFilter.singleOptionBehavior == enums.eSingleOptionBehavior.disable) {
                field.enabled = (field.options.length > 1);
            }
            else if (optionFilter.singleOptionBehavior == enums.eSingleOptionBehavior.hide) {
                field.visible = (field.options.length > 1);
            }
        };
        ConfiguratorHelper.prototype.storeLastValuesFor = function (config, s) {
            if (config.v >= 1) { // older configurators will not have the needed info for optimization
                // store last field values for optimization
                var filter = config.$manager.get(s.filterId);
                var last_2 = filter.$lastValues = filter.$lastValues || {};
                filter.fieldReferences.forEach(function (fieldId) {
                    var field = config.$manager.get(fieldId);
                    if (field.isArrayType()) {
                        last_2[fieldId] = field.value.map(function (v) { return v; });
                    }
                    else {
                        last_2[fieldId] = field.value;
                    }
                });
                s.fieldIds.forEach(function (fieldId) {
                    var field = config.$manager.get(fieldId);
                    if (field.isArrayType()) {
                        last_2[field.id] = field.value.map(function (v) { return v; });
                    }
                    else {
                        last_2[field.id] = field.value;
                    }
                });
            }
        };
        ConfiguratorHelper.prototype.runSelects = function (config) {
            var _this = this;
            if (!this.serverSideOptionFilterSources)
                this.serverSideOptionFilterSources = [];
            var promise = (new _rules.KPromise(null));
            if (!config.optionFilters.length)
                return promise; //shortcircuit if there is nothing to do here
            config.$freezeFieldValueCalculation = true; // freeze field value calculation for perf
            var startTime = Date.now();
            this._optionFilterRunCount = 0;
            // fill in the db
            if (!this.odb)
                this.odb = {};
            if (!this.odb[config.idProduct]) {
                this.odb[config.idProduct] = {};
                this.filterLevelDb[config.idProduct] = {};
                // loop through each select table, find all registered fields
                var allFields_1 = config.getFields(function (f) { return f.canJoinOptionFilter() && f.selectSource == enums.eSelectSource.optionFilter; });
                config.optionFilters.forEach(function (o) {
                    var info = {
                        filterId: o.id,
                        fieldIds: allFields_1.filter(function (f) { return f.idOptionFilter == o.id; }).map(function (f) { return f.id; })
                    };
                    _this.odb[config.idProduct][o.id] = info;
                });
                // filters are organized by level of dependencies.  Those at a level of 1 have no dependencies
                // so we just roll through the filters, and make a jagged array where the primary index is 
                // the level, and we loop them and run them
                config.optionFilters.forEach(function (filter) {
                    var arr = _this.filterLevelDb[config.idProduct][filter.level];
                    if (!arr)
                        _this.filterLevelDb[config.idProduct][filter.level] = [];
                    _this.filterLevelDb[config.idProduct][filter.level].push(filter.id);
                });
                //// fill in start filters also
                // this.startFilters = config.optionFilters.filter(f => !f.dependsOn || f.dependsOn.length == 0);
            }
            // if any of the option filters in the configurator are sourced by a database, then we just have the server
            // do all the figuring
            if (!config.filtersShouldRunOnClient()) {
                /* another level of optimization... if all the fields referenced by option filters in their query
                rule and fields in the option filter haven't changed value, then there is no reason to call the server */
                var shouldRun = true;
                if (config.v >= 1) { // older configurators will not have the needed info for optimization
                    for (var _i = 0, _a = config.optionFilters; _i < _a.length; _i++) {
                        var filter = _a[_i];
                        shouldRun = this.shouldRunOptionFilter(config, filter);
                        if (shouldRun)
                            break;
                    }
                }
                if (shouldRun) {
                    var fieldOptions_1 = [];
                    config.optionFilters.forEach(function (filter) {
                        _this.odb[config.idProduct][filter.id].fieldIds.forEach(function (fieldId) {
                            var field = config.$manager.get(fieldId);
                            fieldOptions_1.push({ id: field.id, name: field.name, options: field.options });
                        });
                    });
                    var lastValues_1 = {};
                    config.optionFilters.forEach(function (filter) {
                        lastValues_1[filter.id] = filter.$lastValues;
                    });
                    var runArgs = {
                        configuredProduct: config.getConfiguredProduct(true),
                        lastValues: lastValues_1,
                        fieldOptions: fieldOptions_1
                    };
                    promise = this.args.api.optionFilters.run(runArgs, this.args.tracker).then(function (r) {
                        var tasks = [];
                        r.filters.forEach(function (filterResult) {
                            var _a;
                            var filter = config.$manager.get(filterResult.id);
                            filterResult.fields.forEach(function (f) {
                                var field = config.$manager.get(f.id);
                                // sort if applicable
                                var sortCol = field.sortColumn ? "sort" : (field.labelColumn ? "label" : "value");
                                if (field.sort == enums.eSort.ascending) {
                                    f.options.sortBy(function (o) { return o[sortCol]; });
                                }
                                else if (field.sort == enums.eSort.descending) {
                                    f.options.sortByDescending(function (o) { return o[sortCol]; });
                                }
                                field.options = f.options;
                                _this.handleSingleOption(field, filter);
                            });
                            var findCached = _this.serverSideOptionFilterSources.find(function (a) { return a.id == filter.id; });
                            if (findCached) {
                                config.optionFilters.find(function (a) { return a.id == filterResult.id; }).$source = (_a = findCached.arr) !== null && _a !== void 0 ? _a : [];
                            }
                            else {
                                var ruleArgs = _this.args.getRuleArgs(filter.$parentConfigurator);
                                var p = _this.runRuleContainerAsync(filter, ruleArgs).then(function (res) {
                                    var arr = res.parameters.source;
                                    _this.serverSideOptionFilterSources.push({ id: filter.id, arr: arr });
                                    config.optionFilters.find(function (a) { return a.id == filterResult.id; }).$source = arr !== null && arr !== void 0 ? arr : [];
                                });
                                tasks.push(p);
                            }
                        });
                        // store optimization info
                        return _this.args.$q.all(tasks).then(function () {
                            r.filters.forEach(function (filter) { return _this.storeLastValuesFor(config, _this.odb[config.idProduct][filter.id]); });
                        });
                    });
                }
            }
            else {
                /* we have all tables, and no databases, so we operate locally to avoid a roundtrip to the server
                because getTables is a KPromise that isn't a real promise, we can run these as if they were
                sync (because they are) */
                var level = 1;
                while (true) {
                    var filterIds = this.filterLevelDb[config.idProduct][level];
                    if (filterIds) {
                        filterIds.forEach(function (filterId) {
                            _this.runOptionFilter(config, _this.odb[config.idProduct][filterId]);
                        });
                        level++;
                    }
                    else {
                        break;
                    }
                }
                promise = (new _rules.KPromise(null)).then(function () {
                    // store optimization info
                    config.optionFilters.forEach(function (filter) { return _this.storeLastValuesFor(config, _this.odb[config.idProduct][filter.id]); });
                });
            }
            return promise.then(function () {
                config.$freezeFieldValueCalculation = false;
                _tools.Logger.logRuleEnd(config.name, "option filters (".concat(_this._optionFilterRunCount, ")"), startTime);
            });
        };
        return ConfiguratorHelper;
    }());

    var SCENE_CLICK_HANDLER_TAG = 'scene_click';
    var Kb3dViewer = /** @class */ (function (_super) {
        __extends(Kb3dViewer, _super);
        function Kb3dViewer(cArgs) {
            var _this = _super.call(this, cArgs) || this;
            _this.cArgs = cArgs;
            _this.hotspotCounter = 0;
            _this.enableScreenshots = cArgs.enableScreenshots || false;
            //this.sceneService = args.$injector.get(Token.ClaraSceneService.key);
            //this.$scope = cArgs.controllerScope.$new();
            _this.$scope.hotspotClick = function ($event, ann) { return _this.hotspotClick($event, ann); };
            _this.$scope.hotspotCloseClick = function ($event, ann) { return _this.hotspotCloseClick($event, ann); };
            _this.$scope.arActive = function () { return _this.viewer.ar.xrActive; };
            _this.$scope.toggleAr = function () { return _this.toggleAr(); };
            _this.$scope.arEnabled = true;
            _tools.Utils.supportsVr().then(function (res) { return (_this.$scope.supportsVr = res); });
            _this.$scope.allHotspots = [];
            return _this;
        }
        Kb3dViewer.prototype.init = function () {
            var _this = this;
            this.createElem();
            this.viewer = new kb3d__namespace.KbViewer({
                container: this.elem,
                highlightColor: this.highlightColor ? kb3d.KbColor.FromIntObject(new _tools.Color(this.highlightColor).toRgb()) : null,
                webworkerPath: this.clusterEnv === 'dev'
                    ? "".concat(this.assetRoot, "/worker3d.js")
                    : "".concat(this.assetRoot, "/worker3d.min.js?v=").concat(this.cacheBuster),
                debugMode: this.clusterEnv === 'dev',
                forceDisableGraphicsOptimization: this.isRender,
                startInLowResolution: this.isRender,
                enableScreenshots: this.enableScreenshots,
            });
            this.elem.addEventListener('kb3d.scenePropertyChange', function (e) {
                if ('arEnabled' in e.detail) {
                    var arEnabled_1 = e.detail['arEnabled'];
                    _this.$scope.$apply(function () {
                        _this.$scope.arEnabled = arEnabled_1;
                    });
                }
            });
            this.createHotspotElem();
            this.viewer.viewChanged.subscribe(function () { return _this.updateHotspots(true); });
            this.viewer.interaction.onKeyboard.subscribe(function (k) { return _this.onKeyboard(k); });
            return new _rules.KPromise(null);
        };
        Kb3dViewer.prototype.dispose = function () {
            if (this.viewer) {
                this.viewer.gizmos.clearGizmo();
                this.viewer.dispose();
            }
            if (this.sceneNode && this.sceneNode._manager) {
                this.sceneNode._manager.clickHandlers.deleteByTag(SCENE_CLICK_HANDLER_TAG);
            }
            if (this.elem) {
                this.elem.remove();
                this.elem = null;
            }
        };
        Kb3dViewer.prototype.loadSceneInternal = function (args) {
            var _this = this;
            var manager = new kb3d__namespace.Kb3dManager({
                assetRoot: this.assetRoot,
                forceFullSizeTextures: args.isRenderContext || false,
                environment: {
                    lastDeploy: this.lastDeploy,
                    cacheBuster: this.cacheBuster,
                },
            }); //default services automatically used
            this.sceneNode = manager.deserialize(this.scene.graph);
            this.$scope.arEnabled = !!this.sceneNode.arEnabled;
            this.$scope.fullscreenEnabled = !!this.sceneNode.fullscreenEnabled;
            args.config.$sceneNode = this.sceneNode;
            this.sceneNode._configurator = args.config;
            //args.loadingExperience is set to false in render.ts to disable loading experiences for renders
            if (args.loadingExperience === false) {
                this.viewer.loadScene({
                    sceneNode: this.sceneNode,
                    loadingExperience: kb3d__namespace.eLoadingExperience.none,
                    deferLoadingPromise: this.$q.all([this.loadDeferred.promise, this.configuratorLoadedPromise]),
                });
            }
            else {
                this.viewer.loadScene({
                    sceneNode: this.sceneNode,
                    deferLoadingPromise: this.$q.all([this.loadDeferred.promise, this.configuratorLoadedPromise]),
                });
            }
            manager.clickHandlers.add(this.sceneNode, SCENE_CLICK_HANDLER_TAG, function (p) {
                _this.onSceneClick(p);
            });
            return this.runRules(false).then(function () {
                _this.notifyLoaded();
            });
        };
        Kb3dViewer.prototype.runRules = function (waitForLoad) {
            var _this = this;
            if (waitForLoad === void 0) { waitForLoad = true; }
            var promise = waitForLoad ? this.loadDeferred.promise : new _rules.KPromise(null);
            return promise
                .then(function () {
                _this.getRuleArgs(enums.eRuleType.scene);
                _this.setFieldsIfStandalone();
                // before running the value rules, we need to clear out transient handlers
                _this.clearTransientHandlers(_this.sceneNode, enums.eRuleType.value);
                var runUiRules = !_this.sceneDb[_this.sceneConfig.idScene].idProduct;
                if (runUiRules) {
                    // run the value rule first
                    // ruleArgs.sceneUtils.ruleType = eRuleType.value;
                    return _this.runRuleTypeAsync(_this.sceneConfig, enums.eRuleType.value, _this.getRuleArgs(enums.eRuleType.value)).then(function () {
                        _this.sceneConfig.preValidate();
                        _this.sceneConfig.isValid();
                    });
                }
            })
                .then(function () {
                return _this.runSceneRules(_this.sceneConfig, _this.uiConfig, _this.getRuleArgs(enums.eRuleType.scene), false);
            })
                .then(function (result) {
                _this.handleRuleError(enums.eRuleType.scene, result);
                //recalculate all hotspots
                _this.$scope.allHotspots = _this.getAllHotspots();
                _this.updateHotspots(false);
                return result;
            });
        };
        Kb3dViewer.prototype.clearTransientHandlers = function (sceneNode) {
            var _a;
            var ruleTypes = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                ruleTypes[_i - 1] = arguments[_i];
            }
            var m = sceneNode._manager;
            var handlerMaps = [m.clickHandlers, m.doubleClickHandlers, m.draggables, m.hotspotClickHandlers];
            for (var _b = 0, handlerMaps_1 = handlerMaps; _b < handlerMaps_1.length; _b++) {
                var hm = handlerMaps_1[_b];
                hm.deleteByTag.apply(hm, ruleTypes);
            }
            var remaining = m.cameraChangeHandlers.filter(function (h) { return !ruleTypes.includes(h.tag); });
            m.cameraChangeHandlers.length = 0;
            (_a = m.cameraChangeHandlers).push.apply(_a, remaining);
        };
        Kb3dViewer.prototype.runSceneRules = function (sceneConfig, uiConfig, ruleArgs, skipRulesIfNoNestedSceneChanges) {
            var _this = this;
            var nestedSceneRulesWereRun = false;
            return this.runNestedSceneRules(uiConfig)
                .then(function (r) {
                nestedSceneRulesWereRun = r && r.some(function (r2) { return r2 != null; });
                if (!sceneConfig.$ranLoadedRule) {
                    sceneConfig.$ranLoadedRule = true;
                    skipRulesIfNoNestedSceneChanges = false;
                    ruleArgs.ruleType = enums.eRuleType.sceneLoaded;
                    return _this.runRuleTypeAsync(sceneConfig, enums.eRuleType.sceneLoaded, ruleArgs);
                }
            })
                .then(function () {
                _this.deleteOrphanedNestedScenes(uiConfig);
                if (!skipRulesIfNoNestedSceneChanges || nestedSceneRulesWereRun) {
                    //skip running the rules if there were no nested scene rules run
                    _this.clearTransientHandlers(ruleArgs.sceneNode, enums.eRuleType.scene);
                    ruleArgs.ruleType = enums.eRuleType.scene;
                    return _this.runRuleTypeAsync(sceneConfig, enums.eRuleType.scene, ruleArgs).then(function (ruleResult) {
                        uiConfig.$fieldsDirtyForSceneRules = false;
                        return ruleResult;
                    });
                }
            });
        };
        Kb3dViewer.prototype.runNestedSceneRules = function (uiConfig) {
            var _this = this;
            var nestedConfigs = uiConfig.getNestedConfigurators();
            if (nestedConfigs.length) {
                var promises_1 = [];
                // loop through nested configurators, merge the scenes if they haven't been already, and run their rules
                nestedConfigs.forEach(function (nested) {
                    if (nested.idScene) {
                        var refConfig = uiConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
                        if (refConfig.nestScene) {
                            // create the scene configurator for the nested configurator if it doesn't already exist
                            // (or has been swapped for another scene)
                            if (!nested.$sceneConfigurator || nested.$sceneConfigurator.idScene != nested.idScene) {
                                nested.$sceneConfigurator = new enums.Configurator(new enums.KbObjectManager(), _this.sceneDb[nested.idScene].configurator);
                            }
                            nested.$sceneConfigurator.$uiConfigurator = nested;
                            nested.$nestHotspots = refConfig.nestHotspots;
                            // in case the nested scene is a standalone scene, we need to set it's fields from the uiConfig
                            nested.$sceneConfigurator.setFields(nested.getFieldsObject());
                            var skipRules = !nested.$fieldsDirtyForSceneRules && (!nested.alwaysChild || !nested.alwaysChildOf);
                            _this.nestScene(
                            // merge the scene if it hasn't already been merged
                            uiConfig.$sceneNode, nested);
                            promises_1.push(
                            // now run the rules on the nested scene
                            _this.runSceneRules(nested.$sceneConfigurator, nested, _this.getNestedSceneRuleArgs(nested, nested.$sceneConfigurator, enums.eRuleType.scene), skipRules));
                        }
                    }
                });
                return this.$q.all(promises_1);
            }
            else {
                return new _rules.KPromise(null);
            }
        };
        Kb3dViewer.prototype.nestScene = function (parentSceneNode, nested) {
            var _this = this;
            if (!nested.$sceneNode) {
                //nested scene has already been created so skip
                var ser = this.sceneDb[nested.idScene];
                var nestedSceneNode = parentSceneNode._manager.nestScene(nested.name, parentSceneNode, ser.graph);
                nested.$sceneNode = nestedSceneNode;
                nestedSceneNode._configurator = nested;
                //add automatic click to navigate if enabled
                if (nested.$parentConfigurator.nestedSceneClickToSelect) {
                    parentSceneNode._manager.clickHandlers.add(nestedSceneNode, undefined, function () {
                        _this.navigateToElement(nested);
                    });
                }
            }
        };
        Kb3dViewer.prototype.runRuleTypeAsync = function (config, ruleType, args) {
            var _this = this;
            return this.ruleService.runRuleTypeAsync(config, ruleType, args).then(function (res) {
                _this.handleRuleError(ruleType, res);
                return res;
            });
        };
        Kb3dViewer.prototype.deleteOrphanedNestedScenes = function (uiConfig) {
            var allNested = uiConfig.getNestedConfigurators();
            var sceneNode = uiConfig.$sceneNode;
            if (sceneNode) {
                for (var i = sceneNode.scenes.length - 1; i >= 0; i--) {
                    var ns = sceneNode.scenes[i];
                    if (!allNested.some(function (n) { return n === ns._configurator; })) {
                        this.destroyNestedScene(sceneNode, ns);
                    }
                }
            }
        };
        Kb3dViewer.prototype.destroyNestedScene = function (parentScene, nestedScene) {
            // Recursively destroy grandchild scenes first so their configurator references
            // and managers are cleaned up before we dispose the parent scene manager
            for (var i = nestedScene.scenes.length - 1; i >= 0; i--) {
                this.destroyNestedScene(nestedScene, nestedScene.scenes[i]);
            }
            var nestedConfig = nestedScene._configurator;
            if (nestedConfig)
                nestedConfig.$sceneNode = undefined;
            nestedScene._configurator = undefined;
            parentScene.scenes.remove(nestedScene);
            nestedScene._manager.dispose(); //dispose of the nested scene manager
        };
        Kb3dViewer.prototype.clearHandlers = function () { };
        Kb3dViewer.prototype.runAction = function (actionName) {
            var args = this.getRuleArgs(enums.eRuleType.action);
            return this.runActionRule(actionName, args);
        };
        Kb3dViewer.prototype.runSceneFunction = function (args, config) {
            var _this = this;
            var ruleArgs = null;
            if (config && config.$sceneConfigurator) {
                ruleArgs = this.getNestedSceneRuleArgs(config, config.$sceneConfigurator, enums.eRuleType.function);
            }
            else {
                ruleArgs = this.getRuleArgs(enums.eRuleType.function);
            }
            ruleArgs.parameters = {};
            for (var p in args.parameters) {
                ruleArgs.parameters[p.toCamelCase()] = args.parameters[p];
            }
            var fn = null;
            if (config && config.$sceneConfigurator) {
                fn = config.$sceneConfigurator.functions.find(function (a) { return a.name.isEqual(args.name); });
            }
            if (!fn) {
                fn = this.sceneConfig.functions.find(function (a) { return a.name.isEqual(args.name); });
            }
            if (fn) {
                return this.ruleService.runRuleContainerAsync(fn, ruleArgs).then(function (r) {
                    _this.handleRuleError(fn.name + ' ' + fn.$type, r);
                    return r;
                });
            }
            else {
                throw "Cannot find scene function with name ".concat(args.name);
            }
        };
        Kb3dViewer.prototype.runFieldAction = function (elem) {
            var _this = this;
            var args = this.getRuleArgs(enums.eRuleType.field);
            return this.ruleService.runRuleContainerAsync(elem, args).then(function (res) {
                _this.handleRuleError(elem.name + ' ' + elem.$type, res);
                return res;
            });
        };
        Kb3dViewer.prototype.onSceneClick = function (p) {
            this.clearHotspots();
            this.$scope.$digest();
        };
        Kb3dViewer.prototype.onKeyboard = function (k) {
            var _this = this;
            var args = this.getRuleArgs(enums.eRuleType.action);
            args['keyArgs'] = k;
            return this.ruleService
                .runRuleTypeAsync(this.sceneConfig, enums.eRuleType.keyboard, args)
                .then(function (r) {
                _this.handleRuleError(enums.eRuleType.keyboard, r);
                _this.$scope.$digest();
            });
        };
        Kb3dViewer.prototype.importUploadFieldImage = function (uiConfig, field, file) {
            return undefined;
        };
        Kb3dViewer.prototype.show = function () {
            _super.prototype.show.call(this);
            this.viewer.startRender();
        };
        Kb3dViewer.prototype.hide = function () {
            this.viewer.stopRender();
            _super.prototype.hide.call(this);
        };
        Kb3dViewer.prototype.resize = function () { };
        Kb3dViewer.prototype.snapshot = function (args) {
            if (args['camera'] && !args.viewpoint)
                args.viewpoint = args['camera']; //backwards compatibility for old snapshot
            return this.viewer.snapshot.take(args);
        };
        Kb3dViewer.prototype.toggleAr = function () {
            var _this = this;
            var rulesFn = function (rt) {
                return _this.runRuleTypeAsync(_this.sceneConfig, rt, _this.getRuleArgs(rt)).then(function () {
                    return _this.runRules(false);
                });
            };
            if (this.arLoading.active()) {
                return;
            }
            var ruleType = this.$scope.arActive() ? enums.eRuleType.xrExit : enums.eRuleType.xrEnter;
            if (ruleType == enums.eRuleType.xrEnter) {
                var subscription_1 = this.viewer.ar.onSessionEnd.subscribe(function () {
                    subscription_1.unsubscribe();
                    return rulesFn(enums.eRuleType.xrExit);
                });
                var overlayElem = document.querySelector('.xr-overlay');
                var arPromise = this.viewer.ar
                    .start(overlayElem, function () { return rulesFn(enums.eRuleType.xrEnter); })
                    .catch(function (err) {
                    if (_this.cArgs.dialogService) {
                        _this.$scope.$apply(function () {
                            _this.cArgs.dialogService.alert({
                                type: enums.eAlertType.error,
                                msg: 'Could not enter AR: ' + err,
                                persist: true,
                            });
                        });
                    }
                    else {
                        console.warn('No Dialog Service!');
                        console.error(err);
                    }
                });
                this.arLoading.addPromise(arPromise);
                return arPromise;
            }
            else {
                return this.viewer.ar.end();
            }
        };
        Kb3dViewer.prototype.updateHotspots = function (digest) {
            var _this = this;
            var _a, _b;
            if (digest === void 0) { digest = true; }
            var hotspotProcessed = false;
            var _loop_1 = function (hotspot) {
                var sceneNode = (_b = (_a = hotspot.$parentConfigurator) === null || _a === void 0 ? void 0 : _a.$uiConfigurator) === null || _b === void 0 ? void 0 : _b.$sceneNode;
                if (sceneNode) {
                    var sceneManager = sceneNode._manager;
                    if (sceneManager) {
                        if (hotspot.target && hotspot.targetNode && hotspot.visible) {
                            hotspotProcessed = true;
                            var targetNode = sceneManager.getById(hotspot.targetNode);
                            if (targetNode) {
                                var pos = this_1.viewer.camera.getScreenBoundingBoxOfNode(targetNode);
                                if (pos) {
                                    this_1.positionHotspot(pos, hotspot);
                                }
                            }
                        }
                        if (hotspot.targetShape == enums.eHotspotShape.mesh && hotspot.targetNode) {
                            var eventTag = "hotspot_".concat(hotspot.id);
                            var node = sceneManager.getById(hotspot.targetNode);
                            if (node) {
                                if (hotspot.visible) {
                                    if (!sceneManager.clickHandlers.has(node, eventTag)) {
                                        sceneManager.clickHandlers.add(node, eventTag, function () {
                                            return _this.hotspotClick({}, hotspot);
                                        });
                                    }
                                }
                                else {
                                    //remove the click handler if the hotspot is invisible
                                    sceneManager.clickHandlers.delete(node, eventTag);
                                }
                            }
                        }
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _c = this.$scope.allHotspots; _i < _c.length; _i++) {
                var hotspot = _c[_i];
                _loop_1(hotspot);
            }
            // call digest manually on this scope instead of scope.$apply because $apply starts
            // at the root and digests everything.We only want to affect the hotspots here.
            if (hotspotProcessed && digest) {
                //this can be expensive, so only run if there is something to update
                this.$scope.$digest();
            }
        };
        Kb3dViewer.prototype.clearHotspots = function () {
            for (var _i = 0, _a = this.$scope.allHotspots; _i < _a.length; _i++) {
                var hotspot = _a[_i];
                if (hotspot.target && hotspot.allowClose) {
                    hotspot.open = false;
                }
            }
        };
        Kb3dViewer.prototype.hotspotClick = function ($event, hotspot) {
            var _this = this;
            this.clearHotspots();
            hotspot.open = true;
            this.hotspotCounter++;
            hotspot.$zindex = this.hotspotCounter;
            var hSceneNode = hotspot.$parentConfigurator.$uiConfigurator.$sceneNode;
            var handlers = hSceneNode._manager.hotspotClickHandlers.getByKey(hotspot);
            if (hotspot.idCamera) {
                var viewpoint = hSceneNode._manager.getById(hotspot.idCamera);
                if (viewpoint) {
                    this.viewer.camera.animateToViewpoint(viewpoint, {
                        duration: hotspot.animationDuration,
                    });
                }
            }
            for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
                var handler = handlers_1[_i];
                var clickArgs = { propagate: false };
                handler(clickArgs);
            }
            // some hotspot popups start off the screen because the height can't be calculated until it's shown
            // so we need to offload to recalculate the hotspot position after the digest
            this.$timeout(function () {
                if (hotspot.target && hotspot.targetNode && hotspot.visible) {
                    var targetNode = hSceneNode._manager.getById(hotspot.targetNode);
                    if (targetNode) {
                        var pos = _this.viewer.camera.getScreenBoundingBoxOfNode(targetNode);
                        if (pos) {
                            _this.positionHotspot(pos, hotspot);
                        }
                    }
                }
            });
        };
        Kb3dViewer.prototype.hotspotCloseClick = function ($event, hotspot) {
            $event.stopPropagation();
            hotspot.open = false;
        };
        Kb3dViewer.prototype.getRuleArgs = function (ruleType) {
            var args;
            if (ruleType == enums.eRuleType.function) {
                args = new Kb3dSceneFunctionRuleArgs(this);
            }
            else {
                args = new Kb3dSceneRuleArgs(this);
            }
            args.environment = this.environment;
            args.baseUrl = this.baseUrl;
            args.configurator = this.sceneConfig.idProduct ? this.uiConfig : this.sceneConfig;
            args.kom = args.configurator.$manager;
            args.parentKom = args.configurator.$parentConfigurator ? args.configurator.$parentConfigurator.$manager : null;
            args.sceneKom = this.sceneConfig.$manager;
            args.sceneNode = this.sceneNode;
            //args.sceneApi = this.sceneApi;
            args.isRender = this.isRender;
            args.isOutput = this.isOutput;
            args.renderPass = this.renderPass;
            //args.sceneUtils = this.sceneService.getSceneUtilities(this.sceneApi, ruleType);
            args.clientLanguage = this.clientLanguage;
            args.ruleType = ruleType;
            args.xrActive = this.viewer.ar.xrActive;
            return args;
        };
        Kb3dViewer.prototype.getNestedSceneRuleArgs = function (uiConfig, sceneConfig, ruleType) {
            var args = new Kb3dSceneRuleArgs(this);
            args.environment = this.environment;
            args.baseUrl = this.baseUrl;
            args.configurator = uiConfig;
            args.kom = args.configurator.$manager;
            args.parentKom = args.configurator.$parentConfigurator ? args.configurator.$parentConfigurator.$manager : null;
            args.sceneKom = sceneConfig.$manager;
            args.sceneNode = uiConfig.$sceneNode;
            //args.sceneApi = this.sceneApi;
            args.isRender = this.isRender;
            args.isOutput = this.isOutput;
            args.renderPass = this.renderPass;
            //args.sceneUtils = this.sceneService.getSceneUtilities(this.sceneApi, ruleType);
            args.clientLanguage = this.clientLanguage;
            args.ruleType = ruleType;
            args.xrActive = this.viewer.ar.xrActive;
            return args;
        };
        return Kb3dViewer;
    }(SceneViewer));
    var Kb3dSceneRuleArgs = /** @class */ (function () {
        function Kb3dSceneRuleArgs(kbv) {
            this.kbv = kbv;
            this.logs = new _rules.ClientLogger();
            this.isMobile = kbv.isMobile;
        }
        Kb3dSceneRuleArgs.prototype.upload = function () {
            //return this.viewer.upload();
        };
        Kb3dSceneRuleArgs.prototype.sendMessage = function (msg) {
            this.kbv.sendMessage(msg);
        };
        Kb3dSceneRuleArgs.prototype.selectPage = function (page) {
            if (this.kbv.navigateToElement) {
                this.kbv.navigateToElement(page);
            }
        };
        Kb3dSceneRuleArgs.prototype.convertCurrency = function (obj) {
            return null;
        };
        Kb3dSceneRuleArgs.prototype.getTables = function (args) {
            var _this = this;
            return new _rules.KPromise(args.ids.map(function (tid) { return _this.kbv.tableArraysDb[tid]; }));
        };
        Kb3dSceneRuleArgs.prototype.getById = function (id) {
            return this.sceneNode._manager.getById(id);
        };
        Kb3dSceneRuleArgs.prototype.getByName = function (name) {
            var node = this.sceneNode._manager.getFirstNodeByName(name, true);
            if (!node) {
                console.warn("No nodes \"".concat(name, "\" found"));
            }
        };
        Kb3dSceneRuleArgs.prototype.getIdByName = function (name) {
            var node = this.sceneNode._manager.getNodeByIdOrName(name);
            if (!node) {
                console.warn("No nodes \"".concat(name, "\" found"));
            }
            else {
                return node.id;
            }
        };
        Kb3dSceneRuleArgs.prototype.getParent = function (n) {
            var node = this.sceneNode._manager.getNodeByIdOrName(n);
            if (node) {
                return node._parent;
            }
        };
        Kb3dSceneRuleArgs.prototype.getNestedPathTo = function (node) {
            return this.sceneNode.getNestedPathTo(node);
        };
        Kb3dSceneRuleArgs.prototype.getNestedPathInConfigurator = function () {
            var _this = this;
            var configs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                configs[_i] = arguments[_i];
            }
            var m = this.sceneNode._manager;
            var lastItem = configs.pop(); // Last item can be a node ID or name as well
            var path = configs.reduce(function (result, config) {
                if (typeof config === 'string') {
                    result += config;
                    var configurator = _this.kom.getByName(config);
                    if (configurator instanceof enums.Configurator && configurator.$sceneNode) {
                        m = configurator.$sceneNode._manager;
                    }
                }
                else {
                    result += config.name;
                    if (config.$sceneNode) {
                        m = config.$sceneNode._manager;
                    }
                }
                return result + '/';
            }, '');
            if (typeof lastItem === 'string') {
                var lastConfig = this.kom.getByName(lastItem, false);
                if (lastConfig instanceof enums.Configurator) {
                    if (!lastConfig.$sceneNode) {
                        console.warn('No Scene on configurator ' + lastConfig.name);
                        return null;
                    }
                    path += lastConfig.name + '/' + lastConfig.$sceneNode.id;
                }
                else {
                    var kb3dNode = m.getFirstNodeByName(lastItem);
                    if (kb3dNode) {
                        path += kb3dNode.id;
                    }
                    else {
                        path += lastItem;
                    }
                }
            }
            else {
                var lastConfig = lastItem;
                if (!lastConfig.$sceneNode) {
                    console.warn('No Scene on configurator ' + lastConfig.name);
                    return null;
                }
                path += lastConfig.name + '/' + lastConfig.$sceneNode.id;
            }
            return '@' + path;
        };
        Kb3dSceneRuleArgs.prototype.setParent = function (opts) {
            var manager = this.sceneNode._manager;
            var item = manager.getNodeByIdOrName(opts.node);
            var newParentNode = opts.newParent ? manager.getNodeByIdOrName(opts.newParent, false) : undefined;
            var transform = opts.preservePosition && kb3d.isSpaceNode(item)
                ? this.kbv.viewer.getTransformSpaceDifference(item, newParentNode)
                : undefined;
            var clickHandlers;
            var doubleClickHandlers;
            var draggables;
            if (item._parent) {
                if (kb3d.isSpaceNode(item) || kb3d.isAnnotation(item)) {
                    clickHandlers = manager.clickHandlers.deleteByKey(item);
                    doubleClickHandlers = manager.doubleClickHandlers.deleteByKey(item);
                    draggables = manager.draggables.deleteByKey(item);
                }
                item._parent.removeChildren(item);
            }
            return this.kbv.viewer.forceAndWaitForNextRender().then(function () {
                if (transform && kb3d.isSpaceNode(item)) {
                    item.setRotationQuaternion(transform.rotationQuaternion);
                    item.scaling = transform.scale;
                    item.position = transform.translation;
                }
                newParentNode.addChildren(item);
                item.calculateParents();
                if (kb3d.isSpaceNode(item) || kb3d.isAnnotation(item)) {
                    if (clickHandlers) {
                        for (var tag in clickHandlers) {
                            for (var _i = 0, _a = clickHandlers[tag]; _i < _a.length; _i++) {
                                var handler = _a[_i];
                                manager.clickHandlers.add(item, tag, handler);
                            }
                        }
                    }
                    if (doubleClickHandlers) {
                        for (var tag in doubleClickHandlers) {
                            for (var _b = 0, _c = doubleClickHandlers[tag]; _b < _c.length; _b++) {
                                var handler = _c[_b];
                                manager.doubleClickHandlers.add(item, tag, handler);
                            }
                        }
                    }
                    if (draggables) {
                        for (var tag in draggables) {
                            for (var _d = 0, _e = draggables[tag]; _d < _e.length; _d++) {
                                var handler = _e[_d];
                                manager.draggables.add(item, tag, handler);
                            }
                        }
                    }
                }
            });
            // const newNode = this.clone({ node: item, parent: newParentNode });
        };
        Kb3dSceneRuleArgs.prototype.setProperty = function (args) {
            var m = this.sceneNode._manager;
            var nodes = new Array();
            var id = args.id;
            if (args.nested) {
                nodes.push(this.getNestedSceneNode(args.nested));
            }
            else if (id && (id instanceof kb3d__namespace.Kb3dObject || id === this.kbv.viewer.camera.activeCamera)) {
                nodes.push(id);
            }
            else {
                nodes = m.getNodesByIdOrName(args.id, true);
            }
            if (nodes.length === 0) {
                console.warn("No nodes \"".concat(args.id, "\" found"));
            }
            if (args.feature) {
                nodes = nodes.selectMany(function (n) {
                    return n instanceof kb3d.MaterialNode
                        ? n.getTextureByName(args.feature)
                        : n instanceof kb3d.SpaceNode
                            ? n.getFeatureByName(args.feature)
                            : null;
                });
            }
            for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
                var node = nodes_1[_i];
                if (args.subProp && !kb3d__namespace.Token.withKey(args.propType).isPrimitive()) {
                    //cover the case of TextureNodes inside a material
                    node[args.prop][args.subProp] = args.value;
                }
                else {
                    var val = this.normalizePropValue(node, args);
                    node[args.prop] = val;
                }
            }
        };
        Kb3dSceneRuleArgs.prototype.getProperty = function (args) {
            var m = this.sceneNode._manager;
            var id = args.id;
            var node;
            if (id && (id instanceof kb3d__namespace.Kb3dObject || id === this.kbv.viewer.camera.activeCamera)) {
                node = id;
            }
            else {
                node = m.getNodeByIdOrName(args.id, true);
            }
            if (args.feature && node instanceof kb3d.MaterialNode) {
                node = node.getTextureByName(args.feature);
            }
            if (args.feature && node instanceof kb3d.SpaceNode) {
                node = node.getFeatureByName(args.feature);
            }
            if (node) {
                var val = args.prop ? node[args.prop] : node;
                if (args.prop && args.subProp)
                    val = val[args.subProp];
                return val;
            }
            else {
                console.warn("No nodes \"".concat(args.id, "\" found"));
            }
        };
        Kb3dSceneRuleArgs.prototype.normalizePropValue = function (node, args) {
            var _a;
            if (!args.subProp && args.value == null) {
                return null; // Return null as-is if applying directly to the prop
            }
            if (!args.subProp && args.propType && args.propType.isEqual(kb3d__namespace.Token.KbColor.key)) {
                return this.convertColor(args.value, enums.eColorFormat.kbcolor);
            }
            if (args.subProp) {
                if (kb3d__namespace.Token.withKey(args.propType).isPrimitive()) {
                    if (args.value == null) {
                        throw Error("Cannot set component of ".concat(args.propType, " to null (on ").concat(node.name, "/").concat(args.prop, ")"));
                    }
                    var currentVal = node[args.prop];
                    var newVal = __assign(__assign({}, currentVal), (_a = {}, _a[args.subProp] = args.value, _a));
                    return this.sceneNode._manager.create(kb3d__namespace.Token.withKey(args.propType), newVal);
                } /**else { //it's not a primitive but has a sub property
                    node[args.prop][args.subProp] = args.value;
                    return node[args.prop];
                }*/
            }
            return args.value;
        };
        Kb3dSceneRuleArgs.prototype.getNestedSceneNode = function (nestedNameOrInstance) {
            var nestedConfig;
            if (typeof nestedNameOrInstance === 'string' || nestedNameOrInstance instanceof String) {
                //if it's a string find the nested configurator
                nestedConfig = this.configurator.$manager.getByName(nestedNameOrInstance);
            }
            else if (nestedNameOrInstance instanceof enums.Configurator) {
                nestedConfig = nestedNameOrInstance;
            }
            if (!nestedConfig) {
                throw Error("could not find nested configurator with name '".concat(nestedNameOrInstance, "'"));
            }
            return nestedConfig.$sceneNode;
        };
        Kb3dSceneRuleArgs.prototype.convertColor = function (from, toFormat) {
            if (toFormat === void 0) { toFormat = enums.eColorFormat.kbcolor; }
            if (toFormat == enums.eColorFormat.kbcolor && from instanceof kb3d__namespace.KbColor) {
                return from;
            }
            if (from instanceof kb3d__namespace.KbColor) {
                from = from.toIntObject();
            }
            var color = new _tools.Color(from);
            var result;
            if (toFormat == enums.eColorFormat.hex) {
                result = color.toHexString();
            }
            else if (toFormat == enums.eColorFormat.hsl) {
                result = color.toHsl();
            }
            else if (toFormat == enums.eColorFormat.hslString) {
                result = color.toHslString();
            }
            else if (toFormat == enums.eColorFormat.hsv) {
                result = color.toHsv();
            }
            else if (toFormat == enums.eColorFormat.hsvString) {
                result = color.toHsvString();
            }
            else if (toFormat == enums.eColorFormat.rgb) {
                result = color.toRgb();
            }
            else if (toFormat == enums.eColorFormat.rgbString) {
                result = color.toRgbString();
            }
            else if (toFormat == enums.eColorFormat.kbcolor) {
                var rgb = color.toRgb();
                result = kb3d__namespace.KbColor.FromIntObject(rgb);
            }
            return result;
        };
        Kb3dSceneRuleArgs.prototype.colorOperation = function (args) {
            if (args.color instanceof kb3d.KbColor) {
                args.color = args.color.toIntObject();
            }
            var color = new _tools.Color(args.color);
            color = color[args.operation](args.amount);
            return kb3d.KbColor.FromIntObject(color.toRgb());
        };
        Kb3dSceneRuleArgs.prototype.addClickHandler = function (args) {
            args.handler = this.digestEvent(args.handler); //the viewer runs the event, so we need to wrap it for the angular digest
            this.sceneNode._manager.clickHandlers.add(args.id, this.getHandlerTag(args.tag), args.handler);
        };
        Kb3dSceneRuleArgs.prototype.addDragHandler = function (args) {
            args.handler = this.digestEvent(args.handler); //the viewer runs the event, so we need to wrap it for the angular digest
            this.sceneNode._manager.dragHandlers.add(args.id, this.getHandlerTag(args.tag), args.handler);
        };
        Kb3dSceneRuleArgs.prototype.addDoubleClickHandler = function (args) {
            args.handler = this.digestEvent(args.handler); //the viewer runs the event, so we need to wrap it for the angular digest
            this.sceneNode._manager.doubleClickHandlers.add(args.id, this.getHandlerTag(args.tag), args.handler);
        };
        Kb3dSceneRuleArgs.prototype.addDraggable = function (args) {
            this.sceneNode._manager.draggables.add(args.id, this.getHandlerTag(args.tag), args);
        };
        Kb3dSceneRuleArgs.prototype.addHotspotClickHandler = function (args) {
            //no $digest wrap needed for hotspot handler because the event is already coming from angular
            this.sceneNode._manager.hotspotClickHandlers.set(args.hotspot, this.getHandlerTag(args.tag), args.handler);
        };
        Kb3dSceneRuleArgs.prototype.addCameraChangeHandler = function (args) {
            var wrappedHandler = this.digestEvent(args.handler);
            var tag = this.getHandlerTag('');
            this.sceneNode._manager.cameraChangeHandlers.push({ tag: tag, orbit: args.orbit, pan: args.pan, zoom: args.zoom, handler: wrappedHandler });
        };
        Kb3dSceneRuleArgs.prototype.removeCameraChangeHandler = function () {
            this.sceneNode._manager.cameraChangeHandlers.length = 0;
        };
        Kb3dSceneRuleArgs.prototype.addBoundboxChangeHandler = function (args) {
            args.handler = this.digestEvent(args.handler); //the viewer runs the event, so we need to wrap it for the angular digest
            this.sceneNode._manager.boundingboxChangeHandlers.add(args.id, this.getHandlerTag(args.tag), {
                handler: args.handler,
                mode: args.mode,
            });
        };
        Kb3dSceneRuleArgs.prototype.getHandlerTag = function (argsTag) {
            if (this.ruleType == enums.eRuleType.scene) {
                //scene rule handlers get a tag of 'scene' automatically and are removed automatically
                return enums.eRuleType.scene;
            }
            else {
                //those added by other rules get the tag given by the snap user
                return argsTag;
            }
        };
        Kb3dSceneRuleArgs.prototype.clearHandlers = function (args) {
            var handlerMap;
            var m = this.sceneNode._manager;
            if (args.handlerType == kb3d__namespace.eHandler.click) {
                handlerMap = m.clickHandlers;
            }
            else if (args.handlerType == kb3d__namespace.eHandler.doubleClick) {
                handlerMap = m.doubleClickHandlers;
            }
            else if (args.handlerType == kb3d__namespace.eHandler.draggable) {
                handlerMap = m.draggables;
            }
            else if (args.handlerType == kb3d__namespace.eHandler.drag) {
                handlerMap = m.dragHandlers;
            }
            else if (args.handlerType == kb3d__namespace.eHandler.hotspot) {
                handlerMap = m.hotspotClickHandlers;
            }
            if (handlerMap) {
                if (args.tag) {
                    handlerMap.deleteByTag(args.tag);
                }
                else {
                    handlerMap.clear();
                }
            }
        };
        Kb3dSceneRuleArgs.prototype.animate = function (args) {
            var nodes = new Array();
            if (args.node) {
                nodes = [args.node];
            }
            else {
                nodes = this.sceneNode._manager.getNodesByIdOrName(args.id, true);
            }
            var promises = new Array();
            for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
                var node = nodes_2[_i];
                var toValue = this.normalizePropValue(node, args);
                var a = __assign(__assign({}, args), { toValue: toValue, node: node });
                promises.push(this.kbv.viewer.animation.queue(a));
            }
            return Promise.all(promises);
        };
        Kb3dSceneRuleArgs.prototype.frameCamera = function (args) {
            this.kbv.viewer.camera.frameCamera(args.node, args);
        };
        Kb3dSceneRuleArgs.prototype.animateCamera = function (args) {
            return this.kbv.viewer.camera.animateToViewpoint(args.viewpoint, args);
        };
        Kb3dSceneRuleArgs.prototype.create = function (args) {
            var token = kb3d__namespace.Token.withKey(args.type);
            var n = undefined;
            if (args.args.id) {
                var existingNode = this.kbv.viewer.getNode(args.args.id);
                if (existingNode) {
                    if (this.environment === enums.eEnvironment.dev) {
                        console.warn("Node with staticId ".concat(args.args.id, " already exists, node's properties will be updated."));
                    }
                    if (args.args && Object.keys(args.args).length > 1) {
                        this.sceneNode._manager.assign(existingNode, args.args);
                    }
                    n = existingNode;
                }
                else {
                    n = this.sceneNode._manager.create(token, args.args);
                    this.addToParent(n, args.parent, token);
                }
            }
            else {
                n = this.sceneNode._manager.create(token, args.args);
                this.addToParent(n, args.parent, token);
            }
            return n;
        };
        Kb3dSceneRuleArgs.prototype.createSketchPath = function (args) {
            var n = this.sceneNode._manager.create(kb3d__namespace.Token.SketchPath, args.args);
            this.addToParent(n, args.parent, kb3d__namespace.Token.SketchPath);
            var controlPoints = args.controlPoints.filter(function (input) { return input && input instanceof kb3d__namespace.SketchControlPoint; });
            n.addChildren.apply(n, controlPoints);
            return n;
        };
        Kb3dSceneRuleArgs.prototype.clone = function (args) {
            var o = args.node;
            var clone = this.sceneNode._manager.clone(o);
            for (var p in args.args) {
                clone[p] = args.args[p];
            }
            var token = kb3d__namespace.Token.withKey(clone.$type);
            this.addToParent(clone, args.parent, token);
            return clone;
        };
        Kb3dSceneRuleArgs.prototype.delete = function (node) {
            if (node && node._parent) {
                node._parent.removeChildren(node);
            }
        };
        Kb3dSceneRuleArgs.prototype.getChildrenOfType = function (args) {
            var n = args.node;
            if (n instanceof kb3d__namespace.Kb3dObject) {
                var tok = kb3d__namespace.Token.withKey(args.type);
                return n.filterByType(tok);
            }
            else {
                return [];
            }
        };
        Kb3dSceneRuleArgs.prototype.searchByName = function (name) {
            return this.sceneNode._manager.getNodesByIdOrName(name, true);
        };
        Kb3dSceneRuleArgs.prototype.getActiveCamera = function () {
            return this.kbv.viewer.camera.activeCamera;
        };
        Kb3dSceneRuleArgs.prototype.highlight = function (args) {
            var _this = this;
            this.kbv.viewer.forceAndWaitForNextRender().then(function () {
                //wait for next render to make sure the mesh exists before highlighting
                var nodes = _this.sceneNode._manager.getNodesByIdOrName(args.id);
                for (var _i = 0, nodes_3 = nodes; _i < nodes_3.length; _i++) {
                    var n = nodes_3[_i];
                    if (n instanceof kb3d__namespace.SpaceNode) {
                        if (args.on) {
                            _this.kbv.viewer.highlighter.add(n, _this.convertColor(args.color, enums.eColorFormat.kbcolor));
                        }
                        else {
                            _this.kbv.viewer.highlighter.remove(n);
                        }
                    }
                }
            });
        };
        Kb3dSceneRuleArgs.prototype.clearHighlights = function () {
            this.kbv.viewer.highlighter.clearAll();
        };
        Kb3dSceneRuleArgs.prototype.activateGizmo = function (args) {
            var _this = this;
            var attachMesh;
            // Rotation with override space node doesn't function well. Disable that functionality so people don't try to use it,
            // Until we can swap axis/angle gizmo in and fix the transform space conversion
            if (args.gizmo === 'rotate') {
                delete args.overrideSpaceNode;
            }
            if (args.overrideSpaceNode) {
                attachMesh = args.overrideSpaceNode;
            }
            else {
                attachMesh = args.node;
            }
            var mesh = args.node;
            this.kbv.viewer.gizmos.clearGizmo();
            if (args.gizmo === 'rotate') {
                var updates = this.kbv.viewer.gizmos.rotate([attachMesh], undefined, undefined, args.axisVisibility);
                var startQ_1 = kb3d.KbQuaternion.FromRotationAxis(mesh.rotationAxis, mesh.rotationAngle);
                var startEuler_1 = mesh.eulerRotation.clone();
                updates.update.subscribe(function (updates) {
                    mesh._primeMover = true;
                    updates.forEach(function (update, index) {
                        mesh.position = mesh.position.add(update.position);
                        var qGizmo = kb3d.KbQuaternion.FromYawPitchRoll(update.rotation);
                        if (!args.overrideSpaceNode) {
                            if (mesh.useEuler) {
                                mesh.eulerRotation = mesh.eulerRotation.add(update.rotation);
                            }
                            else {
                                var q = kb3d.KbQuaternion.FromRotationAxis(mesh.rotationAxis, mesh.rotationAngle);
                                var z = kb3d.KbQuaternion.FromYawPitchRoll(update.rotation);
                                var result = q.multiply(z);
                                mesh.rotationAngle = result.getAngle();
                                mesh.rotationAxis = result.getAxis();
                            }
                            return;
                        }
                        else {
                            var bnode = _this.kbv.viewer.getRendererNode(args.node);
                            if (bnode) {
                                var inSpace = bnode.parent ? bnode.parent.computeWorldMatrix(true) : undefined;
                                var transform = kb3d.applyTransformToSpace(update.worldTransformMatrix, inSpace);
                                qGizmo = transform.rotation;
                            }
                            if (mesh.useEuler) {
                                mesh.eulerRotation = startEuler_1.add(qGizmo.toEuler());
                            }
                            else {
                                var result = startQ_1.multiply(qGizmo);
                                mesh.rotationAngle = result.getAngle();
                                mesh.rotationAxis = result.getAxis();
                            }
                        }
                    });
                });
                updates.totalDelta.subscribe(function () {
                    startQ_1 = kb3d.KbQuaternion.FromRotationAxis(mesh.rotationAxis, mesh.rotationAngle);
                    startEuler_1 = mesh.eulerRotation.clone();
                    if (args.dropped) {
                        args.dropped();
                    }
                    mesh._primeMover = false;
                });
            }
            else if (args.gizmo === 'position') {
                //update attachMesh 
                var updates = null;
                if (args.overrideSpaceNode && args.overrideSpaceNode instanceof kb3d.SpaceNode) {
                    var rotationQuaternion = args.overrideSpaceNode.getRotationQuaternion();
                    updates = this.kbv.viewer.gizmos.position(args.node, undefined, args.axisVisibility, rotationQuaternion.toQuat());
                }
                else {
                    updates = this.kbv.viewer.gizmos.position(attachMesh, undefined, args.axisVisibility);
                }
                if (updates) {
                    updates.update.subscribe(function (newPosition) {
                        mesh._primeMover = true;
                        mesh.position = mesh.position.add(newPosition);
                    });
                }
                if (args.dropped) {
                    updates.totalDelta.subscribe(function () {
                        args.dropped();
                        mesh._primeMover = false;
                    });
                }
            }
        };
        Kb3dSceneRuleArgs.prototype.clearGizmos = function () {
            this.kbv.viewer.gizmos.clearGizmo();
        };
        Kb3dSceneRuleArgs.prototype.activateSketchEditor = function (args) {
            var _this = this;
            this.clearSketchEditor();
            if (args.node instanceof kb3d__namespace.SketchNode) {
                this.kbv.viewer.sketchEditor.startOnPlane(args.node, {
                    normal: args.axis || args.node.normal,
                    intersect: args.intersect || args.node.position,
                }, {
                    snapSize: args.snapSize || undefined,
                });
                if (args.modified) {
                    this.kbv.viewer.sketchEditor.mouseUp.subscribe(function () {
                        _this.kbv.viewer.forceAndWaitForNextRender().then(function () {
                            args.modified();
                        });
                    });
                }
            }
        };
        Kb3dSceneRuleArgs.prototype.clearSketchEditor = function () {
            this.kbv.viewer.sketchEditor.clear();
        };
        Kb3dSceneRuleArgs.prototype.overwriteSketchWithSVG = function (args) {
            var _this = this;
            if (args.svgImage) {
                fetch(args.svgImage)
                    .then(function (resp) { return resp.blob(); })
                    .then(function (blob) { return _this.kbv.viewer.applySvgToSketch(args.node, blob); })
                    .catch(function (e) {
                    console.warn('Could not fetch image ' + args.svgImage, e);
                });
            }
        };
        Kb3dSceneRuleArgs.prototype.getAbsolutePosition = function (node) {
            var n = this.sceneNode._manager.getNodeByIdOrName(node);
            if (n) {
                var bnode = this.kbv.viewer.getRendererNode(n);
                if (bnode) {
                    return kb3d__namespace.KbVector.From(bnode.getAbsolutePosition());
                }
            }
            return kb3d__namespace.KbVector.Zero();
        };
        Kb3dSceneRuleArgs.prototype.getSketchPathLength = function (path) {
            var pointsArray = [];
            path._points.forEach(function (point) {
                pointsArray.push([point.x, point.y, point.z]);
            });
            return computeLength(pointsArray);
            function computeLength(path) {
                var l = 0;
                for (var i = 1; i < path.length; i++) {
                    var point = path[i];
                    var prevPoint = path[i - 1];
                    l += Math.hypot.apply(Math, [point[0] - prevPoint[0], point[1] - prevPoint[1], point[2] - prevPoint[2]]);
                }
                return l;
            }
        };
        Kb3dSceneRuleArgs.prototype.removeMates = function (node) {
            var _this = this;
            var n = this.sceneNode._manager.getNodeByIdOrName(node);
            var connectors = [];
            if (n instanceof kb3d__namespace.Connector) {
                connectors.push(n);
            }
            else if (n instanceof kb3d__namespace.SpaceNode) {
                n.connectors.forEach(function (connector) {
                    connectors.push(connector);
                });
            }
            var matesToRemove = [];
            this.sceneNode.mates.forEach(function (mate) {
                connectors.forEach(function (connector) {
                    if (mate.connector1 === connector.id || mate.connector2 === connector.id) {
                        matesToRemove.push(mate);
                    }
                });
            });
            matesToRemove.forEach(function (mate) {
                _this.sceneNode.mates.remove(mate);
            });
        };
        Kb3dSceneRuleArgs.prototype.getBoundingBox = function (node, space) {
            if (space === void 0) { space = 'world'; }
            if (space === 'world') {
                return this.kbv.viewer.bbCache.getWorld(node);
            }
            else {
                return this.kbv.viewer.bbCache.refreshAndGet(node);
            }
        };
        Kb3dSceneRuleArgs.prototype.nodesIntersect = function (node1, node2) {
            return this.kbv.viewer.nodesIntersect(node1, node2);
        };
        Kb3dSceneRuleArgs.prototype.copyPropertiesTo = function (fromNode, toNode) {
            if (this.sceneNode && this.sceneNode._manager) {
                this.sceneNode._manager.assign(toNode, fromNode, { copyingToDifferentNode: true });
            }
        };
        Kb3dSceneRuleArgs.prototype.getMateChain = function (node) {
            var activeMates = this.kbv.viewer.getActiveMates();
            return __spreadArray([node], Array.from(kb3d__namespace.getNodeChain(node, activeMates)), true);
        };
        Kb3dSceneRuleArgs.prototype.rotate = function (args) {
            args.node.rotate(args.axis, args.angle);
        };
        Kb3dSceneRuleArgs.prototype.callSceneFunction = function (args, config) {
            if (!this.kbv) {
                console.warn("Scene function ".concat(args.name, " was called but a scene is not loaded."));
                return Promise.reject();
            }
            return this.kbv.runSceneFunction(args, config).then(function (r) { return r.parameters.returnValue; });
        };
        Kb3dSceneRuleArgs.prototype.waitForNextRender = function () {
            return this.kbv.viewer.forceAndWaitForNextRender();
        };
        Kb3dSceneRuleArgs.prototype.convertAxisAngleToEuler = function (axis, angle) {
            var q = kb3d__namespace.KbQuaternion.FromRotationAxis(axis, angle);
            return kb3d__namespace.roundKbVectorToPlaces(q.toEuler(), 0.0000001); //round out floating point errors
        };
        Kb3dSceneRuleArgs.prototype.getGlobalMaterialNode = function (id) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                return _this.kbv.viewer.rendererManager.material
                    .loadGlobalMaterial(id, _this.sceneNode._manager.services)
                    .subscribe(resolve, reject);
            });
        };
        Kb3dSceneRuleArgs.prototype.getGlobalMaterialNodeByName = function (name) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                return _this.kbv.viewer.rendererManager.material
                    .getGlobalMaterialByName(name, _this.sceneNode._manager.services)
                    .subscribe(resolve, reject);
            });
        };
        Kb3dSceneRuleArgs.prototype.addToParent = function (node, parent, childToken) {
            if (parent) {
                parent.addChildren(node);
            }
        };
        Kb3dSceneRuleArgs.prototype.digestEvent = function (ev) {
            var _this = this;
            return function (a) {
                ev(a);
                _this.kbv.$scope.$digest();
            };
        };
        return Kb3dSceneRuleArgs;
    }());
    var Kb3dSceneFunctionRuleArgs = /** @class */ (function (_super) {
        __extends(Kb3dSceneFunctionRuleArgs, _super);
        function Kb3dSceneFunctionRuleArgs(kbv) {
            var _this = _super.call(this, kbv) || this;
            _this.kbv = kbv;
            return _this;
        }
        return Kb3dSceneFunctionRuleArgs;
    }(Kb3dSceneRuleArgs));

    var CacheBusterInterceptor = /** @class */ (function () {
        function CacheBusterInterceptor($injector, $rootScope, $templateCache, $q) {
            var _this = this;
            this.$injector = $injector;
            this.$rootScope = $rootScope;
            this.$templateCache = $templateCache;
            this.$q = $q;
            return {
                request: function (config) {
                    // if it's already in the templatecache, then just get it from there
                    if ($templateCache.get(config.url)) {
                        return config;
                    }
                    if (config.method == "GET") {
                        // we only cache-bust stuff from our own server.  Presumably these requests will have a relative url
                        if (!_tools.Utils.isAbsoluteUrl(config.url)) {
                            var extension = _tools.Utils.getExtension(config.url) || "";
                            extension = extension.toLowerCase();
                            // non file calls in the test and prod environments should send the last deploy,
                            // which allows the browser cache to store results for some calls
                            var company = _this.$rootScope.company;
                            var env = _this.$rootScope.environment;
                            if (env != enums.eEnvironment.dev) {
                                var lastDeploy = (env == enums.eEnvironment.test ? company.lastTestDeployment : company.lastProdDeployment);
                                if (!extension) {
                                    var prefix = "?";
                                    if (config.url.search("\\?") !== -1) {
                                        prefix = "&";
                                    }
                                    config.url += "".concat(prefix, "d=").concat(lastDeploy, "&v=").concat($rootScope.cacheBuster);
                                }
                            }
                        }
                    }
                    return config;
                }
            };
        }
        CacheBusterInterceptor = __decorate([
            NgInterceptor({
                token: Token.CacheBusterInterceptor,
                dependencies: [
                    Token.$Injector,
                    Token.$RootScope,
                    Token.$TemplateCache,
                    Token.$Q,
                ]
            })
        ], CacheBusterInterceptor);
        return CacheBusterInterceptor;
    }());

    var ErrorInterceptor = /** @class */ (function () {
        function ErrorInterceptor($injector, $rootScope, $q) {
            this.$injector = $injector;
            this.$rootScope = $rootScope;
            this.$q = $q;
            return {
                response: function (response) {
                    return response;
                },
                responseError: function (response) {
                    $injector.get("$http");
                    var config = response.config;
                    if (!config.ignoreErrors) {
                        switch (response.status) {
                            case 400:
                            case 401:
                            case 0:
                                break;
                            default:
                                var msg = void 0;
                                msg = "status: " + response.status + "\n";
                                msg += "data: \n" + angular__namespace.toJson(response.data);
                                alert(msg);
                                break;
                        }
                    }
                    return $q.reject(response);
                }
            };
        }
        ErrorInterceptor = __decorate([
            NgInterceptor({
                token: Token.ErrorInterceptor,
                dependencies: [
                    Token.$Injector,
                    Token.$RootScope,
                    Token.$Q,
                ]
            })
        ], ErrorInterceptor);
        return ErrorInterceptor;
    }());

    var ForbiddenReason = /** @class */ (function () {
        function ForbiddenReason() {
        }
        ForbiddenReason.SsoNoGroups = "SsoNoGroups";
        ForbiddenReason.InsufficientPermissions = "InsufficientPermissions";
        return ForbiddenReason;
    }());
    var SecurityInterceptor = /** @class */ (function () {
        function SecurityInterceptor($injector, securityRetryQueue, $rootScope, $q) {
            this.$injector = $injector;
            this.securityRetryQueue = securityRetryQueue;
            this.$rootScope = $rootScope;
            this.$q = $q;
            return {
                request: function (request) {
                    if ($rootScope.isSfdcCpq) {
                        request.headers["kb-context"] = "sfdccpq";
                    }
                    return request;
                },
                response: function (response) {
                    return response;
                },
                responseError: function (response) {
                    var config = (response.config);
                    if (!config.ignoreSecurity) {
                        var $http_1 = $injector.get("$http");
                        var promise = void 0;
                        if (response.status === 401) {
                            // if a request set the config to ignore auth, then we don't add the item for replay
                            if (!response.config.doNotReplay) {
                                promise = securityRetryQueue.pushRetryFn("unauthorized-server", function () { return $http_1(response.config); });
                            }
                            $rootScope.user = null;
                            $rootScope.$broadcast(_tools.events.loginRequested);
                            if (promise) {
                                return promise;
                            }
                        }
                        if (response.status === 403) {
                            if (response.data == ForbiddenReason.SsoNoGroups) {
                                alert("We could not find proper permissions for this user. Please contact your system administrator for assistance.");
                                $rootScope.$broadcast(_tools.events.loginRequested);
                            }
                            else {
                                $rootScope.$broadcast(_tools.events.permissionDenied);
                            }
                        }
                    }
                    return $q.reject(response);
                }
            };
        }
        SecurityInterceptor = __decorate([
            NgInterceptor({
                token: Token.SecurityInterceptor,
                dependencies: [
                    Token.$Injector,
                    Token.SecurityRetryService,
                    Token.$RootScope,
                    Token.$Q,
                ]
            })
        ], SecurityInterceptor);
        return SecurityInterceptor;
    }());

    var ApiService = /** @class */ (function () {
        function ApiService($http, $q, $rootScope, $location) {
            this.$http = $http;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$location = $location;
            // public injection(): any[] {
            //     return [
            //         Token.$Http,
            //         Token.$Q,
            //         ApiService
            //     ];
            // }
            this.adminProducts = new AdminProductClient(this.$http, this.$q, "/api/admin/products");
            this.assistantFeedback = new CrudClient(this.$http, this.$q, "/api/assistant/feedback");
            this.assistant = new AssistantClient(this.$http, this.$q, "/api/assistant");
            this.automationStudio = new AutomationStudioClient(this.$http, this.$q, "/api/automationstudio");
            this.builders = new CrudClient(this.$http, this.$q, "/api/builders");
            this.buildTypes = new CrudClient(this.$http, this.$q, "/api/buildtypes");
            this.builderSettings = new SingletonCrudClient(this.$http, this.$q, "/api/buildersettings");
            this.categories = new CategoriesClient(this.$http, this.$q, "/api/categories");
            this.changePassword = new CrudClient(this.$http, this.$q, "/api/users/changepassword");
            this.channels = new CrudClient(this.$http, this.$q, "/api/channels");
            this.companies = new CrudClient(this.$http, this.$q, "/api/companies");
            this.configurators = new ConfiguratorClient(this.$http, this.$q, "/api/admin/products");
            this.contacts = new CrudClient(this.$http, this.$q, "/api/contacts");
            this.currencies = new CurrencyClient(this.$http, this.$q, "/api/currencies");
            this.customActions = new CrudClient(this.$http, this.$q, "/api/customactions");
            this.customers = new CrudClient(this.$http, this.$q, "/api/customers");
            this.dashboard = new SingletonCrudClient(this.$http, this.$q, "/api/dashboard");
            this.dbLogins = new DbLoginsClient(this.$http, this.$q, "/api/dblogins");
            this.dbTables = new DbTablesClient(this.$http, this.$q, "/api/dbtables");
            this.dependencies = new DependenciesClient(this.$http, this.$q, "/api/dependencies");
            this.deployments = new DeploymentClient(this.$http, this.$q, "/api/deployments");
            this.emailTemplates = new CrudClient(this.$http, this.$q, "/api/emailtemplates");
            this.functions = new CrudClient(this.$http, this.$q, "/api/functions");
            this.generators = new GeneratorClient(this.$http, this.$q, "/api/generators");
            this.globalDefinitions = new CrudClient(this.$http, this.$q, "/api/globaldefinitions");
            this.globalFunctions = new GlobalFunctionClient(this.$http, this.$q, "/api/globalfunctions");
            this.integrationSettings = new IntegrationSettingsClient(this.$http, this.$q, "/api/integrationsettings");
            this.jobs = new JobsClient(this.$http, this.$q, "/api/jobs");
            this.kinetic = new KineticClient(this.$http, this.$q, "/api/kinetic");
            this.languages = new LanguageClient(this.$http, this.$q, "/api/languages");
            this.layouts = new LayoutClient(this.$http, this.$q, "/api/layouts");
            this.logs = new CrudClient(this.$http, this.$q, "/api/logs");
            this.notifications = new NotificationClient(this.$http, this.$q, "/api/notifications");
            this.notificationSettings = new SingletonCrudClient(this.$http, this.$q, "/api/notificationsettings");
            this.optionFilters = new OptionFilterClient(this.$http, this.$q, "/api/optionfilters");
            this.outputBuilders = new CrudClient(this.$http, this.$q, "/api/builders");
            this.permissions = new PermissionClient(this.$http, this.$q, "/api/permissions");
            this.priceColumns = new PriceColumnClient(this.$http, this.$q, "/api/pricecolumns");
            this.products = new ProductClient(this.$http, this.$q, "/api/products");
            this.productHistory = new ProductHistoryClient(this.$http, this.$q, "/api/producthistory");
            this.productRules = new SingletonCrudClient(this.$http, this.$q, "/api/productrules");
            this.queues = new CrudClient(this.$http, this.$q, "/api/queues");
            this.quoteHeaders = new QuoteHeaderClient(this.$http, this.$q, "/api/quoteheaders");
            this.quoteOutputs = new CrudClient(this.$http, this.$q, "/api/quoteoutputs");
            this.quotes = new QuoteClient(this.$http, this.$q, "/api/quotes");
            this.quoteProducts = new CrudClient(this.$http, this.$q, "/api/quoteproducts");
            this.roles = new CrudClient(this.$http, this.$q, "/api/roles");
            this.rootUsers = new RootUserClient(this.$http, this.$q, "/api/rootusers");
            this.safeFunctions = new SafeFunctionClient(this.$http, this.$q, "/api/functions");
            this.savedSearches = new SavedSearchClient(this.$http, this.$q, "/api/savedsearches");
            this.scenes = new ScenesClient(this.$http, this.$q, this.$rootScope, "/api/scenes");
            this.sceneHistory = new SceneHistoryClient(this.$http, this.$q, '/api/scenehistory');
            this.settings = new CompanySettingsClient(this.$http, this.$q, "/api/settings");
            this.tables = new TablesClient(this.$http, this.$q, "/api/tables");
            this.tags = new CrudClient(this.$http, this.$q, "/api/tags");
            this.testBuilds = new TestBuildClient(this.$http, this.$q, "/api/testbuilds");
            this.themes = new CrudClient(this.$http, this.$q, "/api/themes");
            this.tools = new ToolsClient(this.$http, this.$q, "api/tools");
            this.translate = new TranslateClient(this.$http, this.$q, "api/translate");
            this.users = new UserClient(this.$http, this.$q, "/api/users");
            this.workflows = new WorkflowsClient(this.$http, this.$q, "/api/workflows");
            this.workflowSelectors = new SingletonCrudClient(this.$http, this.$q, "/api/workflowselector");
            this.dbWhitelist = new DbWhitelistClient(this.$http, this.$q, "/api/dbwhitelist");
            this.dbXuserCreds = new DbXuserCred(this.$http, this.$q, "/api/dbxuser");
            this.interactions = new CrudClient(this.$http, this.$q, "/api/interactions");
            this.kineticMom = new KineticMomClient(this.$http, this.$q, "/api/mom");
            this.materials = new CrudClient(this.$http, this.$q, "/api/materials");
            var queryString = $location.search();
            var cookieToken = queryString["cookieToken"];
            if (cookieToken) {
                $http.defaults.headers.common["x-embed-token"] = cookieToken;
            }
        }
        ApiService.prototype.getProxyClient = function (entityTypeName, admin) {
            var t = entityTypeName.toCamelCase();
            if (t.startsWith("kb"))
                t = t.substr(2);
            if (t.toLowerCase() == "useredit")
                t = "user";
            t = t.endsWith("y") ? t.substr(0, t.length - 1) + "ies" : t + "s";
            if (t.startsWith("company"))
                t = t.substr(7);
            t = t.toCamelCase();
            var service = this[t];
            if (admin) {
                if (service == this.products)
                    service = this.adminProducts;
                if (t.toLowerCase() == "companysettings")
                    service = this.settings;
            }
            return service;
        };
        ApiService = __decorate([
            NgService({
                token: Token.ApiService,
                dependencies: [
                    Token.$Http,
                    Token.$Q,
                    Token.$RootScope,
                    Token.$Location
                ]
            })
        ], ApiService);
        return ApiService;
    }());
    var CrudClient = /** @class */ (function () {
        function CrudClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        CrudClient.prototype.getById = function (id, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(id), { tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.getFromEnvironment = function (id, env, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(id, "/diff"), { params: { env: env }, tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.edit = function (model, tracker, waitForRefresh) {
            if (waitForRefresh === void 0) { waitForRefresh = false; }
            return this.$http.put("".concat(this.baseUrl, "/").concat(model.id, "?waitForRefresh=").concat(waitForRefresh), model, { tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.insert = function (model, tracker, waitForRefresh) {
            if (waitForRefresh === void 0) { waitForRefresh = false; }
            return this.$http.post("".concat(this.baseUrl, "?waitForRefresh=").concat(waitForRefresh), model, { tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.upsert = function (model, tracker, waitForRefresh) {
            if (waitForRefresh === void 0) { waitForRefresh = false; }
            if (model.id) {
                return this.edit(model, tracker, waitForRefresh);
            }
            else {
                return this.insert(model, tracker, waitForRefresh);
            }
        };
        CrudClient.prototype.delete = function (id, tracker, ignoreSecurity) {
            if (ignoreSecurity === void 0) { ignoreSecurity = false; }
            return this.$http.delete("".concat(this.baseUrl, "/").concat(id), { tracker: tracker, ignoreSecurity: ignoreSecurity });
        };
        CrudClient.prototype.clone = function (id, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(id, "/clone"), null, { tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.getPaged = function (p, tracker) {
            return this.$http.get(this.baseUrl, { params: p, tracker: tracker }).then(function (r) { return r.data.items; });
        };
        CrudClient.prototype.searchPaged = function (p, tracker) {
            return this.$http.post(this.baseUrl + "/searchPaged", p).then(function (r) { return r.data.items; });
        };
        CrudClient.prototype.getBatch = function (request, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/batch"), { params: request, tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.search = function (args, tracker) {
            // fill in args with defaults
            var defaultArgs = {
                query: null,
                fields: null,
                sortField: "name",
                descending: false,
                skip: 0,
                take: 10000
            };
            var fullArgs = _tools.Utils.extend({}, defaultArgs, args);
            return this.$http.post("".concat(this.baseUrl, "/search"), fullArgs, { tracker: tracker }).then(function (r) { return r.data; });
        };
        CrudClient.prototype.suggest = function (args) {
            if (args.query) {
                return this.$http.post("".concat(this.baseUrl, "/suggest"), args).then(function (r) { return r.data; });
            }
            else {
                return this.$q.when([]);
            }
        };
        CrudClient.prototype.uniqueValues = function (args) {
            return this.$http.post("".concat(this.baseUrl, "/uniquevalues"), args).then(function (r) { return r.data; });
        };
        CrudClient.prototype.rebuildIndex = function (tracker) {
            return this.$http.post("".concat(this.baseUrl, "/rebuildindex"), null, { tracker: tracker });
        };
        return CrudClient;
    }());
    var AutomationStudioClient = /** @class */ (function () {
        function AutomationStudioClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        AutomationStudioClient.prototype.getToken = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/token"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return AutomationStudioClient;
    }());
    var TranslateClient = /** @class */ (function () {
        function TranslateClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        TranslateClient.prototype.translateArray = function (request, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/array"), request, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return TranslateClient;
    }());
    var DependenciesClient = /** @class */ (function () {
        function DependenciesClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        DependenciesClient.prototype.isRequiredByDependency = function (type, ids, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/isrequired"), { type: type, ids: ids }, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return DependenciesClient;
    }());
    var DeploymentClient = /** @class */ (function () {
        function DeploymentClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        DeploymentClient.prototype.getById = function (id, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(id), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DeploymentClient.prototype.getPaged = function (p, tracker) {
            return this.$http.get(this.baseUrl, { params: p, tracker: tracker })
                .then(function (r) { return r.data.items; });
        };
        DeploymentClient.prototype.deploy = function (model) {
            return this.$http.post("/api/deploy", model).then(function (r) { return r.data; });
        };
        DeploymentClient.prototype.compare = function (model, tracker) {
            return this.$http.post("/api/deploy/compare", model, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return DeploymentClient;
    }());
    var AssistantClient = /** @class */ (function () {
        function AssistantClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        AssistantClient.prototype.getUsageData = function (tracker) {
            //return this.$http.get(`/api/assistant/usage`, { tracker }).then(r => r.data);
            return this.get("/usage");
        };
        AssistantClient.prototype.get = function (endpoint) {
            return __awaiter(this, void 0, void 0, function () {
                var url, requestInit, response, errorText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "".concat(this.baseUrl).concat(endpoint);
                            requestInit = {
                                method: 'GET',
                                credentials: 'include'
                            };
                            return [4 /*yield*/, fetch(url, requestInit)];
                        case 1:
                            response = _a.sent();
                            if (!!response.ok) return [3 /*break*/, 3];
                            return [4 /*yield*/, response.text()];
                        case 2:
                            errorText = _a.sent();
                            throw new Error("HTTP ".concat(response.status, ": ").concat(errorText));
                        case 3: return [2 /*return*/, response.json()];
                    }
                });
            });
        };
        return AssistantClient;
    }());
    var SingletonCrudClient = /** @class */ (function () {
        function SingletonCrudClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        SingletonCrudClient.prototype.get = function (tracker) {
            return this.$http.get("".concat(this.baseUrl), { tracker: tracker }).then(function (r) { return r.data; });
        };
        SingletonCrudClient.prototype.edit = function (model, tracker) {
            return this.$http.put("".concat(this.baseUrl), model, { tracker: tracker }).then(function (r) { return r.data; });
        };
        SingletonCrudClient.prototype.getFromEnvironment = function (id, env, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/diff"), { params: { env: env }, tracker: tracker }).then(function (r) { return r.data; });
        };
        SingletonCrudClient.prototype.rebuildIndex = function (tracker) {
            return this.$http.post("".concat(this.baseUrl, "/rebuildindex"), null, { tracker: tracker });
        };
        return SingletonCrudClient;
    }());
    var PermissionClient = /** @class */ (function () {
        function PermissionClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        PermissionClient.prototype.get = function (tracker) {
            return this.$http.get("".concat(this.baseUrl), { tracker: tracker }).then(function (r) { return r.data; });
        };
        PermissionClient.prototype.save = function (model, tracker) {
            return this.$http.post("".concat(this.baseUrl), model, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return PermissionClient;
    }());
    var ToolsClient = /** @class */ (function () {
        function ToolsClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        ToolsClient.prototype.runIndexOperation = function (args, tracker) {
            return this.$http.post("/api/search/run", args, { tracker: tracker }).then(function (r) { return r.data; });
        };
        ToolsClient.prototype.rebuildIndex = function (tracker) {
            return this.$http.post("/api/search/rebuild", null, { tracker: tracker });
        };
        ToolsClient.prototype.rebuildIndexAllEnv = function (tracker) {
            return this.$http.post("/api/search/rebuildallenv", null, { tracker: tracker });
        };
        ToolsClient.prototype.rebuildIndexAll = function (tracker) {
            return this.$http.post("/api/search/rebuildall", null, { tracker: tracker });
        };
        ToolsClient.prototype.rebuildRootIndex = function (tracker) {
            return this.$http.post("/api/search/rebuildroot", null, { tracker: tracker });
        };
        ToolsClient.prototype.recreateStorage = function (tracker) {
            return this.$http.post("/api/storage/create", null, { tracker: tracker });
        };
        ToolsClient.prototype.pullFromProduction = function (tracker) {
            return this.$http.post("".concat(this.baseUrl, "/pullfromprod"), null, { tracker: tracker });
        };
        ToolsClient.prototype.update3DPlugin = function (tracker) {
            return this.$http.post("/api/debug/post-3d-plugin", null, { tracker: tracker });
        };
        ToolsClient.prototype.recreate3D = function (tracker) {
            return this.$http.post("/api/recreate3d", null, { tracker: tracker });
        };
        ToolsClient.prototype.recreateDns = function (tracker) {
            return this.$http.post("/api/recreatedns", null, { tracker: tracker });
        };
        ToolsClient.prototype.cleanDb = function (args, tracker) {
            return this.$http.post("${this.baseUrl}/cleanDb", args, { tracker: tracker });
        };
        ToolsClient.prototype.pullSfdcProducts = function (soqlStatement, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/pullsfdcproducts"), { whereClause: soqlStatement }, { tracker: tracker });
        };
        ToolsClient.prototype.getSearchableTypeNames = function (tracker) {
            return this.$http.get("/api/search/searchableTypes", { tracker: tracker }).then(function (r) { return r.data; });
        };
        return ToolsClient;
    }());
    var PriceColumnClient = /** @class */ (function (_super) {
        __extends(PriceColumnClient, _super);
        function PriceColumnClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        PriceColumnClient.prototype.getPriceColumnsForUser = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/user")).then(function (r) { return r.data; });
        };
        PriceColumnClient.prototype.reorder = function (args, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/reorder"), args, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return PriceColumnClient;
    }(CrudClient));
    var KineticClient = /** @class */ (function () {
        function KineticClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        KineticClient.prototype.getDocumentRulesSchema = function (idConfig) {
            return this.$http.get("".concat(this.baseUrl, "/documentRuleSchema/").concat(idConfig), null);
        };
        KineticClient.prototype.getDocumentRulesSchemaForDynamicAttributes = function (idConfig, company) {
            return this.$http.get("".concat(this.baseUrl, "/documentRuleSchema/").concat(idConfig, "/").concat(company), null);
        };
        KineticClient.prototype.partNumExists = function (partNum) {
            return this.$http.get("".concat(this.baseUrl, "/partNum/").concat(partNum, "/exists")).then(function (r) { return r.data; });
        };
        KineticClient.prototype.testConnection = function () {
            return this.$http.get("".concat(this.baseUrl, "/test"), null);
        };
        KineticClient.prototype.getCompanies = function () {
            return this.$http.get("".concat(this.baseUrl, "/companies"), null);
        };
        return KineticClient;
    }());
    var JobsClient = /** @class */ (function (_super) {
        __extends(JobsClient, _super);
        function JobsClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        JobsClient.prototype.getLogs = function (idJob, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(idJob, "/logs")).then(function (r) { return r.data; });
        };
        return JobsClient;
    }(CrudClient));
    var TablesClient = /** @class */ (function (_super) {
        __extends(TablesClient, _super);
        function TablesClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        TablesClient.prototype.updateFromSource = function (id, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(id, "/updatefromsource"), null, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return TablesClient;
    }(CrudClient));
    var WorkflowsClient = /** @class */ (function (_super) {
        __extends(WorkflowsClient, _super);
        function WorkflowsClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        WorkflowsClient.prototype.states = function (tracker) {
            return this.$http.get("/api/states", { tracker: tracker }).then(function (r) { return r.data; });
        };
        return WorkflowsClient;
    }(CrudClient));
    var ScenesClient = /** @class */ (function (_super) {
        __extends(ScenesClient, _super);
        function ScenesClient($http, $q, $rootScope, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.$rootScope = $rootScope;
            _this.baseUrl = baseUrl;
            return _this;
        }
        ScenesClient.prototype.search = function (args, tracker) {
            args = args || {};
            args.filters = args.filters || [];
            var externalValues = [];
            if (this.$rootScope.company.kb3dEnabled)
                externalValues.push(false);
            if (this.$rootScope.company.classic3dEnabled)
                externalValues.push(true);
            args.filters.push({
                property: "external",
                values: externalValues
            });
            return _super.prototype.search.call(this, args, tracker);
        };
        ScenesClient.prototype.convertToKb3d = function (id, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(id, "/convert"), null, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return ScenesClient;
    }(CrudClient));
    var SceneHistoryClient = /** @class */ (function () {
        function SceneHistoryClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        SceneHistoryClient.prototype.getSceneHistory = function (idScene, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(idScene), { tracker: tracker }).then(function (r) { return r.data; });
        };
        SceneHistoryClient.prototype.getHistoryByIdHistory = function (idHistory, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/idhist/").concat(idHistory), { tracker: tracker }).then(function (r) { return r.data; });
        };
        SceneHistoryClient.prototype.cloneHistoryToNewScene = function (idSceneHistory, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/clone/").concat(idSceneHistory), {}, { tracker: tracker }).then(function (r) { return r.data; });
        };
        SceneHistoryClient.prototype.revertSceneToHistory = function (idSceneHistory, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/revert/").concat(idSceneHistory), {}, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return SceneHistoryClient;
    }());
    var NotificationClient = /** @class */ (function (_super) {
        __extends(NotificationClient, _super);
        function NotificationClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        return NotificationClient;
    }(CrudClient));
    var CategoriesClient = /** @class */ (function (_super) {
        __extends(CategoriesClient, _super);
        function CategoriesClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        CategoriesClient.prototype.tree = function (params, tracker) {
            return this.$http.get("api/categories/tree", { params: params, tracker: tracker }).then(function (r) { return r.data; });
        };
        return CategoriesClient;
    }(CrudClient));
    var OptionFilterClient = /** @class */ (function () {
        function OptionFilterClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        OptionFilterClient.prototype.run = function (args, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/run"), args, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return OptionFilterClient;
    }());
    var DbLoginsClient = /** @class */ (function () {
        function DbLoginsClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        DbLoginsClient.prototype.getAll = function (tracker) {
            return this.$http.get("".concat(this.baseUrl), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbLoginsClient.prototype.get = function (name, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(name), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbLoginsClient.prototype.search = function (args, tracker) {
            // fill in args with defaults
            var defaultArgs = {
                query: null,
                fields: null,
                sortField: "name",
                descending: false,
                skip: 0,
                take: 10000
            };
            var fullArgs = _tools.Utils.extend({}, defaultArgs, args);
            return this.$http.post("".concat(this.baseUrl, "/search"), fullArgs, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbLoginsClient.prototype.suggest = function (args) {
            if (args.query) {
                return this.$http.post("".concat(this.baseUrl, "/suggest"), args).then(function (r) { return r.data; });
            }
            else {
                return this.$q.when([]);
            }
        };
        DbLoginsClient.prototype.delete = function (name, tracker, ignoreSecurity) {
            if (ignoreSecurity === void 0) { ignoreSecurity = false; }
            return this.$http.delete("".concat(this.baseUrl, "/").concat(name), { tracker: tracker, ignoreSecurity: ignoreSecurity });
        };
        return DbLoginsClient;
    }());
    var DbTablesClient = /** @class */ (function () {
        function DbTablesClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        DbTablesClient.prototype.getAll = function (tracker) {
            return this.$http.get("".concat(this.baseUrl), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.get = function (name, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(name), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.getFromEnvironment = function (name, env, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(name, "/diff"), { params: { env: env }, tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.getTableDataFromEnvironment = function (name, env, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(name, "/diff/data"), { params: { env: env }, tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.getAllSizeInfo = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/sizes"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.search = function (args, tracker) {
            // fill in args with defaults
            var defaultArgs = {
                query: null,
                fields: null,
                sortField: "name",
                descending: false,
                skip: 0,
                take: 10000
            };
            var fullArgs = _tools.Utils.extend({}, defaultArgs, args);
            return this.$http.post("".concat(this.baseUrl, "/search"), fullArgs, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.suggest = function (args) {
            if (args.query) {
                return this.$http.post("".concat(this.baseUrl, "/suggest"), args).then(function (r) { return r.data; });
            }
            else {
                return this.$q.when([]);
            }
        };
        DbTablesClient.prototype.delete = function (name, tracker, ignoreSecurity) {
            if (ignoreSecurity === void 0) { ignoreSecurity = false; }
            return this.$http.delete("".concat(this.baseUrl, "/").concat(name), { tracker: tracker, ignoreSecurity: ignoreSecurity });
        };
        DbTablesClient.prototype.addColumn = function (tableName, column, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(tableName, "/column"), column, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.editColumn = function (tableName, columnName, column, tracker) {
            return this.$http.put("".concat(this.baseUrl, "/").concat(tableName, "/column/").concat(columnName), column, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.deleteColumn = function (tableName, columnName, tracker) {
            return this.$http.delete("".concat(this.baseUrl, "/").concat(tableName, "/column/").concat(columnName), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.addIndex = function (tableName, index, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(tableName, "/index"), index, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.deleteIndex = function (tableName, indexName, tracker) {
            return this.$http.delete("".concat(this.baseUrl, "/").concat(tableName, "/index/").concat(indexName), { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.addForeignKey = function (tableName, foreignKey, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(tableName, "/foreignKey"), foreignKey, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.editForeignKey = function (tableName, foreignKeyName, foreignKey, tracker) {
            return this.$http.put("".concat(this.baseUrl, "/").concat(tableName, "/foreignKey/").concat(foreignKeyName), foreignKey, { tracker: tracker }).then(function (r) { return r.data; });
        };
        DbTablesClient.prototype.deleteForeignKey = function (tableName, foreignKeyName, tracker) {
            return this.$http.delete("".concat(this.baseUrl, "/").concat(tableName, "/foreignKey/").concat(foreignKeyName), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return DbTablesClient;
    }());
    var IntegrationSettingsClient = /** @class */ (function (_super) {
        __extends(IntegrationSettingsClient, _super);
        function IntegrationSettingsClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        IntegrationSettingsClient.prototype.checkSfdcCredentials = function () {
            return this.$http.get("/api/integrationsettings/checksfdccredentials").then(function (r) { return r.data; });
        };
        IntegrationSettingsClient.prototype.checkOracleCpqCredentials = function () {
            return this.$http.get("/api/integrationsettings/checkoraclecpqcredentials").then(function (r) { return r.data; });
        };
        IntegrationSettingsClient.prototype.getSsoGroups = function (keywords) {
            return this.$http.get("/api/integrationsettings/ssogroups?keywords=".concat(keywords)).then(function (r) { return r.data; });
        };
        IntegrationSettingsClient.prototype.getSsoGroupById = function (groupId) {
            return this.$http.get("/api/integrationsettings/ssogroup/".concat(groupId)).then(function (r) { return r.data; });
        };
        return IntegrationSettingsClient;
    }(SingletonCrudClient));
    var CurrencyClient = /** @class */ (function (_super) {
        __extends(CurrencyClient, _super);
        function CurrencyClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        /**
         * gets all company currencies
         * @param tracker
         */
        CurrencyClient.prototype.all = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/all"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        /**
         * gets a list of all currencies (not just company currencies).
         * Used for populating a select box to add new currencies.
         * @param tracker
         */
        CurrencyClient.prototype.options = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/options"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        /**
         * gets a list of company currencies that also includes the base currency.
         * Used for populating a select box in the quote screen for example.
         * @param tracker
         */
        CurrencyClient.prototype.companyOptions = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/companyoptions"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        /**
         * saves the company currencies.
         * @param companyCurrencies
         * @param tracker
         */
        CurrencyClient.prototype.save = function (companyCurrencies, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/save"), companyCurrencies, { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        CurrencyClient.prototype.getExchangeRates = function (baseCurrency, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/exchangerates/").concat(baseCurrency || ""), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return CurrencyClient;
    }(CrudClient));
    var LanguageClient = /** @class */ (function (_super) {
        __extends(LanguageClient, _super);
        function LanguageClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        /**
         * gets a list of all languages supported by CPQ (not just company languages).
         * Used for populating a select box to add new languages.
         * @param tracker
         */
        LanguageClient.prototype.supportedLanguages = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/supported"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return LanguageClient;
    }(CrudClient));
    var GeneratorClient = /** @class */ (function (_super) {
        __extends(GeneratorClient, _super);
        function GeneratorClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        GeneratorClient.prototype.next = function (id, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(id, "/next"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return GeneratorClient;
    }(CrudClient));
    var GlobalFunctionClient = /** @class */ (function (_super) {
        __extends(GlobalFunctionClient, _super);
        function GlobalFunctionClient($http, $q, baseurl) {
            var _this = _super.call(this, $http, $q, baseurl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseurl = baseurl;
            return _this;
        }
        GlobalFunctionClient.prototype.getDependencies = function (request) {
            return this.$http.post("".concat(this.baseUrl, "/dependents"), request).then(function (r) { return r.data; });
        };
        return GlobalFunctionClient;
    }(CrudClient));
    var UserClient = /** @class */ (function (_super) {
        __extends(UserClient, _super);
        function UserClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        UserClient.prototype.clearProfileImage = function (userId) {
            return this.$http.delete("/api/users/profileimage/".concat(userId)).then(function (r) { return r.data; });
        };
        UserClient.prototype.deleteAndAnonymize = function (userId) {
            return this.$http.delete("/api/users/anonymize/".concat(userId)).then(function (r) { return r.data; });
        };
        UserClient.prototype.resetPassword = function (userId) {
            return this.$http.post("api/users/resetpassword/" + userId, {}).then(function (r) { return r.data; });
        };
        UserClient.prototype.acceptPrivacyPolicy = function () {
            return this.$http.post("api/users/acceptprivacypolicy", {}).then(function (r) { return r.data; });
        };
        UserClient.prototype.resetDeactivation = function (userId) {
            return this.$http.put("api/users/resetdeactivation/" + userId, {}).then(function (r) { return r.data; });
        };
        return UserClient;
    }(CrudClient));
    var LayoutClient = /** @class */ (function (_super) {
        __extends(LayoutClient, _super);
        function LayoutClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        LayoutClient.prototype.selections = function (tracker) {
            return this.$http.get("".concat(this.baseUrl, "/selections"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        return LayoutClient;
    }(CrudClient));
    var DbWhitelistClient = /** @class */ (function () {
        function DbWhitelistClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        DbWhitelistClient.prototype.add = function (entry, tracker) {
            return this.$http.post(this.baseUrl, entry).then(function (r) { return r.data; });
        };
        DbWhitelistClient.prototype.getAll = function (tracker) {
            return this.$http.get(this.baseUrl).then(function (r) { return r.data; });
        };
        DbWhitelistClient.prototype.delete = function (name, tracker) {
            return this.$http.delete(this.baseUrl + "/" + name).then(function (r) { return r.data; });
        };
        return DbWhitelistClient;
    }());
    var DbXuserCred = /** @class */ (function () {
        function DbXuserCred($http, $q, baseurl) {
            this.$http = $http;
            this.$q = $q;
            this.baseurl = baseurl;
        }
        DbXuserCred.prototype.post = function () {
            return this.$http.post(this.baseurl, null).then(function (r) { return r.data; });
        };
        return DbXuserCred;
    }());
    var KineticMomClient = /** @class */ (function () {
        function KineticMomClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        KineticMomClient.prototype.get = function (idConfigurator, tracker) {
            return this.$http.get(this.baseUrl + "/partRev/" + idConfigurator).then(function (r) { return r.data; });
        };
        return KineticMomClient;
    }());
    var ConfiguratorClient = /** @class */ (function (_super) {
        __extends(ConfiguratorClient, _super);
        function ConfiguratorClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        ConfiguratorClient.prototype.search = function (args, tracker) {
            args = args || {};
            args.filters = args.filters || [];
            args.filters.push({
                property: enums.meta.Product.isConfigured.name,
                values: [true]
            });
            return _super.prototype.search.call(this, args, tracker);
        };
        ConfiguratorClient.prototype.searchFields = function (id) {
            return this.$http.get("/api/products/".concat(id, "/searchfields"))
                .then(function (r) { return r.data; });
        };
        ConfiguratorClient.prototype.getIsEditing = function (id) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(id, "/isediting")).then(function (r) { return r.data; });
        };
        ConfiguratorClient.prototype.setIsEditing = function (id, isEditing, guid) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(id, "/isediting"), { idProduct: id, isEditing: isEditing, guid: guid }).then(function (r) { return r.data; });
        };
        return ConfiguratorClient;
    }(CrudClient));
    var AdminProductClient = /** @class */ (function (_super) {
        __extends(AdminProductClient, _super);
        function AdminProductClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        AdminProductClient.prototype.search = function (args, tracker) {
            args = args || {};
            args.filters = args.filters || [];
            args.filters.push(ProductClient.getIsConfiguredFilter(false));
            return _super.prototype.search.call(this, args, tracker);
        };
        AdminProductClient.prototype.getOutput = function (idProduct, idOutput, tracker) {
            return this.$http.get("/api/admin/products/".concat(idProduct, "/output/").concat(idOutput)).then(function (r) { return r.data; });
        };
        return AdminProductClient;
    }(CrudClient));
    var ProductHistoryClient = /** @class */ (function () {
        function ProductHistoryClient($http, $q, baseUrl) {
            this.$http = $http;
            this.$q = $q;
            this.baseUrl = baseUrl;
        }
        ProductHistoryClient.prototype.getProductHistory = function (idProduct, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(idProduct), { tracker: tracker }).then(function (r) { return r.data; });
        };
        ProductHistoryClient.prototype.getHistoryByIdHistory = function (idHistory, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/idhist/").concat(idHistory), { tracker: tracker }).then(function (r) { return r.data; });
        };
        ProductHistoryClient.prototype.cloneHistoryToNewProduct = function (idProductHistory, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/clone/").concat(idProductHistory), {}, { tracker: tracker }).then(function (r) { return r.data; });
        };
        ProductHistoryClient.prototype.revertProductToHistory = function (idProductHistory, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/revert/").concat(idProductHistory), {}, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return ProductHistoryClient;
    }());
    var ProductClient = /** @class */ (function (_super) {
        __extends(ProductClient, _super);
        function ProductClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        ProductClient.prototype.run = function (id, isTest, fast, tracker) {
            var path = (fast ? "runfast" : "run?test=".concat(isTest));
            return this.$http.get("".concat(this.baseUrl, "/").concat(id, "/").concat(path), { tracker: tracker }).then(function (r) { return r.data; });
        };
        ProductClient.prototype.autocomplete = function (productId, fieldId, query, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(productId, "/autocomplete"), {
                params: { field: fieldId, query: query },
                tracker: tracker
            }).then(function (r) { return r.data; });
        };
        ProductClient.prototype.searchByCategory = function (args, tracker) {
            return this.$http.post("/api/products/searchByCategory", args, { tracker: tracker }).then(function (r) { return r.data; });
        };
        ProductClient.getIsConfiguredFilter = function (isConfigured) {
            return {
                property: enums.meta.Product.isConfigured.name,
                values: [isConfigured]
            };
        };
        ProductClient.prototype.uniqueAttributeValues = function (args) {
            return this.$http.post("".concat(this.baseUrl, "/uniqueattributevalues"), args).then(function (r) { return r.data; });
        };
        ProductClient.prototype.attributeRanges = function (args) {
            return this.$http.post("".concat(this.baseUrl, "/attributeranges"), args).then(function (r) { return r.data; });
        };
        return ProductClient;
    }(CrudClient));
    var SafeFunctionClient = /** @class */ (function (_super) {
        __extends(SafeFunctionClient, _super);
        function SafeFunctionClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        SafeFunctionClient.prototype.run = function (id, parameters, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/run/").concat(id), parameters, { tracker: tracker }).then(function (r) {
                if (r.status == 204)
                    return null; //no content result should be null to be backwards compatible
                return r.data;
            });
        };
        SafeFunctionClient.prototype.test = function (id, args, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/test/").concat(id), args, { tracker: tracker }).then(function (r) {
                if (r.status == 204)
                    return null; //no content result should be null to be backwards compatible
                return r.data;
            });
        };
        return SafeFunctionClient;
    }(CrudClient));
    var QuoteClient = /** @class */ (function (_super) {
        __extends(QuoteClient, _super);
        function QuoteClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        QuoteClient.prototype.save = function (quote, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/save"), quote, { tracker: tracker }).then(function (r) { return r.data; });
        };
        QuoteClient.prototype.getProductBuildTypes = function (idQuote, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(idQuote, "/productBuildTypes"), { tracker: tracker }).then(function (r) { return r.data; });
        };
        QuoteClient.prototype.copyQuoteProduct = function (idQuote, idQuoteProduct, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(idQuote, "/product/").concat(idQuoteProduct, "/copy"), null, { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        QuoteClient.prototype.getQuoteProduct = function (idQuote, idQuoteProduct, tracker) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(idQuote, "/product/").concat(idQuoteProduct), { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        QuoteClient.prototype.insertQuoteProduct = function (idQuote, quoteProduct, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(idQuote, "/product"), quoteProduct, { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        QuoteClient.prototype.editQuoteProduct = function (idQuote, quoteProduct, tracker) {
            return this.$http.put("".concat(this.baseUrl, "/").concat(idQuote, "/product/").concat(quoteProduct.id), quoteProduct, { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        QuoteClient.prototype.buildQuoteProduct = function (idQuote, idQuoteProduct, idBuildType, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(idQuote, "/product/").concat(idQuoteProduct, "/build/").concat(idBuildType), {}, { tracker: tracker }).then(function (r) { return r.data; });
        };
        QuoteClient.prototype.deleteQuoteProduct = function (idQuote, quoteProduct, tracker) {
            return this.$http.delete("".concat(this.baseUrl, "/").concat(idQuote, "/product/").concat(quoteProduct.id), { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        QuoteClient.prototype.submit = function (quote, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/submit"), quote, { tracker: tracker }).then(function (r) { return r.data; });
        };
        QuoteClient.prototype.runQuoteHeaderRule = function (quote, tracker) {
            return this.$http.post("".concat(this.baseUrl, "/headerrule"), quote, { tracker: tracker }).then(function (r) { return r.data; });
        };
        return QuoteClient;
    }(CrudClient));
    var SavedSearchClient = /** @class */ (function (_super) {
        __extends(SavedSearchClient, _super);
        function SavedSearchClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        SavedSearchClient.prototype.mySearches = function (modelType) {
            return this.$http.get("".concat(this.baseUrl, "/").concat(modelType)).then(function (r) { return r.data; });
        };
        return SavedSearchClient;
    }(CrudClient));
    var TestBuildClient = /** @class */ (function (_super) {
        __extends(TestBuildClient, _super);
        function TestBuildClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        TestBuildClient.prototype.getQueue = function (config, buildId) {
            return this.$http.post("".concat(this.baseUrl, "/").concat(buildId, "/queue"), {
                config: config
            }).then(function (r) { return r.data; });
        };
        return TestBuildClient;
    }(CrudClient));
    var CompanySettingsClient = /** @class */ (function (_super) {
        __extends(CompanySettingsClient, _super);
        function CompanySettingsClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        CompanySettingsClient.prototype.updateSfdcCredential = function (apiUsername, apiPassword, apiToken) {
            return this.$http.post("".concat(this.baseUrl, "/sfdc-credential"), {
                sfdcApiUsername: apiUsername,
                sfdcApiPassword: apiPassword,
                sfdcApiToken: apiToken
            });
        };
        CompanySettingsClient.prototype.editCurrencySetting = function (currencySetting, tracker) {
            return this.$http.put("".concat(this.baseUrl, "/currency"), currencySetting, { tracker: tracker })
                .then(function (r) { return r.data; });
        };
        return CompanySettingsClient;
    }(SingletonCrudClient));
    var QuoteHeaderClient = /** @class */ (function (_super) {
        __extends(QuoteHeaderClient, _super);
        function QuoteHeaderClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        QuoteHeaderClient.prototype.getDefault = function () {
            return this.$http.get("".concat(this.baseUrl, "/default")).then(function (r) { return r.data; });
        };
        QuoteHeaderClient.prototype.searchFields = function () {
            return this.$http.get("/api/quoteheaders/searchfields")
                .then(function (r) { return r.data; });
        };
        return QuoteHeaderClient;
    }(CrudClient));
    var RootUserClient = /** @class */ (function (_super) {
        __extends(RootUserClient, _super);
        function RootUserClient($http, $q, baseUrl) {
            var _this = _super.call(this, $http, $q, baseUrl) || this;
            _this.$http = $http;
            _this.$q = $q;
            _this.baseUrl = baseUrl;
            return _this;
        }
        RootUserClient.prototype.isRootUser = function (email) {
            return this.$http.post("".concat(this.baseUrl, "/isrootuser"), { email: email }).then(function (r) { return r.data; });
        };
        return RootUserClient;
    }(CrudClient));

    var AuthService = /** @class */ (function () {
        function AuthService($http, securityRetryQueue, $rootScope, $q, signalrService, dialogService, $state, storageService) {
            var _this = this;
            this.$http = $http;
            this.securityRetryQueue = securityRetryQueue;
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.signalrService = signalrService;
            this.dialogService = dialogService;
            this.$state = $state;
            this.storageService = storageService;
            // we need a promise that doesn't resolve until we have a real user.  
            // Controllers can set this promise in the resolve property of the 
            // route so that the controller won't initialize until we have a user
            var userDeferred = $q.defer();
            this.userPromise = userDeferred.promise;
            var contextDeferred = $q.defer();
            this.contextPromise = contextDeferred.promise;
            // var companyDeferred = $q.defer();
            // this.companyPromise = companyDeferred.promise;
            // var exchangeRatesDeferred = $q.defer();
            // this.exchangeRatesPromise = exchangeRatesDeferred.promise;
            // var companySettingsDeferred = $q.defer();
            // this.companySettingsPromise = companySettingsDeferred.promise;
            this.authPromise = $q.all([this.userPromise, this.contextPromise]);
            this.loadContext = function () {
                return $q.when((function () {
                    var serverVm = window.serverVm;
                    $rootScope.context = serverVm.context;
                    $rootScope.environment = serverVm.context.environment;
                    $rootScope.clusterEnv = serverVm.context.clusterEnv;
                    $rootScope.cacheBuster = serverVm.context.cacheBuster;
                    $rootScope.supportedLanguages = serverVm.context.supportedLanguages;
                    $rootScope.clientLanguage = serverVm.context.clientLanguage;
                    $rootScope.company = serverVm.context.company;
                    $rootScope.companySettings = serverVm.context.companySettings;
                    $rootScope.companyCurrencies = serverVm.context.companyCurrencies;
                    fx.base = $rootScope.companySettings.currency.toUpperCase();
                    fx.rates = {};
                    $rootScope.companyCurrencies.forEach(function (cc) {
                        fx.rates[cc.currency.toUpperCase()] = cc.rate;
                    });
                    $rootScope.kbmaxLogoPath = storageService.getAssetUrl('images/epicor_logo_white.png');
                    if ($rootScope.context.channel && $rootScope.context.channel.imagePath) {
                        $rootScope.companyLogoPath = storageService.getMediaUrl($rootScope.context.channel.imagePath);
                    }
                    else {
                        $rootScope.companyLogoPath = $rootScope.companySettings.logoPath ? storageService.getMediaUrl($rootScope.companySettings.logoPath) : $rootScope.kbmaxLogoPath;
                    }
                    if (serverVm.context.user) {
                        _this.confirmLogin(serverVm.context.user);
                    }
                    contextDeferred.resolve(serverVm.context);
                })());
            };
            this.login = function (email, password, rememberMe) {
                _this.loginError = null;
                if ($rootScope.user) {
                    _this.logout();
                }
                return _this.$http.post("/api/auth/login", { email: email, password: password, rememberMe: rememberMe }, { doNotReplay: true, tracker: $rootScope.loginTracker }).then(function (r) {
                    _this.confirmLogin(r.data);
                }, function (r) {
                    if (r.status == 400) {
                        _this.loginError = r.data[""].join("\n");
                    }
                });
            };
            this.logout = function () {
                _this.$http.post("/api/auth/logout", { doNotReplay: true }).then(function () {
                    // reload the whole page to clear all context
                    window.location.reload();
                });
                // $rootScope.user = null;
                // $rootScope.$broadcast(events.loginRequested);
            };
            $rootScope.$on(_tools.events.loginRequested, function (e) {
                $rootScope.user = null;
            });
            $rootScope.$on(_tools.events.permissionDenied, function (e) {
                _this.dialogService.alert({
                    msg: "Sorry, you do not have permission to view this.",
                    type: enums.eAlertType.error
                });
                _this.$state.go("kb.products");
            });
            this.confirmLogin = function (user) {
                $rootScope.user = user;
                // resolve the deferred user promise
                userDeferred.resolve(user);
                _this.securityRetryQueue.retryAll();
                if ($rootScope.user.id != -1) {
                    _this.signalrService.start().then(function () {
                        $rootScope.$broadcast(_tools.events.loginSuccessful, $rootScope.user);
                    });
                }
                else {
                    $rootScope.$broadcast(_tools.events.loginSuccessful, $rootScope.user);
                }
            };
            this.keepAlive = function () {
                _this.$http.get("/api/auth/keepalive").then(function () {
                    // reload the whole page to clear all context
                    // window.location.reload();
                });
            };
            this.loadContext();
        }
        AuthService.prototype.hasRole = function (role) {
            var isInRole = false;
            if (this.$rootScope.user) {
                isInRole = this.$rootScope.user.roles.some(function (r) {
                    return r.role.isEqual(role);
                });
            }
            return isInRole;
        };
        AuthService.prototype.userHasRole = function (user, role) {
            var isInRole = user.roles.some(function (r) {
                if (!r.role)
                    return false;
                return r.role.isEqual(role);
            });
            return isInRole;
        };
        AuthService.prototype.isAdminOrCompanyAdmin = function () {
            var bret = false;
            if (this.$rootScope.user) {
                bret = this.hasRole("Company Administrator") || this.$rootScope.user.isAdmin;
            }
            return bret;
        };
        AuthService.ANONYMOUS_USER_ID = -1;
        AuthService = __decorate([
            NgService({
                token: Token.AuthService,
                dependencies: [
                    Token.$Http,
                    Token.SecurityRetryService,
                    Token.$RootScope,
                    Token.$Q,
                    Token.SignalRService,
                    Token.DialogService,
                    Token.$State,
                    Token.StorageService
                ]
            })
        ], AuthService);
        return AuthService;
    }());

    /**
     * base64 encoding from :  http://www.webtoolkit.info/javascript-base64.html
     */
    var Base64Service = /** @class */ (function () {
        function Base64Service() {
            this.keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        }
        Base64Service.prototype.encode = function (input) {
            var output = "";
            var chr1;
            var chr2;
            var chr3;
            var enc1;
            var enc2;
            var enc3;
            var enc4;
            var i = 0;
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
                // tslint:disable:no-bitwise
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                }
                else if (isNaN(chr3)) {
                    enc4 = 64;
                }
                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
            return output;
        };
        Base64Service.prototype.decode = function (input) {
            var output = "";
            var chr1;
            var chr2;
            var chr3;
            var enc1;
            var enc2;
            var enc3;
            var enc4;
            var i = 0;
            input = input.replace("/[^A-Za-z0-9\+\/\=]/g", "");
            while (i < input.length) {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
                output = output + String.fromCharCode(chr1);
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }
            return output;
        };
        Base64Service = __decorate([
            NgService({
                token: Token.Base64Service,
                dependencies: []
            })
        ], Base64Service);
        return Base64Service;
    }());

    var BundleLoaderService = /** @class */ (function () {
        function BundleLoaderService($rootScope, $ocLazyLoad, storageService) {
            var _a;
            this.$rootScope = $rootScope;
            this.$ocLazyLoad = $ocLazyLoad;
            this.storageService = storageService;
            this._libs = (_a = {},
                _a[Token.SnapLib.key] = [
                    {
                        files: [
                            this.getBundleUrl("snap.css", true),
                            this.getBundleUrl("loc/loc-snap.".concat(this.$rootScope.clientLanguage, ".js"), false)
                        ]
                    },
                    {
                        files: [
                            this.getBundleUrl("snap.js", true),
                            this.getBundleUrl("kbsnap.js", true),
                            this.getBundleUrl("assistant.js", true)
                        ],
                        serie: true
                    }
                ],
                _a[Token.HandsontableLib.key] = [
                    this.getBundleUrl("lib/handsontable.full.min.js", false),
                    this.getBundleUrl("lib/handsontable.full.min.css", false)
                ],
                _a[Token.HighchartsLib.key] = [
                    this.getBundleUrl("lib/highcharts.js", false)
                ],
                _a[Token.MonacoLoaderLib.key] = [
                    this.getBundleUrl("lib/monaco-editor/min/vs/loader.js", false)
                ],
                _a[Token.AdminLib.key] = [
                    {
                        files: [
                            this.getBundleUrl("admin.js", true),
                            this.getBundleUrl("admin-templates.js", false),
                            this.getBundleUrl("loc/loc-admin.".concat(this.$rootScope.clientLanguage, ".js"), false)
                        ],
                        serie: true
                    }
                ],
                _a[Token.Recaptcha.key] = [
                    {
                        files: [
                            "https://www.google.com/recaptcha/api.js?render=" + this.$rootScope.recaptchaToken
                        ],
                        serie: true
                    }
                ],
                _a[Token.Viewer.key] = [
                    this.getBundleUrl("viewer.js", true)
                ],
                _a[Token.Creator.key] = [
                    this.getBundleUrl("creator.js", true)
                ],
                _a);
        }
        BundleLoaderService.prototype.cachebuster = function (url, minifyIfNotDebug) {
            if (minifyIfNotDebug && this.$rootScope.clusterEnv != enums.eClusterEnv.dev && this.$rootScope.clusterEnv != enums.eClusterEnv.debug && !this.$rootScope.context.debug) {
                var index = url.lastIndexOf(".");
                url = url.slice(0, index) + ".min" + url.slice(index);
            }
            return "".concat(url, "?v=").concat(this.$rootScope.cacheBuster);
        };
        BundleLoaderService.prototype.getBundleUrl = function (relativePath, minifyIfNotDebug) {
            var url = this.storageService.getFileUrl(relativePath);
            return this.cachebuster(url, minifyIfNotDebug);
        };
        BundleLoaderService.prototype.load = function (libraries, paralell) {
            var _this = this;
            if (paralell === void 0) { paralell = true; }
            var urls = [];
            libraries.forEach(function (lib) { return urls.pushArray(_this._libs[lib.key]); });
            return this.$ocLazyLoad.load(urls, { serie: !paralell });
        };
        BundleLoaderService = __decorate([
            NgService({
                token: Token.BundleLoaderService,
                dependencies: [
                    Token.$RootScope,
                    Token.$OcLazyLoad,
                    Token.StorageService
                ]
            })
        ], BundleLoaderService);
        return BundleLoaderService;
    }());

    /**
     * Acts as an aggregate service so consolidate dependencies used
     * across the crudController inherited classes
     */
    var CrudService = /** @class */ (function () {
        function CrudService($http, $stateParams, $rootScope, $state, $window, dialogService, drawerService, $q, signalrService, api, $transitions, authService, $location, $timeout, promiseTracker, kbService) {
            this.$http = $http;
            this.$stateParams = $stateParams;
            this.$rootScope = $rootScope;
            this.$state = $state;
            this.$window = $window;
            this.dialogService = dialogService;
            this.drawerService = drawerService;
            this.$q = $q;
            this.signalrService = signalrService;
            this.api = api;
            this.$transitions = $transitions;
            this.authService = authService;
            this.$location = $location;
            this.$timeout = $timeout;
            this.promiseTracker = promiseTracker;
            this.kbService = kbService;
        }
        CrudService = __decorate([
            NgService({
                token: Token.CrudService,
                dependencies: [
                    Token.$Http,
                    Token.$StateParams,
                    Token.$RootScope,
                    Token.$State,
                    Token.$Window,
                    Token.DialogService,
                    Token.DrawerService,
                    Token.$Q,
                    Token.SignalRService,
                    Token.ApiService,
                    Token.$Transitions,
                    Token.AuthService,
                    Token.$Location,
                    Token.$Timeout,
                    Token.PromiseTracker,
                    Token.KbService
                ]
            })
        ], CrudService);
        return CrudService;
    }());

    var DialogService = /** @class */ (function () {
        function DialogService($rootScope, $compile, $timeout, $sanitize, promiseTracker, api) {
            this.$rootScope = $rootScope;
            this.$compile = $compile;
            this.$timeout = $timeout;
            this.$sanitize = $sanitize;
            this.promiseTracker = promiseTracker;
            this.api = api;
            this.alerts = [];
            this.dialogs = [];
        }
        DialogService.prototype.progress = function (options) {
            if (!this.alerts)
                this.alerts = [];
            this.alerts.push(options);
        };
        DialogService.prototype.confirm = function (confirmMessage, yesCallback, noCallback, okLabel, cancelLabel) {
            this.dialog({
                content: confirmMessage,
                buttons: [
                    new enums.DialogButton((okLabel ? okLabel : loc.ok), _tools.icons.success, yesCallback),
                    new enums.DialogButton((cancelLabel ? cancelLabel : loc.cancel), _tools.icons.cancel, noCallback)
                ]
            });
        };
        DialogService.prototype.alert = function (alert) {
            var _this = this;
            if (!this.alerts)
                this.alerts = [];
            // handle the alert
            // build up the content (lives in msg div)
            if (alert.templateUrl || alert.template) {
                if (alert.templateUrl) {
                    // if they provided a templateUrl, we'll use an ng-include to fetch it
                    alert.msg = $("<div class=\"kb-alertbar__msg\" ng-include=\"'".concat(alert.templateUrl, "'\"><span>Loading...</span></div>"));
                }
                else if (alert.template) {
                    alert.msg = $("<div class=\"kb-alertbar__msg\">".concat(alert.template, "</div>"));
                }
                // build a scope that we'll use to compile the content
                alert.scope = alert.scope || this.$rootScope.$new();
                // now compile the dialog with the scope
                this.$compile(alert.msg)(alert.scope);
            }
            // recommended way to handle digest to avoid async digest collisions
            this.$timeout(function () {
                _this.alerts.push(alert);
            });
            // $apply scope to ensure first value of array is applied to ui
            //this.$rootScope.$apply(); -- caused digest collisions when digest in progress
            var timeShown = alert.timeShown || 5000;
            if (alert.promise) {
                alert.inProgress = true;
                alert.promise.then(function () {
                    alert.type = enums.eAlertType.success;
                    if (alert.successMsg) {
                        alert.msg = alert.successMsg;
                    }
                }, function (reason) {
                    alert.type = enums.eAlertType.error;
                    if (!angular__namespace.isDefined(alert.showPromiseReasonOnFail) || alert.showPromiseReasonOnFail) {
                        alert.msg = reason;
                    }
                }).finally(function () {
                    alert.inProgress = false;
                    if (!alert.persist) {
                        _this.$timeout(function () {
                            _this.alerts.remove(alert);
                            if (alert.scope)
                                alert.scope.$destroy();
                        }, timeShown);
                    }
                });
            }
            else if (!alert.persist) {
                this.$timeout(function () {
                    _this.alerts.remove(alert);
                    if (alert.scope)
                        alert.scope.$destroy();
                }, timeShown);
            }
            return alert;
        };
        DialogService.prototype.closeAlert = function (index) {
            this.alerts.splice(index, 1);
        };
        DialogService.prototype.dialog = function (options) {
            var _this = this;
            var defaultOptions = {
                type: enums.eAlertType.info,
                content: $("<div></div>"),
                templateUrl: null,
                template: null,
                buttons: [],
                buttonArgs: function () { return new enums.DialogButtonArgs(); },
                scope: null
            };
            options = angular__namespace.extend({}, defaultOptions, options);
            // build up the content (lives in msg div)
            if (options.templateUrl) {
                // if they provided a templateUrl, we'll use an ng-include to fetch it
                options.content = $("<div class=\"kb-dialog__msg-content\" ng-include=\"'".concat(options.templateUrl, "'\"><span>Loading...</span></div>"));
            }
            else if (options.template) {
                options.content = $(options.template);
            }
            else if (angular__namespace.isString(options.content)) {
                options.content = $("<span>" + this.$sanitize(options.content) + "</span>");
            }
            // build a dialog object and add it to root scope
            var kbDialog = {
                content: options.content,
                buttons: options.buttons,
                type: enums.eAlertType[options.type],
                visible: false,
                keypress: function (e) {
                    if (kbDialog.buttons && kbDialog.buttons.length) {
                        if (e.which == 13) {
                            kbDialog.buttons[0].click();
                        }
                        else if (e.which == 27) { // escape
                            kbDialog.buttons.last().click();
                        }
                    }
                },
                tracker: options.tracker,
                fullHeight: options.fullHeight
            };
            // set up a click command on each button that will call the callback with the args
            $.each(kbDialog.buttons, function (index, button) {
                button.click = function () {
                    var args = options.buttonArgs();
                    if (button.callback) {
                        button.callback(args);
                    }
                    if (args.close) {
                        kbDialog.visible = false;
                        // give time for animation to finish before removing
                        _this.$timeout(function () {
                            _this.dialogs.remove(kbDialog);
                            if (scope)
                                scope.$destroy();
                        }, 200);
                    }
                };
            });
            // build a scope that we'll use to compile the content
            var scope = options.scope || this.$rootScope.$new();
            // now compile the dialog with the scope
            this.$compile(kbDialog.content)(scope);
            // add the dialog to the rootscope
            if (!this.dialogs)
                this.dialogs = [];
            this.dialogs.push(kbDialog);
            // wait for shield animation
            this.$timeout(function () {
                _this.$timeout(function () {
                    kbDialog.visible = true;
                }, 10);
            }, 10);
            return kbDialog;
        };
        DialogService.prototype.input = function (options) {
            var defaultOptions = {
                msg: "",
                value: "",
                inputType: enums.eInputDialogType.text,
                buttons: null,
                source: null,
                labelField: "",
                valueField: ""
            };
            options = angular__namespace.extend({}, defaultOptions, options);
            var scope = this.$rootScope.$new();
            scope.msg = options.msg;
            scope.value = options.value;
            scope.source = options.source;
            scope.labelField = options.labelField;
            scope.valueField = options.valueField;
            var input = "";
            switch (options.inputType) {
                case enums.eInputDialogType.text:
                    input = "<kb-textbox class='kb-dialog__input' ng-model='value'></kb-textbox>";
                    break;
                case enums.eInputDialogType.html:
                    break;
                case enums.eInputDialogType.textArea:
                    input = "<kb-textarea class='kb-dialog__input' ng-model='value'></kb-textarea>";
                    break;
                case enums.eInputDialogType.select:
                    input = "<kb-select class='kb-dialog__input' ng-model='value' source='source'" +
                        "          value-field='" + scope.valueField + "'" +
                        (scope.labelField ? "label-field='" + scope.labelField + "'" : "") + ">" +
                        "           {{item" + (scope.labelField ? "." + scope.labelField : "") + "}}" +
                        "       </kb-select>";
                    break;
            }
            var dialogOptions = {
                type: enums.eAlertType.info,
                content: $("<div>{{msg}}</div>" +
                    "<div class='kb-dialog__input-box'>" +
                    input +
                    "</div>"),
                templateUrl: null,
                buttons: options.buttons,
                buttonArgs: function () {
                    var args = new enums.InputDialogButtonArgs();
                    args.value = scope.value;
                    return args;
                },
                scope: scope
            };
            return this.dialog(dialogOptions);
        };
        DialogService.prototype.mediaSelect = function (options) {
            var defaultOptions = {
                startPath: "",
                buttons: null,
                filter: enums.eMediaFilter.imagesAndVideos,
                apiPath: "api/media",
                rootDir: "media",
                open: function (file) {
                    window.open(file.id, "_blank");
                }
            };
            options = angular__namespace.extend({}, defaultOptions, options);
            var filter = "";
            switch (options.filter) {
                case enums.eMediaFilter.images:
                    filter = _tools.extensions.image;
                    break;
                case enums.eMediaFilter.videos:
                    filter = _tools.extensions.video;
                    break;
                case enums.eMediaFilter.imagesAndVideos:
                    filter = _tools.extensions.image + "," + _tools.extensions.video;
                    break;
                case enums.eMediaFilter.environments:
                    filter = _tools.extensions.environments;
                    break;
            }
            var scope = this.$rootScope.$new();
            scope.dStartPath = options.startPath;
            scope.tracker = this.promiseTracker();
            var apiPath = "api/media";
            if (options.apiPath)
                apiPath = options.apiPath;
            if (options.rootDir)
                options.rootDir;
            var dialogOptions = {
                type: enums.eAlertType.info,
                content: $('<kb-media-manager dialog="true" ' +
                    '   multiple="false" ' +
                    '   selected-file="dSelected" ' +
                    '   start-path="{{dStartPath}}" ' +
                    '   filter="' + filter + '"' +
                    '   api-path="' + apiPath + '"' +
                    '   root-dir="' + options.rootDir + '"' +
                    '   tracker="tracker"' +
                    '   ng-attr-style="{{\'text-align: left; height:\' + ($parent.windowHeight / 2) + \'px;\' }}">' +
                    "</kb-media-manager>"),
                templateUrl: null,
                buttons: options.buttons,
                buttonArgs: function () {
                    var args = new enums.MediaDialogButtonArgs();
                    if (scope.dSelected) {
                        args.selectedItem = scope.dSelected;
                    }
                    return args;
                },
                scope: scope,
                tracker: scope.tracker
            };
            return this.dialog(dialogOptions);
        };
        DialogService = __decorate([
            NgService({
                token: Token.DialogService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Compile,
                    Token.$Timeout,
                    Token.$Sanitize,
                    Token.PromiseTracker,
                    Token.ApiService,
                ]
            })
        ], DialogService);
        return DialogService;
    }());

    var DragAndDropService = /** @class */ (function () {
        function DragAndDropService($rootScope) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.subscribers = [];
            this.globalDragCounter = 0;
            this.listenersInitialized = false;
            this.isDragging = false;
            this.onDragEnter = function (e) {
                var _a, _b;
                if (!((_b = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.types) === null || _b === void 0 ? void 0 : _b.includes("Files")))
                    return;
                _this.globalDragCounter++;
                _this.subscribers.forEach(function (s) { var _a; return (_a = s.onDragEnter) === null || _a === void 0 ? void 0 : _a.call(s); });
                _this.safeApply();
            };
            this.onDragOver = function (e) {
                e.preventDefault();
                if (!_this.isDragging)
                    _this.setDragging(true);
            };
            this.onDragLeave = function (e) {
                _this.globalDragCounter--;
                if (_this.globalDragCounter <= 0) {
                    _this.globalDragCounter = 0;
                    _this.setDragging(false);
                    _this.subscribers.forEach(function (s) { var _a; return (_a = s.onDragLeave) === null || _a === void 0 ? void 0 : _a.call(s); });
                    _this.safeApply();
                }
            };
            this.onDrop = function (e) {
                var _a, _b;
                e.preventDefault();
                _this.globalDragCounter = 0;
                _this.setDragging(false);
                _this.subscribers.forEach(function (s) { var _a; return (_a = s.onDragLeave) === null || _a === void 0 ? void 0 : _a.call(s); });
                _this.safeApply();
                if ((_b = (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
                    var files_1 = Array.from(e.dataTransfer.files);
                    _this.subscribers.forEach(function (s) { var _a; return (_a = s.onDropFiles) === null || _a === void 0 ? void 0 : _a.call(s, files_1); });
                }
            };
        }
        DragAndDropService.prototype.setDragging = function (value) {
            this.isDragging = value;
            this.broadcastDragging();
        };
        DragAndDropService.prototype.isDraggingActive = function () {
            return this.isDragging;
        };
        DragAndDropService.prototype.broadcastDragging = function () {
            this.$rootScope.$broadcast('globalDragStateChanged', this.isDragging);
        };
        DragAndDropService.prototype.subscribe = function (callbacks) {
            var _this = this;
            this.subscribers.push(callbacks);
            this.ensureListeners();
            // return unsubscribe function
            return function () {
                _this.subscribers = _this.subscribers.filter(function (s) { return s !== callbacks; });
            };
        };
        DragAndDropService.prototype.ensureListeners = function () {
            if (this.listenersInitialized)
                return;
            this.listenersInitialized = true;
            window.addEventListener("dragenter", this.onDragEnter);
            window.addEventListener("dragover", this.onDragOver);
            window.addEventListener("dragleave", this.onDragLeave);
            window.addEventListener("drop", this.onDrop);
        };
        DragAndDropService.prototype.safeApply = function () {
            var phase = this.$rootScope.$root.$$phase;
            if (phase !== '$apply' && phase !== '$digest') {
                this.$rootScope.$applyAsync();
            }
        };
        DragAndDropService = __decorate([
            NgService({
                token: Token.DragAndDropService,
                dependencies: [
                    Token.$RootScope
                ]
            })
        ], DragAndDropService);
        return DragAndDropService;
    }());

    var DrawerService = /** @class */ (function () {
        function DrawerService($rootScope, kbService, $transitions) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.kbService = kbService;
            this.$transitions = $transitions;
            this.drawers = [];
            this.showHelp = true;
            this.visible = true;
            $transitions.onEnter({}, function (transition, state) {
                if (state.name) {
                    // clear out drawer
                    _this.drawers.clear();
                    _this.pageTitle = null;
                    _this.pageIcon = null;
                    _this.pageType = null;
                    _this.showHelp = true;
                    _this.visible = true;
                }
            });
        }
        DrawerService.prototype.setHelpUrl = function (url) {
            if (!url)
                url = "KBMax+CPQ";
            this.helpUrl = "https://cpqhelp.link/" + url.toLowerCase();
        };
        DrawerService.prototype.addDrawer = function (icon, label, command, visible, children) {
            if (!angular__namespace.isDefined(visible)) {
                visible = true;
            }
            var drawer = {
                icon: icon,
                label: label,
                command: function () { if (!drawer.disabled)
                    return command(); },
                visible: visible,
                disabled: false,
                children: children
            };
            this.drawers.push(drawer);
            return drawer;
        };
        DrawerService = __decorate([
            NgService({
                token: Token.DrawerService,
                dependencies: [
                    Token.$RootScope,
                    Token.KbService,
                    Token.$Transitions
                ]
            })
        ], DrawerService);
        return DrawerService;
    }());

    var InteractionService = /** @class */ (function () {
        function InteractionService(api) {
            this.api = api;
        }
        InteractionService.prototype.record = function (idConfigurator) {
            var guid = null;
            try {
                guid = window.localStorage["userGuid"];
                if (!guid) {
                    guid = window.localStorage["userGuid"] = _tools.Utils.shortId();
                }
            }
            catch (e) {
                guid = _tools.Utils.shortId();
            }
            return this.api.interactions.insert({
                idConfigurator: idConfigurator,
                userGuid: guid
            });
        };
        InteractionService = __decorate([
            NgService({
                token: Token.InteractionService,
                dependencies: [
                    Token.ApiService
                ]
            })
        ], InteractionService);
        return InteractionService;
    }());

    var KbService = /** @class */ (function () {
        function KbService($rootScope, authService, $q, $timeout) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.authService = authService;
            this.$q = $q;
            this.$timeout = $timeout;
            this.fxConvert = function (val, to, from) {
                if (from === void 0) { from = null; }
                if (!from)
                    from = _this.$rootScope.companySettings.currency.toUpperCase();
                return fx(val).from(from).to(to.toUpperCase());
            };
            this.fly = function (sourceSelector, targetSelector, callback) {
                var $source = $(sourceSelector).eq(0);
                var $target = $(targetSelector).eq(0);
                if ($source) {
                    var $fly_1 = $source.clone()
                        .offset({
                        top: $source.offset().top,
                        left: $source.offset().left
                    })
                        .css({
                        "opacity": "0.5",
                        "position": "fixed",
                        "height": $source.height(),
                        "width": $source.width(),
                        "z-index": "1000"
                    })
                        .appendTo($("body"))
                        .animate({
                        top: $target.offset().top,
                        left: $target.offset().left,
                        width: $target.width(),
                        height: $target.height()
                    }, 800, function () {
                        $fly_1.remove();
                        if (callback)
                            callback();
                        _this.animateBounce($target, 5, 10, 500);
                    });
                }
            };
        }
        KbService.prototype.loc = function (key) {
            if (key) {
                var lkey = key.toLowerCase();
                if (loc[lkey]) {
                    return loc[lkey];
                }
            }
            return key;
        };
        KbService.prototype.icon = function (key) {
            var icon = _tools.icons[key];
            if (!icon) {
                icon = key;
            }
            return icon;
        };
        KbService.prototype.getExtension = function (path) {
            if (!path) {
                return "";
            }
            return path.split(".").pop().toLowerCase();
        };
        /**
         * given a kb enum type, gives back an array of NameValue objects
         * with localized names that can be used in a kbSelect
         *
         */
        KbService.prototype.getEnumSelects = function (enm, enumName) {
            var selects = [];
            for (var name_1 in enm) {
                var locName = enumName + "_" + name_1 + "_title";
                var locValue = this.loc(locName);
                selects.push({
                    name: locValue,
                    value: enm[name_1]
                });
            }
            return selects;
        };
        KbService.prototype.copyDataToClipboard = function (data) {
            var _this = this;
            var $el = jQuery('<div class="copyPopup"><p>Copy the Json below and use \'Paste Json\' in another location.</p></div>');
            var $textarea = jQuery('<textarea></textarea>');
            jQuery("body").find(".copyPopup").remove();
            $el.append($textarea);
            this.$timeout(function () {
                var textarea = $textarea.get(0);
                $textarea.val(data);
                $textarea.focus();
                textarea.setSelectionRange(0, 999999);
                textarea.addEventListener("keydown", function (ev) {
                    if (ev.key == "c" && ev.ctrlKey) {
                        _this.$timeout(function () {
                            $el.remove();
                        }, 1);
                    }
                    if (ev.key == "Escape") {
                        _this.$timeout(function () {
                            $el.remove();
                        }, 1);
                    }
                });
            }, 1);
            jQuery("body").append($el);
        };
        KbService.prototype.pasteClipboardData = function () {
            var _this = this;
            var defer = this.$q.defer();
            jQuery("body").find(".copyPopup").remove();
            var $el = jQuery('<div class="copyPopup"><p>Paste the Json below.</p></div>');
            var $textarea = jQuery('<textarea></textarea>');
            $el.append($textarea);
            jQuery("body").append($el);
            this.$timeout(function () {
                var textarea = $textarea.get(0);
                $textarea.focus();
                textarea.setSelectionRange(0, 999999);
                textarea.addEventListener("keydown", function (ev) {
                    if (ev.key == "v" && ev.ctrlKey) {
                        _this.$timeout(function () {
                            defer.resolve($textarea.val());
                            $el.remove();
                        }, 1);
                    }
                    if (ev.key == "Escape") {
                        _this.$timeout(function () {
                            $el.remove();
                        }, 1);
                    }
                });
            }, 1);
            return defer.promise;
        };
        KbService.prototype.fxConvertAsync = function (val, to) {
            var deferred = this.$q.defer();
            deferred.resolve(this.fxConvert(val, to));
            return deferred.promise;
        };
        KbService.prototype.animateBounce = function (element, times, distance, duration) {
            var staticElement = false;
            if (element.css("position") == "static") {
                staticElement = true;
                element.css("position", "relative");
            }
            var speed = duration / (times * 2);
            for (var i = 0; i < times; i++) {
                element.animate({ top: '-=' + distance }, speed)
                    .animate({ top: '+=' + distance }, speed);
                if (staticElement && i >= times - 1) {
                    // excute after last animation
                    element.promise().then(function () { element.css("position", "static"); });
                }
                distance = distance / 2;
            }
        };
        KbService = __decorate([
            NgService({
                token: Token.KbService,
                dependencies: [
                    Token.$RootScope,
                    Token.AuthService,
                    Token.$Q,
                    Token.$Timeout
                ]
            })
        ], KbService);
        return KbService;
    }());

    var QuoteService = /** @class */ (function () {
        function QuoteService($rootScope, $q, kbService, $http, $state, $cookieStore, dialogService, api) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.kbService = kbService;
            this.$http = $http;
            this.$state = $state;
            this.$cookieStore = $cookieStore;
            this.dialogService = dialogService;
            this.api = api;
            this._initDeferred = $q.defer();
            this._initialized = false;
            var quoteIdFromCookie;
            try {
                quoteIdFromCookie = this.getActiveQuoteData();
            }
            catch (e) {
            }
            if (quoteIdFromCookie && quoteIdFromCookie.guidToken) {
                this._initDeferred.promise = $http.get("/api/quotes/guid/" + quoteIdFromCookie.guidToken, {
                    ignoreSecurity: true,
                    ignoreErrors: true
                }).then(function (r) {
                    if (r.data.createdBy == $rootScope.user.id || r.data.ownedBy == $rootScope.user.id ||
                        r.data.allowedActions.some(function (a) { return a.type == enums.eWorkflowAction.modifyProducts; })) {
                        _this.quote = r.data;
                    }
                    else {
                        // tslint:disable-next-line:no-console
                        console.log("Active Quote with ID " +
                            quoteIdFromCookie.guidToken +
                            " does not have proper add product permissions. Unsetting cookie.");
                        _this.$cookieStore.remove(QuoteService_1.COOKIE_NAME);
                    }
                    _this._initialized = true;
                }, function () {
                    // tslint:disable-next-line:no-console
                    console.log("Active Quote with ID " +
                        quoteIdFromCookie.guidToken +
                        " does not exist. Unsetting cookie.");
                    _this.$cookieStore.remove(QuoteService_1.COOKIE_NAME);
                    _this._initialized = true;
                });
                this._initDeferred.resolve();
            }
            else {
                this._initialized = true;
            }
        }
        QuoteService_1 = QuoteService;
        Object.defineProperty(QuoteService.prototype, "isInitialized", {
            get: function () {
                return this._initialized;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(QuoteService.prototype, "initPromise", {
            get: function () {
                return this._initDeferred.promise;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(QuoteService.prototype, "quote", {
            get: function () {
                return this._quote;
            },
            set: function (val) {
                this._quote = val;
                // set the active quote in a cookie
                if (val) {
                    this.storeCookie(val);
                }
                else {
                    this.$cookieStore.remove(QuoteService_1.COOKIE_NAME);
                }
            },
            enumerable: false,
            configurable: true
        });
        QuoteService.prototype.storeCookie = function (quote) {
            this.$cookieStore.put(QuoteService_1.COOKIE_NAME, JSON.stringify({
                idQuote: quote.id,
                guidToken: quote.guidToken
            }));
        };
        QuoteService.prototype.getActiveQuoteData = function () {
            var cookie = this.$cookieStore.get(QuoteService_1.COOKIE_NAME);
            if (!cookie)
                return null;
            return JSON.parse(cookie);
        };
        QuoteService.prototype.getLatestQuoteProduct = function (quote) {
            var result = null;
            quote.products.forEach(function (p) {
                if (!result)
                    result = p;
                else {
                    if (result.id < p.id) {
                        result = p;
                    }
                }
            });
            return result;
        };
        QuoteService.prototype.addProduct = function (args) {
            var _this = this;
            var deferred = this.$q.defer();
            // if there is no current quote, then we need to create one,
            // add the quoteProduct to it, and save on the server
            if (!this.quote) {
                this.quote = this.getNewQuote();
                if (args.currency)
                    this.quote.currency = args.currency;
                // add just the id of the product to the quote products array
                this.quote.products.push({
                    idProduct: args.idProduct,
                    qty: args.qty,
                    configuredProduct: args.configuredProduct,
                    isConfigured: (args.configuredProduct !== null && args.configuredProduct !== undefined),
                    sku: args.sku
                });
                // save it
                this.api.quotes.save(this.quote, this.$rootScope.contentTracker).then(function (r) {
                    _this.quote = r;
                    deferred.resolve(_this.getLatestQuoteProduct(r));
                });
            }
            else { // there is an active quote
                if (this.quote.idWorkflow &&
                    !this.quote.allowedActions.some(function (a) { return a.type == enums.eWorkflowAction.modifyProducts; })) {
                    var confirm_1 = function () {
                        _this.quote = null;
                        _this.addProduct(args).then(function (r) {
                            deferred.resolve(_this.getLatestQuoteProduct(r));
                        });
                    };
                    if (args.silent) {
                        confirm_1();
                    }
                    else {
                        this.dialogService.confirm("You cannot add products to quote '" +
                            this.quote.name +
                            "' at this time. Would you like to add it to a new quote?", function () {
                            confirm_1();
                        });
                    }
                }
                else {
                    // first we post to the server... it has it's own logic to figure
                    // out duplicates and quantities
                    var newQuoteProduct_1 = {
                        idProduct: args.idProduct,
                        qty: args.qty,
                        configuredProduct: args.configuredProduct,
                        isConfigured: (args.configuredProduct !== null && args.configuredProduct !== undefined),
                        sku: args.sku
                    };
                    this.api.quotes.insertQuoteProduct(this.quote.id, newQuoteProduct_1, this.$rootScope.contentTracker).then(function (r) {
                        _this.quote = r;
                        deferred.resolve(_this.getLatestQuoteProduct(r));
                    });
                    // now we figure it out locally to get an immediate update
                    var existingProduct = this.quote.products.find(function (qp) {
                        return !newQuoteProduct_1.isConfigured && qp.idProduct == newQuoteProduct_1.idProduct;
                    });
                    if (args.addLocally) {
                        if (!existingProduct) {
                            this.quote.products.push(newQuoteProduct_1);
                        }
                        else {
                            existingProduct.qty += args.qty;
                        }
                    }
                }
            }
            return deferred.promise;
        };
        QuoteService.prototype.canModifyProductsOfQuote = function (q) {
            return !q.idWorkflow || q.allowedActions.some(function (a) { return a.type == enums.eWorkflowAction.modifyProducts; });
        };
        QuoteService.prototype.copyProductToActiveQuote = function (idQuoteProduct) {
            var _this = this;
            var deferred = this.$q.defer();
            if (this.canModifyProductsOfQuote(this.quote)) {
                this.api.quotes.copyQuoteProduct(this.quote.id, idQuoteProduct, this.$rootScope.contentTracker).then(function (r) {
                    _this.quote = r;
                    deferred.resolve();
                });
            }
            else {
                this.dialogService.confirm("You cannot add products to quote '" +
                    this.quote.name +
                    "' at this time. Would you like to add it to a new quote?", function () {
                    _this.quote = null;
                    _this.copyProductToNewQuote(idQuoteProduct).then(function () {
                        deferred.resolve();
                    });
                });
            }
            return deferred.promise;
        };
        QuoteService.prototype.copyProductToNewQuote = function (idQuoteProduct) {
            var _this = this;
            this.quote = this.getNewQuote();
            // save it
            return this.api.quotes.save(this.quote, this.$rootScope.contentTracker).then(function (r) {
                _this.quote = r;
                return _this.api.quotes.copyQuoteProduct(_this.quote.id, idQuoteProduct, _this.$rootScope.contentTracker).then(function (r) {
                    _this.quote = r;
                });
            });
        };
        QuoteService.prototype.goToQuote = function () {
            if (this.quote) {
                this.$state.go("kb.quoteEdit", { id: this.quote.id });
            }
            else {
                this.$state.go("kb.quoteNew");
            }
        };
        QuoteService.prototype.getNewQuote = function () {
            return {
                name: loc.newquote,
                createdBy: this.$rootScope.user.id,
                ownedBy: this.$rootScope.user.id,
                currency: this.$rootScope.companySettings.currency,
                quoteProducts: [],
                products: [],
                discountPercentage: 0
            };
        };
        QuoteService.prototype.getQuoteById = function (id) {
            var promise;
            if (this.$rootScope.user.id != AuthService.ANONYMOUS_USER_ID) {
                promise = this.$http.get("/api/quotes/" + id, { method: "GET", tracker: this.$rootScope.contentTracker });
            }
            else {
                var data = this.getActiveQuoteData();
                if (data && data.idQuote == id) {
                    promise = this.$http.get("/api/quotes/guid/" + data.guidToken, { method: "GET", tracker: this.$rootScope.contentTracker });
                }
                else {
                    promise = this.$http.get("/api/quotes/" + id, { method: "GET", tracker: this.$rootScope.contentTracker });
                }
            }
            return promise.then(function (data) {
                return (data ? data.data : null);
            });
        };
        var QuoteService_1;
        QuoteService.COOKIE_NAME = "activeQuote";
        QuoteService = QuoteService_1 = __decorate([
            NgService({
                token: Token.QuoteService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Q,
                    Token.KbService,
                    Token.$Http,
                    Token.$State,
                    Token.$CookieStore,
                    Token.DialogService,
                    Token.ApiService,
                ]
            })
        ], QuoteService);
        return QuoteService;
    }());

    var RuleService = /** @class */ (function () {
        function RuleService($q) {
            this.$q = $q;
            this._masterRuleCache = {};
        }
        RuleService.prototype.getConfiguratorHash = function (config, additionalJs) {
            var hash = "".concat(config.idProduct || 0, "-").concat(config.idScene || 0, "-").concat(config.idQuoteHeader || 0, "-").concat(config.id);
            if (additionalJs) {
                additionalJs = additionalJs.trim();
                additionalJs = additionalJs.replaceAll(' ', '');
                hash = "".concat(hash, "-").concat(additionalJs.substring(-8));
            }
            return hash;
        };
        RuleService.prototype.getRuleName = function (rc) {
            return "rule-".concat(rc.id);
        };
        RuleService.prototype.getRuleHeader = function (rc) {
            var desc = "".concat(rc.ruleType.toSentence(), " Rule");
            if (rc.ruleType.equalsAny(enums.eRuleType.field, enums.eRuleType.action, enums.eRuleType.function, enums.eRuleType.optionFilter)) {
                desc += " - " + rc.name;
            }
            var stars = "*".repeat(Math.max(desc.length - 1, 70));
            return "\r\n/".concat(stars, "\r\n * ").concat(desc, "\r\n ").concat(stars, "/\r\n");
        };
        RuleService.prototype.getConfiguratorMasterRule = function (config, additionalJs) {
            var _this = this;
            var hash = this.getConfiguratorHash(config, additionalJs);
            if (!this._masterRuleCache.hasOwnProperty(hash)) {
                var globalRc = config.ruleContainers.find(function (rc) { return rc.ruleType.isEqual(enums.eRuleType.global); });
                var js_1 = globalRc ? globalRc.js + "\r\n\r\n" : "";
                var globalEventRc = config.ruleContainers.find(function (rc) { return rc.ruleType.isEqual(enums.eRuleType.globalEvent); });
                js_1 += globalEventRc ? globalEventRc.js + "\r\n\r\n" : "";
                js_1 += additionalJs + "\r\n\r\n";
                js_1 += "var _ruleDb = {\r\n";
                var ruleContainers_1 = config.ruleContainers
                    .concat(config.actions)
                    .concat(config.functions)
                    .concat(config.getChildrenOfType(enums.CToken.Field, enums.CToken.Button, enums.CToken.SvgViewer, enums.CToken.NestedSet, enums.CToken.RuleContainer, enums.CToken.Html))
                    .concat(config.optionFilters);
                config.getChildrenOfType(enums.CToken.SvgViewer).forEach(function (svg) { return ruleContainers_1 = ruleContainers_1.concat(svg.ruleContainers); });
                config.getChildrenOfType(enums.CToken.Html).forEach(function (html) { return ruleContainers_1 = ruleContainers_1.concat(html.ruleContainers); });
                config.referencedConfigurators.forEach(function (refConfig) { return ruleContainers_1 = ruleContainers_1.concat(refConfig.ruleContainers); });
                ruleContainers_1.forEach(function (rc) {
                    if (rc.ruleType != enums.eRuleType.global && rc.js) {
                        js_1 += _this.getRuleHeader(rc);
                        js_1 += "\"".concat(_this.getRuleName(rc), "\": ");
                        var ruleJs = "\r\n\t" + rc.js.split("\n").join("\r\n\t");
                        if (rc.ruleType == enums.eRuleType.optionFilter) {
                            js_1 += "function(){\r\n" + ruleJs + "\r\n},";
                        }
                        else {
                            js_1 += "function(){return Q.fcall(function () {\r\n" + ruleJs + "\r\n})},";
                        }
                    }
                });
                js_1 += "};\r\n\r\n";
                js_1 += "return _ruleDb[e.ruleName]();";
                this._masterRuleCache[hash] = new Function("Q", "e", js_1);
            }
            return this._masterRuleCache[hash];
        };
        RuleService.prototype.compileAsyncRule = function (js) {
            // tab out the code
            js = "\t\t" + js.split("\n").join("\r\n\t\t");
            // wrap the js.  We use Q.when().then(code) to make sure that errors are propogated to our promise error handler
            var rule = "\t" + "return Q.fcall(function () {\n" +
                js + "\n" +
                "\t})\n";
            return new Function("Q", "e", rule);
        };
        RuleService.prototype.runRuleAsync = function (parameters, fn) {
            var promise = fn(Q__namespace, parameters)
                .then(function () {
                return {
                    parameters: parameters,
                    hasError: false,
                    error: null
                };
            }, function (error) {
                return {
                    parameters: parameters,
                    hasError: true,
                    error: error
                };
            });
            return promise;
        };
        RuleService.prototype.runJsAsync = function (parameters, js) {
            var fn = this.compileAsyncRule(js);
            return this.runRuleAsync(parameters, fn);
        };
        RuleService.prototype.compileSyncRule = function (js) {
            return new Function("e", js);
        };
        /**
         * runs the rule synchronously... Only for use in special circumstances if you know what you're doing!
         */
        RuleService.prototype.runRuleSync = function (parameters, fn) {
            var result = {};
            try {
                fn(Q__namespace, parameters);
            }
            catch (err) {
                result.hasError = true;
                result.error = err.message;
            }
            result.parameters = parameters;
            return result;
        };
        RuleService.prototype.runJsSync = function (parameters, js) {
            var fn = this.compileSyncRule(js);
            return this.runRuleSync(parameters, fn);
        };
        /**
         * runs the rule of a rule container, compiling and caching it along the way
         * @param ruleContainer
         * @param args
         */
        RuleService.prototype.runRuleContainerAsync = function (ruleContainer, args) {
            if (ruleContainer && ruleContainer.js) {
                var globalFuncs_1 = '';
                var globalFuncIds_1 = [];
                if (args.globalFunctions) {
                    var gfJs = args.globalFunctions;
                    gfJs.forEach(function (gf) {
                        if (!globalFuncIds_1.contains(gf.id)) {
                            globalFuncIds_1.push(gf.id);
                            globalFuncs_1 += gf.js + "\r\n";
                        }
                    });
                }
                var masterRule = this.getConfiguratorMasterRule(ruleContainer.$parentConfigurator, globalFuncs_1);
                args["ruleName"] = this.getRuleName(ruleContainer);
                var start_1 = _tools.Logger.logRuleStart(ruleContainer.$parentConfigurator.name, ruleContainer.ruleType);
                var promise = this.runRuleAsync(args, masterRule);
                if (_tools.Logger.writeRuleCycleLogs) {
                    promise = promise.then(function (result) {
                        _tools.Logger.logRuleEnd(ruleContainer.$parentConfigurator.name, ruleContainer.ruleType, start_1);
                        return result;
                    });
                }
                return promise;
            }
            else { // if there is no text in the rule, then don't bother running it
                var result = {
                    hasError: false,
                    parameters: args
                };
                return (new _rules.KPromise(result));
            }
        };
        RuleService.prototype.runRuleContainerSync = function (ruleContainer, args) {
            if (ruleContainer && ruleContainer.js) {
                var masterRule = this.getConfiguratorMasterRule(ruleContainer.$parentConfigurator);
                args["ruleName"] = this.getRuleName(ruleContainer);
                return this.runRuleSync(args, masterRule);
            }
            else { // if there is no text in the rule, then don't bother running it
                var result = {
                    hasError: false,
                    parameters: args
                };
                return result;
            }
        };
        // /**
        //  * runs the rule of a rule container, compiling and caching it along the way
        //  * @param ruleContainer 
        //  * @param args 
        //  */
        // public runRuleContainerAsync<T>(
        //     ruleContainer: RuleContainer,
        //     args: T
        // ): ng.IPromise<IJsResult<T>> {
        //     // find the cached fn, if it's already been compiled
        //     if (ruleContainer && ruleContainer.js) {
        //         // find or cache the compiled fn for perf
        //         ruleContainer.$asyncFn = ruleContainer.$asyncFn || this.compileAsyncRule<T>(ruleContainer.$parentConfigurator.getRuleJsFromContainer(ruleContainer));
        //         return this.runRuleAsync<T>(args, ruleContainer.$asyncFn);
        //     } else { // if there is no text in the rule, then don't bother running it
        //         let result: IJsResult<T> = {
        //             hasError: false,
        //             parameters: args
        //         };
        //         return (new KPromise(result)) as any;
        //     }
        // }
        // public runRuleContainerSync<T>(
        //     ruleContainer: RuleContainer,
        //     args: T
        // ): IJsResult<T> {
        //     // find the cached fn, if it's already been compiled
        //     if (ruleContainer && ruleContainer.js) {
        //         // find or cache the compiled fn for perf
        //         ruleContainer.$syncFn = ruleContainer.$syncFn || this.compileSyncRule<T>(ruleContainer.$parentConfigurator.getRuleJsFromContainer(ruleContainer));
        //         return this.runRuleSync<T>(args, ruleContainer.$syncFn);
        //     } else { // if there is no text in the rule, then don't bother running it
        //         let result: IJsResult<T> = {
        //             hasError: false,
        //             parameters: args
        //         };
        //         return result;
        //     }
        // }
        RuleService.prototype.runRuleTypeAsync = function (config, ruleType, args) {
            var rc = config.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return this.runRuleContainerAsync(rc, args);
        };
        RuleService.prototype.runActionRuleByIdAsync = function (config, actionId, args) {
            var container = config.actions.find(function (a) { return a.id == actionId; });
            return this.runRuleContainerAsync(container, args);
        };
        RuleService = __decorate([
            NgService({
                token: Token.RuleService,
                dependencies: [
                    Token.$Q,
                ]
            })
        ], RuleService);
        return RuleService;
    }());

    /**
     * Acts as an aggregate service so consolidate dependencies used
     * across the crudController inherited classes
     */
    var SearchService = /** @class */ (function () {
        function SearchService($location, $state, $http, $rootScope, dialogService, drawerService, $timeout, $q, api, base64Service, $filter) {
            this.$location = $location;
            this.$state = $state;
            this.$http = $http;
            this.$rootScope = $rootScope;
            this.dialogService = dialogService;
            this.drawerService = drawerService;
            this.$timeout = $timeout;
            this.$q = $q;
            this.api = api;
            this.base64Service = base64Service;
            this.$filter = $filter;
        }
        SearchService = __decorate([
            NgService({
                token: Token.SearchService,
                dependencies: [
                    Token.$Location,
                    Token.$State,
                    Token.$Http,
                    Token.$RootScope,
                    Token.DialogService,
                    Token.DrawerService,
                    Token.$Timeout,
                    Token.$Q,
                    Token.ApiService,
                    Token.Base64Service,
                    Token.$Filter
                ]
            })
        ], SearchService);
        return SearchService;
    }());

    var SecurityRetryService = /** @class */ (function () {
        function SecurityRetryService($q) {
            this.$q = $q;
            this.retryQueue = [];
        }
        SecurityRetryService.prototype.retryAll = function () {
            while (this.retryQueue.length) {
                this.retryQueue.shift().retry();
            }
        };
        SecurityRetryService.prototype.pushRetryFn = function (reason, retryFn) {
            var _this = this;
            var deferredRetry = this.$q.defer();
            var retryItem = {
                reason: reason,
                retry: function () {
                    _this.$q.when(retryFn()).then(function (value) {
                        deferredRetry.resolve(value);
                    }, function (value) {
                        deferredRetry.reject(value);
                    });
                },
                cancel: function () {
                    deferredRetry.reject();
                }
            };
            this.push(retryItem);
            return deferredRetry.promise;
        };
        SecurityRetryService.prototype.push = function (retryItem) {
            this.retryQueue.push(retryItem);
            if (this.onItemAdded) {
                this.onItemAdded();
            }
        };
        SecurityRetryService = __decorate([
            NgService({
                token: Token.SecurityRetryService,
                dependencies: [
                    Token.$Q,
                ]
            })
        ], SecurityRetryService);
        return SecurityRetryService;
    }());

    var SfdcService = /** @class */ (function () {
        function SfdcService($rootScope, $q, dialogService) {
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.dialogService = dialogService;
            this.dynamicOptionsToQueryStatic = [];
        }
        SfdcService.prototype.cloneSfdcCpqPayload = function (payload) {
            if (!payload)
                return payload;
            try {
                return JSON.parse(JSON.stringify(payload));
            }
            catch (e) {
                console.warn('Failed to clone SFDC CPQ payload', e);
                return payload;
            }
        };
        /**
         * Ensure the Sfdc Canvas SDK is available and restore canvas context from sessionStorage if needed.
         * Resolves when Sfdc.canvas.client is available; rejects if timeout or failure to load.
         */
        SfdcService.prototype.ensureReady = function (timeoutMs) {
            if (timeoutMs === void 0) { timeoutMs = 3000; }
            var deferred = this.$q.defer();
            // try to restore context from sessionStorage if missing
            try {
                if (!this.$rootScope.context.sfdcCanvasRequest) {
                    var raw = sessionStorage.getItem("SfdcCanvasCookie");
                    if (raw) {
                        try {
                            this.$rootScope.context.sfdcCanvasRequest = JSON.parse(raw);
                        }
                        catch (e) {
                            console.warn('Failed to parse saved SfdcCanvasCookie', e);
                        }
                    }
                }
            }
            catch (e) {
                console.warn('sessionStorage unavailable while restoring SfdcCanvasCookie', e);
            }
            // If the SDK client already exists resolve immediately
            if (window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                deferred.resolve();
                return deferred.promise;
            }
            // Try to inject the SDK script if it isn't loaded already
            try {
                var src_1 = '/lib/canvas-all.js';
                if (!document.querySelector("script[src=\"".concat(src_1, "\"]"))) {
                    var s = document.createElement('script');
                    s.src = src_1;
                    s.async = true;
                    s.onload = function () {
                        // nothing here; we'll poll below for initialization
                    };
                    s.onerror = function () {
                        // can't load the SDK - still attempt a graceful reject after timeout
                        console.warn('Failed loading canvas SDK script', src_1);
                    };
                    document.head.appendChild(s);
                }
            }
            catch (e) {
                // ignore DOM access errors and continue to poll
                console.warn('Error injecting canvas SDK script', e);
            }
            // Poll for the Sfdc.client to become available
            var start = Date.now();
            var id = setInterval(function () {
                if (window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                    clearInterval(id);
                    deferred.resolve();
                    return;
                }
                if (Date.now() - start > timeoutMs) {
                    clearInterval(id);
                    deferred.reject(new Error('Sfdc.canvas.client not available'));
                }
            }, 50);
            return deferred.promise;
        };
        /**
         * get's the record passed in through the canvas context
         */
        SfdcService.prototype.record = function () {
            if (this.$rootScope.isSfdc)
                return this.canvasRequest().context.environment.record;
        };
        SfdcService.prototype.canvasRequest = function () {
            if (this.$rootScope.isSfdc)
                return this.$rootScope.context.sfdcCanvasRequest;
        };
        /**
         * navigates to the salesforce view page of the object with the given id
         */
        SfdcService.prototype.navigateToObject = function (id) {
            var _this = this;
            this.ensureReady()
                .then(function () {
                var sr = _this.$rootScope.context.sfdcCanvasRequest;
                if (sr && window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                    Sfdc.canvas.client.publish(sr.client, {
                        name: "navigateToObject",
                        payload: id
                    });
                }
                else {
                    console.warn('Sfdc canvas not available for navigateToObject');
                }
            })
                .catch(function (err) { return console.warn('Sfdc not ready for navigateToObject', err); });
        };
        SfdcService.prototype.toggleFullscreen = function () {
            var _this = this;
            this.ensureReady()
                .then(function () {
                var sr = _this.canvasRequest();
                if (sr && window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                    Sfdc.canvas.client.publish(sr.client, {
                        name: "toggleFullscreen",
                        payload: {}
                    });
                }
                else {
                    console.warn('Sfdc canvas not available for toggleFullscreen');
                }
            })
                .catch(function (err) { return console.warn('Sfdc not ready for toggleFullscreen', err); });
        };
        /**
         * send a message to the visual force page hosting our canvas
         * @param msg
         */
        SfdcService.prototype.sendMessage = function (msg) {
            var _this = this;
            if (!this.$rootScope.isSfdc)
                return;
            this.ensureReady()
                .then(function () {
                var sr = _this.canvasRequest();
                if (sr && window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                    Sfdc.canvas.client.publish(sr.client, {
                        name: msg.name,
                        payload: msg.data
                    });
                }
            })
                .catch(function (err) { return console.warn('Sfdc not ready for sendMessage', err); });
        };
        /**
         * makes a quote the primary quote in sfdc by calling through the canvas
         * @param quote
         */
        SfdcService.prototype.makePrimaryQuote = function (quote) {
            var _this = this;
            // Ensure SDK and context are available then call ajax
            return this.ensureReady().then(function () {
                var deferred = _this.$q.defer();
                var sr = _this.$rootScope.context.sfdcCanvasRequest;
                if (!sr) {
                    deferred.reject(new Error('Sfdc canvas request not available'));
                    return deferred.promise;
                }
                var url = sr.context.links.restUrl + "sobjects/KBMAX__Quote__c/" + quote.externalId;
                try {
                    Sfdc.canvas.client.ajax(url, {
                        client: sr.client,
                        method: "PATCH",
                        contentType: "application/json",
                        data: JSON.stringify({
                            KBMAX__Primary__c: true
                        }),
                        success: function (data) {
                            if (data.status === 204) {
                                deferred.resolve();
                            }
                            else {
                                deferred.reject();
                            }
                        },
                        error: function (err) { return deferred.reject(err); }
                    });
                }
                catch (e) {
                    deferred.reject(e);
                }
                return deferred.promise;
            });
        };
        /**
         * when integrating with steelbrick, because of their easyXdm setup, we have to wait for the canvas
         * to tell us what the id of the product is.
         */
        SfdcService.prototype.getPayloadFromSfdcCpq = function () {
            var _this = this;
            // ensure SDK and context are ready
            return this.ensureReady().then(function () {
                var deferred = _this.$q.defer();
                var sr = _this.$rootScope.context.sfdcCanvasRequest;
                if (!sr) {
                    deferred.reject(new Error('Sfdc canvas request not available'));
                    return deferred.promise;
                }
                Sfdc.canvas.client.subscribe(sr.client, {
                    name: "sfdccpq_payload_response",
                    onData: function (e) {
                        _this.originalSfdcCpqPayload = _this.cloneSfdcCpqPayload(e);
                        deferred.resolve(e);
                    }
                });
                Sfdc.canvas.client.publish(sr.client, {
                    name: "sfdccpq_payload_request",
                    payload: {}
                });
                return deferred.promise;
            });
        };
        SfdcService.prototype.getProducts = function (productCodes) {
            var _this = this;
            return this.ensureReady().then(function () {
                var deferred = _this.$q.defer();
                var sr = _this.$rootScope.context.sfdcCanvasRequest;
                if (!sr) {
                    deferred.reject(new Error('Sfdc canvas request not available'));
                    return deferred.promise;
                }
                Sfdc.canvas.client.subscribe(sr.client, {
                    name: "sfdccpq_getproducts_response",
                    onData: function (e) {
                        deferred.resolve(e.products);
                    }
                });
                Sfdc.canvas.client.publish(sr.client, {
                    name: "sfdccpq_getproducts",
                    payload: { productCodes: productCodes }
                });
                return deferred.promise;
            });
        };
        SfdcService.prototype.getColumnOrMetaValue = function (key, priceItem) {
            // find the price column if there is one
            if (priceItem.columns) {
                var colNames = Object.keys(priceItem.columns);
                for (var _i = 0, colNames_1 = colNames; _i < colNames_1.length; _i++) {
                    var colName = colNames_1[_i];
                    if (colName.isEqual(key)) {
                        return priceItem.columns[colName];
                    }
                }
            }
            // find the metadata property if there is one
            if (priceItem.metadata) {
                var metaNames = Object.keys(priceItem.metadata);
                for (var _a = 0, metaNames_1 = metaNames; _a < metaNames_1.length; _a++) {
                    var metaName = metaNames_1[_a];
                    if (metaName.isEqual(key)) {
                        return priceItem.metadata[metaName];
                    }
                }
            }
            return null;
        };
        SfdcService.prototype.getConfigurationAttribute = function (payload, name) {
            for (var att in payload.data.product.configurationAttributes) {
                if (!att.isEqual("attributes") && att.isEqual(name)) {
                    return att;
                }
            }
            return null;
        };
        SfdcService.prototype.addColumnsAndMetadataToConfigurationObject = function (payload, configurationData, item) {
            for (var col in item.columns) {
                var att = this.getConfigurationAttribute(payload, col);
                if (att) {
                    configurationData[att] = item.columns[col];
                }
            }
            for (var m in item.metadata) {
                var att = this.getConfigurationAttribute(payload, m);
                if (att) {
                    configurationData[att] = item.metadata[m];
                }
            }
        };
        SfdcService.prototype.buildOptions = function (payload, item, optionConfig, isDynamic) {
            var _this = this;
            if (isDynamic === void 0) { isDynamic = false; }
            if (!optionConfig) {
                var options = void 0;
                if (isDynamic)
                    options = { 'Dynamic Options': [] };
                else
                    options = { 'Other Options': [] };
                optionConfig = options;
            }
            //let dynamicOptionsToQuery: { item: IPriceItem, dynamicOption: ISfdcCpqPayloadOption }[] = [];
            if (isDynamic) {
                item.items.forEach(function (element, index) {
                    var _a;
                    var salesforceId = item.columns.salesforceId || item.metadata.salesforceId;
                    var dynamicOption = {
                        ProductCode: element.sku,
                        Quantity: (_a = element.qty) !== null && _a !== void 0 ? _a : 1,
                        configurationData: {},
                        productId: '',
                        selected: true
                    };
                    _this.addColumnsAndMetadataToConfigurationObject(payload, dynamicOption.configurationData, element);
                    // if (element.sku == 'y_product')
                    //     dynamicOption.productId = '01t4x000008PckRAAS';
                    // if (element.sku == 'z_product')
                    //     dynamicOption.productId = '01t4x000008PcknAAC';
                    optionConfig['Dynamic Options'][index] = dynamicOption;
                    if (!salesforceId) {
                        _this.dynamicOptionsToQueryStatic.push({ item: element, dynamicOption: dynamicOption });
                    }
                    if (element.items.length) {
                        var dynOptsBuild = _this.buildOptions(payload, element, optionConfig['Dynamic Options'][index].optionConfigurations, true);
                        optionConfig['Dynamic Options'][index].optionConfigurations = dynOptsBuild.load;
                        //this.dynamicOptionsToQueryStatic.push(...dynOptsBuild.dynOptionsToQuery);
                    }
                });
            }
            else {
                item.items.forEach(function (element, index) {
                    var _a;
                    optionConfig['Other Options'][index] = {
                        ProductCode: element.sku,
                        ProductName: Object.keys({ element: element })[0],
                        optionId: element.externalId,
                        selected: true,
                        Quantity: (_a = element.qty) !== null && _a !== void 0 ? _a : 1,
                        configurationData: {},
                    };
                    _this.addColumnsAndMetadataToConfigurationObject(payload, optionConfig['Other Options'][index].configurationData, element);
                    if (element.items.length > 0) {
                        optionConfig['Other Options'][index].optionConfigurations = _this.buildOptions(payload, element, optionConfig['Other Options'][index].optionConfigurations).load;
                    }
                });
            }
            return { load: optionConfig, dynOptionsToQuery: this.dynamicOptionsToQueryStatic };
        };
        SfdcService.prototype.clearNestedOptions = function (options) {
            var _this = this;
            for (var option in options) {
                options[option].forEach(function (element) {
                    element.selected = false;
                    if (element.optionConfigurations) {
                        element.optionConfigurations = _this.clearNestedOptions(element.optionConfigurations);
                    }
                });
            }
            return options;
        };
        SfdcService.prototype.saveToSfdcCpq = function (payload, priceObject) {
            var _this = this;
            this.$rootScope.context.sfdcCanvasRequest;
            // clear out old options
            for (var feature in payload.data.product.optionConfigurations) {
                if (feature.isEqual("Dynamic Options")) {
                    payload.data.product.optionConfigurations[feature].forEach(function (option) {
                        option.Quantity = 0;
                        option.selected = false;
                    }); // clear out dynamic options
                }
                else {
                    payload.data.product.optionConfigurations[feature].forEach(function (option) {
                        return option.selected = false;
                    }); // unselect all pre-defined product options
                    // unselect all pre-defined product options
                    payload.data.product.optionConfigurations[feature].forEach(function (option) {
                        option.selected = false;
                        //delete option['optionConfigurations'];
                        //console.log(option.ProductCode, 'cleared');
                        if (option.optionConfigurations) {
                            option.optionConfigurations = _this.clearNestedOptions(option.optionConfigurations);
                        }
                        //option.Quantity = 0;
                    });
                }
            }
            if (priceObject) {
                // first we process non-dynamic product options
                // we recurse through all the price items and try to find matching product 
                // options that are not in the 'Dynamic Options' optionConfigurations object of the payload
                priceObject.items.forEach(function (item) {
                    var _a;
                    var foundInOptions = false;
                    featureLoop: for (var feature in payload.data.product.optionConfigurations) {
                        if (!feature.isEqual("Dynamic Options")) {
                            var options = payload.data.product.optionConfigurations[feature];
                            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                                var option = options_1[_i];
                                if (item.sku == option.ProductCode) {
                                    option.selected = true;
                                    option.Quantity = (_a = item.qty) !== null && _a !== void 0 ? _a : 1;
                                    foundInOptions = true;
                                    if (item.items.length > 0) {
                                        option.optionConfigurations = _this.buildOptions(payload, item, option.optionConfigurations).load;
                                    }
                                    // load configuration attributes also
                                    // we only add configuration attributes that are defined 
                                    // in the configurationAttributes section of the json
                                    option.configurationData = option.configurationData || {};
                                    _this.addColumnsAndMetadataToConfigurationObject(payload, option.configurationData, item);
                                    break featureLoop;
                                }
                            }
                        }
                    }
                    if (!foundInOptions) {
                        // if it's not found in the options, then we try to add it as a dynamic product option:  
                        // tslint:disable-next-line:max-line-length
                        // https://community.steelbrick.com/t5/Developer-Guidebook/Configurator-Integration-to-Third-Party-Web-Apps/ta-p/5575
                        var dynamicFeature = payload.data.product.optionConfigurations["Dynamic Options"];
                        // salesforceId must be defined for dynamic product options to work
                        var salesforceId = item.columns.salesforceId || item.metadata.salesforceId;
                        if (dynamicFeature) {
                            // first see if the dynamic product option is already there
                            //let dynamicOption: ISfdcCpqPayloadOption =
                            //    dynamicFeature.find(dynOpt => dynOpt.ProductCode && dynOpt.ProductCode.isEqual(item.sku));
                            //if (dynamicOption) {
                            //    dynamicOption.Quantity = item.qty;
                            //    dynamicOption.selected = true;
                            //} else {
                            var dynamicOption = {
                                productId: salesforceId,
                                Quantity: item.qty,
                                configurationData: {},
                                selected: true,
                            };
                            if (item.items.length) {
                                var dynOptsBuild = _this.buildOptions(payload, item, dynamicOption.optionConfigurations, true);
                                dynamicOption.optionConfigurations = dynOptsBuild.load;
                                //dynamicOptionsToQuery.push(...dynOptsBuild.dynOptionsToQuery);
                            }
                            dynamicFeature.push(dynamicOption);
                            // if the salesforceId wasn't provided directly,
                            // then we make a call later to get the product id using the product code
                            if (!salesforceId) {
                                _this.dynamicOptionsToQueryStatic.push({ item: item, dynamicOption: dynamicOption });
                            }
                            _this.addColumnsAndMetadataToConfigurationObject(payload, dynamicOption.configurationData, item);
                        }
                    }
                });
                // set the product level configuration attributes that correspond to price columns or price item metadata
                if (payload.data.product.configurationAttributes) {
                    for (var prop in payload.data.product.configurationAttributes) {
                        var attValue = this.getColumnOrMetaValue(prop, priceObject);
                        if (attValue != null) {
                            // priceObject corresponds to the top level product
                            payload.data.product.configurationAttributes[prop] = attValue;
                        }
                    }
                }
            }
            var dynamicOptionsQueryPromise = new _rules.KPromise(null);
            if (this.dynamicOptionsToQueryStatic.length) {
                dynamicOptionsQueryPromise = this.getProducts(this.dynamicOptionsToQueryStatic.map(function (o) { return o.item.sku; })
                    .removeNulls())
                    .then(function (products) {
                    _this.dynamicOptionsToQueryStatic.forEach(function (dynOption) {
                        var product2 = products.find(function (p) { return p.ProductCode.isEqual(dynOption.item.sku); });
                        if (!product2) {
                            // tslint:disable-next-line:max-line-length
                            var err = "Unable to add dynamic product option '".concat(dynOption.item.sku, "'.  No matching product record was found.");
                            _this.dialogService.alert({ msg: err, persist: true, type: enums.eAlertType.error });
                            throw err;
                        }
                        else {
                            dynOption.dynamicOption.productId = product2.Id;
                        }
                    });
                });
            }
            // DEBUG
            // if (Environment.isDebug) {
            // payload.data.quote["KBMAXSB__Test__c"] = "blah blah";
            // }
            // payload.data.product.optionConfigurations["DynamicFeature"].push(<any>{
            //    productId: "01t41000003vzS3",
            //    Quantity: 2,
            //    configurationData: {
            //        KBMAXSB__Test__c: "hey now",
            //        KBMAXSB__Number_Attribute__c: 444
            //    }
            // });
            // payload.data.product.optionConfigurations["DynamicFeature"].push(<any>{
            //    productId: "01t41000003vzS3",
            //    Quantity: 2,
            //    configurationData: {
            //        KBMAXSB__Test__c: "hey now",
            //        KBMAXSB__Number_Attribute__c: 444
            //    }
            // });
            dynamicOptionsQueryPromise.then(function () {
                // ensure SDK is ready and we have a canvas context before publishing
                _this.ensureReady()
                    .then(function () {
                    var ctx = _this.$rootScope.context.sfdcCanvasRequest;
                    if (ctx && window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                        Sfdc.canvas.client.publish(ctx.client, {
                            name: "sfdccpq_save",
                            payload: payload
                        });
                    }
                    else {
                        console.warn('Sfdc canvas not available for sfdccpq_save');
                    }
                })
                    .catch(function (err) { return console.warn('Sfdc not ready for sfdccpq_save', err); });
            });
        };
        /**
         * Cancel Salesforce CPQ configurator edit and return to the line item list.
         * we have to just save the orifinal payload since the sfdc package doesn't have a cancel endpoint currently.
         */
        SfdcService.prototype.cancelSfdcCpqEdit = function (payload) {
            var _this = this;
            var originalPayload = this.cloneSfdcCpqPayload(payload || this.originalSfdcCpqPayload);
            if (!originalPayload) {
                console.warn('Original SFDC CPQ payload not available for cancel');
                return;
            }
            this.ensureReady()
                .then(function () {
                var ctx = _this.$rootScope.context.sfdcCanvasRequest;
                if (ctx && window['Sfdc'] && window['Sfdc'].canvas && window['Sfdc'].canvas.client) {
                    Sfdc.canvas.client.publish(ctx.client, {
                        name: "sfdccpq_save",
                        payload: originalPayload
                    });
                }
                else {
                    console.warn('Sfdc canvas not available for sfdccpq_save (cancel path)');
                }
            })
                .catch(function (err) { return console.warn('Sfdc not ready for sfdccpq_save (cancel path)', err); });
        };
        SfdcService = __decorate([
            NgService({
                token: Token.SfdcService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Q,
                    Token.DialogService,
                ]
            })
        ], SfdcService);
        return SfdcService;
    }());

    //import {ConsoleLogger} from "@aspnet/signalR";
    //import {JsonHubProtocol} from "@aspnet/signalR";
    //import {LogLevel} from "@aspnet/signalR";
    // import * as signalR from "@aspnet/signalr-client";
    var SignalrService = /** @class */ (function () {
        function SignalrService($rootScope, $q) {
            this.$rootScope = $rootScope;
            this.$q = $q;
        }
        SignalrService.prototype.stop = function () {
            this.stopping = true;
            this.crudConnection.stop();
            this.notificationConnection.stop();
        };
        SignalrService.prototype.start = function () {
            // adapted from https://docs.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-2.1
            // Surprise, surprise, as of today (July, 2018) HubConnectionBuilder which the documentation references
            // isn't in the npm aspnet/signalr project.
            this.crudConnection = new window.signalR.HubConnectionBuilder()
                .withUrl("/crudHub", {
                serverTimeoutInMilliseconds: 100000000
            })
                .withHubProtocol(new signalR.JsonHubProtocol())
                .configureLogging(window.signalR.LogLevel.Information)
                .build();
            this.notificationConnection = new window.signalR.HubConnectionBuilder()
                .withUrl("/notificationHub", {
                serverTimeoutInMilliseconds: 100000000
            })
                .withHubProtocol(new signalR.JsonHubProtocol())
                .configureLogging(window.signalR.LogLevel.Information)
                .build();
            var promises = [this.crudConnectionPromise = this.crudConnection.start(), this.notificationConnectionPromise = this.notificationConnection.start()];
            return this.$q.when(promises);
        };
        SignalrService.prototype.notificationOn = function (eventName, callback) {
            if (this.notificationConnection)
                this.notificationConnection.on(eventName, callback);
        };
        SignalrService.prototype.notificationOff = function (eventName, callback) {
            if (this.notificationConnection)
                this.notificationConnection.off(eventName, callback);
        };
        SignalrService.prototype.notificationInvoke = function (methodName) {
            var _this = this;
            var data = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                data[_i - 1] = arguments[_i];
            }
            if (this.notificationConnectionPromise) {
                this.notificationConnectionPromise.then(function () {
                    _this.notificationConnection.invoke.apply(_this.notificationConnection, [methodName].concat(data))
                        .then(function (result) {
                        _this.$rootScope.$apply(function () {
                        });
                    });
                });
            }
        };
        SignalrService.prototype.on = function (eventName, callback) {
            if (this.crudConnection)
                this.crudConnection.on(eventName, callback);
        };
        SignalrService.prototype.off = function (eventName, callback) {
            if (this.crudConnection)
                this.crudConnection.off(eventName, callback);
        };
        SignalrService.prototype.invoke = function (methodName) {
            var _this = this;
            var data = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                data[_i - 1] = arguments[_i];
            }
            if (this.crudConnectionPromise) {
                this.crudConnectionPromise.then(function () {
                    _this.crudConnection.invoke.apply(_this.crudConnection, [methodName].concat(data))
                        .then(function (result) {
                        _this.$rootScope.$apply(function () {
                        });
                    });
                });
            }
        };
        SignalrService = __decorate([
            NgService({
                token: Token.SignalRService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Q,
                ]
            })
        ], SignalrService);
        return SignalrService;
    }());

    var StorageService = /** @class */ (function () {
        function StorageService($rootScope) {
            this.$rootScope = $rootScope;
        }
        StorageService.prototype.getFallbackImage = function () {
            return "".concat(this.$rootScope.context.publicStorageUrl, "/assets/images/cube.png");
        };
        StorageService.prototype.getAssetUrl = function (relativePath) {
            return "".concat(this.$rootScope.context.publicStorageUrl, "/assets/").concat(relativePath);
        };
        StorageService.prototype.getMediaUrl = function (relativePath) {
            if (_tools.Utils.isAbsoluteUrl(relativePath)) {
                return relativePath;
            }
            else {
                return "".concat(this.$rootScope.context.publicStorageUrl, "/media/").concat(relativePath);
            }
        };
        StorageService.prototype.getProfileImageUrl = function (relativePath) {
            if (_tools.Utils.isAbsoluteUrl(relativePath)) {
                return relativePath;
            }
            else {
                // Adding a parameter to force the model to change (otherwise the image will not auto-load)
                // The parameter is unused and only serves to bust the cache
                return "".concat(this.$rootScope.context.publicStorageUrl, "/profileimages/").concat(relativePath, "?v=").concat((new Date()).getTime().toString());
            }
        };
        /**
         * Gets the absolute url of a generic public blob file.  The relativePath given must include the container in this call (like media, mesh, etc)
         * @param relativePath
         */
        StorageService.prototype.getFileUrl = function (relativePath) {
            return "".concat(this.$rootScope.context.publicStorageUrl, "/").concat(relativePath);
        };
        StorageService = __decorate([
            NgService({
                token: Token.StorageService,
                dependencies: [
                    Token.$RootScope
                ]
            })
        ], StorageService);
        return StorageService;
    }());

    var TelemetryService = /** @class */ (function () {
        function TelemetryService($rootScope, $transitions, $location, authService) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$transitions = $transitions;
            this.$location = $location;
            this.authService = authService;
            authService.contextPromise.then(function () {
                if ($rootScope.context.appInsightsKey) {
                    var snippet = {
                        config: {
                            instrumentationKey: $rootScope.context.appInsightsKey,
                            disableAjaxTracking: true
                        }
                    };
                    var init = new Microsoft.ApplicationInsights["Initialization"](snippet);
                    _this._appInsights = init.loadAppInsights();
                    $transitions.onSuccess({}, function (transition) {
                        var state = transition.to();
                        if (state && state.name && state.url && state.name != _this.lastState && state.name != "kb.admin") {
                            var name_1 = _this.lastState = state.name;
                            if (name_1.startsWith("kb."))
                                name_1 = name_1.slice(3);
                            name_1 = name_1.replace(".base.", ".");
                            // name = name.replace(".", "/");
                            // name = "/" + name;
                            var url = [$location.protocol(), '://', $location.host(), $location.path()].join(''); //url with no query string
                            _this.trackPageView(name_1, url);
                        }
                    });
                }
            });
        }
        TelemetryService.prototype.setDefaultProperties = function (properties) {
            if (properties === void 0) { properties = null; }
            properties = properties || {};
            if (this.$rootScope.company && this.$rootScope.company.subdomain) {
                properties.Company = this.$rootScope.company.subdomain;
            }
            properties.App = "Client";
            return properties;
        };
        TelemetryService.prototype.trackPageView = function (name, url, properties) {
            if (this._appInsights) {
                this._appInsights.trackPageView(name, url, this.setDefaultProperties(properties));
            }
        };
        TelemetryService.prototype.trackEvent = function (name, properties) {
            if (this._appInsights) {
                this._appInsights.trackEvent(name, this.setDefaultProperties(properties));
            }
        };
        TelemetryService.prototype.trackException = function (exception) {
            if (this._appInsights) {
                this._appInsights.trackException(exception, null, this.setDefaultProperties());
            }
        };
        TelemetryService = __decorate([
            NgService({
                token: Token.TelemetryService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Transitions,
                    Token.$Location,
                    Token.AuthService
                ]
            })
        ], TelemetryService);
        return TelemetryService;
    }());

    var ThemeService = /** @class */ (function () {
        function ThemeService($rootScope, $http, $location, $transitions, $state) {
            var _this = this;
            this.$rootScope = $rootScope;
            this.$http = $http;
            this.$location = $location;
            this.$transitions = $transitions;
            this.$state = $state;
            this.defaultThemes = [
                {
                    id: null,
                    name: "Default",
                    skin: enums.eSkin.material,
                    background: "#f2f2f2",
                    input: "#FFFFFF",
                    header: "#025064",
                    primary: "#025064",
                    accent: "#ff8873", //#FF9800", //"#ffd54f", //"#ff9800", //"#ef6c00", //"#ff8f00", //"#E3831C",
                    warn: "#ff2102",
                    success: "#049e8a",
                    border: "#CCC",
                    dark: false,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 4
                },
                {
                    id: -1,
                    name: "Night Launch",
                    skin: enums.eSkin.material,
                    background: "#1a1a1a",
                    input: "#242424",
                    header: "#bfbfbf",
                    primary: "#424242",
                    accent: "#ffaf47",
                    warn: "#e0583a",
                    success: "#22a153",
                    border: "#575757",
                    dark: true,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -2,
                    name: "Valyrian Steel",
                    skin: enums.eSkin.material,
                    background: "#eeeeee",
                    input: "#FFFFFF",
                    header: "#535863",
                    primary: "#535863",
                    accent: "#ff5e00",
                    warn: "#e33e1c",
                    success: "#14a54a",
                    border: "#b6c2e0",
                    dark: false,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -3,
                    name: "Midnight Bananas",
                    skin: enums.eSkin.classic,
                    background: "#2b2b2b",
                    input: "#2b2b2b",
                    header: "#33702b",
                    primary: "#33702b",
                    accent: "#e7f043",
                    warn: "#e33e1c",
                    success: "#14a54a",
                    border: "#a6ffad",
                    dark: true,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -4,
                    name: "Blood Money",
                    skin: enums.eSkin.material,
                    background: "#eeeeee",
                    input: "#ffffff",
                    header: "#8c3333",
                    primary: "#8c3333",
                    accent: "#1F5454",
                    warn: "#e33e1c",
                    success: "#297029",
                    border: "#b8d6d6",
                    dark: false,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -5,
                    name: "Apple II",
                    skin: enums.eSkin.classic,
                    background: "#000000",
                    input: "#000000",
                    header: "#141414",
                    primary: "#141414",
                    accent: "#33fe33",
                    warn: "#e33e1c",
                    success: "#14a54a",
                    border: "#33fe33",
                    dark: true,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -6,
                    name: "Salesforce Lightning",
                    skin: enums.eSkin.material,
                    background: "#f7f7f7",
                    input: "#ffffff",
                    header: "#16325C",
                    primary: "#16325C",
                    accent: "#00A1E0",
                    warn: "#e33e1c",
                    success: "#14a54a",
                    border: "#d8dde6",
                    dark: false,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 2
                },
                {
                    id: -7,
                    name: "Classic",
                    skin: enums.eSkin.material,
                    background: "#f2f2f2",
                    input: "#FFFFFF",
                    header: "#084860",
                    primary: "#084860", //#607D8B", //"#7986cb", //"#0097a7", //"#304ffe", //"#0d47a1", //"#084860",
                    accent: "#E3831C", //#FF9800", //"#ffd54f", //"#ff9800", //"#ef6c00", //"#ff8f00", //"#E3831C",
                    warn: "#E33E1C",
                    success: "#14A54A",
                    border: "#CCC",
                    dark: false,
                    font: "Roboto",
                    fontSize: 15,
                    radius: 4
                },
            ];
            $location.search();
            this.loadTemplate().then(function () {
                _this.parseAndLoad(_this.getActiveTheme());
            });
            $transitions.onFinish({}, function (transition) {
                var from = transition.from().name;
                var to = transition.to().name;
                if ((to == "sceneEdit" && from != "sceneEdit") || from == "sceneEdit" && to != "sceneEdit") {
                    _this.parseAndLoad(_this.getActiveTheme());
                }
            });
        }
        ThemeService.prototype.loadTemplate = function () {
            var _this = this;
            // in debug, we get the css from the server so that it can be changed without stopping debugging
            if (this.$rootScope.clusterEnv == enums.eClusterEnv.dev) {
                return this.$http.get("kbmax-theme.css").then(function (r) {
                    return _this.themeCss = r.data;
                });
            }
            else {
                this.themeCss = this.$rootScope.context.themeCss;
                return new _rules.KPromise(this.themeCss);
            }
        };
        ThemeService.prototype.getDefaultTheme = function (id) {
            if (id === void 0) { id = null; }
            return this.defaultThemes.find(function (t) { return t.id == id; });
        };
        ThemeService.prototype.getActiveTheme = function () {
            var _a;
            var queryString = this.$location.search();
            if (queryString["idtheme"] && !this.$rootScope.context.sfdcCanvasRequest) {
                var idTheme = Number(queryString["idtheme"]);
                if (idTheme > 0) {
                    return this.$rootScope.context.theme;
                }
                else {
                    return this.getDefaultTheme(idTheme);
                }
            }
            else if (this.$rootScope.context.sfdcCanvasRequest) {
                var sfTheme = this.getDefaultTheme(-6);
                //if they have a non-default theme setup, then we use the skin from that.  This way they get the salesforce theme,
                //but with the skin they want (material or classic)
                if (this.$rootScope.companySettings.idTheme && this.$rootScope.companySettings.idTheme > 0) {
                    sfTheme.skin = this.$rootScope.context.theme.skin;
                }
                //let overrideTheme = await this.$apiService.themes.getById(1);
                //sfTheme = overrideTheme;
                if (queryString['idtheme']) {
                    return (_a = this.$rootScope.context.theme) !== null && _a !== void 0 ? _a : sfTheme;
                }
                console.log(sfTheme);
                return sfTheme;
            }
            else if ((this.$state.current && this.$state.current.name == "sceneEdit" && !this.$state.transition)
                || (this.$state.transition && (this.$state.transition.to().name == "sceneEdit"))) {
                return this.getDefaultTheme(-1);
            }
            else if (this.$rootScope.context.theme) {
                return this.$rootScope.context.theme;
            }
            else {
                return this.getDefaultTheme(this.$rootScope.companySettings.idTheme);
            }
        };
        ThemeService.prototype.getRgbString = function (theme, palette, shade, opacity, contrast, grayscale) {
            var c = new _tools.Color(theme[palette]);
            var offset = shade - 50;
            if (theme.dark)
                offset = -offset;
            var percent = Math.abs(offset / 2);
            if (offset > 0) {
                c = _tools.Color.darken(c.getOriginalInput(), percent);
            }
            else if (offset < 0) {
                c = _tools.Color.lighten(c.getOriginalInput(), percent);
            }
            if (contrast) {
                if (c.isDark()) {
                    c = new _tools.Color({ r: 250, g: 250, b: 250 });
                }
                else {
                    c = new _tools.Color({ r: 17, g: 17, b: 17 });
                }
            }
            if (grayscale) {
                var hsv = c.toHsv();
                hsv.s = 0;
                c = new _tools.Color(hsv);
            }
            c.setAlpha(opacity);
            return c.toRgbString();
        };
        ThemeService.prototype.parseTheme = function (theme) {
            var _this = this;
            theme = theme || this.getDefaultTheme();
            var hueRegex = new RegExp(
            // tslint:disable-next-line:max-line-length
            '(\'|")?{{\\s*(background|input|primary|accent|warn|success|border|header)_(color|contrast|grayscale)_?(\\d\\.?\\d*)?_?(\\d\\.?\\d*)?\\s*}}(\"|\')?', "g");
            var css = this.themeCss.replace(hueRegex, function (match, quotes, palette, cType, shade, opacity) {
                var shadeNum = shade ? Number(shade) : 50;
                var opacityNum = opacity == null ? 1 : Number(opacity) / 100;
                return _this.getRgbString(theme, palette, shadeNum, opacityNum, (cType == "contrast"), (cType == "grayscale"));
            });
            // border-radius
            css = css.replaceAll("\"{{radius}}\"", theme.radius + "px");
            css = css.replaceAll("\"{{fontSize}}\"", theme.fontSize + "px");
            // font
            if (theme.font) {
                css = css.replaceAll("{{font}}", theme.font);
            }
            if (theme.customFontUrl) {
                css = "@import url('".concat(theme.customFontUrl, "');\n") + css;
            }
            return css;
        };
        ThemeService.prototype.setThemeToHead = function (themeCss) {
            var style = document.getElementById("kbmax-theme");
            if (!style) {
                style = document.createElement("style");
                style.id = "kbmax-theme";
            }
            style.type = "text/css";
            style.innerHTML = themeCss;
            if (!style.parentElement) {
                document.head.appendChild(style);
            }
        };
        ThemeService.prototype.refreshActiveTheme = function () {
            this.parseAndLoad(this.getActiveTheme());
        };
        ThemeService.prototype.parseAndLoad = function (theme) {
            var css = this.parseTheme(theme);
            this.setThemeToHead(css);
            this.$rootScope.currentTheme = theme;
        };
        ThemeService = __decorate([
            NgService({
                token: Token.ThemeService,
                dependencies: [
                    Token.$RootScope,
                    Token.$Http,
                    Token.$Location,
                    Token.$Transitions,
                    Token.$State
                ]
            })
        ], ThemeService);
        return ThemeService;
    }());

    var UploadService = /** @class */ (function () {
        function UploadService($q, $http, $rootScope) {
            this.$q = $q;
            this.$http = $http;
            this.$rootScope = $rootScope;
            this.uploadInputHelper = angular__namespace.element('<input type="file" />');
        }
        UploadService.prototype.promptUserToChooseFile = function (accept) {
            var _this = this;
            var deferred = this.$q.defer();
            this.uploadInputHelper = angular__namespace.element('<input type="file" />');
            if (this.currentCallback)
                this.uploadInputHelper.unbind("change", this.currentCallback);
            this.uploadInputHelper.val(null); //clear the value otherwise the change event won't fire if another file is picked
            if (accept) {
                this.uploadInputHelper.attr("accept", accept);
            }
            else {
                this.uploadInputHelper.removeAttr("accept");
            }
            this.currentCallback = function (e) {
                var element = e.target;
                _this.uploadInputHelper[0].removeEventListener("change", _this.currentCallback);
                _this.currentCallback = null;
                if (!element || element.files.length == 0) {
                    deferred.reject();
                    return;
                }
                var file = element.files[0];
                file.fullPath = _this.uploadInputHelper.val();
                deferred.resolve(file);
            };
            this.uploadInputHelper[0].addEventListener("change", this.currentCallback);
            this.uploadInputHelper[0].click();
            return deferred.promise;
        };
        UploadService.prototype.promptUserToChooseFiles = function () {
            var _this = this;
            var deferred = this.$q.defer();
            this.uploadInputHelper = angular__namespace.element('<input type="file" />');
            this.uploadInputHelper.attr("multiple", "multiple");
            if (this.currentCallback)
                this.uploadInputHelper.unbind("change", this.currentCallback);
            this.uploadInputHelper.val(null); //clear the value otherwise the change event won't fire if another file is picked
            this.currentCallback = function (e) {
                _this.uploadInputHelper.removeAttr("multiple");
                var element = e.target;
                _this.uploadInputHelper.unbind("change", _this.currentCallback);
                _this.currentCallback = null;
                if (!element || element.files.length == 0) {
                    deferred.reject();
                    return;
                }
                var val = _this.uploadInputHelper.val();
                var files = [];
                for (var _i = 0, _a = element.files; _i < _a.length; _i++) {
                    var f = _a[_i];
                    f.fullPath = val;
                    files.push(f);
                }
                deferred.resolve(files);
            };
            this.uploadInputHelper.bind("change", this.currentCallback);
            this.uploadInputHelper.click();
            return deferred.promise;
        };
        UploadService.prototype.uploadAttachment = function (file, entity, url) {
            var postConfig = {
                // add this to not serialize form data
                transformRequest: angular__namespace.identity,
                // set header to undefined so the browser sets the multipart content type
                headers: { "Content-Type": undefined }
            };
            var deferred = this.$q.defer();
            var formData = new FormData();
            formData.append("file", file);
            formData.append("json", JSON.stringify(entity));
            this.$http.post(url, formData, postConfig).then(function (response) {
                // returns the filename of the new node in the upload scene
                var uploadResult = response.data;
                deferred.resolve(uploadResult);
            }, function (reason) {
                deferred.reject(reason);
            });
            return deferred.promise;
        };
        UploadService.prototype.uploadFileToMedia = function (file, dir, apiPath) {
            if (apiPath === void 0) { apiPath = "api/media"; }
            var d = this.$q.defer();
            var xhr = new XMLHttpRequest();
            var formData = new FormData();
            formData.append("file", file);
            formData.append("dir", dir);
            xhr.onreadystatechange = (function (e) {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        d.resolve();
                    }
                    else {
                        d.reject();
                    }
                }
            });
            // xhr.upload.onload = d.resolve;
            xhr.upload.onprogress = d.notify;
            // xhr.addEventListener("error", d.reject);
            xhr.addEventListener("abort", d.reject, false);
            xhr.open("POST", apiPath + "/upload", true);
            // xhr.setRequestHeader("Content-Type", "multipart/form-data");
            // xhr.setRequestHeader("x-ms-version", "2014-02-14");
            // xhr.setRequestHeader("x-ms-date",(new Date()).toISOString());
            // TODO: kbmax3dev is hardcoded. Need a way to determine the correct account to use (maybe Web.config?)
            // xhr.setRequestHeader("Authentication", "SharedKey kbmax3dev:" + signature);
            // xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
            xhr.send(formData);
            return d.promise;
        };
        UploadService.prototype.uploadProfileImage = function (file, userId) {
            var url = "/api/users/profileimage";
            var postConfig = {
                // add this to not serialize form data
                transformRequest: angular__namespace.identity,
                // set header to undefined so the browser sets the multipart content type
                headers: { "Content-Type": undefined }
            };
            var formData = new FormData();
            formData.append("userId", userId.toString());
            formData.append("file", file, file.name);
            var deferred = this.$q.defer();
            // post the file
            this.$http.put(url, formData, postConfig).then(function (response) {
                // returns the filename of the new node in the upload scene
                var uploadResult = response.data;
                deferred.resolve(uploadResult.imagePath);
            }, function (reason) {
                deferred.reject(reason);
            });
            return deferred.promise;
        };
        UploadService.prototype.importConfigurator = function (file) {
            var formData = new FormData();
            formData.append("file", file);
            return this.uploadFile(formData, "api/admin/products/import");
        };
        UploadService.prototype.uploadConfiguredProductFile = function (file, options) {
            if (options === void 0) { options = { convertPdfToImage: false }; }
            var formData = new FormData();
            formData.append("file", file);
            formData.append("convertPdfToImage", options.convertPdfToImage.toString());
            return this.uploadFile(formData, "api/quotes/filefromconfiguratorfield");
        };
        UploadService.prototype.uploadQuoteFile = function (file, options) {
            if (options === void 0) { options = { convertPdfToImage: false }; }
            var formData = new FormData();
            formData.append("file", file);
            formData.append("convertPdfToImage", options.convertPdfToImage.toString());
            return this.uploadFile(formData, "api/quotes/filefromquoteheaderfield");
        };
        UploadService.prototype.uploadFile = function (formData, url) {
            var postConfig = {
                // add this to not serialize form data
                transformRequest: angular__namespace.identity,
                // set header to undefined so the browser sets the multipart content type
                headers: { "Content-Type": undefined },
                tracker: this.$rootScope.contentTracker
            };
            var deferred = this.$q.defer();
            new XMLHttpRequest();
            this.$http.post(url, formData, postConfig).then(function (response) {
                // returns the filename of the new node in the upload scene
                var uploadResult = response.data;
                deferred.resolve(uploadResult);
            }, function (reason) {
                deferred.reject(reason);
            });
            return deferred.promise;
        };
        UploadService = __decorate([
            NgService({
                token: Token.UploadService,
                dependencies: [
                    Token.$Q,
                    Token.$Http,
                    Token.$RootScope,
                ]
            })
        ], UploadService);
        return UploadService;
    }());

    var BaseController = /** @class */ (function () {
        function BaseController() {
        }
        /**
         * a callback used by ui-router to notify us when query string parameters have been changed.
         * @param changedParams
         * @param $transition$
         */
        BaseController.prototype.uiOnParamsChanged = function (changedParams, $transition$) {
            // do something with the changed params
            // you can inspect $transition$ to see the what triggered the dynamic params change.
        };
        return BaseController;
    }());

    var CrudController = /** @class */ (function (_super) {
        __extends(CrudController, _super);
        function CrudController($scope, agg, model) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.agg = agg;
            _this.loadPromises = [];
            _this.deleteMsg = loc.msg_confirmdelete;
            _this.onSocketRelationshipEdited = function (editedId, relationshipName) {
                var callback = _this.relationshipEditedCallbacks[relationshipName];
                if (callback && editedId == _this.$stateParams.id) {
                    _this.client(_this.api).getById(editedId).then(function (r) { return callback(r); });
                }
            };
            _this.onSocketDeletedDelegate = function (editedId) {
                if (editedId == _this.$stateParams.id) {
                    _this.onSocketDeleted();
                }
            };
            _this.onSocketEditedDelegate = function (editedId) {
                if (editedId == _this.$stateParams.id) {
                    _this.onSocketEdited();
                }
            };
            _this.relationshipEditedCallbacks = {};
            agg.$rootScope.setTitle();
            _this.$http = agg.$http;
            _this.$stateParams = Object.assign({}, agg.$stateParams); //$stateParams is actually a global object that is changed before $destroy is called, so we create a clone of it so that it's static for the life of this view
            _this.$rootScope = agg.$rootScope;
            _this.$state = agg.$state;
            _this.$window = agg.$window;
            _this.dialogService = agg.dialogService;
            _this.drawerService = agg.drawerService;
            _this.$q = agg.$q;
            _this.signalrService = agg.signalrService;
            _this.api = agg.api;
            _this.$transitions = agg.$transitions;
            setTimeout(function () {
                _this.$q.all(_this.loadPromises).finally(function () {
                    _this.markChangesClean();
                });
            });
            var offTransition = _this.$transitions.onStart({}, function (transition) {
                if (_this.bypassUnsavedConfirmation)
                    return;
                // When selecting items in the adminBaseController tree, for instance, this call
                // is sometimes made, so we'll check to ensure we're actually navigating out of
                // the page.
                if (transition.from().name == transition.to().name)
                    return;
                if (!_this.modelIsClean()) {
                    var d_1 = _this.$q.defer();
                    _this.dialogService.confirm(loc.msg_confirmunsavedchanges, function () {
                        if ($scope.offTransitionCallback)
                            $scope.offTransitionCallback();
                        d_1.resolve(true);
                    }, function () {
                        d_1.resolve(false);
                    });
                    return d_1.promise;
                }
                if ($scope.offTransitionCallback)
                    $scope.offTransitionCallback();
                return true;
            });
            var onNavigateAway = function (e) {
                if (_this.bypassUnsavedConfirmation)
                    return;
                if (!_this.modelIsClean()) {
                    // If we haven't been passed the event get the window.event
                    e = e || window.event;
                    var message = loc.msg_confirmunsavedchanges;
                    // For IE6-8 and Firefox prior to version 4
                    if (e) {
                        e.returnValue = message;
                    }
                    // For Chrome, Safari, IE8+ and Opera 12+
                    return message;
                }
                return null;
            };
            window.onbeforeunload = onNavigateAway;
            var offOnLogin = _this.$rootScope.$on(_tools.events.loginSuccessful, function () {
                _this.subscribe();
            });
            $scope.$on("$destroy", function () {
                window.onbeforeunload = null;
                offTransition();
                offOnLogin();
                _this.unsubscribe();
            });
            $scope.model = model;
            $scope.validation = {};
            // set view variables to make it easy for views to bind to
            if (_this.$state.current.data) {
                $scope.isEdit = (_this.$state.current.data.viewType == enums.eViewType.edit);
                $scope.isNew = (_this.$state.current.data.viewType == enums.eViewType.new);
                $scope.isView = (_this.$state.current.data.viewType == enums.eViewType.view);
            }
            $scope.cancel = function () {
                _this.onCancel();
                _this.bypassUnsavedConfirmation = true;
                _this.$window.history.back();
                _this.unsubscribe();
            };
            $scope.delete = function () {
                return _this.delete();
            };
            $scope.save = function () {
                return _this.save().then(function () {
                    _this.markChangesClean();
                });
            };
            _this.handleResponse = function (responseData, responseStatus) {
                $scope.validation = _this.getValidationObject(responseData, responseStatus);
                if ($scope.validation) {
                    var alertMsg = $scope.validation.form || loc.msg_formerror;
                    _this.dialogService.alert({ type: enums.eAlertType.error, msg: alertMsg });
                }
                else if (responseStatus == 500) {
                    _this.dialogService.alert({ type: enums.eAlertType.error, msg: loc.msg_500error });
                }
            };
            _this.subscribe();
            return _this;
        }
        CrudController.prototype.client = function (api) { throw new Error("This method is abstract"); };
        CrudController.prototype.onSuccess = function () { throw new Error("This method is abstract"); };
        CrudController.prototype.onCancel = function () { };
        CrudController.prototype.onDelete = function () { throw new Error("crudController.onDelete is abstract"); };
        CrudController.prototype.webSocketEntityType = function () { return null; };
        CrudController.prototype.waitForRefresh = function () { return false; };
        CrudController.prototype.save = function () {
            if (this.$scope.isEdit) {
                return this.savePut();
            }
            else if (this.$scope.isNew) {
                return this.savePost();
            }
        };
        CrudController.prototype.savePut = function () {
            var _this = this;
            if (!this.isSaving) {
                this.isSaving = true;
                return this.$http.put("".concat(this.client(this.api).baseUrl, "/").concat(this.$stateParams.id, "?waitForRefresh=").concat(this.waitForRefresh()), this.getModelForSave(), { tracker: this.$rootScope.contentTracker }).then(function (r) {
                    _this.setUpdatedModel(r.data);
                    _this.onSuccess();
                    _this.$scope.$broadcast("saveSuccess", r.data);
                }, function (r) {
                    _this.handleResponse(r.data, r.status);
                })
                    .finally(function () {
                    _this.isSaving = false;
                });
            }
        };
        CrudController.prototype.savePost = function () {
            var _this = this;
            if (!this.isSaving) {
                this.isSaving = true;
                return this.$http.post("".concat(this.client(this.api).baseUrl, "?waitForRefresh=").concat(this.waitForRefresh()), this.getModelForSave(), { tracker: this.$rootScope.contentTracker }).then(function (r) {
                    _this.setUpdatedModel(r.data);
                    _this.onSuccess();
                    _this.$scope.$broadcast("saveSuccess", r.data);
                    _this.subscribe();
                }, function (r) {
                    _this.handleResponse(r.data, r.status);
                })
                    .finally(function () {
                    _this.isSaving = false;
                });
            }
        };
        CrudController.prototype.delete = function () {
            var _this = this;
            var deferred = this.$q.defer();
            var requiredPromise = this.$q.defer();
            if (this.$scope.modelType) {
                requiredPromise.promise = this.api.dependencies.isRequiredByDependency(this.$scope.modelType, [this.$scope.model["id"]], this.agg.$rootScope.contentTracker);
            }
            requiredPromise.promise.then(function (required) {
                _this.dialogService.dialog({
                    content: required ? loc.msg_deleterequiredbydependency : _this.deleteMsg,
                    buttons: [
                        new enums.DialogButton(loc.ok, _tools.icons.success, function (args) {
                            _this.unsubscribe(); //unsubscribe before we delete, otherwise we get the notification about the deletion before we've left the state
                            _this.client(_this.api).delete(_this.$stateParams.id).then(function () {
                                _this.bypassUnsavedConfirmation = true;
                                deferred.resolve();
                                _this.onDelete();
                            });
                        }),
                        new enums.DialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                            deferred.reject();
                        })
                    ]
                });
            });
            if (!this.$scope.modelType) {
                requiredPromise.resolve(false);
            }
            return deferred.promise;
        };
        CrudController.prototype.modelIsClean = function () {
            return angular__namespace.equals(this.cleanModel, angular__namespace.copy(this.getModelForSave()));
        };
        CrudController.prototype.getModelForSave = function () {
            return this.$scope.model;
        };
        CrudController.prototype.setUpdatedModel = function (model) {
            this.$scope.model = model;
        };
        CrudController.prototype.markChangesClean = function () {
            this.cleanModel = angular__namespace.copy(this.getModelForSave());
        };
        CrudController.prototype.getValidationObject = function (responseData, responseStatus) {
            var o;
            if (responseStatus == 400) {
                o = {};
                var _loop_1 = function (prop) {
                    // ignore the json type property
                    if (prop !== "$type") {
                        var newProp = prop === "" ? "form" : prop;
                        var sections_1 = newProp.split(".");
                        sections_1.forEach(function (section, key) {
                            sections_1[key] = section.toCamelCase();
                        });
                        newProp = sections_1.join(".");
                        o[newProp] = responseData[prop].join("\n");
                    }
                };
                for (var prop in responseData) {
                    _loop_1(prop);
                }
            }
            return o;
        };
        /**
         * called when the entity has been deleted.  Can be overriden for custom behavior
         * @param editedId
         */
        CrudController.prototype.onSocketDeleted = function () {
            var _this = this;
            this.dialogService.alert({
                type: enums.eAlertType.error,
                msg: "Sorry. This entity has just been deleted by another user."
            });
            setTimeout(function () { _this.onDelete(); }, 1000);
        };
        /**
         * called when the entity has been edited by another consumer.  Can be overriden for custom behavior.
         * @param editedId
         */
        CrudController.prototype.onSocketEdited = function () {
            var _this = this;
            this.client(this.api).getById(this.$stateParams.id).then(function (r) {
                _this.setUpdatedModel(r);
            });
        };
        CrudController.prototype.subscribe = function () {
            this.unsubscribe();
            var entityType = this.webSocketEntityType();
            if (!entityType || !this.$stateParams.id)
                return;
            this.signalrService.invoke("subscribe", this.$rootScope.company.uniqueName, entityType, this.$stateParams.id);
            this.signalrService.on("edited", this.onSocketEditedDelegate);
            this.signalrService.on("deleted", this.onSocketDeletedDelegate);
            this.signalrService.on("relationshipEdited", this.onSocketRelationshipEdited);
        };
        CrudController.prototype.unsubscribe = function () {
            // console.log("Unsubscribing...");
            var entityType = this.webSocketEntityType();
            if (!entityType || !this.$stateParams.id)
                return;
            this.signalrService.invoke("unsubscribe", this.$rootScope.company.uniqueName, entityType, this.$stateParams.id);
            this.signalrService.off("edited", this.onSocketEditedDelegate);
            this.signalrService.off("deleted", this.onSocketDeletedDelegate);
            this.signalrService.off("relationshipEdited", this.onSocketRelationshipEdited);
        };
        CrudController.prototype.onRelationshipEdited = function (property, callback) {
            this.relationshipEditedCallbacks[property] = callback;
        };
        CrudController = __decorate([
            NgView({
                token: Token.CrudView,
                dependencies: [
                    Token.$Scope,
                    Token.CrudService,
                    Token.Model
                ],
                resolves: [
                    {
                        name: "model",
                        dependencies: [
                            Token.$StateParams,
                            Token.AuthService,
                            Token.$RootScope,
                            Token.ApiService
                        ],
                        // tslint:disable-next-line:object-literal-shorthand
                        fn: function (// need to use "function" instead of arrow here because we use "this" to get the api client
                        $stateParams, authService, $rootScope, api) {
                            var constructor = this;
                            // would like to check the state here to get the view type, 
                            // but there is a bug that is sending the old state:  
                            // https://github.com/angular-ui/ui-router/issues/238
                            // instead we'll look for the id state parameter, which shouldn't be there for the new screens
                            if ($stateParams.id) {
                                return authService.authPromise.then(function () {
                                    return constructor.prototype.client(api).getById($stateParams.id, $rootScope.contentTracker);
                                });
                            }
                            else {
                                return authService.authPromise;
                            }
                        }
                    }
                ]
            })
        ], CrudController);
        return CrudController;
    }(BaseController));

    var ContactController = /** @class */ (function (_super) {
        __extends(ContactController, _super);
        function ContactController($scope, crudService, model) {
            var _this = _super.call(this, $scope, crudService, model) || this;
            _this.$scope = $scope;
            _this.drawerService.setHelpUrl("Contacts");
            var viewType = _this.$state.current.data.viewType;
            if ($scope.model) {
                crudService.$rootScope.setTitle($scope.model.firstName + " " + $scope.model.lastName);
                _this.deleteMsg = loc.msg_deleterecord.format(loc.contact_title, $scope.model.firstName + " " + $scope.model.lastName);
            }
            if (viewType == enums.eViewType.new) {
                crudService.$rootScope.setTitle(loc.create + " " + loc.contact_title);
                $scope.model = {
                    idCompany: _this.$rootScope.company.id,
                    shipToBillingAddress: true
                };
            }
            // customers
            _this.$http.get("/api/customers/selections").then(function (response) { return $scope.customers = response.data; });
            // add drawers
            if ($scope.isEdit || $scope.isNew) {
                _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, $scope.delete, $scope.isEdit);
                _this.drawerService.addDrawer(_tools.icons.save, loc.save, $scope.save);
                _this.drawerService.addDrawer(_tools.icons.cancel, loc.cancel, $scope.cancel);
            }
            else {
                _this.drawerService.addDrawer(_tools.icons.edit, loc.edit, function () {
                    _this.$state.go("kb.admin.contactEdit", { id: $scope.model.id });
                }, _this.$rootScope.user.canModifyCustomers);
                _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, $scope.delete, _this.$rootScope.user.canModifyCustomers);
            }
            return _this;
        }
        ContactController.prototype.client = function (api) {
            return api.contacts;
        };
        ContactController.prototype.waitForRefresh = function () {
            return true;
        };
        ContactController.prototype.onSuccess = function () {
            this.$state.go("kb.contacts");
        };
        ContactController.prototype.onDelete = function () {
            this.$state.go("kb.contacts");
        };
        ContactController = __decorate([
            NgView({
                token: Token.ContactView,
                inherit: [Token.CrudView]
            })
        ], ContactController);
        return ContactController;
    }(CrudController));

    /**
     * base class for handling search pages.
     */
    var SearchController = /** @class */ (function (_super) {
        __extends(SearchController, _super);
        function SearchController($scope, agg, bypassInit //for derived classes (like products view) that need to explicitly call init to have a chance to fill in other scope items first
        ) {
            if (bypassInit === void 0) { bypassInit = false; }
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.agg = agg;
            _this.bypassInit = bypassInit;
            _this.pageSize = document.body.clientHeight > 1130 ? 42 : 22;
            _this.epoch = null;
            _this.filledFilterSources = [];
            agg.$rootScope.setTitle();
            $scope.drawerService = agg.drawerService;
            $scope.binding = { selected: null, search: null };
            $scope.results = [];
            $scope.savedSearchEnabled = false; //disabled by default.  Derived controllers can override
            $scope.allowSearch = true;
            $scope.query = function (append) {
                if (append === void 0) { append = false; }
                var filters = []
                    .concat($scope.binding.search.enabled ? $scope.binding.search.filters : [])
                    .concat(_this.getExtraFilters());
                if (append && _this.epoch) {
                    //if we are appending to the infinite scroll, use the epoch as a filter so that we don't get duplicates
                    filters.push({
                        property: "createdDate",
                        control: enums.eFilterControl.dateRange,
                        type: enums.eFilterType.property,
                        max: _this.epoch
                    });
                }
                if (!_this.epoch) {
                    _this.epoch = new Date();
                }
                _this.postProcessFilters(filters);
                var sortInfo = _this.getSortInfo();
                var args = {
                    skip: append ? $scope.results.length : 0,
                    take: _this.pageSize,
                    fields: _this.fields(),
                    query: $scope.binding.search.query,
                    sortField: sortInfo.sortField,
                    descending: sortInfo.descending,
                    filters: filters,
                    nestedPath: _this.getNestedPath(),
                    nestedFields: _this.nestedFields()
                };
                var tracker = append ? agg.$rootScope.infiniteScrollTracker : agg.$rootScope.contentTracker;
                return _this.searchCall(args, tracker).then(function (r) {
                    _this.massageResults(r);
                    append ? $scope.results.pushArray(r) : $scope.results = r;
                    return r;
                });
            };
            $scope.suggestValueField = "name";
            $scope.suggest = function (query) {
                if (query) {
                    return _this.client(agg.api).suggest({ query: query, fields: [$scope.suggestValueField] });
                }
            };
            $scope.addFilter = function (f) {
                var newFilter = JSON.parse(JSON.stringify(f));
                $scope.binding.search.filters.push(newFilter);
                _this.fillFilters();
            };
            $scope.removeFilter = function (f) {
                $scope.binding.search.filters.remove(f);
                // $scope.availableFilters.push(f);
                f.values = (f.control == enums.eFilterControl.multiSelect ? [] : [null]);
                $scope.reload();
            };
            $scope.toggleFilters = function () {
                $scope.binding.search.enabled = !$scope.binding.search.enabled;
                $scope.reload();
            };
            $scope.sort = function (sortColumn) {
                if (sortColumn.sortable) {
                    $scope.columns.forEach(function (col) {
                        if (col.field != sortColumn.field) {
                            col.sorted = false;
                            col.descending = false;
                        }
                        else {
                            if (!col.sorted) {
                                col.sorted = true;
                                col.descending = false;
                            }
                            else {
                                if (col.descending) {
                                    col.sorted = false;
                                    col.descending = false;
                                }
                                else {
                                    col.sorted = true;
                                    col.descending = true;
                                }
                            }
                            if (col.sorted) {
                                $scope.binding.search.sortField = col.field;
                                $scope.binding.search.descending = col.descending;
                            }
                            else {
                                $scope.binding.search.sortField = null;
                                $scope.binding.search.descending = false;
                            }
                        }
                    });
                    lastLength = 0;
                    lastRetrieved = 0;
                    $scope.reload();
                }
            };
            $scope.modelTypeChange = function (modelType) {
                agg.$state.go(modelType.state);
            };
            var lastLength = 0;
            var lastRetrieved = -1;
            $scope.infiniteScroll = function () {
                // if the list doesn't have at least the page size of items, it means there's no more
                // available, so no need to do another page
                var count = $scope.results.length;
                lastRetrieved = count == 0 ? -1 : count - lastLength;
                var noMore = count > 0 && (count % _this.pageSize != 0);
                if (!noMore && (lastRetrieved < 0 || lastRetrieved == _this.pageSize)) {
                    lastLength = count;
                    return $scope.query(true);
                }
            };
            $scope.reload = function (force) {
                if (force === void 0) { force = false; }
                var search = _this.$scope.binding.search;
                var params = _this.getQueryStringParams() || {};
                if (search.enabled) {
                    params = Object.assign(params, { search: agg.base64Service.encode(JSON.stringify(search)) });
                }
                else {
                    //create a search without filters
                    var basicSearch = __assign(__assign({}, search), { filters: [] });
                    params = Object.assign(params, { search: agg.base64Service.encode(JSON.stringify(basicSearch)) });
                }
                var options = {};
                if (force)
                    options.reload = true;
                _this.epoch = null;
                agg.$state.go(agg.$state.current.name, params, options);
            };
            // set all filter sources to an empty array so we have a reference to bind to
            $scope.filterSource = {};
            for (var p in enums.eFilterSource)
                $scope.filterSource[p] = [];
            _this.filterSourceInfo = {};
            for (var e in enums.eFilterSource)
                _this.filterSourceInfo[e] = { valueField: "id", labelField: "name" };
            _this.filterSourceInfo[enums.eFilterSource.states] = { valueField: "value", labelField: "label" };
            _this.filterSourceInfo[enums.eFilterSource.roles] = { valueField: "id", labelField: "role" };
            _this.filterSourceInfo[enums.eFilterSource.manufacturers] = { valueField: null, labelField: null };
            _this.filterSourceInfo[enums.eFilterSource.enum] = { valueField: "value", labelField: "name" };
            $scope.editSearch = function (search) {
                _this.saveSearchDialog(search);
            };
            $scope.deleteSearch = function (s) {
                return agg.api.savedSearches.delete(s.id)
                    .then(function () { return $scope.savedSearches.removeWhere(function (search) { return search.id == s.id; }); });
            };
            $scope.canDeleteSearch = function (s) {
                return _this.agg.$rootScope.user.isCompanyAdmin ||
                    _this.agg.$rootScope.user.isAdmin ||
                    s.createdBy == _this.agg.$rootScope.user.id;
            };
            $scope.$watch("binding.selected", function (newVal, oldVal) {
                if (newVal != oldVal) {
                    $scope.binding.search = $scope.binding.selected;
                    //filters need to be re-filled because they are missing $key in saved searches
                    _this.fillFilters();
                    $scope.reload();
                }
            });
            if (!bypassInit) {
                _this.init();
            }
            return _this;
        }
        /** derived classes must call init.  This gives derives classes a chance to fill in scope, etc before things are processed */
        SearchController.prototype.init = function () {
            /**
            * could be called in the following ways:
            *      -no query string:  create a new savedSearch and fill it with defaults
            *      -#search=[base64 encoded json string of the search]
            *      -#searchId=[the id of the saved search] :  call the server with the saved search id
            */
            if (this.agg.$state.params.search) {
                this.$scope.binding.search = JSON.parse(this.agg.base64Service.decode(this.agg.$state.params.search));
                this.loadedFromQueryString(this.$scope.binding.search);
            }
            else {
                this.$scope.binding.search = this.newSearch();
            }
            this.$scope.availableFilters = this.getFiltersFromMeta(this.$scope.binding.search.modelType);
            this.$scope.availableFilters.sortBy(function (f) { return f.label; });
            this.fillFilters();
            this.refreshSavedSearches();
        };
        SearchController.prototype.client = function (api) {
            throw new Error("client() is abstract");
        };
        /**can be overridden to customize the actual call to search api */
        SearchController.prototype.searchCall = function (args, tracker) {
            return this.client(this.agg.api).search(args, tracker);
        };
        /**can be overriden to catch when we have just loaded a search via the query string */
        SearchController.prototype.loadedFromQueryString = function (search) {
        };
        /**can be overriden by derived class to provide extra query string params */
        SearchController.prototype.getQueryStringParams = function () {
            return {};
        };
        /**
         * the properties of the queried object that should be returned.
         */
        SearchController.prototype.fields = function () {
            return this.getFieldsFromMeta(this.$scope.binding.search.modelType);
        };
        /**
         * a new fresh search.  Can be overriden by the derived controller
         */
        SearchController.prototype.newSearch = function () {
            return {
                filters: [],
                roles: []
            };
        };
        /** can be overridden by derived class to massage the results before showing them on the screen */
        SearchController.prototype.massageResults = function (items) {
        };
        /**
         * can be overridden by derived controllers to add a raw filter to the search
         */
        SearchController.prototype.getExtraFilters = function () {
            return [];
        };
        /**
         * can be overriden by derived controllers to give an extra flag about what we're
         * searching (like configured products needs to be set to "products" so that the
         * search repo knows what we're doing)
         */
        SearchController.prototype.getNestedPath = function () {
            return null;
        };
        /**
         * can be overriden by derived controllers to give relative paths to the properties
         * of the object described in the nestedPath
         */
        SearchController.prototype.nestedFields = function () {
            return [];
        };
        SearchController.prototype.postProcessFilters = function (filters) {
            var _this = this;
            filters.forEach(function (f) {
                if (f.type == enums.eFilterType.attribute) {
                    var productsScope = _this.$scope;
                    if (productsScope.attributeDb) {
                        var att = productsScope.attributeDb[f.attributeId];
                        if (att) {
                            if (att.type == enums.eAttributeType.number && att.useRangeBuckets) {
                                if (f.values && f.values.length && f.values[0] != null) {
                                    f.min = f.values[0]["from"];
                                    f.max = f.values[0]["to"];
                                }
                            }
                        }
                    }
                }
            });
        };
        SearchController.prototype.getSortInfo = function () {
            var ret = { sortField: this.$scope.binding.search.sortField, descending: this.$scope.binding.search.descending };
            //calculate sort
            var s = this.$scope.binding.search;
            if (s.enabled) {
                var sortFilter = s.filters.find(function (f) { return f.type == enums.eFilterType.sort; });
                if (sortFilter && sortFilter.values != null && sortFilter.values.length > 0 && sortFilter.values[0]) {
                    if (sortFilter.sourceType == enums.eFilterSource.productSorts) {
                        var v = sortFilter.values[0];
                        if (v.equalsAny(enums.eProductSortBy.relevance, enums.eProductSortBy.popularity)) {
                            ret.sortField = "score";
                            ret.descending = true;
                        }
                        else if (v == enums.eProductSortBy.priceLowToHigh) {
                            ret.sortField = "price";
                            ret.descending = false;
                        }
                        else if (v == enums.eProductSortBy.priceHighToLow) {
                            ret.sortField = "price";
                            ret.descending = true;
                        }
                        else if (v == enums.eProductSortBy.nameAtoZ) {
                            ret.sortField = "name";
                            ret.descending = false;
                        }
                    }
                }
            }
            return ret;
        };
        SearchController.prototype.getFieldsFromMeta = function (modelType) {
            var m = enums.meta[modelType];
            var fields = [];
            var _loop_1 = function (prop) {
                if (prop[0] != "$") {
                    var info_1 = m[prop];
                    if (info_1.type.endsWith("[]")) {
                        // we look at the array type and get it's meta props
                        var subFields = this_1.getFieldsFromMeta(info_1.type.substr(0, info_1.type.length - 2));
                        subFields.forEach(function (sf) { return fields.push(info_1.name + "." + sf); });
                    }
                    else {
                        fields.push(info_1.name);
                    }
                }
            };
            var this_1 = this;
            for (var prop in m) {
                _loop_1(prop);
            }
            return fields;
        };
        SearchController.prototype.getFiltersFromMeta = function (modelType, onlyDefaults) {
            var _this = this;
            var m = enums.meta[modelType];
            var filters = [];
            for (var prop in m) {
                if (prop[0] != "$") {
                    var info = m[prop];
                    if (!info.permissions ||
                        !info.permissions.length ||
                        info.permissions.every(function (p) { return _this.agg.$rootScope.user["can" + p.toPascalCase()]; })) { // check if the current user has permissions to see this filter
                        if (!info.type.endsWith("[]") &&
                            info.control != enums.eFilterControl.none &&
                            (info.default || !onlyDefaults)) {
                            filters.push({
                                label: loc["generic_" + info.name.toLowerCase() + "_title"] ||
                                    loc[m.$name.toLowerCase() + "_" + info.name.toLowerCase() + "_title"] ||
                                    info.name.toPascalCase(),
                                type: enums.eFilterType.property,
                                property: info.name,
                                sourceType: info.source,
                                enumType: info.enumType,
                                control: info.control,
                                valueField: this.filterSourceInfo[info.source].valueField,
                                labelField: this.filterSourceInfo[info.source].labelField,
                                headerField: this.filterSourceInfo[info.source].labelField,
                                values: (info.control == enums.eFilterControl.multiSelect ? [] : [null]),
                                sticky: info.sticky
                            });
                        }
                    }
                }
            }
            return filters;
        };
        SearchController.prototype.getFilterKey = function (f) {
            var key = f.sourceType;
            if (f.attributeId) {
                var productsScope = this.$scope;
                key = f.sourceType + "_" + f.attributeId + "_" + productsScope.binding.selectedCategory.id;
            }
            else if (f.sourceType == enums.eFilterSource.enum) {
                key = f.sourceType + "_" + f.enumType;
            }
            return key;
        };
        SearchController.prototype.fillFilters = function () {
            var _this = this;
            this.$scope.binding.search.filters.forEach(function (f) {
                var key = _this.getFilterKey(f);
                f["$key"] = key;
                if (!_this.filledFilterSources.some(function (s) { return s.isEqual(key); })) {
                    _this.filledFilterSources.push(key);
                    if (f.sourceType == enums.eFilterSource.enum) {
                        _this.$scope.filterSource[key] = _this.agg.$filter("enum")(f.enumType, false);
                        if (f.enumType == "eJobStatus") { // job status is stored as an int in the database
                            var i = 0;
                            for (var _i = 0, _a = _this.$scope.filterSource[key]; _i < _a.length; _i++) {
                                var v = _a[_i];
                                v.value = i;
                                i++;
                            }
                        }
                    }
                    else if (f.sourceType == enums.eFilterSource.users) {
                        _this.agg.api.users.search({
                            fields: ["id", "firstName", "lastName", "name"], sortField: "firstName"
                        }).then(function (users) { return _this.$scope.filterSource[key] = users; });
                    }
                    else if (f.sourceType == enums.eFilterSource.states) {
                        _this.agg.api.workflows.states()
                            .then(function (r) { return _this.$scope.filterSource[key] = __spreadArray([
                            { value: null, label: loc.unsubmitted }
                        ], r, true); });
                    }
                    else if (f.sourceType == enums.eFilterSource.properties) {
                        _this.$scope.filterSource[key] = Object.keys(enums.meta[_this.$scope.binding.search.modelType + "Meta"]);
                    }
                    else if (f.sourceType == enums.eFilterSource.customers) {
                        _this.$scope.filterSource[key] = _this.agg.api.customers
                            .search({ fields: ["id", "name"] })
                            .then(function (customers) { return _this.$scope.filterSource[key] = __spreadArray([
                            { id: null, name: loc.none.capitalize() }
                        ], customers, true); });
                    }
                    else if (f.sourceType == enums.eFilterSource.configurators) {
                        // only get the products this user has the rights to see
                        _this.$scope.filterSource[key] = _this.agg.api.products
                            .searchByCategory({
                            sortField: "name",
                            fields: ["id", "name"],
                            descending: false,
                            filters: [ProductClient.getIsConfiguredFilter(true)],
                            take: 500
                        })
                            .then(function (configs) { return _this.$scope.filterSource[key] = __spreadArray([
                            {
                                id: null,
                                name: loc.any
                            }
                        ], configs, true); });
                    }
                    else if (f.sourceType == enums.eFilterSource.roles) {
                        _this.$scope.filterSource[key] = _this.agg.api.roles
                            .search({ fields: ["id", "role"] })
                            .then(function (roles) { return _this.$scope.filterSource[key] = roles; });
                    }
                    else if (f.sourceType == enums.eFilterSource.manufacturers) {
                        _this.$scope.filterSource[key] = _this.agg.api.products.uniqueValues({ property: enums.meta.Product.manufacturer.name })
                            .then(function (manufacturers) { return _this.$scope.filterSource[key] = manufacturers; });
                    }
                    else if (f.sourceType == enums.eFilterSource.suggestQuotes) {
                        _this.$scope.filterSource[key] = function (q) { return _this.agg.api.quotes.suggest({ query: q, fields: ["name"] }); };
                    }
                    else if (f.sourceType == enums.eFilterSource.suggestContacts) {
                        _this.$scope.filterSource[key] = function (q) { return _this.agg.api.contacts.suggest({ query: q, fields: ["name"] }); };
                    }
                    else if (f.sourceType == enums.eFilterSource.suggestCustomers) {
                        _this.$scope.filterSource[key] = function (q) { return _this.agg.api.customers.suggest({ query: q, fields: ["name"] }); };
                    }
                    else if (f.sourceType == enums.eFilterSource.suggestProducts) {
                        _this.$scope.filterSource[key] = function (q) { return _this.agg.api.products.suggest({ query: q, fields: ["name"] }); };
                    }
                    else if (f.sourceType == enums.eFilterSource.productSorts) {
                        _this.$scope.filterSource[key] = [
                            {
                                value: enums.eProductSortBy.relevance,
                                label: loc.eproductsortby_relevance_title
                            }, {
                                value: enums.eProductSortBy.priceLowToHigh,
                                label: loc.eproductsortby_pricelowtohigh_title
                            }, {
                                value: enums.eProductSortBy.priceHighToLow,
                                label: loc.eproductsortby_pricehightolow_title
                            }, {
                                value: enums.eProductSortBy.popularity,
                                label: loc.eproductsortby_popularity_title
                            }, {
                                value: enums.eProductSortBy.nameAtoZ,
                                label: loc.eproductsortby_nameatoz_title
                            }
                        ];
                    }
                    else if (f.sourceType == enums.eFilterSource.attributes) {
                        var productsScope = _this.$scope;
                        var categoryIds = [];
                        if (productsScope.binding.selectedCategory.id >= 0) {
                            categoryIds = productsScope.getChildCategories(productsScope.binding.selectedCategory);
                        }
                        _this.$scope.filterSource[key] = [];
                        if (productsScope.attributeDb) {
                            var att_1 = productsScope.attributeDb[f.attributeId];
                            if (att_1.type == enums.eAttributeType.number && att_1.useRangeBuckets) {
                                _this.agg.api.products.attributeRanges({ id: att_1.id, ranges: att_1.ranges, categoryIds: categoryIds })
                                    .then(function (buckets) {
                                    var _a;
                                    buckets.removeWhere(function (b) { return b.count <= 0; });
                                    var options = [];
                                    buckets.forEach(function (b) {
                                        var label = '';
                                        if (b.from == null)
                                            label += "< ";
                                        if (b.to == null)
                                            label += "> ";
                                        if (b.from != null)
                                            label += b.from.toString();
                                        if (b.from != null && b.to != null)
                                            label += " - ";
                                        if (b.to != null)
                                            label += b.to.toString();
                                        options.push({ value: b, label: label });
                                    });
                                    (_a = _this.$scope.filterSource[key]).push.apply(_a, options);
                                });
                            }
                            else {
                                _this.agg.api.products.uniqueAttributeValues({ id: att_1.id, type: att_1.type, categoryIds: categoryIds })
                                    .then(function (vals) {
                                    var _a;
                                    (_a = _this.$scope.filterSource[key]).push.apply(_a, vals);
                                    //if we are confined to a list, merge with the category attribute options so we can get the images
                                    if (att_1.confineToList) {
                                        var _loop_2 = function (v) {
                                            var o = att_1.options.find(function (n) { return n.value == v.value; });
                                            if (o) {
                                                v["image"] = o.image;
                                            }
                                        };
                                        for (var _i = 0, vals_1 = vals; _i < vals_1.length; _i++) {
                                            var v = vals_1[_i];
                                            _loop_2(v);
                                        }
                                    }
                                });
                                // if (att.confineToList) {
                                //     this.$scope.filterSource[key].push(...att.options);
                                // } else {
                                //     this.agg.api.products.uniqueAttributeValues({ id: att.id, type: att.type })
                                //         .then(vals => this.$scope.filterSource[key].push(...vals));
                                // }
                            }
                        }
                    }
                    else if (f.sourceType == enums.eFilterSource.headerFields) {
                        _this.agg.api.quoteHeaders.searchFields().then(function (r) {
                            _this.$scope.filterSource[key] = r;
                        });
                    }
                }
            });
        };
        SearchController.prototype.uiOnParamsChanged = function (changedParams, $transition$) {
            if ($transition$.options().source == "url") {
                if (changedParams.search) {
                    this.$scope.binding.search = JSON.parse(this.agg.base64Service.decode(changedParams.search));
                }
                else {
                    this.$scope.binding.search = this.newSearch();
                }
                this.fillSorts(this.$scope.binding.search.sortField, this.$scope.binding.search.descending);
            }
            this.$scope.query(false);
        };
        /** can be overriden to handle what happens after items are deleted */
        SearchController.prototype.onItemsDeleted = function (items) {
        };
        SearchController.prototype.deleteItems = function () {
            var _this = this;
            var selected = this.$scope.results.filter(function (i) { return i.$selected; });
            if (selected.length > 0) {
                var requiredPromise = this.agg.$q.defer();
                if (this.$scope.modelType) {
                    var ids = selected.map(function (m) { return m["id"]; });
                    requiredPromise.promise = this.agg.api.dependencies.isRequiredByDependency(this.$scope.modelType, ids, this.agg.$rootScope.contentTracker);
                }
                requiredPromise.promise.then(function (required) {
                    _this.agg.dialogService.dialog({
                        content: required ? loc.msg_deleterequiredbydependency : loc.msg_confirmdelete,
                        buttons: [
                            new enums.DialogButton(loc.ok, _tools.icons.success, function (args) {
                                var tracker = _this.agg.$rootScope.contentTracker;
                                var promises = [];
                                selected.forEach(function (item) {
                                    var promise = _this.client(_this.agg.api).delete(item.id, null, true);
                                    tracker.addPromise(promise);
                                    promises.push(promise);
                                });
                                _this.agg.$q.all(promises).then(function () {
                                    _this.onItemsDeleted(selected);
                                }).finally(function () {
                                    _this.$scope.reload(true);
                                });
                            }),
                            new enums.DialogButton(loc.cancel, _tools.icons.cancel, function (args) { })
                        ]
                    });
                });
                if (!this.$scope.modelType) {
                    requiredPromise.resolve(false);
                }
            }
        };
        SearchController.prototype.clone = function () {
            var _this = this;
            var selected = this.$scope.results.filter(function (i) { return i.$selected; });
            var promises = [];
            selected.forEach(function (item) {
                var promise = _this.client(_this.agg.api).clone(item.id);
                _this.agg.$rootScope.contentTracker.addPromise(promise);
                promises.push(promise);
            });
            this.agg.$q.all(promises).then(function () { return _this.$scope.reload(true); });
        };
        SearchController.prototype.refreshSavedSearches = function () {
            var _this = this;
            if (this.$scope.savedSearchEnabled) {
                return this.agg.api.savedSearches.mySearches(this.$scope.binding.search.modelType).then(function (r) { return _this.$scope.savedSearches = r; });
            }
        };
        SearchController.prototype.saveSearchDialog = function (search) {
            var _this = this;
            search = search || this.$scope.binding.search;
            var dscope = this.agg.$rootScope.$new();
            if (this.agg.$rootScope.user.isCompanyAdmin || this.agg.$rootScope.user.isAdmin) {
                this.agg.api.roles.search({ take: 1000, sortField: "role" }).then(function (r) { return dscope.roles = r; });
            }
            dscope.model = { name: "New Search", roles: search.roles || [] };
            this.agg.dialogService.dialog({
                template: Dirs.view("dialog-save-search"),
                scope: dscope,
                buttons: [
                    new enums.DialogButton(loc.ok, _tools.icons.success, function (args) {
                        // validate there is a name
                        if (!dscope.model.name) {
                            dscope.validation.name = "Name is required";
                            args.close = false;
                            return;
                        }
                        var newSearch = Object.assign({}, search); // create a new search
                        newSearch.id = null; // clear out the id so it's treated as an insert
                        newSearch.name = dscope.model.name;
                        newSearch.roles = dscope.model.roles;
                        _this.agg.api.savedSearches.insert(newSearch, _this.agg.$rootScope.contentTracker).then(function (r) {
                            _this.refreshSavedSearches().then(function () {
                                _this.$scope.binding.selected = _this.$scope.savedSearches.find(function (ss) { return ss.id == r.id; });
                            });
                        });
                    }),
                    new enums.DialogButton(loc.close, _tools.icons.cancel, function (args) { })
                ]
            });
        };
        SearchController.prototype.fillSorts = function (sortColumnName, descending) {
            for (var _i = 0, _a = this.$scope.columns; _i < _a.length; _i++) {
                var col = _a[_i];
                if (!sortColumnName || col.field != sortColumnName) {
                    col.sorted = false;
                    col.descending = false;
                }
                else {
                    col.sorted = true;
                    col.descending = descending;
                }
            }
        };
        SearchController = __decorate([
            NgView({
                token: Token.SearchView,
                dependencies: [
                    Token.$Scope,
                    Token.SearchService
                ]
            })
        ], SearchController);
        return SearchController;
    }(BaseController));

    var ContactsController = /** @class */ (function (_super) {
        __extends(ContactsController, _super);
        function ContactsController($scope, agg) {
            var _this = _super.call(this, $scope, agg) || this;
            agg.$rootScope.setTitle(loc.contacts);
            agg.drawerService.pageTitle = loc.contacts;
            agg.drawerService.pageIcon = _tools.icons.user;
            agg.drawerService.setHelpUrl("Contacts");
            if (agg.$rootScope.user.canModifyCustomers) {
                agg.drawerService.addDrawer(_tools.icons.add, loc.add, function () { return agg.$state.go("kb.contactNew"); });
                agg.drawerService.addDrawer(_tools.icons.clone, loc.clone, function () { return _this.clone(); });
                agg.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, function () { return _this.deleteItems(); });
            }
            return _this;
        }
        ContactsController.prototype.client = function (api) {
            return api.contacts;
        };
        ContactsController.prototype.newSearch = function () {
            return {
                modelType: enums.meta.Contact.$name,
                sortField: "FirstName",
                descending: false,
                filters: this.getFiltersFromMeta(enums.meta.Contact.$name, true),
                roles: []
            };
        };
        ContactsController = __decorate([
            NgView({
                token: Token.ContactsView,
                inherit: [Token.SearchView]
            })
        ], ContactsController);
        return ContactsController;
    }(SearchController));

    var CustomerController = /** @class */ (function (_super) {
        __extends(CustomerController, _super);
        function CustomerController($scope, crudService, model) {
            var _this = _super.call(this, $scope, crudService, model) || this;
            _this.$scope = $scope;
            _this.drawerService.setHelpUrl("Customers");
            var viewType = _this.$state.current.data.viewType;
            if ($scope.model) {
                crudService.$rootScope.setTitle($scope.model.name);
                _this.deleteMsg = loc.msg_deleterecord.format(loc.customer_title, $scope.model.name);
            }
            if (viewType == enums.eViewType.new) {
                crudService.$rootScope.setTitle(loc.create + " " + loc.customer_title);
                $scope.model = {
                    idCompany: _this.$rootScope.company.id,
                    name: "New Customer",
                    shipToBillingAddress: true,
                    type: loc.customer_type_direct
                };
            }
            // customerTypes
            _this.$http.get("/api/customers/types").then(function (response) {
                $scope.customerTypes = response.data;
            });
            // add drawers
            if ($scope.isEdit || $scope.isNew) {
                _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, $scope.delete, $scope.isEdit);
                _this.drawerService.addDrawer(_tools.icons.save, loc.save, $scope.save);
                _this.drawerService.addDrawer(_tools.icons.cancel, loc.cancel, $scope.cancel);
            }
            else {
                _this.drawerService.addDrawer(_tools.icons.edit, loc.edit, function () {
                    _this.$state.go("kb.admin.customerEdit", { id: $scope.model.id });
                }, _this.$rootScope.user.canModifyCustomers);
                _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, $scope.delete, _this.$rootScope.user.canModifyCustomers);
            }
            return _this;
        }
        CustomerController.prototype.client = function (api) {
            return api.customers;
        };
        CustomerController.prototype.waitForRefresh = function () {
            return true;
        };
        CustomerController.prototype.onSuccess = function () {
            this.$state.go("kb.customers");
        };
        CustomerController.prototype.onDelete = function () {
            this.$state.go("kb.customers");
        };
        CustomerController = __decorate([
            NgView({
                token: Token.CustomerView,
                inherit: [Token.CrudView]
            })
        ], CustomerController);
        return CustomerController;
    }(CrudController));

    var CustomersController = /** @class */ (function (_super) {
        __extends(CustomersController, _super);
        function CustomersController($scope, agg) {
            var _this = _super.call(this, $scope, agg) || this;
            agg.$rootScope.setTitle(loc.customers);
            agg.drawerService.pageTitle = loc.customers;
            agg.drawerService.pageIcon = _tools.icons.users;
            agg.drawerService.setHelpUrl("Customers");
            if (agg.$rootScope.user.canModifyCustomers) {
                agg.drawerService.addDrawer(_tools.icons.add, loc.add, function () { return agg.$state.go("kb.customerNew"); });
                agg.drawerService.addDrawer(_tools.icons.clone, loc.clone, function () { return _this.clone(); });
                agg.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, function () { return _this.deleteItems(); });
            }
            $scope.fixUrl = function (url) {
                if (url && !url.startsWith("http"))
                    url = "http://" + url;
                return url;
            };
            return _this;
        }
        CustomersController.prototype.client = function (api) {
            return api.customers;
        };
        CustomersController.prototype.newSearch = function () {
            return {
                modelType: enums.meta.Customer.$name,
                sortField: "name",
                descending: false,
                filters: this.getFiltersFromMeta(enums.meta.Customer.$name, true),
                roles: []
            };
        };
        CustomersController = __decorate([
            NgView({
                token: Token.CustomersView,
                inherit: [Token.SearchView]
            })
        ], CustomersController);
        return CustomersController;
    }(SearchController));

    var DialogController = /** @class */ (function (_super) {
        __extends(DialogController, _super);
        function DialogController($scope, dialogService) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.dialogService = dialogService;
            $scope.model = {
                alerts: dialogService.alerts,
                dialogs: dialogService.dialogs
            };
            $scope.closeAlert = function (index) {
                dialogService.closeAlert(index);
            };
            return _this;
        }
        DialogController = __decorate([
            NgView({
                token: Token.DialogView,
                dependencies: [
                    Token.$Scope,
                    Token.DialogService,
                ]
            })
        ], DialogController);
        return DialogController;
    }(BaseController));

    var NotificationsController = /** @class */ (function (_super) {
        __extends(NotificationsController, _super);
        function NotificationsController($scope, agg) {
            var _this = _super.call(this, $scope, agg) || this;
            agg.$rootScope.setTitle(loc.notifications);
            $scope.allowSearch = false;
            agg.drawerService.pageTitle = loc.notifications;
            agg.drawerService.pageIcon = _tools.icons.email;
            agg.drawerService.setHelpUrl("Notifications");
            return _this;
        }
        NotificationsController.prototype.client = function (api) {
            return api.notifications;
        };
        NotificationsController.prototype.newSearch = function () {
            return {
                modelType: enums.meta.Notification.$name,
                sortField: "createdDate",
                descending: true,
                filters: this.getFiltersFromMeta(enums.meta.Notification.$name, true),
                roles: []
            };
        };
        NotificationsController = __decorate([
            NgView({
                token: Token.NotificationsView,
                inherit: [Token.SearchView]
            })
        ], NotificationsController);
        return NotificationsController;
    }(SearchController));

    var DrawerController = /** @class */ (function (_super) {
        __extends(DrawerController, _super);
        function DrawerController($scope, drawerService, $timeout) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.drawerService = drawerService;
            $scope.drawerService = drawerService;
            // routine for resizing drawer buttons if there are too many
            var resizeDrawer = _tools.Utils.throttle(function () {
                var $drawerButtons = jQuery(".kb-drawer__buttons");
                var totalWidth;
                $drawerButtons.find(".kb-drawer__button").each(function (i, e) {
                    totalWidth += jQuery(e).outerWidth();
                });
                $drawerButtons.toggleClass("is-icons-only", totalWidth > $drawerButtons.innerWidth());
            }, 100);
            $scope.$watchCollection("drawerService.drawers", function () {
                resizeDrawer();
            });
            $scope.$watch("drawerService.visible", function (newValue, oldValue) {
                var _a, _b, _c, _d;
                if (newValue != oldValue) {
                    // Scope to Angular's bootstrap element only. The global
                    // $(".kb-content") selector was also matching Vue's
                    // .kb-content when AngularHost is active, mutating its
                    // classes via jQuery outside Vue's knowledge. Since Vue
                    // doesn't re-render the class after the external mutation,
                    // the stale kb-content--no-drawer class persisted after
                    // AngularHost unmounted, pushing the drawer off-screen.
                    var root = (_d = (_c = (_b = (_a = window.__kbAngularHost) === null || _a === void 0 ? void 0 : _a.injector) === null || _b === void 0 ? void 0 : _b.get('$rootElement')) === null || _c === void 0 ? void 0 : _c[0]) !== null && _d !== void 0 ? _d : document;
                    $(root).find(".kb-content").toggleClass("kb-content--no-drawer", !newValue);
                }
            });
            // track the window size
            jQuery(window).resize(function () {
                resizeDrawer();
            });
            return _this;
        }
        DrawerController = __decorate([
            NgView({
                token: Token.DrawerView,
                dependencies: [
                    Token.$Scope,
                    Token.DrawerService,
                    Token.$Timeout,
                ]
            })
        ], DrawerController);
        return DrawerController;
    }(BaseController));

    exports.eLoginMode = void 0;
    (function (eLoginMode) {
        eLoginMode[eLoginMode["login"] = 0] = "login";
        eLoginMode[eLoginMode["register"] = 1] = "register";
        eLoginMode[eLoginMode["thanks"] = 2] = "thanks";
        eLoginMode[eLoginMode["forgotPassword"] = 3] = "forgotPassword";
        eLoginMode[eLoginMode["forgotPasswordSubmitted"] = 4] = "forgotPasswordSubmitted";
    })(exports.eLoginMode || (exports.eLoginMode = {}));
    var LoginController = /** @class */ (function (_super) {
        __extends(LoginController, _super);
        function LoginController($scope, $http, authService, $rootScope, $timeout, $window, $location) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$http = $http;
            _this.authService = authService;
            _this.$rootScope = $rootScope;
            _this.$timeout = $timeout;
            _this.$window = $window;
            _this.$location = $location;
            $rootScope.setTitle(loc.login);
            $scope.mode = exports.eLoginMode.login;
            $scope.loginModel = {};
            $scope.userModel = {};
            $scope.forgotPasswordModel = {};
            $scope.registrationModel = {};
            $scope.ssoEnabled = $rootScope.context.ssoEnabled;
            $scope.login = function () {
                authService.login($scope.loginModel.email, $scope.loginModel.password, $scope.loginModel.rememberMe).finally(function () {
                    $scope.loginError = authService.loginError;
                });
            };
            $scope.loginVisible = false;
            $scope.setMode = function (mode) {
                $scope.mode = mode;
                switch (mode) {
                    case exports.eLoginMode.login:
                        $rootScope.setTitle(loc.login);
                        break;
                    case exports.eLoginMode.register:
                    case exports.eLoginMode.thanks:
                        $rootScope.setTitle(loc.createaccount);
                        break;
                    case exports.eLoginMode.forgotPassword:
                    case exports.eLoginMode.forgotPasswordSubmitted:
                        $rootScope.setTitle(loc.forgotpassword);
                        break;
                    default:
                        $rootScope.setTitle();
                        break;
                }
            };
            $scope.ssoSignIn = function () {
                if (_tools.Utils.isDefined($location.search().embedded)) {
                    _tools.Utils.sendMessageToParent({
                        name: "loginsso",
                        data: {}
                    });
                }
                else {
                    $window.location.href = "/ssosignin?RedirectUrl=" + $window.location.href;
                }
            };
            $scope.showAltLogin = function () {
                $scope.altLogin = true;
            };
            var off1 = $rootScope.$on(_tools.events.loginRequested, function () {
                if ($scope.ssoEnabled && _tools.Utils.getParameterByName($window.location.href, "autoSsoLogin")) {
                    $scope.ssoSignIn();
                }
                $scope.loginVisible = true;
            });
            var off2 = $rootScope.$on(_tools.events.loginSuccessful, function () {
                _this.$timeout(function () {
                    // delay emptying while the fade out animation runs
                    $scope.loginVisible = false;
                    $scope.loginModel.email = "";
                    $scope.loginModel.password = "";
                }, 500);
            });
            $scope.register = function () {
                if (!$scope.registrationModel.agreedToPrivacyPolicy) {
                    $scope.validation = { agreedToPrivacyPolicy: "You must agree to the privacy policy before continuing" };
                    return;
                }
                return $http.post("/api/auth/register", $scope.userModel, { tracker: $rootScope.loginTracker }).then(function () {
                    $scope.mode = exports.eLoginMode.thanks;
                }, function (r) {
                    $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
                });
            };
            $scope.submitForgotPassword = function () {
                return $http.post("/api/auth/forgotpassword", $scope.forgotPasswordModel, { tracker: $rootScope.loginTracker }).then(function () {
                    $scope.mode = exports.eLoginMode.forgotPasswordSubmitted;
                }, function (r) {
                    $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
                });
            };
            if (!$rootScope.context.user && (!$rootScope.context.allowAnonymousLogins || $rootScope.environment !== enums.eEnvironment.prod) && _tools.Utils.getParameterByName($window.location.href, "autoSsoLogin")) {
                $scope.ssoSignIn();
            }
            $scope.$on("$destroy", function () {
                off1();
                off2();
            });
            return _this;
        }
        LoginController = __decorate([
            NgView({
                token: Token.LoginView,
                dependencies: [
                    Token.$Scope,
                    Token.$Http,
                    Token.AuthService,
                    Token.$RootScope,
                    Token.$Timeout,
                    Token.$Window,
                    Token.$Location
                ]
            })
        ], LoginController);
        return LoginController;
    }(BaseController));

    var PortalController = /** @class */ (function () {
        function PortalController($scope, $http, authService, $rootScope, $window, quoteService, $location, signalrService, sfdcService, storageService, agg) {
            var _this = this;
            this.$scope = $scope;
            this.$http = $http;
            this.authService = authService;
            this.$rootScope = $rootScope;
            this.$window = $window;
            this.quoteService = quoteService;
            this.$location = $location;
            this.signalrService = signalrService;
            this.sfdcService = sfdcService;
            this.storageService = storageService;
            this.agg = agg;
            $scope.model = {};
            $scope.notifications = [];
            $scope.pendingApprovals = [];
            $scope.sfdcService = sfdcService;
            $scope.$watch(function () { return quoteService.quote; }, function (opp) {
                $scope.model.quote = opp;
            });
            $scope.goToQuote = function () {
                quoteService.goToQuote();
            };
            $scope.login = function () {
                $rootScope.user = null;
                $rootScope.$broadcast(_tools.events.loginRequested);
            };
            $scope.logout = function () {
                authService.logout();
            };
            $scope.showMobileMenu = function () {
                $scope.model.mobileMenuVisible = true;
            };
            $scope.hideMobileMenu = function () {
                $scope.model.mobileMenuVisible = false;
            };
            var refreshNotifications = function () {
                $http.get("/api/notifications", {
                    params: { pageSize: 10 },
                    ignoreSecurity: true
                }).then(function (r) {
                    $scope.notifications.clear();
                    $scope.notifications.pushArray(r.data.items);
                });
            };
            var onNotificationSignal = function () {
                // fill in notifications
                refreshNotifications();
            };
            var offOnLogin = $rootScope.$on(_tools.events.loginSuccessful, function () {
                if ($rootScope.user.id != -1) {
                    _this.signalrService.notificationInvoke("subscribe", _this.$rootScope.company.uniqueName, _this.$rootScope.user.id);
                    _this.signalrService.notificationOn("notification", onNotificationSignal);
                }
            });
            $scope.$on("$destroy", function () {
                offOnLogin();
                if ($rootScope.user.id != -1) {
                    _this.signalrService.notificationInvoke("unsubscribe", _this.$rootScope.company.uniqueName, _this.$rootScope.user.id);
                    _this.signalrService.notificationOff("notification", onNotificationSignal);
                }
            });
            authService.authPromise.then(function () {
                // fill in company subdomains to drive the company selection for admins
                if ($rootScope.user.isAdmin) {
                    $http.get("/api/companies/subdomains").then(function (r) {
                        $scope.companySubdomains = r.data;
                    });
                }
                $scope.browseToSubdomain = function (subdomain) {
                    var segments = $window.location.host.split(".");
                    $window.location.href = "https://" + subdomain + "." + segments[1] + "." + segments[2];
                };
                if ($rootScope.user.id != -1) {
                    var cutoff = new Date();
                    cutoff.setMonth(cutoff.getMonth() - 6); // 6 months ago
                    // fill in pending approvals
                    $http.get("/api/pendingapprovals", {
                        params: { pageSize: 4, fromDate: cutoff },
                        ignoreSecurity: true
                    }).then(function (r) {
                        $scope.pendingApprovals.pushArray(r.data.items);
                    });
                    // fill in notifications
                    refreshNotifications();
                }
            });
            // fill in environments for environment selector
            $scope.environments = [];
            $scope.environments.push(enums.eEnvironment.dev);
            $scope.environments.push(enums.eEnvironment.test);
            $scope.environments.push(enums.eEnvironment.prod);
            $scope.browseToEnvironment = function (env) {
                if (env == $rootScope.environment)
                    return;
                var envSuffix = "";
                if (env != enums.eEnvironment.prod) {
                    envSuffix = "-" + env;
                }
                var segments = $window.location.host.split(".");
                $window.location.href =
                    "https://" + $rootScope.company.subdomain + envSuffix + "." + segments[1] + "." + segments[2];
            };
            var focusin = function (e) {
                var phase = $rootScope.$$phase;
                if (phase == "$apply" || phase == "$digest") {
                    $scope.mobileKeyboard = true;
                }
                else {
                    $scope.$apply(function () {
                        $scope.mobileKeyboard = true;
                    });
                }
            };
            var focusout = function (e) {
                var phase = $rootScope.$$phase;
                if (phase == "$apply" || phase == "$digest") {
                    $scope.mobileKeyboard = false;
                }
                else {
                    $scope.$apply(function () {
                        $scope.mobileKeyboard = false;
                    });
                }
            };
            $(document).on("focusin", "input[type='text']", focusin);
            $(document).on("focusout", "input[type='text']", focusout);
            $scope.readNotification = function (notification, navigate) {
                if (navigate === void 0) { navigate = true; }
                $http.post("/api/notifications/markasread", [notification.id]);
                // mark as read locally too
                $scope.notifications.find(function (n) {
                    return n.id == notification.id;
                }).read = true;
                if (navigate)
                    $location.path(notification.urlPath);
            };
            $scope.markAllNotificationsAsRead = function () {
                $scope.notifications.forEach(function (n) {
                    $scope.readNotification(n, false);
                });
            };
            $scope.newNotificationCount = function () {
                return $scope.pendingApprovals.length + $scope.notifications.filter(function (n) { return !n.read; }).length;
            };
            $scope.$on("$destroy", function () {
                $(document).off("focusin", "input[type='text']", focusin);
                $(document).off("focusout", "input[type='text']", focusout);
            });
            if ($rootScope.context.company.snapStudioMode || window.__kbHostedByVue) {
                $rootScope.hideHeader = true;
            }
        }
        PortalController = __decorate([
            NgView({
                token: Token.PortalView,
                dependencies: [
                    Token.$Scope,
                    Token.$Http,
                    Token.AuthService,
                    Token.$RootScope,
                    Token.$Window,
                    Token.QuoteService,
                    Token.$Location,
                    Token.SignalRService,
                    Token.SfdcService,
                    Token.StorageService,
                    Token.CrudService
                ]
            })
        ], PortalController);
        return PortalController;
    }());

    var PrivacyPolicyController = /** @class */ (function (_super) {
        __extends(PrivacyPolicyController, _super);
        function PrivacyPolicyController($scope, api, $rootScope, dialogService, authService) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.api = api;
            _this.$rootScope = $rootScope;
            _this.dialogService = dialogService;
            _this.authService = authService;
            $scope.privacyPolicyModel = {};
            $scope.logout = function () {
                authService.logout();
            };
            $scope.agree = function () {
                if (!$scope.privacyPolicyModel.agreed) {
                    dialogService.alert({
                        msg: "Before you can continue you must agree to the privacy policy.",
                        type: enums.eAlertType.error,
                        persist: true
                    });
                    return;
                }
                _this.api.users.acceptPrivacyPolicy().then(function (u) {
                    $rootScope.user.hasLatestPrivacyPolicy = true;
                });
            };
            return _this;
        }
        PrivacyPolicyController = __decorate([
            NgView({
                token: Token.PrivacyPolicyView,
                dependencies: [
                    Token.$Scope,
                    Token.ApiService,
                    Token.$RootScope,
                    Token.DialogService,
                    Token.AuthService
                ]
            })
        ], PrivacyPolicyController);
        return PrivacyPolicyController;
    }(BaseController));

    // can-promise has a crash in some versions of react native that dont have
    // standard global objects
    // https://github.com/soldair/node-qrcode/issues/157

    var canPromise = function () {
      return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
    };

    let toSJISFunction;
    const CODEWORDS_COUNT = [
      0, // Not used
      26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
      404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
      1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
      2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
    ];

    /**
     * Returns the QR Code size for the specified version
     *
     * @param  {Number} version QR Code version
     * @return {Number}         size of QR code
     */
    var getSymbolSize$1 = function getSymbolSize (version) {
      if (!version) throw new Error('"version" cannot be null or undefined')
      if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
      return version * 4 + 17
    };

    /**
     * Returns the total number of codewords used to store data and EC information.
     *
     * @param  {Number} version QR Code version
     * @return {Number}         Data length in bits
     */
    var getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
      return CODEWORDS_COUNT[version]
    };

    /**
     * Encode data with Bose-Chaudhuri-Hocquenghem
     *
     * @param  {Number} data Value to encode
     * @return {Number}      Encoded value
     */
    var getBCHDigit = function (data) {
      let digit = 0;

      while (data !== 0) {
        digit++;
        data >>>= 1;
      }

      return digit
    };

    var setToSJISFunction = function setToSJISFunction (f) {
      if (typeof f !== 'function') {
        throw new Error('"toSJISFunc" is not a valid function.')
      }

      toSJISFunction = f;
    };

    var isKanjiModeEnabled = function () {
      return typeof toSJISFunction !== 'undefined'
    };

    var toSJIS = function toSJIS (kanji) {
      return toSJISFunction(kanji)
    };

    var utils$1 = {
    	getSymbolSize: getSymbolSize$1,
    	getSymbolTotalCodewords: getSymbolTotalCodewords,
    	getBCHDigit: getBCHDigit,
    	setToSJISFunction: setToSJISFunction,
    	isKanjiModeEnabled: isKanjiModeEnabled,
    	toSJIS: toSJIS
    };

    function createCommonjsModule(fn, basedir, module) {
    	return module = {
    		path: basedir,
    		exports: {},
    		require: function (path, base) {
    			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    		}
    	}, fn(module, module.exports), module.exports;
    }

    function commonjsRequire () {
    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
    }

    var errorCorrectionLevel = createCommonjsModule(function (module, exports) {
    exports.L = { bit: 1 };
    exports.M = { bit: 0 };
    exports.Q = { bit: 3 };
    exports.H = { bit: 2 };

    function fromString (string) {
      if (typeof string !== 'string') {
        throw new Error('Param is not a string')
      }

      const lcStr = string.toLowerCase();

      switch (lcStr) {
        case 'l':
        case 'low':
          return exports.L

        case 'm':
        case 'medium':
          return exports.M

        case 'q':
        case 'quartile':
          return exports.Q

        case 'h':
        case 'high':
          return exports.H

        default:
          throw new Error('Unknown EC Level: ' + string)
      }
    }

    exports.isValid = function isValid (level) {
      return level && typeof level.bit !== 'undefined' &&
        level.bit >= 0 && level.bit < 4
    };

    exports.from = function from (value, defaultValue) {
      if (exports.isValid(value)) {
        return value
      }

      try {
        return fromString(value)
      } catch (e) {
        return defaultValue
      }
    };
    });

    function BitBuffer () {
      this.buffer = [];
      this.length = 0;
    }

    BitBuffer.prototype = {

      get: function (index) {
        const bufIndex = Math.floor(index / 8);
        return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
      },

      put: function (num, length) {
        for (let i = 0; i < length; i++) {
          this.putBit(((num >>> (length - i - 1)) & 1) === 1);
        }
      },

      getLengthInBits: function () {
        return this.length
      },

      putBit: function (bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) {
          this.buffer.push(0);
        }

        if (bit) {
          this.buffer[bufIndex] |= (0x80 >>> (this.length % 8));
        }

        this.length++;
      }
    };

    var bitBuffer = BitBuffer;

    /**
     * Helper class to handle QR Code symbol modules
     *
     * @param {Number} size Symbol size
     */
    function BitMatrix (size) {
      if (!size || size < 1) {
        throw new Error('BitMatrix size must be defined and greater than 0')
      }

      this.size = size;
      this.data = new Uint8Array(size * size);
      this.reservedBit = new Uint8Array(size * size);
    }

    /**
     * Set bit value at specified location
     * If reserved flag is set, this bit will be ignored during masking process
     *
     * @param {Number}  row
     * @param {Number}  col
     * @param {Boolean} value
     * @param {Boolean} reserved
     */
    BitMatrix.prototype.set = function (row, col, value, reserved) {
      const index = row * this.size + col;
      this.data[index] = value;
      if (reserved) this.reservedBit[index] = true;
    };

    /**
     * Returns bit value at specified location
     *
     * @param  {Number}  row
     * @param  {Number}  col
     * @return {Boolean}
     */
    BitMatrix.prototype.get = function (row, col) {
      return this.data[row * this.size + col]
    };

    /**
     * Applies xor operator at specified location
     * (used during masking process)
     *
     * @param {Number}  row
     * @param {Number}  col
     * @param {Boolean} value
     */
    BitMatrix.prototype.xor = function (row, col, value) {
      this.data[row * this.size + col] ^= value;
    };

    /**
     * Check if bit at specified location is reserved
     *
     * @param {Number}   row
     * @param {Number}   col
     * @return {Boolean}
     */
    BitMatrix.prototype.isReserved = function (row, col) {
      return this.reservedBit[row * this.size + col]
    };

    var bitMatrix = BitMatrix;

    var alignmentPattern = createCommonjsModule(function (module, exports) {
    /**
     * Alignment pattern are fixed reference pattern in defined positions
     * in a matrix symbology, which enables the decode software to re-synchronise
     * the coordinate mapping of the image modules in the event of moderate amounts
     * of distortion of the image.
     *
     * Alignment patterns are present only in QR Code symbols of version 2 or larger
     * and their number depends on the symbol version.
     */

    const getSymbolSize = utils$1.getSymbolSize;

    /**
     * Calculate the row/column coordinates of the center module of each alignment pattern
     * for the specified QR Code version.
     *
     * The alignment patterns are positioned symmetrically on either side of the diagonal
     * running from the top left corner of the symbol to the bottom right corner.
     *
     * Since positions are simmetrical only half of the coordinates are returned.
     * Each item of the array will represent in turn the x and y coordinate.
     * @see {@link getPositions}
     *
     * @param  {Number} version QR Code version
     * @return {Array}          Array of coordinate
     */
    exports.getRowColCoords = function getRowColCoords (version) {
      if (version === 1) return []

      const posCount = Math.floor(version / 7) + 2;
      const size = getSymbolSize(version);
      const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
      const positions = [size - 7]; // Last coord is always (size - 7)

      for (let i = 1; i < posCount - 1; i++) {
        positions[i] = positions[i - 1] - intervals;
      }

      positions.push(6); // First coord is always 6

      return positions.reverse()
    };

    /**
     * Returns an array containing the positions of each alignment pattern.
     * Each array's element represent the center point of the pattern as (x, y) coordinates
     *
     * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
     * and filtering out the items that overlaps with finder pattern
     *
     * @example
     * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
     * The alignment patterns, therefore, are to be centered on (row, column)
     * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
     * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
     * and are not therefore used for alignment patterns.
     *
     * let pos = getPositions(7)
     * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
     *
     * @param  {Number} version QR Code version
     * @return {Array}          Array of coordinates
     */
    exports.getPositions = function getPositions (version) {
      const coords = [];
      const pos = exports.getRowColCoords(version);
      const posLength = pos.length;

      for (let i = 0; i < posLength; i++) {
        for (let j = 0; j < posLength; j++) {
          // Skip if position is occupied by finder patterns
          if ((i === 0 && j === 0) || // top-left
              (i === 0 && j === posLength - 1) || // bottom-left
              (i === posLength - 1 && j === 0)) { // top-right
            continue
          }

          coords.push([pos[i], pos[j]]);
        }
      }

      return coords
    };
    });

    const getSymbolSize = utils$1.getSymbolSize;
    const FINDER_PATTERN_SIZE = 7;

    /**
     * Returns an array containing the positions of each finder pattern.
     * Each array's element represent the top-left point of the pattern as (x, y) coordinates
     *
     * @param  {Number} version QR Code version
     * @return {Array}          Array of coordinates
     */
    var getPositions = function getPositions (version) {
      const size = getSymbolSize(version);

      return [
        // top-left
        [0, 0],
        // top-right
        [size - FINDER_PATTERN_SIZE, 0],
        // bottom-left
        [0, size - FINDER_PATTERN_SIZE]
      ]
    };

    var finderPattern = {
    	getPositions: getPositions
    };

    var maskPattern = createCommonjsModule(function (module, exports) {
    /**
     * Data mask pattern reference
     * @type {Object}
     */
    exports.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };

    /**
     * Weighted penalty scores for the undesirable features
     * @type {Object}
     */
    const PenaltyScores = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };

    /**
     * Check if mask pattern value is valid
     *
     * @param  {Number}  mask    Mask pattern
     * @return {Boolean}         true if valid, false otherwise
     */
    exports.isValid = function isValid (mask) {
      return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
    };

    /**
     * Returns mask pattern from a value.
     * If value is not valid, returns undefined
     *
     * @param  {Number|String} value        Mask pattern value
     * @return {Number}                     Valid mask pattern or undefined
     */
    exports.from = function from (value) {
      return exports.isValid(value) ? parseInt(value, 10) : undefined
    };

    /**
    * Find adjacent modules in row/column with the same color
    * and assign a penalty value.
    *
    * Points: N1 + i
    * i is the amount by which the number of adjacent modules of the same color exceeds 5
    */
    exports.getPenaltyN1 = function getPenaltyN1 (data) {
      const size = data.size;
      let points = 0;
      let sameCountCol = 0;
      let sameCountRow = 0;
      let lastCol = null;
      let lastRow = null;

      for (let row = 0; row < size; row++) {
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;

        for (let col = 0; col < size; col++) {
          let module = data.get(row, col);
          if (module === lastCol) {
            sameCountCol++;
          } else {
            if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
            lastCol = module;
            sameCountCol = 1;
          }

          module = data.get(col, row);
          if (module === lastRow) {
            sameCountRow++;
          } else {
            if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
            lastRow = module;
            sameCountRow = 1;
          }
        }

        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
      }

      return points
    };

    /**
     * Find 2x2 blocks with the same color and assign a penalty value
     *
     * Points: N2 * (m - 1) * (n - 1)
     */
    exports.getPenaltyN2 = function getPenaltyN2 (data) {
      const size = data.size;
      let points = 0;

      for (let row = 0; row < size - 1; row++) {
        for (let col = 0; col < size - 1; col++) {
          const last = data.get(row, col) +
            data.get(row, col + 1) +
            data.get(row + 1, col) +
            data.get(row + 1, col + 1);

          if (last === 4 || last === 0) points++;
        }
      }

      return points * PenaltyScores.N2
    };

    /**
     * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
     * preceded or followed by light area 4 modules wide
     *
     * Points: N3 * number of pattern found
     */
    exports.getPenaltyN3 = function getPenaltyN3 (data) {
      const size = data.size;
      let points = 0;
      let bitsCol = 0;
      let bitsRow = 0;

      for (let row = 0; row < size; row++) {
        bitsCol = bitsRow = 0;
        for (let col = 0; col < size; col++) {
          bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col);
          if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;

          bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row);
          if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
      }

      return points * PenaltyScores.N3
    };

    /**
     * Calculate proportion of dark modules in entire symbol
     *
     * Points: N4 * k
     *
     * k is the rating of the deviation of the proportion of dark modules
     * in the symbol from 50% in steps of 5%
     */
    exports.getPenaltyN4 = function getPenaltyN4 (data) {
      let darkCount = 0;
      const modulesCount = data.data.length;

      for (let i = 0; i < modulesCount; i++) darkCount += data.data[i];

      const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10);

      return k * PenaltyScores.N4
    };

    /**
     * Return mask value at given position
     *
     * @param  {Number} maskPattern Pattern reference value
     * @param  {Number} i           Row
     * @param  {Number} j           Column
     * @return {Boolean}            Mask value
     */
    function getMaskAt (maskPattern, i, j) {
      switch (maskPattern) {
        case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
        case exports.Patterns.PATTERN001: return i % 2 === 0
        case exports.Patterns.PATTERN010: return j % 3 === 0
        case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
        case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
        case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
        case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
        case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

        default: throw new Error('bad maskPattern:' + maskPattern)
      }
    }

    /**
     * Apply a mask pattern to a BitMatrix
     *
     * @param  {Number}    pattern Pattern reference number
     * @param  {BitMatrix} data    BitMatrix data
     */
    exports.applyMask = function applyMask (pattern, data) {
      const size = data.size;

      for (let col = 0; col < size; col++) {
        for (let row = 0; row < size; row++) {
          if (data.isReserved(row, col)) continue
          data.xor(row, col, getMaskAt(pattern, row, col));
        }
      }
    };

    /**
     * Returns the best mask pattern for data
     *
     * @param  {BitMatrix} data
     * @return {Number} Mask pattern reference number
     */
    exports.getBestMask = function getBestMask (data, setupFormatFunc) {
      const numPatterns = Object.keys(exports.Patterns).length;
      let bestPattern = 0;
      let lowerPenalty = Infinity;

      for (let p = 0; p < numPatterns; p++) {
        setupFormatFunc(p);
        exports.applyMask(p, data);

        // Calculate penalty
        const penalty =
          exports.getPenaltyN1(data) +
          exports.getPenaltyN2(data) +
          exports.getPenaltyN3(data) +
          exports.getPenaltyN4(data);

        // Undo previously applied mask
        exports.applyMask(p, data);

        if (penalty < lowerPenalty) {
          lowerPenalty = penalty;
          bestPattern = p;
        }
      }

      return bestPattern
    };
    });

    const EC_BLOCKS_TABLE = [
    // L  M  Q  H
      1, 1, 1, 1,
      1, 1, 1, 1,
      1, 1, 2, 2,
      1, 2, 2, 4,
      1, 2, 4, 4,
      2, 4, 4, 4,
      2, 4, 6, 5,
      2, 4, 6, 6,
      2, 5, 8, 8,
      4, 5, 8, 8,
      4, 5, 8, 11,
      4, 8, 10, 11,
      4, 9, 12, 16,
      4, 9, 16, 16,
      6, 10, 12, 18,
      6, 10, 17, 16,
      6, 11, 16, 19,
      6, 13, 18, 21,
      7, 14, 21, 25,
      8, 16, 20, 25,
      8, 17, 23, 25,
      9, 17, 23, 34,
      9, 18, 25, 30,
      10, 20, 27, 32,
      12, 21, 29, 35,
      12, 23, 34, 37,
      12, 25, 34, 40,
      13, 26, 35, 42,
      14, 28, 38, 45,
      15, 29, 40, 48,
      16, 31, 43, 51,
      17, 33, 45, 54,
      18, 35, 48, 57,
      19, 37, 51, 60,
      19, 38, 53, 63,
      20, 40, 56, 66,
      21, 43, 59, 70,
      22, 45, 62, 74,
      24, 47, 65, 77,
      25, 49, 68, 81
    ];

    const EC_CODEWORDS_TABLE = [
    // L  M  Q  H
      7, 10, 13, 17,
      10, 16, 22, 28,
      15, 26, 36, 44,
      20, 36, 52, 64,
      26, 48, 72, 88,
      36, 64, 96, 112,
      40, 72, 108, 130,
      48, 88, 132, 156,
      60, 110, 160, 192,
      72, 130, 192, 224,
      80, 150, 224, 264,
      96, 176, 260, 308,
      104, 198, 288, 352,
      120, 216, 320, 384,
      132, 240, 360, 432,
      144, 280, 408, 480,
      168, 308, 448, 532,
      180, 338, 504, 588,
      196, 364, 546, 650,
      224, 416, 600, 700,
      224, 442, 644, 750,
      252, 476, 690, 816,
      270, 504, 750, 900,
      300, 560, 810, 960,
      312, 588, 870, 1050,
      336, 644, 952, 1110,
      360, 700, 1020, 1200,
      390, 728, 1050, 1260,
      420, 784, 1140, 1350,
      450, 812, 1200, 1440,
      480, 868, 1290, 1530,
      510, 924, 1350, 1620,
      540, 980, 1440, 1710,
      570, 1036, 1530, 1800,
      570, 1064, 1590, 1890,
      600, 1120, 1680, 1980,
      630, 1204, 1770, 2100,
      660, 1260, 1860, 2220,
      720, 1316, 1950, 2310,
      750, 1372, 2040, 2430
    ];

    /**
     * Returns the number of error correction block that the QR Code should contain
     * for the specified version and error correction level.
     *
     * @param  {Number} version              QR Code version
     * @param  {Number} errorCorrectionLevel Error correction level
     * @return {Number}                      Number of error correction blocks
     */
    var getBlocksCount = function getBlocksCount (version, errorCorrectionLevel$1) {
      switch (errorCorrectionLevel$1) {
        case errorCorrectionLevel.L:
          return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
        case errorCorrectionLevel.M:
          return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
        case errorCorrectionLevel.Q:
          return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
        case errorCorrectionLevel.H:
          return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
        default:
          return undefined
      }
    };

    /**
     * Returns the number of error correction codewords to use for the specified
     * version and error correction level.
     *
     * @param  {Number} version              QR Code version
     * @param  {Number} errorCorrectionLevel Error correction level
     * @return {Number}                      Number of error correction codewords
     */
    var getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel$1) {
      switch (errorCorrectionLevel$1) {
        case errorCorrectionLevel.L:
          return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
        case errorCorrectionLevel.M:
          return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
        case errorCorrectionLevel.Q:
          return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
        case errorCorrectionLevel.H:
          return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
        default:
          return undefined
      }
    };

    var errorCorrectionCode = {
    	getBlocksCount: getBlocksCount,
    	getTotalCodewordsCount: getTotalCodewordsCount
    };

    const EXP_TABLE = new Uint8Array(512);
    const LOG_TABLE = new Uint8Array(256)
    /**
     * Precompute the log and anti-log tables for faster computation later
     *
     * For each possible value in the galois field 2^8, we will pre-compute
     * the logarithm and anti-logarithm (exponential) of this value
     *
     * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
     */
    ;(function initTables () {
      let x = 1;
      for (let i = 0; i < 255; i++) {
        EXP_TABLE[i] = x;
        LOG_TABLE[x] = i;

        x <<= 1; // multiply by 2

        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
          x ^= 0x11D;
        }
      }

      // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
      // stay inside the bounds (because we will mainly use this table for the multiplication of
      // two GF numbers, no more).
      // @see {@link mul}
      for (let i = 255; i < 512; i++) {
        EXP_TABLE[i] = EXP_TABLE[i - 255];
      }
    }());

    /**
     * Returns log value of n inside Galois Field
     *
     * @param  {Number} n
     * @return {Number}
     */
    var log = function log (n) {
      if (n < 1) throw new Error('log(' + n + ')')
      return LOG_TABLE[n]
    };

    /**
     * Returns anti-log value of n inside Galois Field
     *
     * @param  {Number} n
     * @return {Number}
     */
    var exp = function exp (n) {
      return EXP_TABLE[n]
    };

    /**
     * Multiplies two number inside Galois Field
     *
     * @param  {Number} x
     * @param  {Number} y
     * @return {Number}
     */
    var mul = function mul (x, y) {
      if (x === 0 || y === 0) return 0

      // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
      // @see {@link initTables}
      return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
    };

    var galoisField = {
    	log: log,
    	exp: exp,
    	mul: mul
    };

    var polynomial = createCommonjsModule(function (module, exports) {
    /**
     * Multiplies two polynomials inside Galois Field
     *
     * @param  {Uint8Array} p1 Polynomial
     * @param  {Uint8Array} p2 Polynomial
     * @return {Uint8Array}    Product of p1 and p2
     */
    exports.mul = function mul (p1, p2) {
      const coeff = new Uint8Array(p1.length + p2.length - 1);

      for (let i = 0; i < p1.length; i++) {
        for (let j = 0; j < p2.length; j++) {
          coeff[i + j] ^= galoisField.mul(p1[i], p2[j]);
        }
      }

      return coeff
    };

    /**
     * Calculate the remainder of polynomials division
     *
     * @param  {Uint8Array} divident Polynomial
     * @param  {Uint8Array} divisor  Polynomial
     * @return {Uint8Array}          Remainder
     */
    exports.mod = function mod (divident, divisor) {
      let result = new Uint8Array(divident);

      while ((result.length - divisor.length) >= 0) {
        const coeff = result[0];

        for (let i = 0; i < divisor.length; i++) {
          result[i] ^= galoisField.mul(divisor[i], coeff);
        }

        // remove all zeros from buffer head
        let offset = 0;
        while (offset < result.length && result[offset] === 0) offset++;
        result = result.slice(offset);
      }

      return result
    };

    /**
     * Generate an irreducible generator polynomial of specified degree
     * (used by Reed-Solomon encoder)
     *
     * @param  {Number} degree Degree of the generator polynomial
     * @return {Uint8Array}    Buffer containing polynomial coefficients
     */
    exports.generateECPolynomial = function generateECPolynomial (degree) {
      let poly = new Uint8Array([1]);
      for (let i = 0; i < degree; i++) {
        poly = exports.mul(poly, new Uint8Array([1, galoisField.exp(i)]));
      }

      return poly
    };
    });

    function ReedSolomonEncoder (degree) {
      this.genPoly = undefined;
      this.degree = degree;

      if (this.degree) this.initialize(this.degree);
    }

    /**
     * Initialize the encoder.
     * The input param should correspond to the number of error correction codewords.
     *
     * @param  {Number} degree
     */
    ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
      // create an irreducible generator polynomial
      this.degree = degree;
      this.genPoly = polynomial.generateECPolynomial(this.degree);
    };

    /**
     * Encodes a chunk of data
     *
     * @param  {Uint8Array} data Buffer containing input data
     * @return {Uint8Array}      Buffer containing encoded data
     */
    ReedSolomonEncoder.prototype.encode = function encode (data) {
      if (!this.genPoly) {
        throw new Error('Encoder not initialized')
      }

      // Calculate EC for this data block
      // extends data size to data+genPoly size
      const paddedData = new Uint8Array(data.length + this.degree);
      paddedData.set(data);

      // The error correction codewords are the remainder after dividing the data codewords
      // by a generator polynomial
      const remainder = polynomial.mod(paddedData, this.genPoly);

      // return EC data blocks (last n byte, where n is the degree of genPoly)
      // If coefficients number in remainder are less than genPoly degree,
      // pad with 0s to the left to reach the needed number of coefficients
      const start = this.degree - remainder.length;
      if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);

        return buff
      }

      return remainder
    };

    var reedSolomonEncoder = ReedSolomonEncoder;

    /**
     * Check if QR Code version is valid
     *
     * @param  {Number}  version QR Code version
     * @return {Boolean}         true if valid version, false otherwise
     */
    var isValid = function isValid (version) {
      return !isNaN(version) && version >= 1 && version <= 40
    };

    var versionCheck = {
    	isValid: isValid
    };

    const numeric = '[0-9]+';
    const alphanumeric = '[A-Z $%*+\\-./:]+';
    let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
      '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
      '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
      '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+';
    kanji = kanji.replace(/u/g, '\\u');

    const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+';

    var KANJI = new RegExp(kanji, 'g');
    var BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
    var BYTE = new RegExp(byte, 'g');
    var NUMERIC = new RegExp(numeric, 'g');
    var ALPHANUMERIC = new RegExp(alphanumeric, 'g');

    const TEST_KANJI = new RegExp('^' + kanji + '$');
    const TEST_NUMERIC = new RegExp('^' + numeric + '$');
    const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');

    var testKanji = function testKanji (str) {
      return TEST_KANJI.test(str)
    };

    var testNumeric = function testNumeric (str) {
      return TEST_NUMERIC.test(str)
    };

    var testAlphanumeric = function testAlphanumeric (str) {
      return TEST_ALPHANUMERIC.test(str)
    };

    var regex = {
    	KANJI: KANJI,
    	BYTE_KANJI: BYTE_KANJI,
    	BYTE: BYTE,
    	NUMERIC: NUMERIC,
    	ALPHANUMERIC: ALPHANUMERIC,
    	testKanji: testKanji,
    	testNumeric: testNumeric,
    	testAlphanumeric: testAlphanumeric
    };

    var mode = createCommonjsModule(function (module, exports) {
    /**
     * Numeric mode encodes data from the decimal digit set (0 - 9)
     * (byte values 30HEX to 39HEX).
     * Normally, 3 data characters are represented by 10 bits.
     *
     * @type {Object}
     */
    exports.NUMERIC = {
      id: 'Numeric',
      bit: 1 << 0,
      ccBits: [10, 12, 14]
    };

    /**
     * Alphanumeric mode encodes data from a set of 45 characters,
     * i.e. 10 numeric digits (0 - 9),
     *      26 alphabetic characters (A - Z),
     *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
     * Normally, two input characters are represented by 11 bits.
     *
     * @type {Object}
     */
    exports.ALPHANUMERIC = {
      id: 'Alphanumeric',
      bit: 1 << 1,
      ccBits: [9, 11, 13]
    };

    /**
     * In byte mode, data is encoded at 8 bits per character.
     *
     * @type {Object}
     */
    exports.BYTE = {
      id: 'Byte',
      bit: 1 << 2,
      ccBits: [8, 16, 16]
    };

    /**
     * The Kanji mode efficiently encodes Kanji characters in accordance with
     * the Shift JIS system based on JIS X 0208.
     * The Shift JIS values are shifted from the JIS X 0208 values.
     * JIS X 0208 gives details of the shift coded representation.
     * Each two-byte character value is compacted to a 13-bit binary codeword.
     *
     * @type {Object}
     */
    exports.KANJI = {
      id: 'Kanji',
      bit: 1 << 3,
      ccBits: [8, 10, 12]
    };

    /**
     * Mixed mode will contain a sequences of data in a combination of any of
     * the modes described above
     *
     * @type {Object}
     */
    exports.MIXED = {
      bit: -1
    };

    /**
     * Returns the number of bits needed to store the data length
     * according to QR Code specifications.
     *
     * @param  {Mode}   mode    Data mode
     * @param  {Number} version QR Code version
     * @return {Number}         Number of bits
     */
    exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
      if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

      if (!versionCheck.isValid(version)) {
        throw new Error('Invalid version: ' + version)
      }

      if (version >= 1 && version < 10) return mode.ccBits[0]
      else if (version < 27) return mode.ccBits[1]
      return mode.ccBits[2]
    };

    /**
     * Returns the most efficient mode to store the specified data
     *
     * @param  {String} dataStr Input data string
     * @return {Mode}           Best mode
     */
    exports.getBestModeForData = function getBestModeForData (dataStr) {
      if (regex.testNumeric(dataStr)) return exports.NUMERIC
      else if (regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
      else if (regex.testKanji(dataStr)) return exports.KANJI
      else return exports.BYTE
    };

    /**
     * Return mode name as string
     *
     * @param {Mode} mode Mode object
     * @returns {String}  Mode name
     */
    exports.toString = function toString (mode) {
      if (mode && mode.id) return mode.id
      throw new Error('Invalid mode')
    };

    /**
     * Check if input param is a valid mode object
     *
     * @param   {Mode}    mode Mode object
     * @returns {Boolean} True if valid mode, false otherwise
     */
    exports.isValid = function isValid (mode) {
      return mode && mode.bit && mode.ccBits
    };

    /**
     * Get mode object from its name
     *
     * @param   {String} string Mode name
     * @returns {Mode}          Mode object
     */
    function fromString (string) {
      if (typeof string !== 'string') {
        throw new Error('Param is not a string')
      }

      const lcStr = string.toLowerCase();

      switch (lcStr) {
        case 'numeric':
          return exports.NUMERIC
        case 'alphanumeric':
          return exports.ALPHANUMERIC
        case 'kanji':
          return exports.KANJI
        case 'byte':
          return exports.BYTE
        default:
          throw new Error('Unknown mode: ' + string)
      }
    }

    /**
     * Returns mode from a value.
     * If value is not a valid mode, returns defaultValue
     *
     * @param  {Mode|String} value        Encoding mode
     * @param  {Mode}        defaultValue Fallback value
     * @return {Mode}                     Encoding mode
     */
    exports.from = function from (value, defaultValue) {
      if (exports.isValid(value)) {
        return value
      }

      try {
        return fromString(value)
      } catch (e) {
        return defaultValue
      }
    };
    });

    var version = createCommonjsModule(function (module, exports) {
    // Generator polynomial used to encode version information
    const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
    const G18_BCH = utils$1.getBCHDigit(G18);

    function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
      for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
          return currentVersion
        }
      }

      return undefined
    }

    function getReservedBitsCount (mode$1, version) {
      // Character count indicator + mode indicator bits
      return mode.getCharCountIndicator(mode$1, version) + 4
    }

    function getTotalBitsFromDataArray (segments, version) {
      let totalBits = 0;

      segments.forEach(function (data) {
        const reservedBits = getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
      });

      return totalBits
    }

    function getBestVersionForMixedData (segments, errorCorrectionLevel) {
      for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
        const length = getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode.MIXED)) {
          return currentVersion
        }
      }

      return undefined
    }

    /**
     * Returns version number from a value.
     * If value is not a valid version, returns defaultValue
     *
     * @param  {Number|String} value        QR Code version
     * @param  {Number}        defaultValue Fallback value
     * @return {Number}                     QR Code version number
     */
    exports.from = function from (value, defaultValue) {
      if (versionCheck.isValid(value)) {
        return parseInt(value, 10)
      }

      return defaultValue
    };

    /**
     * Returns how much data can be stored with the specified QR code version
     * and error correction level
     *
     * @param  {Number} version              QR Code version (1-40)
     * @param  {Number} errorCorrectionLevel Error correction level
     * @param  {Mode}   mode                 Data mode
     * @return {Number}                      Quantity of storable data
     */
    exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode$1) {
      if (!versionCheck.isValid(version)) {
        throw new Error('Invalid QR Code version')
      }

      // Use Byte mode as default
      if (typeof mode$1 === 'undefined') mode$1 = mode.BYTE;

      // Total codewords for this QR code version (Data + Error correction)
      const totalCodewords = utils$1.getSymbolTotalCodewords(version);

      // Total number of error correction codewords
      const ecTotalCodewords = errorCorrectionCode.getTotalCodewordsCount(version, errorCorrectionLevel);

      // Total number of data codewords
      const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

      if (mode$1 === mode.MIXED) return dataTotalCodewordsBits

      const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode$1, version);

      // Return max number of storable codewords
      switch (mode$1) {
        case mode.NUMERIC:
          return Math.floor((usableBits / 10) * 3)

        case mode.ALPHANUMERIC:
          return Math.floor((usableBits / 11) * 2)

        case mode.KANJI:
          return Math.floor(usableBits / 13)

        case mode.BYTE:
        default:
          return Math.floor(usableBits / 8)
      }
    };

    /**
     * Returns the minimum version needed to contain the amount of data
     *
     * @param  {Segment} data                    Segment of data
     * @param  {Number} [errorCorrectionLevel=H] Error correction level
     * @param  {Mode} mode                       Data mode
     * @return {Number}                          QR Code version
     */
    exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel$1) {
      let seg;

      const ecl = errorCorrectionLevel.from(errorCorrectionLevel$1, errorCorrectionLevel.M);

      if (Array.isArray(data)) {
        if (data.length > 1) {
          return getBestVersionForMixedData(data, ecl)
        }

        if (data.length === 0) {
          return 1
        }

        seg = data[0];
      } else {
        seg = data;
      }

      return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
    };

    /**
     * Returns version information with relative error correction bits
     *
     * The version information is included in QR Code symbols of version 7 or larger.
     * It consists of an 18-bit sequence containing 6 data bits,
     * with 12 error correction bits calculated using the (18, 6) Golay code.
     *
     * @param  {Number} version QR Code version
     * @return {Number}         Encoded version info bits
     */
    exports.getEncodedBits = function getEncodedBits (version) {
      if (!versionCheck.isValid(version) || version < 7) {
        throw new Error('Invalid QR Code version')
      }

      let d = version << 12;

      while (utils$1.getBCHDigit(d) - G18_BCH >= 0) {
        d ^= (G18 << (utils$1.getBCHDigit(d) - G18_BCH));
      }

      return (version << 12) | d
    };
    });

    const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
    const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
    const G15_BCH = utils$1.getBCHDigit(G15);

    /**
     * Returns format information with relative error correction bits
     *
     * The format information is a 15-bit sequence containing 5 data bits,
     * with 10 error correction bits calculated using the (15, 5) BCH code.
     *
     * @param  {Number} errorCorrectionLevel Error correction level
     * @param  {Number} mask                 Mask pattern
     * @return {Number}                      Encoded format information bits
     */
    var getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
      const data = ((errorCorrectionLevel.bit << 3) | mask);
      let d = data << 10;

      while (utils$1.getBCHDigit(d) - G15_BCH >= 0) {
        d ^= (G15 << (utils$1.getBCHDigit(d) - G15_BCH));
      }

      // xor final data with mask pattern in order to ensure that
      // no combination of Error Correction Level and data mask pattern
      // will result in an all-zero data string
      return ((data << 10) | d) ^ G15_MASK
    };

    var formatInfo = {
    	getEncodedBits: getEncodedBits
    };

    function NumericData (data) {
      this.mode = mode.NUMERIC;
      this.data = data.toString();
    }

    NumericData.getBitsLength = function getBitsLength (length) {
      return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
    };

    NumericData.prototype.getLength = function getLength () {
      return this.data.length
    };

    NumericData.prototype.getBitsLength = function getBitsLength () {
      return NumericData.getBitsLength(this.data.length)
    };

    NumericData.prototype.write = function write (bitBuffer) {
      let i, group, value;

      // The input data string is divided into groups of three digits,
      // and each group is converted to its 10-bit binary equivalent.
      for (i = 0; i + 3 <= this.data.length; i += 3) {
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);

        bitBuffer.put(value, 10);
      }

      // If the number of input digits is not an exact multiple of three,
      // the final one or two digits are converted to 4 or 7 bits respectively.
      const remainingNum = this.data.length - i;
      if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);

        bitBuffer.put(value, remainingNum * 3 + 1);
      }
    };

    var numericData = NumericData;

    /**
     * Array of characters available in alphanumeric mode
     *
     * As per QR Code specification, to each character
     * is assigned a value from 0 to 44 which in this case coincides
     * with the array index
     *
     * @type {Array}
     */
    const ALPHA_NUM_CHARS = [
      '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
      'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
      ' ', '$', '%', '*', '+', '-', '.', '/', ':'
    ];

    function AlphanumericData (data) {
      this.mode = mode.ALPHANUMERIC;
      this.data = data;
    }

    AlphanumericData.getBitsLength = function getBitsLength (length) {
      return 11 * Math.floor(length / 2) + 6 * (length % 2)
    };

    AlphanumericData.prototype.getLength = function getLength () {
      return this.data.length
    };

    AlphanumericData.prototype.getBitsLength = function getBitsLength () {
      return AlphanumericData.getBitsLength(this.data.length)
    };

    AlphanumericData.prototype.write = function write (bitBuffer) {
      let i;

      // Input data characters are divided into groups of two characters
      // and encoded as 11-bit binary codes.
      for (i = 0; i + 2 <= this.data.length; i += 2) {
        // The character value of the first character is multiplied by 45
        let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;

        // The character value of the second digit is added to the product
        value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);

        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
      }

      // If the number of input data characters is not a multiple of two,
      // the character value of the final character is encoded as a 6-bit binary number.
      if (this.data.length % 2) {
        bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
      }
    };

    var alphanumericData = AlphanumericData;

    var encodeUtf8 = function encodeUtf8 (input) {
      var result = [];
      var size = input.length;

      for (var index = 0; index < size; index++) {
        var point = input.charCodeAt(index);

        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
          var second = input.charCodeAt(index + 1);

          if (second >= 0xDC00 && second <= 0xDFFF) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            index += 1;
          }
        }

        // US-ASCII
        if (point < 0x80) {
          result.push(point);
          continue
        }

        // 2-byte UTF-8
        if (point < 0x800) {
          result.push((point >> 6) | 192);
          result.push((point & 63) | 128);
          continue
        }

        // 3-byte UTF-8
        if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
          result.push((point >> 12) | 224);
          result.push(((point >> 6) & 63) | 128);
          result.push((point & 63) | 128);
          continue
        }

        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
          result.push((point >> 18) | 240);
          result.push(((point >> 12) & 63) | 128);
          result.push(((point >> 6) & 63) | 128);
          result.push((point & 63) | 128);
          continue
        }

        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
      }

      return new Uint8Array(result).buffer
    };

    function ByteData (data) {
      this.mode = mode.BYTE;
      if (typeof (data) === 'string') {
        data = encodeUtf8(data);
      }
      this.data = new Uint8Array(data);
    }

    ByteData.getBitsLength = function getBitsLength (length) {
      return length * 8
    };

    ByteData.prototype.getLength = function getLength () {
      return this.data.length
    };

    ByteData.prototype.getBitsLength = function getBitsLength () {
      return ByteData.getBitsLength(this.data.length)
    };

    ByteData.prototype.write = function (bitBuffer) {
      for (let i = 0, l = this.data.length; i < l; i++) {
        bitBuffer.put(this.data[i], 8);
      }
    };

    var byteData = ByteData;

    function KanjiData (data) {
      this.mode = mode.KANJI;
      this.data = data;
    }

    KanjiData.getBitsLength = function getBitsLength (length) {
      return length * 13
    };

    KanjiData.prototype.getLength = function getLength () {
      return this.data.length
    };

    KanjiData.prototype.getBitsLength = function getBitsLength () {
      return KanjiData.getBitsLength(this.data.length)
    };

    KanjiData.prototype.write = function (bitBuffer) {
      let i;

      // In the Shift JIS system, Kanji characters are represented by a two byte combination.
      // These byte values are shifted from the JIS X 0208 values.
      // JIS X 0208 gives details of the shift coded representation.
      for (i = 0; i < this.data.length; i++) {
        let value = utils$1.toSJIS(this.data[i]);

        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) {
          // Subtract 0x8140 from Shift JIS value
          value -= 0x8140;

        // For characters with Shift JIS values from 0xE040 to 0xEBBF
        } else if (value >= 0xE040 && value <= 0xEBBF) {
          // Subtract 0xC140 from Shift JIS value
          value -= 0xC140;
        } else {
          throw new Error(
            'Invalid SJIS character: ' + this.data[i] + '\n' +
            'Make sure your charset is UTF-8')
        }

        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff);

        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
      }
    };

    var kanjiData = KanjiData;

    var dijkstra_1 = createCommonjsModule(function (module) {

    /******************************************************************************
     * Created 2008-08-19.
     *
     * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
     *
     * Copyright (C) 2008
     *   Wyatt Baldwin <self@wyattbaldwin.com>
     *   All rights reserved
     *
     * Licensed under the MIT license.
     *
     *   http://www.opensource.org/licenses/mit-license.php
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     *****************************************************************************/
    var dijkstra = {
      single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};

        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;

        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = dijkstra.PriorityQueue.make();
        open.push(s, 0);

        var closest,
            u, v,
            cost_of_s_to_u,
            adjacent_nodes,
            cost_of_e,
            cost_of_s_to_u_plus_cost_of_e,
            cost_of_s_to_v,
            first_visit;
        while (!open.empty()) {
          // In the nodes remaining in graph that have a known cost from s,
          // find the node, u, that currently has the shortest path from s.
          closest = open.pop();
          u = closest.value;
          cost_of_s_to_u = closest.cost;

          // Get nodes adjacent to u...
          adjacent_nodes = graph[u] || {};

          // ...and explore the edges that connect u to those nodes, updating
          // the cost of the shortest paths to any or all of those nodes as
          // necessary. v is the node across the current edge from u.
          for (v in adjacent_nodes) {
            if (adjacent_nodes.hasOwnProperty(v)) {
              // Get the cost of the edge running from u to v.
              cost_of_e = adjacent_nodes[v];

              // Cost of s to u plus the cost of u to v across e--this is *a*
              // cost from s to v that may or may not be less than the current
              // known cost to v.
              cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

              // If we haven't visited v yet OR if the current known cost from s to
              // v is greater than the new cost we just found (cost of s to u plus
              // cost of u to v across e), update v's cost in the cost list and
              // update v's predecessor in the predecessor list (it's now u).
              cost_of_s_to_v = costs[v];
              first_visit = (typeof costs[v] === 'undefined');
              if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                costs[v] = cost_of_s_to_u_plus_cost_of_e;
                open.push(v, cost_of_s_to_u_plus_cost_of_e);
                predecessors[v] = u;
              }
            }
          }
        }

        if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
          var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
          throw new Error(msg);
        }

        return predecessors;
      },

      extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        while (u) {
          nodes.push(u);
          predecessors[u];
          u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
      },

      find_path: function(graph, s, d) {
        var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
        return dijkstra.extract_shortest_path_from_predecessor_list(
          predecessors, d);
      },

      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function (opts) {
          var T = dijkstra.PriorityQueue,
              t = {},
              key;
          opts = opts || {};
          for (key in T) {
            if (T.hasOwnProperty(key)) {
              t[key] = T[key];
            }
          }
          t.queue = [];
          t.sorter = opts.sorter || T.default_sorter;
          return t;
        },

        default_sorter: function (a, b) {
          return a.cost - b.cost;
        },

        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function (value, cost) {
          var item = {value: value, cost: cost};
          this.queue.push(item);
          this.queue.sort(this.sorter);
        },

        /**
         * Return the highest priority element in the queue.
         */
        pop: function () {
          return this.queue.shift();
        },

        empty: function () {
          return this.queue.length === 0;
        }
      }
    };


    // node.js module exports
    {
      module.exports = dijkstra;
    }
    });

    var segments = createCommonjsModule(function (module, exports) {
    /**
     * Returns UTF8 byte length
     *
     * @param  {String} str Input string
     * @return {Number}     Number of byte
     */
    function getStringByteLength (str) {
      return unescape(encodeURIComponent(str)).length
    }

    /**
     * Get a list of segments of the specified mode
     * from a string
     *
     * @param  {Mode}   mode Segment mode
     * @param  {String} str  String to process
     * @return {Array}       Array of object with segments data
     */
    function getSegments (regex, mode, str) {
      const segments = [];
      let result;

      while ((result = regex.exec(str)) !== null) {
        segments.push({
          data: result[0],
          index: result.index,
          mode: mode,
          length: result[0].length
        });
      }

      return segments
    }

    /**
     * Extracts a series of segments with the appropriate
     * modes from a string
     *
     * @param  {String} dataStr Input string
     * @return {Array}          Array of object with segments data
     */
    function getSegmentsFromString (dataStr) {
      const numSegs = getSegments(regex.NUMERIC, mode.NUMERIC, dataStr);
      const alphaNumSegs = getSegments(regex.ALPHANUMERIC, mode.ALPHANUMERIC, dataStr);
      let byteSegs;
      let kanjiSegs;

      if (utils$1.isKanjiModeEnabled()) {
        byteSegs = getSegments(regex.BYTE, mode.BYTE, dataStr);
        kanjiSegs = getSegments(regex.KANJI, mode.KANJI, dataStr);
      } else {
        byteSegs = getSegments(regex.BYTE_KANJI, mode.BYTE, dataStr);
        kanjiSegs = [];
      }

      const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);

      return segs
        .sort(function (s1, s2) {
          return s1.index - s2.index
        })
        .map(function (obj) {
          return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
          }
        })
    }

    /**
     * Returns how many bits are needed to encode a string of
     * specified length with the specified mode
     *
     * @param  {Number} length String length
     * @param  {Mode} mode     Segment mode
     * @return {Number}        Bit length
     */
    function getSegmentBitsLength (length, mode$1) {
      switch (mode$1) {
        case mode.NUMERIC:
          return numericData.getBitsLength(length)
        case mode.ALPHANUMERIC:
          return alphanumericData.getBitsLength(length)
        case mode.KANJI:
          return kanjiData.getBitsLength(length)
        case mode.BYTE:
          return byteData.getBitsLength(length)
      }
    }

    /**
     * Merges adjacent segments which have the same mode
     *
     * @param  {Array} segs Array of object with segments data
     * @return {Array}      Array of object with segments data
     */
    function mergeSegments (segs) {
      return segs.reduce(function (acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
          acc[acc.length - 1].data += curr.data;
          return acc
        }

        acc.push(curr);
        return acc
      }, [])
    }

    /**
     * Generates a list of all possible nodes combination which
     * will be used to build a segments graph.
     *
     * Nodes are divided by groups. Each group will contain a list of all the modes
     * in which is possible to encode the given text.
     *
     * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
     * The group for '12345' will contain then 3 objects, one for each
     * possible encoding mode.
     *
     * Each node represents a possible segment.
     *
     * @param  {Array} segs Array of object with segments data
     * @return {Array}      Array of object with segments data
     */
    function buildNodes (segs) {
      const nodes = [];
      for (let i = 0; i < segs.length; i++) {
        const seg = segs[i];

        switch (seg.mode) {
          case mode.NUMERIC:
            nodes.push([seg,
              { data: seg.data, mode: mode.ALPHANUMERIC, length: seg.length },
              { data: seg.data, mode: mode.BYTE, length: seg.length }
            ]);
            break
          case mode.ALPHANUMERIC:
            nodes.push([seg,
              { data: seg.data, mode: mode.BYTE, length: seg.length }
            ]);
            break
          case mode.KANJI:
            nodes.push([seg,
              { data: seg.data, mode: mode.BYTE, length: getStringByteLength(seg.data) }
            ]);
            break
          case mode.BYTE:
            nodes.push([
              { data: seg.data, mode: mode.BYTE, length: getStringByteLength(seg.data) }
            ]);
        }
      }

      return nodes
    }

    /**
     * Builds a graph from a list of nodes.
     * All segments in each node group will be connected with all the segments of
     * the next group and so on.
     *
     * At each connection will be assigned a weight depending on the
     * segment's byte length.
     *
     * @param  {Array} nodes    Array of object with segments data
     * @param  {Number} version QR Code version
     * @return {Object}         Graph of all possible segments
     */
    function buildGraph (nodes, version) {
      const table = {};
      const graph = { start: {} };
      let prevNodeIds = ['start'];

      for (let i = 0; i < nodes.length; i++) {
        const nodeGroup = nodes[i];
        const currentNodeIds = [];

        for (let j = 0; j < nodeGroup.length; j++) {
          const node = nodeGroup[j];
          const key = '' + i + j;

          currentNodeIds.push(key);
          table[key] = { node: node, lastCount: 0 };
          graph[key] = {};

          for (let n = 0; n < prevNodeIds.length; n++) {
            const prevNodeId = prevNodeIds[n];

            if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
              graph[prevNodeId][key] =
                getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
                getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);

              table[prevNodeId].lastCount += node.length;
            } else {
              if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;

              graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
                4 + mode.getCharCountIndicator(node.mode, version); // switch cost
            }
          }
        }

        prevNodeIds = currentNodeIds;
      }

      for (let n = 0; n < prevNodeIds.length; n++) {
        graph[prevNodeIds[n]].end = 0;
      }

      return { map: graph, table: table }
    }

    /**
     * Builds a segment from a specified data and mode.
     * If a mode is not specified, the more suitable will be used.
     *
     * @param  {String} data             Input data
     * @param  {Mode | String} modesHint Data mode
     * @return {Segment}                 Segment
     */
    function buildSingleSegment (data, modesHint) {
      let mode$1;
      const bestMode = mode.getBestModeForData(data);

      mode$1 = mode.from(modesHint, bestMode);

      // Make sure data can be encoded
      if (mode$1 !== mode.BYTE && mode$1.bit < bestMode.bit) {
        throw new Error('"' + data + '"' +
          ' cannot be encoded with mode ' + mode.toString(mode$1) +
          '.\n Suggested mode is: ' + mode.toString(bestMode))
      }

      // Use Mode.BYTE if Kanji support is disabled
      if (mode$1 === mode.KANJI && !utils$1.isKanjiModeEnabled()) {
        mode$1 = mode.BYTE;
      }

      switch (mode$1) {
        case mode.NUMERIC:
          return new numericData(data)

        case mode.ALPHANUMERIC:
          return new alphanumericData(data)

        case mode.KANJI:
          return new kanjiData(data)

        case mode.BYTE:
          return new byteData(data)
      }
    }

    /**
     * Builds a list of segments from an array.
     * Array can contain Strings or Objects with segment's info.
     *
     * For each item which is a string, will be generated a segment with the given
     * string and the more appropriate encoding mode.
     *
     * For each item which is an object, will be generated a segment with the given
     * data and mode.
     * Objects must contain at least the property "data".
     * If property "mode" is not present, the more suitable mode will be used.
     *
     * @param  {Array} array Array of objects with segments data
     * @return {Array}       Array of Segments
     */
    exports.fromArray = function fromArray (array) {
      return array.reduce(function (acc, seg) {
        if (typeof seg === 'string') {
          acc.push(buildSingleSegment(seg, null));
        } else if (seg.data) {
          acc.push(buildSingleSegment(seg.data, seg.mode));
        }

        return acc
      }, [])
    };

    /**
     * Builds an optimized sequence of segments from a string,
     * which will produce the shortest possible bitstream.
     *
     * @param  {String} data    Input string
     * @param  {Number} version QR Code version
     * @return {Array}          Array of segments
     */
    exports.fromString = function fromString (data, version) {
      const segs = getSegmentsFromString(data);

      const nodes = buildNodes(segs);
      const graph = buildGraph(nodes, version);
      const path = dijkstra_1.find_path(graph.map, 'start', 'end');

      const optimizedSegs = [];
      for (let i = 1; i < path.length - 1; i++) {
        optimizedSegs.push(graph.table[path[i]].node);
      }

      return exports.fromArray(mergeSegments(optimizedSegs))
    };

    /**
     * Splits a string in various segments with the modes which
     * best represent their content.
     * The produced segments are far from being optimized.
     * The output of this function is only used to estimate a QR Code version
     * which may contain the data.
     *
     * @param  {string} data Input string
     * @return {Array}       Array of segments
     */
    exports.rawSplit = function rawSplit (data) {
      return exports.fromArray(
        getSegmentsFromString(data)
      )
    };
    });

    /**
     * QRCode for JavaScript
     *
     * modified by Ryan Day for nodejs support
     * Copyright (c) 2011 Ryan Day
     *
     * Licensed under the MIT license:
     *   http://www.opensource.org/licenses/mit-license.php
     *
    //---------------------------------------------------------------------
    // QRCode for JavaScript
    //
    // Copyright (c) 2009 Kazuhiko Arase
    //
    // URL: http://www.d-project.com/
    //
    // Licensed under the MIT license:
    //   http://www.opensource.org/licenses/mit-license.php
    //
    // The word "QR Code" is registered trademark of
    // DENSO WAVE INCORPORATED
    //   http://www.denso-wave.com/qrcode/faqpatent-e.html
    //
    //---------------------------------------------------------------------
    */

    /**
     * Add finder patterns bits to matrix
     *
     * @param  {BitMatrix} matrix  Modules matrix
     * @param  {Number}    version QR Code version
     */
    function setupFinderPattern (matrix, version) {
      const size = matrix.size;
      const pos = finderPattern.getPositions(version);

      for (let i = 0; i < pos.length; i++) {
        const row = pos[i][0];
        const col = pos[i][1];

        for (let r = -1; r <= 7; r++) {
          if (row + r <= -1 || size <= row + r) continue

          for (let c = -1; c <= 7; c++) {
            if (col + c <= -1 || size <= col + c) continue

            if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
              (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
              (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
              matrix.set(row + r, col + c, true, true);
            } else {
              matrix.set(row + r, col + c, false, true);
            }
          }
        }
      }
    }

    /**
     * Add timing pattern bits to matrix
     *
     * Note: this function must be called before {@link setupAlignmentPattern}
     *
     * @param  {BitMatrix} matrix Modules matrix
     */
    function setupTimingPattern (matrix) {
      const size = matrix.size;

      for (let r = 8; r < size - 8; r++) {
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
      }
    }

    /**
     * Add alignment patterns bits to matrix
     *
     * Note: this function must be called after {@link setupTimingPattern}
     *
     * @param  {BitMatrix} matrix  Modules matrix
     * @param  {Number}    version QR Code version
     */
    function setupAlignmentPattern (matrix, version) {
      const pos = alignmentPattern.getPositions(version);

      for (let i = 0; i < pos.length; i++) {
        const row = pos[i][0];
        const col = pos[i][1];

        for (let r = -2; r <= 2; r++) {
          for (let c = -2; c <= 2; c++) {
            if (r === -2 || r === 2 || c === -2 || c === 2 ||
              (r === 0 && c === 0)) {
              matrix.set(row + r, col + c, true, true);
            } else {
              matrix.set(row + r, col + c, false, true);
            }
          }
        }
      }
    }

    /**
     * Add version info bits to matrix
     *
     * @param  {BitMatrix} matrix  Modules matrix
     * @param  {Number}    version QR Code version
     */
    function setupVersionInfo (matrix, version$1) {
      const size = matrix.size;
      const bits = version.getEncodedBits(version$1);
      let row, col, mod;

      for (let i = 0; i < 18; i++) {
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = ((bits >> i) & 1) === 1;

        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
      }
    }

    /**
     * Add format info bits to matrix
     *
     * @param  {BitMatrix} matrix               Modules matrix
     * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
     * @param  {Number}    maskPattern          Mask pattern reference value
     */
    function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
      const size = matrix.size;
      const bits = formatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
      let i, mod;

      for (i = 0; i < 15; i++) {
        mod = ((bits >> i) & 1) === 1;

        // vertical
        if (i < 6) {
          matrix.set(i, 8, mod, true);
        } else if (i < 8) {
          matrix.set(i + 1, 8, mod, true);
        } else {
          matrix.set(size - 15 + i, 8, mod, true);
        }

        // horizontal
        if (i < 8) {
          matrix.set(8, size - i - 1, mod, true);
        } else if (i < 9) {
          matrix.set(8, 15 - i - 1 + 1, mod, true);
        } else {
          matrix.set(8, 15 - i - 1, mod, true);
        }
      }

      // fixed module
      matrix.set(size - 8, 8, 1, true);
    }

    /**
     * Add encoded data bits to matrix
     *
     * @param  {BitMatrix}  matrix Modules matrix
     * @param  {Uint8Array} data   Data codewords
     */
    function setupData (matrix, data) {
      const size = matrix.size;
      let inc = -1;
      let row = size - 1;
      let bitIndex = 7;
      let byteIndex = 0;

      for (let col = size - 1; col > 0; col -= 2) {
        if (col === 6) col--;

        while (true) {
          for (let c = 0; c < 2; c++) {
            if (!matrix.isReserved(row, col - c)) {
              let dark = false;

              if (byteIndex < data.length) {
                dark = (((data[byteIndex] >>> bitIndex) & 1) === 1);
              }

              matrix.set(row, col - c, dark);
              bitIndex--;

              if (bitIndex === -1) {
                byteIndex++;
                bitIndex = 7;
              }
            }
          }

          row += inc;

          if (row < 0 || size <= row) {
            row -= inc;
            inc = -inc;
            break
          }
        }
      }
    }

    /**
     * Create encoded codewords from data input
     *
     * @param  {Number}   version              QR Code version
     * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
     * @param  {ByteData} data                 Data input
     * @return {Uint8Array}                    Buffer containing encoded codewords
     */
    function createData (version, errorCorrectionLevel, segments) {
      // Prepare data buffer
      const buffer = new bitBuffer();

      segments.forEach(function (data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);

        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), mode.getCharCountIndicator(data.mode, version));

        // add binary data sequence to buffer
        data.write(buffer);
      });

      // Calculate required number of bits
      const totalCodewords = utils$1.getSymbolTotalCodewords(version);
      const ecTotalCodewords = errorCorrectionCode.getTotalCodewordsCount(version, errorCorrectionLevel);
      const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

      // Add a terminator.
      // If the bit string is shorter than the total number of required bits,
      // a terminator of up to four 0s must be added to the right side of the string.
      // If the bit string is more than four bits shorter than the required number of bits,
      // add four 0s to the end.
      if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
        buffer.put(0, 4);
      }

      // If the bit string is fewer than four bits shorter, add only the number of 0s that
      // are needed to reach the required number of bits.

      // After adding the terminator, if the number of bits in the string is not a multiple of 8,
      // pad the string on the right with 0s to make the string's length a multiple of 8.
      while (buffer.getLengthInBits() % 8 !== 0) {
        buffer.putBit(0);
      }

      // Add pad bytes if the string is still shorter than the total number of required bits.
      // Extend the buffer to fill the data capacity of the symbol corresponding to
      // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
      // and 00010001 (0x11) alternately.
      const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
      for (let i = 0; i < remainingByte; i++) {
        buffer.put(i % 2 ? 0x11 : 0xEC, 8);
      }

      return createCodewords(buffer, version, errorCorrectionLevel)
    }

    /**
     * Encode input data with Reed-Solomon and return codewords with
     * relative error correction bits
     *
     * @param  {BitBuffer} bitBuffer            Data to encode
     * @param  {Number}    version              QR Code version
     * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
     * @return {Uint8Array}                     Buffer containing encoded codewords
     */
    function createCodewords (bitBuffer, version, errorCorrectionLevel) {
      // Total codewords for this QR code version (Data + Error correction)
      const totalCodewords = utils$1.getSymbolTotalCodewords(version);

      // Total number of error correction codewords
      const ecTotalCodewords = errorCorrectionCode.getTotalCodewordsCount(version, errorCorrectionLevel);

      // Total number of data codewords
      const dataTotalCodewords = totalCodewords - ecTotalCodewords;

      // Total number of blocks
      const ecTotalBlocks = errorCorrectionCode.getBlocksCount(version, errorCorrectionLevel);

      // Calculate how many blocks each group should contain
      const blocksInGroup2 = totalCodewords % ecTotalBlocks;
      const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;

      const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);

      const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
      const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;

      // Number of EC codewords is the same for both groups
      const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;

      // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
      const rs = new reedSolomonEncoder(ecCount);

      let offset = 0;
      const dcData = new Array(ecTotalBlocks);
      const ecData = new Array(ecTotalBlocks);
      let maxDataSize = 0;
      const buffer = new Uint8Array(bitBuffer.buffer);

      // Divide the buffer into the required number of blocks
      for (let b = 0; b < ecTotalBlocks; b++) {
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;

        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);

        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);

        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
      }

      // Create final data
      // Interleave the data and error correction codewords from each block
      const data = new Uint8Array(totalCodewords);
      let index = 0;
      let i, r;

      // Add data codewords
      for (i = 0; i < maxDataSize; i++) {
        for (r = 0; r < ecTotalBlocks; r++) {
          if (i < dcData[r].length) {
            data[index++] = dcData[r][i];
          }
        }
      }

      // Apped EC codewords
      for (i = 0; i < ecCount; i++) {
        for (r = 0; r < ecTotalBlocks; r++) {
          data[index++] = ecData[r][i];
        }
      }

      return data
    }

    /**
     * Build QR Code symbol
     *
     * @param  {String} data                 Input string
     * @param  {Number} version              QR Code version
     * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
     * @param  {MaskPattern} maskPattern     Mask pattern
     * @return {Object}                      Object containing symbol data
     */
    function createSymbol (data, version$1, errorCorrectionLevel, maskPattern$1) {
      let segments$1;

      if (Array.isArray(data)) {
        segments$1 = segments.fromArray(data);
      } else if (typeof data === 'string') {
        let estimatedVersion = version$1;

        if (!estimatedVersion) {
          const rawSegments = segments.rawSplit(data);

          // Estimate best version that can contain raw splitted segments
          estimatedVersion = version.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }

        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments$1 = segments.fromString(data, estimatedVersion || 40);
      } else {
        throw new Error('Invalid data')
      }

      // Get the min version that can contain data
      const bestVersion = version.getBestVersionForData(segments$1, errorCorrectionLevel);

      // If no version is found, data cannot be stored
      if (!bestVersion) {
        throw new Error('The amount of data is too big to be stored in a QR Code')
      }

      // If not specified, use min version as default
      if (!version$1) {
        version$1 = bestVersion;

      // Check if the specified version can contain the data
      } else if (version$1 < bestVersion) {
        throw new Error('\n' +
          'The chosen QR Code version cannot contain this amount of data.\n' +
          'Minimum version required to store current data is: ' + bestVersion + '.\n'
        )
      }

      const dataBits = createData(version$1, errorCorrectionLevel, segments$1);

      // Allocate matrix buffer
      const moduleCount = utils$1.getSymbolSize(version$1);
      const modules = new bitMatrix(moduleCount);

      // Add function modules
      setupFinderPattern(modules, version$1);
      setupTimingPattern(modules);
      setupAlignmentPattern(modules, version$1);

      // Add temporary dummy bits for format info just to set them as reserved.
      // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
      // since the masking operation must be performed only on the encoding region.
      // These blocks will be replaced with correct values later in code.
      setupFormatInfo(modules, errorCorrectionLevel, 0);

      if (version$1 >= 7) {
        setupVersionInfo(modules, version$1);
      }

      // Add data codewords
      setupData(modules, dataBits);

      if (isNaN(maskPattern$1)) {
        // Find best mask pattern
        maskPattern$1 = maskPattern.getBestMask(modules,
          setupFormatInfo.bind(null, modules, errorCorrectionLevel));
      }

      // Apply mask pattern
      maskPattern.applyMask(maskPattern$1, modules);

      // Replace format info bits with correct values
      setupFormatInfo(modules, errorCorrectionLevel, maskPattern$1);

      return {
        modules: modules,
        version: version$1,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern$1,
        segments: segments$1
      }
    }

    /**
     * QR Code
     *
     * @param {String | Array} data                 Input data
     * @param {Object} options                      Optional configurations
     * @param {Number} options.version              QR Code version
     * @param {String} options.errorCorrectionLevel Error correction level
     * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
     */
    var create$1 = function create (data, options) {
      if (typeof data === 'undefined' || data === '') {
        throw new Error('No input text')
      }

      let errorCorrectionLevel$1 = errorCorrectionLevel.M;
      let version$1;
      let mask;

      if (typeof options !== 'undefined') {
        // Use higher error correction level as default
        errorCorrectionLevel$1 = errorCorrectionLevel.from(options.errorCorrectionLevel, errorCorrectionLevel.M);
        version$1 = version.from(options.version);
        mask = maskPattern.from(options.maskPattern);

        if (options.toSJISFunc) {
          utils$1.setToSJISFunction(options.toSJISFunc);
        }
      }

      return createSymbol(data, version$1, errorCorrectionLevel$1, mask)
    };

    var qrcode = {
    	create: create$1
    };

    var utils = createCommonjsModule(function (module, exports) {
    function hex2rgba (hex) {
      if (typeof hex === 'number') {
        hex = hex.toString();
      }

      if (typeof hex !== 'string') {
        throw new Error('Color should be defined as hex string')
      }

      let hexCode = hex.slice().replace('#', '').split('');
      if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
        throw new Error('Invalid hex color: ' + hex)
      }

      // Convert from short to long form (fff -> ffffff)
      if (hexCode.length === 3 || hexCode.length === 4) {
        hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
          return [c, c]
        }));
      }

      // Add default alpha value
      if (hexCode.length === 6) hexCode.push('F', 'F');

      const hexValue = parseInt(hexCode.join(''), 16);

      return {
        r: (hexValue >> 24) & 255,
        g: (hexValue >> 16) & 255,
        b: (hexValue >> 8) & 255,
        a: hexValue & 255,
        hex: '#' + hexCode.slice(0, 6).join('')
      }
    }

    exports.getOptions = function getOptions (options) {
      if (!options) options = {};
      if (!options.color) options.color = {};

      const margin = typeof options.margin === 'undefined' ||
        options.margin === null ||
        options.margin < 0
        ? 4
        : options.margin;

      const width = options.width && options.width >= 21 ? options.width : undefined;
      const scale = options.scale || 4;

      return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
          dark: hex2rgba(options.color.dark || '#000000ff'),
          light: hex2rgba(options.color.light || '#ffffffff')
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
      }
    };

    exports.getScale = function getScale (qrSize, opts) {
      return opts.width && opts.width >= qrSize + opts.margin * 2
        ? opts.width / (qrSize + opts.margin * 2)
        : opts.scale
    };

    exports.getImageWidth = function getImageWidth (qrSize, opts) {
      const scale = exports.getScale(qrSize, opts);
      return Math.floor((qrSize + opts.margin * 2) * scale)
    };

    exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
      const size = qr.modules.size;
      const data = qr.modules.data;
      const scale = exports.getScale(size, opts);
      const symbolSize = Math.floor((size + opts.margin * 2) * scale);
      const scaledMargin = opts.margin * scale;
      const palette = [opts.color.light, opts.color.dark];

      for (let i = 0; i < symbolSize; i++) {
        for (let j = 0; j < symbolSize; j++) {
          let posDst = (i * symbolSize + j) * 4;
          let pxColor = opts.color.light;

          if (i >= scaledMargin && j >= scaledMargin &&
            i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
          }

          imgData[posDst++] = pxColor.r;
          imgData[posDst++] = pxColor.g;
          imgData[posDst++] = pxColor.b;
          imgData[posDst] = pxColor.a;
        }
      }
    };
    });

    var canvas = createCommonjsModule(function (module, exports) {
    function clearCanvas (ctx, canvas, size) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (!canvas.style) canvas.style = {};
      canvas.height = size;
      canvas.width = size;
      canvas.style.height = size + 'px';
      canvas.style.width = size + 'px';
    }

    function getCanvasElement () {
      try {
        return document.createElement('canvas')
      } catch (e) {
        throw new Error('You need to specify a canvas element')
      }
    }

    exports.render = function render (qrData, canvas, options) {
      let opts = options;
      let canvasEl = canvas;

      if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
      }

      if (!canvas) {
        canvasEl = getCanvasElement();
      }

      opts = utils.getOptions(opts);
      const size = utils.getImageWidth(qrData.modules.size, opts);

      const ctx = canvasEl.getContext('2d');
      const image = ctx.createImageData(size, size);
      utils.qrToImageData(image.data, qrData, opts);

      clearCanvas(ctx, canvasEl, size);
      ctx.putImageData(image, 0, 0);

      return canvasEl
    };

    exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
      let opts = options;

      if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
      }

      if (!opts) opts = {};

      const canvasEl = exports.render(qrData, canvas, opts);

      const type = opts.type || 'image/png';
      const rendererOpts = opts.rendererOpts || {};

      return canvasEl.toDataURL(type, rendererOpts.quality)
    };
    });

    function getColorAttrib (color, attrib) {
      const alpha = color.a / 255;
      const str = attrib + '="' + color.hex + '"';

      return alpha < 1
        ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
        : str
    }

    function svgCmd (cmd, x, y) {
      let str = cmd + x;
      if (typeof y !== 'undefined') str += ' ' + y;

      return str
    }

    function qrToPath (data, size, margin) {
      let path = '';
      let moveBy = 0;
      let newRow = false;
      let lineLength = 0;

      for (let i = 0; i < data.length; i++) {
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);

        if (!col && !newRow) newRow = true;

        if (data[i]) {
          lineLength++;

          if (!(i > 0 && col > 0 && data[i - 1])) {
            path += newRow
              ? svgCmd('M', col + margin, 0.5 + row + margin)
              : svgCmd('m', moveBy, 0);

            moveBy = 0;
            newRow = false;
          }

          if (!(col + 1 < size && data[i + 1])) {
            path += svgCmd('h', lineLength);
            lineLength = 0;
          }
        } else {
          moveBy++;
        }
      }

      return path
    }

    var render = function render (qrData, options, cb) {
      const opts = utils.getOptions(options);
      const size = qrData.modules.size;
      const data = qrData.modules.data;
      const qrcodesize = size + opts.margin * 2;

      const bg = !opts.color.light.a
        ? ''
        : '<path ' + getColorAttrib(opts.color.light, 'fill') +
          ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';

      const path =
        '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
        ' d="' + qrToPath(data, size, opts.margin) + '"/>';

      const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"';

      const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';

      const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';

      if (typeof cb === 'function') {
        cb(null, svgTag);
      }

      return svgTag
    };

    var svgTag = {
    	render: render
    };

    function renderCanvas (renderFunc, canvas, text, opts, cb) {
      const args = [].slice.call(arguments, 1);
      const argsNum = args.length;
      const isLastArgCb = typeof args[argsNum - 1] === 'function';

      if (!isLastArgCb && !canPromise()) {
        throw new Error('Callback required as last argument')
      }

      if (isLastArgCb) {
        if (argsNum < 2) {
          throw new Error('Too few arguments provided')
        }

        if (argsNum === 2) {
          cb = text;
          text = canvas;
          canvas = opts = undefined;
        } else if (argsNum === 3) {
          if (canvas.getContext && typeof cb === 'undefined') {
            cb = opts;
            opts = undefined;
          } else {
            cb = opts;
            opts = text;
            text = canvas;
            canvas = undefined;
          }
        }
      } else {
        if (argsNum < 1) {
          throw new Error('Too few arguments provided')
        }

        if (argsNum === 1) {
          text = canvas;
          canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
          opts = text;
          text = canvas;
          canvas = undefined;
        }

        return new Promise(function (resolve, reject) {
          try {
            const data = qrcode.create(text, opts);
            resolve(renderFunc(data, canvas, opts));
          } catch (e) {
            reject(e);
          }
        })
      }

      try {
        const data = qrcode.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
      } catch (e) {
        cb(e);
      }
    }

    var create = qrcode.create;
    var toCanvas = renderCanvas.bind(null, canvas.render);
    var toDataURL = renderCanvas.bind(null, canvas.renderToDataURL);

    // only svg for now.
    var toString_1 = renderCanvas.bind(null, function (data, _, opts) {
      return svgTag.render(data, opts)
    });

    var browser = {
    	create: create,
    	toCanvas: toCanvas,
    	toDataURL: toDataURL,
    	toString: toString_1
    };

    /**
     * Class to help with node & page binding.
     * The selected node is what kbTree binds to, and is also what configuratorController
     * sets when trying to set the active page through code or the rules. The selected page
     * is what drives which page is shown and is not necessarily the same thing.
     * There is a special case for nested configurators when they only have one visible page
     * (with no visible children of the page) that we try to show the nested configurator as
     * one node (instead of a node for the configurator, and another child node for the page).
     */
    var SelectedBinding = /** @class */ (function () {
        function SelectedBinding() {
            this.pageChanged = new enums.PropertyChangedEvent();
            this.overlayPopupChanged = new enums.PropertyChangedEvent();
        }
        Object.defineProperty(SelectedBinding.prototype, "page", {
            get: function () {
                return this._page;
            },
            enumerable: false,
            configurable: true
        });
        /**
         * private routine to set the page as consumers should all set the node
         * @param newPage
         */
        SelectedBinding.prototype.setPage = function (newPage) {
            var oldPage = this._page;
            var changed = oldPage !== newPage;
            this._page = newPage;
            if (changed)
                this.pageChanged.trigger({ oldValue: oldPage, newValue: newPage, property: 'page' });
        };
        Object.defineProperty(SelectedBinding.prototype, "overlayPopup", {
            get: function () {
                return this._overlayPopup;
            },
            set: function (newPopup) {
                var oldPopup = this._overlayPopup;
                var changed = oldPopup !== newPopup;
                this._overlayPopup = newPopup;
                if (changed) {
                    this.overlayPopupChanged.trigger({
                        oldValue: oldPopup,
                        newValue: newPopup,
                        property: "overlayPopup"
                    });
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SelectedBinding.prototype, "node", {
            get: function () {
                return this._node;
            },
            set: function (newNode) {
                if (newNode instanceof enums.Configurator) {
                    var firstPage = newNode.pages.find(function (p) { return p.visible; });
                    if (firstPage) {
                        newNode = firstPage;
                    }
                }
                var oldNode = this._node;
                var changed = oldNode !== newNode;
                this._node = newNode;
                if (changed) {
                    var parentConfig = newNode instanceof enums.Configurator ? newNode : newNode.$parentConfigurator;
                    if (this.isSingleNode(parentConfig)) {
                        this._node = parentConfig;
                        this.setPage(newNode);
                    }
                    else {
                        this._node = newNode;
                        this.setPage(newNode);
                    }
                }
            },
            enumerable: false,
            configurable: true
        });
        /**
         * if this is the special case where a nested config is shown as a single node because it has only one visible page
         * @param tab
         */
        SelectedBinding.prototype.isSingleNode = function (tab) {
            return (tab.$parent &&
                !tab.pages.some(function (p) { return p.pages.some(function (p2) { return p2.visible; }) || p.configurators.length > 0; }) &&
                tab.pages.filter(function (p) { return p.visible; }).length == 1);
        };
        return SelectedBinding;
    }());
    var ConfiguratorRuleArgs = /** @class */ (function () {
        function ConfiguratorRuleArgs(ctrl) {
            this.ctrl = ctrl;
            this.activeUrl = window.location.href;
            this.isMobile = ctrl.$rootScope.windowWidth < _tools.Utils.MOBILE_WIDTH;
            this.windowWidth = ctrl.$rootScope.windowWidth;
            this.windowHeight = ctrl.$rootScope.windowHeight;
        }
        ConfiguratorRuleArgs.prototype.getTables = function (args) {
            var _this = this;
            return new _rules.KPromise(args.ids.map(function (tid) { return _this.ctrl.helper.tableArraysDb[tid]; }));
        };
        ConfiguratorRuleArgs.prototype.upload = function () {
            var _this = this;
            return this.ctrl.uploadService.promptUserToChooseFile().then(function (file) {
                return _this.ctrl.$scope.upload(file, null);
            });
        };
        ConfiguratorRuleArgs.prototype.sendMessage = function (msg) {
            // send message to embed consumer
            _tools.Utils.sendMessageToParent(msg);
            this.ctrl.sfdcService.sendMessage(msg);
        };
        ConfiguratorRuleArgs.prototype.callSafeFunction = function (obj) {
            return this.ctrl.api.safeFunctions.run(obj.safeFunctionId, obj.parameters, this.ctrl.$rootScope.contentTracker);
        };
        ConfiguratorRuleArgs.prototype.callGlobalFunction = function (name) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (args.length > 0) {
                return new _rules.KPromise(name.apply(void 0, args));
            }
            return new _rules.KPromise(name());
        };
        ConfiguratorRuleArgs.prototype.startIntervalFunction = function (id, timeSeconds) {
            return this.ctrl.runContinuousAsyncRule(id, timeSeconds);
        };
        ConfiguratorRuleArgs.prototype.stopIntervalFunction = function (id) {
            this.ctrl.cancelScheduledRule(id);
        };
        ConfiguratorRuleArgs.prototype.startTimeoutFunction = function (func, timeSeconds) {
            this.ctrl.runTimeoutRule(func, timeSeconds);
        };
        ConfiguratorRuleArgs.prototype.convertCurrency = function (obj) {
            return this.ctrl.kbService.fxConvertAsync(obj.amount, obj.currencyCode);
        };
        ConfiguratorRuleArgs.prototype.generateNumber = function (args) {
            return this.ctrl.api.generators.next(args.generatorId, this.ctrl.$rootScope.contentTracker);
        };
        ConfiguratorRuleArgs.prototype.selectPage = function (page) {
            var _this = this;
            this.ctrl.$timeout(function () { return _this.ctrl.selectNode(page); });
        };
        ConfiguratorRuleArgs.prototype.selectOverlayPopup = function (popup) {
            var _this = this;
            this.ctrl.$timeout(function () { return _this.ctrl.selectOverlayPopup(popup); });
        };
        ConfiguratorRuleArgs.prototype.navigateToElement = function (elem) {
            this.ctrl.navigateToElement(elem);
        };
        ConfiguratorRuleArgs.prototype.nextPage = function () {
            var _this = this;
            this.ctrl.$timeout(function () { return _this.ctrl.$scope.nextPage(); });
        };
        ConfiguratorRuleArgs.prototype.backPage = function () {
            var _this = this;
            this.ctrl.$timeout(function () { return _this.ctrl.$scope.backPage(); });
        };
        ConfiguratorRuleArgs.prototype.runSceneAction = function (name) {
            return this.ctrl.runSceneAction(this.configurator, name);
        };
        ConfiguratorRuleArgs.prototype.callSceneFunction = function (args) {
            var sv = this.ctrl.$scope.activeSceneViewer;
            if (sv && sv instanceof Kb3dViewer) {
                return sv.runSceneFunction(args, this.configurator).then(function (r) { return r.parameters.returnValue; });
            }
            console.warn("Scene function ".concat(args.name, " was called but a scene is not loaded."));
            return Promise.resolve(null);
        };
        ConfiguratorRuleArgs.prototype.setScene = function (args) {
            return this.ctrl.setScene(this.configurator, args.idScene);
        };
        ConfiguratorRuleArgs.prototype.runNamingRule = function () {
            return this.ctrl.helper.runRuleTypeAsync(this.configurator, enums.eRuleType.naming);
        };
        ConfiguratorRuleArgs.prototype.addNestedConfigurator = function (idProduct, idParent, name, fields) {
            // this call already came from a rule, so we don't need to run the oncePerRuleCycle here
            return this.ctrl.addNestedConfig(idProduct, this.configurator.$manager.get(idParent), false, name, fields);
        };
        ConfiguratorRuleArgs.prototype.copyNestedConfigurator = function (nested, idParent, name) {
            var sourceConfig = nested;
            if (angular__namespace.isString(nested)) {
                sourceConfig = this.configurator.$manager.getByName(nested, false);
            }
            return this.ctrl.copyNestedConfig(sourceConfig, this.configurator.$manager.get(idParent), false, name);
        };
        ConfiguratorRuleArgs.prototype.setNumberOfNestedConfigurators = function (idProduct, idParent, n) {
            return this.ctrl.setNumberOfNestedConfigs(idProduct, this.configurator.$manager.get(idParent), n);
        };
        ConfiguratorRuleArgs.prototype.removeNestedConfigurator = function (nested) {
            var nestedConfig = nested;
            if (angular__namespace.isString(nested)) {
                nestedConfig = this.configurator.$manager.getByName(nested, false);
            }
            return this.ctrl.removeNestedConfig(nestedConfig);
        };
        ConfiguratorRuleArgs.prototype.showPriceDetails = function () {
            this.ctrl.$scope.showPricing();
        };
        ConfiguratorRuleArgs.prototype.alert = function (args) {
            this.ctrl.dialogService.alert(args);
        };
        ConfiguratorRuleArgs.prototype.getOptionFilterSource = function (idOptionFilter, fromConfigurator) {
            fromConfigurator = fromConfigurator || this.configurator;
            var f = fromConfigurator.$manager.get(idOptionFilter);
            return new _rules.KPromise(f ? f.$source : []);
        };
        ConfiguratorRuleArgs.prototype.setLayoutSetting = function (id, value) {
            if (!this.configurator.isNested()) {
                //nested configurators should not be able to override the root's layout settings
                var s = this.layoutConfig.$manager.getByIdOrName(id, true);
                var origValue = s.value;
                s.value = value;
                if (origValue != s.value) {
                    this.layoutConfig.$layoutSettingsDirty = true;
                }
            }
        };
        ConfiguratorRuleArgs.prototype.getLayoutSetting = function (id) {
            var s = this.layoutConfig.$manager.getByIdOrName(id, true);
            return s.value;
        };
        ConfiguratorRuleArgs.prototype.toggleFullscreen = function () {
            this.ctrl.$rootScope.toggleFullscreen();
        };
        ConfiguratorRuleArgs.prototype.runConfiguredProduct = function (configProd) {
            //run the configured product after this rule has ended
            this.ctrl.runConfiguredProduct(this.configurator, configProd);
        };
        ConfiguratorRuleArgs.prototype.compressString = function (input) {
            return __awaiter(this, void 0, void 0, function () {
                var encoder, encodedInput, stream, compressedReadableStream, reader, chunks, done, _a, value, streamDone, compressedData, offset, _i, chunks_1, chunk, binaryString, i, base64String;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            encoder = new TextEncoder();
                            encodedInput = encoder.encode(input);
                            stream = new ReadableStream({
                                start: function (controller) {
                                    controller.enqueue(encodedInput);
                                    controller.close();
                                }
                            });
                            compressedReadableStream = stream.pipeThrough(new CompressionStream("gzip"));
                            reader = compressedReadableStream.getReader();
                            chunks = [];
                            done = false;
                            _b.label = 1;
                        case 1:
                            if (!!done) return [3 /*break*/, 3];
                            return [4 /*yield*/, reader.read()];
                        case 2:
                            _a = _b.sent(), value = _a.value, streamDone = _a.done;
                            if (value) {
                                chunks.push(value);
                            }
                            done = streamDone;
                            return [3 /*break*/, 1];
                        case 3:
                            compressedData = new Uint8Array(chunks.reduce(function (acc, chunk) { return acc + chunk.length; }, 0));
                            offset = 0;
                            for (_i = 0, chunks_1 = chunks; _i < chunks_1.length; _i++) {
                                chunk = chunks_1[_i];
                                compressedData.set(chunk, offset);
                                offset += chunk.length;
                            }
                            binaryString = "";
                            for (i = 0; i < compressedData.length; i++) {
                                binaryString += String.fromCharCode(compressedData[i]);
                            }
                            base64String = btoa(binaryString);
                            return [2 /*return*/, base64String];
                    }
                });
            });
        };
        ConfiguratorRuleArgs.prototype.decompressString = function (input) {
            return __awaiter(this, void 0, void 0, function () {
                var binaryString, compressedData, i, stream, decompressedReadableStream, reader, chunks, done, _a, value, streamDone, decompressedData, offset, _i, chunks_2, chunk, decoder;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            binaryString = atob(input);
                            compressedData = new Uint8Array(binaryString.length);
                            for (i = 0; i < binaryString.length; i++) {
                                compressedData[i] = binaryString.charCodeAt(i);
                            }
                            stream = new ReadableStream({
                                start: function (controller) {
                                    controller.enqueue(compressedData);
                                    controller.close();
                                }
                            });
                            decompressedReadableStream = stream.pipeThrough(new DecompressionStream("gzip"));
                            reader = decompressedReadableStream.getReader();
                            chunks = [];
                            done = false;
                            _b.label = 1;
                        case 1:
                            if (!!done) return [3 /*break*/, 3];
                            return [4 /*yield*/, reader.read()];
                        case 2:
                            _a = _b.sent(), value = _a.value, streamDone = _a.done;
                            if (value) {
                                chunks.push(value);
                            }
                            done = streamDone;
                            return [3 /*break*/, 1];
                        case 3:
                            decompressedData = new Uint8Array(chunks.reduce(function (acc, chunk) { return acc + chunk.length; }, 0));
                            offset = 0;
                            for (_i = 0, chunks_2 = chunks; _i < chunks_2.length; _i++) {
                                chunk = chunks_2[_i];
                                decompressedData.set(chunk, offset);
                                offset += chunk.length;
                            }
                            decoder = new TextDecoder();
                            return [2 /*return*/, decoder.decode(decompressedData)];
                    }
                });
            });
        };
        ConfiguratorRuleArgs.prototype.setDrawerVisibility = function (visible) {
            this.ctrl.drawerService.visible = visible;
        };
        return ConfiguratorRuleArgs;
    }());
    var SvgRuleArgs = /** @class */ (function (_super) {
        __extends(SvgRuleArgs, _super);
        function SvgRuleArgs() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return SvgRuleArgs;
    }(ConfiguratorRuleArgs));
    var HtmlRuleArgs = /** @class */ (function (_super) {
        __extends(HtmlRuleArgs, _super);
        function HtmlRuleArgs() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return HtmlRuleArgs;
    }(ConfiguratorRuleArgs));
    var ConfiguratorController = /** @class */ (function (_super) {
        __extends(ConfiguratorController, _super);
        function ConfiguratorController($scope, $q, $location, $state, $stateParams, $http, $rootScope, $window, $compile, $injector, dialogService, $timeout, $interval, $filter, drawerService, ruleService, uploadService, authService, quoteService, promiseTracker, api, themeService, sfdcService, kbService, telemetryService, interactionService, ocLazyLoad) {
            var _this = _super.call(this) || this;
            _this.$scope = $scope;
            _this.$q = $q;
            _this.$location = $location;
            _this.$state = $state;
            _this.$stateParams = $stateParams;
            _this.$http = $http;
            _this.$rootScope = $rootScope;
            _this.$window = $window;
            _this.$compile = $compile;
            _this.$injector = $injector;
            _this.dialogService = dialogService;
            _this.$timeout = $timeout;
            _this.$interval = $interval;
            _this.$filter = $filter;
            _this.drawerService = drawerService;
            _this.ruleService = ruleService;
            _this.uploadService = uploadService;
            _this.authService = authService;
            _this.quoteService = quoteService;
            _this.promiseTracker = promiseTracker;
            _this.api = api;
            _this.themeService = themeService;
            _this.sfdcService = sfdcService;
            _this.kbService = kbService;
            _this.telemetryService = telemetryService;
            _this.interactionService = interactionService;
            _this.ocLazyLoad = ocLazyLoad;
            _this.runAsyncRule = true;
            // a cache of scene sessions in case the configurator loads the same scene multiple times
            _this.sceneDb = {};
            _this.productDb = {};
            _this.translationDb = {};
            _this.sceneViewerDb = {}; // holds a map of sceneViewer's to the scene id
            _this.loading = true; // whether the configurator is currently loading
            _this.runningRules = {};
            $rootScope.setTitle(loc.configurator);
            _this.model = {};
            _this.configuratorLoadedDeferred = _this.$q.defer();
            _this.$scope.layoutLoaded = false;
            _this.$rootScope.contentTracker.addPromise(_this.configuratorLoadedDeferred.promise);
            var isScene = ($scope.isScene = $state.current.name == 'scene');
            var queryString = $location.search();
            $scope.isTest = false;
            if ($state.current.data) {
                $scope.isEdit = $state.current.data.viewType == enums.eViewType.edit;
                $scope.isNew = $state.current.data.viewType == enums.eViewType.new;
                $scope.isView = $state.current.data.viewType == enums.eViewType.view;
                $scope.isTest = $state.current.data.isTest == true;
            }
            if ($scope.isTest) {
                _this.drawerService.setHelpUrl('Configurators');
            }
            else {
                _this.drawerService.setHelpUrl(null);
            }
            // setup binding to handle selected page and node
            $scope.selected = new SelectedBinding();
            $scope.pricingTracker = promiseTracker();
            $scope.priceDialogTracker = promiseTracker();
            $scope.arLoading = promiseTracker();
            $scope.showSpinnerPricing = true;
            // $scope.showConfigHeader = (queryString.showconfigheader != "false");
            // $scope.showFields = (queryString.showfields != "false");
            $scope.showMove = queryString.showmove == 'true';
            $scope.isEmbed = _tools.Utils.isDefined(queryString.embedded);
            $scope.embedFields = queryString['fields'] ? JSON.parse(queryString['fields']) : null;
            $scope.embedLayoutSettings = queryString['layoutsettings'] ? JSON.parse(queryString['layoutsettings']) : null;
            $scope.embedParameters = queryString['parameters'] ? JSON.parse(queryString['parameters']) : null;
            $scope.embedCurrency = queryString['currency'];
            $scope.deferLoadedRule = queryString['deferLoadedRule'] == 'true';
            $scope.isKinetic = !!queryString['kineticCompany'];
            // only allow the embed currency if it's a defined company currency
            if (!_this.$rootScope.companyCurrencies.some(function (c) { return c.currency == $scope.embedCurrency; })) {
                $scope.embedCurrency = null;
            }
            $scope.actionsVisible = true;
            $scope.absUrl = $location.absUrl();
            $scope.isReadOnly = false;
            if ($scope.isEmbed) {
                $rootScope.hideDrawer = queryString.showdrawer != 'true';
                $rootScope.transparentBackground = queryString.transparentbackground == 'true';
            }
            if (_tools.Utils.isDefined(queryString.showheader) && queryString.showheader == 'false') {
                $rootScope.hideHeader = true;
            }
            _this.requestId = queryString.requestid;
            _this.helper = new ConfiguratorHelper({
                $http: _this.$http,
                $q: _this.$q,
                api: _this.api,
                dialogService: _this.dialogService,
                ruleService: _this.ruleService,
                tracker: _this.$rootScope.contentTracker,
                $rootScope: _this.$rootScope,
                getRuleArgs: function (c, f) { return _this.getRuleArgs(c, f); },
                showErrors: function () { return _this.showErrors(); },
            });
            $scope.translateKbo = function (o, prop) {
                if (o) {
                    if (_this.$rootScope.companySettings.defaultLanguage != _this.$rootScope.clientLanguage) {
                        var parentConfig = o instanceof enums.Configurator ? o : o.$parentConfigurator;
                        var configDb = _this.translationDb[parentConfig.idProduct || parentConfig.idScene];
                        if (configDb && configDb.hasOwnProperty(o.id) && configDb[o.id].hasOwnProperty(prop)) {
                            return configDb[o.id][prop];
                        }
                    }
                    var realProp = prop == 'name' ? '$label' : prop;
                    return o[realProp];
                }
                return '';
            };
            _this.getConfigurator().then(function (rootConfig) {
                if (rootConfig == null)
                    return;
                _this.rootConfig = $scope.config = $scope.tab = rootConfig;
                _this.$rootScope.setTitle(rootConfig.name);
                _this.interactionService.record(_this.rootConfig.idProduct);
                $scope.selected.pageChanged.add(function (args) {
                    // run the pageChanged rule
                    var pageParentConfig = args.newValue.$parentConfigurator;
                    var pageChangedArgs = _this.getRuleArgs(pageParentConfig);
                    pageChangedArgs.selectedPage = args.newValue;
                    if (window.location.href.includes('ar=true')) {
                        _this.enterArModal();
                    }
                    _this.trackConfigPageView(pageChangedArgs.selectedPage);
                    _this.queueRule(function () {
                        return _this.helper
                            .runRuleTypeAsync(pageParentConfig, enums.eRuleType.pageChanged, pageChangedArgs)
                            .then(function (r) {
                            // make sure all nodes are expanded
                            if (args.newValue) {
                                var parent_1 = args.newValue;
                                while (parent_1) {
                                    parent_1.$expanded = true;
                                    parent_1 = parent_1.$parent;
                                }
                            }
                            if (!_this.loading && pageParentConfig.getRuleJs(enums.eRuleType.pageChanged)) {
                                return _this.runRuleCycleUnit(pageParentConfig, null).then(function () {
                                    return _this.oncePerCycleRule();
                                });
                            }
                            else {
                                // refresh viewer so we can change scenes for
                                // nested configurators with scenes that aren't nesting
                                _this.getCurrentConfigForViewerAndSetViewerMode(); //set the viewermode before layout rule so it can show/hide the viewer accordingly
                                return _this.runLayoutRule(_this.$scope.config, _this.getRuleArgs(_this.$scope.config)).then(function () {
                                    return _this.refreshViewer(true).then(function () {
                                        // even if not running the value rule, we still need to
                                        // update the nodes for the next / back buttons
                                        _this.calculateNodes();
                                    });
                                });
                            }
                        });
                    });
                });
                $scope.selected.overlayPopupChanged.add(function (args) {
                    var popup = args.newValue;
                    if (!popup)
                        return;
                    // optional: run popupOpened rules
                    var popupArgs = _this.getRuleArgs(popup.$parentConfigurator);
                    popupArgs.selectedOverlayPopup = popup;
                    _this.queueRule(function () {
                        return _this.helper.runRuleTypeAsync(popup.$parentConfigurator, enums.eRuleType.value, popupArgs);
                    });
                });
                $scope.testBuild = function (build) {
                    _this.runSubmitRule().then(function () {
                        _this.helper.runRuleTypeAsync(_this.rootConfig, enums.eRuleType.naming);
                        var buildRuleArgs = _this.getRuleArgs(_this.rootConfig);
                        buildRuleArgs.build = build;
                        buildRuleArgs.quote = {
                            name: 'Test Quote',
                            id: 1,
                            ownedBy: _this.$rootScope.user.id,
                            owner: _this.$rootScope.user.firstName + ' ' + _this.$rootScope.user.lastName,
                            description: '',
                            currency: 'USD',
                        };
                        buildRuleArgs.quoteProduct = {
                            isConfigured: true,
                            id: 1,
                            qty: 1,
                            priceObject: _this.$scope.priceObject,
                            name: _this.rootConfig.name,
                            description: _this.rootConfig.description,
                            shortDescription: _this.rootConfig.shortDescription,
                        };
                        var displayDialog = function (queueId) {
                            var dialogScope = $rootScope.$new();
                            dialogScope.model = {
                                testBuildName: _this.rootConfig.name + ' ' + build.name + ' Test Build',
                                idQueue: queueId,
                            };
                            dialogScope.validation = {};
                            api.queues.search().then(function (r) { return (dialogScope.queues = r); });
                            dialogService.dialog({
                                template: Dirs.view('dialog-test-build'),
                                scope: dialogScope,
                                buttons: [
                                    new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                                        if (!dialogScope.model.testBuildName) {
                                            dialogScope.validation['testBuildName'] = 'Name is required';
                                            args.close = false;
                                            return;
                                        }
                                        if (dialogScope.model.testBuildName.length > 400) {
                                            dialogScope.validation['testBuildName'] =
                                                'Name must be less than 400 characters';
                                            args.close = false;
                                            return;
                                        }
                                        _this.api.testBuilds
                                            .insert({
                                            idBuildType: build.idBuildType,
                                            idProduct: parseInt($state.params.id, 10),
                                            name: dialogScope.model.testBuildName,
                                            idQueue: dialogScope.model.idQueue,
                                            configuredProduct: _this.rootConfig.getConfiguredProduct(),
                                            cloudBuild: build.cloudBuild,
                                            priceObject: _this.$scope.priceObject,
                                        }, _this.$rootScope.contentTracker)
                                            .then(function (testBuild) {
                                            dialogService.confirm('Your configurator is building ' +
                                                build.name +
                                                ' outputs. Would you like to go to the test build page?', function () {
                                                $state.go('kb.admin.testBuild', { id: testBuild.id });
                                            });
                                        });
                                    }),
                                    new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) { }),
                                ],
                            });
                        };
                        try {
                            _this.helper
                                .runRuleContainerAsync(build.ruleContainers.find(function (rc) { return rc.ruleType == enums.eRuleType.beforeBuild; }), buildRuleArgs)
                                .then(function (result) {
                                var queueId = result.parameters.build.idQueue;
                                displayDialog(queueId);
                            }, function () {
                                // We'll want to display the dialog even if this rule fails,
                                // since it's possible it's due to functionality that's only available in server-side rules.
                                displayDialog(build.idQueue);
                            });
                        }
                        catch (e) {
                            // We'll want to display the dialog even if this rule fails, since it's possible it's due to
                            // functionality that's only available in server-side rules.
                            displayDialog(build.idQueue);
                        }
                    });
                };
                $scope.getSubmitButtonText = function () {
                    return _this.$scope.config.submitButtonText ? _this.$scope.config.submitButtonText : loc.addtoquote;
                };
                $scope.getSubmitAndStayButtonText = function () {
                    return _this.$scope.config.submitAndStayButtonText
                        ? _this.$scope.config.submitAndStayButtonText
                        : loc.saveandstay;
                };
                $scope.getGenerateQrCodeText = function () {
                    return _this.$scope.config.generateQrCodeText
                        ? _this.$scope.config.generateQrCodeText
                        : loc.generateqrcode;
                };
                $scope.submitButtonClick = function () {
                    if ($scope.isEmbed) {
                        _tools.Utils.sendMessageToParent({ name: 'submit', data: {} });
                    }
                    else {
                        return _this.submit();
                    }
                };
                $scope.runFixThis = function (field, fix) {
                    return _this.queueRule(function () {
                        return new _rules.KPromise(fix.fix())
                            .then(function () { return _this.runRuleCycleUnit(field.$parentConfigurator, null); })
                            .then(function () { return _this.oncePerCycleRule(); });
                    });
                };
                var getTargetElementId = function ($event) {
                    var el = $event.target;
                    var elementId = el.id;
                    while (!elementId && el) {
                        if (el.tagName == 'svg')
                            break;
                        elementId = el.id;
                        el = el.parentElement;
                    }
                    return elementId;
                };
                var getSvgArgs = function (svgViewer, $event, $originalStartEvent) {
                    if ($originalStartEvent === void 0) { $originalStartEvent = null; }
                    var c = svgViewer.$parentConfigurator;
                    var args = _this.getRuleArgs(c);
                    args.elementId = getTargetElementId($event);
                    args.mouseX = $event.offsetX;
                    args.mouseY = $event.offsetY;
                    args.commitDrag = false;
                    if ($originalStartEvent) {
                        args.originMouseX = $originalStartEvent.offsetX;
                        args.originMouseY = $originalStartEvent.offsetY;
                        args.originElementId = getTargetElementId($originalStartEvent);
                    }
                    return args;
                };
                $scope.runSvgAction = function (svgViewer, $event) {
                    var rc = svgViewer.ruleContainers.find(function (rc) { return rc.ruleType == enums.eRuleType.svgViewer; });
                    if (rc) {
                        var args = getSvgArgs(svgViewer, $event);
                        return _this.queueEventRule(svgViewer.$parentConfigurator, rc, args);
                    }
                };
                var originalDragStartEvent = null;
                var svgViewerShouldEnablePanAfterDrag = false;
                $scope.svgDragStart = function (svgViewer, $event) {
                    var rc = svgViewer.ruleContainers.find(function (r) { return r.ruleType == enums.eRuleType.dragStart; });
                    if (rc) {
                        var args = getSvgArgs(svgViewer, $event, originalDragStartEvent);
                        return _this.helper.runRuleContainerAsync(rc, args).then(function (result) {
                            if (!result.hasError && result.parameters.commitDrag) {
                                originalDragStartEvent = $event;
                                svgViewerShouldEnablePanAfterDrag = !svgViewer.disablePan;
                                svgViewer.disablePan = true;
                            }
                        });
                    }
                };
                $scope.svgDragMove = function (svgViewer, $event) {
                    if (originalDragStartEvent) {
                        var rc = svgViewer.ruleContainers.find(function (r) { return r.ruleType == enums.eRuleType.dragMove; });
                        if (rc) {
                            var args = getSvgArgs(svgViewer, $event, originalDragStartEvent);
                            return _this.helper.runRuleContainerAsync(rc, args).then(function () { return $scope.$digest(); });
                        }
                    }
                };
                $scope.svgDragEnd = function (svgViewer, $event) {
                    if (originalDragStartEvent) {
                        var rc = svgViewer.ruleContainers.find(function (r) { return r.ruleType == enums.eRuleType.dragEnd; });
                        if (rc) {
                            var args = getSvgArgs(svgViewer, $event, originalDragStartEvent);
                            originalDragStartEvent = null;
                            svgViewer.disablePan = !svgViewerShouldEnablePanAfterDrag;
                            return _this.queueEventRule(svgViewer.$parentConfigurator, rc, args);
                        }
                    }
                };
                var getHtmlArgs = function (htmlViewer, $event, $originalStartEvent) {
                    var c = htmlViewer.$parentConfigurator;
                    var args = _this.getRuleArgs(c);
                    args.elementId = getTargetElementId($event);
                    args.mouseX = $event.offsetX;
                    args.mouseY = $event.offsetY;
                    return args;
                };
                $scope.runHtmlAction = function (html, $event) {
                    var rc = html.ruleContainers.find(function (rc) { return rc.ruleType == enums.eRuleType.html; });
                    if (rc) {
                        var args = getHtmlArgs(html, $event);
                        return _this.queueEventRule(html.$parentConfigurator, rc, args);
                    }
                };
                $scope.runFieldAction = function (field) {
                    if (isScene) {
                        return _this.$scope.activeSceneViewer && _this.$scope.activeSceneViewer.runFieldAction(field);
                    }
                    else {
                        return _this.queueEventRule(field.$parentConfigurator, field, _this.getRuleArgs(field.$parentConfigurator));
                    }
                };
                $scope.runAction = function (action) {
                    if (isScene) {
                        return _this.queueRule(function () { return _this.runSceneAction(_this.rootConfig, action.name); });
                    }
                    else {
                        return _this.queueEventRule(action.$parentConfigurator, action, _this.getRuleArgs(action.$parentConfigurator));
                    }
                };
                $scope.fieldValueChange = function (field) {
                    if (!_this.loading) {
                        return _this.queueRule(function () {
                            return _this.helper
                                .runRuleContainerAsync(field)
                                .then(function () { return _this.runRuleCycleUnit(field.$parentConfigurator, field); })
                                .then(function () { return _this.oncePerCycleRule(); });
                        });
                    }
                };
                $scope.fieldTouched = function (field) {
                    if (field.$parentConfigurator.validationTiming == enums.eValidationTiming.onTouched) {
                        // if validate on touched and it's the first time,
                        // we need to run the validation rule first to avoid flashing errors
                        if (!field.hasBeenTouched) {
                            var ruleArgs = _this.getRuleArgs(field.$parentConfigurator, field);
                            _this.runValidationRule(field.$parentConfigurator, ruleArgs).then(function () {
                                field.hasBeenTouched = true;
                                _this.rootConfig.isValid();
                            });
                        }
                        else {
                            _this.rootConfig.isValid(); //recalculate root as the field might be in a nested set, which is in a page, etc.
                        }
                    }
                    else {
                        field.hasBeenTouched = true;
                    }
                };
                $scope.tabChanged = function (oldTab, newTab, tabControl) {
                    if (!_this.loading) {
                        var c = tabControl.$parentConfigurator;
                        var args = _this.getRuleArgs(c);
                        args.oldTab = c.$manager.getByName(oldTab, false);
                        args.newTab = c.$manager.getByName(newTab, false);
                        args.tabControl = tabControl;
                        c.getNestedConfigurators().length;
                        return _this.queueEventRuleType(c, enums.eRuleType.tabChanged, args);
                    }
                };
                $scope.keydown = function (k) {
                    if (!(k.target instanceof HTMLInputElement ||
                        k.target instanceof HTMLTextAreaElement ||
                        (k.target instanceof HTMLElement && k.target.classList.contains('kb-no-keyboard-rule')))) {
                        var keyArgs = {
                            event: k,
                            key: k.key,
                            keyCode: k.keyCode,
                            altKey: k.altKey,
                            ctrlKey: k.ctrlKey || k.metaKey,
                            shiftKey: k.shiftKey,
                            repeat: k.repeat,
                        };
                        var ruleArgs = _this.getRuleArgs($scope.config);
                        ruleArgs.keyArgs = keyArgs;
                        return _this.queueEventRuleType($scope.config, enums.eRuleType.keyboard, ruleArgs);
                    }
                };
                $scope.expanderChanged = function (expander) {
                    if (!_this.loading) {
                        var c = expander.$parentConfigurator;
                        var args = _this.getRuleArgs(c);
                        args.expander = expander;
                        c.getNestedConfigurators().length;
                        return _this.queueEventRuleType(c, enums.eRuleType.expanderChanged, args);
                    }
                };
                $scope.nestedTabSelected = function (oldTab, nestedName, nestedSet) {
                    var newTab = nestedSet.$parentConfigurator.$manager.getByName(nestedName, false);
                    return $scope.nestedSetSelected(nestedSet, newTab);
                };
                $scope.nestedSetSelected = function (nestedSet, nested) {
                    if (!_this.loading) {
                        var c = nested;
                        var args = _this.getRuleArgs(nestedSet.$parentConfigurator);
                        args.nested = c;
                        c.$parentConfigurator;
                        return _this.queueEventRule(nestedSet.$parentConfigurator, nestedSet, args);
                    }
                };
                $scope.togglePages = function (show) {
                    var changed = $scope.showPages != show;
                    $scope.showPages = show;
                    if (changed) {
                        $scope.resizeScene();
                        _this.refreshDrawer();
                    }
                };
                $scope.resizeScene = function () {
                    if ($scope.activeSceneViewer) {
                        $timeout(function () {
                            $timeout(function () {
                                $scope.activeSceneViewer.resize();
                                $scope.activeSceneViewer.refreshElementParent();
                            });
                        }, 0);
                    }
                };
                $scope.pageClick = function (e, page) {
                    e.stopPropagation();
                    $scope.togglePages(true);
                };
                $scope.nextPage = function () {
                    if (_this.$scope.nextNode)
                        _this.selectNode(_this.$scope.nextNode);
                };
                $scope.backPage = function () {
                    if (_this.$scope.backNode)
                        _this.selectNode(_this.$scope.backNode);
                };
                $scope.nestedClick = function (e, nested) {
                    e.stopPropagation();
                    _this.selectNode(nested);
                    // var firstPage = nested.pages.find(p => p.visible);
                    // if (firstPage) {
                    //    this.selectNode(firstPage);
                    // }
                };
                $scope.hasChildren = function (tab) {
                    if (tab instanceof enums.Configurator && $scope.selected.isSingleNode(tab)) {
                        return tab.configurators.length > 0;
                    }
                    else {
                        return tab.pages.some(function (p) { return p.visible; }) || tab.configurators.length > 0;
                    }
                };
                var thisCtrl = _this;
                $scope.upload = function (file, field) {
                    var uploadOptions = {
                        convertPdfToImage: field.convertUploadPdfToImage,
                    };
                    return thisCtrl.uploadService.uploadConfiguredProductFile(file, uploadOptions).then(function (uuid) {
                        var uploadValue = field.value;
                        uploadValue.path = uuid;
                        field.$parentConfigurator.$fieldsDirty = true;
                        field.$parentConfigurator.$fieldsDirtyForSceneRules = true;
                        // clear the asset id in case there was an old file there that was just
                        // replaced to make sure the new file is uploaded to the scene
                        uploadValue.assetId = null;
                        if (thisCtrl.$scope.activeSceneViewer && thisCtrl.$scope.activeSceneViewer.scene.external) {
                            var sceneUploadPromise = thisCtrl.$scope.activeSceneViewer.importUploadFieldImage(field.$parentConfigurator, field, file);
                            thisCtrl.$rootScope.contentTracker.addPromise(sceneUploadPromise);
                            return sceneUploadPromise;
                        }
                    });
                };
                $scope.uploadCleared = function (field) {
                    field.$parentConfigurator.$fieldsDirty = true;
                    field.$parentConfigurator.$fieldsDirtyForSceneRules = true;
                };
                $scope.getCurrency = function () {
                    // if there is a quote, then that overrides everything
                    if ($scope.parentQuote) {
                        return $scope.parentQuote.currency;
                    }
                    else if (quoteService.quote) {
                        return quoteService.quote.currency;
                    }
                    else {
                        //if this is an sfdc cpq, use the incoming currency if provided
                        if (_this.$scope.sfdcHasCurrency) {
                            //console.log(this.$rootScope.context.sfdcConvertCurrency ?? 'convert currency not set');
                            return _this.$scope.sfdcCurrency;
                        }
                        // if we are in an embed, and the embed currency was specified, then use it
                        if (_this.$scope.isEmbed && _this.$scope.embedCurrency) {
                            return _this.$scope.embedCurrency;
                        }
                        else {
                            // just use the default company currency
                            return _this.$rootScope.companySettings.currency;
                        }
                    }
                };
                $scope.showPricing = function (item) {
                    if (_this.lastPricingPromise) {
                        _this.$scope.priceDialogTracker.addPromise(_this.lastPricingPromise);
                        _this.lastPricingPromise.then(function () {
                            var dialogScope = $scope.$new();
                            dialogScope.itemsInView = [];
                            dialogScope.item = item || $scope.priceObject;
                            _this.addLevelsToPricing(dialogScope.item);
                            dialogScope.flat =
                                dialogScope.item.items && !dialogScope.item.items.some(function (i) { return i.items.length > 0; });
                            dialogScope.getCurrency = $scope.getCurrency;
                            dialogScope.title = (item ? item.sku : _this.rootConfig.name) + ' Pricing';
                            dialogScope.getColumnValue = function (col, item) {
                                var val = col.systemColumn
                                    ? item[col.name.toCamelCase()]
                                    : item.columns[col.name.toCamelCase()];
                                var format = col.format;
                                if (col.name.isEqual('discount')) {
                                    if ((item.useRollup && item.items && item.items.length) || item.discountType == '$') {
                                        val = item.totalDiscount;
                                        format = enums.eFormatType.currency;
                                    }
                                    else {
                                        format = enums.eFormatType.percentage;
                                    }
                                }
                                if (col.type == enums.eColumnType.number) {
                                    var minPrecision = Number(col.formatMinPrecision);
                                    var precision = Number(col.precision);
                                    if (format == enums.eFormatType.currency && precision === 2 && minPrecision === 2) {
                                        val = $filter('fxConvert')(val, $scope.getCurrency());
                                    }
                                    else {
                                        if (format == enums.eFormatType.currency) {
                                            val = kbService.fxConvert(val, $scope.getCurrency());
                                        }
                                        val = Number(val).format({
                                            formatType: format,
                                            minPrecision: minPrecision,
                                            maxPrecision: precision,
                                            currency: $scope.getCurrency(),
                                            decimalSeparator: col.formatDecimalSeparator,
                                            thousandsSeparator: col.formatThousandsSeparator,
                                            prefix: col.formatPrefix,
                                            suffix: col.formatSuffix,
                                        });
                                    }
                                }
                                return val;
                            };
                            dialogScope.openItem = function (nestedItem) {
                                // $scope.showPricing(nestedItem)
                                nestedItem.$expanded = !nestedItem.$expanded;
                            };
                            dialogScope.smartColorStyle = function (level) {
                                var background = new _tools.Color(_this.themeService.getActiveTheme().background);
                                if (level) {
                                    if (background.isDark()) {
                                        background = _tools.Color.lighten(background.getOriginalInput(), level * 6);
                                    }
                                    else {
                                        background = _tools.Color.darken(background.getOriginalInput(), level * 6);
                                    }
                                }
                                var color = background.isDark() ? 'white' : 'black';
                                return 'background: ' + background.toRgbString() + '; color: ' + color + ';';
                            };
                            dialogScope.infiniteScroll = function () {
                                var totalCount = $scope.priceObject.items.length;
                                var currCount = dialogScope.itemsInView.length;
                                if (totalCount > currCount) {
                                    var i = currCount;
                                    if (i < 0)
                                        i = 0;
                                    dialogScope.itemsInView.pushArray($scope.priceObject.items.slice(i, i + 50));
                                }
                            };
                            dialogScope.infiniteScroll();
                            dialogService.dialog({
                                fullHeight: true,
                                template: Dirs.view('dialog-price-object'),
                                scope: dialogScope,
                                buttons: [
                                    new enums.DialogButton(loc.close, _tools.icons.cancel, function (args) {
                                        if ($scope.isEmbed) {
                                            _tools.Utils.sendMessageToParent({ name: 'pricingDetailsClosed', data: {} });
                                        }
                                    }),
                                ],
                            });
                            if ($scope.isEmbed) {
                                _tools.Utils.sendMessageToParent({ name: 'pricingDetailsShown', data: {} });
                            }
                        });
                    }
                };
                $scope.addNestedConfigClick = function (e, parent) {
                    // if the parent only has one type of referenced configurator, then we add it
                    // if more than 1 ref config, then let control pass to the dropdown
                    var parentConfig = parent instanceof enums.Configurator ? parent : parent.$parentConfigurator;
                    var entries = $scope.userCanAddToDb[parentConfig.idProduct][parent.id];
                    if (entries && entries.length == 1) {
                        e.stopPropagation();
                        return $scope.addNestedConfig(entries[0].id, parent, true);
                    }
                    return new _rules.KPromise(null);
                };
                $scope.addNestedConfig = function (idNested, parent, addedByUser, name) {
                    return _this.addNestedConfig(idNested, parent, addedByUser, name).then(function (config) {
                        return _this.runRuleCycleUnit(config.$parentConfigurator, null).then(function () {
                            return _this.oncePerCycleRule().then(function () { return config; });
                        });
                    });
                };
                $scope.copyNestedConfig = function (source) {
                    var sourceConfig = source instanceof enums.Configurator ? source : source.$parentConfigurator;
                    return _this.copyNestedConfig(sourceConfig, sourceConfig.$parent, true).then(function (target) {
                        return _this.nestedRunBottomsUp(target, function (c) { return _this.runRuleCycleUnit(c, null); });
                    });
                };
                $scope.removeNestedConfig = function (nested) {
                    // might be a page or configurator passed in.  If it's a page,
                    // it's the page's parent configurator that needs to be deleted
                    if (nested instanceof enums.Page || nested instanceof enums.NestedSet)
                        nested = nested.$parentConfigurator;
                    _this.dialogService.confirm("Are you sure you want to remove the item '" + nested.name + "'?", function () {
                        return _this.removeNestedConfig(nested).then(function () {
                            var parentConfig = nested.$parent instanceof enums.Configurator
                                ? nested.$parent
                                : nested.$parent.$parentConfigurator;
                            return _this.runRuleCycleUnit(parentConfig, null).then(function () { return _this.oncePerCycleRule(); });
                        });
                    });
                };
                $scope.autoCompleteQuery = function (query, field) {
                    return _this.helper.autoCompleteQuery(query, field);
                };
                $scope.autoCompleteGetLabel = function (value, field) {
                    return _this.helper.autoCompleteGetLabel(value, field);
                };
                $scope.togglePageSlide = function (show) {
                    $scope.pageSlideVisible = show;
                };
                $scope.selectNode = function (node) {
                    _this.selectNode(node);
                };
                // $scope.render = () => {
                //    if (this.$scope.sceneViewer) {
                //        var promise = this.$scope.sceneViewer.render().then((url) => {
                //            this.rootConfig.viewerMediaPath = url;
                //        });
                //        this.dialogService && this.dialogService.alert({
                //            msg: "Your rendering is being processed",
                //            persist: false,
                //            timeShown: 1,
                //            promise: promise
                //        });
                //        return promise;
                //    }
                //    return $q.when(null);
                // };
                // when used in an iframe, we need to catch messages posted from the outside world to respond
                var messageHandler = function (event) {
                    var msg = event.data;
                    if (msg) {
                        var data_1 = msg.data;
                        if (msg.name) {
                            var messageName = msg.name.toLowerCase();
                            if (messageName == 'setfields') {
                                $scope.$apply(function () {
                                    _this.queueRule(function () {
                                        $scope.config.setFields(data_1);
                                        return _this.runRuleCycleUnit($scope.config, null)
                                            .then(function () { return _this.oncePerCycleRule(); })
                                            .then(function () {
                                            _tools.Utils.sendMessageToParent({
                                                name: 'configuratorMessage',
                                                data: {},
                                                correspondenceId: msg.correspondenceId,
                                            });
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'getfields') {
                                var response_1 = {};
                                _this.rootConfig.getFields().forEach(function (f) {
                                    response_1[f.name] = f.value;
                                });
                                _tools.Utils.sendMessageToParent({
                                    name: 'configuratorMessage',
                                    data: response_1,
                                    correspondenceId: msg.correspondenceId,
                                });
                            }
                            else if (messageName == 'setconfiguredproduct') {
                                $scope.$apply(function () {
                                    return _this.runConfiguredProduct(rootConfig, data_1).then(function () {
                                        if ($scope.deferLoadedRule && _this.readyToStart) {
                                            _this.model = { configuredProduct: data_1 };
                                            _this.readyToStart.resolve();
                                            _this.readyToStart = null;
                                        }
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: {},
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'getconfiguredproduct') {
                                _this.queueRule(function () {
                                    _tools.Utils.sendMessageToParent({
                                        name: 'configuratorMessage',
                                        data: _this.rootConfig.getConfiguredProduct(),
                                        correspondenceId: msg.correspondenceId,
                                    });
                                    return new _rules.KPromise(null);
                                });
                            }
                            else if (messageName == 'runaction') {
                                $scope.$apply(function () {
                                    var action = _this.rootConfig.actions.find(function (a) { return a.name.isEqual(msg.data); });
                                    $scope.runAction(action).then(function () {
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: {},
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'saveproductandsubmit') {
                                $scope.$apply(function () {
                                    // clear out current quote first
                                    quoteService.quote = null;
                                    _this.submit(true)
                                        .then(function () {
                                        return _this.api.quotes
                                            .submit(_this.quoteService.quote, _this.$rootScope.contentTracker)
                                            .then(function (q) {
                                            // clear out the active quote again
                                            quoteService.quote = null;
                                            return q;
                                        });
                                    })
                                        .then(function (q) {
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: q,
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'saveproduct') {
                                $scope.$apply(function () {
                                    _this.submit(true).then(function () {
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: _this.quoteService.quote,
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'snapshot') {
                                if ($scope.activeSceneViewer) {
                                    $scope.activeSceneViewer.snapshot(msg.data).then(function (result) {
                                        if (result) {
                                            _tools.Utils.sendMessageToParent({
                                                name: 'configuratorMessage',
                                                data: result,
                                                correspondenceId: msg.correspondenceId,
                                            });
                                        }
                                    });
                                }
                            }
                            else if (messageName == 'runsubmitrule') {
                                $scope.$apply(function () {
                                    _this.runSubmitRule().then(function () {
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: {},
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else if (messageName == 'getprice') {
                                $scope.$apply(function () {
                                    _this.runPricing().then(function () {
                                        _tools.Utils.sendMessageToParent({
                                            name: 'configuratorMessage',
                                            data: _this.rootConfig.priceObject,
                                            correspondenceId: msg.correspondenceId,
                                        });
                                    });
                                });
                            }
                            else {
                                var messageArgs = jQuery.extend(_this.getRuleArgs(_this.rootConfig), { message: msg });
                                if (_this.rootConfig.hasRule(enums.eRuleType.message)) {
                                    return _this.queueEventRuleType(_this.rootConfig, enums.eRuleType.message, messageArgs).then(function () {
                                        _this.$scope.$digest();
                                    });
                                }
                            }
                        }
                    }
                };
                $window.addEventListener('message', messageHandler);
                $window.addEventListener('keydown', $scope.keydown);
                $scope.$on('$destroy', function () {
                    $window.removeEventListener('message', messageHandler);
                    $window.removeEventListener('keydown', $scope.keydown);
                });
                // $scope.$watchCollection("config.actions", () => {
                //     $timeout(() => this.resizeActionBar(), 1);
                // });
                // this.resizeActionBar = Utils.throttle(() => {
                //     // $timeout(() => {
                //     let moreButtonsVisible = false;
                //     //let $actionBar = $(".kb-config__action-bar");
                //     let $header = $(".kb-config__header");
                //     let $moreButton = $(".kb-config__more-actions");
                //     // get more button width
                //     $moreButton.css("display", "inline-block");
                //     let moreButtonWidth = $moreButton.outerWidth();
                //     $moreButton.css("display", "");
                //     let available = $header.outerWidth() / 2 - moreButtonWidth; //$actionBar.outerWidth() - moreButtonWidth;
                //     let taken: number = 0;
                //     this.$scope.config.actions.forEach(action => {
                //         if (action.visible) {
                //             let $action = $("#action-" + action.id);
                //             let $moreAction = $("#action-more-" + action.id);
                //             // temporarily set the action to be visible even if it's
                //             // currently hidden because it's in the more menu
                //             $action.css("display", "inline-block");
                //             let actionWidth = $action.outerWidth();
                //             taken += actionWidth;
                //             let visibleInMore = (taken > available);
                //             if (visibleInMore) moreButtonsVisible = true;
                //             $action.css("display", visibleInMore ? "none" : "");
                //             $moreAction.css("display", visibleInMore ? "" : "none");
                //         }
                //     });
                //     $moreButton.css("display", moreButtonsVisible ? "" : "none");
                //     // });
                // }, 100);
                _this.runResizeRule = _tools.Utils.debounce(function () {
                    // run the resize rule of the configurator
                    if (_this.$scope.config.getRuleJs(enums.eRuleType.resize) || _this.$scope.config.getRuleJs(enums.eRuleType.layout)) {
                        var args_1 = _this.getRuleArgs(_this.$scope.config);
                        _this.helper.runRuleTypeAsync(_this.$scope.config, enums.eRuleType.resize, args_1).then(function () {
                            if (_this.$scope.config.hasRule(enums.eRuleType.layout)) {
                                _this.runLayoutRule(_this.$scope.config, args_1).then(function () {
                                    _this.$scope.$digest();
                                });
                            }
                        });
                    }
                }, 100);
                $(window).resize(function () {
                    $timeout(function () {
                        _this.runResizeRule();
                        //this.resizeActionBar();
                        _this.refreshDrawer();
                    }, 1);
                });
                // get pricing columns if relevant
                if (_this.hasPricing()) {
                    _this.api.priceColumns.getPriceColumnsForUser().then(function (r) {
                        _this.$scope.priceColumns = r;
                        _this.$scope.priceColumnDb = {};
                        _this.$scope.priceColumns.forEach(function (pc) { return (_this.$scope.priceColumnDb[pc.name] = pc); });
                        _this.$scope.pricePrecision = _this.$scope.priceColumns.find(function (pc) { return pc.id == 14; } /* <-- ExtNetPrice --> */).precision;
                    });
                }
                _this.drawerService.pageTitle = _this.rootConfig.name;
                _this.drawerService.pageType = loc.configurator;
                _this.drawerService.pageIcon = _tools.icons.configurator;
                _this.drawerService.showHelp = false;
                if (_this.$scope.isTest) {
                    if (rootConfig.builds.length) {
                        var drawers_1 = [];
                        rootConfig.builds.forEach(function (b) {
                            drawers_1.push({
                                icon: _tools.icons.gear,
                                label: b.name,
                                command: function () {
                                    $scope.testBuild(b);
                                },
                            });
                        });
                        drawerService.addDrawer(_tools.icons.test, loc.testbuild, function () { }, true, drawers_1);
                    }
                    drawerService.addDrawer(_tools.icons.test, loc.testpricing, function () {
                        var pricingArgs = jQuery.extend(_this.getRuleArgs(_this.rootConfig), {
                            priceObject: {
                                items: [],
                                fields: {},
                            },
                            quoteCreator: _this.$rootScope.user,
                            quoteOwner: _this.$rootScope.user,
                        });
                        return _this.helper.runRuleTypeAsync(_this.rootConfig, enums.eRuleType.pricing, pricingArgs);
                    });
                    drawerService.addDrawer(_tools.icons.name, loc.runnamingrule, function () {
                        _this.helper.runRuleTypeAsync(_this.rootConfig, enums.eRuleType.naming);
                    });
                }
                // this.drawerViewer = drawerService.addDrawer(icons.threeD, loc.threedview, () => {
                //     this.$scope.togglePages(false);
                // });
                // this.drawerViewer.classes = "visible-xs";
                // this.drawerOptions = drawerService.addDrawer(icons.group, loc.options, () => {
                //     this.$scope.togglePages(true);
                // });
                // this.drawerOptions.classes = "visible-xs";
                // this.drawerPricing = drawerService.addDrawer(icons.column, loc.details, () => {
                //     this.$scope.showPricing();
                // });
                // this.drawerPricing.classes = "visible-xs";
                _this.drawerSubmitAndStay = drawerService.addDrawer(_tools.icons.save, $scope.getSubmitAndStayButtonText(), function () {
                    _this.submit(true);
                });
                _this.drawerSubmit = drawerService.addDrawer(_tools.icons.quote, $scope.getSubmitButtonText(), function () {
                    _this.submit();
                });
                _this.drawerCancel = drawerService.addDrawer(_tools.icons.cancel, 'Cancel', function () {
                    _this.dialogService.confirm('Are you sure you want to cancel? All unsaved work will be lost!', function () {
                        _this.cancelEdit();
                    }, function () { }, loc.yes, loc.no);
                }, false);
                // this.drawerGenerateQrCode = drawerService.addDrawer(icons.add, $scope.getGenerateQrCodeText(), () => {
                //     this.qrCodeModal();
                // });
                var initialLoad = $q.defer();
                if ($scope.isEdit) {
                    if (_this.$rootScope.isSfdcCpq) {
                        _this.drawerSubmit.icon = _tools.icons.save;
                    }
                    else {
                        initialLoad.promise = initialLoad.promise.then(function () {
                            return _this.api.quotes.getById(_this.model.idQuote).then(function (quote) {
                                $scope.parentQuote = quote;
                                if (_this.$rootScope.isSfdc && !_this.$rootScope.isSfdcCpq) {
                                    quoteService.quote = quote;
                                }
                                if ((!quote.idWorkflow && (quote.createdBy == _this.$rootScope.user.id || quote.ownedBy == _this.$rootScope.user.id)) ||
                                    quote.allowedActions.some(function (a) { return a.type == enums.eWorkflowAction.modifyProducts; })) {
                                    var builds = quote.allowedActions
                                        .filter(function (a) { return a.type == enums.eWorkflowAction.buildQuoteProduct; })
                                        .filter(function (a) { return rootConfig.builds.find(function (b) { return b.idBuildType == a.buildType.id; }) != null; });
                                    if (builds.length) {
                                        var drawers_2 = [];
                                        builds.forEach(function (action) {
                                            drawers_2.push({
                                                icon: _tools.icons.gear,
                                                label: action.buildType.name,
                                                command: function () {
                                                    _this.submit().then(function () {
                                                        return _this.api.quotes.buildQuoteProduct(quote.id, _this.model.id, action.buildType.id);
                                                    });
                                                },
                                            });
                                        });
                                        drawerService.addDrawer(_tools.icons.build, 'Build', function () { }, true, drawers_2);
                                    }
                                }
                                else {
                                    drawerService.drawers.remove(_this.drawerSubmit);
                                    drawerService.drawers.remove(_this.drawerSubmitAndStay);
                                    $scope.isReadOnly = true;
                                    drawerService.addDrawer(_tools.icons.cancel, loc.back, function () {
                                        _this.$state.go('kb.quoteEdit', { id: _this.model.idQuote });
                                    });
                                }
                            });
                        });
                    }
                    //after running the configured product, nested configs could have been added to nested
                    //sets.  We need to set the $nestedSetElement on those configs
                    _this.setAllNestedSetElements(rootConfig);
                }
                else if (!_this.quoteService.isInitialized) {
                    // wait for the quote service to finish loading
                    initialLoad.promise = initialLoad.promise.then(function () {
                        return _this.quoteService.initPromise;
                    });
                }
                //this.runContinuousAsyncRule();
                // select the first page after defining the pagechanged handler
                _this.selectNode(rootConfig.pages.find(function (p) { return p.visible == true; }));
                _this.$scope.togglePages(true);
                _this.readyToStart = $q.defer();
                initialLoad.promise.then(function () {
                    _this.startConfigurator();
                });
                initialLoad.resolve();
            });
            return _this;
        }
        ConfiguratorController_1 = ConfiguratorController;
        ConfiguratorController.prototype.selectNode = function (tab) {
            this.$scope.selected.node = tab;
        };
        ConfiguratorController.prototype.selectOverlayPopup = function (popup) {
            this.$scope.selected.overlayPopup = popup;
        };
        ConfiguratorController.prototype.navigateToElement = function (o) {
            var _this = this;
            var animateTo = null;
            var waitFor = 0;
            var waitPromise = new _rules.KPromise(null);
            if (o.visible) {
                if (o instanceof enums.Page) {
                    this.selectNode(o);
                }
                else if (o instanceof enums.Configurator) {
                    if (o.$parent instanceof enums.NestedSet) {
                        var ancestorNestedSets = [o.$parent];
                        var p = o.$parent;
                        while (p) {
                            ancestorNestedSets.push(p);
                            if (p.$parentConfigurator.$parent instanceof enums.NestedSet) {
                                p = p.$parentConfigurator.$parent;
                            }
                            else {
                                p = null;
                            }
                        }
                        var page = ancestorNestedSets.last().findAncestor(function (kbo) { return kbo instanceof enums.Page; });
                        if (page && page.visible) {
                            this.selectNode(page);
                            animateTo = o;
                            for (var i = ancestorNestedSets.length - 1; i >= 0; i--) {
                                var nestedSet = ancestorNestedSets[i];
                                if (nestedSet.display == enums.eNestedSetDisplay.accordion) {
                                    waitPromise = waitPromise.then(function () {
                                        return _this.$timeout(function () {
                                            if (!o['expanded'])
                                                waitFor = 350;
                                            o['expanded'] = true;
                                            return _this.$timeout(); //we also need to wait for other expanders in the accordion to finish so we return another timeout
                                        });
                                    });
                                }
                                else if (nestedSet.display == enums.eNestedSetDisplay.tabControl) {
                                    nestedSet['$selectedTab'] = o.name;
                                    animateTo = nestedSet;
                                }
                            }
                        }
                    }
                    else {
                        this.selectNode(o.pages.find(function (p) { return p.visible; }));
                    }
                }
                else {
                    var page = o.findAncestor(function (kbo) { return kbo instanceof enums.Page; });
                    if (page && page.visible) {
                        this.selectNode(page);
                        animateTo = o;
                    }
                }
                if (animateTo) {
                    waitPromise.then(function () {
                        _this.$timeout(function () {
                            var $uiObject = jQuery('.' + animateTo.$domId + ':visible');
                            if ($uiObject.length) {
                                _tools.Utils.scrollIntoView({
                                    elem: $uiObject[0],
                                    mode: _tools.eScrollMode.middleIfNecessary,
                                    animate: true,
                                });
                            }
                        }, waitFor);
                    });
                }
            }
        };
        ConfiguratorController.prototype.setAllNestedSetElements = function (config) {
            //after running the configured product, nested configs could have been added to nested
            //sets.  We need to set the $nestedSetElement on those configs
            for (var _i = 0, _a = config.getAllConfigurators(); _i < _a.length; _i++) {
                var nested = _a[_i];
                this.handleNewConfigInNestedSet(nested, nested.$parent, false);
            }
        };
        ConfiguratorController.prototype.refreshDrawer = function () {
            if (this.$scope.isEmbed) {
                // only show the submit button if the configurator says it should be shown
                if (this.drawerSubmit)
                    this.drawerSubmit.visible = this.drawerSubmitAndStay.visible = this.$scope.config.showSubmitButton;
            }
            if (this.$rootScope.isSfdcCpq) {
                if (this.drawerSubmit) {
                    var isValid = this.$scope.config.isValid();
                    this.drawerSubmit.disabled = !isValid;
                    // if (!isValid) {
                    //    this.drawerService.validationMessage = loc.validation_sfdc_correcterrors;
                    // }
                }
                if (this.drawerSubmitAndStay) {
                    this.drawerSubmitAndStay.visible = false;
                }
                if (this.drawerCancel) {
                    this.drawerCancel.visible = true;
                }
            }
            // refresh drawer labels
            if (this.drawerSubmitAndStay) {
                this.drawerSubmitAndStay.label = this.$scope.getSubmitAndStayButtonText();
            }
            if (this.drawerSubmit) {
                this.drawerSubmit.label = this.$scope.getSubmitButtonText();
            }
            // if (this.drawerPricing) {
            //     this.drawerPricing.visible = (this.$rootScope.user && this.$rootScope.user.canViewPrices && this.$scope.config.showPrice);
            // }
            // let viewerExists = (this.$scope.viewerMode != eViewerMode.none);
            // if (this.drawerViewer) {
            //     this.drawerViewer.visible = viewerExists;
            //     this.drawerViewer.selected = !this.$scope.showPages;
            // }
            // if (this.drawerOptions) {
            //     this.drawerOptions.visible = viewerExists;
            //     this.drawerOptions.selected = this.$scope.showPages;
            // }
        };
        ConfiguratorController.prototype.loadSfdcCpqPayload = function () {
            var _this = this;
            if (this.$rootScope.isSfdcCpq) {
                return this.sfdcService.getPayloadFromSfdcCpq().then(function (payload) {
                    _this.sfdcCpqPayload = payload;
                    _this.$scope.isEdit = _this.sfdcCpqPayload.quoteProductId != null;
                    _this.$scope.isNew = !_this.$scope.isEdit;
                    _this.$scope.sfdcHasCurrency = false;
                    if (payload.data.quote.CurrencyIsoCode) {
                        _this.$scope.sfdcCurrency = payload.data.quote.CurrencyIsoCode;
                        _this.$scope.sfdcHasCurrency = true;
                    }
                });
            }
            else {
                return this.$q.when(null);
            }
        };
        ConfiguratorController.prototype.loadModel = function () {
            var _this = this;
            if (this.$scope.isEdit) {
                var quoteProductId = this.$rootScope.isSfdcCpq ? this.sfdcCpqPayload.quoteProductId : this.$stateParams.id;
                return this.api.quoteProducts.getById(quoteProductId, this.$rootScope.contentTracker).then(function (r) {
                    _this.model = r;
                });
            }
            else {
                this.model = {};
                return this.$q.when(null);
            }
        };
        /**
         * depending on the context, we need to figure out the product id for the configurator
         */
        ConfiguratorController.prototype.getProductId = function () {
            if (this.$rootScope.isSfdcCpq) {
                return this.$scope.isEdit ? this.model.idProduct : this.sfdcCpqPayload.productId;
            }
            else {
                return this.$scope.isEdit ? this.model.idProduct : this.$stateParams.id;
            }
        };
        ConfiguratorController.prototype.addTranslationsForEntity = function (entity) {
            var trans = entity.translations.first();
            if (trans) {
                var entry = this.translationDb[entity.id];
                if (!entry)
                    entry = this.translationDb[entity.id] = {};
                Object.keys(trans.data.objects).forEach(function (key) {
                    entry[key] = trans.data.objects[key];
                });
            }
        };
        /**
         * This controller is used for both full configurators and scene configurators.
         * We load the configurator differently based on the situation
         */
        ConfiguratorController.prototype.getConfigurator = function () {
            var _this = this;
            var _a;
            var configuratorPromise;
            if (this.$scope.isScene) {
                // when we are running a scene configurator, the scene is embedded into the html
                var session = window.serverVm.session;
                var scene = session.scenes.first();
                if (((_a = scene === null || scene === void 0 ? void 0 : scene.configurator) === null || _a === void 0 ? void 0 : _a.v) >= 3) {
                    console.warn("[configurator.view] Scene ".concat(scene.id, " uses the v3 scene configurator format. ") +
                        'The legacy Angular scene viewer does not render v3 layoutHtml/fields, and the server ' +
                        'skips MergeLayout for v3 configurators, so this route may show a blank viewer. ' +
                        'Use the Vue v3 scene runtime/editor for this scene.');
                }
                this.sceneDb[scene.id] = scene;
                this.configSession = { idScene: scene.id, scenes: [scene] };
                this.addTranslationsForEntity(scene);
                this.loadLayout(scene.configurator, session.layout);
                this.helper.loadTables(session.tables);
                var configurator = new enums.Configurator(new enums.KbObjectManager(), scene.configurator);
                configurator.$running = true;
                configuratorPromise = new _rules.KPromise(configurator);
            }
            else {
                // it's a normal configurator
                configuratorPromise = this.authService.authPromise
                    .then(function () { return _this.loadSfdcCpqPayload(); })
                    .then(function () { return _this.loadModel(); })
                    .then(function () {
                    var id = _this.getProductId();
                    // if we are in test mode, we get the entire product with server rules
                    // like pricing rule(so they can be debugged on the client)
                    return _this.api.products
                        .run(id, _this.$scope.isTest, _this.$rootScope.environment != enums.eEnvironment.dev, //whether to get the configSession pre-compressed
                    _this.$rootScope.contentTracker)
                        .then(function (session) {
                        //special handling for nested parent
                        id = session.idProduct;
                        _this.configSession = session;
                        // load the productDb
                        session.products.forEach(function (p) { return (_this.productDb[p.id] = p); });
                        // load the scene session db
                        session.scenes.forEach(function (s) { return (_this.sceneDb[s.id] = s); });
                        // load the translation db
                        session.products.forEach(function (p) {
                            _this.addTranslationsForEntity(p);
                        });
                        session.scenes.forEach(function (s) {
                            _this.addTranslationsForEntity(s);
                        });
                        return _this.fillSourcedTables(session).then(function () {
                            _this.helper.loadTables(session.tables);
                            // fill in the pages / nested configurators db
                            _this.$scope.userCanAddToDb = {};
                            session.products.forEach(function (product) {
                                _this.$scope.userCanAddToDb[product.id] = {};
                                if (product.configurator.referencedConfigurators) {
                                    product.configurator.referencedConfigurators.forEach(function (rc) {
                                        if (rc.userCanAddTo) {
                                            rc.userCanAddTo.forEach(function (pageId) {
                                                var entry = _this.$scope.userCanAddToDb[product.id][pageId] ||
                                                    (_this.$scope.userCanAddToDb[product.id][pageId] = []);
                                                entry.push({
                                                    id: rc.idProduct,
                                                    name: _this.productDb[rc.idProduct].name,
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                            _this.$scope.entity = _this.productDb[id];
                            var configurator = new enums.Configurator(new enums.KbObjectManager(), _this.productDb[id].configurator);
                            configurator.$running = true;
                            _this.$scope.showMove = _this.$scope.showMove || configurator.showMoveAnimation;
                            if (_this.$scope.embedFields) {
                                configurator.setFields(_this.$scope.embedFields);
                            }
                            if (_this.$scope.isEdit) {
                                configurator.runConfiguredProduct(_this.model.configuredProduct, _this.productDb);
                                configurator.sku = _this.model.sku;
                                configurator.name = _this.model.name;
                                configurator.description = _this.model.description;
                                configurator.shortDescription = _this.model.shortDescription;
                            }
                            _this.loadLayout(configurator, session.layout);
                            return configurator;
                        });
                    }, function (err) {
                        _this.dialogService.alert({
                            type: enums.eAlertType.error,
                            msg: 'Product not found',
                            persist: true,
                        });
                        _this.$state.go('kb.products');
                        _this.configuratorLoadedDeferred.reject('Product not found');
                        return null;
                    });
                });
            }
            return configuratorPromise;
        };
        ConfiguratorController.prototype.loadLayout = function (rootConfig, layout) {
            var _this = this;
            this.$scope.layoutConfig = new enums.LayoutConfig(new enums.KbObjectManager(), layout.layoutConfig);
            // load the layout settings into the layout
            if (rootConfig.layoutSettings) {
                rootConfig.layoutSettings.forEach(function (ls) {
                    var field = _this.$scope.layoutConfig.$manager.getByIdOrName(ls.id || ls.name, false);
                    if (field)
                        field.value = ls.value;
                });
            }
            //layout settings from the embed take precedence over those in the configurator properties screen, so we set them after
            if (this.$scope.embedLayoutSettings) {
                for (var lsname in this.$scope.embedLayoutSettings) {
                    var field = this.$scope.layoutConfig.$manager.getByIdOrName(lsname, false);
                    if (field)
                        field.value = this.$scope.embedLayoutSettings[lsname];
                }
            }
        };
        /**
         * starts a configurator by loading any tables it references and running the rules once
         * @param config
         */
        ConfiguratorController.prototype.startConfigurator = function () {
            var _this = this;
            this.readyToStart = this.$q.defer();
            if (this.$scope.deferLoadedRule) {
                _tools.Utils.sendMessageToParent({
                    name: 'readyToLoadConfiguredProduct',
                    data: {
                        requestId: this.requestId,
                    },
                });
            }
            else {
                this.readyToStart.resolve();
            }
            return this.readyToStart.promise.then(function () {
                return _this.queueRule(function () {
                    return _this.runLayoutRule(_this.rootConfig, _this.getRuleArgs(_this.rootConfig))
                        .then(function () {
                        //start with layout rule so we don't get FOUC
                        return _this.nestedRunBottomsUp(_this.rootConfig, function (c) {
                            return _this.runRuleCycleUnit(c, null).then(function () {
                                // run the loaded rule
                                var args = _this.getLoadedRuleArgs(c);
                                var origNumberOfNesteds = c.getNestedConfigurators().length;
                                return _this.helper.runRuleTypeAsync(c, enums.eRuleType.resize, args).then(function () {
                                    return (_this.runLoadedRule(c, args)
                                        // if the loaded rule changed field values or added nested
                                        // configs we need to run the rule cycle again
                                        .then(function () {
                                        if (c.$fieldsDirty ||
                                            origNumberOfNesteds != c.getNestedConfigurators().length) {
                                            return _this.runRuleCycleUnit(c, null);
                                        }
                                    }));
                                });
                            });
                        });
                    })
                        .then(function () {
                        _this.loading = false;
                        return _this.oncePerCycleRule();
                    })
                        .then(function () {
                        _this.configuratorLoadedDeferred.resolve();
                        _tools.Utils.sendMessageToParent({
                            name: 'configuratorLoaded',
                            data: {
                                requestId: _this.requestId,
                            },
                        });
                    });
                });
            });
        };
        ConfiguratorController.prototype.saveToQuote = function () {
            var _this = this;
            //!!!Should only be called by "submit".  Everything else should call submit() which calls this
            if (this.$rootScope.isSfdcCpq) {
                // if steelbrick, then add the product to a blank quote and submit it
                var quote = this.quoteService.getNewQuote();
                quote.externalId = this.sfdcCpqPayload.data.quote.Id;
                // name the quote the same as the sfdc cpq quote for tracking
                // in version 28.0.1 of steelbrick they took away the record property
                quote.name = this.sfdcCpqPayload.data.quote.record
                    ? this.sfdcCpqPayload.data.quote.record.Name
                    : this.sfdcCpqPayload.data.quote.Name;
                quote.products = [
                    {
                        idProduct: this.$scope.entity.id,
                        qty: 1,
                        configuredProduct: this.rootConfig.getConfiguredProduct(),
                    },
                ];
                return this.api.quotes.save(quote, this.$rootScope.contentTracker).then(function (q) {
                    // add the quoteproduct id to the payload so it can be saved in sfdc cpq
                    _this.sfdcCpqPayload.quoteProductId = q.products[0].id;
                    return q.products[0];
                });
            }
            else if (this.$scope.isNew) {
                return this.quoteService
                    .addProduct({
                    idProduct: this.$scope.entity.id,
                    qty: 1,
                    configuredProduct: this.rootConfig.getConfiguredProduct(),
                    addLocally: true,
                    silent: this.$scope.isEmbed, // don't show confirmation dialog if we are in an embed
                    currency: this.$scope.getCurrency(),
                    sku: this.model.sku
                })
                    .then(function (r) {
                    return r;
                });
            }
            else {
                this.model.configuredProduct = this.rootConfig.getConfiguredProduct();
                return this.api.quotes
                    .editQuoteProduct(this.model.idQuote, this.model, this.$rootScope.contentTracker)
                    .then(function (r) {
                    var result = _this.quoteService.getLatestQuoteProduct(r);
                    return result;
                });
            }
        };
        ConfiguratorController.prototype.setSubmitButtonDisabled = function (disabled) {
            this.drawerSubmitAndStay.disabled = this.drawerSubmit.disabled = disabled;
        };
        ConfiguratorController.prototype.cancelEdit = function () {
            this.telemetryService.trackEvent('Configurator Cancel');
            if (this.$rootScope.isSfdcCpq) {
                this.sfdcService.cancelSfdcCpqEdit();
            }
            else if (this.$scope.isEdit && this.model && this.model.idQuote) {
                this.$state.go('kb.quoteEdit', { id: this.model.idQuote });
            }
            else if (this.$scope.isNew && !this.$scope.isEmbed) {
                this.quoteService.goToQuote();
            }
            return this.$q.when(null);
        };
        ConfiguratorController.prototype.submit = function (stayOnPage) {
            var _this = this;
            if (stayOnPage === void 0) { stayOnPage = false; }
            this.setSubmitButtonDisabled(true);
            var deferred = this.$q.defer();
            var promise = deferred.promise;
            this.validationPromptDisplayed = false;
            /*
                Process validation before AND after running the submit rule.
                We run it before because in some scenarios people are adding nested configurators in the submit rule,
                and if we're not valid already, then we'd rather not add them.
                We run it after too because perhaps the submit rule changed something that makes it invalid.
            */
            this.shouldSubmit().then(function (should) {
                if (should) {
                    _this.runSubmitRule().then(function () {
                        _this.shouldSubmit().then(function (should) {
                            if (should) {
                                _this.saveToQuote().then(function (r) {
                                    deferred.resolve(r);
                                });
                            }
                            else {
                                deferred.reject();
                            }
                        });
                    });
                }
                else {
                    deferred.reject();
                }
            });
            return promise
                .then(function (data) {
                _this.telemetryService.trackEvent('Configurator Submit');
                if (_this.$rootScope.isSfdcCpq) {
                    _this.sfdcService.saveToSfdcCpq(_this.sfdcCpqPayload, data.priceObject);
                }
                else if (_this.$scope.isNew && !_this.$scope.isEmbed) {
                    if (stayOnPage) {
                        _this.$state.go('kb.configuredProduct', { id: data.id });
                    }
                    else {
                        _this.quoteService.goToQuote();
                    }
                }
                else if (_this.$scope.isEdit) {
                    _this.$scope.$broadcast('saveSuccess', data);
                    if (!stayOnPage)
                        _this.$state.go('kb.quoteEdit', { id: _this.model.idQuote });
                }
            }, function (reason) {
                _this.telemetryService.trackEvent('Configurator Submit Rejected');
                _this.setSubmitButtonDisabled(false);
                return _this.$q.reject(reason);
            })
                .finally(function () {
                if (stayOnPage)
                    _this.setSubmitButtonDisabled(false);
            });
        };
        ConfiguratorController.prototype.qrCodeModal = function () {
            var dialogScope = this.$rootScope.$new();
            dialogScope.autoStartAr = false;
            var url = window.location.href;
            if (url.includes('ar=true')) {
                dialogScope.autoStartAr = true;
            }
            dialogScope.updateQrCode = function (newVal) {
                if (newVal !== dialogScope.autoStartAr) {
                    dialogScope.autoStartAr = newVal;
                }
            };
            var canvas = document.createElement('canvas');
            browser.toCanvas(canvas, url, { width: 150 }, function (error) {
                if (error)
                    console.error(error);
            });
            dialogScope.QrCode = canvas;
            this.dialogService.dialog({
                template: Dirs.view('dialog-create-qr-code', exports.eBundle.app),
                scope: dialogScope,
                buttons: [new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) { })],
            });
            dialogScope.$watch('autoStartAr', function (newVal) {
                if (newVal === true) {
                    if (url.includes('ar=true') === false) {
                        url = url + '?ar=true';
                    }
                    window.history.pushState({}, null, url);
                    browser.toCanvas(canvas, url, { width: 150 }, function (error) {
                        if (error)
                            console.error(error);
                    });
                }
                else {
                    if (url.includes('ar=true') === true) {
                        url = url.replace('ar=true', '');
                        if (url.charAt(url.length - 1) === '?') {
                            url = url.slice(0, -1);
                        }
                    }
                    window.history.pushState({}, null, url);
                    browser.toCanvas(canvas, url, { width: 150 }, function (error) {
                        if (error)
                            console.error(error);
                    });
                }
                var panel = document.getElementById('qrCodeCanvas');
                if (panel instanceof HTMLCanvasElement) {
                    var context = panel.getContext('2d');
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(canvas, 0, 0);
                    //panel.append(canvas);
                }
                //dialogScope.QrCode = canvas;
            }, true);
            setTimeout(function () {
                var panel = document.getElementById('qrCodeCanvas');
                browser.toCanvas(panel, url, { width: 150 }, function (error) {
                    if (error)
                        console.error(error);
                });
                panel.append(canvas);
            }, 1000);
        };
        ConfiguratorController.prototype.enterArModal = function () {
            var _this = this;
            var dialogScope = this.$rootScope.$new();
            var enterArButton = new enums.InputDialogButton('Enter AR', _tools.icons.change, function (args) {
                if (_this.$scope.activeSceneViewer) {
                    _this.$scope.activeSceneViewer.$scope.toggleAr();
                }
            });
            this.dialogService.dialog({
                scope: dialogScope,
                buttons: [enterArButton, new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) { })],
            });
        };
        ConfiguratorController.prototype.shouldSubmit = function () {
            var deferred = this.$q.defer();
            if (this.rootConfig.isValid()) {
                deferred.resolve(true);
            }
            else {
                //it's not valid
                if (this.rootConfig.allowSaveWithErrors) {
                    if (!this.validationPromptDisplayed) {
                        this.validationPromptDisplayed = true;
                        this.dialogService.dialog({
                            content: loc.msg_savetoquoteerrors,
                            buttons: [
                                new enums.DialogButton(loc.save, _tools.icons.success, function (args) {
                                    deferred.resolve(true);
                                }),
                                new enums.DialogButton(loc.keepworking, _tools.icons.cancel, function (args) {
                                    deferred.resolve(false);
                                }),
                            ],
                        });
                    }
                    else {
                        deferred.resolve(true);
                    }
                }
                else {
                    this.dialogService.alert({
                        msg: loc.msg_fixerrorsbeforesave,
                        persist: false,
                        type: enums.eAlertType.error,
                    });
                    deferred.resolve(false);
                }
            }
            return deferred.promise;
        };
        ConfiguratorController.prototype.runConfiguredProduct = function (configurator, configProd) {
            var _this = this;
            return this.queueRule(function () {
                configurator.runConfiguredProduct(configProd, _this.productDb);
                _this.setAllNestedSetElements(configurator);
                return _this.nestedRunBottomsUp(configurator, function (c) { return _this.runRuleCycleUnit(c, null); }).then(function () {
                    return _this.oncePerCycleRule();
                });
            });
        };
        ConfiguratorController.prototype.addNestedConfig = function (idNested, parent, addedByUser, name, fields) {
            var _this = this;
            var product = this.productDb[idNested];
            // if a configurator with the given name already exists, then we do nothing
            var nested = parent.configurators.find(function (c) { return c.name.isEqual(name); });
            if (!nested) {
                nested = new enums.Configurator(new enums.KbObjectManager(), product.configurator);
                nested.$running = true;
                if (name)
                    nested.name = name;
                parent.$expanded = true;
                parent.configurators.push(nested);
                parent.$manager.addKbObject(nested, parent);
                if (addedByUser)
                    nested.addedByUser = this.$rootScope.user.id;
                if (fields) {
                    nested.setFields(fields);
                }
                var parentConfig = parent instanceof enums.Configurator ? parent : parent.$parentConfigurator;
                var refConfig = parentConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
                nested.addAsQuoteProduct = refConfig.addAsQuoteProduct;
                nested.kineticViewOnly = refConfig.kineticViewOnly;
                this.handleNewConfigInNestedSet(nested, parent);
                if (this.sceneDb[nested.idScene] && this.sceneDb[nested.idScene].external) {
                    nested.nestedPath = nested.idScene;
                }
                else {
                    nested.nestedPath = this.getConfiguratorUniqueKey(nested);
                }
                // run the added rule on the nested configurator
                return this.runNestedRuleType(parentConfig, nested, enums.eRuleType.configuratorAdded)
                    .then(function () { return _this.runRuleCycleUnit(nested, null, false); }) // don't bubble here
                    .then(function () { return nested; });
            }
            else if (fields) {
                nested.setFields(fields); //no need to run
                if (nested.$fieldsDirty) {
                    return this.runRuleCycleUnit(nested, null, false).then(function () { return nested; });
                }
                else {
                    return new _rules.KPromise(nested);
                }
            }
            else {
                return new _rules.KPromise(nested);
            }
        };
        ConfiguratorController.prototype.getConfiguratorUniqueKey = function (config) {
            var looping = true;
            do {
                var nestedSettings = undefined;
                if (config.$parentConfigurator) {
                    nestedSettings = config.$parentConfigurator.referencedConfigurators.find(function (rc) { return rc.name === config.name; });
                }
                if (nestedSettings && nestedSettings.nestScene) {
                    config = config.$parentConfigurator;
                }
                else {
                    looping = false;
                }
            } while (looping);
            if (config.$parentConfigurator) {
                return config.$parentConfigurator.name + '/' + config.name;
            }
            else {
                return config.name;
            }
        };
        ConfiguratorController.prototype.copyNestedConfig = function (sourceConfig, appendTo, addedByUser, name) {
            var _this = this;
            var product = this.productDb[sourceConfig.idProduct];
            var target = new enums.Configurator(new enums.KbObjectManager(), product.configurator);
            target.$running = true;
            target.runConfiguredProduct(sourceConfig.getConfiguredProduct(), this.productDb);
            target.name = name || product.configurator.name; // get default name
            appendTo.$expanded = true;
            appendTo.configurators.push(target);
            appendTo.$manager.addKbObject(target, appendTo);
            if (addedByUser)
                target.addedByUser = this.$rootScope.user.id;
            var parentConfig = appendTo instanceof enums.Configurator ? appendTo : appendTo.$parentConfigurator;
            var refConfig = parentConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == target.idProduct; });
            target.addAsQuoteProduct = refConfig.addAsQuoteProduct;
            target.kineticViewOnly = refConfig.kineticViewOnly;
            this.handleNewConfigInNestedSet(target, appendTo);
            //the copied config could have nested configs added to nested sets.
            this.setAllNestedSetElements(target);
            // run the added rule on the nested configurator
            return this.runNestedRuleType(sourceConfig.$parentConfigurator, target, enums.eRuleType.configuratorCopied)
                .then(function () { return _this.nestedRunBottomsUp(target, function (c) { return _this.runRuleCycleUnit(c, null); }); })
                .then(function () { return _this.oncePerCycleRule(); })
                .then(function () { return target; });
        };
        ConfiguratorController.prototype.handleNewConfigInNestedSet = function (nested, parent, navigateTo) {
            var _this = this;
            var _a, _b;
            if (navigateTo === void 0) { navigateTo = true; }
            //we need to save a handle to the element chosen to represent the nested set so we can access it in our angular view
            if (parent) {
                if (parent instanceof enums.NestedSet) {
                    //get the referenced configurator
                    var refConfig = parent.$parentConfigurator.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
                    nested.$nestedSetElement = nested.$manager.get(refConfig.element);
                    if (parent.visible && parent.autoNavigateToElement && navigateTo) {
                        this.$timeout(function () {
                            _this.navigateToElement(nested);
                        });
                    }
                }
                else {
                    //if not added to a NestedSet, we still need to set a $nestedSetElement for NestedElements,
                    //either the one configured in ReferencedConfigurators or a default element
                    //use the first page as the default element
                    var element = nested.pages.first();
                    var parentConfig = (_a = parent.$parentConfigurator) !== null && _a !== void 0 ? _a : parent;
                    if (parentConfig && parentConfig.referencedConfigurators) {
                        var refConfig = parentConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
                        if (refConfig && refConfig.element) {
                            //try to override default element
                            element = (_b = nested.$manager.get(refConfig.element, false)) !== null && _b !== void 0 ? _b : element;
                        }
                    }
                    nested.$nestedSetElement = element;
                }
            }
        };
        ConfiguratorController.prototype.removeNestedConfig = function (nested) {
            var _this = this;
            return new _rules.KPromise(nested).then(function () {
                if (nested) {
                    // might be a page or configurator passed in.  If it's a page,
                    // it's the page's parent configurator that needs to be deleted
                    if (nested instanceof enums.Page || nested instanceof enums.NestedSet)
                        nested = nested.$parentConfigurator;
                    // we need a new selection if we are deleting the page we're on
                    if (_this.$scope.selected.page) {
                        if (_this.$scope.selected.page.findAncestor(function (a) { return a == nested; })) {
                            if (nested.$parent instanceof enums.Page) {
                                _this.selectNode(nested.$parent);
                            }
                            else {
                                _this.selectNode(nested.$parent.pages.find(function (p) { return p.visible; }));
                            }
                        }
                    }
                    nested.$parent.$manager.removeKbObject(nested);
                    nested.$parent.configurators.remove(nested);
                    var parentConfig = nested.$parent instanceof enums.Configurator
                        ? nested.$parent
                        : nested.$parent.$parentConfigurator;
                    // run the removed rule on the nested configurator
                    return _this.runNestedRuleType(parentConfig, nested, enums.eRuleType.configuratorRemoved);
                }
            });
        };
        ConfiguratorController.prototype.setNumberOfNestedConfigs = function (productId, parent, num) {
            var _this = this;
            this.productDb[productId];
            var configs = parent.configurators.filter(function (c) { return c.idProduct == productId; });
            var promises = [];
            var configsChanged = false;
            if (configs.length < num) {
                // need to add
                for (var i = configs.length; i < num; i++) {
                    configsChanged = true;
                    promises.push(this.addNestedConfig(productId, parent, false, null));
                }
            }
            else if (configs.length > num) {
                // need to remove
                for (var i = configs.length - 1; i >= num; i--) {
                    configsChanged = true;
                    promises.push(this.removeNestedConfig(configs[i]));
                }
            }
            var prom = this.$q.all(promises);
            if (configsChanged) {
                var parentConfig_1 = parent instanceof enums.Configurator ? parent : parent.$parentConfigurator;
                prom = prom.then(function () { return _this.runRuleCycleUnit(parentConfig_1, null); });
            }
            return prom;
        };
        ConfiguratorController.prototype.getChildrenForNode = function (tabNode) {
            var _this = this;
            var nodes = [];
            tabNode.node.pages.forEach(function (p) {
                if (p.visible && !_this.$scope.selected.isSingleNode(p.$parentConfigurator)) {
                    var child = { id: p.id, level: tabNode.level + 1, node: p };
                    nodes.push(child);
                    nodes.pushArray(_this.getChildrenForNode(child));
                }
            });
            tabNode.node.configurators.forEach(function (c) {
                var child = { id: c.id, level: tabNode.level + 1, node: c };
                nodes.push(child);
                nodes.pushArray(_this.getChildrenForNode(child));
            });
            return nodes;
        };
        ConfiguratorController.prototype.calculateNodes = function () {
            var rootNode = { id: this.rootConfig.id, level: -1, node: this.rootConfig };
            this.$scope.nodes = [];
            this.$scope.nodes.pushArray(this.getChildrenForNode(rootNode));
            this.$scope.nextNode = this.getNextNode(this.$scope.selected.page, false);
            this.$scope.backNode = this.getBackNode(this.$scope.selected.node);
        };
        ConfiguratorController.prototype.getNextNode = function (node, skipChildren) {
            var next;
            if (node) {
                var parent_2 = node.$parent;
                if (!skipChildren) {
                    // first find if there is a nested page
                    next = node.pages.find(function (p) { return p.visible; });
                    // then check nested configurators
                    if (!next)
                        next = node.configurators.find(function (c) { return c.pages.some(function (p) { return p.visible; }); });
                }
                // get next page or configurator with the same parent
                if (!next && parent_2) {
                    if (node instanceof enums.Page) {
                        next = parent_2.pages.next(node, function (p) { return p.visible; });
                    }
                    if (!next)
                        next = parent_2.configurators.next(node, function (c) { return c.pages.some(function (p) { return p.visible; }); });
                }
                if (!next && parent_2)
                    next = this.getNextNode(parent_2, true);
            }
            return next;
        };
        ConfiguratorController.prototype.getBackNode = function (node) {
            var prev;
            if (node) {
                var parent_3 = node.$parent;
                // find the previous item
                if (node instanceof enums.Configurator) {
                    prev = parent_3.configurators.previous(node, function (c) { return c.pages.some(function (p) { return p.visible; }); });
                }
                if (!prev)
                    prev = parent_3.pages.previous(node, function (p) { return p.visible; });
                if (prev) {
                    var n = prev;
                    while (n) {
                        // find the last nested child
                        n = prev.configurators.filter(function (c) { return c.pages.some(function (p) { return p.visible; }); }).last();
                        if (!n)
                            n = prev.pages.filter(function (p) { return p.visible; }).last();
                        if (n)
                            prev = n;
                    }
                }
                else {
                    // if there was no siblings, then go to the parent
                    if (!prev && parent_3 != this.rootConfig)
                        prev = parent_3;
                    if (prev instanceof enums.Configurator)
                        prev = this.getBackNode(prev);
                }
            }
            return prev;
        };
        ConfiguratorController.prototype.queueRule = function (ruleAction) {
            if (this.activeRule) {
                this.activeRule = this.activeRule.then(function () {
                    return ruleAction();
                });
            }
            else {
                this.activeRule = ruleAction();
            }
            return this.activeRule;
        };
        ConfiguratorController.prototype.oncePerCycleRule = function () {
            var _this = this;
            return new _rules.KPromise((function () {
                _this.runPricing();
                _this.calculateNodes();
                _this.getCurrentConfigForViewerAndSetViewerMode(); //need to set viewerMode before layout rule so the layout rule can show/hide the viewer accordingly
            })())
                .then(function () { return _this.runLayoutRule(_this.$scope.config, _this.getRuleArgs(_this.$scope.config)); })
                .then(function () { return !_this.loading && _this.refreshViewer(); })
                .then(function () {
                _this.$scope.actionsVisible = _this.$scope.config.actions.some(function (a) { return a.visible; });
                _this.$timeout(function () {
                    //this.resizeActionBar();
                    _this.refreshDrawer();
                });
            });
        };
        ConfiguratorController.prototype.runLoadedRule = function (config, args) {
            if (!this.$scope.isScene && !config.$ranLoadedRule) {
                //scene loaded rule is handled by the viewer
                config.$ranLoadedRule = true;
                return this.helper.runRuleTypeAsync(config, enums.eRuleType.loaded, args);
            }
            return new _rules.KPromise({ parameters: args, hasError: false });
        };
        /**
         * manages bubbling the value rule running up or down.  We do this isolated,
         * so we don't end up over-running other rules (like validation, pricing, scene).
         * Returns a boolean indicating whether the configurator fields were dirty immediately
         * after running the value rule (indicating whether something before or during the value
         * rule actually modified a field)
         * @param config
         * @param field
         */
        ConfiguratorController.prototype.runRuleCycleUnit = function (config, field, bubble, showWarning) {
            var _this = this;
            if (bubble === void 0) { bubble = true; }
            if (showWarning === void 0) { showWarning = true; }
            if (this.runningRules[config.name] >= ConfiguratorController_1.cycleLimit) {
                if (showWarning) {
                    console.log("Rule cycle recursion limit hit for configurator '".concat(config.name, "'.  Opting out of running"));
                }
                return this.$q.when(false);
            }
            if (!this.runningRules[config.name])
                this.runningRules[config.name] = 1;
            else
                this.runningRules[config.name]++;
            var nestedRulesRan = false;
            var ruleArgs = this.getRuleArgs(config, field);
            var origNumberOfNesteds = config.getNestedConfigurators().length;
            var configWasDirty = false;
            var runRules = this.helper
                .runSelects(config)
                // value rules
                .then(function () { return _this.helper.loadGlobalFunctions(config); })
                .then(function () { return _this.helper.runRuleTypeAsync(config, enums.eRuleType.value, ruleArgs); })
                .then(function () {
                configWasDirty = config.$fieldsDirty;
                // reset $fieldsDirty of this configurator so it doesn't affect a
                // parent's decision on whether to run the child's rules
                config.$fieldsDirty = false;
            })
                .then(function () {
                // run rule cycle on dirty nesteds
                var promises = [];
                config.getNestedConfigurators().forEach(function (nested) {
                    /* if the nested configurator was changed by the parent rules OR
                           if the nested is setup to be always a child, and this parent actually had a change
                           then we need to run the nested's value rule */
                    if (nested.$fieldsDirty || (nested.alwaysChild && nested.alwaysChildOf && configWasDirty)) {
                        nestedRulesRan = true;
                        // don't bubble the nested rules here.  We'll take care of it at the parent level next
                        promises.push(_this.runRuleCycleUnit(nested, null, false, showWarning));
                    }
                });
                return _this.$q.all(promises);
            })
                .then(function (dirtyArr) {
                // after running nested config rule cycles, if this parent is referencing them,
                // it now needs to be updated we do this here instead of using the bubbling below
                // so that the parent only re - runs it's rules once, instead of once for each nested
                return nestedRulesRan &&
                    ((!_this.loading && dirtyArr && dirtyArr.some(function (b) { return b == true; })) || //make sure that one of the nesteds is actually dirty or it's pointless to re-run this config's value rule
                        (_this.loading && origNumberOfNesteds < config.getNestedConfigurators().length)) && // if we are loading, then only bubble if a new nested configurator was added by the value rule
                    config.bubbleRules &&
                    _this.helper.runRuleTypeAsync(config, enums.eRuleType.value, ruleArgs);
            })
                .then(function () {
                return _this.runValidationRule(config, ruleArgs);
            })
                .then(function () { return _this.helper.runRuleTypeAsync(config, enums.eRuleType.visibility, ruleArgs); })
                .then(function () {
                // as opposed to the bubbling above, this bubbling is more for the user having changed
                // a field value in the nested configurator directly and us sensing that the parent now
                // needs to update. (only if we are done loading, since loading bubbles through all
                // configurators anyways)
                return !_this.loading &&
                    bubble &&
                    config.$parentConfigurator &&
                    config.$parentConfigurator.bubbleRules &&
                    _this.runRuleCycleUnit(config.$parentConfigurator, null, true, showWarning);
            })
                .then(function () {
                // run the loaded rule for nested configs
                if (config.$parentConfigurator && config.$parentConfigurator.referencedConfigurators && !config.$ranLoadedRule) {
                    var refConfig = config.$parentConfigurator.referencedConfigurators.find(function (rc) { return rc.idProduct == config.idProduct; });
                    if (refConfig && refConfig.runLoadedRule) {
                        var origNumberOfNesteds_1 = config.getNestedConfigurators().length;
                        return _this.runLoadedRule(config, _this.getLoadedRuleArgs(config)).then(function () {
                            // if the loaded rule changed field values or added nested
                            // configs we need to run the rule cycle again
                            if (config.$fieldsDirty || origNumberOfNesteds_1 != config.getNestedConfigurators().length) {
                                return _this.runRuleCycleUnit(config, null, false, showWarning);
                            }
                        });
                    }
                }
            })
                .then(function () {
                delete _this.runningRules[config.name];
            });
            return runRules.then(function () { return configWasDirty; });
        };
        ConfiguratorController.prototype.queueEventRuleType = function (config, ruleType, args) {
            var rc = config.ruleContainers.find(function (rc) {
                return rc.ruleType.isEqual(ruleType);
            });
            return this.queueEventRule(config, rc, args);
        };
        /** wraps the given delegate to run a rule, and follows it with a rule cycle if the event rule changed something that warrants it */
        ConfiguratorController.prototype.queueEventRule = function (config, ruleContainer, args) {
            var _this = this;
            return this.queueRule(function () {
                //if there is no rule for the rule type, then cut it off here so we don't run oncePerCycleRule unnecessarily
                if (ruleContainer && ruleContainer.js) {
                    var origNumberOfNesteds_2 = config.getNestedConfigurators().length;
                    return _this.helper.runRuleContainerAsync(ruleContainer, args).then(function () {
                        var nesteds = config.getNestedConfigurators();
                        if (config.$fieldsDirty ||
                            (_this.$scope.layoutConfig && _this.$scope.layoutConfig.$layoutSettingsDirty) ||
                            origNumberOfNesteds_2 != nesteds.length ||
                            nesteds.some(function (n) { return n.$fieldsDirty; })) {
                            return _this.runRuleCycleUnit(config, null).then(function () { return _this.oncePerCycleRule(); });
                        }
                        else if (ruleContainer.ruleType.isEqual(enums.eRuleType.tabChanged) &&
                            ruleContainer.references.length) {
                            _this.refreshViewer(true);
                        }
                        else {
                            _this.$scope.$digest(); //because of the way event queueing works, we need to $digest here
                        }
                    });
                }
                else {
                    var result = {
                        hasError: false,
                        parameters: args,
                    };
                    return new _rules.KPromise(result);
                }
            });
        };
        /**
         * Runs the given function on the configurator given and all of it's child configurators in the direction given
         * @param fn
         */
        ConfiguratorController.prototype.nestedRunTopDown = function (config, fn) {
            var _this = this;
            var nesteds = config.getNestedConfigurators();
            return fn(config).then(function () { return _this.$q.all(nesteds.map(function (n) { return _this.nestedRunTopDown(n, fn); })); });
        };
        ConfiguratorController.prototype.nestedRunBottomsUp = function (config, fn) {
            var _this = this;
            var nesteds = config.getNestedConfigurators();
            var continueRun = function () { return _this.$q.all(nesteds.map(function (n) { return _this.nestedRunBottomsUp(n, fn); })); };
            if (this.loading && nesteds.some(function (n) { return n.alwaysChild; })) {
                return this.nestedRunTopDown(config, fn)
                    .then(continueRun)
                    .then(function () { return fn(config); });
            }
            else {
                return continueRun().then(function () { return fn(config); });
            }
        };
        ConfiguratorController.prototype.runNestedRuleType = function (config, nested, ruleType, args) {
            if (!args)
                args = this.getRuleArgs(config);
            args.nested = nested;
            var refConfig = config.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; });
            var ruleContainer = refConfig.ruleContainers.find(function (rc) { return rc.ruleType.isEqual(ruleType); });
            if (ruleContainer) {
                return this.helper.runRuleContainerAsync(ruleContainer, args);
            }
            else {
                return this.$q.when(null);
            }
        };
        ConfiguratorController.prototype.runValidationRule = function (config, ruleArgs) {
            config.preValidate(); // call internal validation for fields
            return this.helper.runRuleTypeAsync(config, enums.eRuleType.validation, ruleArgs).then(function () {
                config.isValid(); //force recalculation of $valid property
            });
        };
        ConfiguratorController.prototype.runLayoutRule = function (config, ruleArgs) {
            var _this = this;
            return this.helper.runRuleTypeAsync(this.$scope.config, enums.eRuleType.layout, ruleArgs).then(function () {
                _this.$scope.layoutConfig.$layoutSettingsDirty = false;
                if (!_this.$scope.layoutLoaded) {
                    _this.$scope.layoutLoaded = true;
                    if (_this.$scope.config.hasRule(enums.eRuleType.layout)) {
                        /**
                         * Process UI changes when first running so there is no FOUC.
                         * Note that we only call this if there is actually a layout rule, because
                         * otherwise the runRuleTypeAsync above actually resolves synchronously because it's
                         * a KbPromise, then we get an error on the $digest call that there is already one in
                         * progress
                         */
                        _this.$scope.$digest();
                    }
                }
                return _this.$scope.resizeScene();
            });
        };
        ConfiguratorController.prototype.runSubmitRule = function () {
            var _this = this;
            this.runAsyncRule = false;
            this.rootConfig.parameters = this.getParameters();
            return this.queueRule(function () {
                return _this.nestedRunBottomsUp(_this.rootConfig, function (c) {
                    var origNumberOfNesteds = c.getNestedConfigurators().length;
                    var ruleArgs = _this.getLoadedRuleArgs(c);
                    //set all fields to be "touched" and re-run validation to satisfy configurator.validationTiming setting
                    c.getFields().forEach(function (f) { return (f.hasBeenTouched = true); });
                    return _this.runValidationRule(c, ruleArgs).then(function () {
                        return _this.helper.runRuleTypeAsync(c, enums.eRuleType.submit, ruleArgs).then(function () {
                            var nesteds = c.getNestedConfigurators();
                            //if the submit rule changed any fields or added nested configurators, run another rule cycle
                            if (c.$fieldsDirty ||
                                origNumberOfNesteds != nesteds.length ||
                                nesteds.some(function (n) { return n.$fieldsDirty; })) {
                                return _this.runRuleCycleUnit(c, null, true, false);
                            }
                        });
                    });
                }).then(function () {
                    _this.telemetryService.trackEvent('Configurator Submit Rule Run');
                });
            }).then(function () {
                var deferred = _this.$q.defer();
                var configurator = _this.configSession.products[0].configurator;
                var completeSubmit = function () {
                    if (configurator.kineticSettings.notUnique) {
                        var partNum_1 = _this.model.sku;
                        return _this.api.kinetic.partNumExists(partNum_1).then(function (exists) {
                            if (exists) {
                                _this.dialogService.alert({
                                    msg: "Part " + partNum_1 + " already exists",
                                    persist: true
                                });
                            }
                            deferred.resolve();
                        });
                    }
                    else {
                        deferred.resolve();
                    }
                };
                if (configurator.kineticSettings && configurator.kineticSettings.createPart) {
                    if (configurator.kineticSettings.autoCrtPart) {
                        var configuration = " configuration = " + _this.model.name;
                        var part = _this.model.sku ? " part = " + _this.model.sku : "";
                        _this.dialogService.confirm("Would you like to create a new part number for" + configuration + part + "?", function () {
                            if (configurator.kineticSettings.crtPartUsing == "PromptFor") {
                                _this.dialogService.input({
                                    inputType: enums.eInputDialogType.text,
                                    msg: "Enter your desired part number",
                                    value: "",
                                    buttons: [
                                        new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                                            if (args.value == "") {
                                                args.close = false;
                                            }
                                            else {
                                                _this.model.sku = _this.rootConfig.sku = args.value;
                                                completeSubmit();
                                            }
                                        }),
                                        new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                                            _this.drawerSubmit.disabled = false;
                                            _this.drawerSubmitAndStay.disabled = false;
                                        })
                                    ]
                                });
                            }
                            else {
                                completeSubmit();
                            }
                        }, function () {
                            completeSubmit();
                        }, loc.yes, loc.no);
                        return deferred.promise;
                    }
                    else {
                        completeSubmit();
                    }
                }
            });
        };
        ConfiguratorController.prototype.showErrors = function () {
            return (this.$scope.isScene ||
                this.$scope.isTest ||
                this.$rootScope.environment == enums.eEnvironment.dev ||
                this.$rootScope.environment == enums.eEnvironment.test);
        };
        ConfiguratorController.prototype.getRuleArgs = function (config, changedField) {
            var ruleArgs = new ConfiguratorRuleArgs(this);
            ruleArgs.user = this.$rootScope.user;
            ruleArgs.environment = this.$rootScope.environment;
            ruleArgs.baseUrl = this.$rootScope.context.baseUrl;
            ruleArgs.configurator = config;
            ruleArgs.layoutConfig = this.$scope.layoutConfig;
            ruleArgs.kom = config.$manager;
            ruleArgs.parentKom = config.$parentConfigurator ? config.$parentConfigurator.$manager : null;
            ruleArgs.changedField = changedField;
            ruleArgs.logs = new _rules.ClientLogger();
            ruleArgs.clientLanguage = this.$rootScope.clientLanguage;
            ruleArgs.viewerMode = this.$scope.viewerMode;
            ruleArgs.isCrm = this.$rootScope.isSfdc || this.$rootScope.isSfdcCpq;
            ruleArgs.parameters = this.getParameters();
            return ruleArgs;
        };
        ConfiguratorController.prototype.getLoadedRuleArgs = function (config) {
            var _a;
            var args = jQuery.extend(this.getRuleArgs(config), {
                isEdit: this.$scope.isEdit || (this.$scope.isKinetic && this.$scope.deferLoadedRule),
                quoteProduct: this.$scope.isEdit || this.$scope.deferLoadedRule ? this.model : null,
                quote: (_a = (this.$scope.isEdit || this.$scope.deferLoadedRule ? this.$scope.parentQuote : this.quoteService.quote)) !== null && _a !== void 0 ? _a : null,
            });
            return args;
        };
        ConfiguratorController.prototype.createSceneViewer = function (scene) {
            var _this = this;
            var sceneViewer;
            var viewerScope = this.$scope.$new();
            var company = this.$rootScope.company;
            var env = this.$rootScope.environment;
            var vArgs = {
                //$rootScope: this.$rootScope,
                //$http: this.$http,
                environment: this.$rootScope.environment,
                baseUrl: this.$rootScope.context.baseUrl,
                assetRoot: this.$rootScope.context.publicStorageUrl,
                clusterEnv: this.$rootScope.context.clusterEnv,
                cacheBuster: this.$rootScope.context.cacheBuster,
                clientLanguage: this.$rootScope.clientLanguage,
                isMobile: this.$rootScope.windowWidth < _tools.Utils.MOBILE_WIDTH,
                isRender: false,
                isOutput: false,
                renderPass: null,
                $q: this.$q,
                $timeout: this.$timeout,
                $injector: this.$injector,
                ruleService: this.ruleService,
                //uploadService: this.uploadService,
                dialogService: this.dialogService,
                highlightColor: this.themeService.getActiveTheme().accent,
                //$compile: this.$compile,
                $scope: viewerScope,
                handleRuleError: function (ruleName, result) { return _this.helper.handleRuleError(ruleName, result); },
                tableArraysDb: this.helper.tableArraysDb,
                //helper: this.helper,
                elemSelector: '.kb-viewer',
                //isEmbed: true,
                bare: false,
                requestId: null,
                // scene: scene,
                sceneDb: this.sceneDb,
                configSession: this.configSession,
                messageCallback: null,
                configuratorLoadedPromise: this.configuratorLoadedDeferred.promise,
                arLoading: this.$scope.arLoading,
                navigateToElement: function (o) {
                    _this.navigateToElement(o);
                },
                compileTemplate: function (hotspotDiv, scope) {
                    return _this.$compile(hotspotDiv)(scope)[0];
                },
                lastDeploy: env == enums.eEnvironment.dev
                    ? 0
                    : env == enums.eEnvironment.test
                        ? company.lastTestDeployment
                        : company.lastProdDeployment,
            };
            if (scene.external) {
                var cArgs = vArgs;
                cArgs.sceneService = this.$injector.get(Token.ClaraSceneService.key);
                cArgs.playerUrl = this.$rootScope.context.claraV2LibraryUrl;
                cArgs.ocLazyLoad = this.ocLazyLoad;
                sceneViewer = new ClaraViewer(cArgs);
            }
            else {
                sceneViewer = new Kb3dViewer(vArgs);
            }
            return sceneViewer.init().then(function () {
                viewerScope.$on('$destroy', function () {
                    sceneViewer.dispose();
                });
                return sceneViewer;
            });
        };
        ConfiguratorController.prototype.runSceneAction = function (config, actionName) {
            var _this = this;
            if (this.lastViewerPromise) {
                return this.lastViewerPromise.then(function () {
                    return _this.$scope.activeSceneViewer && _this.$scope.activeSceneViewer.runAction(actionName);
                });
            }
            else {
                return this.refreshViewer().then(function () {
                    return _this.$scope.activeSceneViewer && _this.$scope.activeSceneViewer.runAction(actionName);
                });
            }
        };
        ConfiguratorController.prototype.getCurrentConfigForViewerAndSetViewerMode = function () {
            var currentConfig = this.rootConfig;
            if (this.$scope.selected.page)
                currentConfig = this.$scope.selected.page.$parentConfigurator;
            // find the closest config that should show a 3d viewer
            while (currentConfig) {
                if (currentConfig.viewerMode == enums.eViewerMode.media || currentConfig.viewerMode == enums.eViewerMode.none) {
                    break;
                }
                else if (currentConfig.viewerMode == enums.eViewerMode.scene && currentConfig.idScene) {
                    if (!currentConfig.$parent)
                        break;
                    // it's nested: we only show it if it's not set to merge scenes with it's parent
                    var refConfig = currentConfig.$parentConfigurator.referencedConfigurators.find(function (rc) { return rc.idProduct == currentConfig.idProduct; });
                    if (!refConfig.nestScene)
                        break;
                }
                currentConfig = currentConfig.$parentConfigurator;
            }
            if (!currentConfig) {
                this.$scope.viewerMode = enums.eViewerMode.none;
            }
            else {
                this.$scope.viewerMode = currentConfig.viewerMode;
            }
            return currentConfig;
        };
        ConfiguratorController.prototype.refreshViewer = function (skipRules) {
            var _this = this;
            if (skipRules === void 0) { skipRules = false; }
            if (!this.lastViewerPromise)
                this.lastViewerPromise = new _rules.KPromise(null);
            this.lastViewerPromise = this.lastViewerPromise.then(function () {
                var viewerDeferred = _this.$q.defer();
                var origSceneViewer = _this.$scope.activeSceneViewer;
                var origConfig = origSceneViewer ? origSceneViewer.uiConfig : null;
                var currentConfig = _this.getCurrentConfigForViewerAndSetViewerMode();
                if (currentConfig) {
                    if (_this.sceneDb[currentConfig.idScene] && _this.sceneDb[currentConfig.idScene].external) {
                        currentConfig.nestedPath = currentConfig.idScene;
                    }
                    else {
                        currentConfig.nestedPath = _this.getConfiguratorUniqueKey(currentConfig);
                    }
                    if (currentConfig.viewerMode == enums.eViewerMode.media) {
                        _this.$scope.viewerMediaPath = currentConfig.viewerMediaPath;
                        viewerDeferred.resolve();
                    }
                    else if (currentConfig.viewerMode == enums.eViewerMode.scene) {
                        var clear = _this.rootConfig.clearMemoryWhenSwitchingScenes &&
                            _this.$scope.activeSceneViewer &&
                            _this.$scope.activeSceneViewer.scene.id != currentConfig.idScene;
                        /**
                         * for kb3d if we are clearing memory we just dispose of the old viewer and make a new one
                         */
                        if (clear && !_this.sceneDb[currentConfig.idScene].external) {
                            delete _this.sceneViewerDb[currentConfig.nestedPath];
                            origSceneViewer.dispose();
                            _this.$scope.activeSceneViewer = null;
                            clear = false;
                        }
                        if (clear) {
                            _this.$timeout(function () {
                                _this.sceneViewerDb[currentConfig.nestedPath] = _this.$scope.activeSceneViewer;
                                _this.$scope.activeSceneViewer
                                    .loadScene({
                                    scene: _this.sceneDb[currentConfig.idScene],
                                    clearMemory: true,
                                    config: currentConfig,
                                    isStandalone: _this.$scope.isScene,
                                    isRenderContext: false,
                                })
                                    .then(function () { return viewerDeferred.resolve(); });
                            }, 0);
                        }
                        else {
                            _this.$scope.activeSceneViewer = _this.sceneViewerDb[currentConfig.nestedPath];
                            if (_this.$scope.activeSceneViewer) {
                                // execute scene on next frame so configurator appears responsive
                                _this.$timeout(function () {
                                    // if we are switching configurators, but keeping the same sceneViewer,
                                    // then we need to clear the clickDb
                                    if (_this.$scope.activeSceneViewer.uiConfig != currentConfig) {
                                        _this.$scope.activeSceneViewer.clearHandlers();
                                    }
                                    // set the uiConfig of the viewer
                                    if (_this.$scope.activeSceneViewer.sceneConfig.idProduct == currentConfig.idProduct) {
                                        currentConfig.$sceneConfigurator = _this.$scope.activeSceneViewer.sceneConfig;
                                        _this.$scope.activeSceneViewer.sceneConfig.$uiConfigurator = currentConfig;
                                        _this.$scope.activeSceneViewer.uiConfig = currentConfig;
                                    }
                                    //only skip rules if we are told to and we haven't switched scene viewers
                                    if (skipRules && _this.$scope.activeSceneViewer.uiConfig == origConfig) {
                                        viewerDeferred.resolve();
                                    }
                                    else {
                                        _this.$scope.activeSceneViewer
                                            .runRules(true)
                                            //.then(result => this.helper.handleRuleError(eRuleType.scene, result))
                                            .then(function () { return viewerDeferred.resolve(); });
                                    }
                                }, 0);
                            }
                            else {
                                // init the sceneViewer which also runs the rules
                                //if there is no viewer in the layout, then we skip
                                if (!_this.isViewerInLayout()) {
                                    viewerDeferred.resolve();
                                }
                                else {
                                    _this.waitForViewerReady().then(function () {
                                        var scene = _this.sceneDb[currentConfig.idScene];
                                        _this.createSceneViewer(scene).then(function (sceneViewer) {
                                            _this.$scope.activeSceneViewer = sceneViewer;
                                            _this.sceneViewerDb[currentConfig.nestedPath] =
                                                _this.$scope.activeSceneViewer;
                                            _this.$scope.activeSceneViewer
                                                .loadScene({
                                                scene: scene,
                                                clearMemory: _this.rootConfig.clearMemoryWhenSwitchingScenes,
                                                config: currentConfig,
                                                isStandalone: _this.$scope.isScene,
                                                isRenderContext: false,
                                            })
                                                .then(function () { return viewerDeferred.resolve(); });
                                        });
                                    }, function (err) {
                                        viewerDeferred.reject(err);
                                    });
                                }
                            }
                        }
                    }
                    else {
                        viewerDeferred.resolve();
                    }
                }
                else {
                    viewerDeferred.resolve();
                }
                // set other viewers to hide
                Object.keys(_this.sceneViewerDb).forEach(function (key) {
                    if (_this.$scope.viewerMode != enums.eViewerMode.scene ||
                        _this.$scope.activeSceneViewer !== _this.sceneViewerDb[key]) {
                        _this.sceneViewerDb[key].hide();
                    }
                    else {
                        _this.sceneViewerDb[key].show();
                    }
                });
                return viewerDeferred.promise;
            });
            // console.log(this.configuratorMap);
            // console.log(this.nestedSceneMap);
            return this.lastViewerPromise;
        };
        ConfiguratorController.prototype.isViewerInLayout = function () {
            return this.$scope.config.getChildrenOfType(enums.CToken.Viewer).some(function (v) { return v.visible; });
        };
        ConfiguratorController.prototype.waitForViewerReady = function () {
            if (!this.isViewerInLayout()) {
                return new _rules.KPromise(null);
            }
            else {
                var elemDefer_1 = Q__namespace.defer();
                var waitedFor_1 = 0;
                var wait_1 = 30;
                var check_1 = function () {
                    var parentElem = document.querySelector('.kb-viewer');
                    if (parentElem && parentElem.getBoundingClientRect().height > 0) {
                        if (waitedFor_1)
                            console.log("waited ".concat(waitedFor_1, "ms for viewer ready"));
                        elemDefer_1.resolve();
                    }
                    else {
                        setTimeout(function () {
                            waitedFor_1 += wait_1;
                            check_1();
                        }, wait_1);
                    }
                };
                check_1();
                return elemDefer_1.promise;
            }
        };
        ConfiguratorController.prototype.hasPricing = function () {
            return (this.rootConfig.hasPricingRule ||
                this.hasNestedPricing() ||
                (this.$scope.isTest && this.rootConfig.ruleContainers.some(function (rc) { return rc.ruleType == enums.eRuleType.pricing; })));
        };
        ConfiguratorController.prototype.runPricing = function () {
            var _this = this;
            var promise = new _rules.KPromise(null);
            if (this.hasPricing()) {
                var configuredProduct = this.rootConfig.getConfiguredProduct();
                promise = this.lastPricingPromise = this.$http
                    .post('/api/products/' + this.$scope.entity.id + '/pricing', configuredProduct, {
                    tracker: this.$scope.pricingTracker,
                })
                    .then(function (response) {
                    _this.rootConfig.priceObject = _this.$scope.priceObject = response.data;
                }, function (error) {
                    _this.helper.handleRuleError('Pricing Rule', {
                        hasError: true,
                        error: new Error(error.data.error),
                        parameters: _this.getRuleArgs(_this.rootConfig),
                    });
                });
            }
            return promise;
        };
        ConfiguratorController.prototype.addLevelsToPricing = function (item, level) {
            var _this = this;
            if (level === void 0) { level = -1; }
            var o = item;
            if (o) {
                o.$level = level;
                item.items && item.items.forEach(function (i) { return _this.addLevelsToPricing(i, level + 1); });
            }
        };
        ConfiguratorController.prototype.hasNestedPricing = function () {
            var _this = this;
            return this.rootConfig
                .getNestedConfigurators()
                .some(function (nested) {
                return nested.hasPricingRule &&
                    _this.rootConfig.referencedConfigurators.find(function (rc) { return rc.idProduct == nested.idProduct; }).nestPriceObject;
            });
        };
        ConfiguratorController.prototype.setScene = function (configurator, idScene) {
            if (configurator.idScene != idScene) {
                configurator.idScene = idScene;
                configurator.$nestedSceneId = null;
                configurator.$sceneConfigurator = null;
                return this.refreshViewer();
            }
            return new _rules.KPromise(null);
        };
        ConfiguratorController.prototype.trackConfigPageView = function (page) {
            if (page) {
                var path = page.name;
                var parent_4 = page.$parentConfigurator;
                while (parent_4.$parentConfigurator) {
                    path = "".concat(parent_4.name, "/").concat(path);
                    parent_4 = parent_4.$parentConfigurator;
                }
                this.telemetryService.trackEvent('Configurator Page View', { pageName: path });
            }
        };
        ConfiguratorController.prototype.getParameters = function () {
            var _a, _b;
            var parameters = _tools.Utils.extend(this.$location.search(), this.$scope.embedParameters);
            // combine query string parameters with sfdc parameters
            if (this.$rootScope.context.sfdcCanvasRequest) {
                parameters = _tools.Utils.extend(this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters, parameters);
                if (this.$rootScope.isSfdcCpq) {
                    parameters.sfdcQuote = this.sfdcCpqPayload.fullQuote;
                    parameters.sfdcConfiguredProductId = this.sfdcCpqPayload.data.product.configuredProductId;
                    parameters.sfdcQuoteLine = (_b = (_a = this.sfdcCpqPayload) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.product;
                }
            }
            if (!this.$scope.isKinetic && !parameters.kineticCompany && this.rootConfig.defaultKineticCompany) {
                // set default kinetic company from configurator
                parameters.kineticCompany = this.rootConfig.defaultKineticCompany;
            }
            return parameters;
        };
        ConfiguratorController.prototype.runContinuousAsyncRule = function (id, timeSeconds) {
            var _this = this;
            if (!this.scheduledRules)
                this.scheduledRules = [];
            if (this.scheduledRules.find(function (a) { return a.id == id; })) {
                this.cancelScheduledRule(id);
            }
            var interval = this.$interval(function () {
                if (_this.$rootScope && _this.runAsyncRule) {
                    _this.$rootScope.showSpinner = false;
                    return _this.helper.runActionByIdAsync(_this.rootConfig, id).then(function (result) {
                        _this.$rootScope.showSpinner = true;
                        _this.$rootScope.$apply();
                        // TODO: Will need to run this conditionally on whether a rule cycle
                        // actually needs to be run after an interval is run.
                        //this.runRuleCycleUnit(this.$scope.config, null);
                    });
                }
            }, timeSeconds * 1000);
            this.scheduledRules.push({
                id: id,
                promise: interval
            });
        };
        ConfiguratorController.prototype.cancelScheduledRule = function (id) {
            if (this.scheduledRules && this.scheduledRules.length > 0) {
                var runningRule = this.scheduledRules.find(function (a) { return a.id == id; });
                if (runningRule) {
                    this.$interval.cancel(runningRule.promise);
                    this.scheduledRules.remove(runningRule);
                }
            }
            return;
        };
        ConfiguratorController.prototype.runTimeoutRule = function (func, timeSeconds) {
            var _this = this;
            this.$timeout(function () {
                //this.$rootScope.showSpinner = false;
                if (_this.$rootScope && _this.runAsyncRule) {
                    _this.$rootScope.showSpinner = false;
                    var res = func();
                    if (res instanceof Promise) {
                        return res.then(function () {
                            _this.$rootScope.showSpinner = true;
                        });
                    }
                    else {
                        return res;
                    }
                    // return this.helper.runActionByIdAsync(this.rootConfig, id).then(() => {
                    //     this.$rootScope.showSpinner = true;
                    //     this.$rootScope.$apply();
                    // });
                }
            }, timeSeconds * 1000);
        };
        ConfiguratorController.prototype.fillSourcedTables = function (session) {
            new _rules.KPromise(null);
            if (session.sourcedTableIds && session.sourcedTableIds.length) {
                return this.api.tables.getBatch({ ids: session.sourcedTableIds }).then(function (sourcedTables) {
                    if (sourcedTables && sourcedTables.length) {
                        session.tables.pushArray(sourcedTables);
                    }
                });
            }
            else {
                return new _rules.KPromise(null);
            }
        };
        var ConfiguratorController_1;
        ConfiguratorController.cycleLimit = 2;
        ConfiguratorController = ConfiguratorController_1 = __decorate([
            NgView({
                token: Token.ConfiguratorView,
                dependencies: [
                    Token.$Scope,
                    Token.$Q,
                    Token.$Location,
                    Token.$State,
                    Token.$StateParams,
                    Token.$Http,
                    Token.$RootScope,
                    Token.$Window,
                    Token.$Compile,
                    Token.$Injector,
                    Token.DialogService,
                    Token.$Timeout,
                    Token.$Interval,
                    Token.$Filter,
                    Token.DrawerService,
                    Token.RuleService,
                    Token.UploadService,
                    Token.AuthService,
                    Token.QuoteService,
                    Token.PromiseTracker,
                    Token.ApiService,
                    Token.ThemeService,
                    Token.SfdcService,
                    Token.KbService,
                    Token.TelemetryService,
                    Token.InteractionService,
                    Token.$OcLazyLoad,
                ],
            })
        ], ConfiguratorController);
        return ConfiguratorController;
    }(BaseController));

    var ProductCompareController = /** @class */ (function (_super) {
        __extends(ProductCompareController, _super);
        function ProductCompareController($scope, $state, $rootScope, api, drawerService, quoteService, model) {
            var _this = _super.call(this) || this;
            $rootScope.setTitle(loc.productcomparison);
            drawerService.setHelpUrl("Products");
            drawerService.pageTitle = loc.productcomparison;
            drawerService.pageType = loc.product;
            drawerService.pageIcon = _tools.icons.cast;
            $scope.model = model;
            $scope.addToQuote = function (product) {
                quoteService.addProduct({ idProduct: product.id, qty: product.minQty, addLocally: true });
            };
            $scope.removeProduct = function (id) {
                $rootScope.comparedProducts.removeWhere(function (p) { return p == id; });
                if ($rootScope.comparedProducts.length > 0) {
                    $state.go("kb.productCompare", { ids: $rootScope.comparedProducts });
                }
                else {
                    $state.go("kb.products");
                }
            };
            return _this;
        }
        ProductCompareController = __decorate([
            NgView({
                token: Token.ProductCompareView,
                dependencies: [
                    Token.$Scope,
                    Token.$State,
                    Token.$RootScope,
                    Token.ApiService,
                    Token.DrawerService,
                    Token.QuoteService,
                    Token.Model
                ],
                resolves: [
                    {
                        name: "model",
                        dependencies: [
                            Token.ApiService,
                            Token.AuthService,
                            Token.$StateParams,
                            Token.$RootScope,
                        ],
                        fn: function (api, authService, $stateParams, $rootScope) {
                            return authService.authPromise.then(function () {
                                return api.products.getBatch({ ids: $stateParams.ids }, $rootScope.contentTracker);
                            }
                            // api.products.search({ 
                            //     query: `id:(${$stateParams.ids.join(" OR ")})`
                            // }, $rootScope.contentTracker)
                            );
                        }
                    }
                ]
            })
        ], ProductCompareController);
        return ProductCompareController;
    }(BaseController));

    var ProductController = /** @class */ (function (_super) {
        __extends(ProductController, _super);
        function ProductController($scope, $state, $rootScope, api, drawerService, quoteService, dialogService, model) {
            var _this = _super.call(this) || this;
            $rootScope.setTitle(model.name);
            drawerService.setHelpUrl("Products");
            drawerService.pageTitle = $scope.model.name;
            drawerService.pageType = loc.product;
            drawerService.pageIcon = _tools.icons.standardProducts;
            $scope.model = model;
            $scope.qty = $scope.model.minQty;
            if (model.images && model.images.length > 0) {
                $scope.selectedMedia = model.images[0].imagePath;
            }
            $scope.selectMedia = function (path) {
                $scope.selectedMedia = path;
            };
            $scope.addToQuote = function () {
                quoteService.addProduct({ idProduct: $scope.model.id, qty: $scope.qty, addLocally: true });
            };
            $scope.getVolumeDiscountText = function (volumeDiscount) {
                var result = volumeDiscount.qty.toString();
                var nextTier = null;
                var orderedVolumeDiscounts = $scope.model.volumeDiscounts.sort(function (a, b) { return a.qty - b.qty; });
                for (var i = 0; i < orderedVolumeDiscounts.length; i++) {
                    if (orderedVolumeDiscounts[i].qty == volumeDiscount.qty) {
                        nextTier = orderedVolumeDiscounts[i + 1];
                        break;
                    }
                }
                if (nextTier) {
                    result += " " + loc.to + " " + (nextTier.qty - 1).toString() + " " + loc.units;
                }
                else {
                    result += " " + loc.units + " " + loc.andabove + ": ";
                }
                return result;
            };
            api.products.searchByCategory({
                query: (model.relatedProductsQuery ? model.relatedProductsQuery : model.name) + " -id:" + model.id,
                take: 5,
                skip: 0
            }).then(function (r) { return $scope.relatedProducts = r; });
            // add drawers
            if (model.isConfigured) {
                drawerService.addDrawer(_tools.icons.gear, "Configure", function () { return $state.go("kb.configurator", { id: model.id }); });
            }
            else {
                drawerService.addDrawer(_tools.icons.add, loc.addtoquote, $scope.addToQuote);
            }
            if (!$rootScope.comparedProducts.contains($scope.model.id)) {
                drawerService.addDrawer(_tools.icons.cast, loc.compare, function () {
                    if ($rootScope.comparedProducts.length >= 4) {
                        dialogService.alert({
                            msg: loc.msg_productcomparisonlimit,
                            type: enums.eAlertType.info
                        });
                    }
                    else {
                        $rootScope.comparedProducts.push($scope.model.id);
                        $state.go("kb.products");
                    }
                });
            }
            return _this;
        }
        ProductController = __decorate([
            NgView({
                token: Token.ProductView,
                dependencies: [
                    Token.$Scope,
                    Token.$State,
                    Token.$RootScope,
                    Token.ApiService,
                    Token.DrawerService,
                    Token.QuoteService,
                    Token.DialogService,
                    Token.Model
                ],
                resolves: [
                    {
                        name: "model",
                        dependencies: [
                            Token.ApiService,
                            Token.AuthService,
                            Token.$StateParams,
                            Token.$RootScope,
                        ],
                        fn: function (api, authService, $stateParams, $rootScope) {
                            return authService.authPromise.then(function () {
                                return api.products.getById($stateParams.id, $rootScope.contentTracker);
                            });
                        }
                    }
                ]
            })
        ], ProductController);
        return ProductController;
    }(BaseController));

    var ProductsController = /** @class */ (function (_super) {
        __extends(ProductsController, _super);
        function ProductsController($scope, agg, kbService, quoteService, categories) {
            var _this = _super.call(this, $scope, agg, true) || this;
            _this.$scope = $scope;
            _this.agg = agg;
            _this.kbService = kbService;
            _this.quoteService = quoteService;
            _this.categories = categories;
            _this.flatCategories = [];
            agg.$rootScope.setTitle(loc.products);
            agg.drawerService.setHelpUrl("Products");
            agg.drawerService.pageType = loc.products;
            agg.drawerService.pageIcon = _tools.icons.products;
            $scope.categories = categories;
            _this.flatCategories = categories.flatten(function (c) { return c.items; });
            $scope.attributeDb = {};
            for (var _i = 0, _a = _this.flatCategories; _i < _a.length; _i++) {
                var c = _a[_i];
                if (c.attributes) {
                    for (var _b = 0, _c = c.attributes; _b < _c.length; _b++) {
                        var a = _c[_b];
                        $scope.attributeDb[a.id] = a;
                    }
                }
            }
            $scope.savedSearchEnabled = false;
            $scope.customResults = true;
            if (agg.$state.params.imagemode) {
                $scope.imageMode = (agg.$state.params.imagemode == "true");
            }
            else {
                $scope.imageMode = agg.$rootScope.context.companySettings.displayProductsInImageModeByDefault;
            }
            $scope.setToImageMode = function () {
                $scope.imageMode = true;
                // pageSize = 35;
            };
            $scope.setToListMode = function () {
                $scope.imageMode = false;
                // pageSize = 11;
            };
            $scope.getChildCategories = function (cat) {
                return _this.getChildCategories(cat);
            };
            $scope.translateSuggestion = function (item) {
                var name = item.name;
                if (agg.$rootScope.companySettings.defaultLanguage != agg.$rootScope.clientLanguage && item.translations) {
                    var translation = item.translations.find(function (t) { return t.languageIso == agg.$rootScope.clientLanguage; });
                    if (translation) {
                        name = translation.name || item.name;
                    }
                }
                return name;
            };
            // when the category selection is changed, fire a search
            $scope.$watch("binding.selectedCategory", function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    _this.$scope.binding.search.selectedCategoryId = newVal.id;
                    _this.refreshAttributeFilters();
                    $scope.reload();
                }
            });
            var addProductPromise = new _rules.KPromise(null);
            $scope.addToQuote = function (product, qty) {
                if (product.isConfigured) {
                    agg.$state.go("kb.configurator", { id: product.id });
                }
                else {
                    kbService.fly("#product_" + product.id.toString() + "_image", "#product-fly-target", function () {
                        addProductPromise = addProductPromise.then(function () {
                            return quoteService.addProduct({ idProduct: product.id, qty: qty, addLocally: true });
                        });
                    });
                }
            };
            _this.init();
            _this.loadSelectedCategory();
            _this.refreshAttributeFilters();
            return _this;
        }
        ProductsController.prototype.preInit = function () {
        };
        ProductsController.prototype.client = function (api) {
            return api.products;
        };
        ProductsController.prototype.getQueryStringParams = function () {
            return { imagemode: this.$scope.imageMode };
        };
        ProductsController.prototype.searchCall = function (args, tracker) {
            args.categoryIds = [];
            if (this.$scope.binding.selectedCategory.id >= 0) {
                args.categoryIds = this.getChildCategories(this.$scope.binding.selectedCategory);
            }
            return this.client(this.agg.api).searchByCategory(args, tracker);
        };
        ProductsController.prototype.loadedFromQueryString = function (search) {
            this.loadSelectedCategory();
        };
        ProductsController.prototype.massageResults = function (items) {
            //add a property to the product for the UI to control the qty getting added to the quote
            items.forEach(function (p) { return p.$addQty = p.minQty; });
        };
        ProductsController.prototype.loadSelectedCategory = function () {
            var _this = this;
            if (this.$scope.binding.search.selectedCategoryId == null)
                this.$scope.binding.search.selectedCategoryId = -1;
            this.$scope.binding.selectedCategory = this.getCategory(this.$scope.categories, this.$scope.binding.search.selectedCategoryId);
            this.agg.$timeout(function () {
                _this.expandToSelectedCategory();
            }, 0);
        };
        ProductsController.prototype.newSearch = function () {
            var _this = this;
            return {
                selectedCategoryId: -1,
                modelType: enums.meta.Product.$name,
                sortField: "score",
                descending: true,
                filters: (function () {
                    var filters = [];
                    filters.push({
                        type: enums.eFilterType.sort,
                        label: loc.sortby,
                        control: enums.eFilterControl.select,
                        sourceType: enums.eFilterSource.productSorts,
                        valueField: "value",
                        labelField: "label",
                        values: [enums.eProductSortBy.relevance],
                        sticky: true
                    });
                    filters.pushArray(_this.getFiltersFromMeta(enums.meta.Product.$name, true));
                    return filters;
                })()
            };
        };
        ProductsController.prototype.getCategory = function (cats, id) {
            if (cats) {
                for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
                    var cat = cats_1[_i];
                    if (cat.id == id) {
                        return cat;
                    }
                    var match = this.getCategory(cat.items, id);
                    if (match) {
                        return match;
                    }
                }
            }
            return null;
        };
        /** gets an array of the selected category id and all of it's children id's used for filtering the search results*/
        ProductsController.prototype.getChildCategories = function (cat) {
            var _this = this;
            var ids = [];
            ids.push(cat.id);
            cat.items.forEach(function (child) {
                ids = ids.concat(_this.getChildCategories(child));
            });
            return ids;
        };
        ProductsController.prototype.expandToSelectedCategory = function () {
            var addParentRef = function (cats, parent) {
                cats.forEach(function (cat) {
                    cat.$parent = parent;
                    if (cat.items)
                        addParentRef(cat.items, cat);
                });
            };
            addParentRef(this.$scope.categories, null);
            var selectedAncestors = [];
            var p = this.$scope.binding.selectedCategory;
            while (p) {
                selectedAncestors.push(p);
                p = p.$parent;
            }
            selectedAncestors.forEach(function (a) { return a.expanded = true; });
        };
        ProductsController.prototype.refreshAttributeFilters = function () {
            var availableAtts = this.getSelectedCategoryAttributes();
            //remove available attribute filters
            this.$scope.availableFilters.removeWhere(function (f) { return f.type == enums.eFilterType.attribute; });
            //remove any existing filters that are referencing attributes no longer applicable
            this.$scope.binding.search.filters.removeWhere(function (f) { return f.type == enums.eFilterType.attribute && !availableAtts.some(function (a) { return a.name == f.fieldName; }); });
            var attFilters = this.$scope.binding.search.filters.filter(function (f) { return f.type == enums.eFilterType.attribute; });
            var _loop_1 = function (a) {
                if (!attFilters.find(function (f) { return f.attributeId == a.id; })) { //only add the attribute filter it if it's not already a filter
                    var f = {
                        type: enums.eFilterType.attribute,
                        fieldName: a.name,
                        label: a.name,
                        fieldType: a.type,
                        sourceType: enums.eFilterSource.attributes,
                        values: [null],
                        attributeId: a.id
                    };
                    if (a.default) {
                        this_1.$scope.binding.search.filters.push(f);
                    }
                    else {
                        this_1.$scope.availableFilters.push(f);
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, availableAtts_1 = availableAtts; _i < availableAtts_1.length; _i++) {
                var a = availableAtts_1[_i];
                _loop_1(a);
            }
            this.fillFilters(); //fill the filters again so it fills the attribute filters
        };
        ProductsController.prototype.getSelectedCategoryAttributes = function () {
            var parentCats = {};
            var selectedCat = this.$scope.binding.selectedCategory;
            this.flatCategories.filter(function (c) { return selectedCat.lft >= c.lft && selectedCat.rgt <= c.rgt; }).forEach(function (c) { return parentCats[c.id] = c; });
            return Object.values(parentCats).selectMany(function (c) { return c.attributes; });
        };
        ProductsController = __decorate([
            NgView({
                token: Token.ProductsView,
                dependencies: [
                    Token.$Scope,
                    Token.SearchService,
                    Token.KbService,
                    Token.QuoteService,
                    Token.Categories
                ],
                resolves: [
                    {
                        name: "categories",
                        dependencies: [
                            Token.$RootScope,
                            Token.AuthService,
                            Token.ApiService
                        ],
                        fn: function ($rootScope, authService, api) {
                            return authService.authPromise.then(function () {
                                return api.categories.tree({ onlyActiveCategories: true }, $rootScope.contentTracker).then(function (r) {
                                    r.unshift({ name: loc.all, id: -1 });
                                    return r;
                                });
                            });
                        }
                    }
                ]
            })
        ], ProductsController);
        return ProductsController;
    }(SearchController));

    var ConfiguredProductsController = /** @class */ (function (_super) {
        __extends(ConfiguredProductsController, _super);
        function ConfiguredProductsController($scope, agg, quoteService) {
            var _this = _super.call(this, $scope, agg) || this;
            _this.$scope = $scope;
            agg.$rootScope.setTitle(loc.configuredproducts);
            agg.drawerService.setHelpUrl("Quotes");
            agg.drawerService.pageType = loc.configuredproducts;
            agg.drawerService.pageIcon = _tools.icons.quote;
            $scope.binding.search.modelType = enums.meta.QuoteProduct.$name;
            $scope.savedSearchEnabled = true;
            _this.refreshSavedSearches();
            $scope.modelTypes = [
                { type: enums.meta.Quote.$name, label: "Quotes", state: "kb.quotes" },
                { type: enums.meta.QuoteProduct.$name, label: "Configured Products", state: "kb.configuredProducts" }
            ];
            _this.massageFilters($scope.availableFilters);
            $scope.availableFilters.pushArray([
                _this.getWhereFieldFilter()
            ]);
            var fieldsDb = {};
            $scope.$watch("binding.search.filters[0].values[0]", function (newVal, oldVal) {
                if (newVal) {
                    agg.api.configurators.searchFields(newVal).then(function (r) {
                        fieldsDb = {};
                        r.forEach(function (field) { return fieldsDb[field.name] = field; });
                        $scope.filterSource[enums.eFilterSource.fields] = r;
                    });
                }
            });
            // $scope.getFilterControlForField = (fieldName) => {
            //    var field = fieldsDb[fieldName];
            //    var fieldType = field ? field.type : eFieldType.text;
            //    if (fieldType == eFieldType.number)
            //        return eFilterControl.numberRange;
            //    else if (fieldType == eFieldType.boolean)
            //        return eFilterControl.checkbox;
            //    else
            //        return eFilterControl.text;
            // };
            $scope.fieldChange = function (filter) {
                var field = fieldsDb[filter.fieldName];
                var fieldType = field ? field.type : enums.eFieldType.text;
                filter.fieldType = fieldType;
                if (fieldType == enums.eFieldType.number) {
                    filter.control = enums.eFilterControl.numberRange;
                }
                else if (fieldType == enums.eFieldType.boolean) {
                    filter.control = enums.eFilterControl.checkbox;
                }
                else {
                    filter.control = enums.eFilterControl.text;
                }
            };
            $scope.showCopyToActiveQuoteBtn = function (qp) {
                /** only show this 'copy to active quote' button if we are not in the active quote, and the active quote allows modifying products */
                return (quoteService.quote
                    && quoteService.canModifyProductsOfQuote(quoteService.quote)
                    && !agg.$rootScope.isSfdc //this should never happen in CRM integration
                );
            };
            $scope.showCopyToNewQuoteBtn = function (qp) {
                return !agg.$rootScope.isSfdc; //creating a new quote in this way would break the CRM integration
            };
            $scope.copyProductToActiveQuote = function (qp) {
                return quoteService.copyProductToActiveQuote(qp.id).then(function (r) {
                    quoteService.goToQuote();
                });
            };
            $scope.copyProductToNewQuote = function (qp) {
                return quoteService.copyProductToNewQuote(qp.id).then(function (r) {
                    quoteService.goToQuote();
                });
            };
            agg.drawerService.addDrawer(_tools.icons.clone, loc.clone, function () { return _this.clone(); });
            agg.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, function () { return _this.deleteItems(); });
            return _this;
        }
        ConfiguredProductsController.prototype.client = function (api) {
            if (this.agg.$rootScope.company.useDatabaseSearch) {
                return api.quoteProducts;
            }
            else {
                return api.quotes;
            }
        };
        ConfiguredProductsController.prototype.newSearch = function () {
            var _this = this;
            return {
                modelType: enums.meta.QuoteProduct.$name,
                sortField: "modifiedDate",
                descending: true,
                filters: (function () {
                    var filters = [];
                    filters.push({
                        type: enums.eFilterType.property,
                        property: "idProduct",
                        label: "Product Type",
                        control: enums.eFilterControl.select,
                        sourceType: enums.eFilterSource.configurators,
                        valueField: "id",
                        labelField: "name",
                        values: [null],
                        sticky: true
                    }, _this.getWhereFieldFilter());
                    filters.pushArray(_this.getFiltersFromMeta(enums.meta.QuoteProduct.$name, true));
                    _this.massageFilters(filters);
                    return filters;
                })()
            };
        };
        ConfiguredProductsController.prototype.massageFilters = function (filters) {
            if (!this.agg.$rootScope.company.useDatabaseSearch) {
                // configured products is a tricky screen since we're searching for quotes, 
                // but really try to show stuff about products
                // so we need to massage the filters to add the nested property syntax
                filters.forEach(function (f) {
                    if (f.property && !f.property.startsWith("products.")) {
                        f.property = "products." + f.property;
                    }
                });
            }
        };
        ConfiguredProductsController.prototype.postProcessFilters = function (filters) {
            //don't send the product type filter if they haven't selected one
            filters.removeWhere(function (f) { return f.property == "idProduct" && !f.values.first(); });
        };
        /**
         * the properties of the queried objec that should be returned.
         */
        ConfiguredProductsController.prototype.fields = function () {
            if (this.agg.$rootScope.company.useDatabaseSearch) {
                return [
                    enums.meta.QuoteProduct.id.name,
                    enums.meta.QuoteProduct.name.name,
                    enums.meta.QuoteProduct.imagePath.name,
                    enums.meta.QuoteProduct.shortDescription.name,
                    enums.meta.QuoteProduct.price.name,
                    enums.meta.QuoteProduct.sku.name,
                    enums.meta.QuoteProduct.idQuote.name,
                    enums.meta.QuoteProduct.quote.name,
                    enums.meta.QuoteProduct.currency.name,
                    enums.meta.QuoteProduct.modifiedDate.name
                ];
            }
            else {
                return [
                    enums.meta.Quote.id.name,
                    enums.meta.Quote.name.name,
                    enums.meta.Quote.description.name,
                    enums.meta.Quote.customer.name,
                    enums.meta.Quote.idCustomer.name,
                    enums.meta.Quote.contact.name,
                    enums.meta.Quote.idContact.name,
                    enums.meta.Quote.totalPrice.name,
                    enums.meta.Quote.state.name,
                    enums.meta.Quote.createdDate.name,
                    enums.meta.Quote.modifiedDate.name,
                    enums.meta.Quote.ownedBy.name,
                    enums.meta.Quote.owner.name,
                    enums.meta.Quote.currency.name
                ];
            }
        };
        ConfiguredProductsController.prototype.nestedFields = function () {
            if (this.agg.$rootScope.company.useDatabaseSearch) {
                return [];
            }
            else {
                return [
                    enums.meta.QuoteProduct.id.name,
                    enums.meta.QuoteProduct.name.name,
                    enums.meta.QuoteProduct.imagePath.name,
                    enums.meta.QuoteProduct.shortDescription.name,
                    enums.meta.QuoteProduct.price.name,
                    enums.meta.QuoteProduct.sku.name
                ];
            }
        };
        ConfiguredProductsController.prototype.getNestedPath = function () {
            if (this.agg.$rootScope.company.useDatabaseSearch) {
                return null;
            }
            else {
                return "products";
            }
        };
        // public getRawFilter() {
        //    return { term: { isConfigured: true } };
        // }
        ConfiguredProductsController.prototype.getWhereFieldFilter = function () {
            return {
                type: enums.eFilterType.fieldValue,
                label: "Where Field",
                fieldName: null,
                control: enums.eFilterControl.none,
                sourceType: enums.eFilterSource.fields,
                values: [null]
            };
        };
        ConfiguredProductsController.prototype.getExtraFilters = function () {
            if (this.agg.$rootScope.company.useDatabaseSearch) {
                return [
                    {
                        property: enums.meta.QuoteProduct.isConfigured.name,
                        values: [true]
                    }
                ];
            }
            else {
                return [];
            }
        };
        ConfiguredProductsController = __decorate([
            NgView({
                token: Token.ConfiguredProductsView,
                inherit: [Token.SearchView],
                dependencies: [
                    Token.QuoteService,
                ]
            })
        ], ConfiguredProductsController);
        return ConfiguredProductsController;
    }(SearchController));

    var QuoteHeaderRuleArgs = /** @class */ (function () {
        function QuoteHeaderRuleArgs(ctrl) {
            this.ctrl = ctrl;
            this.isMobile = ctrl.$rootScope.windowWidth < _tools.Utils.MOBILE_WIDTH;
            this.windowWidth = ctrl.$rootScope.windowWidth;
            this.windowHeight = ctrl.$rootScope.windowHeight;
        }
        QuoteHeaderRuleArgs.prototype.getTables = function (args) {
            var _this = this;
            return new _rules.KPromise(args.ids.map(function (tid) { return _this.ctrl.helper.tableArraysDb[tid]; }));
        };
        QuoteHeaderRuleArgs.prototype.sendMessage = function (msg) {
            // send message to embed consumer
            _tools.Utils.sendMessageToParent({ name: msg.name, data: msg.data });
            this.ctrl.sfdcService.sendMessage(msg);
        };
        QuoteHeaderRuleArgs.prototype.convertCurrency = function (obj) {
            return this.ctrl.kbService.fxConvertAsync(obj.amount, obj.currencyCode);
        };
        QuoteHeaderRuleArgs.prototype.callSafeFunction = function (obj) {
            return this.ctrl.api.safeFunctions.run(obj.safeFunctionId, obj.parameters, this.ctrl.$rootScope.contentTracker);
        };
        QuoteHeaderRuleArgs.prototype.generateNumber = function (args) {
            return this.ctrl.api.generators.next(args.generatorId, this.ctrl.$rootScope.contentTracker);
        };
        QuoteHeaderRuleArgs.prototype.selectPage = function (page) {
            this.ctrl.$scope.selectedPageId = page.id;
        };
        QuoteHeaderRuleArgs.prototype.navigateToElement = function (elem) {
            var page = elem.findAncestor(function (kbo) { return kbo instanceof enums.Page; });
            if (page && page.visible) {
                this.ctrl.$scope.selectedPageId = page.id;
            }
        };
        QuoteHeaderRuleArgs.prototype.nextPage = function () {
            var selectedPage = this.configurator.$manager.get(this.ctrl.$scope.selectedPageId, false);
            if (selectedPage) {
                var index = this.configurator.pages.indexOf(selectedPage);
                if (index >= 0 && index < this.configurator.pages.length - 1) {
                    this.ctrl.$scope.selectedPageId = this.configurator.pages[index + 1].id;
                }
            }
        };
        QuoteHeaderRuleArgs.prototype.backPage = function () {
            var selectedPage = this.configurator.$manager.get(this.ctrl.$scope.selectedPageId, false);
            if (selectedPage) {
                var index = this.configurator.pages.indexOf(selectedPage);
                if (index >= 0 && index > 0) {
                    this.ctrl.$scope.selectedPageId = this.configurator.pages[index - 1].id;
                }
            }
        };
        QuoteHeaderRuleArgs.prototype.upload = function () { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.runSceneAction = function (name) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.callSceneFunction = function (args) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.setScene = function (args) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.runNamingRule = function () { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.addNestedConfigurator = function (idProduct, idParent, name) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.copyNestedConfigurator = function (nested, idParent, name) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.setNumberOfNestedConfigurators = function (idProduct, idParent, n) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.removeNestedConfigurator = function (nested) { return this.ctrl.$q.when(null); };
        QuoteHeaderRuleArgs.prototype.showPriceDetails = function () { };
        QuoteHeaderRuleArgs.prototype.alert = function (args) { this.ctrl.dialogService.alert(args); };
        QuoteHeaderRuleArgs.prototype.getOptionFilterSource = function (idOptionFilter, fromConfigurator) {
            fromConfigurator = fromConfigurator || this.configurator;
            var f = fromConfigurator.$manager.get(idOptionFilter);
            return new _rules.KPromise(f ? f.$source : []);
        };
        QuoteHeaderRuleArgs.prototype.setLayoutSetting = function (id, value) { };
        QuoteHeaderRuleArgs.prototype.getLayoutSetting = function (id) { };
        QuoteHeaderRuleArgs.prototype.runConfiguredProduct = function (cp) { };
        return QuoteHeaderRuleArgs;
    }());
    /** @class */ ((function (_super) {
        __extends(SvgRuleArgs, _super);
        function SvgRuleArgs() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return SvgRuleArgs;
    })(QuoteHeaderRuleArgs));
    /** @class */ ((function (_super) {
        __extends(HtmlRuleArgs, _super);
        function HtmlRuleArgs() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return HtmlRuleArgs;
    })(QuoteHeaderRuleArgs));
    var QuoteController = /** @class */ (function (_super) {
        __extends(QuoteController, _super);
        function QuoteController($scope, crudService, model, header, quoteService, sfdcService, ruleService, $filter, $timeout, $interval, $location, uploadService, kbService, storageService, productResolve) {
            var _this = _super.call(this, $scope, crudService, model) || this;
            _this.$scope = $scope;
            _this.crudService = crudService;
            _this.header = header;
            _this.quoteService = quoteService;
            _this.sfdcService = sfdcService;
            _this.ruleService = ruleService;
            _this.$filter = $filter;
            _this.$timeout = $timeout;
            _this.$interval = $interval;
            _this.$location = $location;
            _this.uploadService = uploadService;
            _this.kbService = kbService;
            _this.storageService = storageService;
            _this.productResolve = productResolve;
            _this.translationDb = {};
            crudService.$rootScope.setTitle(_this.$scope.model ? _this.$scope.model.name : loc.newquote);
            _this.bypassUnsavedConfirmation = !!model.idWorkflow;
            _this.drawerService.setHelpUrl("Quotes");
            _this.drawerService.pageTitle = _this.$scope.model ? _this.$scope.model.name : loc.newquote;
            _this.drawerService.pageType = loc.quote_title;
            _this.drawerService.pageIcon = _tools.icons.quote;
            $scope.companyHasStandardProducts = productResolve && productResolve.length > 0;
            $scope.v = {};
            $scope.customers = [];
            $scope.contacts = [];
            $scope.currencies = [];
            $scope.validationMessages = [];
            $scope.binding = {};
            $scope.selectedTab = "tab_basic";
            $scope.productsInView = [];
            $scope.productBuildTypes = {};
            /*$rootScope.$on(events.loginSuccessful, () =>
            {
                this.subscribe().finally(() =>
                {
                    if (this.submitQuotePending) {
                        this.submitQuotePending = false;
                        this.dialogService.confirm("Would you like to continue submitting your quote?", () =>
                        {
                            this.submit();
                        });
                    }
                });
            });*/
            var thisCtrl = _this;
            $scope.upload = function (file, field) {
                var uploadOptions = {
                    convertPdfToImage: field.convertUploadPdfToImage
                };
                return thisCtrl.uploadService.uploadQuoteFile(file, uploadOptions).then(function (uuid) {
                    var uploadValue = field.value;
                    uploadValue.path = uuid;
                    // clear the asset id in case there was an old file there that was just 
                    // replaced to make sure the new file is uploaded to the scene
                    uploadValue.assetId = null;
                });
            };
            var viewType = _this.$state.current.data.viewType;
            if ($scope.model) {
                _this.deleteMsg = loc.msg_deleterecord.format(loc.quote_title, $scope.model.name);
            }
            _this.onRelationshipEdited("Files", function (m) {
                _this.setUpdatedModelInternal(m, false);
            });
            if (viewType == enums.eViewType.new) {
                _this.$location.search().idcategory;
                model = $scope.model = quoteService.getNewQuote();
                if (_this.sfdcService.record() && _this.sfdcService.record().Name) {
                    $scope.model.name = _this.sfdcService.record().Name;
                }
            }
            if (_this.$rootScope.isSfdc && !_this.$rootScope.isSfdcCpq) {
                quoteService.quote = _this.$scope.model;
            }
            $scope.assignQuote = function () {
                var _a;
                // update the owner name for display (when the kbAtom is not active)
                var owner = ((_a = $scope.users) !== null && _a !== void 0 ? _a : []).find(function (u) { return u.id == $scope.model.ownedBy; });
                $scope.model.owner = owner ? owner.name : null;
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.assignQuote);
                    }
                    else if ($scope.model.state) {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateName = function () {
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.modifyName);
                    }
                    else {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateCurrency = function () {
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.modifyCurrency);
                    }
                    else if ($scope.model.state) {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateCustomer = function () {
                // update the customer name for display (when the kbAtom is not active)
                var customer = $scope.customers.find(function (c) { return c.id == $scope.model.idCustomer; });
                $scope.model.customer = customer ? customer.name : null;
                var contact = $scope.contacts.find(function (c) { return c.id == $scope.model.idContact; });
                $scope.model.contact = contact ? contact.name : null;
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.modifyCustomer);
                    }
                    else if ($scope.model.state) {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateDiscount = function () {
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.modifyDiscount);
                    }
                    else if ($scope.model.state) {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateShipping = function () {
                if ($scope.model.state) {
                    if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                        $scope.executeAction(enums.eWorkflowAction.modifyShipping);
                    }
                    else if ($scope.model.state) {
                        _this.promptUserToFixErrors();
                        _this.revertToClean();
                    }
                }
            };
            $scope.updateProduct = function (quoteProduct) {
                if (_this.validate() || _this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                    if ($scope.model.idWorkflow || quoteProduct.requiresUpdate) {
                        // we are in a workflow so we need to run the action OR we need to update
                        // the product to re - run it's pricing rule (if it uses the qtyInQuote variable)
                        return $scope.executeAction(enums.eWorkflowAction.modifyProducts, quoteProduct);
                    }
                }
                else if ($scope.model.state) {
                    _this.promptUserToFixErrors();
                    _this.revertToClean();
                }
            };
            $scope.updateProductDescription = function (quoteProduct) {
                if (_this.validate()) {
                    if ($scope.model.idWorkflow || quoteProduct.requiresUpdate) {
                        // we are in a workflow so we need to run the action OR we need to update the product
                        // to re - run it's pricing rule (if it uses the qtyInQuote variable)
                        return $scope.executeAction(enums.eWorkflowAction.modifyQuoteProductDescription, quoteProduct);
                    }
                }
            };
            if (!$scope.model.discountPercentage)
                $scope.model.discountPercentage = 0;
            $scope.getAvailableProductBuildTypes = function (product) {
                var result = [];
                if (product.isConfigured && _this.$scope.productBuildTypes[product.idProduct]) {
                    result = $scope.availableProductBuildTypes.filter(function (b) { return _this.$scope.productBuildTypes[product.idProduct].contains(b.id); });
                }
                return result;
            };
            $scope.buildProduct = function (product, idBuildType) {
                _this.api.quotes.buildQuoteProduct(_this.$scope.model.id, product.id, idBuildType).then(function (q) {
                    _this.handleActionResponse(q, enums.eWorkflowAction.buildQuoteProduct);
                    _this.dialogService.alert({
                        type: enums.eAlertType.success,
                        persist: false,
                        msg: loc.quoteproductbuilding
                    });
                });
            };
            $scope.commentListApi = {
                refresh: function () {
                }
            };
            $scope.downloadQuoteProductFile = function (file) {
                _this.$window.open("/api/quotes/productfile/download/" + file.id, "_blank");
            };
            $scope.addProduct = function () {
                _this.validate();
                if (!_this.$scope.model.name)
                    return;
                // save the current quote
                quoteService.quote = $scope.model;
                $scope.executeAction(enums.eWorkflowAction.save).then(function () {
                    _this.bypassUnsavedConfirmation = true;
                    _this.$state.go("kb.products");
                });
            };
            var expandedProducts = {};
            $scope.isExpanded = function (product) {
                return expandedProducts[product.id];
            };
            $scope.toggleExpansion = function (product, expand) {
                if (expand == null) {
                    expandedProducts[product.id] = !expandedProducts[product.id];
                }
                else {
                    expandedProducts[product.id] = expand;
                }
            };
            $scope.downloadAttachment = function (item) {
                if (item.source == enums.eFileSource.media) {
                    window.open(storageService.getMediaUrl(item.filePath));
                }
                else {
                    window.open("api/quotes/file/download/" + item.id, "_blank");
                }
            };
            $scope.hasFileGenerating = function (product) {
                return product.files && product.files.some(function (f) { return f.status == enums.eFileStatus.generating; });
            };
            $scope.deleteProduct = function (product) {
                _this.dialogService.dialog({
                    content: loc.msg_deletequoteproduct.format(product.name),
                    buttons: [
                        new enums.DialogButton(loc.ok, _tools.icons.success, function (args) {
                            var promise = _this.$q.when(true);
                            if (!_this.$scope.model.idWorkflow) {
                                promise = _this.$scope.executeAction(enums.eWorkflowAction.save);
                            }
                            return promise.then(function () {
                                return _this.api.quotes.deleteQuoteProduct($scope.model.id, product, _this.$rootScope.contentTracker).then(function (r) {
                                    _this.handleActionResponse(r, enums.eWorkflowAction.modifyProducts);
                                });
                            });
                        }),
                        new enums.DialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                        })
                    ]
                });
            };
            $scope.isActiveQuote = function () {
                return quoteService.quote != null && $scope.model.id == quoteService.quote.id;
            };
            $scope.showCopyToActiveQuoteBtn = function (qp) {
                /** only show this 'copy to active quote' button if we are not in the active quote, and the active quote allows modifying products */
                return (qp.isConfigured
                    && !$scope.isActiveQuote() //this quote is not the active quote
                    && quoteService.quote
                    && quoteService.canModifyProductsOfQuote(quoteService.quote)
                    && !_this.$rootScope.isSfdc //this should never happen in CRM integration
                );
            };
            $scope.showCopyToThisQuoteBtn = function (qp) {
                /** only show 'copy to this quote' button if this quote has modify products permissions */
                return (qp.isConfigured
                    && $scope.permissions.canModifyProducts);
            };
            $scope.showCopyToNewQuoteBtn = function (qp) {
                return qp.isConfigured && !_this.$rootScope.isSfdc; //creating a new quote in this way would break the CRM integration
            };
            $scope.copyProductToThisQuote = function (qp) {
                _this.quoteService.quote = _this.$scope.model; //make this the active quote
                var copyProduct = function () {
                    return quoteService.copyProductToActiveQuote(qp.id).then(function (r) {
                        if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
                            _this.$state.reload();
                        }
                        else {
                            quoteService.goToQuote();
                        }
                    });
                };
                if (!_this.$scope.model.idWorkflow && !_this.modelIsClean()) {
                    return _this.$scope.executeAction(enums.eWorkflowAction.save).then(copyProduct);
                }
                else {
                    return copyProduct();
                }
            };
            $scope.copyProductToActiveQuote = function (qp) {
                return quoteService.copyProductToActiveQuote(qp.id).then(function (r) {
                    if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
                        _this.$state.reload();
                    }
                    else {
                        quoteService.goToQuote();
                    }
                });
            };
            $scope.copyProductToNewQuote = function (qp) {
                return quoteService.copyProductToNewQuote(qp.id).then(function (r) {
                    quoteService.goToQuote();
                });
            };
            // $scope.delete = () => {
            //     return this.delete().then(() => {
            //         // if the quote we're deleting is the active quote, clear it out of the quoteservice
            //         if (quoteService.quote && quoteService.quote.id == $scope.model.id) {
            //             quoteService.quote = undefined;
            //         }
            //     });
            // };
            $scope.extNet = function (product) {
                var discount = product.discountPercentage || 0;
                var volumeDiscount = 0;
                var volumeDiscounts = product.volumeDiscounts.sort(function (vd1, vd2) { return vd1.qty - vd2.qty; });
                for (var key in volumeDiscounts) {
                    var vd = volumeDiscounts[key];
                    if (vd.qty > product.qty)
                        break;
                    volumeDiscount = vd.disc;
                }
                var nonfixed = Big__default["default"](product.price).minus(Big__default["default"](product.fixedPrice)).times(Big__default["default"](product.qty));
                var ext = nonfixed.plus(Big__default["default"](product.fixedPrice));
                var extNet = ext.minus(ext.times(Big__default["default"](discount).div(100))).minus(ext.times(Big__default["default"](volumeDiscount).div(100)));
                return extNet;
            };
            $scope.margin = function (product) {
                return $scope.extNet(product) - $scope.extCost(product);
            };
            $scope.extCost = function (product) {
                var extCost = Big__default["default"](product.cost)
                    .minus(Big__default["default"](product.fixedCost))
                    .times(product.qty)
                    .plus(Big__default["default"](product.fixedCost));
                return extCost;
            };
            var sum = function (mapFn) {
                var products = $scope.model.products;
                var total = products.reduce(function (previousValue, currentValue, index) {
                    var product = products[index];
                    var propValue = mapFn(product);
                    return previousValue.plus(Big__default["default"](propValue));
                }, Big__default["default"](0));
                return total;
            };
            $scope.totalCost = function () {
                return sum(function (product) { return $scope.extCost(product); });
            };
            $scope.totalExtNet = function () {
                return sum(function (product) { return $scope.extNet(product); });
            };
            $scope.total = function () {
                var extNet = $scope.totalExtNet();
                var discount = $scope.model.discountPercentage || 0;
                var shipping = $scope.model.shipping || 0;
                return extNet.minus(extNet.times(Big__default["default"](discount).div(100))).plus(Big__default["default"](shipping));
            };
            $scope.showFixedPrice = function () {
                return $scope.model.products.some(function (p) { return p.fixedPrice != 0; });
            };
            $scope.openGoalPriceDialog = function (product) {
                var value = Math.round(Number(product ? product.price : $scope.total()) * 100) / 100;
                var undiscountedValue = (product ? product.price : $scope.totalExtNet());
                _this.dialogService.input({
                    inputType: enums.eInputDialogType.text,
                    value: value,
                    msg: "Please enter the desired goal price for " + (product ? "each " + product.name : "this quote") + ".",
                    buttons: [
                        new enums.InputDialogButton(loc.ok, _tools.icons.success, function (args) {
                            var discount = Number(Big__default["default"](args.value).div(undiscountedValue));
                            discount = Math.round((1 - discount) * 10000) / 100;
                            if (product) {
                                product.discountPercentage = discount;
                            }
                            else {
                                $scope.model.discountPercentage = discount;
                            }
                        }),
                        new enums.InputDialogButton(loc.cancel, _tools.icons.cancel, function (args) {
                        })
                    ]
                });
            };
            $scope.panes = [
                { title: "General", content: "general", disabled: false },
                { title: "Comments", content: "comments", disabled: false },
                { title: "History", content: "history", disabled: false }
            ];
            $scope.inSteelbrick = function () {
                return (_this.sfdcService.record() && _this.sfdcService.record().attributes.type == "SBQQ__Quote__c");
            };
            $scope.searchProducts = function (query) {
                if (!query) {
                    return Q__namespace.resolve([]);
                }
                return _this.api.products.searchByCategory({
                    query: query,
                    skip: 0,
                    take: 11,
                    filters: [
                        {
                            property: enums.meta.Product.isConfigured.name,
                            values: [false]
                        }
                    ]
                });
            };
            $scope.submitQuickAdd = function (item) {
                if (!item)
                    return;
                _this.$scope.binding.quickAddQuery = "";
                var addProduct = function (isNew) {
                    _this.quoteService.quote = _this.$scope.model;
                    _this.quoteService.addProduct({
                        qty: 1,
                        configuredProduct: null,
                        idProduct: item.id,
                        addLocally: false
                    }).then(function () {
                        if (isNew) {
                            // redirect after adding product to prevent race condition.
                            _this.bypassUnsavedConfirmation = true;
                            _this.$state.go("kb.quoteEdit", { id: _this.$scope.model.id });
                        }
                        else {
                            _this.setUpdatedModelInternal(_this.quoteService.quote, false);
                        }
                    });
                };
                if (_this.$scope.model.name) {
                    var isNew_1 = !_this.$scope.model.id;
                    var promise = _this.$q.when(true);
                    if (isNew_1 || !_this.$scope.model.idWorkflow) {
                        // prevent redirect for new quotes because adding a product and the redirect to the edit page creates a race condition.
                        promise = _this.$scope.executeAction(enums.eWorkflowAction.save, null, 0, isNew_1);
                    }
                    return promise.then(function () { return addProduct(isNew_1); });
                }
            };
            $scope.productSortDisabled = true;
            $scope.productsSorted = function () {
                if (_this.$scope.permissions.canReorderProducts && _this.validate()) {
                    // set product order
                    var order_1 = -1;
                    var orderFunc_1 = function (product) {
                        order_1++;
                        product.order = order_1;
                        // nested products must appear after their parent.
                        var nested = $scope.model.products.filter(function (x) { return x.idParent == product.id; });
                        nested.forEach(function (n) { return orderFunc_1(n); });
                    };
                    $scope.model.products.forEach(function (product) {
                        if (!product.idParent) {
                            orderFunc_1(product);
                        }
                    });
                    $scope.model.products.sortBy(function (x) { return x.order; });
                    //reset the products in view
                    _this.$scope.productsInView = [];
                    _this.$scope.infiniteScroll();
                    if ($scope.model.idWorkflow) { // we are in a workflow so we need to run the action
                        _this.$timeout(function () {
                            return $scope.executeAction(enums.eWorkflowAction.reorderProducts);
                        }, 0);
                    }
                }
            };
            $scope.executeAction = function (actionType, modifiedProduct, idCustomAction, preventRedirect) {
                if (modifiedProduct === void 0) { modifiedProduct = null; }
                if (idCustomAction === void 0) { idCustomAction = 0; }
                if (preventRedirect === void 0) { preventRedirect = false; }
                var data;
                var url = "/api/quotes/" + actionType;
                var method = "POST";
                var getDataDeferred = _this.$q.defer();
                if (!_this.validate() && !_this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow &&
                    actionType != enums.eWorkflowAction.unsubmit &&
                    actionType != enums.eWorkflowAction.reject &&
                    actionType != enums.eWorkflowAction.save &&
                    actionType != enums.eWorkflowAction.deleter) {
                    _this.promptUserToFixErrors();
                    return;
                }
                // save the quote header values before executing the action, if feature flag enabled
                if (_this.$rootScope.companySettings.saveQuoteHeaderValuesBeforeAction
                    && _this.$scope.model.idWorkflow
                    && _this.$scope.permissions.canModifyQuoteHeader
                    && actionType != enums.eWorkflowAction.save
                    && actionType != enums.eWorkflowAction.deleter
                    && actionType != enums.eWorkflowAction.submit
                    && actionType != enums.eWorkflowAction.unsubmit
                    && actionType != enums.eWorkflowAction.modifyQuoteHeader) {
                    // add an extra "modifyQuoteHeader" call to promise chain
                    getDataDeferred.promise = getDataDeferred.promise.then(function () {
                        return _this.$scope.executeAction(enums.eWorkflowAction.modifyQuoteHeader);
                    });
                }
                if (!$scope.model.externalId &&
                    _this.sfdcService.record() &&
                    _this.sfdcService.record().attributes.type == "KBMAX__Quote__c") { // add the externalId to the quote
                    $scope.model.externalId = _this.sfdcService.record().Id;
                }
                $scope.model.headerValues = $scope.defConfig.getConfiguredProduct();
                if (actionType == enums.eWorkflowAction.save) {
                    data = $scope.model;
                    getDataDeferred.resolve();
                }
                else if (actionType == enums.eWorkflowAction.custom) {
                    data = { idQuote: $scope.model.id, idCustomAction: idCustomAction };
                    getDataDeferred.resolve();
                }
                else if (actionType == enums.eWorkflowAction.reject) {
                    // build up a scope to drive the dialog ui
                    var dialogScope_1 = $scope.$new(true);
                    dialogScope_1.model = {
                        reason: loc.other,
                        notes: ""
                    };
                    dialogScope_1.reasons = $scope.model.rejectedReasons;
                    _this.dialogService.dialog({
                        template: Dirs.view("dialog-reject"),
                        scope: dialogScope_1,
                        buttons: [
                            new enums.DialogButton(loc.continuer, _tools.icons.success, function (args) {
                                data = {
                                    quote: $scope.model,
                                    reason: dialogScope_1.model.reason,
                                    notes: dialogScope_1.model.notes
                                };
                                getDataDeferred.resolve();
                            }),
                            new enums.DialogButton(loc.cancel, _tools.icons.cancel, function (args) { })
                        ]
                    });
                }
                else if (actionType == enums.eWorkflowAction.modifyProducts) {
                    url = "/api/quotes/" + _this.$scope.model.id + "/product/" + modifiedProduct.id;
                    method = "PUT";
                    data = modifiedProduct;
                    getDataDeferred.resolve();
                }
                else if (actionType == enums.eWorkflowAction.modifyQuoteProductDescription) {
                    url = "/api/quotes/" + _this.$scope.model.id + "/product/" + modifiedProduct.id + "/description";
                    method = "PUT";
                    data = modifiedProduct;
                    getDataDeferred.resolve();
                }
                else if (actionType == enums.eWorkflowAction.reorderProducts) {
                    url = "/api/quotes/reorderproducts";
                    method = "POST";
                    data = {
                        id: _this.$scope.model.id,
                        products: _this.$scope.model.products.map(function (qp) {
                            return { id: qp.id, order: qp.order };
                        })
                    };
                    getDataDeferred.resolve();
                }
                else {
                    data = $scope.model;
                    getDataDeferred.resolve();
                }
                return getDataDeferred.promise.then(function () {
                    return _this.$http({
                        method: method,
                        url: url,
                        data: data,
                        tracker: _this.$rootScope.contentTracker
                    }).then(function (response) {
                        return _this.handleActionResponse(response.data, actionType, preventRedirect);
                    });
                });
            };
            var getTargetElementId = function ($event) {
                var el = $event.target;
                var elementId = el.id;
                while (!elementId && el) {
                    if (el.tagName == 'svg')
                        break;
                    elementId = el.id;
                    el = el.parentElement;
                }
                return elementId;
            };
            var getHtmlArgs = function (htmlViewer, $event, $originalStartEvent) {
                var c = htmlViewer.$parentConfigurator;
                var args = _this.getRuleArgs(c);
                args.elementId = getTargetElementId($event);
                args.mouseX = $event.offsetX;
                args.mouseY = $event.offsetY;
                return args;
            };
            $scope.runHtmlAction = function (html, $event) {
                var rc = html.ruleContainers.find(function (rc) { return rc.ruleType == enums.eRuleType.html; });
                if (rc) {
                    var args = getHtmlArgs(html, $event);
                    return _this.helper.runRuleContainerAsync(rc, args)
                        .then(function () { return _this.runRuleCycleUnit(html.$parentConfigurator, null); })
                        .then(function () {
                        if (_this.$scope.model.idWorkflow) {
                            return _this.$scope.executeAction(enums.eWorkflowAction.modifyQuoteHeader);
                        }
                    });
                }
            };
            $scope.runFieldAction = function (field) {
                return _this.helper.runRuleContainerAsync(field)
                    .then(function () { return _this.runRuleCycleUnit(field.$parentConfigurator, null); })
                    .then(function () {
                    if (_this.$scope.model.idWorkflow) {
                        return _this.$scope.executeAction(enums.eWorkflowAction.modifyQuoteHeader);
                    }
                });
            };
            $scope.runAction = function (action) {
                return _this.helper.runRuleContainerAsync(action)
                    .then(function () { return _this.runRuleCycleUnit(action.$parentConfigurator, null); });
            };
            $scope.fieldValueChange = function (field) {
                return _this.helper.runRuleContainerAsync(field)
                    .then(function () { return _this.runRuleCycleUnit(field.$parentConfigurator, field); })
                    .then(function () {
                    if (_this.$scope.model.idWorkflow) {
                        return _this.$scope.executeAction(enums.eWorkflowAction.modifyQuoteHeader);
                    }
                });
            };
            $scope.autoCompleteQuery = function (query, field) {
                return _this.helper.autoCompleteQuery(query, field);
            };
            $scope.autoCompleteGetLabel = function (value, field) {
                return _this.helper.autoCompleteGetLabel(value, field);
            };
            $scope.getCurrencyName = function (iso) {
                var cc = $scope.currencies.find(function (c) { return c.currency.isEqual(iso); });
                return cc ? "".concat(cc.name, " (").concat(cc.currency, ")") : iso;
            };
            $scope.validationMessageClicked = function (msg) {
            };
            $scope.translateKbo = function (o, prop) {
                if (o) {
                    if (_this.$rootScope.companySettings.defaultLanguage != _this.$rootScope.clientLanguage) {
                        if (_this.translationDb.hasOwnProperty(o.id) && _this.translationDb[o.id].hasOwnProperty(prop)) {
                            return _this.translationDb[o.id][prop];
                        }
                    }
                    var realProp = prop == "name" ? "$label" : prop;
                    return o[realProp];
                }
                return "";
            };
            $scope.infiniteScroll = function () {
                var pageSize = 30;
                var totalCount = $scope.model.products.length;
                var currCount = $scope.productsInView.length;
                if (totalCount > currCount) {
                    $scope.productsInView.pushArray($scope.model.products.slice(currCount, currCount + pageSize));
                }
            };
            // calculate the product level which is used for margins
            $scope.productLevel = function (productId) {
                var level = 0;
                var product = $scope.model.products.find(function (x) { return x.id == productId; });
                if (product && product.idParent) {
                    level = $scope.productLevel(product.idParent) + 1;
                }
                return level;
            };
            _this.refreshPermissions();
            _this.helper = new ConfiguratorHelper({
                $http: _this.$http,
                $q: _this.$q,
                api: _this.api,
                dialogService: _this.dialogService,
                ruleService: _this.ruleService,
                tracker: _this.$rootScope.contentTracker,
                $rootScope: _this.$rootScope,
                getRuleArgs: function (c, f) { return _this.getRuleArgs(c, f); },
                showErrors: function () { return (_this.$rootScope.environment != enums.eEnvironment.prod); }
            });
            _this.refreshDrawers();
            _this.setupQuoteHeader();
            _this.validate();
            _this.startConfigurator();
            $scope.$on("$destroy", function () {
                _this.stopValidationTimer();
            });
            // currencies
            _this.api.currencies.companyOptions().then(function (r) {
                $scope.currencies = r;
            });
            var updateCustomers = function () {
                _this.api.customers.search({
                    fields: ["id", "name"],
                    sortField: "name"
                }).then(function (r) { return $scope.customers = r; });
            };
            var updateContacts = function () {
                if ($scope.model.idCustomer) {
                    _this.api.contacts.search({
                        filters: [{
                                property: "idCustomer",
                                values: [$scope.model.idCustomer]
                            }]
                    }).then(function (r) { return $scope.contacts = r; });
                }
                else {
                    $scope.contacts.clear();
                }
            };
            if (_this.$rootScope.companySettings.enableCustomersAndContacts && (_this.$scope.permissions.canViewCustomer || _this.$scope.permissions.canModifyCustomer)) {
                updateCustomers();
            }
            $scope.$watch("model.idCustomer", function (newValue, oldValue) {
                updateContacts();
            });
            var updateUsers = function () {
                _this.api.users.search({
                    fields: ["id", "name"],
                    sortField: "name"
                }).then(function (r) { return $scope.users = r; });
            };
            if (_this.$scope.permissions.canViewQuoteOwner || _this.$scope.permissions.canAssignQuote) {
                updateUsers();
            }
            _this.$scope.infiniteScroll(); //fill in first set of products
            _this.startValidationTimer();
            if (_this.$scope.isNew && _this.$rootScope.isSfdc && !_this.$rootScope.isSfdcCpq) {
                var canvasParams = _this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters;
                if (canvasParams.autoSubmit != null && (canvasParams.autoSubmit == true || canvasParams.autoSubmit.isEqual("true"))) {
                    _this.submit();
                }
                else {
                    _this.$scope.executeAction(enums.eWorkflowAction.save);
                }
            }
            return _this;
        }
        QuoteController.prototype.client = function (api) {
            return api.quotes;
        };
        QuoteController.prototype.onSuccess = function () {
            this.$state.go("kb.quoteEdit", { id: this.$scope.model.id });
            this.drawerService.pageTitle = this.$scope.model.name;
            // this.registerWebSocket();
        };
        QuoteController.prototype.onDelete = function () {
            // if the quote we're deleting is the active quote, clear it out of the quoteservice
            if (this.quoteService.quote && this.quoteService.quote.id == this.$scope.model.id) {
                this.quoteService.quote = undefined;
            }
            this.$state.go("kb.quotes");
        };
        QuoteController.prototype.webSocketEntityType = function () {
            return "Quote";
        };
        QuoteController.prototype.subscribe = function () {
            var _this = this;
            _super.prototype.subscribe.call(this);
            this.signalrService.on("productImageChange", this.productImageChange = function (args) {
                if (args.idQuote == _this.$scope.model.id) {
                    _this.$timeout(function () {
                        var product = _this.$scope.model.products.find(function (p) { return p.id == args.idQuoteProduct; });
                        if (product)
                            product.imagePath = args.imagePath;
                    }, 0);
                }
            });
        };
        QuoteController.prototype.unsubscribe = function () {
            _super.prototype.unsubscribe.call(this);
            this.signalrService.off("productImageChange", this.productImageChange);
        };
        QuoteController.prototype.setUpdatedModel = function (model) {
            this.setUpdatedModelInternal(model);
        };
        QuoteController.prototype.setUpdatedModelInternal = function (model, refreshComments) {
            if (refreshComments === void 0) { refreshComments = true; }
            this.$scope.model = model;
            this.crudService.$rootScope.setTitle(this.$scope.model ? this.$scope.model.name : loc.newquote);
            this.refreshDrawers();
            // refresh the comments as sometimes they are added server-side (like for rejection reasons)
            if (refreshComments)
                this.$scope.commentListApi.refresh();
            this.refreshPermissions();
            this.$scope.productsInView = [];
            this.$scope.infiniteScroll();
        };
        QuoteController.prototype.setupQuoteHeader = function () {
            var _this = this;
            var configurator = new enums.Configurator(new enums.KbObjectManager(), this.header.configurator);
            configurator.$running = true;
            if (this.$scope.isEdit && this.$scope.model.headerValues) {
                configurator.runConfiguredProduct(this.$scope.model.headerValues, null);
            }
            this.$scope.defConfig = configurator;
            this.setupQuoteHeaderPages(this.$scope.defConfig, true);
            // setup translationDb
            var trans = this.header.translations.first();
            if (trans) {
                Object.keys(trans.data.objects).forEach(function (key) {
                    _this.translationDb[key] = trans.data.objects[key];
                });
            }
        };
        QuoteController.prototype.setupQuoteHeaderPages = function (config, isInitialization) {
            var pages = config.pages.filter(function (p) { return true; }); // filter prevents modifying original array
            if (!this.$scope.defConfig.hideQuoteHeaderBasicTab) {
                var basicIndex = this.$scope.defConfig.quoteHeaderBasicTabIndex;
                if (basicIndex < 0) {
                    basicIndex = 0;
                }
                pages.splice(basicIndex, 0, { id: "tab_basic", visible: true, children: [], $valid: true });
            }
            this.$scope.visiblePages = pages.filter(function (p) { return p.visible; });
            if (isInitialization) {
                var page = this.$scope.visiblePages.first();
                if (page && this.$scope.permissions.canViewQuoteHeader) {
                    this.$scope.selectedTab = page.id;
                }
                else {
                    this.$scope.selectedTab = "tab_basic";
                }
            }
        };
        QuoteController.prototype.refreshDrawers = function () {
            var _this = this;
            // TODO: This doesn't work for some reason.
            // if (this.$state.current.controller != kb.quoteController) return;
            this.drawerService.drawers.clear();
            this.$scope.availableProductBuildTypes = [];
            if (this.$scope.model.idWorkflow > 0) {
                var actions = this.$scope.model.allowedActions;
                var hasBuildProductAction_1 = false;
                if (actions) {
                    angular__namespace.forEach(actions, function (action) {
                        if (action.type == enums.eWorkflowAction.modifyCustomer ||
                            action.type == enums.eWorkflowAction.modifyDiscount ||
                            action.type == enums.eWorkflowAction.modifyName ||
                            action.type == enums.eWorkflowAction.addAttachments ||
                            action.type == enums.eWorkflowAction.modifyAttachments ||
                            action.type == enums.eWorkflowAction.completeBuild ||
                            action.type == enums.eWorkflowAction.failBuild ||
                            action.type == enums.eWorkflowAction.modifyQuoteHeader ||
                            action.type == enums.eWorkflowAction.modifyCurrency ||
                            action.type == enums.eWorkflowAction.reorderProducts ||
                            action.type == enums.eWorkflowAction.modifyQuoteProductDescription ||
                            action.type == enums.eWorkflowAction.modifyShipping ||
                            action.type == enums.eWorkflowAction.assignQuote) ;
                        else if (action.type == enums.eWorkflowAction.modifyProducts) {
                            // unshift so addProducts is always at the left
                            _this.drawerService.drawers.unshift({
                                icon: _tools.icons.products,
                                label: loc.addproduct,
                                visible: true,
                                command: function () {
                                    // set the active quote
                                    _this.quoteService.quote = _this.$scope.model;
                                    _this.$state.go("kb.products");
                                }
                            });
                        }
                        else if (action.type == enums.eWorkflowAction.buildQuoteProduct) {
                            _this.$scope.availableProductBuildTypes.push(action.buildType);
                            hasBuildProductAction_1 = true;
                        }
                        else if (action.type == enums.eWorkflowAction.deleter) {
                            _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, _this.$scope.delete);
                        }
                        else {
                            var icon = action.type == enums.eWorkflowAction.custom ? action.icon : _tools.icons[action.type];
                            var actionName = action.type == enums.eWorkflowAction.custom ?
                                action.name
                                : loc[action.type] || action.type;
                            _this.drawerService.addDrawer(icon, actionName, function () {
                                _this.$scope.executeAction(action.type, null, action.idCustomAction);
                            });
                        }
                    });
                    if (hasBuildProductAction_1) {
                        this.api.quotes.getProductBuildTypes(this.$scope.model.id).then(function (result) {
                            result.value.forEach(function (pbt) {
                                _this.$scope.productBuildTypes[pbt.idProduct] = pbt.idBuildTypes;
                            });
                        });
                    }
                    if (actions.find(function (x) { return x.type == enums.eWorkflowAction.unsubmit; })) {
                        this.dialogService.dialog({
                            content: loc.msg_quotebuildstuck,
                            buttons: [
                                new enums.DialogButton(loc.unsubmit, _tools.icons.unsubmit, function () { _this.$scope.executeAction(enums.eWorkflowAction.unsubmit); }),
                                new enums.DialogButton(loc.cancel, _tools.icons.cancel, function () { })
                            ]
                        });
                    }
                }
                if (this.$rootScope.companySettings.useUnsubmittedWorkflowState && this.$scope.permissions.canSubmitQuote) {
                    var drSubmit_1 = this.drawerService.addDrawer(_tools.icons.play, loc.submit, function () {
                        drSubmit_1.disabled = true;
                        _this.submit();
                    });
                }
            }
            else {
                if (this.$scope.isEdit) {
                    this.drawerService.addDrawer(_tools.icons.products, loc.addproduct, this.$scope.addProduct);
                    if (!this.$rootScope.isSfdc) {
                        this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, this.$scope.delete);
                    }
                }
                this.drawerService.addDrawer(_tools.icons.save, loc.save, function () {
                    _this.validate();
                    if (_this.$scope.model.name) {
                        _this.$scope.executeAction(enums.eWorkflowAction.save).then(function () {
                            if (_this.$state.current.data.viewType == enums.eViewType.new &&
                                _this.$rootScope.user.id == AuthService.ANONYMOUS_USER_ID) {
                                // Anonymous users need to immediately activate this newly saved quote, 
                                // since otherwise they'll not have access to it ever again.
                                _this.quoteService.quote = _this.$scope.model;
                            }
                        });
                    }
                });
                var drSubmit_2 = this.drawerService.addDrawer(_tools.icons.play, loc.submit, function () {
                    drSubmit_2.disabled = true;
                    _this.submit();
                });
            }
            var last = this.drawerService.drawers.last();
            if (last)
                last.endGroup = true;
            if (this.$rootScope.isSfdc && !this.$rootScope.isSfdcCpq && this.$scope.model.externalId) {
                var drPrimary = void 0;
                if (this.$scope.isEdit &&
                    this.sfdcService.record().KBMAX__Opportunity__c &&
                    !this.sfdcService.record().KBMAX__Primary__c) {
                    drPrimary = this.drawerService.addDrawer(_tools.icons.approve, "Make Primary", function () {
                        var p = _this.sfdcService.makePrimaryQuote(_this.$scope.model);
                        _this.dialogService.alert({
                            promise: p,
                            msg: "Setting " + _this.$scope.model.name + " as primary quote",
                            successMsg: _this.$scope.model.name +
                                " has successfully been made the primary quote of the opportunity"
                        });
                        _this.refreshDrawers();
                    });
                    drPrimary.startGroup = true;
                }
                // add an sfdc 'out' button to take us back to the sfdc quote (or opportunity) 
                var drDone = this.drawerService.addDrawer(_tools.icons.success, loc.done, function () {
                    /*if sfdc passed in a "navigateTo" id parameter, then we go there on done
                      if not, then we go to the sfdc quote object.  You can use this for example
                      to go back to the opportunity instead of the quote */
                    var canvasParams = _this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters;
                    if (canvasParams.navigateTo != null) {
                        _this.sfdcService.navigateToObject(canvasParams.navigateTo);
                    }
                    else {
                        _this.sfdcService.navigateToObject(_this.$scope.model.externalId);
                    }
                });
                if (!drPrimary)
                    drDone.startGroup = true;
            }
            else if (this.$rootScope.isSfdc && this.$scope.inSteelbrick()) {
                // add an sfdc 'out' button to take us back to the sfdc quote (or opportunity) 
                var drDone = this.drawerService.addDrawer(_tools.icons.success, loc.done, function () {
                    _this.sfdcService.sendMessage({ name: "goToSteelbrickQuote", data: _this.sfdcService.record().Id });
                });
            }
        };
        QuoteController.prototype.canUserPerformAction = function (actionType) {
            return this.$scope.model.allowedActions.some(function (a) { return a.type == actionType; });
        };
        QuoteController.prototype.refreshPermissions = function () {
            if (this.$scope.model.idWorkflow) {
                this.$scope.permissions = {
                    canModifyName: this.canUserPerformAction(enums.eWorkflowAction.modifyName),
                    canModifyCustomer: this.canUserPerformAction(enums.eWorkflowAction.modifyCustomer),
                    canModifyDiscount: this.canUserPerformAction(enums.eWorkflowAction.modifyDiscount),
                    canModifyProducts: this.canUserPerformAction(enums.eWorkflowAction.modifyProducts),
                    canAddAttachments: this.canUserPerformAction(enums.eWorkflowAction.addAttachments),
                    canModifyQuoteHeader: this.canUserPerformAction(enums.eWorkflowAction.modifyQuoteHeader),
                    canModifyAttachments: this.canUserPerformAction(enums.eWorkflowAction.modifyAttachments),
                    canModifyCurrency: this.canUserPerformAction(enums.eWorkflowAction.modifyCurrency),
                    canModifyShipping: this.canUserPerformAction(enums.eWorkflowAction.modifyShipping),
                    canReorderProducts: this.canUserPerformAction(enums.eWorkflowAction.reorderProducts),
                    canViewQuoteHeader: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewQuoteHeader;
                    }),
                    canViewDiscount: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewDiscount;
                    }),
                    canViewCost: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewCost;
                    }),
                    canViewPricing: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewPricing;
                    }),
                    canViewCustomer: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewCustomer;
                    }),
                    canViewCurrency: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewCurrency;
                    }),
                    canViewShipping: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewShipping;
                    }),
                    canModifyQuoteProductDescription: this.canUserPerformAction(enums.eWorkflowAction.modifyQuoteProductDescription),
                    canViewQuoteProductDetails: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewQuoteProductDetails;
                    }),
                    canSubmitQuote: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.submitQuote;
                    }),
                    canViewQuoteOwner: this.$scope.model.userViewPermissions.some(function (a) {
                        return a.permission == enums.eViewPermission.viewQuoteOwner;
                    }),
                    canAssignQuote: this.canUserPerformAction(enums.eWorkflowAction.assignQuote),
                };
            }
            else {
                this.$scope.permissions = {
                    canModifyName: true,
                    canModifyProducts: true,
                    canModifyCustomer: this.$rootScope.user.canSetQuoteCustomer,
                    canModifyDiscount: this.$rootScope.user.canSetQuoteDiscount,
                    canAddAttachments: this.$rootScope.user.canAddAttachments,
                    canModifyAttachments: this.$rootScope.user.canModifyAllAttachments,
                    canModifyShipping: this.$rootScope.user.canSetQuoteShipping,
                    canModifyQuoteHeader: true,
                    canModifyCurrency: this.$rootScope.user.canSetQuoteCurrency,
                    canReorderProducts: true,
                    canViewQuoteHeader: this.$rootScope.user.canViewQuoteHeader,
                    canViewDiscount: this.$rootScope.user.canViewQuoteDiscount,
                    canViewCost: this.$rootScope.user.canViewCost,
                    canViewPricing: this.$rootScope.user.canViewPrices,
                    canViewCustomer: this.$rootScope.user.canViewQuoteCustomer || this.$rootScope.user.canSetQuoteCustomer,
                    canViewCurrency: this.$rootScope.user.canViewQuoteCurrency,
                    canViewShipping: this.$rootScope.user.canViewQuoteShipping,
                    canModifyQuoteProductDescription: this.$rootScope.user.canSetQuoteProductDescription,
                    canViewQuoteProductDetails: true,
                    canSubmitQuote: true,
                    canViewQuoteOwner: this.$rootScope.user.canViewQuoteOwner || this.$rootScope.user.canSetQuoteOwner,
                    canAssignQuote: this.$rootScope.user.canSetQuoteOwner,
                };
            }
            this.$scope.productSortDisabled = !this.$scope.permissions.canReorderProducts;
        };
        QuoteController.prototype.validate = function () {
            var _this = this;
            var model = this.$scope.model;
            this.$scope.validationMessages = [];
            this.$scope.v.validation = {
                products: {}
            };
            var validation = this.$scope.v.validation;
            var result = true;
            if (!model.name) {
                this.$scope.validationMessages.push({
                    messageType: enums.eValidationType.error,
                    message: "Quote is missing a name",
                    propertyName: "name",
                    object: {
                        name: "Quote"
                    }
                });
                validation.name = "Please enter a name";
                result = false;
            }
            var productError = function (index, field, msg, includeInValidationMessages) {
                if (includeInValidationMessages === void 0) { includeInValidationMessages = true; }
                if (!validation.products[index])
                    validation.products[index] = {};
                validation.products[index][field] = msg;
                if (includeInValidationMessages) {
                    _this.$scope.validationMessages.push({
                        messageType: enums.eValidationType.error,
                        message: msg,
                        propertyName: "Product " + model.products[index].name,
                        object: {
                            id: model.products[index].id.toString(),
                            name: "Product " + model.products[index].name
                        }
                    });
                }
                result = false;
            };
            var getErrors = function (configProd, name) {
                if (configProd.validationMessages) {
                    configProd.validationMessages.forEach(function (err) { return _this.$scope.validationMessages.push(err); });
                }
                if (configProd.configurators) {
                    configProd.configurators.forEach(function (c) { return getErrors(c); });
                }
            };
            model.headerValues = this.$scope.defConfig.getConfiguredProduct();
            getErrors(model.headerValues);
            model.products.forEach(function (product, i) {
                if (product.isConfigured && product.configuredProduct.hasErrors) {
                    productError(i, "name", "Please correct the configurator errors.", false);
                    getErrors(product.configuredProduct, "Product " + product.name);
                }
                if (!product.allowFractionalQty && product.qty % 1 != 0) {
                    productError(i, "qty", "Must be whole number");
                }
                var maxDiscount = Math.min(product.maxDiscountPercentage, 100);
                if (product.discountPercentage > maxDiscount) {
                    productError(i, "discountPercentage", "Must be less than " + maxDiscount + "%");
                }
                if (product.maxQty && product.qty > product.maxQty) {
                    productError(i, "qty", "Limited to " + product.maxQty);
                }
                if ((product.minQty && product.qty < product.minQty) || product.qty < 1) {
                    productError(i, "qty", "Must be at least " + Math.max(product.minQty, 1));
                }
            });
            return result &&
                (!model.headerValues ||
                    !model.headerValues.validationMessages ||
                    !model.headerValues.validationMessages.some(function (m) { return m.messageType == enums.eValidationType.error; }));
        };
        QuoteController.prototype.submit = function () {
            var _this = this;
            /*if (this.$rootScope.user.id == authService.ANONYMOUS_USER_ID) {
                this.dialogService.alert({
                    type: eAlertType.info,
                    msg: "Before you can submit this quote, please login or register."
                });
                    
                this.$rootScope.user = null;
                this.$rootScope.$broadcast(kb.events.loginRequested);
                this.submitQuotePending = true;
                return;
            }*/
            this.$scope.model.headerValues = this.$scope.defConfig.getConfiguredProduct();
            if (this.validate() ||
                this.$rootScope.context.companySettings.allowInvalidQuotesInWorkflow) {
                this.$scope.executeAction(enums.eWorkflowAction.submit).then(function () {
                    _this.$location.url("/quotes/" + _this.$scope.model.id);
                    _this.bypassUnsavedConfirmation = true;
                });
            }
            else
                this.promptUserToFixErrors();
        };
        QuoteController.prototype.runRuleCycleUnit = function (config, field, isInitialization) {
            var _this = this;
            if (isInitialization === void 0) { isInitialization = false; }
            // Skip the entire cycle if user can't view the quote header, since doing so is wasteful.
            if (!this.$scope.permissions.canViewQuoteHeader)
                return this.$q.all([]);
            var ruleArgs = this.getRuleArgs(config, field);
            var runRules = this.helper.runSelects(config)
                // value rules
                .then(function () {
                return _this.helper.runRuleTypeAsync(config, enums.eRuleType.value, ruleArgs);
            }).then(function () {
                // reset $fieldsDirty of this configurator so it doesn't affect 
                // a parent's decision on whether to run the child's rules
                return config.$fieldsDirty = false;
            }).then(function () {
                return _this.runValidationRule(config, ruleArgs);
            }).then(function () {
                return _this.helper.runRuleTypeAsync(config, enums.eRuleType.visibility, ruleArgs);
            }).then(function () {
                _this.setupQuoteHeaderPages(config, isInitialization);
                if (!_this.$scope.model.idWorkflow &&
                    _this.$scope.defConfig.hasQuoteRule) {
                    // run the quote rule if we are not in a workflow 
                    // (in a workflow it get's run the by the action on the server)
                    _this.$scope.model.headerValues = _this.$scope.defConfig.getConfiguredProduct();
                    return _this.api.quotes.runQuoteHeaderRule(_this.$scope.model, _this.$rootScope.contentTracker).then(function (q) {
                        _this.setUpdatedModelInternal(q, false);
                    });
                }
            });
            return runRules;
        };
        QuoteController.prototype.getRuleArgs = function (config, changedField) {
            var ruleArgs = new QuoteHeaderRuleArgs(this);
            ruleArgs.user = this.$rootScope.user;
            ruleArgs.environment = this.$rootScope.environment;
            ruleArgs.baseUrl = this.$rootScope.context.baseUrl;
            ruleArgs.configurator = config;
            ruleArgs.kom = config.$manager;
            ruleArgs.parentKom = config.$parentConfigurator ? config.$parentConfigurator.$manager : null;
            ruleArgs.changedField = changedField;
            ruleArgs.quote = this.$scope.model;
            ruleArgs.logs = new _rules.ClientLogger();
            ruleArgs.clientLanguage = this.$rootScope.clientLanguage;
            if (this.$rootScope.context.sfdcCanvasRequest) {
                // combine query string parameters with sfdc parameters
                ruleArgs.parameters = _tools.Utils.extend(this.$rootScope.context.sfdcCanvasRequest.context.environment.parameters, this.$location.search());
            }
            else {
                ruleArgs.parameters = this.$location.search();
            }
            return ruleArgs;
        };
        /**
         * starts a configurator by loading any tables it references and running the rules once
         * @param config
         */
        QuoteController.prototype.startConfigurator = function () {
            var _this = this;
            var tableIds = this.header.references.filter(function (r) { return r.type.isEqual("Table"); }).map(function (r) { return r.id; });
            return this.helper.downloadTables(tableIds)
                .then(function () { return _this.runRuleCycleUnit(_this.$scope.defConfig, null, true); });
        };
        QuoteController.prototype.startValidationTimer = function () {
            var _this = this;
            if (!this._stopValidationTimer) {
                this._stopValidationTimer = this.$interval(function () {
                    _this.validate();
                }, 1000);
            }
        };
        QuoteController.prototype.stopValidationTimer = function () {
            this.$interval.cancel(this._stopValidationTimer);
            this._stopValidationTimer = null;
        };
        QuoteController.prototype.handleActionResponse = function (result, actionType, preventRedirect) {
            if (preventRedirect === void 0) { preventRedirect = false; }
            this.setUpdatedModelInternal(result, false);
            if (actionType == enums.eWorkflowAction.submit
                && !this.$rootScope.isSfdc
                && !result.allowedActions.some(function (a) { return a.type == enums.eWorkflowAction.modifyProducts; }) //only clear the active quote if the user no longer has modify product permissions
            ) {
                this.quoteService.quote = null;
            }
            else {
                // if this is the active quote, then refresh the active quote data to keep it in sync
                if (this.quoteService.quote && result && this.quoteService.quote.id === result.id) {
                    this.quoteService.quote = result;
                }
            }
            if (this.$scope.isNew) { // change to edit edit screen if we were on the new screen before
                this.quoteService.quote = result;
                if (!preventRedirect) {
                    this.$state.go("kb.quoteEdit", { id: this.$scope.model.id });
                }
            }
            else {
                this.refreshDrawers();
            }
            // refresh the comments as sometimes they are added server-side (like for rejection reasons)
            this.$scope.commentListApi.refresh();
            this.refreshPermissions();
            this.validate();
            this.markChangesClean();
        };
        QuoteController.prototype.revertToClean = function () {
            this.setUpdatedModelInternal(angular__namespace.copy(this.cleanModel), false);
        };
        QuoteController.prototype.promptUserToFixErrors = function () {
            this.dialogService.alert({ type: enums.eAlertType.error, template: Dirs.view("alert-quote-errors") });
        };
        QuoteController.prototype.runValidationRule = function (config, ruleArgs) {
            config.preValidate(); // call internal validation for fields
            return this.helper.runRuleTypeAsync(config, enums.eRuleType.validation, ruleArgs).then(function () {
                config.isValid(); //force recalculation of $valid property
            });
        };
        QuoteController = __decorate([
            NgView({
                token: Token.QuoteView,
                inherit: [Token.CrudView],
                dependencies: [
                    Token.Header,
                    Token.QuoteService,
                    Token.SfdcService,
                    Token.RuleService,
                    Token.$Filter,
                    Token.$Timeout,
                    Token.$Interval,
                    Token.$Location,
                    Token.UploadService,
                    Token.KbService,
                    Token.StorageService,
                    Token.ProductResolve
                ],
                resolves: [
                    {
                        name: "model",
                        dependencies: [
                            Token.$StateParams,
                            Token.AuthService,
                            Token.QuoteService
                        ],
                        fn: function ($stateParams, authService, quoteService) {
                            return authService.authPromise.then(function () {
                                if ($stateParams.id) {
                                    return quoteService.getQuoteById($stateParams.id);
                                }
                                else {
                                    return quoteService.getNewQuote();
                                }
                            });
                        }
                    },
                    {
                        name: "header",
                        dependencies: [
                            Token.AuthService,
                            Token.ApiService
                        ],
                        fn: function (authService, api) {
                            return authService.authPromise.then(function () {
                                return api.quoteHeaders.getDefault();
                            });
                        }
                    },
                    {
                        name: "productResolve",
                        dependencies: [
                            Token.AuthService,
                            Token.ApiService
                        ],
                        fn: function (authService, api) {
                            return authService.authPromise.then(function () {
                                return api.products.searchByCategory({
                                    query: "",
                                    skip: 0,
                                    take: 1,
                                    filters: [
                                        {
                                            property: enums.meta.Product.isConfigured.name,
                                            values: [false]
                                        }
                                    ]
                                });
                            });
                        }
                    }
                ]
            })
        ], QuoteController);
        return QuoteController;
    }(CrudController));

    var QuotesController = /** @class */ (function (_super) {
        __extends(QuotesController, _super);
        function QuotesController($scope, agg, $rootScope, upload, quoteService, storageService) {
            var _this = _super.call(this, $scope, agg) || this;
            _this.upload = upload;
            _this.quoteService = quoteService;
            _this.storageService = storageService;
            agg.$rootScope.setTitle(loc.quotes);
            agg.drawerService.setHelpUrl('Quotes');
            agg.drawerService.pageType = loc.quotes;
            agg.drawerService.pageIcon = _tools.icons.quote;
            $scope.savedSearchEnabled = true;
            _this.refreshSavedSearches();
            if (_this.agg.$rootScope.company.useDatabaseSearch) {
                $scope.availableFilters.pushArray([_this.getWhereFieldFilter()]);
            }
            $scope.binding.search.modelType = enums.meta.Quote.$name;
            $scope.modelTypes = [
                { type: enums.meta.Quote.$name, label: 'Quotes', state: 'kb.quotes' },
                { type: enums.meta.QuoteProduct.$name, label: 'Configured Products', state: 'kb.configuredProducts' },
            ];
            $scope.downloadAttachment = function (file) {
                if (file.source == enums.eFileSource.media) {
                    window.open(storageService.getMediaUrl(file.filePath));
                }
                else {
                    window.open('api/quotes/file/download/' + file.id, '_blank');
                }
            };
            $scope.openProduct = function (idQuote, p) {
                if (p.isConfigured) {
                    agg.$state.go('kb.configuredProduct', { id: p.id });
                }
                else {
                    agg.$state.go('kb.product', { id: p.idProduct });
                }
            };
            $scope.getFirstProductImage = function (quote) {
                var p = quote.products.find(function (p) { return p.imagePath != null; });
                return p ? p.imagePath : null;
            };
            $scope.fieldChange = function (filter) {
                var field = _this.$scope.filterSource[filter['$key']].find(function (f) { return f.name == filter.fieldName; });
                var fieldType = field ? field.type : enums.eFieldType.text;
                filter.fieldType = fieldType;
                if (fieldType == enums.eFieldType.number) {
                    filter.control = enums.eFilterControl.numberRange;
                }
                else if (fieldType == enums.eFieldType.boolean) {
                    filter.control = enums.eFilterControl.checkbox;
                }
                else {
                    filter.control = enums.eFilterControl.text;
                }
            };
            agg.drawerService.addDrawer(_tools.icons.add, loc.add, function () { return agg.$state.go('kb.quoteNew'); });
            if ($rootScope.companySettings.enableQuoteImport) {
                agg.drawerService.addDrawer(_tools.icons.upload, 'Import', function () { return _this.import(); });
            }
            agg.drawerService.addDrawer(_tools.icons.clone, loc.clone, function () { return _this.clone(); });
            agg.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, function () { return _this.deleteItems(); });
            return _this;
        }
        QuotesController.prototype.import = function () {
            var _this = this;
            this.upload.promptUserToChooseFile().then(function (file) {
                var formData = new FormData();
                formData.append('file', file);
                _this.upload.uploadFile(formData, '/api/quotes/import').then(function (r) {
                    _this.agg.$state.go('kb.quoteEdit', { id: r.id });
                });
            });
        };
        QuotesController.prototype.client = function (api) {
            return api.quotes;
        };
        QuotesController.prototype.newSearch = function () {
            return {
                modelType: enums.meta.Quote.$name,
                sortField: enums.meta.Quote.modifiedDate.name, // "modifiedDate",
                descending: true,
                filters: this.getFiltersFromMeta(enums.meta.Quote.$name, true),
                roles: [],
            };
        };
        QuotesController.prototype.onItemsDeleted = function (items) {
            //empty out the active quote if we just deleted it
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var q = items_1[_i];
                if (q && this.quoteService.quote && q.id == this.quoteService.quote.id) {
                    this.quoteService.quote = null;
                }
            }
        };
        QuotesController.prototype.getWhereFieldFilter = function () {
            return {
                type: enums.eFilterType.headerValue,
                label: 'Where Header Field',
                fieldName: null,
                control: enums.eFilterControl.none,
                sourceType: enums.eFilterSource.headerFields,
                values: [null],
            };
        };
        QuotesController = __decorate([
            NgView({
                token: Token.QuotesView,
                inherit: [Token.SearchView],
                dependencies: [Token.$RootScope, Token.UploadService, Token.QuoteService, Token.StorageService],
            })
        ], QuotesController);
        return QuotesController;
    }(SearchController));

    var ChangePasswordController = /** @class */ (function (_super) {
        __extends(ChangePasswordController, _super);
        function ChangePasswordController($scope, crudService) {
            var _this = _super.call(this, $scope, crudService, { id: crudService.$stateParams.id }) || this;
            crudService.$rootScope.setTitle(loc.changepassword);
            $scope.model = { id: _this.$stateParams.id };
            _this.drawerService.setHelpUrl(null);
            // add drawers
            _this.drawerService.addDrawer(_tools.icons.save, loc.save, $scope.save);
            _this.drawerService.addDrawer(_tools.icons.cancel, loc.cancel, $scope.cancel);
            return _this;
        }
        ChangePasswordController.prototype.client = function (api) {
            return api.changePassword;
        };
        ChangePasswordController.prototype.onSuccess = function () {
            this.$state.go("kb.admin.userEdit", { id: this.$stateParams.id });
        };
        ChangePasswordController = __decorate([
            NgView({
                token: Token.ChangePasswordView,
                inherit: [Token.CrudView],
                dependencies: [
                    Token.$Scope,
                    Token.CrudService
                ]
            })
        ], ChangePasswordController);
        return ChangePasswordController;
    }(CrudController));

    exports.eUserActivationMode = void 0;
    (function (eUserActivationMode) {
        eUserActivationMode["password"] = "password";
        eUserActivationMode["thanks"] = "thanks";
        eUserActivationMode["invalid"] = "invalid";
    })(exports.eUserActivationMode || (exports.eUserActivationMode = {}));
    var UserActivationController = /** @class */ (function () {
        function UserActivationController($scope, $rootScope, drawerService, $http, $stateParams, $state) {
            this.$scope = $scope;
            drawerService.setHelpUrl(null);
            $rootScope.user = {
                id: $stateParams.idUser
            };
            $scope.model = {};
            $rootScope.setTitle(loc.user_activation);
            $http.post("api/users/activate?idUser=" + $stateParams.idUser +
                "&activationGuid=" + $stateParams.activationGuid, {
                password: "",
            }, { tracker: $rootScope.contentTracker }).then(function (r) {
                $scope.userActivationGuid = r.data.activationGuid;
                $scope.isNew = r.data.isNew;
                if (r.data.requiresPassword) {
                    $scope.mode = exports.eUserActivationMode.password;
                }
                else {
                    $scope.mode = exports.eUserActivationMode.thanks;
                }
            }, function (r) {
                $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
                $scope.mode = exports.eUserActivationMode.invalid;
            });
            $scope.save = function () {
                $scope.validation = {};
                if ($scope.model.password != $scope.model.confirmPassword) {
                    $scope.validation.confirmPassword = "Passwords do not match.";
                }
                if ($scope.isNew && !$scope.model.agreedToPrivacyPolicy) {
                    $scope.validation.agreedToPrivacyPolicy = "Must agree to the privacy policy";
                }
                if ($scope.validation.confirmPassword || $scope.validation.agreedToPrivacyPolicy)
                    return;
                return $http.post("api/users/activate?idUser=" + $stateParams.idUser +
                    "&activationGuid=" + $scope.userActivationGuid, {
                    password: $scope.model.password,
                    agreed: $scope.model.agreedToPrivacyPolicy
                }, { tracker: $rootScope.contentTracker }).then(function () {
                    $scope.mode = exports.eUserActivationMode.thanks;
                }, function (r) {
                    $scope.validation = CrudController.prototype.getValidationObject(r.data, r.status);
                });
            };
            $scope.goToLogin = function () {
                window.location.href = "/";
            };
        }
        UserActivationController = __decorate([
            NgView({
                token: Token.UserActivationView,
                dependencies: [
                    Token.$Scope,
                    Token.$RootScope,
                    Token.DrawerService,
                    Token.$Http,
                    Token.$StateParams,
                    Token.$State
                ]
            })
        ], UserActivationController);
        return UserActivationController;
    }());

    var UserController = /** @class */ (function (_super) {
        __extends(UserController, _super);
        function UserController($scope, crudService, model, $rootScope, kbService) {
            var _this = _super.call(this, $scope, crudService, model) || this;
            _this.$scope = $scope;
            _this.$rootScope = $rootScope;
            $scope.isReadOnlySso = !$rootScope.context.ssoManualUserManagement && model.isSsoUser;
            _this.drawerService.setHelpUrl("Users");
            _this.$http.get("/api/notificationsettings").then(function (response) {
                $scope.notificationSetting = response.data;
            });
            if ($rootScope.user.isCompanyAdmin) {
                _this.api.channels.search({
                    sortField: "name"
                }).then(function (channels) {
                    $scope.channels = channels.map(function (c) {
                        return {
                            name: c.name,
                            value: c.id.toString()
                        };
                    });
                    $scope.channels.unshift({
                        name: "-None-",
                        value: null
                    });
                });
            }
            if ($scope.model) {
                crudService.$rootScope.setTitle($scope.model.firstName + " " + $scope.model.lastName);
            }
            if (_this.$state.current.data.viewType == enums.eViewType.new) {
                crudService.$rootScope.setTitle(loc.create + " " + loc.user);
                // create a new blank user
                $scope.model = {
                    isApproved: true,
                    licenseType: enums.eUserLicenseType.internal,
                    shipToBillingAddress: true,
                    roles: []
                };
            }
            _this.api.roles.search({
                sortField: "role",
            }).then(function (r) {
                $scope.roles = r.filter(function (ur) { return ur.id != -1; });
            });
            $scope.resetDeactivation = function () {
                _this.api.users.resetDeactivation(_this.$stateParams.id).then(function () {
                    _this.dialogService.alert({
                        type: enums.eAlertType.success,
                        msg: loc.msg_resetdeactivationcomplete
                    });
                });
            };
            $scope.resetPassword = function () {
                _this.api.users.resetPassword(_this.$stateParams.id).then(function () {
                    _this.dialogService.alert({
                        type: enums.eAlertType.success,
                        msg: loc.msg_passwordreset.format($scope.model.email)
                    });
                });
            };
            $scope.deleteAndAnonymize = function () {
                _this.dialogService.confirm("Are you sure you want to delete and permanently anonymize this user? This cannot be undone!", function () {
                    _this.api.users.deleteAndAnonymize(_this.$stateParams.id).then(function () {
                        _this.$state.go("kb.admin.users");
                    });
                });
            };
            _this.deleteMsg = loc.msg_deleteuser.format(_this.$scope.model.firstName + " " + _this.$scope.model.lastName);
            $scope.canEdit = false;
            $scope.canResetPassword = false;
            $scope.canChangePassword = false;
            // determine whether to show edit buttons
            if (_this.$rootScope.user.id == _this.$stateParams.id) {
                // if (this.$rootScope.user.canModifySelf) {
                _this.$scope.canEdit = true;
                _this.$scope.canChangePassword = true;
                // }
            }
            else {
                if (_this.$rootScope.user.canModifyUsers) {
                    _this.$scope.canEdit = true;
                    _this.$scope.canResetPassword = true;
                }
            }
            $scope.notificationOptions = kbService.getEnumSelects(enums.eNotificationSetting, "eNotificationSetting");
            $scope.pendingApprovalNotificationOptions = [
                {
                    name: loc.enotificationsetting_email_title,
                    value: enums.eNotificationSetting.email
                },
                {
                    name: loc.enotificationsetting_none_title,
                    value: enums.eNotificationSetting.none
                },
                {
                    name: loc.enotificationsetting_companydefault_title,
                    value: enums.eNotificationSetting.companyDefault
                },
            ];
            // add drawers
            if (!$scope.model.isSsoUser) {
                _this.drawerService.addDrawer(_tools.icons.change, loc.changepassword, function () {
                    _this.$state.go("kb.changePassword", { id: $scope.model.id });
                }, $scope.canChangePassword && !$scope.isNew);
                _this.drawerService.addDrawer(_tools.icons.change, loc.resetpassword, $scope.resetPassword, $scope.canResetPassword && !$scope.isNew);
            }
            _this.drawerService.addDrawer(_tools.icons.edit, loc.edit, function () {
                _this.$state.go("kb.admin.userEdit", { id: $scope.model.id });
            }, $scope.canEdit && $scope.isView);
            _this.drawerService.addDrawer(_tools.icons.deleter, loc.deleter, $scope.delete, $scope.canEdit && !$scope.isNew);
            _this.drawerService.addDrawer(_tools.icons.anonymize, loc.deleteandanonymize, $scope.deleteAndAnonymize, $scope.canEdit && !$scope.isNew);
            _this.drawerService.addDrawer(_tools.icons.action, loc.resetdeactivationtimer, $scope.resetDeactivation, $rootScope.companySettings.accountIdleExpirationInDays > 0 && $scope.isEdit && $rootScope.context.user.canModifyUsers);
            _this.drawerService.addDrawer(_tools.icons.save, loc.save, $scope.save, $scope.isEdit || $scope.isNew);
            _this.drawerService.addDrawer(_tools.icons.cancel, loc.cancel, $scope.cancel, $scope.isEdit || $scope.isNew);
            return _this;
        }
        UserController.prototype.client = function (api) {
            return api.users;
        };
        UserController.prototype.waitForRefresh = function () {
            return true;
        };
        UserController.prototype.onSuccess = function () {
            if (this.$rootScope.user.isCompanyAdmin) {
                this.$state.go("kb.admin.users");
            }
            else {
                this.$state.go("kb.products");
            }
        };
        UserController.prototype.onDelete = function () {
            this.$state.go("kb.admin.users");
        };
        UserController = __decorate([
            NgView({
                token: Token.UserView,
                inherit: [Token.CrudView],
                dependencies: [
                    Token.$RootScope,
                    Token.KbService
                ]
            })
        ], UserController);
        return UserController;
    }(CrudController));

    angular__namespace.module('appTemplates', []);
    var kbapp = angular__namespace.module("kbapp", [
        "ngAnimate",
        "ngCookies",
        "ngSanitize",
        "ui.router",
        "ajoslin.promise-tracker",
        "oc.lazyLoad",
        "appTemplates",
        "text-mask"
        // "jcs.angular-http-batch"
    ]);
    DI.fillAngularApp(kbapp);
    kbapp.config([
        "$locationProvider",
        "$stateProvider",
        "$httpProvider",
        "$urlRouterProvider",
        "$provide",
        "$animateProvider",
        // "httpBatchConfigProvider",
        "$compileProvider",
        function ($locationProvider, $stateProvider, $httpProvider, $urlRouterProvider, $provide, $animateProvider, 
        // httpBatchConfigProvider: any,
        $compileProvider) {
            // don't use hashbang mode
            $locationProvider.html5Mode(true);
            // Remove the header used to identify ajax call  that would prevent CORS from working
            delete $httpProvider.defaults.headers.common["X-Requested-With"];
            // turn off debug classes from angular for performance boost: 
            // https://code.angularjs.org/1.5.5/docs/guide/production
            $compileProvider.debugInfoEnabled(false);
            $compileProvider.commentDirectivesEnabled(false);
            $compileProvider.cssClassDirectivesEnabled(false);
            // add our http interceptors
            $httpProvider.interceptors.push("securityInterceptor");
            $httpProvider.interceptors.push("cacheBusterInterceptor");
            // $httpProvider.useApplyAsync(true);
            // $httpProvider.interceptors.push("errorInterceptor");
            $provide.decorator("$exceptionHandler", ["$delegate", Token.$Injector.key, function ($delegate, $injector) {
                    return (function (exception, cause) {
                        $delegate(exception, cause);
                        var $telemetryService = $injector.get(Token.TelemetryService.key);
                        $telemetryService.trackException(exception);
                    });
                }]);
            // Phase 2 (Vue migration): when kbapp runs inside AngularHost (hosted
            // by the Vue SPA), Vue Router owns /, /admin, and every non-embedded
            // URL. Registering these redirects unconditionally causes ui-router
            // to react to benign URL changes (e.g. Vue navigating /products ->
            // /quotes while the embed is about to unmount) and redirect INSIDE
            // the about-to-die AngularHost, which races with Vue's unmount. In
            // hosted mode we keep only the SFDC pre-handler (the /sfdc URL is
            // explicitly an AngularHost route) and skip the rest. In standalone
            // legacy mode (Views/Home/Index.cshtml) all four still register.
            var kbHostedByVue = !!window.__kbHostedByVue;
            if (kbHostedByVue) {
                // AngularHost activates the embedded state explicitly after every
                // bootstrap. Defer the automatic URL sync so it cannot race that
                // activation and report a superseded transition.
                $urlRouterProvider.deferIntercept();
            }
            // when we are on the sfdc url, then go to whatever path the sfdc canvas asked for
            $urlRouterProvider.when("/sfdc", [
                Token.$Location.key, Token.$RootScope.key, Token.$State.key, function ($location, $rootScope, $state) {
                    var isSfdcCpq = $rootScope.context.sfdcCanvasRequest.context.environment.parameters.sfdccpq;
                    if (isSfdcCpq) {
                        var queryString = $location.search();
                        if (queryString['idtheme']) {
                            return "/configurators/1?idtheme=".concat(queryString['idtheme']);
                        }
                        // we use a dummy configurator id here.  The configuratorController will 
                        // communicate through the canvas to get the real id
                        return "/configurators/1";
                    }
                    else {
                        var path = $rootScope.context.sfdcCanvasRequest.context.environment.parameters.path;
                        path = path || "/products";
                        return path;
                    }
                }
            ]);
            // $urlRouterProvider.when("/sfdc/", handleSfdcUrl);
            if (!kbHostedByVue) {
                // defult to products page
                $urlRouterProvider.when("/", [
                    "$location", "$rootScope", function ($location, $rootScope) {
                        if (!$rootScope.company.licenseKbmax && $rootScope.company.license3D) {
                            return "/admin/scenes";
                        }
                        if ($rootScope.companySettings.landingPageUrl && $rootScope.companySettings.landingPageUrl != "") {
                            if ($rootScope.companySettings.landingPageUrl.includes("://")) {
                                window.location.href = $rootScope.companySettings.landingPageUrl;
                            }
                            return $rootScope.companySettings.landingPageUrl;
                        }
                        return "/products";
                    }
                ]);
                $urlRouterProvider.when("/admin", [
                    "$location", "$rootScope", function ($location, $rootScope) {
                        if ($rootScope.company.licenseKbmax) {
                            if ($rootScope.user.canModifyProducts) {
                                return "/admin/configurators";
                            }
                            else if ($rootScope.user.canModifyScenes && $rootScope.company.license3D) {
                                return "/admin/scenes";
                            }
                            else if ($rootScope.user.canModifyUsers || $rootScope.user.isChannelAdmin) {
                                return "/admin/users";
                            }
                            else if ($rootScope.user.canModifyCurrencies) {
                                return "/admin/currencies";
                            }
                            else if ($rootScope.user.canModifyMedia) {
                                return "/admin/media";
                            }
                        }
                        else {
                            if ($rootScope.company.license3D) {
                                return "/admin/scenes";
                            }
                        }
                        return "/";
                    }
                ]);
                $urlRouterProvider.otherwise("/");
            }
            // else: no `.otherwise` is registered, which means unknown URLs inside
            // AngularHost simply don't match any state. That's fine because Vue
            // Router has already matched and routed to an AngularHost component;
            // the only URLs angular sees are configurator/quote-product/scene/sfdc
            // ones that DO match concrete states below.
            // only run animations on elements that have a kb-animate class name.  
            // This should increase performance.See here: https://docs.angularjs.org/api/ng/provider/$animateProvider
            $animateProvider.classNameFilter(/kb-animate/);
            // register the api batch handler
            // httpBatchConfigProvider.setAllowedBatchEndpoint("/api", "/api/batch", {
            //     maxBatchedRequestPerCall: 10,
            //     minimumBatchSize: 2,
            //     batchRequestCollectionDelay: 100,
            //     ignoredVerbs: ["head"],
            //     sendCookies: false,
            //     enabled: true,
            //     // defaults to this value we currently also support a node js multifetch format as well
            //     adapter: "httpBatchAdapter"
            // });
            var stateHelper = new StateHelper($stateProvider, exports.eBundle.app);
            // setup states using ui-router library
            stateHelper.addState({
                name: "kb",
                url: null,
                abstract: true,
                view: Token.PortalView,
                templateName: "portal"
            });
            stateHelper.addState({
                name: "kb.login",
                view: Token.LoginView,
                data: { onLoginPage: true }
            });
            stateHelper.addSearchState({
                name: "kb.products",
                view: Token.ProductsView,
                url: "/products?imagemode&search&searchid"
            });
            // stateHelper.addState({
            //     name: "kb.products",
            //     url: "/products?cat&sort&q&mode",
            //     view: Token.ProductsView
            // });
            stateHelper.addState({
                name: "kb.product",
                url: "/products/:id",
                view: Token.ProductView
            });
            stateHelper.addState({
                name: "kb.productCompare",
                url: "/productcompare/:ids",
                view: Token.ProductCompareView,
                params: {
                    ids: { array: true }
                }
            });
            stateHelper.addState({
                name: "kb.configurator",
                url: "/configurators/:id",
                data: { viewType: enums.eViewType.new },
                view: Token.ConfiguratorView
            });
            stateHelper.addState({
                name: "kb.configuredProduct",
                url: "/quoteproducts/:id",
                templateName: "configurator",
                data: { viewType: enums.eViewType.edit },
                view: Token.ConfiguratorView
            });
            stateHelper.addState({
                name: "kb.configuratorTest",
                url: "/configurators/test/:id",
                templateName: "configurator",
                data: { viewType: enums.eViewType.new, isTest: true },
                view: Token.ConfiguratorView
            });
            stateHelper.addCrudStates({
                name: "kb.quote",
                view: Token.QuoteView,
                searchView: Token.QuotesView
            });
            stateHelper.addSearchState({
                name: "kb.configuredProducts",
                view: Token.ConfiguredProductsView
            });
            stateHelper.addCrudStates({
                name: "kb.customer",
                view: Token.CustomerView,
                searchView: Token.CustomersView
            });
            stateHelper.addCrudStates({
                name: "kb.contact",
                view: Token.ContactView,
                searchView: Token.ContactsView
            });
            stateHelper.addState({
                name: "userActivation",
                url: "/users/activate/?idUser&activationGuid&pass&new",
                view: Token.UserActivationView,
                allowAnonymous: true
            });
            stateHelper.addState({
                name: "kb.changePassword",
                url: "/users/changepassword/:id",
                data: { viewType: enums.eViewType.new },
                view: Token.ChangePasswordView
            });
            stateHelper.addState({
                name: "kb.notifications",
                url: "/notifications?q&sort&desc",
                view: Token.NotificationsView
            });
            stateHelper.addState({
                name: "scene",
                url: "/scenes/:id?requestid&&showmove",
                view: Token.ConfiguratorView,
                templateName: "configurator",
                allowAnonymous: true
            });
            $stateProvider.state("kb.admin.**", {
                url: "/admin",
                lazyLoad: function ($transition$) {
                    var bundleLoader = $transition$.injector().get(Token.BundleLoaderService.key);
                    return bundleLoader.load([Token.AdminLib]);
                }
            });
        }
    ]);
    kbapp.run([
        Token.AuthService.key,
        Token.$RootScope.key,
        Token.$Http.key,
        Token.PromiseTracker.key,
        Token.$Location.key,
        Token.$State.key,
        Token.$Window.key,
        Token.ThemeService.key,
        Token.TelemetryService.key,
        Token.QuoteService.key,
        Token.ApiService.key,
        Token.SfdcService.key,
        Token.$Transitions.key,
        function (authService, $rootScope, $http, promiseTracker, $location, $state, $window, themeService, telemetryService, quoteService, apiService, sfdcService, $transitions) {
            // Phase 2 (Vue migration): hand URL transitions back to Vue Router
            // when the user clicks a link in angular chrome that targets a state
            // Vue owns (home, products, quotes, customers, etc.). Without this
            // bridge the legacy ui-router happily pushes a new URL + fetches a
            // legacy template — but AngularHost is still mounted because Vue
            // Router never saw the URL change, so the user stays inside the
            // embed showing the wrong page.
            //
            // Runtime transitions and transitions inside the currently hosted V2
            // configurator stay in angular. Navigating to another admin resource
            // goes through Vue so its route guards and V2/V3 gate own the result.
            //
            // `onBefore({}, ...)` matches every transition. We return `false` to
            // cancel when we redirect to Vue — the URL has already been pushed
            // by Vue Router, so canceling the angular transition leaves things
            // consistent.
            if (window.__kbHostedByVue) {
                $transitions.onBefore({}, function (trans) {
                    var _a, _b;
                    var toState = trans.to();
                    var toName = toState && toState.name;
                    var router = window.__kbVueRouter;
                    if (!router || typeof router.push !== "function") {
                        console.warn("[app] angular transition to Vue-owned state '" + toName +
                            "' but __kbVueRouter is not available; letting angular handle it");
                        return true;
                    }
                    try {
                        var href = $state.href(toName, trans.params(), { absolute: false });
                        if (shouldAngularOwnHostedTransition({
                            currentVuePath: (_b = (_a = router.currentRoute) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.path,
                            hostMode: window.__kbAngularHostMode,
                            targetHref: href,
                            targetStateName: toName,
                        })) {
                            return true;
                        }
                        console.info("[app] transition '" + toName + "' -> Vue Router.push(" + href + ")");
                        router.push(href);
                    }
                    catch (e) {
                        console.error("[app] failed to bridge transition to Vue Router", e);
                        return true; // fall back to letting angular try
                    }
                    // Cancel angular's transition: Vue Router now owns navigation.
                    return false;
                });
            }
            // store the state service on the rootscope so views can bind to it
            $rootScope.$state = $state;
            $rootScope.baseUrl = "https://" + $(location).attr("host");
            $rootScope.isEpicorEmployee = function () { return $rootScope.user.email.toLowerCase().endsWith("@kbmax.com") || $rootScope.user.email.toLowerCase().endsWith("@epicor.com"); };
            // track if we are in sfdc; use sessionStorage instead of cookies
            var getSessionValue = function (name) {
                try {
                    return sessionStorage.getItem(name);
                }
                catch (e) {
                    console.warn('sessionStorage unavailable', e);
                    return null;
                }
            };
            var sfdcCookie = getSessionValue("SfdcCanvasCookie");
            if (sfdcCookie && $rootScope.context.sfdcCanvasRequest) {
                if (JSON.parse(sfdcCookie).issuedAt > $rootScope.context.sfdcCanvasRequest.issuedAt) {
                    $rootScope.context.sfdcCanvasRequest = JSON.parse(sfdcCookie);
                }
            }
            if (sfdcCookie && !$rootScope.context.sfdcCanvasRequest) {
                $rootScope.context.sfdcCanvasRequest = JSON.parse(sfdcCookie);
            }
            $rootScope.isSfdc = ($rootScope.context.sfdcCanvasRequest != null);
            if ($rootScope.isSfdc) {
                try {
                    // store the request as a JSON string in sessionStorage
                    sessionStorage.setItem("SfdcCanvasCookie", JSON.stringify($rootScope.context.sfdcCanvasRequest));
                }
                catch (e) {
                    console.warn('Failed to set SfdcCanvasCookie in sessionStorage', e);
                }
                $rootScope.isSfdcCpq = $rootScope.context.sfdcCanvasRequest.context.environment.parameters.sfdccpq;
                var queryString = $location.search();
                $rootScope.isSfdcCustomTheme = false;
                if (queryString["idtheme"]) {
                    $rootScope.isSfdcCustomTheme = true;
                }
            }
            // icons array used as a source for some bindings
            $rootScope.icons = Object.values(_tools.icons);
            // set initial window size values
            var $win = $(window);
            $rootScope.windowWidth = $win.width();
            $rootScope.windowHeight = $win.height();
            // track the window size
            $(window).resize(function () {
                if (!$rootScope.$$phase) {
                    $rootScope.$apply(function () {
                        var $win = $(window);
                        $rootScope.windowWidth = $win.width();
                        $rootScope.windowHeight = $win.height();
                    });
                }
            });
            $rootScope.contentTracker = promiseTracker();
            $rootScope.showSpinner = true;
            $rootScope.loginTracker = promiseTracker();
            $rootScope.infiniteScrollTracker = promiseTracker();
            $rootScope.isHoverSupported = !(matchMedia("(hover: none)").matches);
            $rootScope.isIE = /msie\s|trident\//i.test(navigator.userAgent);
            $rootScope.comparedProducts = [];
            $rootScope.recaptchaToken = "6LfFNOAUAAAAAAreoPer8J4F9qh9WLklfpUAbt28";
            // hide browser address bar
            window.scrollTo(0, 1);
            $rootScope.translate = function (entity, prop, realProp) {
                if (entity) {
                    if ($rootScope.clientLanguage != $rootScope.companySettings.defaultLanguage) {
                        if (entity && entity.translations && entity.translations.length) {
                            var translation = entity.translations
                                .find(function (t) { return t.languageIso == $rootScope.clientLanguage; });
                            if (translation) {
                                return translation.data[prop];
                            }
                        }
                    }
                    return entity[realProp || prop] || entity[prop];
                }
                else {
                    return "";
                }
            };
            $rootScope.supportsFullscreen = !$rootScope.isSfdcCpq && _tools.Utils.supportsFullscreen();
            $rootScope.toggleFullscreen = function () {
                if ($rootScope.isSfdc) {
                    sfdcService.toggleFullscreen();
                }
                else {
                    _tools.Utils.toggleFullscreen();
                }
            };
            $rootScope.setTitle = function (subtitle) {
                var page = subtitle ? "".concat(subtitle, " - ") : '';
                var company = $rootScope.environment == enums.eEnvironment.prod ? "".concat($rootScope.company.name) : "".concat($rootScope.company.name, " [").concat($rootScope.environment.toUpperCase(), "]");
                $window.document.title = "".concat(page).concat(company, " - KBMax");
            };
            $rootScope.companyDatabaseName = "kbmax_".concat($rootScope.clusterEnv, "_").concat($rootScope.company.uniqueName, "_").concat($rootScope.environment);
            // track activity
            var lastMove = Date.now();
            var mouseMoveWait = false;
            window.onmousemove = function (event) {
                if (!mouseMoveWait) {
                    lastMove = Date.now();
                    mouseMoveWait = true;
                    setTimeout(function () {
                        mouseMoveWait = false;
                    }, 200);
                }
            };
            var checkTime = 5 * 60000;
            setInterval(function () {
                if (Date.now() - lastMove < checkTime || $rootScope.user.isAnonymous)
                    authService.keepAlive();
            }, checkTime);
        }
    ]);

    exports.AdminProductClient = AdminProductClient;
    exports.ApiService = ApiService;
    exports.AssetFilter = AssetFilter;
    exports.AssistantClient = AssistantClient;
    exports.AuthService = AuthService;
    exports.AutomationStudioClient = AutomationStudioClient;
    exports.Base64Service = Base64Service;
    exports.BaseController = BaseController;
    exports.BundleLoaderService = BundleLoaderService;
    exports.BytesFilter = BytesFilter;
    exports.CacheBusterInterceptor = CacheBusterInterceptor;
    exports.CategoriesClient = CategoriesClient;
    exports.ChangePasswordController = ChangePasswordController;
    exports.ClaraSceneRuleArgs = ClaraSceneRuleArgs;
    exports.ClaraSceneService = ClaraSceneService;
    exports.ClaraSceneUtilities = ClaraSceneUtilities;
    exports.ClaraViewer = ClaraViewer;
    exports.CompanySettingsClient = CompanySettingsClient;
    exports.ConfiguratorClient = ConfiguratorClient;
    exports.ConfiguratorController = ConfiguratorController;
    exports.ConfiguratorHelper = ConfiguratorHelper;
    exports.ConfiguratorRuleArgs = ConfiguratorRuleArgs;
    exports.ConfiguredProductsController = ConfiguredProductsController;
    exports.ContactController = ContactController;
    exports.ContactsController = ContactsController;
    exports.CrudClient = CrudClient;
    exports.CrudController = CrudController;
    exports.CrudService = CrudService;
    exports.CurrencyClient = CurrencyClient;
    exports.CustomerController = CustomerController;
    exports.CustomersController = CustomersController;
    exports.DI = DI;
    exports.DbLoginsClient = DbLoginsClient;
    exports.DbTablesClient = DbTablesClient;
    exports.DbWhitelistClient = DbWhitelistClient;
    exports.DbXuserCred = DbXuserCred;
    exports.DependenciesClient = DependenciesClient;
    exports.DeploymentClient = DeploymentClient;
    exports.DialogController = DialogController;
    exports.DialogService = DialogService;
    exports.Directive = Directive;
    exports.Dirs = Dirs;
    exports.DragAndDropService = DragAndDropService;
    exports.DrawerController = DrawerController;
    exports.DrawerService = DrawerService;
    exports.EnumFilter = EnumFilter;
    exports.ErrorInterceptor = ErrorInterceptor;
    exports.FileIconFilter = FileIconFilter;
    exports.FileIdFilter = FileIdFilter;
    exports.ForbiddenReason = ForbiddenReason;
    exports.FxConvertFilter = FxConvertFilter;
    exports.GeneratorClient = GeneratorClient;
    exports.GetFileExtensionFilter = GetFileExtensionFilter;
    exports.GetFilenameFilter = GetFilenameFilter;
    exports.GlobalFunctionClient = GlobalFunctionClient;
    exports.HandlerDb = HandlerDb;
    exports.HasRoleFilter = HasRoleFilter;
    exports.HtmlRuleArgs = HtmlRuleArgs;
    exports.IconFilter = IconFilter;
    exports.ImageSelectHelper = ImageSelectHelper;
    exports.IntegrationSettingsClient = IntegrationSettingsClient;
    exports.InteractionService = InteractionService;
    exports.IsAdminOrCompanyAdminFilter = IsAdminOrCompanyAdminFilter;
    exports.JobsClient = JobsClient;
    exports.Kb3dSceneFunctionRuleArgs = Kb3dSceneFunctionRuleArgs;
    exports.Kb3dSceneRuleArgs = Kb3dSceneRuleArgs;
    exports.Kb3dViewer = Kb3dViewer;
    exports.KbActionSelect = KbActionSelect;
    exports.KbAllowFractions = KbAllowFractions;
    exports.KbAtom = KbAtom;
    exports.KbAttachments = KbAttachments;
    exports.KbAutoComplete = KbAutoComplete;
    exports.KbAvatar = KbAvatar;
    exports.KbAvatarSelect = KbAvatarSelect;
    exports.KbButton = KbButton;
    exports.KbCheckbox = KbCheckbox;
    exports.KbColorPicker = KbColorPicker;
    exports.KbColumn = KbColumn;
    exports.KbComments = KbComments;
    exports.KbContent = KbContent;
    exports.KbCurrencyFilter = KbCurrencyFilter;
    exports.KbDataGrid = KbDataGrid;
    exports.KbDateFilter = KbDateFilter;
    exports.KbDatePicker = KbDatePicker;
    exports.KbDateTimeFilter = KbDateTimeFilter;
    exports.KbDropdown = KbDropdown;
    exports.KbEdit = KbEdit;
    exports.KbEllipsis = KbEllipsis;
    exports.KbExpander = KbExpander;
    exports.KbExpanderGroup = KbExpanderGroup;
    exports.KbField = KbField;
    exports.KbFocus = KbFocus;
    exports.KbForm = KbForm;
    exports.KbIcon = KbIcon;
    exports.KbIf = KbIf;
    exports.KbIfDelay = KbIfDelay;
    exports.KbImageMultiSelect = KbImageMultiSelect;
    exports.KbImageSelect = KbImageSelect;
    exports.KbInclude = KbInclude;
    exports.KbInfiniteScroll = KbInfiniteScroll;
    exports.KbInput = KbInput;
    exports.KbLabel = KbLabel;
    exports.KbList = KbList;
    exports.KbListItem = KbListItem;
    exports.KbMarkdownViewer = KbMarkdownViewer;
    exports.KbMax = KbMax;
    exports.KbMediaList = KbMediaList;
    exports.KbMediaManager = KbMediaManager;
    exports.KbMediaSelect = KbMediaSelect;
    exports.KbMediaViewer = KbMediaViewer;
    exports.KbMenu = KbMenu;
    exports.KbMenuItem = KbMenuItem;
    exports.KbMin = KbMin;
    exports.KbMoney = KbMoney;
    exports.KbMultiAutoComplete = KbMultiAutoComplete;
    exports.KbMultiSelect = KbMultiSelect;
    exports.KbNumberbox = KbNumberbox;
    exports.KbOverlayPopupComponent = KbOverlayPopupComponent;
    exports.KbPage = KbPage;
    exports.KbPageTitle = KbPageTitle;
    exports.KbPassword = KbPassword;
    exports.KbPrivacyPolicy = KbPrivacyPolicy;
    exports.KbProgress = KbProgress;
    exports.KbRadio = KbRadio;
    exports.KbResize = KbResize;
    exports.KbRipple = KbRipple;
    exports.KbRise = KbRise;
    exports.KbScope = KbScope;
    exports.KbSearchGrid = KbSearchGrid;
    exports.KbSelect = KbSelect;
    exports.KbService = KbService;
    exports.KbSfdcHeader = KbSfdcHeader;
    exports.KbSlide = KbSlide;
    exports.KbSlider = KbSlider;
    exports.KbSortable = KbSortable;
    exports.KbSpinner = KbSpinner;
    exports.KbSpinnerElement = KbSpinnerElement;
    exports.KbSrcOnError = KbSrcOnError;
    exports.KbSvgViewer = KbSvgViewer;
    exports.KbTab = KbTab;
    exports.KbTabs = KbTabs;
    exports.KbTextarea = KbTextarea;
    exports.KbTextbox = KbTextbox;
    exports.KbToggle = KbToggle;
    exports.KbTooltip = KbTooltip;
    exports.KbTransclude = KbTransclude;
    exports.KbTree = KbTree;
    exports.KbTreeNode = KbTreeNode;
    exports.KbUiObject = KbUiObject;
    exports.KbUpload = KbUpload;
    exports.KbValidationMessages = KbValidationMessages;
    exports.KineticClient = KineticClient;
    exports.KineticMomClient = KineticMomClient;
    exports.LanguageClient = LanguageClient;
    exports.LastValueCache = LastValueCache;
    exports.LayoutClient = LayoutClient;
    exports.LeadTimeFilter = LeadTimeFilter;
    exports.LocFilter = LocFilter;
    exports.LogIconFilter = LogIconFilter;
    exports.LoginController = LoginController;
    exports.MediaFilter = MediaFilter;
    exports.NgAnimation = NgAnimation;
    exports.NgComponent = NgComponent;
    exports.NgFilter = NgFilter;
    exports.NgInterceptor = NgInterceptor;
    exports.NgService = NgService;
    exports.NgView = NgView;
    exports.NotificationClient = NotificationClient;
    exports.NotificationIconFilter = NotificationIconFilter;
    exports.NotificationsController = NotificationsController;
    exports.NumberFormatFilter = NumberFormatFilter;
    exports.OptionFilterClient = OptionFilterClient;
    exports.PathCache = PathCache;
    exports.PermissionClient = PermissionClient;
    exports.PortalController = PortalController;
    exports.PriceColumnClient = PriceColumnClient;
    exports.PrivacyPolicyController = PrivacyPolicyController;
    exports.ProductClient = ProductClient;
    exports.ProductCompareController = ProductCompareController;
    exports.ProductController = ProductController;
    exports.ProductHistoryClient = ProductHistoryClient;
    exports.ProductsController = ProductsController;
    exports.ProfileImageFilter = ProfileImageFilter;
    exports.QuoteClient = QuoteClient;
    exports.QuoteController = QuoteController;
    exports.QuoteHeaderClient = QuoteHeaderClient;
    exports.QuoteHeaderRuleArgs = QuoteHeaderRuleArgs;
    exports.QuoteProductImageFilter = QuoteProductImageFilter;
    exports.QuoteService = QuoteService;
    exports.QuotesController = QuotesController;
    exports.RangeFilter = RangeFilter;
    exports.RawTextFilter = RawTextFilter;
    exports.RootUserClient = RootUserClient;
    exports.RuleService = RuleService;
    exports.SafeFunctionClient = SafeFunctionClient;
    exports.SavedSearchClient = SavedSearchClient;
    exports.SceneCache = SceneCache;
    exports.SceneHistoryClient = SceneHistoryClient;
    exports.SceneViewer = SceneViewer;
    exports.ScenesClient = ScenesClient;
    exports.SearchController = SearchController;
    exports.SearchService = SearchService;
    exports.SecurityInterceptor = SecurityInterceptor;
    exports.SecurityRetryService = SecurityRetryService;
    exports.SelectedBinding = SelectedBinding;
    exports.SfdcService = SfdcService;
    exports.ShadeFilter = ShadeFilter;
    exports.SignalrService = SignalrService;
    exports.SingletonCrudClient = SingletonCrudClient;
    exports.SmartColorFilter = SmartColorFilter;
    exports.StateHelper = StateHelper;
    exports.StorageService = StorageService;
    exports.SvgRuleArgs = SvgRuleArgs;
    exports.TablesClient = TablesClient;
    exports.TelemetryService = TelemetryService;
    exports.TestBuildClient = TestBuildClient;
    exports.ThemeColorFilter = ThemeColorFilter;
    exports.ThemeService = ThemeService;
    exports.ThumbFilter = ThumbFilter;
    exports.Token = Token;
    exports.ToolsClient = ToolsClient;
    exports.TranslateClient = TranslateClient;
    exports.TruncateFilter = TruncateFilter;
    exports.TrustAsHtmlFilter = TrustAsHtmlFilter;
    exports.UploadService = UploadService;
    exports.UserActivationController = UserActivationController;
    exports.UserClient = UserClient;
    exports.UserController = UserController;
    exports.WorkflowsClient = WorkflowsClient;
    exports.kbapp = kbapp;
    exports.shouldAngularOwnHostedTransition = shouldAngularOwnHostedTransition;

    Object.defineProperty(exports, '__esModule', { value: true });

    return exports;

})({}, models, angular, tools, flatpickr, Tether, rules, kb3d, Q, signalR, Big);
//# sourceMappingURL=app.js.map
